const UniversitiesList = [
  {
    web_pages: ["http://www.marywood.edu"],
    name: "Marywood University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marywood.edu"],
    country: "United States",
  },
  {
    web_pages: [
      "https://www.cstj.qc.ca",
      "https://ccmt.cstj.qc.ca",
      "https://ccml.cstj.qc.ca",
    ],
    name: "Cégep de Saint-Jérôme",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cstj.qc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.lindenwood.edu/"],
    name: "Lindenwood University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lindenwood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.davietjal.org/"],
    name: "DAV Institute of Engineering & Technology",
    alpha_two_code: "IN",
    "state-province": "Punjab",
    domains: ["davietjal.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.lpu.in/"],
    name: "Lovely Professional University",
    alpha_two_code: "IN",
    "state-province": "Punjab",
    domains: ["lpu.in"],
    country: "India",
  },
  {
    web_pages: ["https://sullivan.edu/"],
    name: "Sullivan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sullivan.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.fscj.edu/"],
    name: "Florida State College at Jacksonville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fscj.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.xavier.edu/"],
    name: "Xavier University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["xavier.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://home.tusculum.edu/"],
    name: "Tusculum College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tusculum.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://cst.edu/"],
    name: "Claremont School of Theology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cst.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://somaiya.edu/"],
    name: "Somaiya Vidyavihar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["somaiya.edu"],
    country: "India",
  },
  {
    web_pages: ["https://www.columbiasc.edu/"],
    name: "Columbia College (SC)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbiasc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clpccd.edu/"],
    name: "Chabot-Las Positas Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clpccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.keller.edu/"],
    name: "Keller Graduate School of Management",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["keller.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://monroecollege.edu/"],
    name: "Monroe College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monroecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://smccd.edu/"],
    name: "San Mateo County Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://losrios.edu/"],
    name: "Los Rios Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["losrios.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.digipen.edu/"],
    name: "DigiPen Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["digipen.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.upmc.com/"],
    name: "University of Pittsburgh Medical Center",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["upmc.edu", "upmc.com"],
    country: "United States",
  },
  {
    web_pages: ["https://www.cgu.edu/"],
    name: "Claremont Graduate University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cgu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utrgv.edu/"],
    name: "University of Texas Rio Grande Valley",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utrgv.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://mountsaintvincent.edu/"],
    name: "College of Mount Saint Vincent",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mountsaintvincent.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.uasys.edu/"],
    name: "University of Arkansas System eVersity",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uasys.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.ecpi.edu/"],
    name: "ECPI University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ecpi.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.umw.edu/"],
    name: "University of Mary Washington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umw.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.bw.edu/"],
    name: "Baldwin Wallace University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bw.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.csuci.edu/"],
    name: "California State University Channel Islands",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csuci.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.brandman.edu/"],
    name: "Brandman University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brandman.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uscga.edu/"],
    name: "United States Coast Guard Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uscga.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.athens.edu/"],
    name: "Athens State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["athens.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://scripps.edu/"],
    name: "The Scripps Research Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scripps.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.easternflorida.edu/"],
    name: "Eastern Florida State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["easternflorida.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www1.wne.edu/"],
    name: "Western New England University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wne.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://king.edu/"],
    name: "King University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["king.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://ggc.edu/"],
    name: "Georgia Gwinnett College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ggc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.trident.edu/"],
    name: "Trident University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trident.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.alliant.edu/"],
    name: "Alliant International University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alliant.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://mvsu.edu/"],
    name: "Mississippi Valley State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mvsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.roosevelt.edu/"],
    name: "Roosevelt University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roosevelt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://itt-tech.info/"],
    name: "ITT Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["itt-tech.info", "itt-tech.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://iecc.edu/"],
    name: "Illinois Eastern Community Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://park.edu/"],
    name: "Park University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["park.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://icahn.mssm.edu/"],
    name: "Icahn School of Medicine at Mount Sinai",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mssm.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://uvu.edu/"],
    name: "Utah Valley Uniersity",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uvu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wlc.edu/"],
    name: "Wisconsin Lutheran College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wlc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rccd.edu/"],
    name: "Riverside Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wakehealth.edu/"],
    name: "Wake Forest Baptist Health",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wakehealth.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.umb.edu/"],
    name: "University of Massachusetts Boston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umb.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://floridapoly.edu/"],
    name: "Florida Polytechnic University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["floridapoly.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://wagner.edu/"],
    name: "Wagner College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wagner.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.wilmu.edu/"],
    name: "Wilmington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://itu.edu/"],
    name: "International Technological University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["itu.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.yhc.edu/"],
    name: "Young Harris College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yhc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.findlay.edu/"],
    name: "University of Findlay",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["findlay.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.pcom.edu/"],
    name: "Philadelphia College of Osteopathic Medicine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pcom.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.yosemite.edu/"],
    name: "Yosemite Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yosemite.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastalalabama.edu/"],
    name: "Coastal Alabama Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastalalabama.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.pnw.edu/"],
    name: "Purdue University Northwest",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pnw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.columbiabasin.edu/"],
    name: "Columbia Basin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbiabasin.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.seattlecolleges.edu/"],
    name: "Seattle Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["seattlecolleges.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.lipscomb.edu/"],
    name: "Lipscomb University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lipscomb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tiffin.edu/"],
    name: "Tiffin University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tiffin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncuindia.edu/"],
    name: "NorthCap University",
    alpha_two_code: "IN",
    "state-province": "Haryana",
    domains: ["ncuindia.edu"],
    country: "India",
  },
  {
    web_pages: ["https://troy.edu/"],
    name: "Troy University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["troy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.42.us.org/"],
    name: "42 US",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["student.42.us.org"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calbaptist.edu/"],
    name: "California Baptist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calbaptist.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stevenson.edu/"],
    name: "Stevenson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stevenson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mbl.edu/"],
    name: "Marine Biological Laboratory",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mbl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.maryville.edu/"],
    name: "Maryville University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["maryville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aii.edu/"],
    name: "The Art Institutes",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umc.edu/"],
    name: "University of Mississippi Medical Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uco.edu/"],
    name: "University of Central Oklahoma",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hallmarkuniversity.edu/"],
    name: "Hallmark University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hallmarkuniversity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.keiseruniversity.edu/"],
    name: "Keiser University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["keiseruniversity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjrstate.edu/"],
    name: "St. Johns River State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjrstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.irsc.edu/"],
    name: "Indian River State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["irsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.barnard.edu/"],
    name: "Barnard College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["barnard.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calsouthern.edu/"],
    name: "California Southern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calsouthern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laverne.edu/"],
    name: "University of La Verne",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laverne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.washjeff.edu/"],
    name: "Washington &amp; Jefferson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["washjeff.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uopeople.edu/"],
    name: "University of the People",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uopeople.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.touro.edu/"],
    name: "Touro College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["touro.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.njcu.edu/"],
    name: "New Jersey City University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["njcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lander.edu/"],
    name: "Lander University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lander.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunymaritime.edu/"],
    name: "SUNY Maritime College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunymaritime.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lesley.edu/"],
    name: "Lesley University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lesley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lauruscollege.edu/"],
    name: "Laurus College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lauruscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.np.edu/"],
    name: "National Park College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["np.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oc.edu/"],
    name: "Oklahoma Christian University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdcc.edu/"],
    name: "San Diego Christian College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sans.edu/"],
    name: "SANS Technology Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sans.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.phsc.edu/"],
    name: "Pasco-Hernando State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["phsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncf.edu/"],
    name: "New College of Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gcu.edu/"],
    name: "Grand Canyon University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cshl.edu/"],
    name: "Cold Spring Harbor Laboratory",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cshl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asurams.edu/"],
    name: "Albany State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asurams.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lasell.edu/"],
    name: "Lasell College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lasell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.4cd.edu/"],
    name: "Contra Costa Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["4cd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msmary.edu/"],
    name: "Mount St. Mary's University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msmary.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.robertmorris.edu/"],
    name: "Robert Morris University Illinois",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["robertmorris.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwfsc.edu/"],
    name: "Northwest Florida State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwfsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wvwc.edu/"],
    name: "West Virginia Wesleyan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wvwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utica.edu/"],
    name: "Utica College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utica.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccnn.edu/"],
    name: "Career College of Northern Nevada",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccnn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ung.edu/"],
    name: "University of North Georgia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ung.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.principia.edu/"],
    name: "The Principia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["principia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lynn.edu/"],
    name: "Lynn University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lynn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccs.edu/"],
    name: "Colorado Community College System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.valenciacollege.edu/"],
    name: "Valencia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["valenciacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.spcollege.edu/"],
    name: "St. Petersburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["spcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msbcollege.edu/"],
    name: "Globe University &amp; Minnesota School of Business",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msbcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.everest.edu/"],
    name: "Everest College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["everest.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swri.edu/"],
    name: "Southwest Research Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.apus.edu/"],
    name: "American Public University System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["apus.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fullsail.edu/"],
    name: "Full Sail University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fullsail.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yti.edu/"],
    name: "YTI Career Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yti.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dliflc.edu/"],
    name: "Defense Language Institute Foreign Language Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dliflc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.columbusstate.edu/"],
    name: "Columbus State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbusstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.moreheadstate.edu/"],
    name: "Morehead State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["moreheadstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csuglobal.edu/"],
    name: "Colorado State University - Global Campus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csuglobal.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ndus.edu/"],
    name: "North Dakota University System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ndus.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uhd.edu/"],
    name: "University of Houston-Downtown",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uhd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stratford.edu/"],
    name: "Stratford University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stratford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cpp.edu/"],
    name: "California Polytechnic State University, Pomona",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cpp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.baker.edu/"],
    name: "Baker College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["baker.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tcnj.edu/"],
    name: "The College of New Jersey",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcnj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.acu.edu/"],
    name: "Abilene Christian University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["acu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.adelphi.edu/"],
    name: "Adelphi University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["adelphi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.agnesscott.edu/"],
    name: "Agnes Scott College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["agnesscott.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.atc.edu/"],
    name: "Aiken Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["atc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.afit.edu/"],
    name: "Air Force Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["afit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aamu.edu/"],
    name: "Alabama A&M University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aamu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alasu.edu/"],
    name: "Alabama State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alasu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamo.edu/"],
    name: "Alamo Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aloma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.acofi.edu/"],
    name: "Albertson College of Idaho",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["acofi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.albion.edu/"],
    name: "Albion College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["albion.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alfred.edu/"],
    name: "Alfred University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alfred.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alleg.edu/"],
    name: "Allegheny College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alleg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.allencol.edu/"],
    name: "Allentown College of Saint Francis de Sales",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["allencol.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alma.edu/"],
    name: "Alma College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alverno.edu/"],
    name: "Alverno College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alverno.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ambassador.edu/"],
    name: "Ambassador University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ambassador.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.amercoastuniv.edu/"],
    name: "American Coastline University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["amercoastuniv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aic.edu/"],
    name: "American International College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.american.edu/"],
    name: "American University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["american.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.amherst.edu/"],
    name: "Amherst College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["amherst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.andrews.edu/"],
    name: "Andrews University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["andrews.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.angelo.edu/"],
    name: "Angelo State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["angelo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aacc.edu/"],
    name: "Anne Arundel Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.antiochne.edu/"],
    name: "Antioch New England",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["antiochne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.antioch.edu/"],
    name: "Antioch University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["antioch.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.antiochla.edu/"],
    name: "Antioch University - Los Angeles",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["antiochla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.seattleantioch.edu/"],
    name: "Antioch University - Seattle",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["seattleantioch.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.appstate.edu/"],
    name: "Appalachian State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["appstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aquinas.edu/"],
    name: "Aquinas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aquinas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.arcadia.edu/"],
    name: "Arcadia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["arcadia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asu.edu/"],
    name: "Arizona State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.azwestern.edu/"],
    name: "Arizona Western College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["azwestern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.astate.edu/"],
    name: "Arkansas State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["astate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.atu.edu/"],
    name: "Arkansas Tech University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["atu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.armstrong.edu/"],
    name: "Armstrong State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["armstrong.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ashland.edu/"],
    name: "Ashland University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ashland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.assumption.edu/"],
    name: "Assumption College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["assumption.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.auburn.edu/"],
    name: "Auburn University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["auburn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aum.edu/"],
    name: "Auburn University at Montgomery",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.augsburg.edu/"],
    name: "Augsburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["augsburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.augustana.edu/"],
    name: "Augustana College (IL)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["augustana.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.augie.edu/"],
    name: "Augustana College (SD)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["augie.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.augusta.edu/", "http://www.gru.edu/"],
    name: "Augusta University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["augusta.edu", "gru.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aurora.edu/"],
    name: "Aurora University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aurora.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.austincollege.edu/"],
    name: "Austin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["austincollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.austincc.edu/"],
    name: "Austin Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["austincc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.apsu.edu/"],
    name: "Austin Peay State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["apsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.averett.edu/"],
    name: "Averett College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["averett.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.avila.edu/"],
    name: "Avila College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["avila.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.apu.edu/"],
    name: "Azusa Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["apu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.babson.edu/"],
    name: "Babson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["babson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bakeru.edu/"],
    name: "Baker University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bakeru.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bsu.edu/"],
    name: "Ball State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bbc.edu/"],
    name: "Baptist Bible College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bard.edu/"],
    name: "Bard College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bard.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.barry.edu/"],
    name: "Barry University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["barry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bastyr.edu/"],
    name: "Bastyr University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bastyr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bates.edu/"],
    name: "Bates College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bates.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bcm.edu/"],
    name: "Baylor College of Medicine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bcm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.baylor.edu/"],
    name: "Baylor University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["baylor.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bellevue.edu/"],
    name: "Bellevue University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bellevue.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.belmont.edu/"],
    name: "Belmont University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["belmont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.beloit.edu/"],
    name: "Beloit College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["beloit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bemidjistate.edu/"],
    name: "Bemidji State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bemidjistate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.benedictine.edu/"],
    name: "Benedictine College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["benedictine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bennington.edu/"],
    name: "Bennington College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bennington.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bentley.edu/"],
    name: "Bentley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bentley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.berea.edu/"],
    name: "Berea College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["berea.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.berklee.edu/"],
    name: "Berklee College of Music",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["berklee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bethanywv.edu/"],
    name: "Bethany College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bethanywv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bethelks.edu/"],
    name: "Bethel College (KS)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bethelks.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bethel.edu/"],
    name: "Bethel University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bethel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.biola.edu/"],
    name: "Biola University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["biola.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bsc.edu/"],
    name: "Birmingham-Southern College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bhsu.edu/"],
    name: "Black Hills State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bhsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bloomu.edu/"],
    name: "Bloomsburg University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["bloomu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bluffton.edu/"],
    name: "Bluffton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bluffton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bju.edu/"],
    name: "Bob Jones University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.boisestate.edu/"],
    name: "Boise State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["boisestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bc.edu/"],
    name: "Boston College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bgsp.edu/"],
    name: "Boston Graduate School of Psychoanalysis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bgsp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bu.edu/"],
    name: "Boston University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bowdoin.edu/"],
    name: "Bowdoin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bowdoin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bowiestate.edu/"],
    name: "Bowie State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bowiestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bgsu.edu/"],
    name: "Bowling Green State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bgsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bradley.edu/"],
    name: "Bradley University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bradley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brandeis.edu/"],
    name: "Brandeis University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brandeis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brenau.edu/"],
    name: "Brenau University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brenau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.briar-cliff.edu/"],
    name: "Briar Cliff College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["briar-cliff.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bridgewater.edu/"],
    name: "Bridgewater College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bridgewater.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.byu.edu/"],
    name: "Brigham Young University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["byu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.byui.edu/"],
    name: "Brigham Young University - Idaho",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["byui.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.byuh.edu/"],
    name: "Brigham Young University Hawaii",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["byuh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.broward.edu/"],
    name: "Broward College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["broward.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brown.edu/"],
    name: "Brown University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brown.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bryant.edu/"],
    name: "Bryant College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bryant.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brynmawr.edu/college"],
    name: "Bryn Mawr College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brynmawr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bucknell.edu/"],
    name: "Bucknell University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bucknell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bvu.edu/"],
    name: "Buena Vista University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bvu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.butler.edu/"],
    name: "Butler University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["butler.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calcoast.edu/"],
    name: "California Coast University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calcoast.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.caltech.edu/"],
    name: "California Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["caltech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.callutheran.edu/"],
    name: "California Lutheran University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["callutheran.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csum.edu/"],
    name: "California Maritime Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cnuas.edu/"],
    name: "California National University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cnuas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calpoly.edu/"],
    name: "California Polytechnic State University, San Luis Obispo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calpoly.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csub.edu/"],
    name: "California State University, Bakersfield",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csub.edu", "csubak.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csuchico.edu/"],
    name: "California State University, Chico",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csuchico.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csudh.edu/"],
    name: "California State University, Dominguez Hills",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csudh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csufresno.edu/", "http://www.fresnostate.edu/"],
    name: "California State University, Fresno",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csufresno.edu", "fresnostate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fullerton.edu/"],
    name: "California State University, Fullerton",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fullerton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csuhayward.edu/"],
    name: "California State University, Hayward",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csuhayward.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csulb.edu/"],
    name: "California State University, Long Beach",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csulb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calstatela.edu/"],
    name: "California State University, Los Angeles",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calstatela.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.monterey.edu/"],
    name: "California State University, Monterey Bay",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monterey.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csun.edu/"],
    name: "California State University, Northridge",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csun.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csus.edu/"],
    name: "California State University, Sacramento",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csus.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csusb.edu/"],
    name: "California State University, San Bernardino",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csusb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csusm.edu/"],
    name: "California State University, San Marcos",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csusm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csustan.edu/"],
    name: "California State University, Stanislaus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csustan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calstate.edu/"],
    name: "California State University System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cup.edu/"],
    name: "California University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["cup.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calvin.edu/"],
    name: "Calvin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calvin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cameron.edu/"],
    name: "Cameron University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cameron.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.campbellsville.edu/"],
    name: "Campbellsville College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["campbellsville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.campbell.edu/"],
    name: "Campbell University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["campbell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.canisius.edu/"],
    name: "Canisius College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["canisius.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.capella.edu/", "http://www.capellauniversity.edu/"],
    name: "Capella University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["capella.edu", "capellauniversity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.captechu.edu/"],
    name: "Capitol Technology University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["captechu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carleton.edu/"],
    name: "Carleton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carleton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carlow.edu/"],
    name: "Carlow College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carlow.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmu.edu/"],
    name: "Carnegie Mellon University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carroll.edu/"],
    name: "Carroll College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carroll.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carrollu.edu/"],
    name: "Carroll University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carrollu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cn.edu/"],
    name: "Carson-Newman College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carthage.edu/"],
    name: "Carthage College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carthage.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.case.edu/"],
    name: "Case Western Reserve University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["case.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.castleton.edu/"],
    name: "Castleton State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["castleton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cua.edu/"],
    name: "Catholic University of America",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cedarville.edu/"],
    name: "Cedarville College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cedarville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.centenary.edu/"],
    name: "Centenary College of Louisiana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["centenary.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.central.edu/"],
    name: "Central College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["central.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccsu.edu/"],
    name: "Central Connecticut State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmc.edu/"],
    name: "Central Methodist College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmich.edu/"],
    name: "Central Michigan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cwu.edu/"],
    name: "Central Washington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.centre.edu/"],
    name: "Centre College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["centre.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csc.edu/"],
    name: "Chadron State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.champlain.edu/"],
    name: "Champlain College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["champlain.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chapman.edu/"],
    name: "Chapman University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chapman.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chatham.edu/"],
    name: "Chatham College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chatham.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chesapeake.edu/"],
    name: "Chesapeake College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chesapeake.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cheyney.edu/"],
    name: "Cheyney University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cheyney.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csopp.edu/"],
    name: "Chicago School of Professional Psychology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csopp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cbu.edu/"],
    name: "Christian Brothers University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cts.edu/"],
    name: "Christian Theological Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cts.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cnu.edu/"],
    name: "Christopher Newport University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cnu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cityu.edu/"],
    name: "City University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cityu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cuny.edu/"],
    name: "City University of New York",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cgs.edu/"],
    name: "Claremont Graduate School",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cgs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmc.edu/"],
    name: "Claremont McKenna College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["claremontmckenna.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarion.edu/"],
    name: "Clarion University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["clarion.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarke.edu/"],
    name: "Clarke College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clarke.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarkson.edu/"],
    name: "Clarkson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clarkson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarku.edu/"],
    name: "Clark University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clarku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clayton.edu/"],
    name: "Clayton State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clayton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clemson.edu/"],
    name: "Clemson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clemson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csuohio.edu/"],
    name: "Cleveland State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csuohio.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clinch.edu/"],
    name: "Clinch Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clinch.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastal.edu/"],
    name: "Coastal Carolina University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastal.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccd.edu/"],
    name: "Coast Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coe.edu/"],
    name: "Coe College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coe.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coker.edu/"],
    name: "Coker College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coker.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colby.edu/"],
    name: "Colby College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colby.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colgate.edu/"],
    name: "Colgate University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colgate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cofc.edu/"],
    name: "College of Charleston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cofc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ceu.edu/"],
    name: "College of Eastern Utah",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ceu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cnr.edu/"],
    name: "College of New Rochelle",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cnr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csbsju.edu/"],
    name: "College of Saint Benedict",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csbsju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stkate.edu/"],
    name: "College of Saint Catherine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stkate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.strose.edu/"],
    name: "College of Saint Rose",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["strose.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stfrancis.edu/"],
    name: "College of St. Francis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stfrancis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.css.edu/"],
    name: "College of St. Scholastica",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["css.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coa.edu/"],
    name: "College of the Atlantic",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.holycross.edu/"],
    name: "College of the Holy Cross",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["holycross.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wm.edu/"],
    name: "College of William and Mary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wooster.edu/"],
    name: "College of Wooster",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wooster.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccu.edu/"],
    name: "Colorado Christian University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coloradocollege.edu/"],
    name: "Colorado College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coloradocollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coloradomesa.edu/"],
    name: "Colorado Mesa University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coloradomesa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mines.edu/"],
    name: "Colorado School of Mines",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mines.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colostate.edu/"],
    name: "Colorado State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colostate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coloradotech.edu/", "http://www.ctuonline.edu/"],
    name: "Colorado Technical University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coloradotech.edu", "ctuonline.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colum.edu/"],
    name: "Columbia College Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colsouth.edu/"],
    name: "Columbia Southern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colsouth.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cuc.edu/"],
    name: "Columbia Union College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cuc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.columbia.edu/"],
    name: "Columbia University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccbcmd.edu/"],
    name: "Community College of Baltimore County",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccbcmd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccaa.edu/"],
    name: "Concordia College - Ann Arbor",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccaa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cord.edu/"],
    name: "Concordia College - Moorhead",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cord.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccsn.edu/"],
    name: "Concordia College - Seward",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccsn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csp.edu/"],
    name: "Concordia College - St. Paul",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.conncoll.edu/"],
    name: "Connecticut College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["conncoll.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ct.edu/"],
    name: "Connecticut State University System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ct.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cooper.edu/"],
    name: "Cooper Union for the Advancement of Science and Art",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cooper.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coppin.edu/"],
    name: "Coppin State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coppin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cornell-iowa.edu/"],
    name: "Cornell College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cornell-iowa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cornell.edu/"],
    name: "Cornell University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cornell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.corning-cc.edu/"],
    name: "Corning Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["corning-cc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.creighton.edu/"],
    name: "Creighton University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["creighton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.curry.edu/"],
    name: "Curry College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["curry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.daemen.edu/"],
    name: "Daemen College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["daemen.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dsu.edu/"],
    name: "Dakota State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dwu.edu/"],
    name: "Dakota Wesleyan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dbu.edu/"],
    name: "Dallas Baptist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dcccd.edu/"],
    name: "Dallas County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dcccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dana.edu/"],
    name: "Dana College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dana.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dwc.edu/"],
    name: "Daniel Webster College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dartmouth.edu/"],
    name: "Dartmouth College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dartmouth.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.davenport.edu/"],
    name: "Davenport University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["davenport.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.davidson.edu/"],
    name: "Davidson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["davidson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dne.wvnet.edu/"],
    name: "Davis & Elkins College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dne.wvnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.daytonastate.edu/"],
    name: "Daytona State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["daytonastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dsc.edu/"],
    name: "Delaware State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.deltastate.edu/"],
    name: "Delta State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["deltastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.denison.edu/"],
    name: "Denison University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["denison.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.depaul.edu/"],
    name: "DePaul University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["depaul.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.depauw.edu/"],
    name: "DePauw University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["depauw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.devry.edu/"],
    name: "DeVry Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["devry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ddu.ac.in/"],
    name: "Dharamsinh Desai University",
    alpha_two_code: "IN",
    "state-province": "Gujarat",
    domains: ["ddu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dickinson.edu/"],
    name: "Dickinson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dickinson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dickinsonstate.edu/"],
    name: "Dickinson State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dickinsonstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dillard.edu/"],
    name: "Dillard University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dillard.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dominican.edu/"],
    name: "Dominican College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dominican.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dordt.edu/"],
    name: "Dordt College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dordt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dowling.edu/"],
    name: "Dowling College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dowling.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.drake.edu/"],
    name: "Drake University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["drake.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.drew.edu/"],
    name: "Drew University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["drew.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.drexel.edu/"],
    name: "Drexel University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["drexel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.drury.edu/"],
    name: "Drury College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["drury.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.duke.edu/"],
    name: "Duke University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["duke.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.duq.edu/"],
    name: "Duquesne University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["duq.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.earlham.edu/"],
    name: "Earlham College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["earlham.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ecu.edu/"],
    name: "East Carolina University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ecu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ecok.edu/"],
    name: "East Central University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ecok.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.easternct.edu/"],
    name: "Eastern Connecticut State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["easternct.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eiu.edu/"],
    name: "Eastern Illinois University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eku.edu/"],
    name: "Eastern Kentucky University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emu.edu/"],
    name: "Eastern Mennonite University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emich.edu/"],
    name: "Eastern Michigan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.enmu.edu/"],
    name: "Eastern New Mexico University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["enmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eou.edu/"],
    name: "Eastern Oregon State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eou.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ewu.edu/"],
    name: "Eastern Washington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ewu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.esu.edu/"],
    name: "East Stroudsburg State University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["esu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.etsu.edu/"],
    name: "East Tennessee State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["etsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.edgewood.edu/"],
    name: "Edgewood College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["edgewood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.edinboro.edu/"],
    name: "Edinboro University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["edinboro.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ecsu.edu/"],
    name: "Elizabeth City State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ecsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.etown.edu/"],
    name: "Elizabethtown College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["etown.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elmhurst.edu/"],
    name: "Elmhurst College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elmhurst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elon.edu/"],
    name: "Elon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.erau.edu/"],
    name: "Embry-Riddle Aeronautical University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["erau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emerson.edu/"],
    name: "Emerson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emerson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emmanuel.edu/"],
    name: "Emmanuel College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emmanuel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emory.edu/"],
    name: "Emory University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emory.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emporia.edu/"],
    name: "Emporia State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emporia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ecc.edu/"],
    name: "Erie Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.etbu.edu/"],
    name: "East Texas Baptist University",
    alpha_two_code: "US",
    "state-province": "TX",
    domains: ["etbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.evergreen.edu/"],
    name: "Evergreen State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["evergreen.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fdu.edu/"],
    name: "Fairleigh Dickinson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fdu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fairmontstate.edu/"],
    name: "Fairmont State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fairmontstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uncfsu.edu/"],
    name: "Fayetteville State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uncfsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ferris.edu/"],
    name: "Ferris State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ferris.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fielding.edu/"],
    name: "Fielding Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fielding.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fisk.edu/"],
    name: "Fisk University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fisk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fsc.edu/"],
    name: "Fitchburg State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.famu.edu/"],
    name: "Florida Agricultural and Mechanical University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["famu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fau.edu/"],
    name: "Florida Atlantic University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fgcu.edu/"],
    name: "Florida Gulf Coast University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fgcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fit.edu/"],
    name: "Florida Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fiu.edu/"],
    name: "Florida International University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fsu.edu/"],
    name: "Florida State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fontbonne.edu/"],
    name: "Fontbonne College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fontbonne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fordham.edu/"],
    name: "Fordham University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fordham.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fhsu.edu/"],
    name: "Fort Hays State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fhsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fortlewis.edu/"],
    name: "Fort Lewis College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fortlewis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://fountainheadcollege.edu/"],
    name: "Fountainhead College of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fountainheadcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fandm.edu/"],
    name: "Franklin and Marshall College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fandm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fplc.edu/"],
    name: "Franklin Pierce Law Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fplc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.franklin.edu/"],
    name: "Franklin University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["franklin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.frederick.edu/"],
    name: "Frederick Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["frederick.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fresno.edu/"],
    name: "Fresno Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fresno.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.friends.edu/"],
    name: "Friends University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["friends.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.frostburg.edu/"],
    name: "Frostburg State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["frostburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fuller.edu/"],
    name: "Fuller Theological Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fuller.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.furman.edu/"],
    name: "Furman University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["furman.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://futureworks.ac.uk/"],
    name: "Futureworks",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["futureworks.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gallaudet.edu/"],
    name: "Gallaudet University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gallaudet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gannon.edu/"],
    name: "Gannon University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gannon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.geneva.edu/"],
    name: "Geneva College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["geneva.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gfc.edu/"],
    name: "George Fox College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gfc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gmu.edu/"],
    name: "George Mason University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.georgetown.edu/"],
    name: "Georgetown University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["georgetown.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gwu.edu/"],
    name: "George Washington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gcsu.edu/"],
    name: "Georgia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gcsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gatech.edu/"],
    name: "Georgia Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.georgian.edu/"],
    name: "Georgian Court College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["georgian.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.georgiasouthern.edu/"],
    name: "Georgia Southern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["georgiasouthern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://gsw.edu/"],
    name: "Georgia Southwestern State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gsw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gsu.edu/"],
    name: "Georgia State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gettysburg.edu/"],
    name: "Gettysburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gettysburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gmi.edu/"],
    name: "GMI Engineering and Management Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gmi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ggu.edu/"],
    name: "Golden Gate University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ggu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gbc.edu/"],
    name: "Goldey-Beacom College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gonzaga.edu/"],
    name: "Gonzaga University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gonzaga.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.goshen.edu/"],
    name: "Goshen College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["goshen.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.goucher.edu/"],
    name: "Goucher College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["goucher.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.govst.edu/"],
    name: "Governors State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["govst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.grace.edu/"],
    name: "Grace College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["grace.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.graceland.edu/"],
    name: "Graceland College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["graceland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gvsu.edu/"],
    name: "Grand Valley State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gvsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.greenleaf.edu/"],
    name: "Greenleaf University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["greenleaf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.grinnell.edu/"],
    name: "Grinnell College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["grinnell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.guilford.edu/"],
    name: "Guilford College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["guilford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gac.edu/"],
    name: "Gustavus Adolphus College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hagerstowncc.edu/"],
    name: "Hagerstown Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hagerstowncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hamilton.edu/"],
    name: "Hamilton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hamilton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hamline.edu/"],
    name: "Hamline University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hamline.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hsc.edu/"],
    name: "Hampden-Sydney College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hampshire.edu/"],
    name: "Hampshire College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hampshire.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hamptonu.edu/"],
    name: "Hampton University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hamptonu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hanover.edu/"],
    name: "Hanover College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hanover.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harding.edu/"],
    name: "Harding University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harding.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harford.edu/"],
    name: "Harford Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hartwick.edu/"],
    name: "Hartwick College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hartwick.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harvard.edu/"],
    name: "Harvard University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harvard.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hmc.edu/"],
    name: "Harvey Mudd College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hmc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.haskell.edu/"],
    name: "Haskell Indian Nations University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["haskell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hastings.edu/"],
    name: "Hastings College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hastings.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.haverford.edu/"],
    name: "Haverford College in Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["haverford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hpu.edu/"],
    name: "Hawaii Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hpu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.heidelberg.edu/"],
    name: "Heidelberg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["heidelberg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hendrix.edu/"],
    name: "Hendrix College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hendrix.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hesston.edu/"],
    name: "Hesston College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hesston.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.highpoint.edu/"],
    name: "High Point University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["highpoint.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hillsdale.edu/"],
    name: "Hillsdale College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hillsdale.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hiram.edu/"],
    name: "Hiram College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hiram.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hws.edu/"],
    name: "Hobart and William Smith Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hws.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hofstra.edu/"],
    name: "Hofstra University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hofstra.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hollins.edu/"],
    name: "Hollins College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hollins.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hood.edu/"],
    name: "Hood College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hope.edu/"],
    name: "Hope College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hope.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.howardcc.edu/"],
    name: "Howard Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["howardcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.howard.edu/"],
    name: "Howard University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["howard.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.humboldt.edu/"],
    name: "Humboldt State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["humboldt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hunter.cuny.edu/"],
    name: "Hunter College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hunter.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.huntingdon.edu/"],
    name: "Huntingdon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["huntingdon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.huntington.edu/"],
    name: "Huntington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["huntington.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ici.edu/"],
    name: "ICI University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ici.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.isu.edu/"],
    name: "Idaho State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["isu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ibc.edu/"],
    name: "Illinois Benedictine College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ibc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iit.edu/"],
    name: "Illinois Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.illinoisstate.edu/"],
    name: "Illinois State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["illinoisstate.edu", "ilstu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indianatech.edu/"],
    name: "Indiana Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indianatech.edu", "indianatech.net"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indstate.edu/"],
    name: "Indiana State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iu.edu/"],
    name: "Indiana University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indiana.edu/"],
    name: "Indiana University at Bloomington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indiana.edu", "iub.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iusb.edu/"],
    name: "Indiana University at South Bend",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iusb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iup.edu/"],
    name: "Indiana University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["iup.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iupuc.edu/"],
    name: "Indiana University/Purdue University at Columbus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iupuc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ipfw.edu/"],
    name: "Indiana University/Purdue University at Fort Wayne",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ipfw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iupui.edu/"],
    name: "Indiana University/Purdue University at Indianapolis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iupui.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ius.edu/"],
    name: "Indiana University Southeast",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ius.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indwes.edu/"],
    name: "Indiana Wesleyan University, Marion",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indwes.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iwp.edu/"],
    name: "Institute for World Politics",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iwp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iona.edu/"],
    name: "Iona College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iona.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iastate.edu/"],
    name: "Iowa State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ivc.edu/"],
    name: "Irvine Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ivc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ithaca.edu/"],
    name: "Ithaca College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ithaca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jsums.edu/"],
    name: "Jackson State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jsums.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jsu.edu/"],
    name: "Jacksonville State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ju.edu/"],
    name: "Jacksonville University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jmu.edu/"],
    name: "James Madison University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jbu.edu/"],
    name: "John Brown University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jfku.edu/"],
    name: "John F. Kennedy University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jfku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jhu.edu/"],
    name: "Johns Hopkins University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jh.edu", "jhu.edu", "johnshopkins.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jhuapl.edu/"],
    name: "Johns Hopkins University Applied Physics Laboratory",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jhuapl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jwu.edu/"],
    name: "Johnson & Wales University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jbc.edu/"],
    name: "Johnson Bible College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jcsu.edu/"],
    name: "Johnson C. Smith University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jcsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jones.edu/"],
    name: "Jones College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jones.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.judson.edu/"],
    name: "Judson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["judson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.juniata.edu/"],
    name: "Juniata College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["juniata.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kzoo.edu/"],
    name: "Kalamazoo College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kzoo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ksu.edu/"],
    name: "Kansas State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ksu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kwu.edu/"],
    name: "Kansas Wesleyan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kaplan.edu/"],
    name: "Kaplan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kaplan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kean.edu/"],
    name: "Kean College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kean.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.keene.edu/"],
    name: "Keene State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["keene.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kennesaw.edu/"],
    name: "Kennesaw State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kennesaw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kent.edu/"],
    name: "Kent State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kent.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kctcs.edu/"],
    name: "Kentucky Community & Technical College System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kenyon.edu/"],
    name: "Kenyon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kenyon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kettering.edu/"],
    name: "Kettering University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kettering.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kings.edu/"],
    name: "King's College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kings.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.knox.edu/"],
    name: "Knox College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["knox.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kutztown.edu/"],
    name: "Kutztown University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["kutztown.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lafayette.edu/"],
    name: "Lafayette College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lafayette.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lagrange.edu/"],
    name: "LaGrange College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lagrange.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lfc.edu/"],
    name: "Lake Forest College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lfc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lsc.edu/"],
    name: "Lake Superior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lssu.edu/"],
    name: "Lake Superior State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lssu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lamar.edu/"],
    name: "Lamar University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lamar.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.lambtoncollege.ca"],
    name: "Lambton College",
    alpha_two_code: "CA",
    "state-province": "Sarnia",
    domains: ["lambtoncollege.ca", "mylambton.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.langston.edu/"],
    name: "Langston University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["langston.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lasalle.edu/"],
    name: "LaSalle University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lasalle.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lasierra.edu/"],
    name: "La Sierra University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lasierra.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ltu.edu/"],
    name: "Lawrence Technological University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ltu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lawrence.edu/"],
    name: "Lawrence University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lawrence.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lvc.edu/"],
    name: "Lebanon Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lehigh.edu/"],
    name: "Lehigh University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lehigh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lemoyne.edu/"],
    name: "Le Moyne College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lemoyne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lenoircc.edu/"],
    name: "Lenoir Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lenoircc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lrc.edu/"],
    name: "Lenoir-Rhyne College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lrc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.letu.edu/"],
    name: "LeTourneau University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["letu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lclark.edu/"],
    name: "Lewis & Clark College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lclark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lcsc.edu/"],
    name: "Lewis-Clark State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lcsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lewisu.edu/"],
    name: "Lewis University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lewisu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.liberty.edu/"],
    name: "Liberty University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["liberty.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lincoln.edu/"],
    name: "Lincoln University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lincoln.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.linfield.edu/"],
    name: "Linfield College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["linfield.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://lockhaven.edu/"],
    name: "Lock Haven University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lhup.edu", "lockhaven.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.llu.edu/"],
    name: "Loma Linda University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["llu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.liu.edu/"],
    name: "Long Island University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["liunet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.longwood.edu/"],
    name: "Longwood University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["longwood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.loras.edu/"],
    name: "Loras College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["loras.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laccd.edu/"],
    name: "Los Angeles Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lacollege.edu/"],
    name: "Louisiana College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lsu.edu/"],
    name: "Louisiana State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lsua.edu/"],
    name: "Louisiana State University at Alexandria",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lsua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.latech.edu/"],
    name: "Louisiana Tech University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["latech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.loyola.edu/"],
    name: "Loyola College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["loyola.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lmu.edu/"],
    name: "Loyola Marymount University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.luc.edu/"],
    name: "Loyola University Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["luc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.luther.edu/"],
    name: "Luther College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["luther.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.luthersem.edu/"],
    name: "Luther Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["luthersem.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lycoming.edu/"],
    name: "Lycoming College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lycoming.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lynchburg.edu/"],
    name: "Lynchburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lynchburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lyndonstate.edu/"],
    name: "Lyndon State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lyndonstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lyon.edu/"],
    name: "Lyon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lyon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.macalester.edu/"],
    name: "Macalester College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["macalester.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mum.edu/"],
    name: "Maharishi University of Management",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.malone.edu/"],
    name: "Malone College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["malone.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.manhattan.edu/"],
    name: "Manhattan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["manhattan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mansfield.edu/"],
    name: "Mansfield University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["mansfield.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.maricopa.edu/"],
    name: "Maricopa County Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marietta.edu/"],
    name: "Marietta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marietta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marist.edu/"],
    name: "Marist College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marist.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marlboro.edu/"],
    name: "Marlboro College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marlboro.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marquette.edu/"],
    name: "Marquette University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marquette.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marshall.edu/"],
    name: "Marshall University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marshall.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mbc.edu/"],
    name: "Mary Baldwin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mmm.edu/"],
    name: "Marymount Manhattan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mmm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marymount.edu/"],
    name: "Marymount University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marymount.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mwc.edu/"],
    name: "Mary Washington College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://web.mit.edu/"],
    name: "Massachusetts Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcdaniel.edu"],
    name: "McDaniel College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcdaniel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www2.mcm.edu/"],
    name: "McMurry University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcneese.edu/"],
    name: "McNeese State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcneese.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcg.edu/"],
    name: "Medical College of Georgia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcw.edu/"],
    name: "Medical College of Wisconsin",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mccc.edu/"],
    name: "Mercer County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mercer.edu/"],
    name: "Mercer University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mercer.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mercy.edu/"],
    name: "Mercy College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mercymavericks.edu", "mercy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://mercyhurst.edu/"],
    name: "Mercyhurst College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mercyhurst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.meredith.edu/"],
    name: "Meredith College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["meredith.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.messiah.edu/"],
    name: "Messiah College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["messiah.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcckc.edu/"],
    name: "Metropolitan Community College (MO)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcckc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mccneb.edu/"],
    name: "Metropolitan Community College (NE)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mccneb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msudenver.edu/"],
    name: "Metropolitan State College of Denver",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msudenver.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.metrostate.edu/"],
    name: "Metropolitan State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["metrostate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.miamioh.edu/"],
    name: "Miami University of Ohio",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["miamioh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msu.edu/"],
    name: "Michigan State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtu.edu/"],
    name: "Michigan Technological University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.manc.edu/"],
    name: "Mid-America Nazarene College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["manc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.middlebury.edu/"],
    name: "Middlebury College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["middlebury.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mga.edu/"],
    name: "Middle Georgia State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mga.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtsu.edu/"],
    name: "Middle Tennessee State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mwsu.edu/"],
    name: "Midwestern State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mwsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.millersville.edu/"],
    name: "Millersville University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["millersville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.milligan.edu/"],
    name: "Milligan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["milligan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.millikin.edu/"],
    name: "Millikin University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["millikin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.millsaps.edu/"],
    name: "Millsaps College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["millsaps.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msoe.edu/"],
    name: "Milwaukee School of Engineering",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msoe.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcad.edu/"],
    name: "Minneapolis College of Art and Design",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcad.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mnsu.edu/"],
    name: "Minnesota State University, Mankato",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mnsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mnstate.edu/"],
    name: "Minnesota State University Moorhead",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mnstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.minotstateu.edu/"],
    name: "Minot State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["minotstateu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mc.edu/"],
    name: "Mississippi College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msstate.edu/"],
    name: "Mississippi State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.muw.edu/"],
    name: "Mississippi University for Women",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["muw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mssc.edu/"],
    name: "Missouri Southern State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mssc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mst.edu/"],
    name: "Missouri University of Science and Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mwsc.edu/"],
    name: "Missouri Western State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mwsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.molloy.edu/"],
    name: "Molloy College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["molloy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.monmouthcollege.edu/"],
    name: "Monmouth College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monmouthcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.monmouth.edu/"],
    name: "Monmouth University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monmouth.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msubillings.edu/"],
    name: "Montana State University - Billings",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msubillings.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montana.edu/"],
    name: "Montana State University - Bozeman",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montana.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msun.edu/"],
    name: "Montana State University - Northern",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msun.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtech.edu/"],
    name: "Montana Tech",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montclair.edu/"],
    name: "Montclair State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montclair.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montgomerycollege.edu/"],
    name: "Montgomery College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montgomerycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montreat.edu/"],
    name: "Montreat College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montreat.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.moravian.edu/"],
    name: "Moravian College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["moravian.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.morgan.edu/"],
    name: "Morgan State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["morgan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcc.edu/"],
    name: "Mott Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtholyoke.edu/"],
    name: "Mount Holyoke College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtholyoke.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msj.edu/"],
    name: "Mount Saint Joseph College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msmc.edu/"],
    name: "Mount Saint Mary College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msmc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mscfs.edu/"],
    name: "Mount Senario College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mscfs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.muc.edu/"],
    name: "Mount Union College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["muc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mursuky.edu/"],
    name: "Murray State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mursuky.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.muskingum.edu/"],
    name: "Muskingum College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["muskingum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nscc.edu/"],
    name: "Nashville State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ndu.edu/"],
    name: "National Defense University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ndu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nl.edu/"],
    name: "National-Louis University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nrao.edu/"],
    name: "National Radio Astronomy Observatory",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nrao.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ntu.edu/"],
    name: "National Technological University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ntu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nu.edu/"],
    name: "National University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nps.edu/"],
    name: "Naval Postgraduate School",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nps.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www2.naz.edu/"],
    name: "Nazareth College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["naz.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://system.nevada.edu/"],
    name: "Nevada System of Higher Education",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nevada.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newberry.edu/"],
    name: "Newberry College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["newberry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newcollege.edu/"],
    name: "New College of California",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["newcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.neit.edu/"],
    name: "New England Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["neit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nhc.edu/"],
    name: "New Hampshire College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nhc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.njit.edu/"],
    name: "New Jersey Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["njit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmhu.edu/"],
    name: "New Mexico Highlands University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmhu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmt.edu/"],
    name: "New Mexico Institute of Mining & Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmsu.edu/"],
    name: "New Mexico State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nyit.edu/"],
    name: "New York Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nyit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nyu.edu/"],
    name: "New York University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nyu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.niagara.edu/"],
    name: "Niagara University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["niagara.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nicholls.edu/"],
    name: "Nicholls State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nicholls.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nsu.edu/"],
    name: "Norfolk State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.na.edu/"],
    name: "North American University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["na.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northampton.edu/"],
    name: "Northampton Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northampton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncat.edu/"],
    name: "North Carolina A&T State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncat.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nccu.edu/"],
    name: "North Carolina Central University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nccu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncsu.edu/"],
    name: "North Carolina State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncwc.edu/"],
    name: "North Carolina Wesleyan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncbc.edu/"],
    name: "North Central Bible College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ndsu.edu/"],
    name: "North Dakota State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ndsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nlu.edu/"],
    name: "Northeastern Louisiana University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nlu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nsuok.edu/"],
    name: "Northeastern State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nsuok.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northeastern.edu/"],
    name: "Northeastern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["neu.edu", "northeastern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nau.edu/"],
    name: "Northern Arizona University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.niu.edu/"],
    name: "Northern Illinois University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["niu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nku.edu/"],
    name: "Northern Kentucky University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmu.edu/"],
    name: "Northern Michigan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northern.edu/"],
    name: "Northern State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northland.edu/"],
    name: "Northland College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.npcts.edu/"],
    name: "North Park College and Theological Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["npcts.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwciowa.edu/"],
    name: "Northwestern College of Iowa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwciowa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nsula.edu/"],
    name: "Northwestern State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nsula.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northwestern.edu/"],
    name: "Northwestern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northwestern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwmissouri.edu/"],
    name: "Northwest Missouri State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwmissouri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nnc.edu/"],
    name: "Northwest Nazarene College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nnc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.norwich.edu/"],
    name: "Norwich University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["norwich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nova.edu/"],
    name: "Nova Southeastern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nova.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oakland.edu/"],
    name: "Oakland University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oakland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oakwood.edu/"],
    name: "Oakwood University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oakwood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oberlin.edu/"],
    name: "Oberlin College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oberlin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oxy.edu/"],
    name: "Occidental College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oxy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.odc.edu/"],
    name: "Ohio Dominican College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["odc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.onu.edu/"],
    name: "Ohio Northern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["onu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.osu.edu/"],
    name: "Ohio State University, Columbus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["osu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ohio.edu/"],
    name: "Ohio University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ohio.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.owu.edu/"],
    name: "Ohio Wesleyan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["owu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.okbu.edu/"],
    name: "Oklahoma Baptist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["okbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.okcu.edu/"],
    name: "Oklahoma City University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["okcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.okstate.edu/"],
    name: "Oklahoma State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["okstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.odu.edu/"],
    name: "Old Dominion University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["odu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.olivet.edu/"],
    name: "Olivet Nazarene University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["olivet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oru.edu/"],
    name: "Oral Roberts University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oru.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ogi.edu/"],
    name: "Oregon Graduate Institute of Science and Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ogi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ohsu.edu/"],
    name: "Oregon Health Sciences University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ohsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oit.edu/"],
    name: "Oregon Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oregonstate.edu/"],
    name: "Oregon State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oregonstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.otterbein.edu/"],
    name: "Otterbein College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["otterbein.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ollusa.edu/"],
    name: "Our Lady of the Lake University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ollusa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pace.edu/"],
    name: "Pace University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pace.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.plu.edu/"],
    name: "Pacific Lutheran University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["plu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.puc.edu/"],
    name: "Pacific Union College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["puc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pacificu.edu/"],
    name: "Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pacificu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pwu.com/"],
    name: "Pacific Western University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pwu.com"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pbac.edu/"],
    name: "Palm Beach Atlantic College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pbac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.palmbeachstate.edu/"],
    name: "Palm Beach State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["palmbeachstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.peace.edu/"],
    name: "Peace College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["peace.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pembroke.edu/"],
    name: "Pembroke State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pembroke.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pct.edu/"],
    name: "Pennsylvania College of Technology",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pct.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.psu.edu/"],
    name: "Pennsylvania State University",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["psu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sl.psu.edu/"],
    name: "Pennsylvania State University - Schuylkill Campus",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["sl.psu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pcci.edu/"],
    name: "Pensacola Christian College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pcci.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pensacolastate.edu/"],
    name: "Pensacola State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pensacolastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pepperdine.edu/"],
    name: "Pepperdine University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pepperdine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.peru.edu/"],
    name: "Peru State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["peru.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.pdfw.edu/"],
    name: "Purdue University Fort Wayne",
    alpha_two_code: "US",
    "state-province": "IN",
    domains: ["pfw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.philau.edu/"],
    name: "Philadelphia University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["philau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.phillips.edu/"],
    name: "Phillips University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["phillips.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pittstate.edu/"],
    name: "Pittsburg State University",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pittstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pitzer.edu/"],
    name: "Pitzer College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pitzer.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.platt.edu/"],
    name: "Platt College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["platt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.plymouth.edu/"],
    name: "Plymouth State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["plymouth.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.poly.edu/"],
    name: "Polytechnic University of New York",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["poly.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pupr.edu/"],
    name: "Polytechnic University of Puerto Rico",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pupr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pomona.edu/"],
    name: "Pomona College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pomona.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pcc.edu/"],
    name: "Portland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ee.pdx.edu/"],
    name: "Portland State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pdx.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pvamu.edu/"],
    name: "Prairie View A&M University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pvamu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pratt.edu/"],
    name: "Pratt Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pratt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.presby.edu/"],
    name: "Presbyterian College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["presby.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.prescott.edu/"],
    name: "Prescott College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["prescott.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.princeton.edu/"],
    name: "Princeton University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["princeton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.providence.edu/"],
    name: "Providence College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["providence.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.purdue.edu/"],
    name: "Purdue University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["purdue.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://webs.purduecal.edu/"],
    name: "Purdue University Calumet",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["purduecal.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pnc.edu/"],
    name: "Purdue University North Central",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pnc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.quincy.edu/"],
    name: "Quincy University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["quincy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.quinnipiac.edu/"],
    name: "Quinnipiac College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["quinnipiac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.radford.edu/"],
    name: "Radford University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["radford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ramapo.edu/"],
    name: "Ramapo College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ramapo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rmc.edu/"],
    name: "Randolph-Macon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rmc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rmwc.edu/"],
    name: "Randolph-Macon Woman's College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rmwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.reed.edu/"],
    name: "Reed College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["reed.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.regent.edu/"],
    name: "Regent University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["regent.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.regis.edu/"],
    name: "Regis University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["regis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rpi.edu/"],
    name: "Rensselaer Polytechnic Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rpi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ric.edu/"],
    name: "Rhode Island College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ric.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rhodes.edu/"],
    name: "Rhodes College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rhodes.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rice.edu/"],
    name: "Rice University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rice.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stockton.edu/"],
    name: "Richard Stockton College of New Jersey",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stockton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rider.edu/"],
    name: "Rider University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rider.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ripon.edu/"],
    name: "Ripon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ripon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.riv.edu/"],
    name: "Rivier College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["riv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.roanoke.edu/"],
    name: "Roanoke College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roanoke.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rmu.edu/"],
    name: "Robert Morris University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rit.edu/"],
    name: "Rochester Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rockefeller.edu/"],
    name: "Rockefeller University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rockefeller.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rockford.edu/"],
    name: "Rockford College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rockford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rockhurst.edu/"],
    name: "Rockhurst College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rockhurst.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rocky.edu/"],
    name: "Rocky Mountain College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rocky.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rwu.edu/"],
    name: "Roger Williams University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rollins.edu/"],
    name: "Rollins College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rollins.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rosary.edu/"],
    name: "Rosary College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rosary.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rose-hulman.edu/"],
    name: "Rose-Hulman Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rose-hulman.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rowan.edu/"],
    name: "Rowan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rowan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rutgers.edu/"],
    name: "Rutgers University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rutgers.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.camden.rutgers.edu/"],
    name: "Rutgers University, Camden",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rutgers.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newark.rutgers.edu/"],
    name: "Rutgers University, Newark",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rutgers.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sacredheart.edu/"],
    name: "Sacred Heart University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sacredheart.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sage.edu/"],
    name: "Sage Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sage.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.svsu.edu/"],
    name: "Saginaw Valley State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["svsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.anselm.edu/"],
    name: "Saint Anselm College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["anselm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stcloudstate.edu/"],
    name: "Saint Cloud State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stcloudstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stedwards.edu/"],
    name: "Saint Edward's University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stedwards.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sfcpa.edu/"],
    name: "Saint Francis College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sfcpa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csbsju.edu/"],
    name: "Saint John's University (MN)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csbsju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stjohns.edu/"],
    name: "Saint John's University (NY)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stjohns.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saintjoe.edu/"],
    name: "Saint Joseph's College (IN)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saintjoe.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sju.edu/"],
    name: "Saint Joseph's University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saintleo.edu/"],
    name: "Saint Leo University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saintleo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.slu.edu/"],
    name: "Saint Louis University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["slu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smcks.edu/"],
    name: "Saint Mary College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smcks.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saintmarys.edu/"],
    name: "Saint Mary's College (IN)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saintmarys.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stmarys-ca.edu/"],
    name: "Saint Mary's College of California",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stmarys-ca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smumn.edu/"],
    name: "Saint Mary's University of Minnesota",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smumn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smcvt.edu/"],
    name: "Saint Michael's College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smcvt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stolaf.edu/"],
    name: "Saint Olaf College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stolaf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stvincent.edu/"],
    name: "Saint Vincent College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stvincent.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sxu.edu/"],
    name: "Saint Xavier University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sxu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.salisbury.edu/"],
    name: "Salisbury University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["salisbury.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.skc.edu/"],
    name: "Salish Kootenai College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["skc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.samford.edu/"],
    name: "Samford University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["samford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shsu.edu/"],
    name: "Sam Houston State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdsu.edu/"],
    name: "San Diego State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sfsu.edu/"],
    name: "San Francisco State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sfsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjsu.edu/"],
    name: "San Jose State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scu.edu/"],
    name: "Santa Clara University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.slc.edu/"],
    name: "Sarah Lawrence College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["slc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saic.edu"],
    name: "School of the Art Institute of Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://seattlecentral.edu/"],
    name: "Seattle Central College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["seattlecentral.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.spu.edu/"],
    name: "Seattle Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["spu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.seattleu.edu/"],
    name: "Seattle University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["seattleu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shu.edu/"],
    name: "Seton Hall University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sewanee.edu/"],
    name: "Sewanee, University of the South",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sewanee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shawnee.edu/"],
    name: "Shawnee State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shawnee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.su.edu/"],
    name: "Shenandoah University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["su.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ship.edu/"],
    name: "Shippensburg University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["ship.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shorter.edu/"],
    name: "Shorter College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shorter.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.simmons.edu/"],
    name: "Simmons College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["simmons.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.simons-rock.edu/"],
    name: "Simon's Rock College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["simons-rock.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.simpson.edu/"],
    name: "Simpson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["simpson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sinclair.edu/"],
    name: "Sinclair Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sinclair.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.skidmore.edu/"],
    name: "Skidmore College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["skidmore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sru.edu/"],
    name: "Slippery Rock University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["sru.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smith.edu/"],
    name: "Smith College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smith.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sonoma.edu/"],
    name: "Sonoma State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sonoma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdsmt.edu/"],
    name: "South Dakota School of Mines and Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdsmt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdstate.edu/"],
    name: "South Dakota State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.selu.edu/"],
    name: "Southeastern Louisiana University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["selu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.semo.edu/"],
    name: "Southeast Missouri State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["semo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southern.edu/"],
    name: "Southern College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sct.edu/"],
    name: "Southern College of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sct.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southernct.edu/"],
    name: "Southern Connecticut State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southernct.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.siu.edu/"],
    name: "Southern Illinois University-Carbondale",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["siu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.siue.edu/"],
    name: "Southern Illinois University-Edwardsville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["siue.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smu.edu/"],
    name: "Southern Methodist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.snu.edu/"],
    name: "Southern Nazarene University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["snu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.snhu.edu/"],
    name: "Southern New Hampshire University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["snhu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sou.edu/"],
    name: "Southern Oregon State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sou.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.subr.edu/"],
    name: "Southern University and A&M College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["subr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.suu.edu/"],
    name: "Southern Utah University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["suu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stcl.edu/"],
    name: "South Texas College of Law",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stcl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sbuniv.edu/"],
    name: "Southwest Baptist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sbuniv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swac.edu/"],
    name: "Southwestern Adventist College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sagu.edu/"],
    name: "Southwestern Assemblies of God University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sagu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sckans.edu/"],
    name: "Southwestern College (KS)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sckans.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southwestern.edu/"],
    name: "Southwestern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southwestern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smsu.edu/"],
    name: "Southwest Missouri State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swt.edu/"],
    name: "Southwest Texas State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.auc.edu/"],
    name: "Spelman College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["auc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.arbor.edu/"],
    name: "Spring Arbor College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["arbor.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shc.edu/"],
    name: "Spring Hill College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sau.edu/"],
    name: "St. Ambrose University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sau.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sapc.edu/"],
    name: "St. Andrews Presbyterian College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sapc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stanford.edu/"],
    name: "Stanford University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stanford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.albany.edu/"],
    name: "State University of New York at Albany",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["albany.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.binghamton.edu/"],
    name: "State University of New York at Binghamton",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["binghamton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.buffalo.edu/"],
    name: "State University of New York at Buffalo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["buffalo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.farmingdale.edu/"],
    name: "State University of New York at Farmingdale",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["farmingdale.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://home.fredonia.edu/"],
    name: "State University of New York at Fredonia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fredonia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oswego.edu/"],
    name: "State University of New York at Oswego",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oswego.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.plattsburgh.edu/"],
    name: "State University of New York at Plattsburgh",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["plattsburgh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stonybrook.edu/"],
    name: "State University of New York at Stony Brook",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stonybrook.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stonybrookmedicine.edu/"],
    name: "Academic medical center at State University of New York at Stony Brook",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stonybrookmedicine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brockport.edu/"],
    name: "State University of New York College at Brockport",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brockport.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://suny.buffalostate.edu/"],
    name: "State University of New York College at Buffalo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["buffalostate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cortland.edu/"],
    name: "State University of New York College at Cortland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cortland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.geneseo.edu/"],
    name: "State University of New York College at Geneseo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["geneseo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newpaltz.edu/"],
    name: "State University of New York College at New Paltz",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["newpaltz.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.potsdam.edu/"],
    name: "State University of New York College at Potsdam",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["potsdam.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cobleskill.edu/"],
    name: "State University of New York College of Agriculture and Technology at Cobleskill",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cobleskill.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.esf.edu/"],
    name: "State University of New York College of Environmental Science and Forestry",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["esf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alfredtech.edu/"],
    name: "State University of New York College of Technology at Alfred",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alfredtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunypoly.edu/"],
    name: "State University of New York Polytechnic Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunycentral.edu/"],
    name: "State University of New York System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunycentral.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sbu.edu/"],
    name: "St. Bonaventure University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sfasu.edu/"],
    name: "Stephen F. Austin State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sfasu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stephens.edu/"],
    name: "Stephens College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stephens.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stetson.edu/"],
    name: "Stetson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stetson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stevens.edu/"],
    name: "Stevens Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stevens.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjca.edu/"],
    name: "St. John's College - Annapolis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjcsf.edu/"],
    name: "St. John's College - Santa Fe",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjcsf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjc.edu/"],
    name: "St. Joseph College (CT)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjcme.edu/"],
    name: "St. Joseph's College (ME)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjcme.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stlawu.edu/"],
    name: "St. Lawrence University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stlawu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stlcop.edu/"],
    name: "St. Louis College of Pharmacy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stlcop.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stmartin.edu/"],
    name: "St. Martin's College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stmartin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smcm.edu/"],
    name: "St. Mary's College of Maryland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smcm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.strayer.edu/"],
    name: "Strayer College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["strayer.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stu.edu/"],
    name: "St. Thomas University (FL)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.suffolk.edu/"],
    name: "Suffolk University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["suffolk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sulross.edu/"],
    name: "Sul Ross State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sulross.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.summitunivofla.edu/"],
    name: "Summit University of Louisiana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["summitunivofla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.susqu.edu/"],
    name: "Susquehanna University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["susqu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swarthmore.edu/"],
    name: "Swarthmore College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swarthmore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sbc.edu/"],
    name: "Sweet Briar College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.syr.edu/"],
    name: "Syracuse University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["syr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tabor.edu/"],
    name: "Tabor College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tabor.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tarleton.edu/"],
    name: "Tarleton State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tarleton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tayloru.edu/"],
    name: "Taylor University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tayloru.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.temple.edu/"],
    name: "Temple University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["temple.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tnstate.edu/"],
    name: "Tennessee State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tnstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tntech.edu/"],
    name: "Tennessee Technological University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tntech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tccd.edu/"],
    name: "Terrant County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tamiu.edu/"],
    name: "Texas A&M International University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tamiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tamu.edu/"],
    name: "Texas A&M University - College Station",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tamu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tamuc.edu/"],
    name: "Texas A&M University - Commerce",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tamuc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tamucc.edu/"],
    name: "Texas A&M University - Corpus Christi",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tamucc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tamuk.edu/"],
    name: "Texas A&M University - Kingsville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tamuk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tcu.edu/"],
    name: "Texas Christian University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tsu.edu/"],
    name: "Texas Southern University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.txstate.edu/"],
    name: "Texas State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["txstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ttu.edu/"],
    name: "Texas Tech University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ttu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ttuhsc.edu/"],
    name: "Texas Tech University-Health Sciences Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ttuhsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.twu.edu/"],
    name: "Texas Woman's University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["twu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.citadel.edu/"],
    name: "The Citadel",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["citadel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jtsa.edu/"],
    name: "The Jewish Theological Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jtsa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.thomas.edu/"],
    name: "Thomas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["thomas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tesc.edu/", "http://www.tesu.edu/"],
    name: "Thomas Edison State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tesc.edu", "tesu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tju.edu/"],
    name: "Thomas Jefferson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tju.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.thomasmore.edu/"],
    name: "Thomas More College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["thomasmore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.thunderbird.edu/"],
    name: "Thunderbird School of Global Management",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["thunderbird.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.towson.edu/"],
    name: "Towson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["towson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.transy.edu/"],
    name: "Transylvania University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["transy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trenton.edu/"],
    name: "Trenton State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trenton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trine.edu/"],
    name: "Trine University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trincoll.edu/"],
    name: "Trinity College (CT)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trincoll.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trinitydc.edu"],
    name: "Trinity College (DC)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trinitydc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trinity.edu/"],
    name: "Trinity University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trinity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tsufl.edu/"],
    name: "Troy State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tsufl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.truman.edu/"],
    name: "Truman State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["truman.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tucsonu.edu/"],
    name: "Tucson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tucsonu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tufts.edu/"],
    name: "Tufts University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tufts.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tulane.edu/"],
    name: "Tulane University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tulane.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tuskegee.edu/"],
    name: "Tuskegee University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tuskegee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usuhs.mil/"],
    name: "Uniformed Services University of the Health Sciences",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usuhs.mil"],
    country: "United States",
  },
  {
    web_pages: ["http://www.union.edu/"],
    name: "Union College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["union.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tui.edu/"],
    name: "Union Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tui.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uu.edu/"],
    name: "Union University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usafa.af.mil/", "http://www.usafa.edu/"],
    name: "United States Air Force Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usafa.af.mil", "usafa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usiu.edu/"],
    name: "United States International University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usmma.edu/"],
    name: "United States Merchant Marine Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usmma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usma.edu/"],
    name: "United States Military Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usna.edu/"],
    name: "United States Naval Academy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usna.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uat.edu/"],
    name: "University of Advancing Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uat.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uakron.edu/"],
    name: "University of Akron",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uakron.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uab.edu/"],
    name: "University of Alabama at Birmingham",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uab.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uah.edu/"],
    name: "University of Alabama at Huntsville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uah.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ua.edu/"],
    name: "University of Alabama at Tuscaloosa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alaska.edu/"],
    name: "University of Alaska",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uaa.alaska.edu/"],
    name: "University of Alaska - Anchorage",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uaa.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uaf.edu"],
    name: "University of Alaska - Fairbanks",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uaf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uas.alaska.edu/"],
    name: "University of Alaska - Southeast",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uas.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.arizona.edu/"],
    name: "University of Arizona",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["arizona.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uark.edu/"],
    name: "University of Arkansas - Fayetteville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uafs.edu/"],
    name: "University of Arkansas - Fort Smith",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uafs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uams.edu/"],
    name: "University of Arkansas for Medical Sciences",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uams.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ualr.edu/"],
    name: "University of Arkansas - Little Rock",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ualr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uamont.edu/"],
    name: "University of Arkansas - Monticello",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uamont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ubalt.edu/"],
    name: "University of Baltimore",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ubalt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bridgeport.edu/"],
    name: "University of Bridgeport",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bridgeport.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.berkeley.edu/"],
    name: "University of California, Berkeley",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["berkeley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucdavis.edu/"],
    name: "University of California, Davis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucdavis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uci.edu/"],
    name: "University of California, Irvine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uci.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucla.edu/"],
    name: "University of California, Los Angeles",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucmerced.edu/"],
    name: "University of California, Merced",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucmerced.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.ucop.edu/"],
    name: "University of California, Office of the President",
    alpha_two_code: "US",
    "state-province": "CA",
    domains: ["ucop.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucr.edu/"],
    name: "University of California, Riverside",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucsd.edu/"],
    name: "University of California, San Diego",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucsd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucsf.edu/"],
    name: "University of California, San Francisco",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucsf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucsb.edu/"],
    name: "University of California, Santa Barbara",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucsb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucsc.edu/"],
    name: "University of California, Santa Cruz",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uca.edu/"],
    name: "University of Central Arkansas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucf.edu/"],
    name: "University of Central Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucmo.edu/"],
    name: "University of Central Missouri",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucmo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uchastings.edu/"],
    name: "UC Hastings College of the Law",
    alpha_two_code: "US",
    "state-province": "CA",
    domains: ["uchastings.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uchaswv.edu/"],
    name: "University of Charleston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uchaswv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uchicago.edu/"],
    name: "University of Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uchicago.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uc.edu/"],
    name: "University of Cincinnati",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colorado.edu/"],
    name: "University of Colorado at Boulder",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colorado.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uccs.edu/"],
    name: "University of Colorado at Colorado Springs",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucdenver.edu/"],
    name: "University of Colorado at Denver",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucdenver.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hsc.colorado.edu/"],
    name: "University of Colorado Health Sciences Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hsc.colorado.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uconn.edu/"],
    name: "University of Connecticut",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uconn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.udallas.edu/"],
    name: "University of Dallas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["udallas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.udayton.edu/"],
    name: "University of Dayton",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["udayton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.udel.edu/"],
    name: "University of Delaware",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["udel.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.du.edu/"],
    name: "University of Denver",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["du.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.udmercy.edu/"],
    name: "University of Detroit Mercy",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["udmercy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dbq.edu/"],
    name: "University of Dubuque",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dbq.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.evansville.edu/"],
    name: "University of Evansville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["evansville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ufl.edu/"],
    name: "University of Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ufl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uga.edu/"],
    name: "University of Georgia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uga.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ugf.edu/"],
    name: "University of Great Falls",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ugf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uog.edu/"],
    name: "University of Guam",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uog.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hartford.edu/"],
    name: "University of Hartford",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hartford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://hilo.hawaii.edu/"],
    name: "University of Hawaii at Hilo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hilo.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://manoa.hawaii.edu/"],
    name: "University of Hawaii at Manoa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["manoa.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hawaii.edu/"],
    name: "University of Hawaii System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uh.edu/"],
    name: "University of Houston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uidaho.edu/"],
    name: "University of Idaho",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uidaho.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uic.edu/"],
    name: "University of Illinois at Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uis.edu/"],
    name: "University of Illinois at Springfield",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.illinois.edu/"],
    name: "University of Illinois at Urbana-Champaign",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uiuc.edu", "illinois.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uindy.edu/"],
    name: "University of Indianapolis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uindy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uiowa.edu/"],
    name: "University of Iowa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uiowa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uj.edu/"],
    name: "University of Jamestown",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ku.edu"],
    name: "University of Kansas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kumc.edu/"],
    name: "University of Kansas School of Medicine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kumc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uky.edu/"],
    name: "University of Kentucky",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uky.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.louisiana.edu/"],
    name: "University of Louisiana at Lafeyette",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["louisiana.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ulm.edu/"],
    name: "University of Louisiana at Monroe",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ulm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.louisville.edu/"],
    name: "University of Louisville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["louisville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umaine.edu/"],
    name: "University of Maine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umaine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umf.maine.edu/"],
    name: "University of Maine at Farmington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umf.maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umfk.maine.edu/"],
    name: "University of Maine at Fort Kent",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umfk.maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umm.maine.edu/"],
    name: "University of Maine at Machias",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umm.maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umpi.maine.edu/"],
    name: "University of Maine at Presque Island",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umpi.maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.maine.edu/"],
    name: "University of Maine System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umaryland.edu/"],
    name: "University of Maryland, Baltimore",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umaryland.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.mayo.edu/"],
    name: "Mayo Clinic",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mayo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umbc.edu/"],
    name: "University of Maryland, Baltimore County",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umd.edu/"],
    name: "University of Maryland, College Park",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umes.edu/"],
    name: "University of Maryland Eastern Shore",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umes.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umuc.edu/"],
    name: "University of Maryland - University College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umuc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umass.edu/"],
    name: "University of Massachusetts at Amherst",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umassd.edu/"],
    name: "University of Massachusetts at Dartmouth",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umassd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uml.edu/"],
    name: "University of Massachusetts at Lowell",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uml.edu", "student.uml.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.memphis.edu/"],
    name: "University of Memphis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["memphis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://welcome.miami.edu/"],
    name: "University of Miami",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["miami.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umich.edu/"],
    name: "University of Michigan - Ann Arbor",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umdearborn.edu/"],
    name: "University of Michigan - Dearborn",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umdearborn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umn.edu/"],
    name: "University of Minnesota",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.crk.umn.edu/"],
    name: "University of Minnesota - Crookston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["crk.umn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.d.umn.edu/"],
    name: "University of Minnesota - Duluth",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["d.umn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mrs.umn.edu/"],
    name: "University of Minnesota - Morris",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mrs.umn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://twin-cities.umn.edu/"],
    name: "University of Minnesota - Twin Cities",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.olemiss.edu/"],
    name: "University of Mississippi",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["olemiss.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.missouri.edu/"],
    name: "University of Missouri - Columbia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["missouri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umkc.edu/"],
    name: "University of Missouri - Kansas City",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umkc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umr.edu/"],
    name: "University of Missouri - Rolla",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umsl.edu/"],
    name: "University of Missouri - Saint Louis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umsl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umt.edu/"],
    name: "University of Montana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unk.edu/"],
    name: "University of Nebraska, Kearney",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unl.edu/"],
    name: "University of Nebraska, Lincoln",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unomaha.edu/"],
    name: "University of Nebraska, Omaha",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unomaha.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unlv.edu/"],
    name: "University of Nevada, Las Vegas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unlv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unr.edu/"],
    name: "University of Nevada, Reno",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.une.edu/"],
    name: "University of New England",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["une.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unh.edu/"],
    name: "University of New Hampshire, Durham",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newhaven.edu/"],
    name: "University of New Haven",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["newhaven.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unm.edu/"],
    name: "University of New Mexico",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uno.edu/"],
    name: "University of New Orleans",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uno.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unca.edu/"],
    name: "University of North Carolina at Asheville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unc.edu/"],
    name: "University of North Carolina at Chapel Hill",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unc.edu", "ad.unc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uncc.edu/"],
    name: "University of North Carolina at Charlotte",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uncg.edu/"],
    name: "University of North Carolina at Greensboro",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uncg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://uncw.edu/"],
    name: "University of North Carolina at Wilmington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uncw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://und.edu/"],
    name: "University of North Dakota",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["und.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unco.edu/"],
    name: "University of Northern Colorado",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uni.edu/"],
    name: "University of Northern Iowa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uni.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unf.edu/"],
    name: "University of North Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.unt.edu/"],
    name: "University of North Texas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["unt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hsc.unt.edu/"],
    name: "University of North Texas Health Science Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hsc.unt.edu", "unthsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nd.edu/"],
    name: "University of Notre Dame",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ou.edu/"],
    name: "University of Oklahoma",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ou.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uoregon.edu/"],
    name: "University of Oregon",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uoregon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.upenn.edu/"],
    name: "University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["upenn.edu", "seas.upenn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.phoenix.edu/"],
    name: "University of Phoenix",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["phoenix.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pitt.edu/"],
    name: "University of Pittsburgh",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pitt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.upj.pitt.edu/"],
    name: "University of Pittsburgh at Johnstown",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["upj.pitt.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.upb.pitt.edu/"],
    name: "University of Pittsburgh at Bradford",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["upb.pitt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.up.edu/"],
    name: "University of Portland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["up.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.upr.edu/"],
    name: "University of Puerto Rico",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["upr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ups.edu/"],
    name: "University of Puget Sound",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ups.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uor.edu/"],
    name: "University of Redlands",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uor.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uri.edu/"],
    name: "University of Rhode Island",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.urich.edu/"],
    name: "University of Richmond",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["urich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rochester.edu/"],
    name: "University of Rochester",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rochester.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stthomas.edu/"],
    name: "University of Saint Thomas (MN)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stthomas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stthom.edu/"],
    name: "University of Saint Thomas (TX)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stthom.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sandiego.edu/"],
    name: "University of San Diego",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sandiego.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usfca.edu/"],
    name: "University of San Francisco",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usfca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://usao.edu/"],
    name: "University of Science & Arts of Oklahoma",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usao.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scranton.edu/"],
    name: "University of Scranton",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scranton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usouixfalls.edu/"],
    name: "University of Sioux Falls",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usouixfalls.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southalabama.edu/"],
    name: "University of South Alabama",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southalabama.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sc.edu/"],
    name: "University of South Carolina",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usca.edu/"],
    name: "University of South Carolina - Aiken",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usd.edu/"],
    name: "University of South Dakota",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usc.edu/"],
    name: "University of Southern California",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usi.edu/"],
    name: "University of Southern Indiana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usm.maine.edu/"],
    name: "University of Southern Maine",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usm.maine.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usm.edu/"],
    name: "University of Southern Mississippi",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usf.edu/"],
    name: "University of South Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usl.edu/"],
    name: "University of Southwestern Louisiana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ut.edu/"],
    name: "University of Tampa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ut.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utc.edu/"],
    name: "University of Tennessee at Chattanooga",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utk.edu/"],
    name: "University of Tennessee, Knoxville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utm.edu/"],
    name: "University of Tennessee, Martin",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uta.edu/"],
    name: "University of Texas at Arlington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utexas.edu/"],
    name: "University of Texas at Austin",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utexas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utb.edu/"],
    name: "University of Texas at Brownsville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utdallas.edu/"],
    name: "University of Texas at Dallas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utd.edu", "utdallas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utep.edu/"],
    name: "University of Texas at El Paso",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utep.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utsa.edu/"],
    name: "University of Texas at San Antonio",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utsa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uttyler.edu/"],
    name: "University of Texas at Tyler",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uttyler.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utmb.edu/"],
    name: "University of Texas Medical Branch",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utmb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.panam.edu/"],
    name: "University of Texas - Pan American",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["panam.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swmed.edu/", "http://www.utsouthwestern.edu/"],
    name: "University of Texas Southwestern Medical Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swmed.edu", "utsouthwestern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utpb.edu/"],
    name: "University of Texas Permian Basin",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utpb.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.arts.ac.uk"],
    name: "University of the Arts London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["arts.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.udc.edu/"],
    name: "University of the District of Columbia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["udc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uiw.edu/", "http://www.uiwtx.edu/"],
    name: "University of the Incarnate Word",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uiw.edu", "uiwtx.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ozarks.edu/"],
    name: "University of the Ozarks",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ozarks.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uop.edu/", "http://www.pacific.edu/"],
    name: "University of the Pacific",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uop.edu", "pacific.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uvi.edu/"],
    name: "University of the Virgin Islands",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uvi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utoledo.edu/"],
    name: "University of Toledo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utoledo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://utulsa.edu/"],
    name: "University of Tulsa",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utulsa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.utah.edu/"],
    name: "University of Utah",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["utah.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uvm.edu/"],
    name: "University of Vermont",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uvm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.virginia.edu/"],
    name: "University of Virginia, Charlottesville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["virginia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.washington.edu/"],
    name: "University of Washington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uw.edu", "washington.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westal.edu/"],
    name: "University of West Alabama",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westal.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwf.edu/"],
    name: "University of West Florida",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwec.edu/"],
    name: "University of Wisconsin - Eau Claire",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwec.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwgb.edu/"],
    name: "University of Wisconsin - Green Bay",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwgb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwlax.edu/"],
    name: "University of Wisconsin - LaCrosse",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwlax.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wisc.edu/"],
    name: "University of Wisconsin - Madison",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wisc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwm.edu/"],
    name: "University of Wisconsin - Milwaukee",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwosh.edu/"],
    name: "University of Wisconsin - Oshkosh",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwosh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwp.edu/"],
    name: "University of Wisconsin - Parkside",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwplatt.edu/"],
    name: "University of Wisconsin - Platteville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwplatt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwrf.edu/"],
    name: "University of Wisconsin - River Falls",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwrf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwsp.edu/"],
    name: "University of Wisconsin - Stevens Point",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwsp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwstout.edu/"],
    name: "University of Wisconsin - Stout",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwstout.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwsuper.edu/"],
    name: "University of Wisconsin - Superior",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwsuper.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwsa.edu/"],
    name: "University of Wisconsin System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwsa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uww.edu/"],
    name: "University of Wisconsin - Whitewater",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uww.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwyo.edu/"],
    name: "University of Wyoming",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwyo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uiu.edu/"],
    name: "Upper Iowa University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ursinus.edu/"],
    name: "Ursinus College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ursinus.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.usu.edu/"],
    name: "Utah State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["usu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uvsc.edu/"],
    name: "Utah Valley State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uvsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.valdosta.edu/"],
    name: "Valdosta State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["valdosta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vcsu.nodak.edu/home.html"],
    name: "Valley City State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vcsu.nodak.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.valpo.edu/"],
    name: "Valparaiso University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["valpo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vgcc.edu/"],
    name: "Vance-Granville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vgcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vanderbilt.edu/"],
    name: "Vanderbilt University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vanderbilt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vassar.edu/"],
    name: "Vassar College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vassar.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vtc.edu/"],
    name: "Vermont Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vjc.edu/"],
    name: "Villa Julie College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.villanova.edu/"],
    name: "Villanova University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["villanova.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://vcu.vcu.edu/"],
    name: "Virginia Commonwealth University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vccs.edu/"],
    name: "Virginia Community College System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vic.edu/"],
    name: "Virginia Intermont College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vmi.edu/"],
    name: "Virginia Military Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vmi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vt.edu/"],
    name: "Virginia Polytechnic Institute and State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vsu.edu/"],
    name: "Virginia State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vwc.edu/"],
    name: "Virginia Wesleyan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wabash.edu/"],
    name: "Wabash College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wabash.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wfu.edu/"],
    name: "Wake Forest University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wfu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.waldenu.edu/"],
    name: "Walden University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waldenu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wallawalla.edu/"],
    name: "Walla Walla University",
    alpha_two_code: "US",
    "state-province": "Washington",
    domains: ["wallawalla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.walshcollege.edu/"],
    name: "Walsh College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["walshcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.warren-wilson.edu/"],
    name: "Warren Wilson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["warren-wilson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wartburg.edu/"],
    name: "Wartburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wartburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wuacc.edu/"],
    name: "Washburn University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wuacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wlu.edu/"],
    name: "Washington & Lee University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wlu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bible.edu/"],
    name: "Washington Bible College/Capital Bible Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bible.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.washcoll.edu/"],
    name: "Washington College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["washcoll.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wsu.edu/"],
    name: "Washington State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tricity.wsu.edu/"],
    name: "Washington State University at Tri-Cities",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vancouver.wsu.edu/"],
    name: "Washington State University at Vancouver",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vancouver.wsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wustl.edu/"],
    name: "Washington University, Saint Louis",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wustl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.waubonsee.edu/"],
    name: "Waubonsee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waubonsee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://waynesburg.edu/"],
    name: "Waynesburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waynesburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wayne.edu/"],
    name: "Wayne State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wayne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.weber.edu/"],
    name: "Weber State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["weber.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.webster.edu/"],
    name: "Webster University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["webster.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wellesley.edu/"],
    name: "Wellesley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wellesley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wells.edu/"],
    name: "Wells College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wells.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wit.edu/"],
    name: "Wentworth Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wesleyan.edu/"],
    name: "Wesleyan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wesleyan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wesley.edu/"],
    name: "Wesley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wesley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcupa.edu/"],
    name: "West Chester University of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["wcupa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://westcoastuniversity.edu/"],
    name: "West Coast University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westcoastuniversity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcu.edu/"],
    name: "Western Carolina University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcsu.edu/"],
    name: "Western Connecticut State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wgu.edu/"],
    name: "Western Governors University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wgu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wiu.edu/"],
    name: "Western Illinois University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wiu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wku.edu/"],
    name: "Western Kentucky University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wku.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmich.edu/"],
    name: "Western Michigan University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmc.edu/"],
    name: "Western Montana College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wnec.edu/"],
    name: "Western New England College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wnec.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wnmu.edu/"],
    name: "Western New Mexico University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wnmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.western.edu/"],
    name: "Western State Colorado University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["western.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wwu.edu/"],
    name: "Western Washington University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wwu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westfield.mass.edu/"],
    name: "Westfield State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westfield.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westga.edu/"],
    name: "West Georgia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westga.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wlsc.wvnet.edu/"],
    name: "West Liberty State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wlsc.wvnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westminster.edu/"],
    name: "Westminster College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westminster.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westminster-mo.edu/"],
    name: "Westminster College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westminster-mo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcslc.edu/"],
    name: "Westminster College of Salt Lake City",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcslc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wts.edu/"],
    name: "Westminster Theological Seminary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wts.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westmont.edu/"],
    name: "Westmont College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westmont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wtamu.edu/"],
    name: "West Texas A&M University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wtamu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wvu.edu/"],
    name: "West Virginia University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wvu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westliberty.edu/"],
    name: "West Virginia University at Parkersburg",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westliberty.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wheaton.edu/"],
    name: "Wheaton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wheaton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wheatonma.edu/"],
    name: "Wheaton College, Norton MA",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wheatonma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wjc.edu/"],
    name: "Wheeling Jesuit College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.whitman.edu/"],
    name: "Whitman College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["whitman.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.whittier.edu/"],
    name: "Whittier College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["whittier.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.whitworth.edu/"],
    name: "Whitworth College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["whitworth.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wichita.edu/"],
    name: "Wichita State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wichita.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.widener.edu/"],
    name: "Widener University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["widener.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wilberforce.edu/"],
    name: "Wilberforce University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilberforce.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wilkes.edu/"],
    name: "Wilkes University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilkes.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.willamette.edu/"],
    name: "Willamette University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["willamette.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.taftu.edu/"],
    name: "William Howard Taft University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["taftu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jewell.edu/"],
    name: "William Jewell College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jewell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmitchell.edu/"],
    name: "William Mitchell College of Law",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmitchell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wpunj.edu/"],
    name: "William Paterson University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wpunj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmpenn.edu/"],
    name: "William Penn College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmpenn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.williams.edu/"],
    name: "Williams College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["williams.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmwoods.edu/"],
    name: "William Woods University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmwoods.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wilmington.edu/"],
    name: "Wilmington College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilmington.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.winona.edu/"],
    name: "Winona State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["winona.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.winthrop.edu/"],
    name: "Winthrop University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["winthrop.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wittenberg.edu/"],
    name: "Wittenberg University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wittenberg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wofford.edu/"],
    name: "Wofford College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wofford.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.woodbury.edu/"],
    name: "Woodbury University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["woodbury.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wpi.edu/"],
    name: "Worcester Polytechnic Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wpi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wright.edu/"],
    name: "Wright State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wright.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.xula.edu/"],
    name: "Xavier University of Louisiana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["xula.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yale.edu/"],
    name: "Yale University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yale.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yu.edu/"],
    name: "Yeshiva University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ycp.edu/"],
    name: "York College of Pennsylvania",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["ycp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ysu.edu/"],
    name: "Youngstown State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ysu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.afghanuniversity.edu.af/"],
    name: "Afghan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["afghanuniversity.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.aria.edu.af/"],
    name: "Aria Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["aria.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.auaf.edu.af/"],
    name: "American University of Afghanistan",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["auaf.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.au.edu.af/"],
    name: "Al-Birony University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["au.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.badakhshan.edu.af/"],
    name: "Badakhshan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["badakhshan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.ba.edu.af/"],
    name: "Balkh University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["ba.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.baghlan.edu.af/"],
    name: "Baghlan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["baghlan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.bakhtar.edu.af/"],
    name: "Bakhtar University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["bakhtar.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.bost.edu.af/"],
    name: "Bost University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["bost.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.bu.edu.af/"],
    name: "Bamiyan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["bu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.dawat.edu.af/"],
    name: "Dawat University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["dawat.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.dunya.edu.af/"],
    name: "Dunya Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["dunya.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.faryab.edu.af/"],
    name: "Faryab Higher Education Institute",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["faryab.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.gu.edu.af/"],
    name: "Ghazni University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["gu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.hu.edu.af/"],
    name: "Herat University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["hu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.ibnesina.edu.af/"],
    name: "Ibn Sina University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["ibnesina.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.ju.edu.af/"],
    name: "Jawzjan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["ju.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kaboora.edu.af/"],
    name: "Kaboora Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kaboora.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kabuli.edu.af/"],
    name: "Kabul Health Sciences Institute",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kabuli.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kan.edu.af/"],
    name: "Kandahar University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kardan.edu.af/"],
    name: "Kardan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kardan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.karwan.edu.af/"],
    name: "Karwan Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["karwan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kateb.edu.af/"],
    name: "Kateb Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kateb.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.ken.edu.af/"],
    name: "Khana-e-Noor Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["ken.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.keu.edu.af/"],
    name: "Kabul Education University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["keu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kmu.edu.af/"],
    name: "Kabul Medical University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kmu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.ku.edu.af/"],
    name: "Kabul University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["ku.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.kumsa.net/"],
    name: "Khurasan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["kumsa.net"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.maryam.edu.af/"],
    name: "Maryam Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["maryam.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.nmaa.edu.af/"],
    name: "National Military Academy of Afghanistan",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["nmaa.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.nu.edu.af/"],
    name: "Nangarhar University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["nu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.pamir.edu.af/"],
    name: "Pamir University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["pamir.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.parwan.edu.af/"],
    name: "Parwan University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["parwan.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.polytechnic-kabul.org/"],
    name: "Polytechnical University of Kabul",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["polytechnic-kabul.org"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.pu.edu.af/"],
    name: "Paktia University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["pu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.rihs.edu.af/"],
    name: "Rana Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["rihs.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.sadat.edu.af/"],
    name: "Sadat Institute of Higher Education",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["sadat.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.salam.edu.af/"],
    name: "Salam University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["salam.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.szu.edu.af/"],
    name: "Shaikh Zayed University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["szu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.tu.edu.af/"],
    name: "Takhar University",
    alpha_two_code: "AF",
    "state-province": null,
    domains: ["tu.edu.af"],
    country: "Afghanistan",
  },
  {
    web_pages: ["http://www.aefs.edu.al/"],
    name: "Academy of Sports and Physical Training",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["aefs.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.akademiaearteve.edu.al/"],
    name: "Academy of Arts",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["akademiaearteve.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.beder.edu.al/"],
    name: "Beder University",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["beder.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.epoka.edu.al/"],
    name: "Epoka University",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["epoka.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.uat.edu.al/"],
    name: "American University of Tirana",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["uat.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.ubt.edu.al/"],
    name: "Agricultural University of Tirana",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["ubt.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.uniel.edu.al/"],
    name: 'University of Elbasan "Aleksander Xhuvani"',
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["uniel.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.unipavaresia.edu.al/"],
    name: "University “Pavaresia” Vlore",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["unipavaresia.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.unishk.edu.al/"],
    name: 'University of Shkodra "Luigj Gurakuqi"',
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["unishk.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.unitir.edu.al/"],
    name: "University of Tirana",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["unitir.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.univlora.edu.al/"],
    name: 'University of Vlora "Ismail Qemali"',
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["univlora.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.unkorce.edu.al/"],
    name: 'University of Korca "Fan Noli"',
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["unkorce.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.unyt.edu.al/"],
    name: "University of New York Tirana",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["unyt.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.uogj.edu.al/"],
    name: 'University of Gjirokstra "Eqerem Cabej"',
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["uogj.edu.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.upt.al/"],
    name: "Polytechnic University of Tirana",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["upt.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.epitech.al/"],
    name: "Ecole pour l'Informatique et les nouvelles Technologies - Albania",
    alpha_two_code: "AL",
    "state-province": null,
    domains: ["epitech.al"],
    country: "Albania",
  },
  {
    web_pages: ["http://www.lagh-univ.dz/"],
    name: "Université Amar Telidji",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["lagh-univ.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.umbb.dz/"],
    name: "Université M'hamed Bouguerra de Boumerdes",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["umbb.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.umc.edu.dz/"],
    name: "Université Mentouri Constantine",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["umc.edu.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.ummto.dz/"],
    name: "Université Mouloud Mammeri de Tizi Ouzou",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["ummto.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-alger3.dz/"],
    name: "Université d'Alger 3",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-alger3.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-alger.dz/"],
    name: "Université d'Alger",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-alger.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-annaba.dz/"],
    name: "Université Badji Mokhtar",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-annaba.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-batna.dz/"],
    name: "Université de Batna",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-batna.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-bejaia.dz/"],
    name: "Université de Béjaia",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-bejaia.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-biskra.dz/"],
    name: "Université de Biskra",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-biskra.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-blida.dz/"],
    name: "Université de Blida",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-blida.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-chlef.dz/"],
    name: "Université de Chlef",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-chlef.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-emir.dz/"],
    name: "Universite des Sciences Islamiques de Constantine",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-emir.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-guelma.dz/"],
    name: "Université de Guelma",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-guelma.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-jijel.dz/"],
    name: "Centre Universitaire de Jijel",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-jijel.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-mosta.dz/"],
    name: "Université de Mostaganem",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-mosta.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-msila.dz/"],
    name: "Université de M'sila",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-msila.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-oeb.dz/"],
    name: "Centre Universitaire d'Oum El Bouaghi",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-oeb.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-oran.dz/"],
    name: "Université d'Oran Es-Senia",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-oran.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-ouargla.dz/"],
    name: "Université Kasdi Merbah Ouargla",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-ouargla.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-saida.dz/"],
    name: "Université de Saida",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-saida.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-sba.dz/"],
    name: "Université de Sidi-Bel-Abbès (Djillali Liabès)",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-sba.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-setif.dz/"],
    name: "Université de Sétif",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-setif.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-skikda.dz/"],
    name: "Université de Skikda",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-skikda.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-tebessa.dz/"],
    name: "Centre Universitaire de Tebessa",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-tebessa.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-tiaret.dz/"],
    name: "Centre Universitaire de Tiaret",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-tiaret.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-tlemcen.dz/"],
    name: "Université Abou Bekr Belkaid, Tlemcen",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-tlemcen.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.univ-usto.dz/"],
    name: "Université des Sciences et de la Technologie d'Oran",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["univ-usto.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.usthb.dz/"],
    name: "Université des Sciences et de la Technologie Houari Boumediène",
    alpha_two_code: "DZ",
    "state-province": null,
    domains: ["usthb.dz"],
    country: "Algeria",
  },
  {
    web_pages: ["http://www.uda.ad/"],
    name: "University of Andorra",
    alpha_two_code: "AD",
    "state-province": null,
    domains: ["uda.ad"],
    country: "Andorra",
  },
  {
    web_pages: ["http://www.uan.ao/"],
    name: "Univesidade Agostinho Neto",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["uan.ao"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.ucan.edu/"],
    name: "Universidade Católica de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["ucan.edu"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.ugs.ed.ao/"],
    name: "Universidade Gregorio Semedo",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["ugs.ed.ao"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.ulangola.net/"],
    name: "Universidade Lusíada de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["ulangola.net"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.uma.co.ao/"],
    name: "Universidade Metodista de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["uma.co.ao"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.unia.ao/"],
    name: "Universidade Independente de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["unia.ao"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.unimetroangola.com/"],
    name: "Universidade Metropolitana de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["unimetroangola.com"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.utanga.co.ao/"],
    name: "Universidade Tecnica de Angola",
    alpha_two_code: "AO",
    "state-province": null,
    domains: ["utanga.co.ao"],
    country: "Angola",
  },
  {
    web_pages: ["http://www.auamed.org/"],
    name: "American University of Antigua",
    alpha_two_code: "AG",
    "state-province": null,
    domains: ["auamed.org"],
    country: "Antigua and Barbuda",
  },
  {
    web_pages: ["http://www.uhsa.ag/"],
    name: "University of Health Sciences Antigua",
    alpha_two_code: "AG",
    "state-province": null,
    domains: ["uhsa.ag"],
    country: "Antigua and Barbuda",
  },
  {
    web_pages: ["http://www.atlantida.edu.ar/"],
    name: "Universidad Atlantida Argentina",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["atlantida.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.austral.edu.ar/"],
    name: "Universidad Austral Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["austral.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.caece.edu.ar/"],
    name: "Universidad CAECE, Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["caece.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.cema.edu.ar/"],
    name: "Instituto Universitario CEMA",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["cema.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.iese.edu.ar/"],
    name: "Instituto de Enseñanza Superior del Ejército",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["iese.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.inun.edu.ar/"],
    name: "Instituto Universitario de Estudios Navales y Marítimos",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["inun.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.itba.edu.ar/"],
    name: "Instituto Tecnológico de Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["itba.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.iua.edu.ar/"],
    name: "Instituto Universitario Aeronáutico",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["iua.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://iucs.uncoma.edu.ar/"],
    name: "Instituto Universitario de Ciencias de la Salud - Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["iucs.uncoma.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.iuna.edu.ar/"],
    name: "Instituto Universitario Nacional del Arte",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["iuna.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.kennedy.edu.ar/"],
    name: 'Universidad Argentina "John F. Kennedy"',
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["kennedy.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.maimonides.edu.ar/"],
    name: "Universidad Maimónides",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["maimonides.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.mdp.edu.ar/"],
    name: "Universidad Nacional de Mar del Plata",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["mdp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.palermo.edu.ar/"],
    name: "Universidad de Palermo",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["palermo.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.salvador.edu.ar/"],
    name: "Universidad del Salvador",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["salvador.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uade.edu.ar/"],
    name: "Universidad Argentina de la Empresa",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uade.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uader.edu.ar/"],
    name: "Universidad Autónoma de Entre Ríos",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uader.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uapar.edu/"],
    name: "Universidad Adventista del Plata",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uapar.edu"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uba.ar/"],
    name: "Universidad de Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uba.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ub.edu.ar/"],
    name: "Universidad de Belgrano",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ub.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ubp.edu.ar/"],
    name: "Universidad Blas Pascal",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ubp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uca.edu.ar/"],
    name: "Universidad Católica Argentina Santa Maria de los Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uca.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucalp.edu.ar/"],
    name: "Universidad Católica de La Plata",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucalp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucasal.net/"],
    name: "Universidad Católica de Salta",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucasal.net"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uccor.edu.ar/"],
    name: "Universidad Católica de Córdoba",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uccor.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uccuyo.edu.ar/"],
    name: "Universidad Católica de Cuyo",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uccuyo.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucel.edu.ar/"],
    name: "Universidad del Centro Educativo Latinoamericano Rosario",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucel.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uces.edu.ar/"],
    name: "Universidad de Ciencias Empresariales y Sociales",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uces.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uch.edu.ar/"],
    name: "Universidad Champagnat",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uch.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucine.edu.ar/"],
    name: "Universidad del Cine - Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucine.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucongres.edu.ar/"],
    name: "Universidad de Congreso",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucongres.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucp.edu.ar/"],
    name: "Universidad de la Cuenca del Plata",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucse.edu.ar/"],
    name: "Universidad Católica de Santiago del Estero",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucse.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucsf.edu.ar/"],
    name: "Universidad Católica de Santa Fé",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucsf.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ucu.edu.ar/"],
    name: "Universidad de Concepción del Uruguay",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ucu.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uda.edu.ar/"],
    name: "Universidad del Aconcagua",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uda.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.udemm.edu.ar/"],
    name: "Universidad de la Marina Mercante",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["udemm.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.udesa.edu.ar/"],
    name: "Universidad de San Andres",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["udesa.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uesiglo21.edu.ar/"],
    name: "Universidad Empresarial Siglio 21",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uesiglo21.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ufasta.edu.ar/"],
    name: "Universidad de la Fraternidad de Agrupaciones Santo Tomas de Aquino (FASTA)",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ufasta.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uflo.edu.ar/"],
    name: "Universidad de Flores - Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uflo.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.umaza.edu.ar/"],
    name: 'Universidad "Juan Agustín Maza"',
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["umaza.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.um.edu.ar/"],
    name: "Universidad de Mendoza",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["um.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.umsa.edu.ar/"],
    name: "Universidad del Museo Social Argentino",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["umsa.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unam.edu.ar/"],
    name: "Universidad Nacional de Misiones",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unam.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unca.edu.ar/"],
    name: "Universidad Nacional de Catamarca",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unca.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unc.edu.ar/"],
    name: "Universidad Nacional de Córdoba",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unc.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uncoma.edu.ar/"],
    name: "Universidad Nacional del Comahue",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uncoma.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uncu.edu.ar/"],
    name: "Universidad Nacional de Cuyo",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uncu.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uner.edu.ar/"],
    name: "Universidad Nacional de Entre Ríos",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uner.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unf.edu.ar/"],
    name: "Universidad Nacional de Formosa",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unf.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.ungs.edu.ar/"],
    name: "Universidad Nacional de General Sarmiento",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["ungs.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unibo.edu.ar/"],
    name: "Universidad de Bologna - Representación en Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unibo.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unicen.edu.ar/"],
    name: "Universidad Nacional del Centro de la Provincia de Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unicen.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unimoron.edu.ar/"],
    name: "Universidad de Morón",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unimoron.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.universidadnotarial.edu.ar/"],
    name: "Universidad Notarial Argentina",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["universidadnotarial.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.universidad-policial.edu.ar/"],
    name: "Instituto Universitario de la Policia Federal",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["universidad-policial.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unju.edu.ar/"],
    name: "Universidad Nacional de Jujuy",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unju.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unla.edu.ar/"],
    name: "Universidad Nacional de Lanus",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unla.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlam.edu.ar/"],
    name: "Universidad Nacional de La Matanza",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlam.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlar.edu.ar/"],
    name: "Universidad Nacional de La Rioja",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlar.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unl.edu.ar/"],
    name: "Universidad Nacional del Littoral",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unl.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlpam.edu.ar/"],
    name: "Universidad Nacional de La Pampa",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlpam.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlp.edu.ar/"],
    name: "Universidad Nacional de La Plata",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlu.edu.ar/Belgrano.htm"],
    name: 'Instituto Nacional de Educación Física "General Manuel Belgrano"',
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlu.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlu.edu.ar/"],
    name: "Universidad Nacional de Luján",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlu.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unlz.edu.ar/"],
    name: "Universidad Nacional de Lomas de Zamora",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unlz.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unne.edu.ar/"],
    name: "Universidad Nacional del Nordeste",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unne.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unnoba.edu.ar/"],
    name: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unnoba.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unpa.edu.ar/"],
    name: "Universidad Nacional de la Patagonia Austral",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unpa.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unp.edu.ar/"],
    name: 'Universidad Nacional de la Patagonia "San Juan Bosco"',
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unp.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unq.edu.ar/"],
    name: "Universidad Nacional de Quilmes",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unq.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unrc.edu.ar/"],
    name: "Universidad Nacional de Río Cuarto",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unrc.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unr.edu.ar/"],
    name: "Universidad Nacional de Rosario",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unr.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unsa.edu.ar/"],
    name: "Universidad Nacional de Salta",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unsa.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unsam.edu.ar/"],
    name: "Universidad Nacional de General San Martín",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unsam.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.uns.edu.ar/"],
    name: "Universidad Nacional del Sur",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["uns.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unse.edu.ar/"],
    name: "Universidad Nacional de Santiago del Estero",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unse.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unsj.edu.ar/"],
    name: "Universidad Nacional de San Juan",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unsj.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unsl.edu.ar/"],
    name: "Universidad Nacional de San Luis",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unsl.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unsta.edu.ar/"],
    name: 'Universidad del Norte "Santo Tomás de Aquino"',
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unsta.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.unt.edu.ar/"],
    name: "Universidad Nacional de Tucumán",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["unt.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.untref.edu.ar/"],
    name: "Universidad Nacional de Tres de Febrero",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["untref.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.utdt.edu/"],
    name: "Universidad Torcuato di Tella",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["utdt.edu"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.utn.edu.ar/"],
    name: "Universidad Tecnológica Nacional",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["utn.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.vaneduc.edu.ar/uai/"],
    name: "Universidad Abierta Interamericana",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["vaneduc.edu.ar"],
    country: "Argentina",
  },
  {
    web_pages: ["http://webs.satlink.com/usuarios/i/iiunvm/"],
    name: "Universidad Nacional de Villa María",
    alpha_two_code: "AR",
    "state-province": null,
    domains: ["webs.satlink.com"],
    country: "Argentina",
  },
  {
    web_pages: ["http://www.armmed.am/"],
    name: "Mehrabyan Medical Institute and Medical College",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["armmed.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.asau.am/"],
    name: "Armenian State Agrarian University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["asau.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.asue.am/"],
    name: "Armenian State University of Economics",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["asue.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.aua.am/"],
    name: "American University of Armenia",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["aua.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.eiu.am/"],
    name: "Eurasia International University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["eiu.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.eriicta.am/"],
    name: "European Regional Educational Academy of Armenia",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["eriicta.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.haybusak.org/"],
    name: "Yerevan Haibusak University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["haybusak.org"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.rau.am/"],
    name: "Russian-Armenian (Slavonic) State University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["rau.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.seua.am/"],
    name: "State Engineering University of Armenia",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["seua.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.ufar.am/"],
    name: "French University in Armenia (UFAR)",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["ufar.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.ysmu.am/"],
    name: "Yerevan State Medical University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["ysmu.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.ysu.am/"],
    name: "Yerevan State University",
    alpha_two_code: "AM",
    "state-province": null,
    domains: ["ysu.am"],
    country: "Armenia",
  },
  {
    web_pages: ["http://www.acs.edu.au/"],
    name: "Australian Correspondence Schools",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["acs.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.acu.edu.au/"],
    name: "Australian Catholic University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["acu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.adelaide.edu.au/"],
    name: "University of Adelaide",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["adelaide.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.adfa.oz.au/"],
    name: "Australian Defence Force Academy",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["adfa.oz.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.alc.edu.au/"],
    name: "Australian Lutheran College",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["alc.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.amc.edu.au/"],
    name: "Australian Maritime College",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["amc.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.anu.edu.au/"],
    name: "Australian National University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["anu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.avondale.edu.au/"],
    name: "Avondale College",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["avondale.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://federation.edu.au/"],
    name: "Federation University Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["federation.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.bond.edu.au/"],
    name: "Bond University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["bond.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.canberra.edu.au/"],
    name: "University of Canberra",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["canberra.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.cdu.edu.au/"],
    name: "Charles Darwin University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["cdu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.cqu.edu.au/"],
    name: "Central Queensland University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["cqu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.csu.edu.au/"],
    name: "Charles Sturt University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["csu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.curtin.edu.au/"],
    name: "Curtin University of Technology",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["curtin.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.deakin.edu.au/"],
    name: "Deakin University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["deakin.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.ecu.edu.au/"],
    name: "Edith Cowan University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["ecu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.flinders.edu.au/"],
    name: "Flinders University of South Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["flinders.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["https://www.griffith.edu.au/"],
    name: "Griffith University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["griffith.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.holmes.edu.au/"],
    name: "Holmes Institute",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["holmes.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.hotelschool.com.au/"],
    name: "Blue Mountains Hotel School",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["hotelschool.com.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.icthm.edu.au/"],
    name: "International College of Tourism and Hotel Management",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["icthm.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.iota.edu.au/"],
    name: "Institute Of Technology, Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["iota.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.jcu.edu.au/"],
    name: "James Cook University of North Queensland",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["jcu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.latrobe.edu.au/"],
    name: "La Trobe University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["latrobe.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.marcusoldham.vic.edu.au/"],
    name: "Marcus Oldham College",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["marcusoldham.vic.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.monash.edu/"],
    name: "Monash University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["monash.edu", "monash.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.mq.edu.au/"],
    name: "Macquarie University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["mq.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.murdoch.edu.au/"],
    name: "Murdoch University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["murdoch.edu.au", "student.murdoch.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.nd.edu.au/"],
    name: "University of Notre Dame Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["nd.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.newcastle.edu.au/"],
    name: "University of Newcastle",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["newcastle.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.nt.gov.au/batc/"],
    name: "Batchelor Institute of Indigenous Tertiary Education",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["nt.gov.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.qut.edu.au/"],
    name: "Queensland University of Technology",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["qut.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.rmit.edu.au/"],
    name: "Royal Melbourne Institute of Technology",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["rmit.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.scu.edu.au/"],
    name: "Southern Cross University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["scu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.swin.edu.au/"],
    name: "Swinburne University of Technology",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["swin.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.une.edu.au/"],
    name: "University of New England",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["une.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.unimelb.edu.au/"],
    name: "University of Melbourne",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["unimelb.edu.au", "student.unimelb.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.unisa.edu.au/"],
    name: "University of South Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["unisa.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.unsw.edu.au/"],
    name: "University of New South Wales",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["unsw.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.uow.edu.au/"],
    name: "University of Wollongong",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["uow.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.uq.edu.au/"],
    name: "University of Queensland",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["uq.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.usc.edu.au/"],
    name: "University of the Sunshine Coast",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["usc.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.usq.edu.au/"],
    name: "University of Southern Queensland",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["usq.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://sydney.edu.au/"],
    name: "University of Sydney",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["sydney.edu.au", "usyd.edu.au", "uni.sydney.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.utas.edu.au/"],
    name: "University of Tasmania",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["utas.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.uts.edu.au/"],
    name: "University of Technology Sydney",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["uts.edu.au", "student.uts.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.uwa.edu.au/"],
    name: "University of Western Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["uwa.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.uws.edu.au/"],
    name: "University of Western Sydney",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["uws.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.vu.edu.au/"],
    name: "Victoria University",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["vu.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.akbild.ac.at/"],
    name: "Akademie der bildenden Künste Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["akbild.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.boku.ac.at/"],
    name: "Universität für Bodenkultur Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["boku.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.donau-uni.ac.at/"],
    name: "Donau-Universität Krems",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["donau-uni.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-burgenland.at/"],
    name: "Fachhochschule Burgenland",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-burgenland.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-hagenberg.at/"],
    name: "Fachhochschulstudiengänge Hagenberg",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-hagenberg.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-joanneum.at/"],
    name: "Fachhochschule JOANNEUM",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-joanneum.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-kaernten.ac.at/"],
    name: "Fachhochschule Kärnten",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-kaernten.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-krems.ac.at/"],
    name: "Fachhochschule Krems",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-krems.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-kufstein.ac.at/"],
    name: "Fachhochschule Kufstein (Tirol)",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-kufstein.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-sbg.ac.at/"],
    name: "Fachhochschule Salzburg",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-sbg.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-steyr.at/"],
    name: "Fachhochschulstudiengänge Steyr",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-steyr.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-stpoelten.ac.at/"],
    name: "Fachhochschule St. Pölten",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-stpoelten.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fhv.at/"],
    name: "Fachhochschule Vorarlberg",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fhv.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-vie.ac.at/"],
    name: "Fachhochschule für Bank- und Finanzwirtschaft",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-vie.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fhw.at/"],
    name: "Fachhochschulstudiengänge der Wiener Wirtschaft",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fhw.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fh-wels.at/"],
    name: "Fachhochschulstudiengänge Wels",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fh-wels.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.fhwn.ac.at/"],
    name: "Fachhochschule Wiener Neustadt",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["fhwn.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.imc-krems.ac.at/"],
    name: "Fachhochschulstudiengänge Krems IMC",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["imc-krems.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.i-med.ac.at/"],
    name: "Medizinische Universität Innsbruck",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["i-med.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.ist.ac.at/"],
    name: "Institute of Science and Technology",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["ist.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.kfunigraz.ac.at/"],
    name: "Universität Graz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["kfunigraz.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.khs-linz.ac.at/"],
    name: "Universität für künstlerische und industrielle Gestaltung Linz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["khs-linz.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.kth-linz.ac.at/"],
    name: "Katholisch-Theologische Privatuniversität Linz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["kth-linz.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.kug.ac.at/"],
    name: "Universität für Musik und darstellende Kunst Graz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["kug.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.mci.edu/"],
    name: "MCI-Management Center Innsbruck",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["mci.edu"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.mdw.ac.at/"],
    name: "Universität für Musik und darstellende Kunst  Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["mdw.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.meduni-graz.at/"],
    name: "Medizinische Universität Graz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["meduni-graz.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.meduniwien.at/"],
    name: "Medizinische Universität Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["meduniwien.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.moz.ac.at/"],
    name: "Universität Mozarteum Salzburg",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["moz.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://ns2.uni-ak.ac.at/"],
    name: "Universität für angewandte Kunst Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["ns2.uni-ak.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.sbg.ac.at/"],
    name: "Universität Salzburg",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["sbg.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.technikum-wien.at/"],
    name: "Technikum Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["technikum-wien.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.tugraz.at/"],
    name: "Technische Universität Graz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["tugraz.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.tuwien.ac.at/"],
    name: "Technische Universität Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["tuwien.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.uibk.ac.at/"],
    name: "Universität Innsbruck",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["uibk.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.umit.at/"],
    name: "Private Universität für Medizinische Informatik und Technik Tirol",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["umit.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.uni-klu.ac.at/"],
    name: "Universität Klagenfurt",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["uni-klu.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.unileoben.ac.at/"],
    name: "Montanuniversität Leoben",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["unileoben.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["https://www.jku.at/"],
    name: "Johannes Kepler Universität Linz",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["jku.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.univie.ac.at/"],
    name: "Universität Vienna",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["univie.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.vu-wien.ac.at/"],
    name: "Veterinärmedizinische Universität Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["vu-wien.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.webster.ac.at/"],
    name: "Webster University, Vienna",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["webster.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.wu-wien.ac.at/"],
    name: "Wirtschaftsuniversität Wien",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["wu-wien.ac.at", "wu.ac.at"],
    country: "Austria",
  },
  {
    web_pages: ["http://www.ada.edu.az/"],
    name: "Azerbaijan Diplomatic Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["ada.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.adau.edu.az/"],
    name: "Azerbaijan State Agricultural Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["adau.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.ascca.gov.az/"],
    name: "Azerbaijan State Customs Committee Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["ascca.gov.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.asoiu.edu.az/"],
    name: "Azerbaijan State University of Oil and Industry",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["asoiu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.adda.edu.az/"],
    name: "Azerbaijan State Marine Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["adda.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.adpu.edu.az/"],
    name: "Azerbaijan State Pedagogic University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["adpu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.azmiu.edu.az/"],
    name: "Azerbaijan University of Architecture and Construction",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["azmiu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.adu.edu.az/"],
    name: "Azerbaijan University of Languages",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["adu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://amu.edu.az/"],
    name: "Azerbaijan Medical University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["amu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://unec.edu.az/"],
    name: "Azerbaijan State University of Economics",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["unec.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.admiu.edu.az/"],
    name: "Azerbaijan State University of Culture and Arts",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["admiu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.au.edu.az/"],
    name: "Azerbaijan University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["au.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.az-npu.org/"],
    name: "Nakhchivan Private University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["az-npu.org"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.aztu.edu.az/"],
    name: "Azerbaijan Technical University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["aztu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.musicacademy.edu.az/"],
    name: "Baku Academy of Music",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["musicacademy.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.bbu.edu.az/"],
    name: "Baku Business University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["bbu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://bsu.edu.az/"],
    name: "Baku State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["bsu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.bsu-edu.org/"],
    name: "Baku Slavic University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["bsu-edu.org"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.conservatory.az/"],
    name: "Azerbaijan National Conservatorie",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["conservatory.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.dia.edu.az/"],
    name: "The Academy of Public Administration",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["dia.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://gdu.edu.az/"],
    name: "Ganja State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["gdu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.khazar.org/"],
    name: "Khazar University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["khazar.org"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.lsu.edu.az/"],
    name: "Lankaran State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["lsu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.mdu.edu.az/"],
    name: "Mingechevir State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["mdu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.naa.edu.az/"],
    name: "National Aviation Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["naa.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.ndu.edu.az/"],
    name: "Nakhchivan State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["ndu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.oyu.edu.az/"],
    name: "Odlar Yurdu University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["oyu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.pa.edu.az/"],
    name: "Police Academy",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["pa.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.qu.edu.az/"],
    name: "Qafqaz University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["qu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.sdu.edu.az/"],
    name: "Sumgait State University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["sdu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.tourism.edu.az/"],
    name: "Azerbaijan Toursim Institute",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["tourism.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.wu.edu.az/"],
    name: "Western University",
    alpha_two_code: "AZ",
    "state-province": null,
    domains: ["wu.edu.az"],
    country: "Azerbaijan",
  },
  {
    web_pages: ["http://www.cob.edu.bs/"],
    name: "The College of The Bahamas",
    alpha_two_code: "BS",
    "state-province": null,
    domains: ["cob.edu.bs"],
    country: "Bahamas",
  },
  {
    web_pages: ["http://www.agu.edu.bh/"],
    name: "Arabian Gulf University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["agu.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.ahliauniversity.org/"],
    name: "Al Ahlia University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["ahliauniversity.org"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.amaiu.edu.bh/"],
    name: "Ama International University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["amaiu.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.aou.org.bh/"],
    name: "Arab Open University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["aou.org.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.asu.edu.bh/"],
    name: "Applied Science University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["asu.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.gulfuniversity.net/"],
    name: "Gulf University College",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["gulfuniversity.net"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.ku.edu.bh/"],
    name: "The Kingdom University",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["ku.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.nyit.edu.bh/"],
    name: "New York Instiute of Technology",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["nyit.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.rcsi-mub.com/"],
    name: "RCSI-Medical University of Bahrain",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["rcsi-mub.com"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.ucb.edu.bh/"],
    name: "University College Bahrain",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["ucb.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.uob.edu.bh/"],
    name: "University of Bahrain",
    alpha_two_code: "BH",
    "state-province": null,
    domains: ["uob.edu.bh"],
    country: "Bahrain",
  },
  {
    web_pages: ["http://www.aiub.edu/"],
    name: "American International University - Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["aiub.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.asaub.edu.bd/"],
    name: "Asa University Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["asaub.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.atishdipankaruniversity.edu.bd/"],
    name: "Atish Dipankar University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["atishdipankaruniversity.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.aub-bd.org/"],
    name: "Asian University of Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["aub-bd.org"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.aust.edu/"],
    name: "Ahsanullah University of Science & Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["aust.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bau.edu.bd/"],
    name: "Bangladesh Agricultural University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bau.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bgctrustbd.org/btub/"],
    name: "BGC Trust University, Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bgctrustbd.org"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bou.edu.bd/"],
    name: "Bangladesh Open University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bou.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bracuniversity.net/"],
    name: "Brac University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bracuniversity.net"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.brur.ac.bd/"],
    name: "Begum Rokeya University, Rangpur",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["brur.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bsmmu.edu.bd/"],
    name: "Bangabandhu Sheikh Mujibur Rahman Medical University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bsmmu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bsmrau.edu.bd/"],
    name: "Bangabandhu Sheikh Mujibur Rahman Agricultural University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bsmrau.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bubt.edu.bd/"],
    name: "Bangladesh University of Business & Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bubt.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bu.edu.bd/"],
    name: "Bangladesh University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.buet.ac.bd/"],
    name: "Bangladesh University of Engineering and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["buet.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.bup.edu.bd/"],
    name: "Bangladesh University of Professionals",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["bup.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.butex.edu.bd/"],
    name: "Bangladesh University of Textiles",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["butex.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.cityuniversity.edu.bd/"],
    name: "City University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["cityuniversity.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.cou.ac.bd/"],
    name: "Comilla University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["cou.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.cu.ac.bd/"],
    name: "University of Chittagong",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["cu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.cuet.ac.bd/"],
    name: "Chittagong University of Engineering and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["cuet.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.daffodilvarsity.edu.bd/"],
    name: "Daffodil International University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["daffodilvarsity.edu.bd", "diu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.diu.ac.bd/"],
    name: "Darul Ihsan University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["diu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.diu.net.bd/"],
    name: "Dhaka International University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["diu.net.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.du.ac.bd/"],
    name: "University of Dhaka",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["du.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.duet.ac.bd/"],
    name: "Dhaka University of Engineering and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["duet.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.eastdelta.edu.bd/"],
    name: "East Delta University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["eastdelta.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.easternuni.edu.bd/"],
    name: "Eastern University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["easternuni.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ewubd.edu/"],
    name: "East West University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ewubd.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ewubd.edu/"],
    name: "East-West University, Mohakhali",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ewubd.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.green.edu.bd/"],
    name: "Green University of Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["green.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.hstu.ac.bd/"],
    name: "Hajee Mohammad Danesh Science and Technology University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["hstu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ibaisuniv.edu.bd/"],
    name: "IBAIS University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ibaisuniv.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.icu-edu.org/"],
    name: "International Culture University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["icu-edu.org"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.iiuc.ac.bd/"],
    name: "International Islamic University Chittagong",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["iiuc.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.iu.ac.bd/"],
    name: "Islamic University Kushtia",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["iu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.iubat.edu/"],
    name: "International University of Business Agriculture and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["iubat.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.iub.edu.bd/"],
    name: "Independent University, Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["iub.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.iutoic-dhaka.edu/"],
    name: "Islamic University of Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["iutoic-dhaka.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.jkkniu.edu.bd/"],
    name: "Jatiya Kabi Kazi Nazrul Islam University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["jkkniu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.jnu.ac.bd/"],
    name: "Jagannath University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["jnu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.juniv.edu/"],
    name: "Jahangirnagar University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["juniv.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ku.ac.bd/"],
    name: "Khulna University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ku.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.kuet.ac.bd/"],
    name: "Khulna University of Engineering And Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["kuet.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.lus.ac.bd/"],
    name: "Leading University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["lus.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.manarat.ac.bd/"],
    name: "Manarat International University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["manarat.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.mbstu.ac.bd/"],
    name: "Mawlana Bhashani Science And Technology University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["mbstu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.metrouni.edu.bd/"],
    name: "Metropolitan University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["metrouni.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.mist.ac.bd/"],
    name: "Military Institute of Science and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["mist.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.neub.edu.bd/"],
    name: "North East University Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["neub.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.northsouth.edu/"],
    name: "North South University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["northsouth.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.nstu.edu.bd/"],
    name: "Noakhali University of Science and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["nstu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.nub.ac.bd/"],
    name: "Northern University Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["nub.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.nu.edu.bd/"],
    name: "National University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["nu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.presidency.edu.bd/"],
    name: "Presidency University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["presidency.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.pstu.ac.bd/"],
    name: "Patuakhali Science and Technology University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["pstu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.pub.ac.bd/"],
    name: "People's University of Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["pub.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.puc.ac.bd/"],
    name: "Premier University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["puc.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.pust.ac.bd/"],
    name: "Pabna University of Science and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["pust.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.queensuniversity.edu.bd/"],
    name: "Queens University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["queensuniversity.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ru.ac.bd/"],
    name: "University of Rajshahi",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ru.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ruet.ac.bd/"],
    name: "Rajshahi University of Engineering and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ruet.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.sau.ac.bd/"],
    name: "Sylhet Agricultural University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["sau.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.sec.ac.bd/"],
    name: "Sylhet Engineering College",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["sec.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.seu.ac.bd/"],
    name: "Southeast University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["seu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.siu.edu.bd/"],
    name: "Sylhet International University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["siu.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.southern.edu.bd/"],
    name: "Southern University Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["southern.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.stamforduniversity.edu.bd/"],
    name: "Stamford University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["stamforduniversity.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.sust.edu/"],
    name: "Shahjalal University of Science and Technology",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["sust.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.uap-bd.edu/"],
    name: "University of Asia Pacific, Dhanmondi",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["uap-bd.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.uits.edu.bd/"],
    name: "University of Information Technology & Sciences",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["uits.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.uiu.ac.bd/"],
    name: "United International University",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["uiu.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ulab.edu.bd/"],
    name: "University of Liberal Arts",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ulab.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.uoda.edu.bd/"],
    name: "University of Development Alternative",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["uoda.edu.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.ustc.ac.bd/"],
    name: "University of Science & Technology Chittagong",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["ustc.ac.bd"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.wub.edu/"],
    name: "World University of Bangladesh",
    alpha_two_code: "BD",
    "state-province": null,
    domains: ["wub.edu"],
    country: "Bangladesh",
  },
  {
    web_pages: ["http://www.uwichill.edu.bb/"],
    name: "University of the West Indies, Cave Hill",
    alpha_two_code: "BB",
    "state-province": null,
    domains: ["uwichill.edu.bb"],
    country: "Barbados",
  },
  {
    web_pages: ["http://academy.mia.by/"],
    name: "Academy of the Ministry of Internal Affairs of the Republic of Belarus",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["academy.mia.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.baa.by/"],
    name: "Belarussian State Agricultural Academy",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["baa.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.batu.edu.by/"],
    name: "Belarussian State Agrarian Technical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["batu.edu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.belsut.gomel.by/"],
    name: "Belarussian State University of Transport",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["belsut.gomel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bgam.edu.by/"],
    name: "Belarussian State Academy of Music",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bgam.edu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bntu.by/"],
    name: "Belarussian National Technical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bntu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.brsu.brest.by/"],
    name: "Brest State University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["brsu.brest.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bru.mogilev.by/"],
    name: "Belarusian-Russian University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bru.mogilev.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bseu.by/"],
    name: "Belarussian State Economic University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bseu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bsmu.by/"],
    name: "Belarussian State Medical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bsmu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bspa.unibel.by/"],
    name: "Belarussian State Polytechnical Academy",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bspa.unibel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bspu.unibel.by/"],
    name: "Belarussian State Pedagogical University M. Tanka",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bspu.unibel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bstu.by/"],
    name: "Brest State Technical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bstu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bstu.unibel.by/"],
    name: "Belarussian State Technological University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bstu.unibel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bsu.by/"],
    name: "Belarussian State University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bsu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.bsuir.by/"],
    name: "Belarussian State University of Informatics and Radioelectronics",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["bsuir.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.buk.by/"],
    name: "Belarussian State University of Culture and Arts",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["buk.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.data.minsk.by/ehu/"],
    name: "European Humanities University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["data.minsk.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.grsmu.by/"],
    name: "Grodno State Medical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["grsmu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.grsu.by/"],
    name: "Grodno State University Yanka Kupaly",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["grsu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.gstu.gomel.by/"],
    name: "Gomel State Technical University Pavel Sukhoi",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["gstu.gomel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.gsu.unibel.by/"],
    name: "Gomel State University Francisk Scarnia",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["gsu.unibel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.iseu.by/"],
    name: "International Sakharov Environmental University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["iseu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.kii.gov.by/"],
    name: "Institute for Command Engineers of The Ministry for Emergency Situations",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["kii.gov.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.meduniver.gomel.by/"],
    name: "Gomel State Medical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["meduniver.gomel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.mgpu.gomel.by/"],
    name: "Mozyr State Pedagogical Institute",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["mgpu.gomel.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.miu.by/"],
    name: "Minsk Institute of Management",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["miu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.mslu.by/"],
    name: "Minsk State Linguistic University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["mslu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://msu.mogilev.by/"],
    name: "Mogilev State University A.A. Kuleshov",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["msu.mogilev.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.pac.by/"],
    name: "Academy of Public Administration of Belarus",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["pac.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.psu.by/"],
    name: "Polotsk State University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["psu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.uni-agro.grodno.by/"],
    name: "Grodno State Agrarian University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["uni-agro.grodno.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.vgmu.vitebsk.by/"],
    name: "Vitebsk State Medical University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["vgmu.vitebsk.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.vsavm.com/"],
    name: "Vitebsk State Academy of Veterinary Medicine",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["vsavm.com"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.vstu.vitebsk.by/"],
    name: "Vitebsk State Technological University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["vstu.vitebsk.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.vsu.by/"],
    name: "Vitebsk State University",
    alpha_two_code: "BY",
    "state-province": null,
    domains: ["vsu.by"],
    country: "Belarus",
  },
  {
    web_pages: ["http://www.brexgata.eu/"],
    name: "Brexgata University Academy",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["brexgata.eu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.carolus-magnus-university.eu/"],
    name: "European Carolus Magnus University",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["carolus-magnus-university.eu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.coleurope.eu/"],
    name: "College of Europe",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["coleurope.eu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ctsem.edu/"],
    name: "Continental Theological Seminary",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ctsem.edu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ecam.be/"],
    name: "ECAM - Institut Supérieur Industriel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ecam.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ehb.be/"],
    name: "Erasmushogeschool Brussel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ehb.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ehsal.be/"],
    name: "EHSAL - Europese Hogeschool Brussel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ehsal.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.etf.edu/"],
    name: "Evangelische Theologische Faculteit, Leuven",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["etf.edu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.europeaniu.org/"],
    name: "European International University",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["europeaniu.org"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.fpms.ac.be/"],
    name: "Faculté Polytechnique de Mons",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["fpms.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.fsagx.ac.be/"],
    name: "Faculté Universitaire des Sciences Agronomiques de Gembloux",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["fsagx.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.fucam.ac.be/"],
    name: "Facultés Universitaires Catholiques de Mons",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["fucam.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ful.ac.be/"],
    name: "Fondation Universitaire Luxembourgeoise",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ful.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.fundp.ac.be/"],
    name: "Facultés Universitaires Notre-Dame de la Paix",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["fundp.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.fusl.ac.be/"],
    name: "Facultés Universitaires Saint-Louis",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["fusl.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ha.be/"],
    name: "Hogeschool Antwerpen",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ha.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.howest.be/"],
    name: "Hogeschool West-Vlaanderen (TU)",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["howest.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.hzs.be/"],
    name: "Hogere Zeevaartschool - Maritime Academy",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["hzs.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ichec.be/"],
    name: "Brussels Management School (ICHEC)",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ichec.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.kdg.be/"],
    name: "Karel De Grote Hogeschool",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["kdg.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.khk.be/"],
    name: "Katholieke Hogeschool Kempen",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["khk.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.khleuven.be/"],
    name: "Katholieke Hogeschool Leuven",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["khleuven.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.khlim.be/"],
    name: "Katholieke Hogeschool Limburg",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["khlim.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.kubrussel.ac.be/"],
    name: "Katholieke Universiteit Brussel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["kubrussel.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.kulak.ac.be/"],
    name: "Katholieke Universiteit Leuven, Campus Kortrijk",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["kulak.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.kuleuven.ac.be/"],
    name: "Katholieke Universiteit Leuven",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["kuleuven.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.rma.ac.be/"],
    name: "Royal Military Academy",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["rma.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["https://www.ugent.be/", "http://www.rug.ac.be/"],
    name: "Universiteit Gent",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ugent.be", "rug.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.thierryschool.org/"],
    name: "Thierry Graduate School of Leadership",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["thierryschool.org"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ua.ac.be/"],
    name: "Universiteit Antwerpen",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ua.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.uams.be/"],
    name: "Universiteit Antwerpen Management School",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["uams.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ubi.edu/"],
    name: "United Business Institute",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ubi.edu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ucl.ac.be/"],
    name: "Université Catholique de Louvain",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ucl.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ufsia.ac.be/"],
    name: "Universiteit Antwerpen, UFSIA",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ufsia.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.uhasselt.be/"],
    name: "Hasselt University",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["uhasselt.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ukc.ac.uk/international/bsis/"],
    name: "Brussels School of International Studies",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ukc.ac.uk"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ulb.ac.be/"],
    name: "Université Libre de Bruxelles",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ulb.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.ulg.ac.be/"],
    name: "Université de Liège",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["ulg.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.umh.ac.be/"],
    name: "Université de Mons-Hainaut",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["umh.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.vesalius.edu/"],
    name: "Vesalius College",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["vesalius.edu"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.vlekho.be/"],
    name: "Hogeschool voor Wetenschap en Kunst (VLEKHO), Brussel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["vlekho.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.vlerick.be/"],
    name: "Vlerick Leuven Gent Management School",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["vlerick.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.vub.ac.be/"],
    name: "Vrije Universiteit Brussel",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["vub.ac.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.wenk.be/"],
    name: "Hogeschool voor Wetenschap & Kunst",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["wenk.be"],
    country: "Belgium",
  },
  {
    web_pages: ["https://www.odisee.be/"],
    name: "University College Odisee",
    alpha_two_code: "BE",
    "state-province": null,
    domains: ["odisee.be"],
    country: "Belgium",
  },
  {
    web_pages: ["http://www.aucmed.edu/"],
    name: "American University of the Caribbean, School of Medicine",
    alpha_two_code: "BZ",
    "state-province": null,
    domains: ["aucmed.edu"],
    country: "Belize",
  },
  {
    web_pages: ["http://www.cahsu.edu/"],
    name: "Central America Health Sciences University (Belize Medical College)",
    alpha_two_code: "BZ",
    "state-province": null,
    domains: ["cahsu.edu"],
    country: "Belize",
  },
  {
    web_pages: ["http://www.giuedu.bz/"],
    name: "Greenford International University",
    alpha_two_code: "BZ",
    "state-province": null,
    domains: ["giuedu.bz"],
    country: "Belize",
  },
  {
    web_pages: ["http://www.ub.edu.bz/"],
    name: "University of Belize",
    alpha_two_code: "BZ",
    "state-province": null,
    domains: ["ub.edu.bz"],
    country: "Belize",
  },
  {
    web_pages: ["http://www.westcoastuniversity.bz/"],
    name: "West Coast University (WCU)",
    alpha_two_code: "BZ",
    "state-province": null,
    domains: ["westcoastuniversity.bz"],
    country: "Belize",
  },
  {
    web_pages: ["http://www.espam-formationuc.org/"],
    name: "Espam Formation University",
    alpha_two_code: "BJ",
    "state-province": null,
    domains: ["espam-formationuc.org"],
    country: "Benin",
  },
  {
    web_pages: ["http://www.hnaubenin.org/"],
    name: "Houdegbe North American University Benin",
    alpha_two_code: "BJ",
    "state-province": null,
    domains: ["hnaubenin.org"],
    country: "Benin",
  },
  {
    web_pages: ["http://www.uac.bj/"],
    name: "Université d'Abomey-Calavi (UAC)",
    alpha_two_code: "BJ",
    "state-province": null,
    domains: ["uac.bj"],
    country: "Benin",
  },
  {
    web_pages: ["http://www.bercol.bm/"],
    name: "Bermuda College",
    alpha_two_code: "BM",
    "state-province": null,
    domains: ["bercol.bm"],
    country: "Bermuda",
  },
  {
    web_pages: ["http://www.rub.edu.bt/"],
    name: "Royal University of Bhutan",
    alpha_two_code: "BT",
    "state-province": null,
    domains: ["rub.edu.bt"],
    country: "Bhutan",
  },
  {
    web_pages: ["http://www.emi.edu.bo/"],
    name: "Escuela Militar de Ingeniería",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["emi.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.nur.edu/"],
    name: "Universidad NUR",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["nur.edu"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uab.edu.bo/"],
    name: "Universidad Adventista de Bolivia",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uab.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uabjb.edu.bo/"],
    name: 'Universidad Autónoma del Beni "José Ballivián"',
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uabjb.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uagrm.edu.bo/"],
    name: "Universidad Autónoma Gabriel René Moreno",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uagrm.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uajms.edu.bo/"],
    name: "Universidad Autónoma Juan Misael Saracho",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uajms.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uajms.edu.bo/"],
    name: "Universidad Juan Misael Saracho",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uajms.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uapnet.edu.bo/"],
    name: "Universidad Amazonica de Pando",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uapnet.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uasb.edu.bo/"],
    name: "Universidad Andina Simón Bolivar",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uasb.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uatf.edu.bo/"],
    name: "Universidad Autónoma Tomás Frías",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uatf.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.ucbcba.edu.bo/"],
    name: "Universidad Católica Boliviana, Cochabamba",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["ucbcba.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.ucb.edu.bo/"],
    name: "Universidad Católica Boliviana, La Paz",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["ucb.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.ucbscz.edu.bo/"],
    name: "Universidad Católica Boliviana, Santa Cruz",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["ucbscz.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.ucbtja.edu.bo/"],
    name: "Universidad Católica Boliviana, Tarija",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["ucbtja.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.udabol.edu.bo/"],
    name: "Universidad de Aquino Bolivia",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["udabol.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.udelosandes.edu.bo/"],
    name: "Universidad Los Andes",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["udelosandes.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.umsanet.edu.bo/"],
    name: "Universidad Mayor de San Andrés",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["umsanet.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.umss.edu.bo/"],
    name: "Universidad Mayor de San Simón",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["umss.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.unicen.edu.bo/"],
    name: "Universidad Central",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["unicen.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.unifranz.edu.bo/"],
    name: "Universidad Privada Franz Tamayo (UNIFRANZ)",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["unifranz.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.unikuljis.edu.bo/"],
    name: "Universidad Empresarial Mateo Kuljis",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["unikuljis.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.univalle.edu/"],
    name: "Universidad Privada del Valle",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["univalle.edu"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.unslp.edu.bo/"],
    name: "Universidad Nuestra Senora de La Paz",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["unslp.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.unsxx.edu.bo/"],
    name: "Universidad Nacional Siglo XX Llallagua",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["unsxx.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.upal.edu/"],
    name: "Universidad Privada Abierta Latinoamericana",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["upal.edu"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.upb.edu/"],
    name: "Universidad Privada Boliviana",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["upb.edu"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.upds.edu.bo/"],
    name: "Universidad Domingo Savio",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["upds.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.upsa.edu.bo/"],
    name: "Universidad Privada de Santa Cruz de la Sierra",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["upsa.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.usalesiana.edu.bo/"],
    name: "Universidad Salesiana de Bolivia",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["usalesiana.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.usfx.edu.bo/"],
    name: "Universidad San Francisco Xavier de Chuquisaca",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["usfx.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.usfx.info/"],
    name: "Universidad San Francisco Xavier",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["usfx.info"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.uto.edu.bo/"],
    name: "Universidad Técnica de Oruro",
    alpha_two_code: "BO",
    "state-province": null,
    domains: ["uto.edu.bo"],
    country: "Bolivia, Plurinational State of",
  },
  {
    web_pages: ["http://www.aubih.ba/"],
    name: "American University",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["aubih.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.ibu.edu.ba/"],
    name: "International Burch University",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["ibu.edu.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.ius.edu.ba/"],
    name: "International University of Sarajevo",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["ius.edu.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.iu-travnik.com/"],
    name: "International University of Travnik",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["iu-travnik.com"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.sfa.ba/"],
    name: "Sarajevo Film Academy",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["sfa.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.spu.ba/"],
    name: "Slobomir P Univerzitet",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["spu.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.sve-mo.ba/"],
    name: "University of Mostar",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["sve-mo.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unbi.ba/"],
    name: "University of Bihac",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unbi.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unibl.org/"],
    name: "University of Banja Luka",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unibl.org"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unmo.ba/"],
    name: 'Univerzitet u Mostaru "Dzemal Bijedic"',
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unmo.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unsa.ba/"],
    name: "University of Sarajevo",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unsa.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unssa.rs.ba/"],
    name: "University of East Srarajevo",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unssa.rs.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.untz.ba/"],
    name: "University of Tuzla",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["untz.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unvi.edu.ba/"],
    name: "University Vitez In Travnik",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unvi.edu.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.unze.ba/"],
    name: "University of Zenica",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["unze.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["http://www.abm.ac.bw/"],
    name: "ABM University College",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["abm.ac.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.bac.ac.bw/"],
    name: "Botswana Accountancy College",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["bac.ac.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.bca.bw/"],
    name: "Botswana College of Agriculture",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["bca.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.biust.ac.bw/"],
    name: "Botswana International University of Science & Technology",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["biust.ac.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.bothocollege.ac.bw/"],
    name: "Botho University",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["bothocollege.ac.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.guc.co.bw/"],
    name: "Gaborone Universal College of Law",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["guc.co.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.neweracollege.ac.bw/"],
    name: "New Era College of Arts, Science & Technology",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["neweracollege.ac.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.ub.bw/"],
    name: "University of Botswana",
    alpha_two_code: "BW",
    "state-province": null,
    domains: ["ub.bw"],
    country: "Botswana",
  },
  {
    web_pages: ["http://www.baraodemaua.br/"],
    name: "Centro Universitário Barao de Maua",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["baraodemaua.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.brazcubas.br/"],
    name: "Universidade Braz Cubas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["brazcubas.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.candidomendes.br/"],
    name: "Universidade Candido Mendes",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["candidomendes.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.castelobranco.br/"],
    name: "Universidade Castelo Branco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["castelobranco.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.claretiano.edu.br/"],
    name: "Centro Universitário Claretiano",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["claretiano.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.creupi.br/"],
    name: "Centro Regional Universitário de Espiríto Santo do Pinhal",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["creupi.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.emescam.br/"],
    name: "EMESCAM - Escola Superior de Ciências da Santa Casa de Misericórdia de Vitória",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["emescam.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.epm.br/"],
    name: "Universidade Federal de São Paulo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["epm.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.estacio.br/"],
    name: "Universidade Estácio de Sá",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["estacio.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.faap.br/"],
    name: "FAAP - Fundação Armando Alvares Penteado",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["faap.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.faculdadescuritiba.br/"],
    name: "Faculdades Integradas Curitiba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["faculdadescuritiba.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.fae.edu/"],
    name: "FAE Business School - Faculdade de Administração e Economia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["fae.edu"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.feituverava.com.br/"],
    name: "Fundação Educacional de Ituverava",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["feituverava.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.fic.br/"],
    name: "Faculdade Integradas do Ceará",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["fic.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.fua.br/"],
    name: "Universidade do Amazonas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["fua.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.furb.rct-sc.br/"],
    name: "Universidade Regional de Blumenau",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["furb.rct-sc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.furg.br/"],
    name: "Universidade Federal do Rio Grande",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["furg.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.impa.br/"],
    name: "Instituto Nacional de Matemática Pura e Aplicada - IMPA",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["impa.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ime.eb.mil.br"],
    name: "Instituto Militar de Engenharia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ime.eb.mil.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ita.br/"],
    name: "Instituto Tecnológico de Aeronáutica",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ita.br"],
    country: "Brazil",
  },
  {
    web_pages: ["https://www.insper.edu.br"],
    name: "Insper Instituto de Ensino e Pesquisa",
    alpha_two_code: "BR",
    "state-province": "SP",
    domains: ["insper.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.italo.br/"],
    name: "Faculdade Italo Brasileira",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["italo.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.mackenzie.br/"],
    name: "Universidade Mackenzie",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["mackenzie.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.maua.br/"],
    name: "Instituto Mauá de Tecnologia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["maua.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.newtonpaiva.br/"],
    name: "Centro Universitário Newton Paiva",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["newtonpaiva.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.pop-to.rnp.br/"],
    name: "Universidade de Tocantins",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["pop-to.rnp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.puccamp.br/"],
    name: "Pontifícia Universidade Católica de Campinas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["puccamp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.pucminas.br/"],
    name: "Pontifícia Universidade Católica de Minas Gerais",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["pucminas.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.pucpr.br/"],
    name: "Pontificia Universidade Católica do Paraná",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["pucpr.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.puc-rio.br/"],
    name: "Pontifícia Universidade Católica do Rio de Janeiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["puc-rio.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.pucrs.br/"],
    name: "Pontifícia Universidade Católica do Rio Grande do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["pucrs.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.pucsp.br/"],
    name: "Pontifícia Universidade Católica de São Paulo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["pucsp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.saojudas.br/"],
    name: "Universidade São Judas Tadeu",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["saojudas.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.smarcos.br/"],
    name: "Universidade São Marcos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["smarcos.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.sp.senac.br/"],
    name: "Centro Universitário Senac",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["sp.senac.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.stcecilia.br/"],
    name: "Universidade Santa Cecília dos Bandeirantes",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["stcecilia.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.technet.com.br/vestibular/"],
    name: "Universidade Federal de Roraima",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["technet.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.toledo.br/"],
    name: "Faculdades Integradas Toledo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["toledo.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucb.br/"],
    name: "Universidade Católica de Brasília",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucb.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucg.br/"],
    name: "Universidade Católica de Goiás",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucg.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucp.br/"],
    name: "Universidade Católica de Petrópolis",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucpel.tche.br/"],
    name: "Universidade Católica de Pelotas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucpel.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucsal.br/"],
    name: "Universidade Católica de Salvador",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucsal.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ucs.tche.br/"],
    name: "Universidade de Caxias do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ucs.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.udesc.br/"],
    name: "Universidade do Estado de Santa Catarina",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["udesc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uece.br/"],
    name: "Universidade Estadual do Ceará",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uece.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uefs.br/"],
    name: "Universidade Estadual de Feira de Santana",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uefs.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uel.br/"],
    name: "Universidade Estadual de Londrina",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uel.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uema.br/"],
    name: "Universidade Estadual do Maranhão",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uema.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uem.br/"],
    name: "Universidade Estadual de Maringá",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uem.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uenf.br/"],
    name: "Universidade Estadual do Norte Fluminense",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uenf.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uepb.edu.br/"],
    name: "Universidade Estadual da Paraíba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uepb.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uepg.br/"],
    name: "Universidade Estadual de Ponta Grossa",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uepg.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uerj.br/"],
    name: "Universidade do Estado do Rio de Janeiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uerj.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uern.br/"],
    name: "Universidade do Estado do Rio Grande do Norte",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uern.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uesb.br/"],
    name: "Universidade Estadual Sudoeste da Bahia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uesb.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uesc.br/"],
    name: "Universidade Estadual de Santa Cruz",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uesc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uespi.br/"],
    name: "Universidade Estadual do Piauí",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uespi.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufabc.edu.br/"],
    name: "Universidade Federal do ABC",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufabc.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufac.br/"],
    name: "Universidade Federal do Acre",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufac.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufal.br/"],
    name: "Universidade Federal de Alagoas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufal.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufba.br/"],
    name: "Universidade Federal da Bahia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufba.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufc.br/"],
    name: "Universidade Federal do Ceará",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufcg.edu.br/"],
    name: "Universidade Federal de Campina Grande",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufcg.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufes.br/"],
    name: "Universidade Federal do Espírito Santo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufes.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uff.br/"],
    name: "Universidade Federal Fluminense",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uff.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufg.br/"],
    name: "Universidade Federal de Goiás",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufg.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufgd.edu.br/"],
    name: "Universidade Federal da Grande Dourados",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufgd.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufjf.br/"],
    name: "Universidade Federal de Juiz de Fora",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufjf.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufla.br/"],
    name: "Universidade Federal de Lavras",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufla.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufma.br/"],
    name: "Universidade Federal do Maranhão",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufma.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufmg.br/"],
    name: "Universidade Federal de Minas Gerais",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufmg.br", "dcc.ufmg.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufvjm.edu.br"],
    name: "Universidade Federal dos Vales do Jequitinhonha e Mucuri",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufvjm.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["https://unifei.edu.br/"],
    name: "Universidade Federal de Itajubá",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifei.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["https://www.ufsj.edu.br/"],
    name: "Universidade Federal de São João del-Rei",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufsj.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uftm.edu.br/"],
    name: "Universidade Federal do Triângulo Mineiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uftm.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufms.br/"],
    name: "Universidade Federal de Mato Grosso do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufms.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufmt.br/"],
    name: "Universidade Federal de Mato Grosso",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufmt.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufop.br/"],
    name: "Universidade Federal de Ouro Preto",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufop.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpa.br/"],
    name: "Universidade Federal do Pará",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpa.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpb.br/"],
    name: "Universidade Federal da Paraíba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpb.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpe.br/"],
    name: "Universidade Federal de Pernambuco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpe.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpel.tche.br/"],
    name: "Universidade Federal de Pelotas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpel.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpi.br/"],
    name: "Universidade Federal do Piauí",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpi.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufpr.br/"],
    name: "Universidade Federal do Paraná",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufpr.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufrgs.br/"],
    name: "Universidade Federal do Rio Grande do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufrgs.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufrj.br/"],
    name: "Universidade Federal do Rio de Janeiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufrj.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufrn.br/"],
    name: "Universidade Federal do Rio Grande do Norte",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufrn.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufrpe.br/"],
    name: "Universidade Federal Rural de Pernambuco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufrpe.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufrrj.br/"],
    name: "Universidade Federal Rural do Rio de Janeiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufrrj.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufs.br/"],
    name: "Universidade Federal de Sergipe",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufs.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufscar.br/"],
    name: "Universidade Federal de São Carlos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufscar.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufsc.br/"],
    name: "Universidade Federal de Santa Catarina",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufsc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufsm.br/"],
    name: "Universidade Federal de Santa Maria",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufsm.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufu.br/"],
    name: "Universidade Federal de Uberlândia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ufv.br/"],
    name: "Universidade Federal de Viçosa",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ufv.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ugf.br/"],
    name: "Universidade Gama Filho",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ugf.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ulbra.br/"],
    name: "Universidade Luterana do Brasil",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ulbra.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.umc.br/"],
    name: "Universidade de Mogi das Cruzes",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["umc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unaerp.br/"],
    name: "Universidade de Ribeirão Preto",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unaerp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unama.br/"],
    name: "Universidade da Amazônia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unama.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unb.br/"],
    name: "Universidade de Brasília",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unb.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uneb.br/"],
    name: "Universidade do Estado da Bahia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uneb.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unesc.rct-sc.br/"],
    name: "Universidade do Extremo Sul Catarinense",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unesc.rct-sc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unesp.br/"],
    name: "Universidade Estadual Paulista",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unesp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.ung.br/"],
    name: "Universidade de Guarulhos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["ung.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uniara.com.br/"],
    name: "Centro Universitário de Araraquara",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uniara.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uniban.br/"],
    name: "Universidade Bandeirante de São Paulo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uniban.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unib.br/"],
    name: "Universidade Ibirapuera",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unib.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unibosco.br/"],
    name: "Universidade Católica Dom Bosco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unibosco.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unibrasil.com.br/"],
    name: "Faculdades Integradas do Brasil - UNIBRASIL",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unibrasil.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicamp.br/"],
    name: "Universidade Estadual de Campinas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicamp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicap.br/"],
    name: "Universidade Católica de Pernambuco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicap.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicastelo.br/"],
    name: "Universidade Camilo Castelo Branco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicastelo.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicid.br/"],
    name: "Universidade Cidade de São Paulo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicid.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicruz.tche.br/"],
    name: "Universidade de Cruz Alta",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicruz.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unicsul.br/"],
    name: "Universidade Cruzeiro do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unicsul.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unidavi.rct-sc.br/"],
    name: "Universidade para o Desenvolvimento do Alto Vale do Itajaí",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unidavi.rct-sc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifacs.br/"],
    name: "Universidade Salvador",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifacs.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifap.br/"],
    name: "Universidade Federal do Amapá",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifap.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifenas.br/"],
    name: "Universidade de Alfenas",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifenas.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifeso.edu.br/"],
    name: "Centro Universitário Serra dos Órgãos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifeso.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifor.br/"],
    name: "Universidade de Fortaleza",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifor.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unifran.br/"],
    name: "Universidade de Franca",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unifran.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unig.br/"],
    name: "Universidade de Nova Iguaçu",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unig.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unigranrio.br/"],
    name: "Universidade do Grande Rio",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unigranrio.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unijui.tche.br/"],
    name: "Universidade Regional do Noroeste do Estado do Rio Grande do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unijui.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unimar.br/"],
    name: "Universidade de Marília",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unimar.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unimep.br/"],
    name: "Universidade Metodista de Piracicaba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unimep.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unimes.com.br/"],
    name: "Universidade Metropolitana de Santos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unimes.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unimonte.br/"],
    name: "Centro Universitário Monte Serrat",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unimonte.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unimontes.br/"],
    name: "Universidade Estadual de Montes Claros",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unimontes.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unioeste.br/"],
    name: "Universidade Estadual do Oeste do Paraná",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unioeste.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unipe.br/"],
    name: "Centro Universitário de João Pessoa",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unipe.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unipli.com.br/"],
    name: "Centro Universitário Plinio Leite",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unipli.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unip-objetivo.br/"],
    name: "Universidade Paulista",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unip-objetivo.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unir.br/"],
    name: "Universidade Federal de Rondônia",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unir.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unirio.br/"],
    name: "Universidade do Rio de Janeiro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unirio.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unisa.br/"],
    name: "Universidade de Santo Amaro",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unisa.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unisantos.com.br/"],
    name: "Universidade Católica de Santos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unisantos.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unisc.br/"],
    name: "Universidade de Santa Cruz do Sul",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unisc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unisinos.br/"],
    name: "Universidade Vale do Rio dos Sinos",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unisinos.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unisul.br/"],
    name: "Universidade do Sul de Santa Catarina",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unisul.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unitau.br/"],
    name: "Universidade de Taubaté",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unitau.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unit.br/"],
    name: "Universidade Tiradentes",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unit.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uniube.br/"],
    name: "Universidade de Uberaba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uniube.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.univale.br/"],
    name: "Universidade Vale do Rio Doce",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["univale.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.univali.rct-sc.br/"],
    name: "Universidade do Vale do Itajaí",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["univali.rct-sc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.univap.br/"],
    name: "Universidade Vale do Paraiba",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["univap.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.univasf.edu.br/"],
    name: "Universidade Federal do Vale do São Francisco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["univasf.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.universo.br/"],
    name: "Universidade Salgado de Oliveira",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["universo.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unoesc.edu.br/"],
    name: "Universidade do Oeste de Santa Catarina",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unoesc.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unoeste.br/"],
    name: "Universidade do Oeste Paulista",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unoeste.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.unp.br/"],
    name: "Universidade Potiguar",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["unp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.upe.br/"],
    name: "Universidade de Pernambuco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["upe.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.upf.tche.br/"],
    name: "Universidade de Passo Fundo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["upf.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.upis.br/"],
    name: "Faculdades Integradas UPIS",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["upis.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.urca.br/"],
    name: "Universidade Regional do Cariri",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["urca.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.urcamp.tche.br/"],
    name: "Universidade da Região da Campanha",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["urcamp.tche.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uri.br/"],
    name: "Universidade Regional Integrada do Alto Uruguai e das Missões",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uri.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.usc.br/"],
    name: "Universidade do Sagrado Coração",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["usc.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.usf.br/"],
    name: "Universidade São Francisco",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["usf.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.usp.br/"],
    name: "Universidade de São Paulo",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["usp.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.usu.br/"],
    name: "Universidade Santa Úrsula",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["usu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uva.br/"],
    name: "Universidade Veiga de Almeida",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uva.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.uvanet.br/"],
    name: "Universidade Estadual do Vale do Acaraú",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["uvanet.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://web.prover.com.br/fui/"],
    name: "Universidade de Itaúna",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["web.prover.com.br"],
    country: "Brazil",
  },
  {
    web_pages: ["http://www.itb.edu.bn/"],
    name: "Institut Teknologi Brunei",
    alpha_two_code: "BN",
    "state-province": null,
    domains: ["itb.edu.bn"],
    country: "Brunei Darussalam",
  },
  {
    web_pages: ["http://www.ubd.edu.bn/"],
    name: "University of Brunei Darussalam",
    alpha_two_code: "BN",
    "state-province": null,
    domains: ["ubd.edu.bn"],
    country: "Brunei Darussalam",
  },
  {
    web_pages: ["http://www.unissa.edu.bn/"],
    name: "Universiti Islam Sultan Sharif Ali",
    alpha_two_code: "BN",
    "state-province": null,
    domains: ["unissa.edu.bn"],
    country: "Brunei Darussalam",
  },
  {
    web_pages: ["http://amti.hit.bg/"],
    name: "Academy of Music, Dance and Fine Arts",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["amti.hit.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.aubg.bg/"],
    name: "American University in Bulgaria",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["aubg.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.au-plovdiv.bg/"],
    name: "Agricultural University of Plovdiv",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["au-plovdiv.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.bfu.bg/"],
    name: "Bourgas Free University",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["bfu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.btu.bg/"],
    name: 'Bourgas University "Prof. Assen Zlatarov"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["btu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.cityu.bg/"],
    name: "City University Programs in Bulgaria",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["cityu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.ltu.bg/"],
    name: "University of Forestry Sofia",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["ltu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.meduniversity-plovdiv.bg/"],
    name: "Medical University Plovdiv",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["meduniversity-plovdiv.bg", "mu-plovdiv.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.mgu.bg/"],
    name: 'University of Mining and Geology "St. Ivan Rils"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["mgu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.mu-pleven.bg/"],
    name: "Medical University Pleven",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["mu-pleven.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.mu-sofia.bg/"],
    name: "Medical University of Sofia",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["mu-sofia.bg", "students.mu-sofia.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.mu-varna.bg/"],
    name: "Medical University Varna",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["mu-varna.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.natfiz.bg/"],
    name: 'National Academy for Theatre and Film Arts "Krustju Sarafov"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["natfiz.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.nbu.bg/"],
    name: "New Bulgarian University",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["nbu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.nha-bg.org/"],
    name: "National Academy of Arts",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["nha-bg.org"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.nma.bg/"],
    name: 'National Academy of Music "Pantcho Vladigerov"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["nma.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.nsa.bg/"],
    name: "National Sports Academy Sofia",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["nsa.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.pv-ma.bg/"],
    name: "Military University Shoumen",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["pv-ma.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.ru.acad.bg/"],
    name: "University of Rousse",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["ru.acad.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.shu-bg.net/"],
    name: 'Shoumen University "Konstantin Preslavski"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["shu-bg.net"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.swu.bg/"],
    name: 'South-West University "Neofit Rilski"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["swu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.tugab.bg/"],
    name: "Technical University of Gabrovo",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["tugab.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.tu-sofia.bg/"],
    name: "Technical University of Sofia",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["tu-sofia.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.tu-varna.acad.bg/"],
    name: "Technical University of Varna",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["tu-varna.acad.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uacg.bg/"],
    name: "University of Architecture, Civil Engineering and Geodesy",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uacg.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uctm.edu/"],
    name: "University of Chemical Technology and Metallurgy",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uctm.edu"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.ue-varna.bg/"],
    name: "University of Economics Varna",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["ue-varna.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uft-plovdiv.bg/"],
    name: "University of Food Technology",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uft-plovdiv.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uni-plovdiv.bg/"],
    name: "University of Plovdiv",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uni-plovdiv.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uni-sofia.bg/"],
    name: 'Sofia University "St. Kliment Ohridski"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uni-sofia.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uni-svishtov.bg/"],
    name: 'Academy of Economics "Dimitur A. Tscenov"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uni-svishtov.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uni-sz.bg/"],
    name: "Trakia University Stara Zagora",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uni-sz.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.uni-vt.bg/"],
    name: 'Veliko Turnovo University "Cyril and Methodius"',
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["uni-vt.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.unwe.acad.bg/"],
    name: "University of National and World Economy",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["unwe.acad.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.vfu.bg/"],
    name: "Varna Free University",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["vfu.bg"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.vumk.eu/"],
    name: "International University College",
    alpha_two_code: "BG",
    "state-province": null,
    domains: ["vumk.eu"],
    country: "Bulgaria",
  },
  {
    web_pages: ["http://www.univ-ouaga.bf/"],
    name: "Université de Ouagadougou",
    alpha_two_code: "BF",
    "state-province": null,
    domains: ["univ-ouaga.bf"],
    country: "Burkina Faso",
  },
  {
    web_pages: ["http://www.itbmu.org.mm/"],
    name: "International Theravada Buddhist Missionary University",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["itbmu.org.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/mtu/"],
    name: "Mandalay Technological University",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/maeu/"],
    name: "Myanmar Aerospace Engineering University",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/banmawtu/"],
    name: "Technological University (Banmaw)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/daweitu/"],
    name: "Technological University (Dawei)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/hinthadatu/"],
    name: "Technological University (Hinthada)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/hmawbitu/"],
    name: "Technological University (Hmawbi)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/hpaantu/"],
    name: "Technological University (Hpaan)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/kalaytu/"],
    name: "Technological University (Kalay)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/kyaingtongtu/"],
    name: "Technological University (Kyaing Tong)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/kyauksetu/"],
    name: "Technological University (Kyaukse)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/lashiotu/"],
    name: "Technological University (Lashio)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/loikawtu/"],
    name: "Technological University (Loikaw)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/magwaytu/"],
    name: "Technological University (Magway)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/mdytu/"],
    name: "Technological University (Mandalay)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/maubintu/"],
    name: "Technological University (Maubin)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/mawlamyaingtu/"],
    name: "Technological University (Mawlamyaing)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/meikhtilatu/"],
    name: "Technological University (Meikhtila)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/monywatu/"],
    name: "Technological University (Monywa)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/myeiktu/"],
    name: "Technological University (Myeik)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/myitkyinatu/"],
    name: "Technological University (Myitkyina)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/pakokkutu/"],
    name: "Technological University (Pakokku)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/patheintu/"],
    name: "Technological University (Pathein)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/pinlontu/"],
    name: "Technological University (Pinlon)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/ptu/"],
    name: "Technological University (Pyay)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/sittwetu/"],
    name: "Technological University (Sittwe)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/taunggyitu/"],
    name: "Technological University (Taunggyi)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/taungootu/"],
    name: "Technological University (Taungoo)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/thanlyintu/"],
    name: "Technological University (Thanlyin)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/wytu/"],
    name: "Technological University (West Yangon)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.most.gov.mm/ytu/"],
    name: "Technological University (Yangon)",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["most.gov.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.ucsy.edu.mm/"],
    name: "University of Computer Studies, Yangon",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["ucsy.edu.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.um1ygn.edu.mm/"],
    name: "University of Medicine 1, Yangon",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["um1ygn.edu.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://www.ummg.edu.mm/"],
    name: "University of Medicine Magway",
    alpha_two_code: "MM",
    "state-province": null,
    domains: ["ummg.edu.mm"],
    country: "Myanmar",
  },
  {
    web_pages: ["http://hopeafricauniversity.org/"],
    name: "Hope Africa University",
    alpha_two_code: "BI",
    "state-province": null,
    domains: ["hopeafricauniversity.org"],
    country: "Burundi",
  },
  {
    web_pages: ["http://www.ub.edu.bi/"],
    name: "Université du Burundi",
    alpha_two_code: "BI",
    "state-province": null,
    domains: ["ub.edu.bi"],
    country: "Burundi",
  },
  {
    web_pages: ["http://www.ulbu.bi/"],
    name: "Université Lumière de Bujumbura",
    alpha_two_code: "BI",
    "state-province": null,
    domains: ["ulbu.bi"],
    country: "Burundi",
  },
  {
    web_pages: ["http://www.aeu.edu.kh/"],
    name: "Asia Europe University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["aeu.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.angkor.edu.kh/"],
    name: "Angkor University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["angkor.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.bbu.edu.kh/"],
    name: "Build Bright University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["bbu.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.cup.edu.kh/"],
    name: "Chamreun University of Poly Technology",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["cup.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.cus.edu.kh/"],
    name: "Cambodia University of Specialties",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["cus.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.ine.edu.kh/"],
    name: "National Institute of Education",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["ine.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.iu.edu.kh/"],
    name: "International University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["iu.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.mekong.edu.kh/"],
    name: "Cambodian Mekong University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["mekong.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.norton.edu.kh/"],
    name: "Norton University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["norton.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.num.edu.kh/"],
    name: "National University of Management",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["num.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.puc.edu.kh/"],
    name: "Pannnasatra University of Cambodia",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["puc.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.rua.edu.kh/"],
    name: "Royal University of Agriculture",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["rua.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.rufa.edu.kh/"],
    name: "Royal University of Fine Arts",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["rufa.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.rule.edu.kh/"],
    name: "Royal University of Law and Economics",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["rule.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.rupp.edu.kh/"],
    name: "Royal University of Phnom Penh",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["rupp.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.sru.edu.kh/"],
    name: "Svey Reong University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["sru.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.uc.edu.kh/"],
    name: "University of Cambodia",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["uc.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.univ-sante.edu.kh/"],
    name: "University of Health and Science",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["univ-sante.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.utpp.edu.kh/"],
    name: "University of Technology Phnom Penh",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["utpp.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.western.edu.kh/"],
    name: "Western University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["western.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.zamanuniversity.edu.kh/"],
    name: "Zaman University",
    alpha_two_code: "KH",
    "state-province": null,
    domains: ["zamanuniversity.edu.kh"],
    country: "Cambodia",
  },
  {
    web_pages: ["http://www.bamendauniversity.com/"],
    name: "Bamenda University of Science & Technology",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["bamendauniversity.com"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.fomicgroup.cm/"],
    name: "Fomic Polytechnic",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["fomicgroup.cm"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.ubuea.cm/"],
    name: "Université de Buéa",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["ubuea.cm"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.udesmontagnes.org/"],
    name: "Université des Montagnes",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["udesmontagnes.org"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.unibda.net/"],
    name: "Université de Bamenda",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["unibda.net"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.univ-douala.com/"],
    name: "Université de Douala",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["univ-douala.com"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.univ-dschang.org/"],
    name: "Université de Dschang",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["univ-dschang.org"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.universite-yde2.org/"],
    name: "Université de Yaoundé II",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["universite-yde2.org"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.univ-ndere.cm/"],
    name: "Université de Ngaoundéré",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["univ-ndere.cm"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.uy1.uninet.cm/"],
    name: "Université de Yaoundé I",
    alpha_two_code: "CM",
    "state-province": null,
    domains: ["uy1.uninet.cm"],
    country: "Cameroon",
  },
  {
    web_pages: ["http://www.acadiau.ca/"],
    name: "Acadia University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["acadiau.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.algonquincollege.com/"],
    name: "Algonquin College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["algonquincollege.com"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ashtoncollege.com/"],
    name: "Ashton College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ashtoncollege.com"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.assumptionu.ca/"],
    name: "Assumption University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["assumptionu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.athabascau.ca/"],
    name: "Athabasca University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["athabascau.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.augustana.ab.ca/"],
    name: "Augustana University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["augustana.ab.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.bcit.ca/"],
    name: "British Columbia Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["bcit.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.bcou.ca/"],
    name: "British Columbia Open University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["bcou.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.boothcollege.ca/"],
    name: "William and Catherine Booth College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["boothcollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.borealc.on.ca/"],
    name: "Collège Boréal",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["borealc.on.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.bowvalleycollege.ca/"],
    name: "Bow Valley College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["bowvalleycollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.brandonu.ca/"],
    name: "Brandon University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["brandonu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.brocku.ca/"],
    name: "Brock University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["brocku.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cal.devry.ca/"],
    name: "DeVry Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cal.devry.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.camosun.bc.ca/"],
    name: "Camosun College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["camosun.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.capcollege.bc.ca/"],
    name: "Capilano College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["capcollege.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cariboo.bc.ca/"],
    name: "University College of the Cariboo",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cariboo.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.carleton.ca/"],
    name: "Carleton University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["carleton.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ccbc.ca/"],
    name: "Canadian College of Business & Computers",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ccbc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.centennialcollege.ca/"],
    name: "Centennial College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["centennialcollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cmu.ca/"],
    name: "Canadian Mennonite University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cmu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cnc.bc.ca/"],
    name: "College of New Caledonia",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cnc.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.columbiacollege.ca/"],
    name: "Columbia College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["columbiacollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.concordia.ab.ca/"],
    name: "Concordia University College of Alberta",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["concordia.ab.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.concordia.ca/"],
    name: "Concordia University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["concordia.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.conestogac.on.ca/"],
    name: "Conestoga College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["conestogac.on.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cotr.bc.ca/"],
    name: "College of the Rockies",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cotr.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cus.ca/"],
    name: "University of Moncton, Shippagan",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cus.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.cuslm.ca/"],
    name: "University of Moncton, Edmundston",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["cuslm.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.dal.ca/"],
    name: "Dalhousie University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["dal.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.douglas.bc.ca/"],
    name: "Douglas College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["douglas.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["https://durhamcollege.ca/"],
    name: "Durham College",
    alpha_two_code: "CA",
    "state-province": "Ontario",
    domains: ["dcmail.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.eciad.bc.ca/"],
    name: "Emily Carr Institute of Art + Design",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["eciad.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.enap.uquebec.ca/"],
    name: "École nationale d'administration publique, Université du Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["enap.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.etsmtl.ca/"],
    name: "École de technologie supérieure, Université du Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["etsmtl.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.firstnationsuniversity.ca/"],
    name: "First Nations University of Canada",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["firstnationsuniversity.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.gbrownc.on.ca/"],
    name: "George Brown College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["gbrownc.on.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.hec.ca/"],
    name: "École des Hautes Études Commerciales",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["hec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.humber.ca/"],
    name: "Humber College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["humber.ca", "humbermail.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.huronuc.on.ca/"],
    name: "Huron University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["huronuc.on.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.iaf.inrs.ca/"],
    name: "Institut Armand-Frappier, Université du Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["iaf.inrs.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.inrs.uquebec.ca/"],
    name: "Institut National de la Recherche Scientifique, Université du Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["inrs.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.kingston.edu/"],
    name: "Kingston College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["kingston.edu"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.kingsu.ab.ca/"],
    name: "King's University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["kingsu.ab.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.kwantlen.bc.ca/"],
    name: "Kwantleen University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["kwantlen.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.lakeheadu.ca/"],
    name: "Lakehead University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["lakeheadu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.langara.bc.ca/", "https://langara.ca/"],
    name: "Langara College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["langara.bc.ca", "langara.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.lansbridge.com/"],
    name: "Lansbridge University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["lansbridge.com"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.laurentian.ca/"],
    name: "Laurentian University of Sudbury",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["laurentian.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.macewan.ca/"],
    name: "MacEwan University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["macewan.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.mala.bc.ca/"],
    name: "Malaspina University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mala.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.mcgill.ca/"],
    name: "McGill University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mcgill.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.mcmaster.ca/"],
    name: "McMaster University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mcmaster.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.msvu.ca/"],
    name: "Mount Saint Vincent University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["msvu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.mta.ca/"],
    name: "Mount Allison University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mta.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.mtroyal.ca/"],
    name: "Mount Royal University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mtroyal.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nait.ca/"],
    name: "Northern Alberta Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nait.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nic.bc.ca/"],
    name: "North Island College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nic.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nipissingu.ca/"],
    name: "Nipissing University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nipissingu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nlc.bc.ca/"],
    name: "Northern Lights College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nlc.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nsac.ns.ca/"],
    name: "Nova Scotia Agricultural College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nsac.ns.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nscad.ns.ca/"],
    name: "Nova Scotia College of Art and Design",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nscad.ns.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.nvit.bc.ca/"],
    name: "Nicola Valley Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["nvit.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ocad.ca/"],
    name: "Ontario College of Art and Design",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ocad.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.okanagan.bc.ca/"],
    name: "Okanagan University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["okanagan.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.op.org/canada/college.htm"],
    name: "Dominican College of Philosophy and Theology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["op.org"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.picollege.ca/"],
    name: "Pacific International College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["picollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.polymtl.ca/"],
    name: "École Polytechnique de Montréal, Université de Montréal",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["polymtl.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.queensu.ca/"],
    name: "Queen's University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["queensu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.questu.ca/"],
    name: "Quest University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["questu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.redeemer.ca/"],
    name: "Redeemer College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["redeemer.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.regent-college.edu/"],
    name: "Regent College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["regent-college.edu"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.rmc.ca/"],
    name: "Royal Military College of Canada",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["rmc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.royalroads.ca/"],
    name: "Royal Roads University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["royalroads.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ryerson.ca/"],
    name: "Ryerson Polytechnic University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ryerson.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.sait.ca/"],
    name: "Southern Alberta Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["sait.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.saskweb.com/luthercollege/"],
    name: "Luther College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["saskweb.com"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.sauder.ubc.ca/"],
    name: "Sauder School of Business",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["sauder.ubc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.scar.utoronto.ca/"],
    name: "University of Toronto, Scarborough",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["scar.utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.selkirk.bc.ca/"],
    name: "Selkirk College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["selkirk.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.senecacollege.ca/"],
    name: "Seneca College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["senecacollege.ca", "myseneca.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.sfu.ca/"],
    name: "Simon Fraser University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["sfu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.sheridancollege.ca/"],
    name: "Sheridan College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["sheridancollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.sifc.edu/"],
    name: "Saskatchewan Indian Federated College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["sifc.edu"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.stclairc.on.ca/"],
    name: "St. Clair College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["stclairc.on.ca", "stclairconnect.ca", "myscc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.stfx.ca/"],
    name: "St. Francis Xavier University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["stfx.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.stmarys.ca/", "https://smu.ca/"],
    name: "St. Mary's University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["stmarys.ca", "smu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.stthomasu.ca/"],
    name: "St. Thomas University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["stthomasu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.teluq.uquebec.ca/"],
    name: "Télé-université, Université du Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["teluq.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.trentu.ca/"],
    name: "Trent University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["trentu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.trinity.utoronto.ca/"],
    name: "University of Trinity College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["trinity.utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.tru.ca/"],
    name: "Thompson Rivers University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["tru.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.twu.ca/"],
    name: "Trinity Western University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["twu.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ualberta.ca/"],
    name: "University of Alberta",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ualberta.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ubc.ca/"],
    name: "University of British Columbia",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ubc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ubishops.ca/"],
    name: "Bishop's University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ubishops.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ucalgary.ca/"],
    name: "University of Calgary",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ucalgary.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uccb.ns.ca/"],
    name: "University College of Cape Breton",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uccb.ns.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ucfv.bc.ca/"],
    name: "University College of the Fraser Valley",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ucfv.bc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ucs.mun.ca/"],
    name: "Memorial University of Newfoundland",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ucs.mun.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ukings.ns.ca/"],
    name: "University of King's College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ukings.ns.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ulaval.ca/"],
    name: "Université Laval",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ulaval.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uleth.ca/"],
    name: "University of Lethbridge",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uleth.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.umanitoba.ca/"],
    name: "University of Manitoba",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["umanitoba.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.umoncton.ca/"],
    name: "University of Moncton",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["umoncton.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.umontreal.ca/"],
    name: "Université de Montréal",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["umontreal.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.unb.ca/"],
    name: "University of New Brunswick",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["unb.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.unbc.ca/"],
    name: "University of Northern British Columbia",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["unbc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.unbsj.ca/"],
    name: "University of New Brunswick, Saint John",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["unbsj.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.universitycanadawest.ca/"],
    name: "University Canada West",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["universitycanadawest.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uoguelph.ca/"],
    name: "University of Guelph",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uoguelph.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uoit.ca/"],
    name: "University of Ontario Institute of Technology",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uoit.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uottawa.ca/"],
    name: "University of Ottawa",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uottawa.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.upei.ca/"],
    name: "University of Prince Edward Island",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["upei.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqac.ca/"],
    name: "Université du Québec à Chicoutimi",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqac.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqam.ca/"],
    name: "Université du Québec à Montréal",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqam.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqar.uquebec.ca/"],
    name: "Université du Québec à Rimouski",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqar.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqat.uquebec.ca/"],
    name: "Université du Québec en Abitibi-Témiscamingue",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqat.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqo.ca/"],
    name: "Université du Québec en Outaouais",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uqtr.uquebec.ca/"],
    name: "Université du Québec à Trois-Rivières",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uqtr.uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uquebec.ca/"],
    name: "University of Québec",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uquebec.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uregina.ca/campion/"],
    name: "Campion College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uregina.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uregina.ca/"],
    name: "University of Regina",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uregina.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.usask.ca/"],
    name: "University of Saskatchewan",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["usask.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.usherb.ca/"],
    name: "Université de Sherbrooke",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["usherb.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.usjc.uwaterloo.ca/"],
    name: "University of St. Jerome's College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["usjc.uwaterloo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ustanne.ednet.ns.ca/"],
    name: "St. Anne University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ustanne.ednet.ns.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ustboniface.mb.ca/"],
    name: "University College of Saint-Boniface",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ustboniface.mb.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.ustpaul.ca/"],
    name: "St. Paul University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ustpaul.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.usudbury.com/"],
    name: "University of Sudbury",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["usudbury.com"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.utm.utoronto.ca/"],
    name: "University of Toronto, Mississauga",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["utm.utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.utoronto.ca/stmikes/"],
    name: "University of St. Michael's College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.utoronto.ca/"],
    name: "University of Toronto",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uvic.ca/"],
    name: "University of Victoria",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uvic.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uwaterloo.ca/"],
    name: "University of Waterloo",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwaterloo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uwindsor.ca/"],
    name: "University of Windsor",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwindsor.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uwinnipeg.ca/"],
    name: "University of Winnipeg",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwinnipeg.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://brescia.uwo.ca/"],
    name: "Brescia University College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uwo.ca/kings/"],
    name: "King's College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.uwo.ca/"],
    name: "University of Western Ontario",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["uwo.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.vcc.ca/"],
    name: "Vancouver Community College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["vcc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://vicu.utoronto.ca/"],
    name: "Victoria University Toronto, University of Toronto",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["vicu.utoronto.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.wlu.ca/"],
    name: "Wilfrid Laurier University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["wlu.ca", "mylaurier.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.yorku.ca/"],
    name: "York University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["yorku.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.yukoncollege.yk.ca/"],
    name: "Yukon College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["yukoncollege.yk.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://cv.unipiaget.org/"],
    name: "Universidade Jean Piaget de Cabo Verde",
    alpha_two_code: "CV",
    "state-province": null,
    domains: ["cv.unipiaget.org"],
    country: "Cape Verde",
  },
  {
    web_pages: ["http://www.icci.edu.ky/"],
    name: "International College of the Cayman Islands",
    alpha_two_code: "KY",
    "state-province": null,
    domains: ["icci.edu.ky"],
    country: "Cayman Islands",
  },
  {
    web_pages: ["http://www.stmatthews.edu/"],
    name: "St. Matthews University",
    alpha_two_code: "KY",
    "state-province": null,
    domains: ["stmatthews.edu"],
    country: "Cayman Islands",
  },
  {
    web_pages: ["http://www.univ-bangui.net/"],
    name: "Université de Bangui",
    alpha_two_code: "CF",
    "state-province": null,
    domains: ["univ-bangui.net"],
    country: "Central African Republic",
  },
  {
    web_pages: ["http://www.univ-ndjamena.org/"],
    name: "Université de N'Djamena",
    alpha_two_code: "TD",
    "state-province": null,
    domains: ["univ-ndjamena.org"],
    country: "Chad",
  },
  {
    web_pages: ["http://www.academia.cl/"],
    name: "Universidad Academia de Humanismo Cristiano",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["academia.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.arquitecturaucv.cl/"],
    name: "Escuela de Arquitectura y Diseño",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["arquitecturaucv.cl"],
    country: "Chile",
  },
  {
    web_pages: ["https://www.uc.cl/"],
    name: "Pontificia Universidad Catolica de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uc.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uach.cl/"],
    name: "Universidad Austral de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uach.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uaconcagua.cl/"],
    name: "Universidad de Aconcagua",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uaconcagua.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uahurtado.cl/"],
    name: "Universidad Alberto Hurtado",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uahurtado.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uai.cl/"],
    name: "Universidad Adolfo Ibáñez",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uai.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uai.cl/"],
    name: 'Universidad "Adolfo Ibañez"',
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uai.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uamericas.cl/"],
    name: "Universidad de Las Américas",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uamericas.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uandes.cl/"],
    name: "Universidad de Los Andes",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uandes.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uantof.cl/"],
    name: "Universidad de Antofagasta",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uantof.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uas.cl/"],
    name: "Universidad Autonoma del Sur",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uas.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ubiobio.cl/"],
    name: "Universidad del Bío-Bío",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ubiobio.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ubohiggins.cl/"],
    name: "Universidad Bernardo O'Higgins",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ubohiggins.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ubolivariana.cl/"],
    name: "Universidad Bolivariana",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ubolivariana.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ubritanica.cl/"],
    name: "Universidad Chileno Britanica de Cultura",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ubritanica.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucentral.cl/"],
    name: "Universidad Central",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucentral.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucervantes.cl/"],
    name: "Universidad Miguel de Cervantes",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucervantes.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uchile.cl/"],
    name: "Universidad de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uchile.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucinf.cl/"],
    name: "Universidad de Ciencias de la Informatica",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucinf.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucm.cl/"],
    name: "Universidad Catolica del Maule",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucm.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucn.cl/"],
    name: "Universidad Catolica del Norte",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucn.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucsc.cl/"],
    name: "Universidad Catolica de La Santísima Concepción",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucsc.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucsh.cl/"],
    name: "Universidad Católica Cardenal Raúl Silva Henríquez",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucsh.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uctem.cl/"],
    name: "Universidad Catolica de Temuco",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uctem.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ucv.cl/"],
    name: "Universidad Catolica de Valparaiso",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ucv.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uda.cl/"],
    name: "Universidad de Atacama",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uda.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.udec.cl/"],
    name: "Universidad de Concepcion",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["udec.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.udelmar.cl/"],
    name: "Universidad del Mar",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["udelmar.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.udesarrollo.cl/"],
    name: "Universidad del Desarrollo",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["udesarrollo.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.udp.cl/"],
    name: "Universidad Diego Portales",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["udp.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ufinis.cl/"],
    name: "Universidad Finis Terrae",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ufinis.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ufro.cl/"],
    name: "Universidad de La Frontera",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ufro.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ugm.cl/"],
    name: "Universidad Gabriela Mistral",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ugm.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uisek.cl/"],
    name: "Universidad International SEK, Santiago",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uisek.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ujso.cl/"],
    name: "Universidad José Santos Ossa",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ujso.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ulagos.cl/"],
    name: "Universidad de Los Lagos",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ulagos.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ulare.cl/"],
    name: "Universidad La Republica",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ulare.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.umag.cl/"],
    name: "Universidad de Magallanes",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["umag.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.umaritima.cl/"],
    name: "Universidad Maritima de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["umaritima.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.umayor.cl/"],
    name: "Universidad Mayor",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["umayor.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.umce.cl/"],
    name: "Universidad Metropolitana de Ciencias de la Educación",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["umce.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ume.cl/"],
    name: "Universidad Mariano Egaña",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ume.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.unab.cl/"],
    name: "Universidad Nacional Andrés Bello",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["unab.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.unachile.cl/"],
    name: "Universidad Adventista de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["unachile.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.unap.cl/"],
    name: 'Universidad "Arturo Prat"',
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["unap.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.unfa.cl/"],
    name: "Universidad Francisco de Aguirre",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["unfa.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uniacc.cl/"],
    name: "Universidad de Artes, Ciencias y Comunicación",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uniacc.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.unicit.cl/"],
    name: "Universidad Iberoamericana de Ciencias y Tecnologia",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["unicit.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.universidadarcis.cl/"],
    name: "Universidad Arcis",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["universidadarcis.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.upacifico.cl/"],
    name: "Universidad del Pacífico",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["upacifico.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.upa.cl/"],
    name: "Universidad de Playa Ancha de Ciencias de la Educacion",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["upa.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.usach.cl/"],
    name: "Universidad de Santiago de Chile",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["usach.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.usanandres.cl/"],
    name: "Universidad de San Andres",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["usanandres.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.userena.cl/"],
    name: "Universidad de La Serena",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["userena.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uss.cl/"],
    name: "Universidad San Sebastian",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uss.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ust.cl/"],
    name: "Universidad Santo Tomás",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["ust.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uta.cl/"],
    name: "Universidad de Tarapacá",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uta.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.utalca.cl/"],
    name: "Universidad de Talca",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["utalca.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.utem.cl/"],
    name: "Universidad Tecnológica Metropolitana",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["utem.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.utfsm.cl/"],
    name: 'Universidad Técnica "Federico Santa María"',
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["utfsm.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uv.cl/"],
    name: "Universidad de Valparaiso",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uv.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uvipro.cl/"],
    name: 'Universidad Tecnologica "Vicente Perez Rosales"',
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uvipro.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.uvm.cl/"],
    name: "Universidad de Viña del Mar",
    alpha_two_code: "CL",
    "state-province": null,
    domains: ["uvm.cl"],
    country: "Chile",
  },
  {
    web_pages: ["http://www.ahmu.edu.cn/"],
    name: "Anhui Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ahmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ahnu.edu.cn/"],
    name: "Anhui Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ahnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ahsdxy.ah.edu.cn/"],
    name: "Anhui Technical College of Water Resources and Hydroelectric Power",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ahsdxy.ah.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ahtcm.edu.cn/"],
    name: "Anhui University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ahtcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ahu.edu.cn/"],
    name: "Anhui University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ahu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.aufe.edu.cn/"],
    name: "Anhui University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["aufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bac.edu.cn/"],
    name: "Beijing University of Agriculture",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bac.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bfsu.edu.cn/"],
    name: "Beijing Foreign Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bfsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bhu.edu.cn/"],
    name: "Bohai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bisu.edu.cn/"],
    name: "Beijing International Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bisu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bit.edu.cn/"],
    name: "Beijing Institute of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bit.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.biti.edu.cn/"],
    name: "Beijing Information Science and Technology University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["biti.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["https://www.bjtu.edu.cn"],
    name: "Beijing Jiaotong University",
    alpha_two_code: "CN",
    "state-province": "Beijing",
    domains: ["bjtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjaeu.edu.cn/"],
    name: "China Agriculture University East",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjaeu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjfu.edu.cn/"],
    name: "Beijing Forestry University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjfu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjmu.edu.cn/"],
    name: "Beijing Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjpeu.edu.cn/"],
    name: "Beijing Petroleum University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjpeu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjpu.edu.cn/"],
    name: "Beijing Polytechnic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bjucmp.edu.cn/"],
    name: "Beijing University of Chinese Medicine and Pharmacology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bjucmp.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.blcu.edu.cn/"],
    name: "Beijing Language and Culture University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["blcu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bnu.edu.cn/"],
    name: "Beijing Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bsu.edu.cn/"],
    name: "Beijing Sport University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.buaa.edu.cn/"],
    name: "Beijing University of Aeronautics and Astronautics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["buaa.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.buct.edu.cn/"],
    name: "Beijing University of Chemical Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["buct.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.bupt.edu.cn/"],
    name: "Beijing University of Posts and Telecommunications",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["bupt.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cafa.edu.cn/"],
    name: "Central Academy of  Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cafa.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cauc.edu/"],
    name: "Civil Aviation University of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cauc.edu"],
    country: "China",
  },
  {
    web_pages: ["http://www.cau.edu.cn/"],
    name: "China Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ccnu.edu.cn/"],
    name: "Central China Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ccnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ccut.edu.cn/"],
    name: "Changchun University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ccut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cdu.edu.cn/"],
    name: "Chengdu University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cdu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cdutcm.edu.cn/"],
    name: "Chengdu University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cdutcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cdut.edu.cn/"],
    name: "Chengdu University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cdut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cfau.edu.cn/"],
    name: "China Foreign Affairs University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cfau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.chinaacademyofart.com/"],
    name: "China Academy of Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["chinaacademyofart.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.cisisu.edu.cn/"],
    name: "Chengdu Institute of Sichuan International Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cisisu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cmu.edu.cn/"],
    name: "China Medical University Shenyang",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cncnc.edu.cn/"],
    name: "Changchun Teachers College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cncnc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cnu.edu.cn/"],
    name: "Capital Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cppsu.edu.cn/"],
    name: "Chinese People's Public Security University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cppsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cpu.edu.cn/"],
    name: "China Pharmaceutical University Nanjing",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cpums.edu.cn/"],
    name: "Capital University of Medical Sciences",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cpums.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqec.net.cn/"],
    name: "Chongqing Education College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqec.net.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqgyzy.com/"],
    name: "Chongqing Vocational College of Public Transportation",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqgyzy.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqmu.edu.cn/"],
    name: "Chongqing Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqnu.edu.cn/"],
    name: "Chongqing Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqtcedu.com/"],
    name: "Chongqing Telecommunication College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqtcedu.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.cquc.edu.cn/"],
    name: "Chongqing University of Communications",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cquc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqu.edu.cn/"],
    name: "Chongqing University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqupt.edu.cn/"],
    name: "Chongqing University of Post and Telecommunications",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqupt.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqust.cn/"],
    name: "Chongqing University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqust.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqut.edu.cn/"],
    name: "Chongqing University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cqwu.net/"],
    name: "Chongqing Wenli University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cqwu.net"],
    country: "China",
  },
  {
    web_pages: ["http://www.crtvu.edu.cn/"],
    name: "Central Radio and TV University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["crtvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.csfu.edu.cn/"],
    name: "Central South Forestry University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["csfu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.csru.edu.cn/"],
    name: "Changsha Railway University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["csru.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.csu.edu.cn/"],
    name: "Central South University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["csu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.csuep.edu.cn/"],
    name: "Changsha University of Electric Power",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["csuep.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ctbu.edu.cn/"],
    name: "Chongqing Technology and Business University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ctbu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ctgu.edu.cn/"],
    name: "China Three Gorges University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ctgu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cubu.edu/"],
    name: "China USA Business University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cubu.edu"],
    country: "China",
  },
  {
    web_pages: ["http://www.cuc.edu.cn/"],
    name: "Communication University of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cuc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cueb.edu.cn/"],
    name: "Capital University of Economics and Business",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cueb.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cufe.edu.cn/"],
    name: "Central University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cugb.edu.cn/"],
    name: "China University of Geoscience Beijing",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cugb.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cug.edu.cn/"],
    name: "China University of Geosciences Wuhan",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cug.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cumtb.edu.cn/"],
    name: "China University of Mining Technology - Beijing",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cumtb.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cumt.edu.cn/"],
    name: "China University of Mining Technology - Xuzhou",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cumt.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cun.edu.cn/"],
    name: "Central University for Nationalities",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cun.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cupl.edu.cn/"],
    name: "China University of Political Science and Law",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cupl.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.cyc.edu.cn/"],
    name: "China youth college for political science",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["cyc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dhu.edu.cn/"],
    name: "Donghua University, Shanghai",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dlmedu.edu.cn/"],
    name: "Dalian Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dlmedu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dlmu.edu.cn/"],
    name: "Dalian Martime University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dlmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dlu.edu.cn/"],
    name: "Dalian University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dlu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dlufl.edu.cn/"],
    name: "Dalian University of Foreign Language",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dlufl.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dlut.edu.cn/"],
    name: "Dalian University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dlut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.dufe.edu.cn/"],
    name: "Dongbei University of Finance And Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["dufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ecjtu.jx.cn/"],
    name: "East China Jiao Tong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ecjtu.jx.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ecnu.edu.cn/"],
    name: "East China Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ecnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ecust.edu.cn/"],
    name: "East China University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ecust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.emsfj.com/"],
    name: "Emeishan Buddhist College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["emsfj.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.fimmu.edu.cn/"],
    name: "Southern Medial University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fimmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fjau.edu.cn/"],
    name: "Fujian Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fjau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fjmu.edu.cn/"],
    name: "Fujian Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fjmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fjnu.edu.cn/"],
    name: "Fujian Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fjnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fjtcm.edu.cn/"],
    name: "Fujian University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fjtcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fmmu.edu.cn/"],
    name: "4th Military Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fmmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fosu.edu.cn/"],
    name: "Foshan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fosu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fspu.edu.cn/"],
    name: "Fushun Petroleum University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fspu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fudan.edu.cn/"],
    name: "Fudan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fudan.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.fzu.edu.cn/"],
    name: "Fuzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["fzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gdin.edu.cn/"],
    name: "Guangdong Polytechnic Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gdin.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gdrtvu.edu.cn/"],
    name: "Guangdong Radio & TV University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gdrtvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gdufs.edu.cn/"],
    name: "Guangdong University of Foreign Studies",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gdufs.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gdut.edu.cn/"],
    name: "Guangdong University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gdut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gsau.edu.cn/"],
    name: "Gansu Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gsau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gsut.edu.cn/"],
    name: "Gansu University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gsut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.guangztc.edu.cn/"],
    name: "Guangzhou Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["guangztc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gxmu.edu.cn/"],
    name: "Guangxi Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gxmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gxnu.edu.cn/"],
    name: "Guangxi Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gxnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gxtcmu.edu.cn/"],
    name: "Guangxi Traditional Chinese Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gxtcmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gxu.edu.cn/"],
    name: "Guangxi University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gxu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gxun.edu.cn/"],
    name: "Guangxi University for Nationalities",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gxun.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gzarts.edu.cn/"],
    name: "Guangzhou Academy of Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gzarts.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gzhtcm.edu.cn/"],
    name: "Guangzhou University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gzhtcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gzhu.edu.cn/"],
    name: "Guangzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gzhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gznu.edu.cn/"],
    name: "Guizhou Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gznu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gzsums.edu.cn/"],
    name: "Sun Yat-Sen University of Medical Sciences",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gzsums.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.gzu.edu.cn/"],
    name: "Guizhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["gzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hainnu.edu.cn/"],
    name: "Hainan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hainnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hainu.edu.cn/"],
    name: "Hainan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hainu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hbafa.com/"],
    name: "Hebei Academy of Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hbafa.com"],
    country: "China",
  },
  {
    web_pages: ["https://www.hbu.edu/"],
    name: "Houston Baptist University",
    alpha_two_code: "US",
    "state-province": "TX",
    domains: ["hbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hbu.edu.cn/"],
    name: "Hebei University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hbu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hdpu.edu.cn/"],
    name: "University of Petroleum (East China)",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hdpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebau.edu.cn/"],
    name: "Hebei Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebeiuniteduniversity.com/"],
    name: "Hebei United University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebeiuniteduniversity.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebmu.edu.cn/"],
    name: "Hebei Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebnu.edu.cn/"],
    name: "Hebei Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebust.edu.cn/"],
    name: "Hebei University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hebut.edu.cn/"],
    name: "Hebei University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hebut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.henannu.edu.cn/"],
    name: "Henan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["henannu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.henau.edu.cn/"],
    name: "Henan Agriculture University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["henau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.henu.edu.cn/"],
    name: "Henan Univeristy",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["henu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.heuet.edu.cn/"],
    name: "Hebei University of Economics and Trade",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["heuet.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hfut.edu.cn/"],
    name: "Hefei University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hfut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhit.edu.cn/"],
    name: "Huaihai Institute of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhit.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhrtu.com/"],
    name: "Huaihua Radio and Television University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhrtu.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhstu.edu.cn/"],
    name: "Huanghe Science & Technology University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhstu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhuc.edu.cn/"],
    name: "Hohai University Changzhou",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhuc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhu.edu.cn/"],
    name: "Hehai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hhu.edu.cn/"],
    name: "Huaihua University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hit.edu.cn/"],
    name: "Harbin Institute of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hit.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hlaflru.edu.cn/"],
    name: "Heilongjiang August 1st Reclamation University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hlaflru.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hljcu.edu.cn/"],
    name: "Heilongjiang Commercial University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hljcu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hlju.edu.cn/"],
    name: "Heilongjiang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hlju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hnfjxy.cn/"],
    name: "Henan Buddhist College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hnfjxy.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hqgc.net/"],
    name: "Logistics Engineering University of PLA",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hqgc.net"],
    country: "China",
  },
  {
    web_pages: ["http://www.hqu.edu.cn/"],
    name: "Huaqiao University Quanzhuo",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hqu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hrbeu.edu.cn/"],
    name: "Harbin Engineering University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hrbeu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hrbmu.edu.cn/"],
    name: "Harbin Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hrbmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hrbnu.edu.cn/"],
    name: "Harbin Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hrbnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hrbucea.edu.cn/"],
    name: "Harbin University of Civil Engineering & Architecture",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hrbucea.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hrbust.edu.cn/"],
    name: "Harbin University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hrbust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hubu.edu.cn/"],
    name: "Hubei University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hubu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hunau.net/"],
    name: "Hunan Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hunau.net"],
    country: "China",
  },
  {
    web_pages: ["http://www.hunnu.edu.cn/"],
    name: "Hunan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hunnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hunu.edu.cn/"],
    name: "Hunan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hunu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hust.edu.cn/"],
    name: "Huazhong University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hzau.edu.cn/"],
    name: "Huazhong Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hzau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.hzu.edu.cn/"],
    name: "Huizhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["hzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ibub.edu.cn/"],
    name: "International Business University of Beijing",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ibub.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.imau.edu.cn/"],
    name: "Inner Mongolia Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["imau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.imnu.edu.cn/"],
    name: "Inner Mongolia Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["imnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.impu.edu.cn/"],
    name: "Inner Mongolia Polytechnic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["impu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.imu.edu.cn/"],
    name: "Inner Mongolia University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["imu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ipdbuu.com.cn/"],
    name: "Beijing Union University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ipdbuu.com.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jci.edu.cn/"],
    name: "Jingdezhen China Institute",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jci.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jlau.edu.cn/"],
    name: "Jilin Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jlau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jlu.edu.cn/"],
    name: "Jilin University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jlu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jmu.edu.cn/"],
    name: "Jimei University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jnu.edu.cn/"],
    name: "Jinan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jsu.edu.cn/"],
    name: "Jishou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jsust.edu.cn/"],
    name: "Jiangsu University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jsust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jutcm.com/"],
    name: "Jiangxi University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jutcm.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.jut.edu.cn/"],
    name: "Jilin University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jxau.edu.cn/"],
    name: "Jiangxi Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jxau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jxnu.edu.cn/"],
    name: "Jiangxi Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jxnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jxufe.edu.cn/"],
    name: "Jiangxi University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jxufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.jyu.edu.cn/"],
    name: "Jiaying University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["jyu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.kmust.edu.cn/"],
    name: "Kunmimg University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["kmust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lctu.edu.cn/"],
    name: "Liaocheng Teachers University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lctu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lidapoly.com/"],
    name: "Shanghai Lida Polytechnic Institute",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lidapoly.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.lixin.edu.cn/"],
    name: "Shanghai Lixin University of Commerce",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lixin.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lnnu.edu.cn/"],
    name: "Liaoning Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lnnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lntu.edu.cn/"],
    name: "Liaoning Technical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lntu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lnu.edu.cn/"],
    name: "Liaoning University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lumei.edu.cn/"],
    name: "Luxun Academy of Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lumei.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lzmc.edu.cn/"],
    name: "Luzhou Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lzmc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.lzu.edu.cn/"],
    name: "Lanzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["lzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nbu.edu.cn/"],
    name: "Ningbo University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nbu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nbut.edu.cn/"],
    name: "Ningbo University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nbut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ncepubj.edu.cn/"],
    name: "North China Electric Power University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ncepubj.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ncu.edu.cn/"],
    name: "Nanchang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ncu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ncut.edu.cn/"],
    name: "North China University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ncut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.neau.edu.cn/"],
    name: "Northeast Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["neau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nefu.edu.cn/"],
    name: "Northeast Forest University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nefu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.neijtc.edu.cn/"],
    name: "Neijiang Teacher University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["neijtc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nenu.edu.cn/"],
    name: "Northeast Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nenu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.neu.edu.cn/"],
    name: "Northeastern University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["neu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.neuq.edu.cn/"],
    name: "Northeast University at Qinhuangdao Campus",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["neuq.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.newasia.bj.edu.cn/"],
    name: "Beijing New Asia University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["newasia.bj.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njau.edu.cn/"],
    name: "Nanjing Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njfu.edu.cn/"],
    name: "Nanjing Forestry University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njfu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njim.edu.cn/"],
    name: "Nanjing Institute of Meteorology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njim.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njmu.edu.cn/"],
    name: "Nanjing Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njnu.edu.cn/"],
    name: "Nanjing Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njtu.edu.cn/"],
    name: "Northern Jiaotong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njuct.edu.cn/"],
    name: "Nanjing University of Chemical Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njuct.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nju.edu.cn/"],
    name: "Nanjing University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njue.edu.cn/"],
    name: "Nanjing University of Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njue.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njupt.edu.cn/"],
    name: "Nanjing University of Posts and Telecommunications",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njupt.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njust.edu.cn/"],
    name: "Nanjing University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njutcm.edu.cn/"],
    name: "Nanjing University of Traditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njutcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.njuts.cn/"],
    name: "Nanjing Union Theological Seminary",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["njuts.cn"],
    country: "China",
  },
  {
    web_pages: ["http://nku.nankai.edu.cn/"],
    name: "Nankai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nku.nankai.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nottingham.edu.cn/"],
    name: "The University of Nottingham Ningbo China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nottingham.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nsmc.edu.cn/"],
    name: "Northern Sichuan Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nsmc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nuaa.edu.cn/"],
    name: "Nanjing University of Aeronautics and Astronautics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nuaa.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nudt.edu.cn/"],
    name: "National University of Defense Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nudt.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nwau.edu.cn/"],
    name: "Northwest A&F University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nwau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nwnu.edu.cn/"],
    name: "Northwest Normal University Lanzhou",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nwnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nwpu.edu.cn/"],
    name: "Northwest Polytechnical University Xi'an",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nwpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nwu.edu.cn/"],
    name: "Northwest University Xi'an",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nwu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nxmc.edu.cn/"],
    name: "Ningxia Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nxmc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.nxu.edu.cn/"],
    name: "Ningxia University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["nxu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ouc.edu.cn/"],
    name: "Ocean University of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ouc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.peizheng.com.cn/"],
    name: "Guangdong Peizheng College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["peizheng.com.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.pku.edu.cn/"],
    name: "Peking University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["pku.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.pzhu.edu.cn/"],
    name: "Panzhihua University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["pzhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qdu.edu.cn/"],
    name: "Qingdao University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qdu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qfnu.edu.cn/"],
    name: "Qufu Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qfnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qhnu.edu.cn/"],
    name: "Qinghai Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qhnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qhrtvu.edu.cn/"],
    name: "Qinghai Radio & Television University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qhrtvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qhu.edu.cn/"],
    name: "Qinghai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qust.edu.cn/"],
    name: "Qingdao University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.qzu.edu.cn/"],
    name: "Qiongzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["qzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ruc.edu.cn/"],
    name: "Renmin University of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ruc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sandau.edu.cn/"],
    name: "Shanghai Sanda University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sandau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sanxiau.edu.cn/"],
    name: "Chongqing Three Gorges University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sanxiau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sbs.edu.cn/"],
    name: "Shanghai Business School",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sbs.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.scau.edu.cn/"],
    name: "South China Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["scau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sccu.edu.cn/"],
    name: "South China Construction University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sccu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.scnu.edu.cn/"],
    name: "South China Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["scnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.scu.edu.cn/"],
    name: "Sichuan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["scu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.scut.edu.cn/"],
    name: "South China University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["scut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdada.edu.cn/"],
    name: "Shandong University of Art and Design",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdada.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdau.edu.cn/"],
    name: "Shandong Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdie.edu.cn/"],
    name: "Shandong Economic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdie.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdju.edu.cn/"],
    name: "Shanghai Dainji University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdmu.edu.cn/"],
    name: "Shandong Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdnu.edu.cn/"],
    name: "Shandong Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdu.edu.cn/"],
    name: "Shandong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdust.edu.cn/"],
    name: "Shandong University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdutcm.edu.cn/"],
    name: "Shandong University of Triaditional Chinese Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdutcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdut.edu.cn/"],
    name: "Shandong University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sdufe.edu.cn/"],
    name: "Shandong University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sdufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.seu.edu.cn/"],
    name: "Southeast University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["seu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sgu.edu.cn/"],
    name: "Shaoguan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sgu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://shanghai_edu.customs.gov.cn/"],
    name: "Shanghai Customs College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shanghai_edu.customs.gov.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shfu.edu.cn/"],
    name: "Shanghai Fisheries University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shfu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shift.edu.cn/"],
    name: "Shanghai Institue of Foreign Trade",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shift.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shisu.edu.cn/"],
    name: "Shanghai International Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shisu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shmtu.edu.cn/"],
    name: "Shanghai Maritime University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shmtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shmu.edu.cn/"],
    name: "Shanghai Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shouhua.net.cn/"],
    name: "Shanghai Ouhua Vocational Technical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shouhua.net.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sh-sipopolytechnic.com/"],
    name: "Shanghai Sipo Polytechnic",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sh-sipopolytechnic.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.shsmu.edu.cn/"],
    name: "Shanghai Second Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shsmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shspu.edu.cn/"],
    name: "Shanghai Second Polytechnic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shspu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shtdu.edu.cn/"],
    name: "Shanghai TieDao University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shtdu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shtu.edu.cn/"],
    name: "Shanghai Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shtvu.edu.cn/"],
    name: "Shanghai Television University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shtvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shu.edu.cn/"],
    name: "Shanghai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shufe.edu.cn/"],
    name: "Shanghai University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shutcm.edu.cn/"],
    name: "Shanghai University of Traditional Chinese Medicine and Pharmacology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shutcm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.shzu.edu.cn/"],
    name: "Shihezi University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["shzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sicau.edu.cn/"],
    name: "Sichuan Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sicau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sicnu.edu.cn/"],
    name: "Sichuan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sicnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sisu.edu.cn/"],
    name: "Sichuan International Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sisu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sjtu.edu.cn/"],
    name: "Shanghai Jiaotong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sjtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sjzu.edu.cn/"],
    name: "Shenyang Jianzhu University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sjzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.smmu.edu.cn/"],
    name: "2nd Military Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["smmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.snnu.edu.cn/"],
    name: "Shaanxi Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["snnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.snnu.edu.cn/"],
    name: "Shanxi Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["snnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.stu.edu.cn/"],
    name: "Shantou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["stu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.suda.edu.cn/"],
    name: "Suzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["suda.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sues.edu.cn/"],
    name: "Shanghai University of Engineering Science",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sues.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sustc.edu.cn/"],
    name: "South University of Science and Technology of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sustc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swau.edu.cn/"],
    name: "Southwest Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swfc.edu.cn/"],
    name: "Southwest Forestry University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swfc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swjtu.edu.cn/"],
    name: "Southwest Jiaotong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swjtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swnu.edu.cn/"],
    name: "Southwest University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swpu.edu.cn/"],
    name: "Southwest Petroleum University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swsm.cn/"],
    name: "Chongqing Normal University Foreign Trade and Business College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swsm.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swufe.edu.cn/"],
    name: "Southwest University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swun.edu.cn/"],
    name: "Southwest University of Nationalities",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swun.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swupl.edu.cn/"],
    name: "Southwest University of Political Science and Law",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swupl.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swust.edu.cn/"],
    name: "Southwest University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.swuyc.edu.cn/"],
    name: "South West University Yucai College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["swuyc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sxau.edu.cn/"],
    name: "Shanxi Agricultural University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sxau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sxu.edu.cn/"],
    name: "Shanxi University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sxu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.syict.edu.cn/"],
    name: "Shenyang Institute of Chemical Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["syict.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.syphu.edu.cn/"],
    name: "Shenyang Pharmaceutical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["syphu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sypu.edu.cn/"],
    name: "Shenyang Polytechnic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sypu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.sytu.edu.cn/"],
    name: "Southern Yangtze University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["sytu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.syu.edu.cn/"],
    name: "Shenyang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["syu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.szu.edu.cn/"],
    name: "Shenzhen University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["szu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tijmu.edu.cn/"],
    name: "Tianjin Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tijmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjarts.edu.cn/"],
    name: "Tianjin Academy of Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjarts.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjcu.edu.cn/"],
    name: "Tianjin University of Commerce",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjcu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjmu.edu.cn/"],
    name: "Tongji Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjnu.edu.cn/"],
    name: "Tianjin Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjpu.edu.cn/"],
    name: "Tianjin Polytechnic University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjpu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjrtvu.edu.cn/"],
    name: "Tianjin Open University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjrtvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tju.edu.cn/"],
    name: "Tianjin University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjufe.edu.cn/"],
    name: "Tianjin University of Finance & Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tjut.edu.cn/"],
    name: "Tianjin University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tjut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tmmu.edu.cn/"],
    name: "3rd Military Medical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tmmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tongji.edu.cn/"],
    name: "Tongji University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tongji.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tsinghua.edu.cn/"],
    name: "Tsinghua University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tsinghua.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ttmc.edu.cn/"],
    name: "Tibet Tibetan Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ttmc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tyut.edu.cn/"],
    name: "Taiyuan University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tyut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.tzc.edu.cn/"],
    name: "Taizhou College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["tzc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.uestc.edu.cn/"],
    name: "University of Electronic Science and Technology of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["uestc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.uheeyc.edu.cn/"],
    name: "University of Hydraulic Electric Engineering",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["uheeyc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.uibe.edu.cn/"],
    name: "University of International Business and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["uibe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ujn.edu.cn/"],
    name: "University of Jinan",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ujn.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.umcollege.com/"],
    name: "Shanghai City College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["umcollege.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.usc.edu.cn/"],
    name: "South China University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["usc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.usst.edu.cn/"],
    name: "Shanghai University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["usst.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ustb.edu.cn/"],
    name: "Beijing University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ustb.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ustb.edu.cn/"],
    name: "University of Science and Technology Beijing",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ustb.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ustc.edu.cn/"],
    name: "University of Science and Technology of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ustc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.utibet.edu.cn/"],
    name: "Tibet University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["utibet.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.uvu.edu.cn/"],
    name: "Urumqi Vocational University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["uvu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wcums.edu.cn/"],
    name: "West China University of Medical Sciences",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wcums.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wdsdjxy.com/"],
    name: "Wudanshan Taoist College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wdsdjxy.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.whapu.edu.cn/"],
    name: "Wuhan Automobile Polytechnical University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["whapu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.whtu.edu.cn/"],
    name: "Wuhan Transportation University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["whtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.whu.edu.cn/"],
    name: "Wuhan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["whu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.whut.edu.cn/"],
    name: "Wuhan University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["whut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://wsm.whu.edu.cn/"],
    name: "Wuhan University School of Medicine",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wsm.whu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wtusm.edu.cn/"],
    name: "Wuhan Technical University of Surveying and Mapping",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wtusm.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wuhee.edu.cn/"],
    name: "Wuhan University of Hydraulic and Electric Engineering",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wuhee.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wxuli.edu.cn/"],
    name: "Wuxi University of Light Industry",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wxuli.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wyu.edu.cn/"],
    name: "Wuyi University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wyu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.wzmu.net/"],
    name: "Wenzhou Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wzmu.net"],
    country: "China",
  },
  {
    web_pages: ["http://www.wzu.edu.cn/"],
    name: "Wenzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["wzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xafa.edu.cn/"],
    name: "Xi'an Academy of Fine Art",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xafa.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xahu.edu.cn/"],
    name: "Xi'an Highway University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xahu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xauat.edu.cn/"],
    name: "Xi'an University of Architecture and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xauat.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xaut.edu.cn/"],
    name: "Xi'an University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xaut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xhcom.edu.cn/"],
    name: "Xinghai Conservatory of Music",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xhcom.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xidian.edu.cn/"],
    name: "Xi'an University of Electronic Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xidian.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xiju.edu.cn/"],
    name: "Xijiang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xiju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xisu.edu.cn/"],
    name: "Xi'an International Studies University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xisu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xjau.edu.cn/"],
    name: "Xinjiang Agriculture University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xjau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xjnu.edu.cn/"],
    name: "Xinjiang Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xjnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xjtlu.edu.cn/"],
    name: "Xi'an Jiaotong-Liverpool University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xjtlu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://en.eurasia.edu/"],
    name: "Xi'an Eurasia University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["eurasia.edu"],
    country: "China",
  },
  {
    web_pages: ["http://www.xjtu.edu.cn/"],
    name: "Xi'an Jiaotong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xjtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xju.edu.cn/"],
    name: "Xinjiang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xjufe.edu.cn/"],
    name: "Xinjiang University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xjufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xmu.edu.cn/"],
    name: "Xiamen University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xmu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xtnu.edu.cn/"],
    name: "Xiangtan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xtnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xtu.edu.cn/"],
    name: "Xiangtan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xtu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xza.cn/"],
    name: "Tibet Agricultural and Animal Husbandry College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xza.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xzmy.edu.cn/"],
    name: "Tibet University of Nationalities",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xzmy.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xznu.edu.cn/"],
    name: "Xuzhou Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["xznu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.yangtzeu.edu.cn/"],
    name: "Yangtze University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["yangtzeu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.yau.edu.cn/"],
    name: "Yan'an University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["yau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ybu.edu.cn/"],
    name: "Yanbian University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ybu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ybust.edu.cn/"],
    name: "Yanbian University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ybust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.yizhuan.com/"],
    name: "Huaihua Medical College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["yizhuan.com"],
    country: "China",
  },
  {
    web_pages: ["http://www.ynau.edu.cn/"],
    name: "Yunnan Agriculture University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ynau.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ynnu.edu.cn/"],
    name: "Yunnan Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ynnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ynu.edu.cn/"],
    name: "Yunnan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ynu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ysu.edu.cn/"],
    name: "Yan Shan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ysu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ytet.edu.cn/"],
    name: "Yantai Education Institute & Yantai Television University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ytet.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ytnc.edu.cn/"],
    name: "Ludong University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ytnc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.ytu.edu.cn/"],
    name: "Yantai University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["ytu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.yznu.cn/"],
    name: "Yangtze Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["yznu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.yzu.edu.cn/"],
    name: "Yangzhou University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["yzu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zdsoft.com.cn/"],
    name: "Zhengda Software College",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zdsoft.com.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zgfxy.cn/"],
    name: "Buddhist Acamedy of China",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zgfxy.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zhnut.edu.cn/"],
    name: "Zhongnan University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zhnut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zjfc.edu.cn/"],
    name: "Zhejiang Forestry University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zjfc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zjgsu.edu.cn/"],
    name: "Zhejiang Gongshang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zjgsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zjnu.edu.cn/"],
    name: "Zhejiang Normal University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zjnu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zjou.edu.cn/"],
    name: "Zhanjiang Ocean University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zjou.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zju.edu.cn/"],
    name: "Zhejiang University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zju.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zjut.edu.cn/"],
    name: "Zhejiang University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zjut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.znuel.net/"],
    name: "Zhongnan University of Economics and Law",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["znuel.net"],
    country: "China",
  },
  {
    web_pages: ["http://www.znufe.edu.cn/"],
    name: "Zhongnan University of Finance and Economics",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["znufe.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://zsb.scfai.edu.cn/"],
    name: "Sichuan Fine Art Institute",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zsb.scfai.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zstu.edu.cn/"],
    name: "Zhejiang Sci-Tech University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zstu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zsu.edu.cn/"],
    name: "Zhongshan University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zsu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zzgc.edu.cn/"],
    name: "Zhengzhou Grain University",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zzgc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.zzut.edu.cn/"],
    name: "Zhengzhou University of Technology",
    alpha_two_code: "CN",
    "state-province": null,
    domains: ["zzut.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.autonoma.edu.co/"],
    name: "Universidad Autónoma de Manizales",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["autonoma.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.bellasartes.edu.co/"],
    name: "Universidad Bellas Artes",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["bellasartes.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.bundenet.com/umusical/"],
    name: "Conservatorio del Tolima",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["bundenet.com"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.cesa.edu.co/"],
    name: "Colegio de Estudios Superiores de Administración (CESA)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["cesa.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ces.edu.co/"],
    name: "Universidad CES",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ces.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.cuao.edu.co/"],
    name: "Universidad Autónoma de Occidente",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["cuao.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.cuc.edu.co/"],
    name: "Corporación Universitaria de la Costa (UNICOSTA)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["cuc.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.cui.edu.co/"],
    name: "Corporación Universitaria de Ibagué (CORUNIVERSITARIA)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["cui.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.cutb.edu.co/"],
    name: "Corporación Universitaria Tecnológica de Bolivar",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["cutb.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.eafit.edu.co/"],
    name: "Universidad EAFIT",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["eafit.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ean.edu.co/"],
    name: "Escuela de Administración de Negocios",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ean.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ecci.edu.co/"],
    name: "Escuela Colombiana de Carreras Industriales",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ecci.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ecr.edu.co/"],
    name: "Fundacion Escuela Colombiana de Rehabiliación",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ecr.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.eia.edu.co/"],
    name: "Escuela de Ingeniería de Antioquia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["eia.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.esap.edu.co/"],
    name: "Escuela Superiore de Administración Pública",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["esap.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.escueladepolicia.edu.co/"],
    name: 'Escuela de Policia "General Santander"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["escueladepolicia.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.escuelaing.edu.co/"],
    name: "Escuela Colombiana de Ingeniería Julio Garavito",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["escuelaing.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.fuac.edu.co/"],
    name: "Universidad Autónoma de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["fuac.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.funandi.edu.co/"],
    name: "Fundación Universitaria del Area Andina. Sede Pereira",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["funandi.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.funlam.edu.co/"],
    name: "Fundación Universitaria Luis Amigó",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["funlam.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.iberoamericana.edu.co/"],
    name: "Institución Universitaria Iberoamericana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["iberoamericana.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.iceit.edu.co/"],
    name: "Centro de Estudios Investigación y Tecnología (CEIT)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["iceit.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.icesi.edu.co/"],
    name: "Universidad ICESI",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["icesi.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.itm.edu.co/"],
    name: "Instituto Tecnológico Metropolitano",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["itm.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.iue.edu.co/"],
    name: "Institucion Universitaria de Envigado",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["iue.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.javeriana.edu.co/"],
    name: "Pontificia Universidad Javeriana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["javeriana.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.lasalle.edu.co/"],
    name: "Universidad de La Salle",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["lasalle.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.pedagogica.edu.co/"],
    name: "Universidad Pedagogica Nacional",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["pedagogica.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.poligran.edu.co/"],
    name: "Politécnico Grancolombiano - Institución Universitaria",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["poligran.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.politecjic.edu.co/"],
    name: 'Politécnico Columbiano "Jaime Isaza Cadavid"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["politecjic.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.sanmartin.edu.co/"],
    name: "Fundación Universitaria San Martín",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["sanmartin.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uac.edu.co/"],
    name: "Universidad Autónoma del Caribe",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uac.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uam.edu.co/"],
    name: "Universidad Autónoma de Las Américas",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uam.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uamerica.edu.co/"],
    name: "Universidad de América Bogotá",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uamerica.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uanarino.edu.co/"],
    name: "Universidad Antonio Nariño",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uanarino.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucaldas.edu.co/"],
    name: "Universidad de Caldas",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucaldas.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucatolica.edu.co/"],
    name: "Universidad Católica de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucatolica.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucatolicamz.edu.co/"],
    name: "Universidad Católica de Manizales",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucatolicamz.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucauca.edu.co/"],
    name: "Universidad del Cauca",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucauca.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucc.edu.co/"],
    name: "Universidad Cooperativa de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucc.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucentral.edu.co/"],
    name: "Universidad Central",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucentral.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uceva.edu.co/"],
    name: "Universidad Central del Valle del Cauca",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uceva.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucn.edu.co/"],
    name: "Universidad Católica del Norte",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucn.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uco.edu.co/"],
    name: "Universidad Católica del Oriente",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uco.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucpr.edu.co/"],
    name: "Universidad Católica Popular del Risaralda",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ucpr.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udca.edu.co/"],
    name: "Universidad de Ciencias Aplicadas y Ambientales (UDCA)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udca.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udea.edu.co/"],
    name: "Universidad de Antioquia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udea.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udea.edu.co/"],
    name: "Universidad de Antioquía",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udea.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udem.edu.co/"],
    name: "Universidad de Medellín",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udem.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udenar.edu.co/"],
    name: "Universidad de Nariño",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udenar.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udes.edu.co/"],
    name: "Corporación Universitaria de Santander (UDES)",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udes.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.udistrital.edu.co/"],
    name: 'Universidad Distral "Francisco José de Caldas"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["udistrital.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uexternado.edu.co/"],
    name: "Universidad Externado de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uexternado.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ufps.edu.co/"],
    name: "Universidad Francisco de Paula Santander",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ufps.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ugrancolombia.edu.co/"],
    name: "Universidad La Gran Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ugrancolombia.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uis.edu.co/"],
    name: "Universidad Industrial de Santander",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uis.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.umanizales.edu.co/"],
    name: "Universidad de Manizales",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["umanizales.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.umariana.edu.co/"],
    name: "Universidad Mariana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["umariana.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.umb.edu.co/"],
    name: "Fundación Universitaria Manuela Beltrán",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["umb.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.umng.edu.co/"],
    name: "Universidad Militar Nueva Granada",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["umng.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unab.edu.co/"],
    name: "Universidad Autónoma de Bucaramanga",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unab.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unac.edu.co/"],
    name: "Universidad Adventista de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unac.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unad.edu.co/"],
    name: "Universidad Nacional Abierta y a Distancia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unad.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unal.edu.co/"],
    name: "Universidad Nacional de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unal.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unaula.edu.co/"],
    name: "Universidad Autónoma Latinoamericana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unaula.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unbosque.edu.co/"],
    name: "Universidad El Bosque",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unbosque.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniamazonia.edu.co/"],
    name: "Universidad de La Amazonia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniamazonia.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniandes.edu.co/"],
    name: "Universidad de Los Andes",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniandes.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniatlantico.edu.co/"],
    name: "Universidad del Atlántico",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniatlantico.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniboyaca.edu.co/"],
    name: "Fundación Universitaria de Boyacá",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniboyaca.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unicartagena.edu.co/"],
    name: "Universidad de Cartagena",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unicartagena.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unicesar.edu.co/"],
    name: "Universidad Popular del Cesar",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unicesar.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unicordoba.edu.co/"],
    name: "Universidad de Córdoba",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unicordoba.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniguajira.edu.co/"],
    name: "Universidad de La Guajira",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniguajira.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unilibre.edu.co/"],
    name: "Universidad Libre de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unilibre.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unillanos.edu.co/"],
    name: "Universidad de Los Llanos",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unillanos.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unimagdalena.edu.co/"],
    name: "Universidad del Magdalena",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unimagdalena.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unimetro.edu.co/"],
    name: "Universidad Metropolitana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unimetro.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unincca.edu.co/"],
    name: "Universidad INCCA de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unincca.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uninorte.edu.co/"],
    name: "Universidad del Norte",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uninorte.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unipamplona.edu.co/"],
    name: "Universidad de Pamplona",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unipamplona.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unipaz.edu.co/"],
    name: "Instituto Universitario de La Paz",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unipaz.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unipiloto.edu.co/"],
    name: "Universidad Piloto de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unipiloto.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uniquindio.edu.co/"],
    name: "Universidad del Quindío",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uniquindio.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unisabana.edu.co/"],
    name: "Universidad de La Sabana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unisabana.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unisimonbolivar.edu.co/"],
    name: 'Corporación Educativa Mayor del Desarrollo "Simón Bolivar"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unisimonbolivar.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unisinucartagena.edu.co/"],
    name: "Universidad del Sinú",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unisinucartagena.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.unisucre.edu.co/"],
    name: "Universidad de Sucre",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["unisucre.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.univalle.edu.co/"],
    name: "Universidad del Valle del Cauca",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["univalle.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.upb.edu.co/"],
    name: "Universidad Pontificia Bolivariana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["upb.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.uptc.edu.co/"],
    name: "Universidad Pedagógica y Tecnológica de Colombia",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["uptc.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.urosario.edu.co/"],
    name: "Universidad del Rosario",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["urosario.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usaca.edu.co/"],
    name: "Universidad Santiago de Cali",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usaca.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usb.edu.co/"],
    name: "Universidad de San Buenaventura",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usb.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usbmed.edu.co/"],
    name: "Universidad de San Buenaventura Medellin",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usbmed.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usergioarboleda.edu.co/"],
    name: "Universidad Sergio Arboleda",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usergioarboleda.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usta.edu.co/"],
    name: "Universidad Santo Tomás",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usta.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.usurcolombia.com/"],
    name: "Universidad Surcolombiana",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["usurcolombia.com"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.utadeo.edu.co/"],
    name: 'Universidad de Bogotá "Jorge Tadeo Lozano"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["utadeo.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.utch.edu.co/"],
    name: 'Universidad Tecnológica del Choco "Diego Luis Cordoba"',
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["utch.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ut.edu.co/"],
    name: "Universidad del Tolima",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["ut.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.utp.edu.co/"],
    name: "Universidad Tecnológica de Pereira",
    alpha_two_code: "CO",
    "state-province": null,
    domains: ["utp.edu.co"],
    country: "Colombia",
  },
  {
    web_pages: ["http://www.ucbc.org/"],
    name: "Université Chrétienne Bilingue du Congo",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["ucbc.org"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.ucbukavu.ac.cd/"],
    name: "Université Catholique de Bukavu",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["ucbukavu.ac.cd"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://um-rdc.org/"],
    name: "Université de Mbuji Mayi",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["um-rdc.org"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.uniband.org/"],
    name: "Université de Bandundu Ville",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["uniband.org"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.unikin.cd/"],
    name: "Université de Kinshasa",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["unikin.cd"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.unikis.ac.cd/"],
    name: "Université de Kisangani",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["unikis.ac.cd"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.unilu.ac.cd/"],
    name: "Université de Lubumbashi",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["unilu.ac.cd"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.unishabunia.org/"],
    name: "Université Shalom de Bunia",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["unishabunia.org"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.universitekongo.org/"],
    name: "Université Kongo",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["universitekongo.org"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.upc-rdc.cd/"],
    name: "Université Protestante au Congo",
    alpha_two_code: "CD",
    "state-province": null,
    domains: ["upc-rdc.cd"],
    country: "Congo, the Democratic Republic of the",
  },
  {
    web_pages: ["http://www.univ-mngb.net/"],
    name: "University Marien Ngouabi Brazzaville",
    alpha_two_code: "CG",
    "state-province": null,
    domains: ["univ-mngb.net"],
    country: "Congo",
  },
  {
    web_pages: ["http://www.fundepos.ac.cr/"],
    name: "Universidad Fundepos Alma Mater",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["fundepos.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.isaacnewtoncr.com/"],
    name: "Universidad Isaac Newton",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["isaacnewtoncr.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.itcr.ac.cr/"],
    name: "Instituto Tecnológico de Costa Rica",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["itcr.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.sjdlc.com/"],
    name: "Universidad San Juan de la Cruz",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["sjdlc.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uaca.ac.cr/"],
    name: "Universidad Autónoma de Centro América",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uaca.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uca.ac.cr/"],
    name: "Universidad de Cartago Florencio del Castillo",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uca.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ucatolica.ac.cr/"],
    name: "Universidad Católica Anselmo Llorente",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ucatolica.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uci.ac.cr/"],
    name: "Universidad para la Cooperación Internacional",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uci.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ucr.ac.cr/"],
    name: "Universidad de Costa Rica",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ucr.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ufidelitas.ac.cr/"],
    name: "Universidad Fidélitas",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ufidelitas.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uhispanoamericana.ac.cr/"],
    name: "Universidad Hispanoamericana",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uhispanoamericana.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uia.ac.cr/"],
    name: "Universidad Internacional de las Américas",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uia.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ulacit.ac.cr/"],
    name: "Universidad Latinoamericana de Ciencia y Tecnología",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ulacit.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ulasalle.ac.cr/"],
    name: "Universidad de La Salle",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ulasalle.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ulatina.ac.cr/"],
    name: "Universidad Latina de Costa Rica",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ulatina.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.ulicori.ac.cr/"],
    name: "Universidad Libre de Costa Rica",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["ulicori.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.umca.net/"],
    name: "Universidad Metropolitana Castro Carazo",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["umca.net"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.una.ac.cr/"],
    name: "Universidad Nacional",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["una.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.unadeca.ac.cr/"],
    name: "Universidad Adventista de Centro América",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["unadeca.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.unam.ac.cr/"],
    name: "Universidad Autonoma Monterrey",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["unam.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uned.ac.cr/"],
    name: "Universidad Estatal a Distancia",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uned.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.unem.edu/internacional/"],
    name: "Universidad Empresarial",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["unem.edu"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.unibe.ac.cr/"],
    name: "Universidad de Iberoamérica",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["unibe.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.universidadbrauliocarrillo.com/"],
    name: "Universidad Braulio Carrillo",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["universidadbrauliocarrillo.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.universidadcentral.com/"],
    name: "Universidad Central",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["universidadcentral.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.universidadsanjosecr.com/"],
    name: "Universidad de San José",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["universidadsanjosecr.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.upeace.org/"],
    name: "University for Peace",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["upeace.org"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.usam.ac.cr/"],
    name: "Universidad San Marcos",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["usam.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uspsantapaula.com/"],
    name: "Universidad Santa Paula",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uspsantapaula.com"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.utur.ac.cr/"],
    name: "Universidad del Turismo",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["utur.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uveritas.ac.cr/"],
    name: "Universidad Veritas",
    alpha_two_code: "CR",
    "state-province": null,
    domains: ["uveritas.ac.cr"],
    country: "Costa Rica",
  },
  {
    web_pages: ["http://www.uabobo.ci/"],
    name: "Université d'Abobo-Adjamé",
    alpha_two_code: "CI",
    "state-province": null,
    domains: ["uabobo.ci"],
    country: "Côte d'Ivoire",
  },
  {
    web_pages: ["http://www.ubouake.ci/"],
    name: "Université de Bouaké",
    alpha_two_code: "CI",
    "state-province": null,
    domains: ["ubouake.ci"],
    country: "Côte d'Ivoire",
  },
  {
    web_pages: ["http://www.univ-cocody.ci/"],
    name: "Université de Cocody",
    alpha_two_code: "CI",
    "state-province": null,
    domains: ["univ-cocody.ci"],
    country: "Côte d'Ivoire",
  },
  {
    web_pages: ["http://www.tabari.ac.ir/"],
    name: "Tabari Institute of Higher Education",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["tabari.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.zut.edu.pl/"],
    name: "Zachodniopomorska School of Science and Engineering",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["zut.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.unidu.hr/"],
    name: "University of Dubrovnik",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unidu.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unios.hr/"],
    name: "University of Osijek",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unios.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unipu.hr/"],
    name: "University of Pula",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unipu.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.uniri.hr/"],
    name: "University of Rijeka",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["uniri.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unist.hr/"],
    name: "University of Split",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unist.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unizd.hr/"],
    name: "University of Zadar",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unizd.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unizg.hr/"],
    name: "University of Zagreb",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unizg.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.zsem.hr/"],
    name: "Zagreb School of Economics and Management",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["zsem.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.vern.hr/"],
    name: "VERN' University of Applied Sciences",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["vern.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.tvz.hr/"],
    name: "Zagreb University of Applied Sciences",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["tvz.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.algebra.hr/"],
    name: "Algebra University College",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["algebra.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.unin.hr/"],
    name: "University North",
    alpha_two_code: "HR",
    "state-province": null,
    domains: ["unin.hr"],
    country: "Croatia",
  },
  {
    web_pages: ["http://www.cujae.edu.cu/"],
    name: "Instituto Superior Politécnico José Antonio Echeverría",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["cujae.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.ismm.edu.cu/"],
    name: 'Instituto Superior Minero Metalúrgico "Dr. Antonio Núñez Jiménez"',
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["ismm.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.ispcmw.rimed.cu/"],
    name: 'Universidad Pedagógica "José Martí", Camagüey',
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["ispcmw.rimed.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.reduc.edu.cu/"],
    name: "Universidad de Camagüey",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["reduc.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.ucf.edu.cu/"],
    name: "Universidad de Cienfuegos",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["ucf.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.uclv.edu.cu/"],
    name: "Universidad Central de Las Villas",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["uclv.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.udg.co.cu/"],
    name: "Universidad de Granma",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["udg.co.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.uh.cu/"],
    name: "Universidad de La Habana",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["uh.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.uho.edu.cu/"],
    name: "Universidad de Holguín",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["uho.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.umcc.cu/"],
    name: "Universidad de Matanzas Camilo Cienfuegos",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["umcc.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.unica.cu/"],
    name: "Universidad de Ciego de Avila",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["unica.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.uo.edu.cu/"],
    name: "Universidad de Oriente",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["uo.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.upr.edu.cu/"],
    name: "Universidad de Pinar del Río",
    alpha_two_code: "CU",
    "state-province": null,
    domains: ["upr.edu.cu"],
    country: "Cuba",
  },
  {
    web_pages: ["http://www.ac.ac.cy/"],
    name: "Americanos College",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ac.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.ciim.ac.cy/"],
    name: "Cyprus International Institute of Management (CIIM)",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ciim.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.ciu.edu.tr/"],
    name: "Cyprus International University",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ciu.edu.tr"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.ctleuro.ac.cy/"],
    name: "The CTL Eurocollege",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ctleuro.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.cut.ac.cy/"],
    name: "Cyprus University of Technology",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["cut.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.cycollege.ac.cy/"],
    name: "Cyprus College",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["cycollege.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.emu.edu.tr/"],
    name: "Eastern Mediterranean University",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["emu.edu.tr"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.euc.ac.cy/"],
    name: "European University Cyprus",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["euc.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.frederick.ac.cy/"],
    name: "Frederick University",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["frederick.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.gau.edu.tr/"],
    name: "Girne American University",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["gau.edu.tr"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.intercollege.ac.cy/"],
    name: "Intercollege",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["intercollege.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.lefke.edu.tr/"],
    name: "European University of Lefke",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["lefke.edu.tr"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.neu.edu.tr/"],
    name: "Near East University",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["neu.edu.tr"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.ouc.ac.cy/"],
    name: "Open University of Cyprus",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ouc.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.ucy.ac.cy/"],
    name: "University of Cyprus",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["ucy.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.unic.ac.cy/"],
    name: "University of Nicosia",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["unic.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["https://www.nicosia.sgul.ac.cy/"],
    name: "University of Nicosia, St George's",
    alpha_two_code: "CY",
    "state-province": null,
    domains: ["live.sgul.ac.cy", "sgul.ac.cy"],
    country: "Cyprus",
  },
  {
    web_pages: ["http://www.aauni.edu/"],
    name: "Anglo-American University",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["aauni.edu"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.cuni.cz/"],
    name: "Charles University Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["cuni.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.cvut.cz/"],
    name: "Czech Technical University of Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["cvut.cz", "fa.cvut.cz", "fit.cvut.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.czu.cz/"],
    name: "Czech University of Agriculture Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["czu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.famu.cz/"],
    name: "Academy of Performing Arts, Film and TV Fakulty",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["famu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.jcu.cz/"],
    name: "University of South Bohemia",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["jcu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.mendelu.cz/"],
    name: "Mendel University of Agriculture and Forestry",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["mendelu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.mpu-prague.cz/"],
    name: "Prague International University",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["mpu-prague.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.muni.cz/"],
    name: "Masaryk University",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["muni.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.osu.cz/"],
    name: "University of Ostrava",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["osu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.praguecollege.cz/"],
    name: "Prague College",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["praguecollege.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.slu.cz/"],
    name: "Silesian University",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["slu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.tiffinprague.cz/"],
    name: "Tiffin University Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["tiffinprague.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.ujep.cz/"],
    name: "University of Jan Evangelista Purkyne",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["ujep.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.unva.cz/"],
    name: "University of Northern Virginia, Prague Campus",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["unva.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.unyp.cz/"],
    name: "University of New York in Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["unyp.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.upce.cz/"],
    name: "University of Pardubice",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["upce.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.upol.cz/"],
    name: "Palacky University",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["upol.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.utb.cz/"],
    name: "Tomas Bata University in Zlin",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["utb.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vfu.cz/"],
    name: "University of Veterinary and Pharmaceutical Science",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vfu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vsb.cz/"],
    name: "Technical University of Mining and Metallurgy Ostrava",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vsb.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vscht.cz/"],
    name: "Prague Institute of Chemical Technology",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vscht.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vsci.cz/"],
    name: "Cevro Institut College",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vsci.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vse.cz/"],
    name: "University of Economics Prague",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vse.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vslib.cz/"],
    name: "Technical University of Liberec",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vslib.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vsp.cz/"],
    name: "University of Education Hradec Kralove",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vsp.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.vutbr.cz/"],
    name: "Brno University of Technology",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["vutbr.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.zcu.cz/"],
    name: "University of West Bohemia",
    alpha_two_code: "CZ",
    "state-province": null,
    domains: ["zcu.cz"],
    country: "Czech Republic",
  },
  {
    web_pages: ["http://www.a-aarhus.dk/"],
    name: "Aarhus School of Architecture",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["a-aarhus.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ah.dk/"],
    name: "Aalborg Business College",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ah.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ats.dk/"],
    name: "Aarhus Technical College",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ats.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.auc.dk/"],
    name: "Aalborg University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["auc.dk", "aau.dk", "student.aau.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.au.dk/"],
    name: "Aarhus University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["au.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.cbs.dk/"],
    name: "Copenhagen Business School",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["cbs.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.db.dk/"],
    name: "Royal School of Library and Information Science",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["db.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ddea.dk/"],
    name: "Danish Business Academy",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ddea.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.dfh.dk/"],
    name: "Royal Danish School of Pharmacy",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["dfh.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.dkdm.dk/"],
    name: "Royal Danish Academy of Music",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["dkdm.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.dlh.dk/"],
    name: "Royal Danish School of Educational Sciences",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["dlh.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.dpu.dk/"],
    name: "Danish University of Education",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["dpu.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.dtu.dk/"],
    name: "Technical University of Denmark",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["dtu.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.hha.dk/"],
    name: "Aarhus School of Business",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["hha.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.hhs.dk/"],
    name: "Southern Denmark Business School",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["hhs.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ibss.eu/"],
    name: "International Business School of Scandinavia",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ibss.eu"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.iha.dk/"],
    name: "Engineering College of Aarhus",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["iha.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ihk.dk/"],
    name: "Engineering College of Copenhagen",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ihk.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ipc.dk/"],
    name: "International People's College",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ipc.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.itu.dk/"],
    name: "IT University of Copenhagen",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["itu.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.karch.dk/"],
    name: "Royal Danish Academy of Fine Arts, School of Architecture",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["karch.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.knightsbridgeuniversity.com/"],
    name: "Knightsbridge University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["knightsbridgeuniversity.com"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ku.dk/"],
    name: "Copenhagen University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ku.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.kunstakademiet.dk/"],
    name: "Royal Danish Academy of Fine Arts, School of Visual Art",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["kunstakademiet.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.kvl.dk/"],
    name: "Royal Veterinary and Agricultural University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["kvl.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.musik-kons.dk/"],
    name: "Royal Academy of Music",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["musik-kons.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ou.dk/"],
    name: "Odense University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ou.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.ruc.dk/"],
    name: "Roskilde University",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["ruc.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.sdu.dk/"],
    name: "University of Southern Denmark - SDU",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["sdu.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.teologi.dk/"],
    name: "Lutheran School Of Theology In Aarhus",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["teologi.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.tietgen.dk/"],
    name: "Tietgen Business College",
    alpha_two_code: "DK",
    "state-province": null,
    domains: ["tietgen.dk"],
    country: "Denmark",
  },
  {
    web_pages: ["http://www.univ.edu.dj/"],
    name: "Université de Djibouti",
    alpha_two_code: "DJ",
    "state-province": null,
    domains: ["univ.edu.dj"],
    country: "Djibouti",
  },
  {
    web_pages: ["http://www.dsc.dm/"],
    name: "Dominica State College",
    alpha_two_code: "DM",
    "state-province": null,
    domains: ["dsc.dm"],
    country: "Dominica",
  },
  {
    web_pages: ["http://www.newworld.ac/"],
    name: "New World University",
    alpha_two_code: "DM",
    "state-province": null,
    domains: ["newworld.ac"],
    country: "Dominica",
  },
  {
    web_pages: ["http://www.rossu.edu/medical-school/"],
    name: "Ross University Caribbean School of Medicine",
    alpha_two_code: "DM",
    "state-province": null,
    domains: ["rossu.edu"],
    country: "Dominica",
  },
  {
    web_pages: ["http://www.icda.edu.do/espanol/unicda/"],
    name: "Universidad Dominico-Americana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["icda.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.intec.edu.do/"],
    name: "Instituto Tecnológico de Santo Domingo",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["intec.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.pucmm.edu.do/"],
    name: "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["pucmm.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.pucmm.edu.do/"],
    name: "Universidad Católica Madre y Maestra",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["pucmm.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uafam.edu.do/"],
    name: "Universidad Agroforestal Fernando A.Meriño",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uafam.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uapa.edu.do/"],
    name: "Universidad Abierta Para Adultos",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uapa.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uasd.edu.do/"],
    name: "Universidad Autónoma de Santo Domingo",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uasd.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ucateci.edu.do/"],
    name: "Universidad Católica Tecnológica del Cibao",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ucateci.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uce.edu.do/"],
    name: "Universidad Central del Este",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uce.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ucne.edu.do/"],
    name: "Universidad Católica Nordestana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ucne.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ucsd.edu.do/"],
    name: "Universidad Católica de Santo Domingo",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ucsd.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.udoym.edu.do/"],
    name: "Universidad Dominicana O&M",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["udoym.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ufhec.edu.do/"],
    name: "Universidad Federico Henríquez y Carvajal",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ufhec.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ufhec.edu.do/"],
    name: "Universidad Ulises Francisco Espaillat",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ufhec.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unad.edu.do/"],
    name: "Universidad Adventista Dominicana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unad.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unapec.edu.do/"],
    name: "Universidad APEC",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unapec.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unefa.edu.do/"],
    name: "Universidad Experimental Felix Adam",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unefa.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unev-rd.edu.do/"],
    name: "Universidad Nacional Evangélica",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unev-rd.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unibe.edu.do/"],
    name: "Universidad Iberoamericana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unibe.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unica.edu.do/"],
    name: "Universidad Interamericana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unica.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unicaribe.edu.do/"],
    name: "Universidad del Caribe",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unicaribe.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uniremhos.edu.do/"],
    name: "Universidad Eugenio Maria de Hostos",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uniremhos.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.unphu.edu.do/"],
    name: "Universidad Nacional Pedro Henríquez Ureña",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["unphu.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.uod.edu.do/"],
    name: "Universidad Odontológica Dominicana",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["uod.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.ute.edu.do/"],
    name: "Universidad de la Tercera Edad",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["ute.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.utesa.edu/"],
    name: "Universidad Tecnológica de Santiago",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["utesa.edu"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.utesur.edu.do/"],
    name: "Universidad Tecnológica del Sur",
    alpha_two_code: "DO",
    "state-province": null,
    domains: ["utesur.edu.do"],
    country: "Dominican Republic",
  },
  {
    web_pages: ["http://www.brookdale.edu.ec/"],
    name: "Brookdale Community College",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["brookdale.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["https://www.brookings.edu/"],
    name: "Brookings Institution",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brookings.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.casagrande.edu.ec/"],
    name: "Universidad Casa Grande",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["casagrande.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.epn.edu.ec/"],
    name: "Escuela Politécnica Nacional",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["epn.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.espe.edu.ec"],
    name: "Escuela Politécnica del Ejercito",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["espe.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.espoch.edu/"],
    name: "Escuela Politécnica de Chimborazo",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["espoch.edu"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.espol.edu.ec/"],
    name: "Escuela Superior Politécnica del Litoral",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["espol.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.indoamerica.edu.ec/"],
    name: "Universidad Tecnológica Indoamérica",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["indoamerica.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.internacional.edu.ec/"],
    name: "Universidad Internacional del Ecuador",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["internacional.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.puce.edu.ec/"],
    name: "Pontificia Universidad Católica del Ecuador",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["puce.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.sek.edu/html/ecuador.html"],
    name: "Universidad Internacional SEK, Quito",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["sek.edu"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uagraria.edu.ec/"],
    name: "Universidad Agraria del Ecuador",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uagraria.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uasb.edu.ec/"],
    name: "Universidad Andina Simón Bolívar",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uasb.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uazuay.edu.ec/"],
    name: "Universidad del Azuay",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uazuay.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ucaazo.edu.ec/"],
    name: "Universidad Catolica de Azogues",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ucaazo.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ucacue.edu.ec/"],
    name: "Universidad Católica de Cuenca",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ucacue.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ucentral.edu.ec/"],
    name: "Universidad Central del Ecuador",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ucentral.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ucsg.edu.ec/"],
    name: "Universidad Católica de Santiago de Guayaquil",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ucsg.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uct.edu.ec/"],
    name: "Universidad de Especialidades Turísticas",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uct.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ucuenca.edu.ec/"],
    name: "Universidad de Cuenca",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ucuenca.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ueb.isfun.net/"],
    name: "Universidad Estatal de Bolívar",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ueb.isfun.net"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uees.edu.ec/"],
    name: "Universidad de Especialidades del Espíritu Santo",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uees.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ug.edu.ec/"],
    name: "Universidad de Guayaquil",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ug.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uisrael.ec/"],
    name: "Universidad Tecnologica Israel",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uisrael.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ulaicavr.com/"],
    name: 'Universidad Laica "Vicente Rocafuerte" de Guayaquil',
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ulaicavr.com"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uleam.edu.ec/"],
    name: 'Universidad Laica "Eloy Alfaro" de Manabi',
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uleam.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.unach.edu.ec/"],
    name: "Universidad Nacional de Chimborazo",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["unach.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.unita.edu.ec/"],
    name: "Universidad Tecnológica América",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["unita.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.unl.edu.ec/"],
    name: "Universidad Nacional de Loja",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["unl.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.upacifico.edu.ec/"],
    name: "Universidad del Pacifico",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["upacifico.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ups.edu.ec/"],
    name: "Universidad Politécnica Salesiana",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ups.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.usfq.edu.ec/"],
    name: "Universidad San Francisco de Quito",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["usfq.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.usm.edu.ec/"],
    name: "Universidad Santa María Campus Guayaquil",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["usm.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uta.edu.ec/"],
    name: "Universidad Técnica de Ambato",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uta.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utb.edu.ec/"],
    name: "Universidad Técnica de Babahoyo",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utb.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utc.edu.ec/"],
    name: "Universidad Técnica de Cotopaxi",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utc.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.ute.edu.ec/"],
    name: "Universidad Tecnológica Equinoccial",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["ute.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utelvt.edu.ec/"],
    name: 'Universidad Técnica de Esmeraldas "Luis Vargas Torres"',
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utelvt.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.uteq.edu.ec/"],
    name: "Universidad Técnica Estatal de Quevedo",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["uteq.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utmachala.edu.ec/"],
    name: "Universidad Técnica de Machala",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utmachala.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utm.edu.ec/"],
    name: "Universidad Técnica de Manabí",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utm.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utn.edu.ec/"],
    name: "Universidad Técnica del Norte",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utn.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utpl.edu.ec/"],
    name: "Universidad Técnica Particular de Loja",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utpl.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.utsam.edu.ec/"],
    name: "Universidad Tecnológica San Antonio de Machala",
    alpha_two_code: "EC",
    "state-province": null,
    domains: ["utsam.edu.ec"],
    country: "Ecuador",
  },
  {
    web_pages: ["http://www.aast.edu/"],
    name: "Arab Academy for Science & Technology",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["aast.edu"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.akhbaracademy.edu.eg/"],
    name: "Akhbar El Yom Academy",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["akhbaracademy.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.alex.edu.eg/"],
    name: "Alexandria University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["alex.edu.eg", "alexmed.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.aou.edu.eg/"],
    name: "Arab Open University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["aou.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.aucegypt.edu/"],
    name: "American University in Cairo",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["aucegypt.edu"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.aun.edu.eg/"],
    name: "Assiut University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["aun.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.azhar.edu.eg/"],
    name: "Al Azhar University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["azhar.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.bsu.edu.eg/"],
    name: "Beni Suef University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["bsu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.bu.edu.eg/"],
    name: "Benha University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["bu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.cu.edu.eg/"],
    name: "Cairo University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["cu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.damanhour.edu.eg/"],
    name: "Damanhour University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["damanhour.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.du.edu.eg/"],
    name: "Damietta University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["du.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.elshoroukacademy.edu.eg/"],
    name: "El Shorouk Academy",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["elshoroukacademy.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.fayoum.edu.eg/"],
    name: "Fayoum University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["fayoum.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.futureuniversity.edu.eg/"],
    name: "Future University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["futureuniversity.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.guc.edu.eg/"],
    name: "German University in Cairo",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["guc.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.helwan.edu.eg/"],
    name: "Helwan University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["helwan.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.hti.edu.eg/"],
    name: "Higher Technological Institute",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["hti.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.kfs.edu.eg/"],
    name: "Kafr El-Sheikh University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["kfs.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.mans.edu.eg/"],
    name: "Mansoura University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["mans.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.menofia.edu.eg/"],
    name: "Menoufia University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["menofia.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.minia.edu.eg/"],
    name: "Minia University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["minia.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.miuegypt.edu.eg/"],
    name: "Misr International University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["miuegypt.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.modern-academy.edu.eg/"],
    name: "Modern Acadmy",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["modern-academy.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.msa.eun.eg/"],
    name: "Modern Sciences & Arts University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["msa.eun.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.mtc.edu.eg/"],
    name: "Military Technical College",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["mtc.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.mti.edu.eg/"],
    name: "Modern University For Technology and Information",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["mti.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.must.edu.eg/"],
    name: "Misr University for Sience and Technology",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["must.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.nileu.edu.eg/"],
    name: "Nile University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["nileu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.o6u.edu.eg/"],
    name: "October 6 university",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["o6u.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.pua.edu.eg/"],
    name: "Pharos International University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["pua.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.sadatacademy.edu.eg/"],
    name: "Sadat Academy for Management Sciences",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["sadatacademy.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.shams.edu.eg/"],
    name: "Ain Shams University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["shams.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.sohag-univ.edu.eg/"],
    name: "Sohag University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["sohag-univ.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.su.edu.eg/"],
    name: "Sinai University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["su.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.suez.edu.eg/"],
    name: "Suez Canal University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["suez.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.svu.edu.eg/"],
    name: "South Valley University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["svu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.tanta.edu.eg/"],
    name: "Tanta University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["tanta.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.ufe.edu.eg/"],
    name: "Université Française d'Égypte",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["ufe.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.usenghor-francophonie.org/"],
    name: "Université Senghor d'Alexandrie",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["usenghor-francophonie.org"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.zu.edu.eg/"],
    name: "Zagazig University",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["zu.edu.eg"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.cdb.edu.sv/"],
    name: "Universidad Don Bosco",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["cdb.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.netcomsa.com/uls/"],
    name: "Universidad Luterana Salvadorena",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["netcomsa.com"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.uae.edu.sv/"],
    name: "Universidad Albert Einstein",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["uae.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.ucad.edu.sv/"],
    name: "Universidad Cristiana de las Asambleas de Dios",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["ucad.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.uca.edu.sv/"],
    name: 'Universidad Centroamericana "José Simeón Canas"',
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["uca.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.uees.edu.sv/"],
    name: "Universidad Evangélica de El Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["uees.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.ues.edu.sv/"],
    name: "Universidad de El Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["ues.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.ufg.edu.sv/"],
    name: "Universidad Francisco Gavidia",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["ufg.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.ugb.edu.sv/"],
    name: "Universidad Capitain General Gerardo Barrios",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["ugb.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.ujmd.edu.sv/"],
    name: "Universidad Dr. Jose Matias Delgado",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["ujmd.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.uma.edu.sv/"],
    name: "Universidad Modular Abierta",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["uma.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.umoar.edu.sv/"],
    name: "Universidad Monsenor Oscar Arnulfo Romeo",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["umoar.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.unab.edu.sv/"],
    name: "Universidad Dr. Andreas Bello",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["unab.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.unasa.edu.sv/"],
    name: "Universidad Autónoma de Santa Ana",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["unasa.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.unico.edu.sv/"],
    name: "Universidad Católica de Occidente",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["unico.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.universidadpedagogica.com/"],
    name: "Universidad Pedagógica de El Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["universidadpedagogica.com"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.univo.edu.sv/"],
    name: "Universidad de Oriente",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["univo.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.unssa.edu.sv/"],
    name: "Universidad Nueva San Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["unssa.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.upan.edu.sv/"],
    name: "Universidad Panamericana de San Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["upan.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.upes.edu.sv/"],
    name: "Universidad Politécnica de El Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["upes.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.usam.edu.sv/"],
    name: 'Universidad Salvadorena "Alberto Masferrer"',
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["usam.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.usin.edu.sv/"],
    name: "Universidad Isaac Newton",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["usin.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.usonsonate.edu.sv/"],
    name: "Universidad de Sonsonate",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["usonsonate.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.utec.edu.sv/"],
    name: "Universidad Tecnológica de El Salvador",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["utec.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.utla.edu.sv/"],
    name: "Universidad Técnica Latinoamericana",
    alpha_two_code: "SV",
    "state-province": null,
    domains: ["utla.edu.sv"],
    country: "El Salvador",
  },
  {
    web_pages: ["http://www.unge.gq/"],
    name: "Universidad Nacional de Guinea Ecuatorial",
    alpha_two_code: "GQ",
    "state-province": null,
    domains: ["unge.gq"],
    country: "Equatorial Guinea",
  },
  {
    web_pages: ["http://www.eit.edu.er/"],
    name: "Eritrea Institute of Technology",
    alpha_two_code: "ER",
    "state-province": null,
    domains: ["eit.edu.er"],
    country: "Eritrea",
  },
  {
    web_pages: ["http://www.artun.ee/"],
    name: "Estonian Academy of Arts",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["artun.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.ebs.ee/"],
    name: "Estonian Business School",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["ebs.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.ema.edu.ee/"],
    name: "Estonian Academy of Music and Theatre",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["ema.edu.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.emu.ee/"],
    name: "Estonian University of Life Sciences",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["emu.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.nooruse.ee/"],
    name: "Tartu Health Care College",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["nooruse.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.sisekaitse.ee/"],
    name: "Estonian Academy of Security Sciences",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["sisekaitse.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.tktk.ee/"],
    name: "University of Applied Sciences",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["tktk.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.tlu.ee/"],
    name: "Tallinn University",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["tlu.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.ttu.ee/"],
    name: "Tallinn University of Technology",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["ttu.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.ut.ee/"],
    name: "University of Tartu",
    alpha_two_code: "EE",
    "state-province": null,
    domains: ["ut.ee"],
    country: "Estonia",
  },
  {
    web_pages: ["http://www.aastu.org/"],
    name: "Addis Ababa Science & Technology University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["aastu.org"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.aau.edu.et/"],
    name: "Addis Ababa University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["aau.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.adu.edu.et/"],
    name: "Adigrat University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["adu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.aku.edu.et/"],
    name: "Aksum University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["aku.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.ambou.edu.et/"],
    name: "Ambo University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["ambou.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.amu.edu.et/"],
    name: "Arba Minch University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["amu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.astu.edu.et/"],
    name: "Adama Science and Technology University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["astu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.asu.edu.et/"],
    name: "Assosa University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["asu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.bdu.edu.et/"],
    name: "Bahir Dar University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["bdu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.bulehorauniversity.com/"],
    name: "Bule Hora  University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["bulehorauniversity.com"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.dbu.edu.et/"],
    name: "Debre Birhan University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["dbu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.ddu.edu.et/"],
    name: "Dire Dawa University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["ddu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.dillauniversity.edu.et/"],
    name: "Dilla University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["dillauniversity.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.dmu.edu.et/"],
    name: "Debre Markos University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["dmu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.ecsc.edu.et/"],
    name: "Ethiopian Civil Service University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["ecsc.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.haramaya.edu.et/"],
    name: "Haramaya University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["haramaya.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.hu.edu.et/"],
    name: "Hawassa University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["hu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.jju.edu.et/"],
    name: "Jigjiga University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["jju.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.ju.edu.et/"],
    name: "Jimma University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["ju.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.mitethiopia.edu.et/"],
    name: "Mekelle Institute of Technology",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["mitethiopia.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.mtu.edu.et/"],
    name: "Mizan Tepi University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["mtu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.mu.edu.et/"],
    name: "Mekelle University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["mu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.mwu.edu.et/"],
    name: "Madawalabu University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["mwu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.su.edu.et/"],
    name: "Semera University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["su.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.uog.edu.et/"],
    name: "Gondar University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["uog.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.uuc.edu.et/"],
    name: "Unity  University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["uuc.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.wku.edu.et/"],
    name: "Wolkite University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["wku.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.wsu.edu.et/"],
    name: "Wolaita Sodo University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["wsu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.wu.edu.et/"],
    name: "Wollo University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["wu.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.wuni.edu.et/"],
    name: "Wollega University",
    alpha_two_code: "ET",
    "state-province": null,
    domains: ["wuni.edu.et"],
    country: "Ethiopia",
  },
  {
    web_pages: ["http://www.setur.fo/"],
    name: "University of the Faroe Islands",
    alpha_two_code: "FO",
    "state-province": null,
    domains: ["setur.fo"],
    country: "Faroe Islands",
  },
  {
    web_pages: ["http://www.fnu.ac.fj/"],
    name: "Fiji National University",
    alpha_two_code: "FJ",
    "state-province": null,
    domains: ["fnu.ac.fj"],
    country: "Fiji",
  },
  {
    web_pages: ["http://www.fsm.ac.fj/"],
    name: "Fiji School of Medicine",
    alpha_two_code: "FJ",
    "state-province": null,
    domains: ["fsm.ac.fj"],
    country: "Fiji",
  },
  {
    web_pages: ["http://www.unifiji.ac.fj/"],
    name: "University of Fiji",
    alpha_two_code: "FJ",
    "state-province": null,
    domains: ["unifiji.ac.fj"],
    country: "Fiji",
  },
  {
    web_pages: ["http://www.usp.ac.fj/"],
    name: "University of the South Pacific",
    alpha_two_code: "FJ",
    "state-province": null,
    domains: ["usp.ac.fj"],
    country: "Fiji",
  },
  {
    web_pages: ["http://www.abo.fi/"],
    name: "Abo Akademi University",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["abo.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.cou.fi/"],
    name: "Central Ostrobothnia University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["cou.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.diak.fi/"],
    name: "Diaconia University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["diak.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.evtek.fi/"],
    name: "EVTEK University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["evtek.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.helsinki.fi/"],
    name: "University of Helsinki",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["helsinki.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.hkkk.fi/"],
    name: "Helsinki School of Economics and Business Administration",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["hkkk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.hut.fi/"],
    name: "Helsinki University of Technology",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["hut.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.joensuu.fi/"],
    name: "University of Joensuu",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["joensuu.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.jyu.fi/"],
    name: "University of Jyväskylä",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["jyu.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.kuva.fi/"],
    name: "Academy of Fine Arts",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["kuva.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.lamk.fi/"],
    name: "Lahti Polytechnic",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["lamk.fi", "student.lamk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.laurea.fi/"],
    name: "Laurea University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["laurea.fi", "student.laurea.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.lut.fi/"],
    name: "Lappeenranta University of Technology",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["lut.fi", "student.lut.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.oamk.fi/"],
    name: "Oulu Polytechnic",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["oamk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.oulu.fi/"],
    name: "University of Oulu",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["oulu.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.puv.fi/"],
    name: "Vaasa University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["puv.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.ramk.fi/"],
    name: "Rovaniemi University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["ramk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.sabi.eu.com/"],
    name: "Scandinavian Art and Business Institute",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["sabi.eu.com"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.samk.fi/"],
    name: "Satakunta University Of Applied Scinces",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["samk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.scp.fi/"],
    name: "South Carelian Polytechnic",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["scp.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.shh.fi/"],
    name: "Swedish School of Economics and Business Administration, Finland",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["shh.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.siba.fi/"],
    name: "Sibelius Academy",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["siba.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.teak.fi/"],
    name: "Theatre Academy Finland",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["teak.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.tpu.fi/"],
    name: "Tampere Polytechnic",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["tpu.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.tukkk.fi/"],
    name: "Turku School of Economics and Business Administration",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["tukkk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.tut.fi/"],
    name: "Tampere University of Technology",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["tut.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.uiah.fi/"],
    name: "University of Art and Design Helsinki",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["uiah.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.uku.fi/"],
    name: "University of Kuopio",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["uku.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.ulapland.fi/"],
    name: "University of Lapland",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["ulapland.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.uta.fi/"],
    name: "University of Tampere",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["uta.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.utu.fi/"],
    name: "University of Turku",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["utu.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.uwasa.fi/"],
    name: "University of Vaasa",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["uwasa.fi"],
    country: "Finland",
  },
  {
    web_pages: ["https://www.aalto.fi"],
    name: "Aalto University",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["aalto.fi"],
    country: "Finland",
  },
  {
    web_pages: ["https://www.metropolia.fi/"],
    name: "Metropolia University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["metropolia.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.42.fr/"],
    name: "42 FR",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["student.42.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.aea.asso.fr/"],
    name: "Ecole de l'Air",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["aea.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.agroparistech.fr/"],
    name: "AgroParisTech",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["agroparistech.fr"],
    country: "France",
  },
  {
    web_pages: ["http://agro.roazhon.inra.fr/"],
    name: "Ecole Nationale Supérieure d'Agronomie de Rennes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["agro.roazhon.inra.fr"],
    country: "France",
  },
  {
    web_pages: ["http://agro.roazhon.inra.fr/etab/insfa/accueil.htm"],
    name: "Institut National Supérieur de Formation Agro-Alimentaire",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["agro.roazhon.inra.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.agrosupdijon.fr/"],
    name: "AgroSup Dijon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["agrosupdijon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ags.edu/"],
    name: "American Graduate School in Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ags.edu"],
    country: "France",
  },
  {
    web_pages: ["http://www.aup.fr/"],
    name: "American University of Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["aup.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.bip.lon.ac.uk/"],
    name: "British Institute in Paris, University of London",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["bip.lon.ac.uk"],
    country: "France",
  },
  {
    web_pages: ["http://www.ceram.edu/"],
    name: "Ecole Supérieure de Commerce de Sophia Antipolis",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ceram.edu"],
    country: "France",
  },
  {
    web_pages: ["http://www.cesi.fr/"],
    name: "Centre d'Etudes Supérieures Industrielles Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cesi.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.cfpj.com/"],
    name: "Centre de Formation et de Perfectionnement des Journalistes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cfpj.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.cnam.fr/"],
    name: "Conservatoire National des Arts et Métiers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cnam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.cnearc.fr/"],
    name: "Centre National d'Etudes Agronomiques des Régions Chaudes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cnearc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.cpe.fr/"],
    name: "Ecole Supérieure de Chimie Physique Electronique de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cpe.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.cribx1.u-bordeaux.fr/"],
    name: "Université Bordeaux I",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cribx1.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://cust.univ-bpclermont.fr/"],
    name: "Institut des Sciences de l'Ingénieur de Clermont-Ferrand",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cust.univ-bpclermont.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.dauphine.fr/"],
    name: "Université Paris-Dauphine (Paris IX)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["dauphine.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.devinci.fr/"],
    name: "Ecole Superieur d'Ingenieurs Leonard de Vinci",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["devinci.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.e3i.univ-tours.fr/"],
    name: "Ecole d'Ingénieurs en Informatique pour l'Industrie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["e3i.univ-tours.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.eap.fr/"],
    name: "Ecole Européen des Affaires",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["eap.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ebs-paris.com/"],
    name: "European Business School",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ebs-paris.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.ecam.fr/"],
    name: "Ecole Catholique d'Arts & Metiers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ecam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ece.fr/"],
    name: "Ecole Centrale d'Electronique - ECE",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ece.fr"],
    country: "France",
  },
  {
    web_pages: ["https://www.imt-atlantique.fr/"],
    name: "IMT Atlantique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["imt-atlantique.net"],
    country: "France",
  },
  {
    web_pages: ["http://www.ec-lille.fr/"],
    name: "Ecole Centrale de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ec-lille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ec-lyon.fr/"],
    name: "Ecole Centrale de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ec-lyon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ec-nantes.fr/"],
    name: "Ecole Centrale de Nantes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ec-nantes.fr"],
    country: "France",
  },
  {
    web_pages: ["https://www.centrale-marseille.fr/"],
    name: "Ecole Centrale de Marseille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["centrale-marseille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ecoles-idrac.com/"],
    name: "IDRAC (Institut de recherche en action commerciale)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ecoles-idrac.com"],
    country: "France",
  },
  {
    web_pages: ["http://edu.edhec.com/"],
    name: "Ecole des Hautes Etudes Commerciales du Nord",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["edu.edhec.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.eerie.fr/"],
    name: "Ecole pour les Etudes et la Recherche en Informatique et Electronique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["eerie.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.efpg.inpg.fr/"],
    name: "Ecole Française de Papeterie et des Industries Graphiques",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["efpg.inpg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.efrei.fr/"],
    name: "Ecole Française d'Electronique et d'Informatique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["efrei.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.eivp-paris.fr/"],
    name: "Ecole des Ingénieurs de la Ville de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["eivp-paris.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.emc-campus.com/"],
    name: "European Management Center Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["emc-campus.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.em-lyon.com/"],
    name: "Ecole Supérieure de Commerce de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["em-lyon.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.emse.fr/"],
    name: "Ecole Nationale Supérieure des Mines de St-Etienne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["emse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enac.fr/"],
    name: "Ecole Nationale de l'Aviation Civile",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enac.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ena.fr/"],
    name: "Ecole Nationale d'Administration",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ena.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enic.fr/"],
    name: "ENIC Telecom Lille 1",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enic.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enim.fr/"],
    name: "Ecole Nationale d'Ingénieurs de Metz",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enim.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enise.fr/"],
    name: "Ecole Nationale d'Ingénieurs de Saint-Etienne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enise.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enitab.fr/"],
    name: "Ecole Nationale d'Ingénieurs des Travaux Agricoles de Bordeaux",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enitab.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enitac.fr/"],
    name: "Ecole Nationale d'Ingénieurs des Travaux Agricoles de Clermont-Ferrand",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enitac.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enit.fr/"],
    name: "Ecole Nationale d'Ingénieurs de Tarbes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enit.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enitiaa-nantes.fr/"],
    name: "Ecole Nationale d'Ingénieurs des Techniques des Industries Agricoles et Alimentaires",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enitiaa-nantes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enm.meteo.fr/"],
    name: "Ecole Nationale de la Météorologie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enm.meteo.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enpc.fr/"],
    name: "Ecole Nationale des Ponts et Chausees",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enpc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ens2m.fr/"],
    name: "Ecole Nationale Supérieur de Mécaniques et des Microtechniques",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ens2m.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensae.fr/"],
    name: "Ecole Nationale de la Statistique et de l'Administration Economique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensae.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensaia.u-nancy.fr/"],
    name: "Ecole Nationale Supérieure d'Agronomie et des Industries Alimentaires",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensaia.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensai.fr/"],
    name: "Ecole Nationale de la Statistique et de l'Analyse de l'information",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensai.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensait.fr/"],
    name: "Ecole Nationale Supérieure des Arts et Industries Textiles",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensait.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensam.inra.fr/"],
    name: "Ecole Nationale Supérieure d'Agronomie de Montpellier",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensam.inra.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensat.fr/"],
    name: "Ecole Nationale Supérieure Agronomique de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensat.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ens-cachan.fr/"],
    name: "Ecole Normale Supérieure de Cachan",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ens-cachan.fr"],
    country: "France",
  },
  {
    web_pages: ["http://ensccf.univ-bpclermont.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Clermont-Ferrand",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensccf.univ-bpclermont.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensc-lille.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensc-lille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enscm.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Montpellier",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enscm.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enscmu.univ-mulhouse.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Mulhouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enscmu.univ-mulhouse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enscpb.u-bordeaux.fr/"],
    name: "Ecole Nationale Supérieure de Chimie et de Physique de Bordeaux",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enscpb.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enscp.jussieu.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enscp.jussieu.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensc-rennes.fr/"],
    name: "Ecole Nationale Supérieure de Chimie de Rennes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensc-rennes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensea.fr/"],
    name: "Ecole Nationale Supérieure de l'Electronique et de ses Applications",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensea.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enseeiht.fr/"],
    name: "Ecole Nationale Supérieure d'Electronique, d'Electrotechnique, d'Informatique et d'Hydraulique de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enseeiht.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enseeiht.fr/"],
    name: "Ecole Nationale Supérieure en Electrotechnique, Electronique, Informatique et Hydraulique de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enseeiht.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensem.u-nancy.fr/"],
    name: "Ecole Nationale Supérieure Electricité et Mécanique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensem.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enserb.u-bordeaux.fr/"],
    name: "Ecole Nationale Supérieure d'Electronique et de Radioelectricite de Bordeaux",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enserb.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ens-fcl.fr/"],
    name: "Ecole Normale Supérieure de Fontenay-Saint Cloud",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ens-fcl.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ens.fr/"],
    name: "Ecole Normale Supérieure de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ens.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensg.ign.fr/"],
    name: "Ecole Nationale des Sciences Géographiques",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensg.ign.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensg.u-nancy.fr/"],
    name: "Ecole Nationale Supérieur de Géologie de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensg.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensica.fr/"],
    name: "Ecole Nationale Supérieur d'Ingénieurs de Constructions Aéronautique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensica.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensica.fr/"],
    name: "École Nationale Supérieure d'Ingénieurs de Constructions Aéronautiques",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensica.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensic.u-nancy.fr/"],
    name: "Ecole Nationale Supérieure des Industries Chimiques de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensic.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensieta.fr/"],
    name: "Ecole Nationale Supérieur des Ingénieur des Etudes et Techniques d'Armement",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensieta.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensitm.fr/"],
    name: "Ecole Nationale Supérieure des Industries Textiles de Mulhouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensitm.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ens-lyon.fr/"],
    name: "Ecole Normale Supérieure de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ens-lyon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensma.fr/"],
    name: "Ecole Nationale Supérieur de Mécanique et d'Aéronautique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensma.fr"],
    country: "France",
  },
  {
    web_pages: ["https://www.mines-ales.fr/"],
    name: "Ecole Nationale Supérieure des Mines d'Alès",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensm-ales.fr", "mines-ales.fr", "mines-ales.org"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensm-douai.fr/"],
    name: "Ecole Nationale Supérieure des Mines de Douai",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensm-douai.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensmp.fr/"],
    name: "Ecole Nationale Supérieure des Mines de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensmp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enspm.u-3mrs.fr/"],
    name: "Ecole Nationale Supérieure de Physique de Marseille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enspm.u-3mrs.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ensta.fr/"],
    name: "Ecole Nationale Supérieure de Techniques Avancées",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ensta.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enst-bretagne.fr/"],
    name: "Ecole Nationale Supérieure des Telecommunications de Bretagne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enst-bretagne.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.enst.fr/"],
    name: "Ecole Nationale Supérieure des Telecommunications de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["enst.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.entpe.fr/"],
    name: "Ecole Nationale des Travaux Publics de l'Etat",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["entpe.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.envt.fr/"],
    name: "Ecole Nationale Vétérinaire de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["envt.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.epf.fr/"],
    name: "EPF Ecole d'Ingénieurs",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["epf.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esa-purpan.fr/"],
    name: "Ecole Supérieure d'Agriculture de Purpan",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esa-purpan.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-bordeaux.fr/"],
    name: "Ecole Supérieure de Commerce de Bordeaux",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-brest.fr/"],
    name: "Ecole Supérieure de Commerce de Brest",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-brest.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-clermont.fr/"],
    name: "Ecole Supérieure de Commerce de Clermont-Ferrand",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-clermont.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.escdijon.com/"],
    name: "Ecole Supérieure de Commerce de Dijon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["escdijon.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.escem.fr/"],
    name: "Ecole Supérieure de Commerce et Management",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["escem.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-lille.fr/"],
    name: "Ecole Supérieure de Commerce de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-lille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-marseille.fr/"],
    name: "Ecole Supérieure de Commerce de Marseille-Provence",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-marseille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.escna.fr/"],
    name: "Ecole Supérieure de Commerce de Nantes-Atlantique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["escna.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-normandie.fr/"],
    name: "Ecole Supérieure de Commerce de Le Havre/Caen",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-normandie.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.escom.fr/"],
    name: "Ecole Supérieure de Chimie Organique et Minérale",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["escom.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-pau.fr/"],
    name: "Ecole Supérieure de Commerce de Pau",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-pau.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.escp.fr/"],
    name: "Ecole Supérieure de Commerce de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["escp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-reims.edu/"],
    name: "Ecole Supérieure de Commerce de Reims",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-reims.edu"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-rouen.fr/"],
    name: "Ecole Supérieure de Commerce de Rouen",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-rouen.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esc-toulouse.fr/"],
    name: "Ecole Supérieure de Commerce de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esc-toulouse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.eseo.fr/"],
    name: "Ecole Supérieure d'Electronique de l'Ouest",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["eseo.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esiae.fr/"],
    name: "Ecole Supérieure Internationale d'Administration des Entreprises",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esiae.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esiea.fr/"],
    name: "Ecole Supérieure d'Informatique-Electronique-Automatique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esiea.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esiee.fr/"],
    name: "Ecole Supérieure d'Ingénieurs en Electronique et Electrotechnique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esiee.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esigelec.fr/"],
    name: "Ecole Supérieure d'Ingénieurs en Génie Electrique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esigelec.fr"],
    country: "France",
  },
  {
    web_pages: ["http://esim.imt-mrs.fr/"],
    name: "Ecole Supérieure d'Ingénieurs de Marseille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esim.imt-mrs.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esitpa.org/"],
    name: "Ecole Supérieure d'Ingénieurs et de Techniciens pour l'Agriculture",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esitpa.org"],
    country: "France",
  },
  {
    web_pages: ["http://www.esme.fr/"],
    name: "Ecole Spéciale de Mécanique et d'Electricité",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esme.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.espci.fr/"],
    name: "Ecole Supérieure de Physique et de Chimie Industrielles",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["espci.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.essca.asso.fr/"],
    name: "Ecole Supérieure des Sciences Commerciales d'Angers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["essca.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.essec.fr/"],
    name: "Ecole Supérieure des Sciences Economiques et Commerciales",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["essec.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.esstin.u-nancy.fr/"],
    name: "Ecole Supérieure des Sciences et Technologie de l'Ingénieur de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esstin.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.estp.fr/"],
    name: "Ecole Spéciale des Travaux Publics du Bâtiment et de l'Industrie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["estp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.eudil.fr/"],
    name: "Ecole Universitaire d'Ingénieurs de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["eudil.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.fupl.asso.fr/estit/"],
    name: "Ecole Supérieure des Techniques Industrielles et des Textiles",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["fupl.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.fupl.asso.fr/"],
    name: "Université Catholique de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["fupl.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.grenoble-em.com/"],
    name: "Grenoble Ecole de Management",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["grenoble-em.com", "esc-grenoble.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.groupe-esa.com/"],
    name: "Ecole Supérieure d'Agriculture d'Angers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["groupe-esa.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.hec.fr/"],
    name: "Ecole des Hautes Etudes Commerciales",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["hec.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.hei.fr/"],
    name: "Ecole des Hautes Etudes Industrielles de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["hei.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.icam.fr/"],
    name: "Institut Catholique d'Arts et Métiers Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["icam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.icam.fr/presentation/nantes.htm"],
    name: "Institut Catholique d'Arts et Métiers Nantes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["icam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.icn-nancy.com/"],
    name: "Institut Commercial de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["icn-nancy.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.icp.fr/"],
    name: "Institut Catholique de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["icp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ict-toulouse.asso.fr/"],
    name: "Institut Catholique de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ict-toulouse.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.iep.u-bordeaux.fr/"],
    name: "Institut d'Etudes Politiques de Bordeaux",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["iep.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ifp.fr/EC/EC000GP1.html"],
    name: "Ecole Nationale Supérieure du Pétrole et des Monteurs",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ifp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.inp-fc.fr/~ensigc/"],
    name: "Ecole Nationale Supérieure d'Ingénieurs de Génie Chimique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["inp-fc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.inp-fc.fr/"],
    name: "Institut National Polytechnique de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["inp-fc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.inpg.fr/INPG/fr_see.html"],
    name: "Ecole Nationale Supérieure d'Electrochimie et d'Electrométallurgie de Gernoble",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["inpg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.inpl-nancy.fr/"],
    name: "Institut National Polytechnique de Lorraine",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["inpl-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.insa-lyon.fr/"],
    name: "Institut National des Sciences Appliquées de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["insa-lyon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.insa-rennes.fr/"],
    name: "Institut National des Sciences Appliquées de Rennes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["insa-rennes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.insa-rouen.fr/"],
    name: "Institut National des Sciences Appliquées de Rouen",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["insa-rouen.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.insa-tlse.fr/"],
    name: "Institut National des Sciences Appliquées de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["insa-tlse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.inseec.fr/"],
    name: "Institut des hautes études économiques et commerciales",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["inseec.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.int-evry.fr/"],
    name: "Institut National des Télécommunications",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["int-evry.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.iota.u-psud.fr/~ecole/"],
    name: "Ecole Supérieure d'Optique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["iota.u-psud.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ircam.fr/"],
    name: "Institut de Recherche et Coordination Acoustique/Musique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ircam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ireste.fr/"],
    name: "Institut de Recherche et d'Enseignement Supérieur aux Techniques de l'électronique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ireste.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isab.fr/"],
    name: "Institut Supérieur Agricole de Beauvais",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isab.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isa.fupl.asso.fr/"],
    name: "Institut Supérieur d'Agriculture Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isa.fupl.asso.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isara.fr/"],
    name: "Institut Supérieur d'Agriculture Rhone-Alpes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isara.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isen.fr/"],
    name: "Institut Supérieure d'Electronique du Nord",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isen.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isep.fr/"],
    name: "Institut Supérieure d'Electronique de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isep.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.isim.univ-montp2.fr/"],
    name: "Institut des Sciences de l'Ingénieur de Montpellier",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["isim.univ-montp2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ismcm-cesti.fr/"],
    name: "Centre d'Etudes Supérieures des Techniques Industrielles",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ismcm-cesti.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ismra.fr/"],
    name: "Institut des Sciences de la Matière et du Rayonnement",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ismra.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.itech.fr/"],
    name: "Institut Textile et Chimique de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["itech.fr"],
    country: "France",
  },
  {
    web_pages: ["https://sciences.sorbonne-universite.fr/"],
    name: "Sorbonne Université - Faculté des Sciences (Paris VI)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: [
      "jussieu.fr",
      "etu.upmc.fr",
      "upmc.fr",
      "etu.sorbonne-universite.fr",
      "sorbonne-universite.fr",
    ],
    country: "France",
  },
  {
    web_pages: ["http://www.mines.u-nancy.fr/"],
    name: "Ecole Nationale Supérieure des Mines de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["mines.u-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.montaigne.u-bordeaux.fr/"],
    name: "Université Michel de Montaigne (Bordeaux III )",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["montaigne.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.montesquieu.u-bordeaux.fr/"],
    name: "Université Montesquieu (Bordeaux IV)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["montesquieu.u-bordeaux.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.nancy.archi.fr/"],
    name: "Ecole d'Architecture de Nancy",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["nancy.archi.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.paris4.sorbonne.fr/"],
    name: "Université Paris-Sorbonne (Paris IV)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["paris4.sorbonne.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.paris.ensam.fr/"],
    name: "Ecole Nationale Supérieure d'Arts et Métiers de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["paris.ensam.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.polytech-lille.fr/"],
    name: "Ecole Polytechnique Universitaire de Lille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["polytech-lille.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.polytech-marseille.fr/"],
    name: "Ecole Polytechnique Marseille",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["polytech-marseille.fr"],
    country: "France",
  },
  {
    web_pages: [
      "http://www.polytechnique.fr/",
      "https://www.polytechnique.edu/",
    ],
    name: "École Polytechnique",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["polytechnique.fr", "polytechnique.edu"],
    country: "France",
  },
  {
    web_pages: ["http://www.schillerparis.com/"],
    name: "Schiller International University, Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["schillerparis.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.schillerstrasbourg.com/"],
    name: "Schiller International University, Strasbourg",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["schillerstrasbourg.com"],
    country: "France",
  },
  {
    web_pages: ["http://www.sciences-po.fr/"],
    name: "Institut d'Etudes Politiques de Paris (Sciences Po)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["sciences-po.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.sigu7.jussieu.fr/"],
    name: "Université Denis Diderot (Paris VII)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["sigu7.jussieu.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.sorbon.fr/"],
    name: "Ecole Superieure Robert de Sorbon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["sorbon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.supaero.fr/"],
    name: "Ecole Nationale Supérieure de l'Aéronautique et de l'Espace",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["supaero.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.supco-amiens.fr/"],
    name: "Groupe Sup de Co Amiens Picardie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["supco-amiens.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.supco-montpellier.fr/"],
    name: "Groupe Sup de Co Montpellier",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["supco-montpellier.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.supelec.fr/"],
    name: "Ecole Supérieure d'Electricité",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["supelec.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-3mrs.fr/"],
    name: "Université d'Aix-Marseille III",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-3mrs.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-bordeaux2.fr/"],
    name: "Université Victor Segalen (Bordeaux II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-bordeaux2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ubfc.fr/"],
    name: "Université Bourgogne - Franche-Comté",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ubfc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-cergy.fr/"],
    name: "Université de Cergy-Pontoise",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-cergy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-clermont1.fr/"],
    name: "Université d'Auvergne (Clermont-Ferrand I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-clermont1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.uco.fr/"],
    name: "Université Catholique de l' Ouest",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["uco.fr"],
    country: "France",
  },
  {
    web_pages: ["https://www.univ-grenoble-alpes.fr/"],
    name: "Université Grenoble Alpes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-grenoble3.fr", "univ-grenoble-alpes.fr", "ujf-grenoble.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.uhb.fr/"],
    name: "Université Rennes II - Haute-Bretagne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["uhb.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.uhp-nancy.fr/"],
    name: "Université Henri Poincaré (Nancy I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["uhp-nancy.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.unicaen.fr/"],
    name: "Université de Caen Basse Normandie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["unicaen.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.unice.fr/"],
    name: "Université de Nice-Sophia Antipolis",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["unice.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.unilim.fr/"],
    name: "Université de Limoges",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["unilim.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-angers.fr/"],
    name: "Université d'Angers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-angers.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-artois.fr/"],
    name: "Université d'Artois",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-artois.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-avignon.fr/"],
    name: "Université d'Avignon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-avignon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-bpclermont.fr/"],
    name: "Université Blaise Pascal (Clermont-Ferrand II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-bpclermont.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-brest.fr/"],
    name: "Université de Bretagne Occidentale",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-brest.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-catholyon.fr/"],
    name: "Université Catholique de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-catholyon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-corse.fr/"],
    name: "Université de Corse Pascal Paoli",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-corse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-evry.fr/"],
    name: "Université d'Evry Val d'Essonne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-evry.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-inpt.fr/~ensct/"],
    name: "Ecole Nationale Supérieure de Chimie de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-inpt.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lehavre.fr/"],
    name: "Université du Havre",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lehavre.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lemans.fr/"],
    name: "Université du Maine",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lemans.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lille1.fr/"],
    name: "Université des Sciences et Technologies de Lille (Lille I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lille1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lille2.fr/"],
    name: "Université du Droit et de la Sante (Lille II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lille2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lille3.fr/"],
    name: "Université Charles-de-Gaulle (Lille III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lille3.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-littoral.fr/"],
    name: "Université du Littoral Cote d'Opale",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-littoral.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lorraine.fr/"],
    name: "Université de Lorraine",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lorraine.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lr.fr/"],
    name: "Université de La Rochelle",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lr.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lyon1.fr/"],
    name: "Université Claude Bernard (Lyon I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lyon1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lyon2.fr/"],
    name: "Université Lumiére (Lyon II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lyon2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-lyon3.fr/"],
    name: "Université Jean Moulin (Lyon III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-lyon3.fr"],
    country: "France",
  },
  {
    web_pages: ["https://www.cpe.fr/"],
    name: "École supérieure de chimie, physique, électronique de Lyon (CPE Lyon)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["cpe.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univmed.fr/"],
    name: "Université de la Méditerranée (Aix Marseille II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univmed.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-metz.fr/"],
    name: "Université de Metz",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-metz.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-mlv.fr/", "http://www.u-pem.fr/"],
    name: "Université Paris-Est Marne-la-Vallée",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-mlv.fr", "u-pem.fr", "etud.u-pem.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-montp1.fr/"],
    name: "Université de Montpellier I",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-montp1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-montp2.fr/"],
    name: "Université de Montpellier II",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-montp2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-montp3.fr/"],
    name: "Université Paul Valéry (Montpellier III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-montp3.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-mulhouse.fr/"],
    name: "Université de Haute-Alsace",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-mulhouse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-nancy2.fr/"],
    name: "Université Nancy II",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-nancy2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-nantes.fr/"],
    name: "Université de Nantes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-nantes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-orleans.fr/"],
    name: "Université d'Orléans",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-orleans.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris12.fr/"],
    name: "Université Val-de-Marne (Paris XII)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris12.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris13.fr/"],
    name: "Université Paris Nord (Paris XIII)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris13.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris1.fr/"],
    name: "Université Panthéon-Sorbonne (Paris I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris3.fr/"],
    name: "Université Sorbonne-Nouvelle (Paris III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris3.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris5.fr/"],
    name: "Université René Descartes (Paris V)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris5.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-paris8.fr/"],
    name: "Université Vincennes Saint-Denis (Paris VIII)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-paris8.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-pau.fr/"],
    name: "Université de Pau et des Pays de l'Adour",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-pau.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-perp.fr/"],
    name: "Université de Perpignan",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-perp.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-poitiers.fr/"],
    name: "Université de Poitiers",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-poitiers.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-reims.fr/"],
    name: "Université de Reims Champagne-Ardenne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-reims.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-rennes1.fr/"],
    name: "Université Rennes I",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-rennes1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-rouen.fr/"],
    name: "Université de Rouen - Haute Normandie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-rouen.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-savoie.fr/"],
    name: "Université de Savoie",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-savoie.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-st-etienne.fr/"],
    name: "Université Jean Monnet",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-st-etienne.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-tln.fr/"],
    name: "Université du Sud, Toulon et Var",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-tln.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-tlse1.fr/"],
    name: "Université des Sciences Sociales (Toulouse I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-tlse1.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-tlse2.fr/"],
    name: "Université de Toulouse-le-Mirail (Toulouse II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-tlse2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-toulouse.fr/"],
    name: "Université de Toulouse",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-toulouse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-tours.fr/"],
    name: "Université François Rabelais de Tours",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-tours.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-ubs.fr/"],
    name: "Université de Bretagne Sud",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-ubs.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-valenciennes.fr/ensimev/"],
    name: "Ecole Nationale Supérieure d'Ingénieurs en Mécanique et Energétique de Valenciennes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-valenciennes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-valenciennes.fr/"],
    name: "Université de Valenciennes et du Hainaut-Cambrésis",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["univ-valenciennes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-paris10.fr/"],
    name: "Université Paris Nanterre (Paris X)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-paris10.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-paris2.fr/"],
    name: "Université Panthéon-Assas (Paris II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-paris2.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-picardie.fr/"],
    name: "Université de Picardie Jules-Verne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-picardie.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ups-tlse.fr/"],
    name: "Université Paul Sabatier (Toulouse III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ups-tlse.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.u-psud.fr/"],
    name: "Université Paris Sud (Paris XI)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["u-psud.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.up.univ-mrs.fr/"],
    name: "Université de Provence (Aix-Marseille I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["up.univ-mrs.fr"],
    country: "France",
  },
  {
    web_pages: ["http://ushs.u-strasbg.fr/"],
    name: "Université des Sciences Humaines (Strasbourg II)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ushs.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.utbm.fr/"],
    name: "Université de Technologie de Belfort Montbéliard",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["utbm.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.utc.fr/"],
    name: "Université de Technologie de Compiègne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["utc.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.utt.fr/"],
    name: "Université de Technologie de Troyes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["utt.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.uvsq.fr/"],
    name: "Université de Versailles Saint-Quentin-en-Yvelines",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["uvsq.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.vet-alfort.fr/"],
    name: "Ecole Nationale Vétérinaire d'Alfort",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["vet-alfort.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.vet-lyon.fr/"],
    name: "Ecole Nationale Vétérinaire de Lyon",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["vet-lyon.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.vet-nantes.fr/"],
    name: "Ecole Nationale Vétérinaire de Nantes",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["vet-nantes.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-ecpm.u-strasbg.fr/"],
    name: "Ecole Européenne de Chimie, Polymères et Matériaux de Strasbourg",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-ecpm.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-engees.u-strasbg.fr/"],
    name: "Ecole Nationale du Génie de l'Eau et de l'Environnement de Strasbourg",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-engees.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-ensais.u-strasbg.fr/"],
    name: "Ecole Nationale Supérieure des Arts et Industries de Strasbourg",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-ensais.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: [
      "https://grenoble-inp.fr/",
      "https://phelma.grenoble-inp.fr/",
      "https://ensimag.grenoble-inp.fr/",
      "https://ense3.grenoble-inp.fr/",
      "https://esisar.grenoble-inp.fr/",
      "https://genie-industriel.grenoble-inp.fr/",
      "https://pagora.grenoble-inp.fr/",
    ],
    name: "Institut polytechnique de Grenoble",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["grenoble-inp.fr", "inpg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-ensps.u-strasbg.fr/"],
    name: "Ecole Nationale Supérieure de Physique de Strasbourg",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-ensps.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-ulp.u-strasbg.fr/"],
    name: "Université Louis Pasteur (Strasbourg I)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-ulp.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www-urs.u-strasbg.fr/"],
    name: "Université Robert Schuman (Strasbourg III)",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["www-urs.u-strasbg.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.epitech.eu/"],
    name: "Ecole pour l'Informatique et les nouvelles Technologies",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["epitech.eu", "epitech.net"],
    country: "France",
  },
  {
    web_pages: ["http://www.epita.fr/"],
    name: "Ecole Pour l'Informatique et les Techniques Avancees",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["epita.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.ipsa.fr/"],
    name: "Institut polytechnique des sciences avancees",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["ipsa.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.etna.io/"],
    name: "Ecole des technologies numeriques appliquees",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["etna.io"],
    country: "France",
  },
  {
    web_pages: ["http://www.esme.fr/"],
    name: "ESME Sudria",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["esme.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.supbiotech.fr/"],
    name: "Institut Sup'Biotech de Paris",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["supbiotech.fr"],
    country: "France",
  },
  {
    web_pages: ["http://www.univ-ag.fr/"],
    name: "Université des Antilles et de la Guyane",
    alpha_two_code: "GF",
    "state-province": null,
    domains: ["univ-ag.fr"],
    country: "French Guiana",
  },
  {
    web_pages: ["http://www.upf.pf/"],
    name: "Université de la Polynésie Française",
    alpha_two_code: "PF",
    "state-province": null,
    domains: ["upf.pf"],
    country: "French Polynesia",
  },
  {
    web_pages: ["http://www.uob.ga/"],
    name: "Université Omar Bongo",
    alpha_two_code: "GA",
    "state-province": null,
    domains: ["uob.ga"],
    country: "Gabon",
  },
  {
    web_pages: ["http://www.aiu.edu.gm/"],
    name: "American International University West Africa",
    alpha_two_code: "GM",
    "state-province": null,
    domains: ["aiu.edu.gm"],
    country: "Gambia",
  },
  {
    web_pages: ["http://www.euclid.int/"],
    name: "EUCLID University",
    alpha_two_code: "GM",
    "state-province": null,
    domains: ["euclid.int"],
    country: "Gambia",
  },
  {
    web_pages: ["http://www.utg.edu.gm/"],
    name: "University of the Gambia",
    alpha_two_code: "GM",
    "state-province": null,
    domains: ["utg.edu.gm"],
    country: "Gambia",
  },
  {
    web_pages: ["http://www.atsu.edu.ge/"],
    name: "Akaki Tsereteli State University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["atsu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.cu.edu.ge/"],
    name: "Caucasus University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["cu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.esm-tbilisi.ge/"],
    name: "European School of Management - Tbilisi",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["esm-tbilisi.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.gruni.edu.ge/"],
    name: "University of Grigol Robakidze",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["gruni.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.gsau.edu.ge/"],
    name: "Georgian Agricultural University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["gsau.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.gtu.edu.ge/"],
    name: "Georgian Technical University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["gtu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.ibsu.edu.ge/"],
    name: "International Blacksea University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["ibsu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.iliauni.edu.ge/"],
    name: "Ilia Chavchavadze State University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["iliauni.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.saba.edu.ge/"],
    name: "Tbilisi Pedagogical University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["saba.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.sangu.ge/"],
    name: "St. Andrew Georgian University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["sangu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.tiaa.edu.ge/"],
    name: "Tbilisi Institute of Asia and Africa",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["tiaa.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.tsmu.edu/"],
    name: "Tbilisi State Medical University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["tsmu.edu"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.tsu.edu.ge/"],
    name: "Tbilisi State University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["tsu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://www.akad.de/"],
    name: "AKAD Hochschulen für Berufstätige, Fachhochschule Leipzig",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["akad.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.akad.de/"],
    name: "Hochschule für Berufstätige Rendsburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["akad.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.asfh-berlin.de/"],
    name: "Alice-Salomon-Fachhochschule für Sozialarbeit und Sozialpädagogik Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["asfh-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.augustana.de/"],
    name: "Augustana Hochschule Neuendettelsau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["augustana.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.bethel.de/kiho/"],
    name: "Kirchliche Hochschule Bethel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["bethel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.bits-iserlohn.de/"],
    name: "BiTS - Business and Information Technology School gGmbH",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["bits-iserlohn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.cbs.de/"],
    name: "Cologne Business School",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["cbs.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://code.berlin/"],
    name: "CODE University of Applied Sciences Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["code.berlin"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhv-speyer.de/"],
    name: "Deutsche Hochschule für Verwaltungswissenschaften Speyer",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["dhv-speyer.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.diploma.de/"],
    name: "DIPLOMA-Fachhochschule Ölsnitz/Vogtland",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["diploma.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.diploma.de/"],
    name: "Fachhochschule Nordhessen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["diploma.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dshs-koeln.de/"],
    name: "Deutsche Sporthochschule Köln",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["dshs-koeln.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.eap.net/"],
    name: "E.A.P. Europäische Wirtschaftshochschule Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["eap.net"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.eba-muenchen.de/"],
    name: "Europäische Betriebswirtschafts-Akademie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["eba-muenchen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ebs.de/"],
    name: "European Business School Schloß Reichartshausen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ebs.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ecla.de/"],
    name: "European College of Liberal Arts",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ecla.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.efh-bochum.de/"],
    name: "Evangelische Fachhochschule Rheinland-Westfalen-Lippe",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["efh-bochum.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.eh-darmstadt.de/"],
    name: "Evangelische Fachhochschule Darmstadt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["eh-darmstadt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.efh-freiburg.de/"],
    name: "Evangelische Fachhochschule Freiburg, Hochschule für Soziale Arbeit, Diakonie und Religionspädagogik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["efh-freiburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.efh-hannover.de/"],
    name: "Evangelische Fachhochschule Hannover",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["efh-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.efhlu.de/"],
    name: "Evangelische Fachhochschule Ludwigshafen Hochschule für Sozial- und Gesundheitswesen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["efhlu.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.efh-reutlingen-ludwigsburg.de/"],
    name: "Evangelische Fachhochschule Reutlingen-Ludwigsburg, Hochschule für Soziale Arbeit, Religionspädagogik und Diakonie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["efh-reutlingen-ludwigsburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ehs-dresden.de/"],
    name: "Evangelische Hochschule für Soziale Arbeit Dresden (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ehs-dresden.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ems-mainz.de/"],
    name: "European Management School",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ems-mainz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.eufh.de/"],
    name: "Europäische Fachhochschule",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["eufh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.euv-frankfurt-o.de/"],
    name: "Europa-Universität Viadrina Frankfurt (Oder)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["euv-frankfurt-o.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.evfh-berlin.de/"],
    name: "Evangelische Fachhochschule Berlin, Fachhochschule für Sozialarbeit und Sozialpädagogik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["evfh-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.evfh-nuernberg.de/"],
    name: "Evangelische Fachhochschule Nürnberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["evfh-nuernberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fern-fh.de/"],
    name: "Fern-Fachhochschule Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fern-fh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fernuni-hagen.de/"],
    name: "Fernuniversität Gesamthochschule Hagen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fernuni-hagen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-aachen.de/"],
    name: "Fachhochschule Aachen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-aachen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-aschaffenburg.de/"],
    name: "Fachhochschule Aschaffenburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-aschaffenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-augsburg.de/"],
    name: "Fachhochschule Augsburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-augsburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-bad-honnef.de/"],
    name: "Internationale Fachhochschule Bad Honnef",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-bad-honnef.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-biberach.de/"],
    name: "Fachhochschule Biberach, Hochschule für Bauwesen und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-biberach.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-bielefeld.de/"],
    name: "Fachhochschule Bielefeld",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-bielefeld.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-bingen.de/"],
    name: "Fachhochschule Bingen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-bingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-bochum.de/"],
    name: "Fachhochschule Bochum",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-bochum.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hochschule-bonn-rhein-sieg.de/"],
    name: "Hochschule Bonn-Rhein-Sieg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hochschule-bonn-rhein-sieg.de", "h-brs.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-brandenburg.de/"],
    name: "Fachhochschule Brandenburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-brandenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.th-brandenburg.de/"],
    name: "Technische Hochschule Brandenburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["th-brandenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.th-deg.de/"],
    name: "Technische Hochschule Deggendorf",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["th-deg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-dortmund.de/"],
    name: "Fachhochschule Dortmund",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-dortmund.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-duesseldorf.de/"],
    name: "Hochschule Düsseldorf",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-duesseldorf.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhdw.bib.de/"],
    name: "Fachhochschule für die Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhdw.bib.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhdw.de/"],
    name: "Fachhochschule der Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhdw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-eberswalde.de/"],
    name: "Fachhochschule Eberswalde",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-eberswalde.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-erfurt.de/"],
    name: "Fachhochschule Erfurt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-erfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-flensburg.de/"],
    name: "Fachhochschule Flensburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-flensburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-frankfurt.de/"],
    name: "Fachhochschule Frankfurt am Main",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-frankfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-fresenius.de/"],
    name: "Europa Fachhochschule Fresenius",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-fresenius.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-furtwangen.de/"],
    name: "Fachhochschule Furtwangen, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-furtwangen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-gelsenkirchen.de/"],
    name: "Fachhochschule Gelsenkirchen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-gelsenkirchen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-giessen.de/"],
    name: "Fachhochschule Gießen-Friedberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-giessen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-hamburg.de/"],
    name: "Fachhochschule Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-hamburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-hannover.de/"],
    name: "Fachhochschule Hannover",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-heidelberg.de/"],
    name: "Fachhochschule Heidelberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-heidelberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-heilbronn.de/"],
    name: "Fachhochschule Heilbronn, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-heilbronn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-hildesheim.de/"],
    name: "Fachhochschule Hildesheim/Holzminden/Göttingen, Hochschule für angewandte Wissenschaft und Kunst",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-hildesheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-hof.de/"],
    name: "Fachhochschule Hof",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-hof.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.thi.de/"],
    name: "Technische Hochschule Ingolstadt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["thi.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-isny.de/"],
    name: "Fachhochschule und Berufskollegs NTA, Prof.Dr. Grübler gemein. GmbH",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-isny.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-jena.de/"],
    name: "Fachhochschule Jena",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-jena.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-karlsruhe.de/"],
    name: "Fachhochschule Karlsruhe, Hochschule für Technik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-karlsruhe.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-Kempten.de/"],
    name: "Fachhochschule Kempten, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-kempten.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-kiel.de/"],
    name: "Fachhochschule Kiel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-kiel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-kl.de/"],
    name: "Fachhochschule Kaiserslautern",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-kl.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-koblenz.de/"],
    name: "Fachhochschule Koblenz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-koblenz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-koeln.de/"],
    name: "Fachhochschule Köln",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-koeln.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-konstanz.de/"],
    name: "Fachhochschule Konstanz, Hochschule für Technik, Wirtschaft und Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-konstanz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhkt.de/"],
    name: "Staatlich anerkannte Fachhochschule für Kunsttherapie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhkt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-landshut.de/"],
    name: "Fachhochschule Landshut, Hochschule für Wirtschaft - Sozialwesen - Technik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-landshut.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-lausitz.de/"],
    name: "Fachhochschule Lausitz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-lausitz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-lippe.de/"],
    name: "Fachhochschule Lippe",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-lippe.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-ludwigshafen.de/"],
    name: "Fachhochschule Ludwigshafen, Hochschule für Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-ludwigshafen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-luebeck.de/"],
    name: "Fachhochschule Lübeck",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-luebeck.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-mainz.de/"],
    name: "Fachhochschule Mainz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-mainz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-mannheim.de/"],
    name: "Fachhochschule Mannheim, Hochschule für Technik und Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-mannheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-merseburg.de/"],
    name: "Fachhochschule Merseburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-merseburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhm-mittelstand.de/"],
    name: "Fachhochschule des Mittelstandes (FHM)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhm-mittelstand.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-muenchen.de/"],
    name: "Fachhochschule München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-muenchen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hm.edu/"],
    name: "Hochschule München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hm.edu"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-muenster.de/"],
    name: "Fachhochschule Münster",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-muenster.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-nb.de/"],
    name: "Fachhochschule Neubrandenburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-nb.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-neu-ulm.de/"],
    name: "Hochschule Neu-Ulm, Hochschule Neu-Ulm University of applied sciences",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-neu-ulm.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-niederrhein.de/"],
    name: "Fachhochschule Niederrhein",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-niederrhein.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhnon.de/"],
    name: "Fachhochschule Nordostniedersachsen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhnon.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-nordhausen.de/"],
    name: "Fachhochschule Nordhausen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-nordhausen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-nuernberg.de/"],
    name: "Georg-Simon-Ohm-Fachhochschule Nürnberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-nuernberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-nuertingen.de/"],
    name: "Fachhochschule Nürtingen, Hochschule für Wirtschaft, Landwirtschaft und Landespflege",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-nuertingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhoebb.de/"],
    name: "Fachhochschule für das öffentliche Bibliothekswesen Bonn",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhoebb.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-offenburg.de/"],
    name: "Fachhochschule Offenburg, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-offenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-oow.de/"],
    name: "Fachhochschule Oldenburg/Ostfriesland/Wilhelmshaven",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-oow.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-osnabrueck.de/"],
    name: "Fachhochschule Osnabrück",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-osnabrueck.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-ottersberg.de/"],
    name: "Freie Kunst-Studienstätte Ottersberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-ottersberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-pforzheim.de/"],
    name: "Fachhochschule Pforzheim, Hochschule für Gestaltung, Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-pforzheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-potsdam.de/"],
    name: "Fachhochschule Potsdam",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-potsdam.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-regensburg.de/"],
    name: "Fachhochschule Regensburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-regensburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-reutlingen.de/"],
    name: "Fachhochschule Reutlingen, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-reutlingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-riedlingen.de/"],
    name: "Deutsch-Ordens Fachhochschule Riedlingen, Hochschule für Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-riedlingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-rosenheim.de/"],
    name: "Fachhochschule Rosenheim, Hochschule für Technik und Wirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-rosenheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-rottenburg.de/"],
    name: "Fachhochschule Rottenburg, Hochschule für Forstwirtschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-rottenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-schmalkalden.de/"],
    name: "Fachhochschule Schmalkalden",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-schmalkalden.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-schwaebischhall.de/"],
    name: "Fachhochschule Schwäbisch Hall, Hochschule für Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-schwaebischhall.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhs-mannheim.de/"],
    name: "Fachhochschule Mannheim, Hochschule für Sozialwesen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhs-mannheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhs-moritzburg.de/"],
    name: "Evangelische Fachhochschule für Religionspädagogik, und Gemeindediakonie Moritzburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhs-moritzburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-stralsund.de/"],
    name: "Fachhochschule Stralsund",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-stralsund.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-telekom-leipzig.de/"],
    name: "Deutsche Telekom Fachhochschule Leipzig",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-telekom-leipzig.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-trier.de/"],
    name: "Fachhochschule Trier, Hochschule für Technik, Wirtschaft und Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-trier.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fht-stuttgart.de/"],
    name: "Fachhochschule Stuttgart, Hochschule für Technik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fht-stuttgart.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.htw-berlin.de/"],
    name: "Hochschule für Technik und Wirtschaft Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhtw-berlin.de", "htw-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-ulm.de/"],
    name: "Hochschule Ulm, Hochschule für Angewandte Wissenschaft",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-ulm.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhvr.berlin.de/"],
    name: "Fachhochschule für Verwaltung und Rechtspflege Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhvr.berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhw-berlin.de/"],
    name: "Fachhochschule für Wirtschaft Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhw-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-wedel.de/"],
    name: "Fachhochschule Wedel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-wedel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-weihenstephan.de/"],
    name: "Fachhochschule Weihenstephan",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-weihenstephan.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-weingarten.de/"],
    name: "Fachhochschule Ravensburg-Weingarten",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-weingarten.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-westkueste.de/"],
    name: "Fachhochschule Westküste, Hochschule für Wirtschaft und Technik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-westkueste.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-wiesbaden.de/"],
    name: "Fachhochschule Wiesbaden",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-wiesbaden.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-wolfenbuettel.de/"],
    name: "Fachhochschule Braunschweig/Wolfenbüttel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-wolfenbuettel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-worms.de/"],
    name: "Fachhochschule Worms",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-worms.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fhwt.de/"],
    name: "Private Fachhochschule für Wirtschaft und Technik Vechta/Diepholz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fhwt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-wuerzburg.de/"],
    name: "Fachhochschule Würzburg - Schweinfurt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-wuerzburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fh-zwickau.de/"],
    name: "Westsächsische Hochschule Zwickau (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fh-zwickau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fom.de/"],
    name: "Fachhochschule für Oekonomie und Management (FOM)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fom.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.fu-berlin.de/"],
    name: "Freie Universität Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fu-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hanseuni.de/"],
    name: "Private Hanseuniversität",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hanseuni.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hcu-hamburg.de/"],
    name: "Hafencity Universität Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hcu-hamburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hdm-stuttgart.de/"],
    name: "Fachhochschule Stuttgart, Hochschule der Medien",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hdm-stuttgart.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hertie-school.org/"],
    name: "Hertie School of Governance",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hertie-school.org"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hfb.de/"],
    name: "Hochschule für Bankwirtschaft (HfB), Private Fachhochschule der Bankakademie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hfb.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hfg-gmuend.de/"],
    name: "Fachhochschule Schwäbisch Gmünd, Hochschule für Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hfg-gmuend.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hfph.mwn.de/"],
    name: "Hochschule für Philosophie München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hfph.mwn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hfp.mhn.de/"],
    name: "Hochschule für Politik (HFP)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hfp.mhn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hhl.de/"],
    name: "Handelshochschule Leipzig",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hhl.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.himh.de/"],
    name: "Hochschule für Internationales Management",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["himh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hjs.uni-heidelberg.de/"],
    name: "Hochschule für Jüdische Studien Heidelberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hjs.uni-heidelberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-albsig.de/"],
    name: "Hochschule Albstadt-Sigmaringen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-albsig.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-anhalt.de/"],
    name: "Hochschule Anhalt (FH), Hochschule für angewandte Wissenschaften",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-anhalt.de", "student.hs-anhalt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-bremen.de/"],
    name: "Hochschule Bremen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-bremen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-bremerhaven.de/"],
    name: "Hochschule Bremerhaven",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-bremerhaven.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-coburg.de/"],
    name: "Hochschule Coburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-coburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.h-da.de/"],
    name: "Hochschule Darmstadt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["h-da.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-esslingen.de/"],
    name: "Hochschule Esslingen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-esslingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-fulda.de/"],
    name: "Hochschule Fulda",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-fulda.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-harz.de/"],
    name: "Hochschule Harz, Hochschule für angewandte Wissenschaften (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-harz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-magdeburg.de/"],
    name: "Hochschule Magdeburg-Stendal (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-magdeburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-wismar.de/"],
    name: "Hochschule Wismar, Fachhochschule für Technik, Wirtschaft und Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-wismar.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hs-zigr.de/"],
    name: "Hochschule Zittau/Görlitz (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hs-zigr.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.htw-dresden.de/"],
    name: "Hochschule für Technik und Wirtschaft Dresden (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["htw-dresden.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.htwk-leipzig.de/"],
    name: "Hochschule für Technik, Wirtschaft und Kultur Leipzig (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["htwk-leipzig.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.htwm.de/"],
    name: "Hochschule Mittweida (FH)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["htwm.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.htw-saarland.de/"],
    name: "Hochschule für Technik und Wirtschaft des Saarlandes",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["htw-saarland.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hu-berlin.de/"],
    name: "Humboldt Universität Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hu-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.hwp-hamburg.de/"],
    name: "HWP - Hamburger Universität für Wirtschaft und Politik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hwp-hamburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ihi-zittau.de/"],
    name: "Internationales Hochschulinstitut Zittau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ihi-zittau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.international.fh-aalen.de/"],
    name: "Internationale Fachhochschule Aalen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["international.fh-aalen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ism-dortmund.de/"],
    name: "International School of Management ISM Dortmund",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ism-dortmund.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.isnm.de/"],
    name: "International School of New Media, University of Lübeck",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["isnm.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.i-u.de/"],
    name: "International University in Germany",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["i-u.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.jacobs-university.de/"],
    name: "Jacobs University Bremen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["jacobs-university.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.karlshochschule.de/"],
    name: "Karlshochschule International University",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["karlshochschule.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kath-fh-nord.de/"],
    name: "Katholische Fachhochschule Norddeutschland",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kath-fh-nord.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kfb-berlin.de/"],
    name: "Katholische Fachhochschule Berlin (KFB)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kfb-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kfh-Freiburg.de/"],
    name: "Katholische Fachhochschule Freiburg, Hochschule für Sozialwesen, Religionspädagogik und Pflege",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kfh-freiburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kfh-mainz.de/"],
    name: "Katholische Fachhochschule Mainz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kfh-mainz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kfhnw.de/"],
    name: "Katholische Fachhochschule Nordrhein-Westfalen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kfhnw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kh-berlin.de/"],
    name: "Kunsthochschule Berlin-Weissensee, Hochschule für Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kh-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.khsa.de/"],
    name: "Katholische Hochschule für Soziale Arbeit Saarbrücken",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["khsa.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ksfh.de/"],
    name: "Katholische Stiftungsfachhochschule München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ksfh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ku-eichstaett.de/"],
    name: "Katholische Universität Eichstätt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ku-eichstaett.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kunstakademie-duesseldorf.de/"],
    name: "Kunstakademie Düsseldorf.",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kunstakademie-duesseldorf.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.merkur-fh.org/"],
    name: "Merkur Internationale FH Karlsruhe",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["merkur-fh.org"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.merz-akademie.de/"],
    name: "Merz Akademie, Hochschule für Gestaltung Stuttgart",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["merz-akademie.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.mfh-iserlohn.de/"],
    name: "Märkische Fachhochschule Iserlohn",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["mfh-iserlohn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.mh-hannover.de/"],
    name: "Medizinische Hochschule Hannover",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["mh-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.mh-trossingen.de/"],
    name: "Staatliche Hochschule für Musik",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["mh-trossingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.mu-luebeck.de/"],
    name: "Medizinische Universität Lübeck",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["mu-luebeck.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.muthesius.de/"],
    name: "Muthesius-Hochschule, Fachhochschule für Kunst und Gestaltung",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["muthesius.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.nordakademie.de/"],
    name: "Nordakademie, Staatlich anerkannte private Fachhochschule mit dualen Studiengängen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["nordakademie.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.paderborn.de/theofak/"],
    name: "Theologische Fakultät Paderborn",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["paderborn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.pfh-goettingen.de/"],
    name: "Private Fachhochschule Göttingen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["pfh-goettingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-erfurt.de/"],
    name: "Pädagogische Hochschule Erfurt/Mühlhausen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-erfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-freiburg.de/"],
    name: "Pädagogische Hochschule Freiburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-freiburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-gmuend.de/"],
    name: "Pädagogische Hochschule Schwäbisch Gmünd",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-gmuend.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-heidelberg.de/"],
    name: "Pädagogische Hochschule Heidelberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-heidelberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.philtheol-augustin.de/"],
    name: "Philosophisch-Theologische Hochschule SVD Sankt Augustin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["philtheol-augustin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-karlsruhe.de/"],
    name: "Pädagogische Hochschule Karlsruhe",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-karlsruhe.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-ludwigsburg.de/"],
    name: "Pädagogische Hochschule Ludwigsburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-ludwigsburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ph-weingarten.de/"],
    name: "Pädagogische Hochschule Weingarten",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ph-weingarten.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.popakademie.de/"],
    name: "Popakademie Baden-Württemberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["popakademie.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.privatfh-da.de/"],
    name: "Private FernFachhochschule Darmstadt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["privatfh-da.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.pth-bb.de/"],
    name: "Philosophisch-Theologische Hochschule der Salesianer Don Boscos",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["pth-bb.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.pth-muenster.de/"],
    name: "Philosophisch-Theologische Hochschule Münster",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["pth-muenster.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.pthv.de/"],
    name: "Philosophisch-Theologische Hochschule Vallendar der Gesellschaft des Katholischen Apostolates (Pallottiner)",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["pthv.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.rauheshaus.de/fachhochschule/"],
    name: 'Evangelische Fachhochschule für Sozialpädagogik der "Diakonenanstalt des Rauhen Hauses" Hamburg',
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["rauheshaus.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.rfh-koeln.de/"],
    name: "Rheinische Fachhochschule Köln",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["rfh-koeln.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ruhr-uni-bochum.de/"],
    name: "Ruhr-Universität Bochum",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["ruhr-uni-bochum.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.rwth-aachen.de/"],
    name: "Rheinisch Westfälische Technische Hochschule Aachen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["rwth-aachen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.selk.de/LThH/"],
    name: "Lutherische Theologische Hochschule Oberursel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["selk.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.siewerth-akademie.de/"],
    name: "Gustav-Siewerth-Akademie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["siewerth-akademie.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.siu-heidelberg.de/"],
    name: "Schiller International University, Heidelberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["siu-heidelberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.srh-berlin.de/"],
    name: "SRH University of Applied Sciences",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["srh-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.st-georgen.uni-frankfurt.de/"],
    name: "Philosophisch-Theologische Hochschule Sankt Georgen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["st-georgen.uni-frankfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.stw.de/shb/"],
    name: "Steinbeis-Hochschule-Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["stw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tfh-berlin.de/"],
    name: "Technische Fachhochschule Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tfh-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tfh-bochum.de/"],
    name: "Technische Fachhochschule Georg Agricola für Rohstoff, Energie und, Umwelt zu Bochum",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tfh-bochum.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tfh-wildau.de/"],
    name: "Technische Fachhochschule Wildau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tfh-wildau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.thh-friedensau.de/"],
    name: "Theologische Hochschule Friedensau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["thh-friedensau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tiho-hannover.de/"],
    name: "Tierärztliche Hochschule Hannover",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tiho-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-berlin.de/"],
    name: "Technische Universität Berlin",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-berlin.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-bs.de/"],
    name: "Technische Universität Carolo-Wilhelmina Braunschweig",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-bs.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-chemnitz.de/"],
    name: "Technische Universität Chemnitz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-chemnitz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-clausthal.de/"],
    name: "Technische Universität Clausthal",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-clausthal.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-cottbus.de/"],
    name: "Brandenburgische Technische Universität Cottbus",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-cottbus.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.tu-darmstadt.de/"],
    name: "Technische Universität Darmstadt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-darmstadt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-dresden.de/"],
    name: "Technische Universität Dresden",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-dresden.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-freiberg.de/"],
    name: "Technische Universität Bergakademie Freiberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-freiberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tuhh.de/"],
    name: "Technische Universität Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tuhh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-ilmenau.de/"],
    name: "Technische Universität Ilmenau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-ilmenau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tum.de/"],
    name: "Technische Universität München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tum.de", "tum.edu", "mytum.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-augsburg.de/"],
    name: "Universität Augsburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-augsburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-bamberg.de/"],
    name: "Otto-Friedrich Universität Bamberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-bamberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-bayreuth.de/"],
    name: "Universität Bayreuth",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-bayreuth.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-bielefeld.de/"],
    name: "Universität Bielefeld",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-bielefeld.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-bonn.de/"],
    name: "Rheinische Friedrich-Wilhelms Universität Bonn",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-bonn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-bremen.de/"],
    name: "Universität Bremen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-bremen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.unibw-hamburg.de/"],
    name: "Universität der Bundeswehr Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["unibw-hamburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.unibw-muenchen.de/"],
    name: "Universität der Bundeswehr München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["unibw-muenchen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.tu-dortmund.de/"],
    name: "Technische Universität Dortmund",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["tu-dortmund.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-duesseldorf.de/"],
    name: "Heinrich-Heine Universität Düsseldorf",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-duesseldorf.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-duisburg-essen.de/"],
    name: "Universität Duisburg-Essen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-duisburg-essen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-erfurt.de/phil-theol/"],
    name: "Philosophisch-Theologisches Studium Erfurt, Staatlich anerkannte Wissenschaftliche Hochschule",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-erfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-erfurt.de/"],
    name: "Universität Erfurt",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-erfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-erlangen.de/"],
    name: "Friedrich-Alexander Universität Erlangen-Nürnberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-erlangen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-flensburg.de/"],
    name: "Universität Flensburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-flensburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-frankfurt.de/"],
    name: "Johann Wolfgang Goethe Universität Frankfurt am Main",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-frankfurt.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-freiburg.de/"],
    name: "Albert-Ludwigs-Universität Freiburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-freiburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-giessen.de/"],
    name: "Justus Liebig Universität Gießen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-giessen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-goettingen.de/"],
    name: "Georg-August Universität Göttingen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-goettingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-greifswald.de/"],
    name: "Ernst-Moritz-Arndt Universität Greifswald",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-greifswald.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-halle.de/"],
    name: "Martin-Luther Universität Halle-Wittenberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-halle.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-hamburg.de/"],
    name: "Universität Hamburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-hamburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-hannover.de/"],
    name: "Universität Hannover",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-heidelberg.de/"],
    name: "Ruprecht-Karls-Universität Heidelberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-heidelberg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-hildesheim.de/"],
    name: "Universität Hildesheim",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-hildesheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-hohenheim.de/"],
    name: "Universität Hohenheim",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-hohenheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-jena.de/"],
    name: "Friedrich-Schiller Universität Jena",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-jena.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.kit.edu/"],
    name: "Karlsruher Institut für Technologie",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["kit.edu"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-kassel.de/"],
    name: "Universität Kassel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-kassel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-kiel.de/"],
    name: "Christian-Albrechts-Universität Kiel",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-kiel.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-kl.de/"],
    name: "Universität Kaiserslautern",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-kl.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-koblenz-landau.de/"],
    name: "Universität Koblenz-Landau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-koblenz-landau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-koeln.de/"],
    name: "Universität Köln",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-koeln.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-konstanz.de/"],
    name: "Universität Konstanz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-konstanz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-leipzig.de/"],
    name: "Universität Leipzig",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-leipzig.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-lueneburg.de/"],
    name: "Universität Lüneburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-lueneburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-magdeburg.de/"],
    name: "Otto-von-Guericke Universität Magdeburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-magdeburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-mainz.de/"],
    name: "Johannes-Gutenberg Universität Mainz",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-mainz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-mannheim.de/"],
    name: "Universität Mannheim",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-mannheim.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-marburg.de/"],
    name: "Phillips-Universität Marburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-marburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.lmu.de/", "http://www.uni-muenchen.de/"],
    name: "Ludwig-Maximilians-Universität München",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["lmu.de", "uni-muenchen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-muenster.de/", "http://www.wwu.de/"],
    name: "Westfälische Wilhelms-Universität Münster",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-muenster.de", "wwu.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://uol.de", "https://www.uni-oldenburg.de/"],
    name: "Carl von Ossietzky Universität Oldenburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uol.de", "uni-oldenburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-osnabrueck.de/"],
    name: "Universität Osnabrück",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-osnabrueck.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-paderborn.de/"],
    name: "Universität Paderborn",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-paderborn.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-passau.de/"],
    name: "Universität Passau",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-passau.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-potsdam.de/"],
    name: "Universität Potsdam",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-potsdam.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-polsdam.de/"],
    name: "Universität Polsdam",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-polsdam.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-regensburg.de/"],
    name: "Universität Regensburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-regensburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-rostock.de/"],
    name: "Universität Rostock",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-rostock.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-saarland.de/"],
    name: "Universität des Saarlandes",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-saarland.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-siegen.de/"],
    name: "Universität Siegen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-siegen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-stuttgart.de/"],
    name: "Universität Stuttgart",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-stuttgart.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-trier.de/uni/theo/"],
    name: "Theologische Fakultät Trier",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-trier.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-trier.de/"],
    name: "Universität Trier",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-trier.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-tuebingen.de/"],
    name: "Eberhard-Karls-Universität Tübingen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-tuebingen.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-ulm.de/"],
    name: "Universität Ulm",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-ulm.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-vechta.de/"],
    name: "Hochschule Vechta",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-vechta.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-weimar.de/"],
    name: "Bauhaus Universität Weimar",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-weimar.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-wh.de/"],
    name: "Private Universität Witten/Herdecke",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-wh.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-wuerzburg.de/"],
    name: "Bayerische Julius-Maximilians-Universität Würzburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-wuerzburg.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-wuppertal.de/"],
    name: "Bergische Universität Gesamthochschule Wuppertal",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-wuppertal.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.uni-wuppertal.de/inst/kiho/"],
    name: "Kirchliche Hochschule Wuppertal",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["uni-wuppertal.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.whu-koblenz.de/"],
    name: "Wissenschaftliche Hochschule für Unternehmensführung, Otto-Beisheim Hochschule",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["whu-koblenz.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.accrapolytechnic.edu.gh/"],
    name: "Accra Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["accrapolytechnic.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.acighana.org/"],
    name: "Akrofi-Christaller Institute of Theeology, Mission and  Culture",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["acighana.org"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.anuc.edu.gh/"],
    name: "All Nations University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["anuc.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.ashesi.edu.gh/"],
    name: "Ashesi University",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["ashesi.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.central.edu.gh/"],
    name: "Central University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["central.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.cpoly.edu.gh/"],
    name: "Cape Coast Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["cpoly.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.ghanacu.org/"],
    name: "Ghana Christian University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["ghanacu.org"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.gimpa.edu.gh/"],
    name: "Ghana Institute of Management and Public Administration (GIMPA)",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["gimpa.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.gtuc.edu.gh/"],
    name: "Ghana Telecom University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["gtuc.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.hopoly.edu.gh/"],
    name: "Ho Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["hopoly.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.iug.edu.gh/"],
    name: "Islamic University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["iug.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.knust.edu.gh/"],
    name: "Kwame Nkrumah University of Science and Technology",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["knust.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.koforiduapoly.edu.gh/"],
    name: "Koforidua Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["koforiduapoly.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.kpoly.edu.gh/"],
    name: "Kumasi Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["kpoly.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.pacuc.edu.gh/"],
    name: "Pan African Christian University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["pacuc.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.prempeh-college.com/"],
    name: "Prempeh College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["prempeh-college.com"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.presbyuniversity.edu.gh/"],
    name: "Presbyterian University College",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["presbyuniversity.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.regentghana.net/"],
    name: "Regent University College of Science and Technology",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["regentghana.net"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.tpoly.edu.gh/"],
    name: "Takoradi Polytechnic",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["tpoly.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.trinity.edu.gh/"],
    name: "Trinity Theological Seminary",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["trinity.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.ucc.edu.gh/"],
    name: "University of Cape Coast",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["ucc.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.uds.edu.gh/"],
    name: "University for Development Studies",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["uds.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.uew.edu.gh/"],
    name: "University of Education, Winneba",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["uew.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.ug.edu.gh/"],
    name: "University of Ghana",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["ug.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.vvu.edu.gh/"],
    name: "Valley View University",
    alpha_two_code: "GH",
    "state-province": null,
    domains: ["vvu.edu.gh"],
    country: "Ghana",
  },
  {
    web_pages: ["http://www.acg.gr/"],
    name: "American College of Greece",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["acg.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.act.edu/"],
    name: "American College of Thessaloniki",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["act.edu"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.aegean.gr/"],
    name: "Aegean University",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["aegean.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.agsm.gr/"],
    name: "Athens Graduate School of Management (AGSM)",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["agsm.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.alba.edu.gr/"],
    name: "Athens Laboratory of Business Administration (ALBA)",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["alba.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.asfa.gr/"],
    name: "Athens School of Fine Arts",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["asfa.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.aua.gr/"],
    name: "Agricultural University of Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["aua.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.aueb.gr/"],
    name: "Athens University of Economics and Business",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["aueb.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.auth.gr/"],
    name: "Aristotle University of Thessaloniki",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["auth.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.cityu.gr/"],
    name: "City University Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["cityu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.dei.edu.gr/"],
    name: "DEI Bachelor & Master Degrees",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["dei.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.duth.gr/"],
    name: "Dimocritus University of Thrace",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["duth.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.eap.gr/"],
    name: "Hellenic Open University",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["eap.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.euruni.edu/"],
    name: "European University, Athens Campus",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["euruni.edu"],
    country: "Greece",
  },
  {
    web_pages: ["https://www.hua.gr"],
    name: "Harokopio University",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["hua.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.ihu.edu.gr/"],
    name: "International Hellenic University",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["ihu.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.imd.edu.gr/"],
    name: "Institute of Management Development - Ohrid",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["imd.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.imese.gr/"],
    name: "Institute of Management & Enteurpreneurship of South East Europe",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["imese.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.laverne.edu.gr/"],
    name: "University of LaVerne in Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["laverne.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.ntua.gr/"],
    name: "National Technical University of Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["ntua.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.nyuniversity.net/"],
    name: "Yorker International University, Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["nyuniversity.net"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.panteion.gr/"],
    name: "Panteios University of Economics and Political Sciences Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["panteion.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.sse.gr/"],
    name: "Hellenic Army Academy",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["sse.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teiath.gr/"],
    name: "Technological Education Institute of Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teiath.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teiep.gr/"],
    name: "Technological Education Institute of Epiros",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teiep.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teihal.gr/"],
    name: "Technological Education Institute of Halkida, Euboea",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teihal.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teiher.gr/"],
    name: "Technological Education Institute of Heraklion",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teiher.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teikal.gr/"],
    name: "Technological Education Institute of Kalamata",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teikal.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teikav.edu.gr/"],
    name: "Technological Education Institute of Kavala",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teikav.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teikoz.gr/"],
    name: "Technological Education Institute of Kozani",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teikoz.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teilam.gr/"],
    name: "Technological Education Institute of Lamia",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teilam.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teilar.gr/"],
    name: "Technological Education Institute of Larissa",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teilar.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teimes.gr/"],
    name: "Technological Education Institute of Mesologgi",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teimes.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teipat.gr/"],
    name: "Technological Education Institute of Patras",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teipat.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teipir.gr/"],
    name: "Technological Education Institute of Piraeus",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teipir.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teiser.gr/"],
    name: "Technological Education Institute of Serres",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teiser.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teithe.gr/"],
    name: "Technological Education Institute of Thessaloniki",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teithe.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.teiwest.gr/"],
    name: "Technological Education Institute of Western Greece",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["teiwest.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.tuc.gr/"],
    name: "Technical University of Crete",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["tuc.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.ucg.gr/"],
    name: "University of Central Greece",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["ucg.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uindy.edu.gr/"],
    name: "University of Indianapolis in Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uindy.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uion.edu.gr/"],
    name: "Ionian University Corfu",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uion.edu.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.unipi.gr/"],
    name: "University of Piraeus",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["unipi.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uoa.gr/"],
    name: "University of Athens",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uoa.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uoc.gr/"],
    name: "University of Crete",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uoc.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uoi.gr/"],
    name: "University of Ioannina",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uoi.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uom.gr/"],
    name: "University of Macedonia",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uom.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uop.gr/"],
    name: "University of Peloponnese",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uop.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uowm.gr/"],
    name: "University of Western Macedonia",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uowm.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.upatras.gr/"],
    name: "University of Patras",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["upatras.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.uth.gr/"],
    name: "University of Thessaly",
    alpha_two_code: "GR",
    "state-province": null,
    domains: ["uth.gr"],
    country: "Greece",
  },
  {
    web_pages: ["http://www.ilisimatusarfik.gl/"],
    name: "University of Greenland",
    alpha_two_code: "GL",
    "state-province": null,
    domains: ["ilisimatusarfik.gl"],
    country: "Greenland",
  },
  {
    web_pages: ["http://www.sgu.edu/"],
    name: "St. George's University",
    alpha_two_code: "GD",
    "state-province": null,
    domains: ["sgu.edu"],
    country: "Grenada",
  },
  {
    web_pages: ["http://www.univ-ag.fr/"],
    name: "Université des Antilles et de la Guyane",
    alpha_two_code: "GP",
    "state-province": null,
    domains: ["univ-ag.fr"],
    country: "Guadeloupe",
  },
  {
    web_pages: ["http://www.uog.edu/"],
    name: "University of Guam",
    alpha_two_code: "GU",
    "state-province": null,
    domains: ["uog.edu"],
    country: "Guam",
  },
  {
    web_pages: ["http://www.cucv.edu.gt/"],
    name: "Centro Universitario Ciudad Vieja",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["cucv.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.cunoc.edu.gt/"],
    name: "Centro Universitario de Occidente",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["cunoc.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.galileo.edu/"],
    name: "Universidad Galileo",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["galileo.edu"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.ufm.edu.gt/"],
    name: "Universidad Francisco Marroquín",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["ufm.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.umg.edu.gt/"],
    name: "Universidad Mariano Gálvez",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["umg.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.unis.edu.gt/"],
    name: "Universidad del Istmo",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["unis.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.upana.edu.gt/"],
    name: "Universidad Panamericana",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["upana.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.url.edu.gt/"],
    name: "Universidad Rafael Landívar",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["url.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.urural.edu.gt/"],
    name: "Universidad Rural de Guatemala",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["urural.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.usac.edu.gt/"],
    name: "Universidad de San Carlos de Guatemala",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["usac.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.uvg.edu.gt/"],
    name: "Universidad del Valle de Guatemala",
    alpha_two_code: "GT",
    "state-province": null,
    domains: ["uvg.edu.gt"],
    country: "Guatemala",
  },
  {
    web_pages: ["http://www.uganc.org/"],
    name: "Université Gamal Abdel Nasser de Conakry",
    alpha_two_code: "GN",
    "state-province": null,
    domains: ["uganc.org"],
    country: "Guinea",
  },
  {
    web_pages: ["http://www.ujnk.org/"],
    name: "Université Julius Nyerere Kankan",
    alpha_two_code: "GN",
    "state-province": null,
    domains: ["ujnk.org"],
    country: "Guinea",
  },
  {
    web_pages: ["http://www.univ-kag.org/"],
    name: "Université Kofi Annan",
    alpha_two_code: "GN",
    "state-province": null,
    domains: ["univ-kag.org"],
    country: "Guinea",
  },
  {
    web_pages: ["http://www.utad-petel-edu.org/"],
    name: "Université Thierno Amadou Diallo",
    alpha_two_code: "GN",
    "state-province": null,
    domains: ["utad-petel-edu.org"],
    country: "Guinea",
  },
  {
    web_pages: ["http://www.gemsvilleuniversity.com/"],
    name: "Gemsville Technical University",
    alpha_two_code: "GY",
    "state-province": null,
    domains: ["gemsvilleuniversity.com"],
    country: "Guyana",
  },
  {
    web_pages: ["http://www.greenheartmed.org/"],
    name: "Greenheart Medical School",
    alpha_two_code: "GY",
    "state-province": null,
    domains: ["greenheartmed.org"],
    country: "Guyana",
  },
  {
    web_pages: ["http://www.tauedu.org/"],
    name: "Texila American University",
    alpha_two_code: "GY",
    "state-province": null,
    domains: ["tauedu.org"],
    country: "Guyana",
  },
  {
    web_pages: ["http://www.uog.edu.gy/"],
    name: "University of Guyana",
    alpha_two_code: "GY",
    "state-province": null,
    domains: ["uog.edu.gy"],
    country: "Guyana",
  },
  {
    web_pages: ["http://www.auchaiti.org/"],
    name: "American University of the Caribbean",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["auchaiti.org"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.ucnh.org/"],
    name: "Université Chrétienne du Nord d'Haiti",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["ucnh.org"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.ueh.edu.ht/"],
    name: "Université d'Etat d'Haiti",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["ueh.edu.ht"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.undh.org/"],
    name: "Université Notre Dame d'Haïti",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["undh.org"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.uneph.org/"],
    name: "Université Épiscopale d'Haiti",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["uneph.org"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.uniq.edu/"],
    name: "Université Quisqueya",
    alpha_two_code: "HT",
    "state-province": null,
    domains: ["uniq.edu"],
    country: "Haiti",
  },
  {
    web_pages: ["http://www.pul.it/"],
    name: "Pontifcia Universitas Lateranensis",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["pul.it"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.pust.urbe.it/"],
    name: "Pontifcia Universitas a S.Thomas Aquinate in Urbe",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["pust.urbe.it"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.unigre.urbe.it/"],
    name: "Pontifcia Università Gregoriana",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["unigre.urbe.it"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.upra.org/"],
    name: "Athenaeum Pontificium Regina Apostolorum",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["upra.org"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.ups.urbe.it/"],
    name: "Università Pontifcia Salesiana",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["ups.urbe.it"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.urbaniana.edu/"],
    name: "Pontifcia Università Urbaniana",
    alpha_two_code: "VA",
    "state-province": null,
    domains: ["urbaniana.edu"],
    country: "Holy See (Vatican City State)",
  },
  {
    web_pages: ["http://www.ujcv.edu.hn/"],
    name: "Universidad José Cecilio del Valle",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["ujcv.edu.hn"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.unah.edu.hn/"],
    name: "Universidad Nacional Autónoma de Honduras",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["unah.edu.hn"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.unicah.edu/"],
    name: "Universidad Católica de Honduras",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["unicah.edu"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.unimetro.edu.hn/"],
    name: "Universidad Metropolitana de Honduras",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["unimetro.edu.hn"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.unitec.edu/"],
    name: "Universidad Tecnológica Centroamericana",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["unitec.edu"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.upnfm.edu.hn/"],
    name: 'Universidad Pedagógica Nacional "Francisco Morazán"',
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["upnfm.edu.hn"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.usps.edu.hn/", "http://www.usap.edu"],
    name: "Universidad de San Pedro Sula",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["usps.edu.hn", "usap.edu"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.uth.hn/"],
    name: "Universidad Tecnológica de Honduras",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["uth.hn"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.zamorano.edu/"],
    name: "Escuela Agricola Panamericana Zamorano",
    alpha_two_code: "HN",
    "state-province": null,
    domains: ["zamorano.edu"],
    country: "Honduras",
  },
  {
    web_pages: ["http://www.chuhai.edu.hk/"],
    name: "Chu Hai College",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["chuhai.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["https://www.cityu.edu.hk/"],
    name: "City University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["cityu.edu.hk", "um.cityu.edu.hk", "my.cityu.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.cuhk.hk/"],
    name: "Chinese University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["cuhk.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.hkapa.edu/"],
    name: "Hong Kong Academy for Performing Arts",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["hkapa.edu"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.hkbu.edu.hk/"],
    name: "Hong Kong Baptist University",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["hkbu.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.hksyc.edu/"],
    name: "Hong Kong Shue Yan College",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["hksyc.edu"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.hku.hk/"],
    name: "University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["hku.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.ied.edu.hk/"],
    name: "Hong Kong Institute of Education",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["ied.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.ln.edu.hk/"],
    name: "Lingnan University",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["ln.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.ouhk.edu.hk/"],
    name: "Open University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["ouhk.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.polyu.edu.hk/"],
    name: "Hong Kong Polytechnic University",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["polyu.edu.hk", "connect.polyu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.ust.hk/"],
    name: "Hong Kong University of Science and Technology",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["ust.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["https://www.eduhk.hk"],
    name: "The Education University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["s.eduhk.hk", "eduhk.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["http://www.agr.unideb.hu/"],
    name: "Debrecen University of Agricultural Sciences",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["agr.unideb.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.andrassyuni.hu/"],
    name: "Andrassy Gyula German Speaking University Budapest",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["andrassyuni.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.arts7.hu/"],
    name: "Hungarian Academy of Fine Arts Budapest",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["arts7.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.avicenna.hu/"],
    name: "Avicenna International College",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["avicenna.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.bdtf.hu/"],
    name: "Dániel Berzsenyi Teacher Training College",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["bdtf.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.bke.hu/"],
    name: "Budapest University of Economic Sciences and Public Administration",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["bke.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.bme.hu/"],
    name: "Technical University of Budapest",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["bme.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.ceu.hu/"],
    name: "Central European University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["ceu.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.dote.hu/"],
    name: "University Medical School of Debrecen",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["dote.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.drk.hu/"],
    name: "Reformed Theological Academy of Debrecen",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["drk.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.duf.hu/"],
    name: "College of Dunaujvaros",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["duf.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.efe.hu/"],
    name: "University of Sopron",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["efe.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.ehf.hu/"],
    name: "Esztergom Theological College",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["ehf.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.elte.hu/"],
    name: "Eötvös Lorand University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["elte.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.filmacademy.hu/"],
    name: "Academy of Drama and Film",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["filmacademy.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.hiete.hu/"],
    name: "Haynal Imre University of Health Sciences Budapest",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["hiete.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.hupe.hu/"],
    name: "Hungarian University of Physical Education",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["hupe.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.jpte.hu/"],
    name: "Janus Pannonius University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["jpte.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.kee.hu/"],
    name: "University of Horticulture and Food Industry",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["kee.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.kgre.hu/"],
    name: "Károl Gáspár University of the Reformed Church",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["kgre.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.kodolanyi.hu/"],
    name: "Kodolanyi Janos University College",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["kodolanyi.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.lfze.hu/"],
    name: "Liszt Ferenc Academy of Music Budapest",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["lfze.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.lib.klte.hu/"],
    name: "Kossuth Lajos University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["lib.klte.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.mif.hu/"],
    name: "Hungarian Academy of Craft and Design",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["mif.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.nyme.hu/"],
    name: "University of West Hungary",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["nyme.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.pote.hu/"],
    name: "University Medical School of Pécs",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["pote.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.ppke.hu/"],
    name: "Pázmány Péter Catholic University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["ppke.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.pte.hu/"],
    name: "University of Pecs",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["pte.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.sote.hu/"],
    name: "Semmelweis University of Medical Sciences",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["sote.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.sze.hu/"],
    name: "Séchenyi István University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["sze.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.szie.hu/"],
    name: "Szent István University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["szie.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.tkbf.hu/"],
    name: "Budapest Buddhist University",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["tkbf.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.unideb.hu/"],
    name: "University of Debrecen",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["unideb.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.uni-miskolc.hu/"],
    name: "University of Miskolc",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["uni-miskolc.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.uni-pannon.hu/"],
    name: "University of Pannonia",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["uni-pannon.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.univet.hu/"],
    name: "University of Veterinary Science",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["univet.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.u-szeged.hu/"],
    name: "University of Szeged",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["u-szeged.hu"],
    country: "Hungary",
  },
  {
    web_pages: ["http://www.bifrost.is/"],
    name: "Bifrost School of Business",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["bifrost.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.hi.is/"],
    name: "University of Iceland",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["hi.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.holar.is/"],
    name: "Holar University College",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["holar.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.hsvest.is/"],
    name: "University Centre of the Westfjords",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["hsvest.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.hvanneyri.is/"],
    name: "Hvanneyri Agricultural University",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["hvanneyri.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.iti.is/"],
    name: "Technological University of Iceland",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["iti.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.khi.is/"],
    name: "Iceland University of Education",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["khi.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.lhi.is/"],
    name: "Iceland Academy of the Arts",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["lhi.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.ru.is/"],
    name: "Reykjavík University",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["ru.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://www.unak.is/"],
    name: "University of Akureyri",
    alpha_two_code: "IS",
    "state-province": null,
    domains: ["unak.is"],
    country: "Iceland",
  },
  {
    web_pages: ["http://ntruhs.ap.nic.in/"],
    name: "University of Health Sciences Andhra Pradesh",
    alpha_two_code: "IN",
    "state-province": "Andhra Pradesh",
    domains: ["ntruhs.ap.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.aaidu.org/"],
    name: "Allahabad Agricultural Institute, Deemed University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["aaidu.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.aau.ac.in/"],
    name: "Assam Agricultural University",
    alpha_two_code: "IN",
    "state-province": "Assam",
    domains: ["aau.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ahduni.edu.in/"],
    name: "Ahmedabad University",
    alpha_two_code: "IN",
    "state-province": "Gujarat",
    domains: ["ahduni.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.aiims.ac.in/"],
    name: "All India Institute of Medical Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["aiims.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.aisectuniversity.ac.in/"],
    name: "AISECT University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["aisectuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.alagappauniversity.ac.in/"],
    name: "Alagappa University",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["alagappauniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.alldunivpio.org/"],
    name: "Allahabad University",
    alpha_two_code: "IN",
    "state-province": "Uttar Pradesh",
    domains: ["alldunivpio.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.altmeduniversity.com/"],
    name: "Open International University for Alternative Medicines",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["altmeduniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.altmedworld.net/"],
    name: "Indian Board of Alternative Medicine",
    alpha_two_code: "IN",
    "state-province": "West Bengal",
    domains: ["altmedworld.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.amity.edu/"],
    name: "Amity University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["amity.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.amrita.edu/"],
    name: "Amrita Vishwa Vidyapeetham (Deemed University)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["amrita.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.amtuni.com/"],
    name: "Amravati University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["amtuni.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.amu.ac.in/"],
    name: "Aligarh Muslim University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["amu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.andhrauniversity.info/"],
    name: "Andhra University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["andhrauniversity.info"],
    country: "India",
  },
  {
    web_pages: ["http://www.angrau.net/"],
    name: "Acharya Ranga Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["angrau.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.annamalaiuniversity.ac.in/"],
    name: "Annamalai University",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["annamalaiuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.annauniv.edu.in/"],
    name: "Anna University of Technology, Tirunelveli",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["annauniv.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.annauniv.edu/"],
    name: "Anna University",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["annauniv.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.apsurewa.nic.in/"],
    name: "Awadhesh Pratap Singh University",
    alpha_two_code: "IN",
    "state-province": "Madhya Pradesh",
    domains: ["apsurewa.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.aryainstitutejpr.com/"],
    name: "ARYA Institute of Engineering & Technology",
    alpha_two_code: "IN",
    "state-province": "Rajasthan",
    domains: ["aryainstitutejpr.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.assamuniversity.nic.in/"],
    name: "Assam University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["assamuniversity.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ayurveduniversity.com/"],
    name: "Gujarat Ayurved University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ayurveduniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bamu.net/"],
    name: "Dr. Babasaheb Ambedkar Marathwada Universtiy",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bamu.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.bamu.nic.in/"],
    name: "Berhampur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bamu.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.banasthali.org/"],
    name: "Banasthali University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["banasthali.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.bankurauniv.com/"],
    name: "Bankura University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bankurauniv.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bau.nic.in/"],
    name: "Birsa Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bau.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bbauindia.org/"],
    name: "Babasaheb Bhimrao Ambedkar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bbauindia.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.bckv.edu.in/"],
    name: "Bidhan Chandra Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bckv.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bdu.ernet.in/"],
    name: "Bharathidasan University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bdu.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.becs.ac.in/"],
    name: "Bengal Engineering College",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["becs.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://bengaluruuniversity.com/"],
    name: "Bangalore University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bengaluruuniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bhagwantuniversity.com/"],
    name: "Bhagwant University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bhagwantuniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bharathi.ernet.in/"],
    name: "Bharathiar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bharathi.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bharathuniv.com/"],
    name: "Bharath Institue Of Higher Education & Research",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bharathuniv.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bharatividyapeeth.edu/"],
    name: "Bharati Vidyapeeth University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bharatividyapeeth.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.bhavuni.edu/"],
    name: "Bhavnagar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bhavuni.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.bhu.ac.in/"],
    name: "Banaras Hindu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bhu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://bhub.ori.nic.in/ouat/"],
    name: "Orissa University of Agriculture and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bhub.ori.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://bitmesraranchi.org/"],
    name: "Birla Institute of Technology, Ranchi",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bitmesraranchi.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.bits-pilani.ac.in/"],
    name: "Birla Institute of Technology and Science",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bits-pilani.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bnmu.in/"],
    name: "Bhupendra Narayan Mandal University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bnmu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bput.org/"],
    name: "Biju Pattnaik University of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bput.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.brabu.net/"],
    name: "B. R. Ambedkar Bihar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["brabu.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.braou.ac.in/"],
    name: "Dr. B.R. Ambedkar Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["braou.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitj.ac.in/"],
    name: "Dr. B. R. Ambedkar National Institute of Technology Jalandhar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitj.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.brauagra.com/"],
    name: "Dr. Bhim Rao Abdekar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["brauagra.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.bsauniv.ac.in/"],
    name: "B. S. Abdur Rahman University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bsauniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bubhopal.nic.in/"],
    name: "Barkatullah University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bubhopal.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.bundelkhanduniversity.org/"],
    name: "Bundelkhand University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["bundelkhanduniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.burdwanuniversity.ac.in/"],
    name: "University of Burdwan",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["burdwanuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.caluniv.ac.in/"],
    name: "University of Calcutta",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["caluniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cau.org.in/"],
    name: "Central Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cau.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ccsuniversity.ac.in/"],
    name: "Chaudhary Charan Singh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ccsuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ccsuniversity.org/"],
    name: "Ch. Charan Singh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ccsuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.cesbm.ac.in/"],
    name: "Center for Entrepreneurship and Small Business Management",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cesbm.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.christuniversity.in/"],
    name: "Christ University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["christuniversity.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ciefl.org/"],
    name: "Central Institute of English and Foreign Languages",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ciefl.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.cife.edu.in/"],
    name: "Central Institute of Fisheries Education",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cife.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cihts.ac.in/"],
    name: "Central Institute of Higher Tibetan Studies",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cihts.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cmjuniversity.edu.in/"],
    name: "CMJ University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cmjuniversity.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.csauk.ac.in/"],
    name: "Chandra Shekhar Azad University of Agriculture and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["csauk.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cusat.ac.in/"],
    name: "Cochin University of Science and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cusat.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cvru.ac.in/"],
    name: "Dr. C.V. Raman University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["cvru.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.da-iict.org/"],
    name: "Dhirubhai Ambani Institute of Information and Communication Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["da-iict.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.darulhuda.com/"],
    name: "Darul Huda Islamic University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["darulhuda.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.davuniversity.org/"],
    name: "Dav University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["davuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.davv.ac.in/"],
    name: "Devi Ahilya University of Indore",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["davv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dbatechuni.org/"],
    name: "Dr. Babasaheb Ambedkar Technological University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dbatechuni.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.dbskkv.org/"],
    name: "Konkan Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dbskkv.org"],
    country: "India",
  },
  {
    web_pages: ["http://dbs.tn.nic.in/tnau/"],
    name: "Tamil Nadu Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dbs.tn.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dceonline.net/"],
    name: "Delhi College of Engineering (DCE)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dceonline.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.ddugu.edu.in/"],
    name: "Deen Dayal Upadhyay Gorakhpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ddugu.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.deccancollegepune.ac.in/"],
    name: "Deccan College Postgraduate and Research Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["deccancollegepune.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dei.ac.in/"],
    name: "Dayalbagh Educational Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dei.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dibru.ernet.in/"],
    name: "Dibrugarh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dibru.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dravidianuniversity.ac.in/"],
    name: "Dravidian University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dravidianuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.du.ac.in/"],
    name: "University of Delhi",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["du.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.dypatiluniversity.org/"],
    name: "Dr. D.Y. Patil University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["dypatiluniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.eiilmuniversity.ac.in/"],
    name: "Eiilm University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["eiilmuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.fatimacollege.net/"],
    name: "Fatima mata national college kollam kerala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["fatimacollege.net"],
    country: "India",
  },
  {
    web_pages: ["http://fri.icfre.gov.in/"],
    name: "Forest Research Institute Dehradun",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["fri.icfre.gov.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gbpuat.ac.in/"],
    name: "Govind Ballabh Pant University of Agriculture and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gbpuat.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ggu.ac.in/"],
    name: "Guru Ghasidas University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ggu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gipe.ernet.in/"],
    name: "Gokhale Institute of Politics and Economics",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gipe.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gitam.edu/"],
    name: "Gandhi Institute of Technology and Managment",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gitam.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.gju.ernet.in/"],
    name: "Guru Jambeshwar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gju.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gkvharidwar.org/"],
    name: "Gurukula Kangri University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gkvharidwar.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.gnduonline.org/"],
    name: "Guru Nanak Dev University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gnduonline.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.government.ind.in/"],
    name: "Global Open University , Nagaland",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["government.ind.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gtu.ac.in/"],
    name: "Gujarat Technological University Ahmedabad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gtu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gujaratuniversity.org.in/"],
    name: "Gujarat University Ahmedabad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gujaratuniversity.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gulbargauniversity.kar.nic.in/"],
    name: "Gulbarga University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gulbargauniversity.kar.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gu.nic.in/"],
    name: "Gauhati University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gu.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.gurukuluniversity.org/"],
    name: "Gurukul University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["gurukuluniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://hau.ernet.in/"],
    name: "CCS Haryana Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hau.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.hau.ernet.in/"],
    name: "Chaudhary Charan Singh Haryana Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hau.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://hillagric.ernet.in/"],
    name: "Himachal Pradesh Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hillagric.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.hnbgu.ac.in/"],
    name: "Hemwati Nandan Bahuguna Garhwal University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hnbgu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.hnluraipur.com/"],
    name: "Hidayatullah National Law University, Raipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hnluraipur.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.hostindia.com/srmc/"],
    name: "Sri Ramachardra Medical College and Research Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hostindia.com"],
    country: "India",
  },
  {
    web_pages: ["http://hpuniv.nic.in/"],
    name: "Himachal Pradesh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["hpuniv.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iari.ernet.in/"],
    name: "Indian Agricultural Research Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iari.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iaseduniv.org/"],
    name: "IASE (Institute of Advanced Studies) Deemed University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iaseduniv.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.icfai.org/"],
    name: "ICFAI University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["icfai.org"],
    country: "India",
  },
  {
    web_pages: ["https://www.iudehradun.edu.in/"],
    name: "ICFAI University, Dehradun",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iudehradun.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iutripura.edu.in/"],
    name: "ICFAI University, Tripura",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iutripura.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iusikkim.edu.in/"],
    name: "ICFAI University, Sikkim",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iusikkim.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iumizoram.edu.in/"],
    name: "ICFAI University, Mizoram",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iumizoram.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iumeghalaya.edu.in/"],
    name: "ICFAI University, Meghalaya",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iumeghalaya.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iujharkhand.edu.in/"],
    name: "ICFAI University, Jharkhand",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iujharkhand.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iunagaland.edu.in/"],
    name: "ICFAI University, Nagaland",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iunagaland.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iujaipur.edu.in/"],
    name: "ICFAI University, Jaipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iujaipur.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iuraipur.edu.in/"],
    name: "ICFAI University, Raipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iuraipur.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.iuhimachal.edu.in/"],
    name: "ICFAI University, Himachal Pradesh",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iuhimachal.edu.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.ifheindia.org/"],
    name: "ICFAI University, Hyderabad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ifheindia.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.igau.edu.in/"],
    name: "Indira Gandhi Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["igau.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.igidr.ac.in/"],
    name: "Indira Gandhi Institute of Development and Research",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["igidr.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.igims.org/"],
    name: "Indira Gandhi Institute of Medical Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["igims.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.ignou.ac.in/"],
    name: "Indira Gandhi National Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ignou.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iiita.com/"],
    name: "Indian Institute of Information Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiita.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.iiitmk.ac.in/"],
    name: "Indian Institute of Information Technology and Management - Kerala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitmk.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iiitm.ac.in/"],
    name: "Indian Institute of Information Technology and Management - Gwalior",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitm.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iiitd.ac.in/"],
    name: "Indraprastha Institute of Information Technology, Delhi",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitd.ac.in"],
    country: "India",
  },
  {
    web_pages: ["www.isquareit.ac.in/"],
    name: "International Institute of Information Technology, Pune",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["squareit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["www.iiit-bh.ac.in/"],
    name: "International Institute of Information Technology, Bhubaneswar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiit-bh.ac.in"],
    country: "India",
  },
  {
    web_pages: ["www.iiitb.ac.in/"],
    name: "International Institute of Information Technology, Bangalore",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitb.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iimtrichy.ac.in/"],
    name: "Indian Institute of Management, Tiruchirappalli",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iimtrichy.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iimtrichy.ac.in/"],
    name: "Indian Institute of Information Technology, Guwahati",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitg.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://iiitvadodara.ac.in/"],
    name: "Indian Institute of Information Technology, Vadodara",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitvadodara.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://iiitkota.ac.in/"],
    name: "Indian Institute of Information Technology, Kota",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiitkota.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iipsindia.org/"],
    name: "International Institute for Population Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iipsindia.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.iisc.ernet.in/"],
    name: "Indian Institute of Science",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iisc.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitb.ac.in/"],
    name: "Indian Institute of Technology, Bombay",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitb.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitd.ernet.in/"],
    name: "Indian Institute of Technology, Delhi",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitd.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["https://iitgn.ac.in/"],
    name: "Indian Institute of Technology, Gandhinagar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitgn.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitg.ernet.in/", "http://www.iitg.ac.in/"],
    name: "Indian Institute of Technology, Guwahati",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitg.ernet.in", "iitg.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iith.ac.in/"],
    name: "Indian Institute of Technology, Hyderabad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iith.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitk.ac.in/"],
    name: "Indian Institute of Technology, Kanpur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitk.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitkgp.ernet.in/"],
    name: "Indian Institute of Technology, Kharagpur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitkgp.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitm.ac.in/"],
    name: "Indian Institute of Technology, Madras",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitm.ac.in"],
    country: "India",
  },
  {
    web_pages: ["https://www.mitindia.edu/en/"],
    name: "Madras Institute of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mitindia.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitr.ac.in/"],
    name: "Indian Institute of Technology, Roorkee",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitr.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitp.ac.in/"],
    name: "Indian Institute of Technology, Patna",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitp.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iiti.ac.in/"],
    name: "Indian Institute of Technology, Indore",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iiti.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iitj.ac.in/"],
    name: "Indian Institute of Technology, Jodhpur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iitj.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.iksvv.com/"],
    name: "University of Music and Fine Arts",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iksvv.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.ilidelhi.org/"],
    name: "Indian Law Institue",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ilidelhi.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.indusuni.ac.in/"],
    name: "Indus University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["indusuni.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.integraluniversity.ac.in/"],
    name: "Integral University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["integraluniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ipu.ac.in/"],
    name: "Guru Gobind Singh Indraprastha University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ipu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://isbm.org.in/"],
    name: "Indian School of Business Management and Administration",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["isbm.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.isical.ac.in/"],
    name: "Indian Statistical Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["isical.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ismdhanbad.ac.in/"],
    name: "Indian School of Mines (ISM)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ismdhanbad.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.itmindia.edu/"],
    name: "Institute of Technology and Management",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["itmindia.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.iur.ac.in/"],
    name: "Indian University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["iur.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ivri.nic.in/"],
    name: "Indian Veterinary Research Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ivri.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jadavpur.edu/"],
    name: "Jadavpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jadavpur.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.jainuniversity.org/"],
    name: "First Global University to teaching Jainism",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jainuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.jamiahamdard.edu/"],
    name: "Jamia Hamdard University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jamiahamdard.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.jammuvarsity.org/"],
    name: "University of Jammu",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jammuvarsity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.jiit.ac.in/"],
    name: "Jaypee Institute of Information Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jiit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jiwaji.edu/"],
    name: "Jiwaji University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jiwaji.edu"],
    country: "India",
  },
  {
    web_pages: ["http://jmi.nic.in/"],
    name: "Jamia Millia Islamia University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jmi.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jncasr.ac.in/"],
    name: "Jawaharlal Nehru Centre for Advanced  Scientific Research",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jncasr.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jnkvv.nic.in/"],
    name: "Jawaharlal Nehru Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jnkvv.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jntu.ac.in/"],
    name: "Jawaharlal Nehru Technological University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jntu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jnu.ac.in/"],
    name: "Jawaharlal Nehru University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jnu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jnujaipur.ac.in/"],
    name: "Jaipur National University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jnujaipur.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jodhpurnationaluniversity.com/"],
    name: "Jodhpur National University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jodhpurnationaluniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://jpv.bih.nic.in/"],
    name: "Jai Prakash University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jpv.bih.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.jrnrvu.org/"],
    name: "Rajasthan Vidyapeeth University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jrnrvu.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.jvbi.ac.in/"],
    name: "Jain Vishva Bharati Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["jvbi.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kalingauniversity.com/"],
    name: "Kalinga University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kalingauniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.kanchiuniv.ac.in/"],
    name: "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kanchiuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kannadauniversity.org/"],
    name: "Kannada University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kannadauniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.kannuruniversity.ac.in/"],
    name: "Kannur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kannuruniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kanpuruniversity.org/"],
    name: "Chhatrapati Shahu Ji Maharaj University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kanpuruniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.kanpuruniversity.org/"],
    name: "Kanpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kanpuruniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.karnatakastateopenuniversity.in/"],
    name: "Karnataka State Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["karnatakastateopenuniversity.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.karpagamuniv.com/"],
    name: "Karpagam University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["karpagamuniv.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.karunya.edu/"],
    name: "Karunya Institute Of Technology ( Deemed University)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["karunya.edu"],
    country: "India",
  },
  {
    web_pages: ["http://kashmiruniversity.net/"],
    name: "University of Kashmir",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kashmiruniversity.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.kau.edu/"],
    name: "Kerala Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kau.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.keralauniversity.ac.in/"],
    name: "University of Kerala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["keralauniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://kimi.kohinoor.ac.in/"],
    name: "Kohinoor School of Hospitality Management",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kimi.kohinoor.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.klyuniv.ac.in/"],
    name: "University of Kalyani",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["klyuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.krishnauniversity.ac.in/"],
    name: "Krishna University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["krishnauniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ksdsu.edu.in/"],
    name: "Kameshwar Singh Darbhanga Sanskrit University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ksdsu.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kslu.ac.in/"],
    name: "Karnataka State Law University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kslu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kud.ac.in/"],
    name: "Karnatak University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kud.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kufos.ac.in/"],
    name: "Kerala University of Fisheries and Ocean Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kufos.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kukinfo.com/"],
    name: "Kurukshetra University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kukinfo.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.kct.ac.in/"],
    name: "Kumaraguru College of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kct.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kumaununiversity.org/"],
    name: "Kumaun University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kumaununiversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.kuvempu.ac.in/"],
    name: "Kuvempu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kuvempu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.kuwarangal.com/"],
    name: "Kakatiya University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["kuwarangal.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.ldceahd.org/"],
    name: "L.D.College of Engineering",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ldceahd.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.lnipe.edu/"],
    name: "Lakshmibai National Institute of Physical Education",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["lnipe.edu"],
    country: "India",
  },
  {
    web_pages: ["http://lnmu.bih.nic.in/"],
    name: "Lalit Narayan Mithila University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["lnmu.bih.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.lucknowuniv.org/"],
    name: "University of Lucknow",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["lucknowuniv.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.macfast.org/"],
    name: "Mar Athanasios College for Advanced Studies",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["macfast.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.magadhuniversity.org/"],
    name: "Magadh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["magadhuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.mangaloreuniversity.ac.in/"],
    name: "Mangalore University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mangaloreuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.manipal.edu/"],
    name: "Manipal University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["manipal.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.manipur.nic.in/maniuniversity.htm"],
    name: "Manipur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["manipur.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.manuu.ac.in/"],
    name: "Moulana Azad national Urdu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["manuu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mcu.ac.in/"],
    name: "Makanlal Chutur Vedi University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mcu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mcu.ac.in/"],
    name: "Makhanlal Chaturvedi National University of Journalism and Communication",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mcu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mdsuajmer.ac.in/"],
    name: "Maharshi Dayanand Sarswati University Ajmer",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mdsuajmer.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mdurohtak.com/"],
    name: "Maharishi Dayanand University, Rohtak (Haryana )",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mdurohtak.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.mgkvp.ac.in/"],
    name: "Mahatma Gandhi Kashi Vidyapith",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mgkvp.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mgsubikaner.ac.in/"],
    name: "Maharaja Ganga Singh University, Bikaner",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mgsubikaner.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mgu.ac.in/"],
    name: "Mahatma Gandhi University, Kerala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mgu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mjpru.ac.in/"],
    name: "Mahatma Jyotiba Phule Rohilkhand University Bareilly",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mjpru.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mkuhyd.com/"],
    name: "Madurai Kamaraj University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mkuhyd.com"],
    country: "India",
  },
  {
    web_pages: ["http://mkv2.mah.nic.in/"],
    name: "Marathwada Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mkv2.mah.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mlsu.ac.in/"],
    name: "Mohan Lal Sukhadia University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mlsu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mnnit.ac.in/"],
    name: "Motilal Nehru National Institute Of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mnnit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mpbou.org/"],
    name: "Madhya Pradesh Bhoj (Open) University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mpbou.org"],
    country: "India",
  },
  {
    web_pages: ["http://mpkv.mah.nic.in/"],
    name: "Mahatma Phule Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mpkv.mah.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.msubaroda.ac.in/"],
    name: "Maharaja Sayajirao University of Baroda",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["msubaroda.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mu.ac.in/"],
    name: "University of Mumbai",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nagarjunauniversity.ac.in/"],
    name: "Acharya Nagarjuna University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nagarjunauniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nagauniv.org.in/"],
    name: "Nagaland University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nagauniv.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nagpur-university.com/"],
    name: "Nagpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nagpur-university.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.nalandaopenuniversity.info/"],
    name: "Nalanda Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nalandaopenuniversity.info"],
    country: "India",
  },
  {
    web_pages: ["http://www.nationalmuseumindia.org/nmi/index.htm"],
    name: "National Museum Institute of History of Art, Conservation and Museology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nationalmuseumindia.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.nbu.ac.in/"],
    name: "University of North Bengal",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nbu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://ndri.nic.in/"],
    name: "National Dairy Research Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ndri.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nduat.nic.in/"],
    name: "Narendra Deva University of Agriculture and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nduat.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nehu.ac.in/"],
    name: "North Eastern Hill University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nehu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ngu.ac.in/"],
    name: "Hemchandracharay North Gujarat University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ngu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nimhans.kar.nic.in/"],
    name: "National Institute of Mental Health and Neuro Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nimhans.kar.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://nims.ap.nic.in/"],
    name: "Nizam's Institute of Medical Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nims.ap.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nims.net.in/"],
    name: "Institute of Management Studies",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nims.net.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nirmauni.ac.in/"],
    name: "Nirma University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nirmauni.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitie.edu/"],
    name: "National Institute of Industrial Engineering",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitie.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.nita.ac.in/"],
    name: "National Institute of Technology Agartala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nita.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitandhra.ac.in/"],
    name: "National Institute of Technology Andhra Pradesh",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitandhra.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitap.in/"],
    name: "National Institute of Technology Arunachal Pradesh",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitap.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitc.ac.in/"],
    name: "National Institute of Technology Calicut",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitc.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitdelhi.ac.in/"],
    name: "National Institute of Technology Delhi",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitdelhi.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitdgp.ac.in/"],
    name: "National Institute of Technology Durgapur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitdgp.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitgoa.ac.in/"],
    name: "National Institute of Technology Goa",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitgoa.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nith.ac.in/"],
    name: "National Institute of Technology Hamirpur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nith.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitjsr.ac.in/"],
    name: "National Institute of Technology Jamshedpur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitjsr.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitkkr.net/"],
    name: "National Institute of Technology Kurukshetra",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitkkr.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitmanipur.ac.in"],
    name: "National Institute of Technology Manipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitmanipur.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitm.ac.in"],
    name: "National Institute of Technology Meghalaya",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitm.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitmz.ac.in"],
    name: "National Institute of Technology Mizoram",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitmz.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitnagaland.ac.in"],
    name: "National Institute of Technology Nagaland",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitnagaland.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitp.ac.in"],
    name: "National Institute of Technology Patna",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitp.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitpy.ac.in"],
    name: "National Institute of Technology Puducherry",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitpy.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitrr.ac.in"],
    name: "National Institute of Technology Raipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitrr.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitrkl.ac.in/"],
    name: "National Institute of Technology Rourkela",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitrkl.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitsikkim.ac.in/"],
    name: "National Institute of Technology Sikkim",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitsikkim.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nits.ac.in/"],
    name: "National Institute of Technology Silchar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nits.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitsri.net/"],
    name: "National Institute of Technology Srinagar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitsri.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitk.ac.in/"],
    name: "National Institute of Technology Surathkal",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitk.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitt.edu/"],
    name: "National Institute of Technology Trichy",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitt.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.nituk.ac.in/"],
    name: "National Institute of Technology Uttarakhand",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nituk.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nitw.ernet.in/"],
    name: "National Institute of Technology Warangal",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nitw.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nls.ac.in/"],
    name: "National Law School of India University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nls.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nmims.edu/"],
    name: "Narsee Monjee Institute of Management Studies",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nmims.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.nmu.ac.in/"],
    name: "North Maharashtra University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nmu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nsit.ac.in/"],
    name: "Netaji Subhas Institute of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["nsit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.osmania.ac.in/"],
    name: "Osmania University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["osmania.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.padmavatiwomen-univ.org/"],
    name: "Sri Padmavati Women's University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["padmavatiwomen-univ.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.pdpu.ac.in/"],
    name: "Pandit Deendayal Petroleum University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pdpu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.pau.edu/"],
    name: "Punjab Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pau.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.pdkv.ac.in/"],
    name: "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pdkv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.paruluniversity.ac.in/"],
    name: "Parul University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["paruluniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.pec.ac.in/"],
    name: "Punjab Engineering College",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pec.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.pes.edu/"],
    name: "Pes University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pes.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.pgimer.nic.in/"],
    name: "Postgraduate lnstitute of Medical Education and Research",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pgimer.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.pondiuni.org/"],
    name: "Pondicherry University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pondiuni.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.psgtech.edu/"],
    name: "PSG College of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["psgtech.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.ptetjnvu.org/"],
    name: "Jai Narain Vyas University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ptetjnvu.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.ptu.ac.in/"],
    name: "Punjab Technical University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ptu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.puchd.ac.in/"],
    name: "Panjab University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["puchd.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.punjabiuniversity.ac.in/"],
    name: "Punjabi University Patiala",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["punjabiuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://puonline.bih.nic.in/"],
    name: "Patna University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["puonline.bih.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.pusavarsity.org.in/"],
    name: "Rajendra Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["pusavarsity.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.rabindrabharatiuniversity.net/"],
    name: "Rabindra Bharati University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rabindrabharatiuniversity.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.ranchiuniversity.org.in/"],
    name: "Ranchi University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ranchiuniversity.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.raubikaner.org/"],
    name: "Rajasthan Agricultural University, Bikaner",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["raubikaner.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.rdunijbpin.org/"],
    name: "Rani Durgavati University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rdunijbpin.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.rgtu.net/"],
    name: "Rajiv Gandhi Technical University (University of Technology of Madhya Pradesh)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rgtu.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.rgu.ac.in/"],
    name: "Rajiv Gandhi University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rgu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.riths.ac.in/"],
    name: "Rajitlal Institute of Technology & Health Sciences (RITHS)",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["riths.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.rmlau.ac.in/"],
    name: "Dr. Ram Manohar Lohia Avadh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rmlau.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.rsuniversity.com/"],
    name: "Pandit Ravi Shankar Shukla University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rsuniversity.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.rtu.ac.in/"],
    name: "Rajasthan Technical University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["rtu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.ruraluniversity-chitrakoot.org/"],
    name: "Mahatma Gandhi Chitrakut Gramoday University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ruraluniversity-chitrakoot.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.sagaruniversity.nic.in/"],
    name: "Dr. Hari Singh Gour University, formerly University of Sagar",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sagaruniversity.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sambalpuruniversitypgc.in/"],
    name: "Sambalpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sambalpuruniversitypgc.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sanskrit.nic.in/"],
    name: "National Sanskrit University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sanskrit.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sastra.edu/"],
    name: "SASTRA Deemed University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sastra.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.sathyabamauniv.ac.in/"],
    name: "Sathyabama University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sathyabamauniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.saurashtrauniversity.edu/"],
    name: "Saurashtra University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["saurashtrauniversity.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.sce.ac.in/"],
    name: "Shanmugha Arts Science Technology and Research Academy",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sce.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://sctimst.ker.nic.in/"],
    name: "Sree Chitra Tirunal Institute for Medical Sciences and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sctimst.ker.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sdau.edu.in/"],
    name: "Sardarkrushinagar Dantiwada Agricultural University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sdau.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sgpgi.ac.in/"],
    name: "Sanjay Gandhi Postgraduate lnstitute of Medical Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sgpgi.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sgu.ernet.in/"],
    name: "South Gujarat University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sgu.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.shobhituniversity.ac.in/"],
    name: "Shobhit University, Meerut",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["shobhituniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.shridharuniversity.ac.in/"],
    name: "Shridhar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["shridharuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.simhapuriuniv.ac.in/"],
    name: "Vikrama Simhapuri University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["simhapuriuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.siu.edu.in/"],
    name: "Symbiosis International University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["siu.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sjsv.nic.in/"],
    name: "Shri Jagannath Sanskrit University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sjsv.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.skmu.edu.in/"],
    name: "Sido Kanhu Murmu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["skmu.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.skuastkashmir.ac.in/"],
    name: "Sher-E-Kashmir University of Agricultural Sciences and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["skuastkashmir.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://skuniv.ap.nic.in/"],
    name: "Sri Krishnadevaraya University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["skuniv.ap.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.slbsrsv.ac.in/"],
    name: "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["slbsrsv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.smkfomra.net/"],
    name: "SMK Fomra Institute of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["smkfomra.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.smu.edu.in/"],
    name: "Sikkim Manipal University of Health, Medical and Technological Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["smu.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.sndt.edu/"],
    name: "Shreemati Nathibai Damodar Thackersey Women's University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["sndt.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.soauniversity.ac.in/"],
    name: "Sikha 'O' Anushandhan University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["soauniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.southasianuniversity.org/"],
    name: "South Asian University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["southasianuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.spa.ac.in/"],
    name: "School of Planning and Architecture",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["spa.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.spuniv.org/"],
    name: "Periyar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["spuniv.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.spuvvn.edu/"],
    name: "Sardar Patel University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["spuvvn.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.srisathyasai.org.in/pages/instts/HighLearn.htm"],
    name: "Sri Sathya Sai Institute of Higher Learning",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["srisathyasai.org.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.srkdc.org/"],
    name: "Sree Rama Krishna Degree College",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["srkdc.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.srmuniv.ac.in/"],
    name: "SRM Institute Of Science & Technology ( Deemed University)",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["srmuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.srtmun.org/"],
    name: "Swami Ramanand Teerth Marathwada University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["srtmun.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.ssgmce.org/"],
    name: "Sri Sant Gajanan Maharaj College of Engineering",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ssgmce.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.ssus.ac.in/"],
    name: "Sree Sankaracharya University of Sanskrit",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ssus.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://ssvv.up.nic.in/"],
    name: "Sampurnanand Sanskrit University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ssvv.up.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://su.digitaluniversity.ac/"],
    name: "Solapur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["su.digitaluniversity.ac"],
    country: "India",
  },
  {
    web_pages: ["http://www.svbpuctm.org/"],
    name: "Sardar Vallabhai Patel University of Agriculture Amd Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["svbpuctm.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.svnit.ac.in/"],
    name: "Sardar Vallabhbhai National Institute of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["svnit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://svimstpt.ap.nic.in/"],
    name: "Sri Venkateswara Institute of Medical Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["svimstpt.ap.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://svuni.ap.nic.in/"],
    name: "Sri Venkateswara University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["svuni.ap.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tamiluniversity.ac.in/"],
    name: "Tamil University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tamiluniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tanuvas.com/"],
    name: "Tamil Nadu Veterinary and Animal Sciences University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tanuvas.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.tce.edu/"],
    name: "Thiagarajar College of Engineering",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tce.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.teluguuniversity.ac.in/"],
    name: "Potti Sreeramulu Telugu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["teluguuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.teluguuniversity.ac.in/"],
    name: "Telugu University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["teluguuniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tezu.ernet.in/"],
    name: "Tezpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tezu.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.thenewcollege.org/"],
    name: "The New College",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["thenewcollege.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.tiet.ac.in/"],
    name: "Thapar Institute of Engineering and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tiet.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tiss.edu/"],
    name: "Tata Institute of Social Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tiss.edu"],
    country: "India",
  },
  {
    web_pages: ["http://www.tmbu.org/"],
    name: "Tilka Manjhi Bhagalpur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tmbu.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.tmv.edu.in/"],
    name: "Tilak Maharashtra Vidyapeeth",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tmv.edu.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tndalu.org/"],
    name: "Tamil Nadu Dr. Ambedkar Law University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tndalu.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.tnmmu.ac.in/"],
    name: "Tamil Nadu Dr. M.G.R. Medical University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tnmmu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tnuniv.ac.in/adu/"],
    name: "Avinashilingam Institute for Home Science and Higher Education for Women",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tnuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tnuniv.ac.in/gri/"],
    name: "Gandhigram Rural Institute",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tnuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tnuniv.ac.in/msu/"],
    name: "Manonmaniam Sundaranar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tnuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tnuniv.ac.in/mteresa/"],
    name: "Mother Teresa Women's University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tnuniv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.manit.ac.in/"],
    name: "Maulana Azad National Institute of Technology Bhopal",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["manit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.mnit.ac.in/"],
    name: "Malaviya National Institute of Technology Jaipur",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["mnit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tripurauniv.in/"],
    name: "Tripura University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tripurauniv.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tshmc.org/"],
    name: "Takhatmal Shrivallabh Homoeopathic Medical College",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tshmc.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.tumkuruniversity.ac.in/"],
    name: "Tumkur University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tumkuruniversity.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.tvuni.in/"],
    name: "Thiruvalluvar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["tvuni.in"],
    country: "India",
  },
  {
    web_pages: ["http://uasbng.kar.nic.in/"],
    name: "University of Agricultural Sciences, Bangalore",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uasbng.kar.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uasd.net/"],
    name: "University of Agricultural Sciences, Dharwad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uasd.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.uktech.ac.in/"],
    name: "Uttarakhand Technical University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uktech.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uma.ac.in/"],
    name: "University of Media Arts",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uma.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://unical.ac.in/"],
    name: "University of Calicut",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["unical.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.unigoa.ac.in/"],
    name: "Goa University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["unigoa.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uni-mysore.ac.in/"],
    name: "University of Mysore",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uni-mysore.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.unipune.ernet.in/"],
    name: "University of Pune",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["unipune.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uniraj.org/"],
    name: "University of Rajasthan",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uniraj.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.unishivaji.ac.in/"],
    name: "Shivaji University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["unishivaji.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.unom.ac.in/"],
    name: "University of Madras",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["unom.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uohyd.ernet.in/"],
    name: "University of Hyderabad",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uohyd.ernet.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uok.ac.in/"],
    name: "University of Kota",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uok.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uor.org/"],
    name: "University of Roorkee",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uor.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.uou.ac.in/"],
    name: "Uttarakhand Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uou.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.uptu.ac.in/"],
    name: "Uttar Pradesh Technical University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["uptu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.utkaluniv.org/"],
    name: "Utkal University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["utkaluniv.org"],
    country: "India",
  },
  {
    web_pages: ["http://vbspu.ac.in/"],
    name: "VBS Purvanchal University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vbspu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vbu.co.in/"],
    name: "Vinoba Bhave University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vbu.co.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vidyasagar.ac.in/"],
    name: "Vidyasagar University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vidyasagar.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vignanuniversity.org/"],
    name: "Vignan University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vignanuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.vikramuniversity.org/"],
    name: "Vikram University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vikramuniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.vinayakamissions.com/"],
    name: "Vinayaka Mission's Research Foundation-Deemed University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vinayakamissions.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.visva-bharati.ac.in/"],
    name: "Visva-Bharati University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["visva-bharati.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vit.ac.in/"],
    name: "Vellore Institute of Technology",
    alpha_two_code: "IN",
    "state-province": "Tamil Nadu",
    domains: ["vit.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vksu-ara.org/"],
    name: "Veer Kunwar Singh University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vksu-ara.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.vmou.ac.in/"],
    name: "Vardhaman Mahaveer Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vmou.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vnitnagpur.ac.in/"],
    name: "Visvesvaraya National Institute of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vnitnagpur.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vssut.ac.in/"],
    name: "Veer Surendra Sai University of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vssut.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.vtu.ac.in/"],
    name: "Visvesvaraya Technological University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["vtu.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.wbuafs.nic.in/"],
    name: "West Bengal University of Animal and Fishery Sciences",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["wbuafs.nic.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.wbut.net/"],
    name: "West Bengal University of Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["wbut.net"],
    country: "India",
  },
  {
    web_pages: ["http://www.ycmou.com/"],
    name: "Yashawantrao Chavan Maharashtra Open University",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ycmou.com"],
    country: "India",
  },
  {
    web_pages: ["http://www.ysparmaruniversity.org/"],
    name: "Dr. YS Parmar University of Horticulture and Forestry",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["ysparmaruniversity.org"],
    country: "India",
  },
  {
    web_pages: ["http://www.akfarmitseda.ac.id/"],
    name: "Akademi Farmasi Mitra Sehat Mandiri Sidoarjo",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["akfarmitseda.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.akprind.ac.id/"],
    name: "Institut Sains & Teknologi Akprind",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["akprind.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.amikom.ac.id/"],
    name: "STMIK AMIKOM Yogyakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["amikom.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.stikesrsanwarmedika.ac.id/"],
    name: "STIKES RS Anwar Medika",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["stikesrsanwarmedika.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.atmajaya.ac.id/"],
    name: "Universitas Katolik Indonesia Atma Jaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["atmajaya.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.bakrie.ac.id/"],
    name: "Universitas Bakrie",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["bakrie.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.binus.ac.id/"],
    name: "Binus University",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["binus.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.stikes-ppni.ac.id/"],
    name: "STIKES Bina Sehat PPNI Mojokerto",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["stikes-ppni.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.bunghatta.ac.id/"],
    name: "Universitas Bung Hatta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["bunghatta.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.dinus.ac.id/"],
    name: "Universitas Dian Nuswantoro",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["dinus.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.gunadarma.ac.id/"],
    name: "Universitas Gunadarma",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["gunadarma.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ibnuchaldun.ac.id/"],
    name: "Universitas Ibn Chaldun Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ibnuchaldun.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.indonusa.ac.id/"],
    name: "Universitas Indonusa Esa Unggul",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["indonusa.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ipb.ac.id/"],
    name: "Bogor Agricultural University",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ipb.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ista.ac.id/"],
    name: "Institut Sains dan Teknologi Al Kamal",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ista.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.itats.ac.id/"],
    name: "Institut Teknologi Adhi Tama Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["itats.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.itb.ac.id/"],
    name: "Institut Teknologi Bandung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["itb.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.its.ac.id/"],
    name: "Institut Teknologi Sepuluh Nopember",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["its.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.janabadra.ac.id/"],
    name: "Universitas Janabadra",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["janabadra.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.jayabaya.ac.id/"],
    name: "Universitas Jayabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["jayabaya.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.machung.ac.id/"],
    name: "Universitas Ma Chung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["machung.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umaha.ac.id/"],
    name: "Universitas Maarif Hasyim Latif",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umaha.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.mahendradatta.org/"],
    name: "Universitas Mahendradatta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["mahendradatta.org"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.um.ac.id/"],
    name: "Universitas Negeri Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["um.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.maranatha.edu/"],
    name: "Universitas Kristen Maranatha",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["maranatha.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.mercubuana.ac.id/"],
    name: "Universitas Mercu Buana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["mercubuana.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.moestopo.ac.id/"],
    name: "Universitas Dr. R. Moestopo",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["moestopo.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.narotama.ac.id/"],
    name: "Universitas Narotama",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["narotama.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.nommensen.org/"],
    name: "Universitas HKBP Nommensen",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["nommensen.org"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.pancabudi.ac.id/"],
    name: "Universitas Pembangunan Panca Budi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["pancabudi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.paramadina.ac.id/"],
    name: "Universitas Paramadina Mulya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["paramadina.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.pasim.ac.id/"],
    name: "Universitas Nasional Pasim",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["pasim.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.perbanas.ac.id/"],
    name: "STIE Perbanas",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["perbanas.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://perbanas.id/"],
    name: "Perbanas Institute",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["perbanas.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.petra.ac.id/"],
    name: "Universitas Kristen Petra",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["petra.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.pmbs.ac.id/"],
    name: "Prasetiya Mulya Business School",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["pmbs.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.pnj.ac.id/"],
    name: "Politeknik Negeri Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["pnj.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.pnl.ac.id/"],
    name: "Politeknik Negeri Lhokseumawe",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["pnl.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.polban.ac.id/"],
    name: "Politeknik Negeri Bandung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["polban.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.polines.ac.id/"],
    name: "Politeknik Negeri Semarang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["polines.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.polinpdg.ac.id/"],
    name: "Politeknik Negeri Padang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["polinpdg.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.polnep.ac.id/"],
    name: "Politeknik Negeri Pontianak",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["polnep.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.poltek-malang.ac.id/"],
    name: "Politeknik Negeri Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["poltek-malang.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.poltekpos.ac.id/"],
    name: "Politeknik Pos Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["poltekpos.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.poltesa.ac.id/"],
    name: "Politeknik Negeri Sambas",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["poltesa.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.puterabatam.ac.id/"],
    name: "Universitas Putera Batam",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["puterabatam.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.sarjanawiyata.ac.id/"],
    name: "Universitas Sarjanawiyata Tamansiswa",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["sarjanawiyata.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.sgu.ac.id/"],
    name: "Swiss German University",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["sgu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.sinus.ac.id/"],
    name: "STMIK Sinar Nusantara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["sinus.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.stan.ac.id/"],
    name: "Sekolah Tinggi Akuntansi Negara (STAN)",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["stan.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.stptrisakti.ac.id/"],
    name: "Trisakti Institute of Tourism",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["stptrisakti.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.telkomuniversity.ac.id/"],
    name: "Universitas Telkom",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["telkomuniversity.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unklab.ac.id/"],
    name: "Universitas Klabat",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unklab.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.trisakti.ac.id/"],
    name: "Universitas Trisakti",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["trisakti.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uad.ac.id/"],
    name: "Universitas Ahmad Dahlan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uad.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uajy.ac.id/"],
    name: "Universitas Atma Jaya Yogyakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uajy.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ub.ac.id/"],
    name: "Universitas Brawijaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ub.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ubaya.ac.id/"],
    name: "Universitas Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ubaya.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ubhara.ac.id/"],
    name: "Universitas Bhayangkara Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ubhara.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ubharajaya.ac.id/"],
    name: "Universitas Bhayangkara Jakarta Raya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ubharajaya.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ubm.ac.id/"],
    name: "Universitas Bunda Mulia Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ubm.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uda.ac.id/"],
    name: "Universitas Darma Agung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uda.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ugm.ac.id/"],
    name: "Universitas Gadjah Mada",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ugm.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ui.ac.id/"],
    name: "Universitas Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ui.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uii.ac.id/"],
    name: "Universitas Islam Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uii.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uika-bogor.ac.id/"],
    name: "Universitas Ibn Khaldun Bogor",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uika-bogor.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uinjkt.ac.id/"],
    name: "Universitas Islam Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uinjkt.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uir.ac.id/"],
    name: "Universitas Islam Riau",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uir.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uisu.ac.id/"],
    name: "Universitas Islam Sumatera Utara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uisu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ukdw.ac.id/"],
    name: "Universitas Kristen Duta Wacana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ukdw.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uki.ac.id/"],
    name: "Universitas Kristen Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uki.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ukit-tomohon.org/"],
    name: "Universitas Kristen Indonesia Tomohon",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ukit-tomohon.org"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ukrida.ac.id/"],
    name: "Universitas Kristen Krida Wacana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ukrida.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uksw.edu/"],
    name: "Universitas Kristen Satya Wacana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uksw.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umi.ac.id/"],
    name: "Universitas Muslim Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umi-mdn.edu/"],
    name: "Universitas Methodist Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umi-mdn.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umj.ac.id/"],
    name: "Universitas Muhammadiyah Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umj.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umk.ac.id/"],
    name: "Universitas Muria Kudus",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umk.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umm.ac.id/"],
    name: "Universitas Muhammadiyah Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umm.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ummgl.ac.id/"],
    name: "Universitas Muhammadiyah Magelang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ummgl.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umsida.ac.id/"],
    name: "Universitas Muhammadiyah Sidoarjo",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umsida.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ums.ac.id/"],
    name: "Universitas Muhammadiyah Surakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ums.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umsu.ac.id/"],
    name: "Universitas Muhammadiyah Sumatra Utara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umsu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.umy.ac.id/"],
    name: "Universitas Muhammadiyah Yogyakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["umy.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unai.edu/"],
    name: "Universitas Advent Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unai.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unair.ac.id/"],
    name: "Universitas Airlangga",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unair.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unand.ac.id/"],
    name: "Universitas Andalas",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unand.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unas.ac.id/"],
    name: "Universitas Nasional Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unas.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uncen.ac.id/"],
    name: "Universitas Cenderawasih",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uncen.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.undana.ac.id/"],
    name: "Universitas Nusa Cendana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["undana.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.undip.ac.id/"],
    name: "Universitas Diponegoro",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["undip.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unej.ac.id/"],
    name: "Universitas Jember",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unej.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unesa.ac.id/"],
    name: "Universitas Negeri Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unesa.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ung.ac.id/"],
    name: "Universitas Negeri Gorontalo",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ung.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unhalu.ac.id/"],
    name: "Universitas Haluoleo",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unhalu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unhamzah.ac.id/"],
    name: "Universitas Amir Hamzah",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unhamzah.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unhas.ac.id/"],
    name: "Universitas Hasanuddin",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unhas.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unib.ac.id/"],
    name: "Universitas Bengkulu",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unib.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unigoro.ac.id/"],
    name: "Universitas Bojonegoro",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unigoro.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unika.ac.id/"],
    name: "Universitas Katolik Soegijapranoto",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unika.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unikal.ac.id/"],
    name: "Universitas Pekalongan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unikal.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unik-kediri.ac.id/"],
    name: "Universitas Kediri",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unik-kediri.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unikom.ac.id/"],
    name: "Universitas Komputer Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unikom.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unila.ac.id/"],
    name: "Universitas Lampung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unila.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://unilak.ac.id/"],
    name: "Universitas Lancang Kuning",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unilak.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unima.ac.id/"],
    name: "Universitas Negeri Manado",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unima.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unimed.ac.id/"],
    name: "Universitas Negeri Medan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unimed.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uninus.ac.id/"],
    name: "Universitas Islam Nusantara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uninus.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unipdu.ac.id/"],
    name: "Universitas Pesantren Darul Ulum Jombang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unipdu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unira.ac.id/"],
    name: "Universitas Madura",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unira.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unisba.ac.id/"],
    name: "Universitas Islam Bandung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unisba.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unisma.ac.id/"],
    name: "Universitas Islam Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unisma.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unismuh.ac.id/"],
    name: "Universitas Muhammadiyah Makassar",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unismuh.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unisri.ac.id/"],
    name: "Universitas Slamet Riyadi Surakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unisri.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unissula.ac.id/"],
    name: "Universitas Islam Sultan Agung",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unissula.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unistangerang.ac.id/"],
    name: "Universitas Islam Syekh-Yusuf",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unistangerang.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unitomo.ac.id/"],
    name: "Unitomo Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unitomo.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.universitas-trilogi.ac.id/"],
    name: "Universitas Trilogi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["universitas-trilogi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.trunojoyo.ac.id/"],
    name: "Universitas Trunojoyo Madura",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["trunojoyo.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.univpancasila.ac.id/"],
    name: "Universitas Pancasila",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["univpancasila.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unipasby.ac.id/"],
    name: "Universitas PGRI Adi Buana Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unipasby.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unja.ac.id/"],
    name: "Universitas Jambi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unja.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unj.ac.id/"],
    name: "Universitas Negeri Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unj.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unjani.ac.id/"],
    name: "Universitas Jenderal Achmad Yani",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unjani.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unkhair.ac.id/"],
    name: "Universitas Khairun",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unkhair.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unkris.ac.id/"],
    name: "Universitas Krisnadwipayana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unkris.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unlam.ac.id/"],
    name: "Universitas Lambung Mangkurat",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unlam.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unm.ac.id/"],
    name: "Universitas Negeri Makassar",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unm.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmas.org/"],
    name: "Universitas Mahasaraswati Denpasar",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmas.org"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmer.ac.id/"],
    name: "Universitas Merdeka Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmer.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmer-madiun.ac.id/"],
    name: "Universitas Merdeka Madiun",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmer-madiun.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmuhjember.ac.id/"],
    name: "Universitas Muhammadiyah Jember",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmuhjember.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmuhmataram.com/"],
    name: "Universitas Muhammadiyah Mataram",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmuhmataram.com"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unmul.ac.id/"],
    name: "Universitas Mulawarman",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unmul.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unnes.ac.id/"],
    name: "Universitas Negeri Semarang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unnes.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unp.ac.id/"],
    name: "Universitas Negeri Padang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unp.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unpad.ac.id/"],
    name: "Universitas Padjadjaran",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unpad.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unpak.ac.id/"],
    name: "Universitas Pakuan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unpak.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unpar.ac.id/"],
    name: "Universitas Katolik Parahyangan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unpar.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unpas.ac.id/"],
    name: "Universitas Pasundan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unpas.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unpatti.ac.id/"],
    name: "Universitas Pattimura",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unpatti.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unr.ac.id/"],
    name: "Universitas Ngurah Rai",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unr.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unram.ac.id/"],
    name: "Universitas Mataram",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unram.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unri.ac.id/"],
    name: "Universitas Riau",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unri.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uns.ac.id/"],
    name: "Universitas Sebelas Maret",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uns.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsada.ac.id/"],
    name: "Universitas Darma Persada",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsada.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsil.ac.id/"],
    name: "Universitas Siliwangi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsil.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsoed.ac.id/"],
    name: "Universitas Jenderal Soedirman",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsoed.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsrat.ac.id/"],
    name: "Universitas Sam Ratulangi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsrat.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsri.ac.id/"],
    name: "Universitas Sriwijaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsri.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unswagati-crb.ac.id/"],
    name: "Universitas Swadaya Gunung Djati",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unswagati-crb.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unsyiah.ac.id/"],
    name: "Universitas Syiah Kuala",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unsyiah.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untad.ac.id/"],
    name: "Universitas Tadulako",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untad.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untag.ac.id/"],
    name: "Universitas 17 Agustus 1945 Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untag.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untag-banyuwangi.ac.id/"],
    name: "Universitas 17 Agustus 1945 Banyuwangi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untag-banyuwangi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untagcirebon.info/"],
    name: "Universitas 17 Agustus 1945 Cirebon",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untagcirebon.info"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untag-jkt.org/"],
    name: "Universitas 17 Agustus 1945 Jakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untag-jkt.org"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untag-smd.ac.id/"],
    name: "Universitas 17 Agustus 1945 Samarinda",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untag-smd.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untagsmg.ac.id/"],
    name: "Universitas 17 Agustus 1945 Semarang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untagsmg.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untan.ac.id/"],
    name: "Universitas Tanjungpura",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untan.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untar.ac.id/"],
    name: "Universitas Tarumanagara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untar.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untirta.ac.id/"],
    name: "Universitas Sultan Ageng Tirtayasa",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untirta.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unud.ac.id/"],
    name: "Universitas Udayana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unud.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.unwiku.ac.id/"],
    name: "Universitas Wijaya Kusuma Purwokerto",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["unwiku.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uny.ac.id/"],
    name: "Universitas Negeri Yogyakarta",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uny.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.up45.ac.id/"],
    name: "Universitas Proklamasi 45",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["up45.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.uph.edu/"],
    name: "Universitas Pelita Harapan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["uph.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upi.edu/"],
    name: "Universitas Pendidikan Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upi.edu"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upnvj.ac.id/"],
    name: 'Universitas Pembangunan Nasional "Veteran" Jakarta',
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upnvj.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upnjatim.ac.id/"],
    name: 'Universitas Pembangunan Nasional "Veteran" Jawa Timur',
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upnjatim.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upnyk.ac.id/"],
    name: 'Universitas Pembangunan Nasional "Veteran" Yogyakarta',
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upnyk.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upr.ac.id/"],
    name: "Universitas Palangka Raya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upr.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.upstegal.ac.id/"],
    name: "Universitas Pancasakti Tegal",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["upstegal.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.usd.ac.id/"],
    name: "Universitas Sanata Dharma",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["usd.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.usi.ac.id/"],
    name: "Universitas Simalungun",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["usi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.usm.ac.id/"],
    name: "Universitas Semarang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["usm.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.usu.ac.id/"],
    name: "Universitas Sumatera Utara",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["usu.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.ut.ac.id/"],
    name: "Universitas Terbuka Indonesia",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["ut.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.untidar.ac.id/"],
    name: "Universitas Tidar Magelang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["untidar.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.utp.ac.id/"],
    name: "Universitas Tunas Pembangunan",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["utp.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.widyagama.ac.id/"],
    name: "Universitas Widya Gama Malang",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["widyagama.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.widyakarya.ac.id/"],
    name: "Universitas Katolik Widya Karya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["widyakarya.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.widyatama.ac.id/"],
    name: "Universitas Widyatama",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["widyatama.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.wijayakusumasby.ac.id/"],
    name: "Universitas Wijaya Kusuma Surabaya",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["wijayakusumasby.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.wima.ac.id/"],
    name: "Universitas Katolik Widya Manadala",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["wima.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.wisnuwardhana.ac.id/"],
    name: "Universitas Wisnuwardhana",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["wisnuwardhana.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.yai.ac.id/"],
    name: "Universitas Persada Indonesia Y.A.I",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["yai.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["http://www.yarsi.ac.id/"],
    name: "Universitas Yarsi",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["yarsi.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["https://www.acmt.ac.ir/"],
    name: "Amirkabir College of Management & Technology",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["acmt.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.adiban.ac.ir/"],
    name: "Adiban Institute of Higher Education",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["adiban.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["https://www.ajums.ac.ir/"],
    name: "Ahvaz Jondishapur University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Khuzestan",
    domains: ["ajums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://aliabadiau.ac.ir/"],
    name: "Islamic Azad University, Aliabad",
    alpha_two_code: "IR",
    "state-province": "Golestan",
    domains: ["aliabadiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://miu.ac.ir/"],
    name: "Al-Mustafa International University",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["miu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.arakmu.ac.ir/"],
    name: "Arak University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["arakmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.araku.ac.ir/"],
    name: "Arak University",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["araku.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.arakut.ac.ir/"],
    name: "Arak University of Technology",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["arakut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.art.ac.ir/"],
    name: "Art University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["art.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.arums.ac.ir/"],
    name: "Ardabil University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Ardabil",
    domains: ["arums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.atu.ac.ir/"],
    name: "Allameh Tabatabaie University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["atu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.aums.ac.ir/"],
    name: "Ahvaz University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Khuzestan",
    domains: ["aums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.aut.ac.ir/"],
    name: "Amirkabir University of Technology",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["aut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.azad.ac.ir/"],
    name: "Islamic Azad University, Tehran South",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["azad.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.alzahra.ac.ir/"],
    name: "Alzahra University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["alzahra.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.basu.ac.ir/"],
    name: "Bu Ali Sina University",
    alpha_two_code: "IR",
    "state-province": "Hamedan",
    domains: ["basu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bihe.org/"],
    name: "Baha'i Institute for Higher Education",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["bihe.org"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bihe.org/"],
    name: "The Bahá'í Institute For Higher Education (BIHE)",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["bihe.org"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.birjand.ac.ir/"],
    name: "Birjand University",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["birjand.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bmsu.ac.ir/"],
    name: "Baqiyatallah University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["bmsu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bojnourdiau.ac.ir/"],
    name: "Islamic Azad University, Bojnourd",
    alpha_two_code: "IR",
    "state-province": "North Khorasan",
    domains: ["bojnourdiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bpums.ac.ir/"],
    name: "Bushehr University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Bushehr",
    domains: ["bpums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.bums.ac.ir/"],
    name: "Birjand University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "South Khorasan",
    domains: ["bums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://scu.ac.ir/"],
    name: "Shahid Chamran University of Ahvaz",
    alpha_two_code: "IR",
    "state-province": "Khuzestan",
    domains: ["scu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.dehaghan.ac.ir/"],
    name: "Islamic Azad University, Dehaghan",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["dehaghan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.delijanpnu.ac.ir/"],
    name: "Delijan Payame Noor University",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["delijanpnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.deylaman.ac.ir/"],
    name: "Deylaman Institute of Higher Education",
    alpha_two_code: "IR",
    "state-province": "Gilan",
    domains: ["deylaman.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.du.ac.ir/"],
    name: "Damghan University",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["du.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.falavarjan.ac.ir/"],
    name: "Islamic Azad University, Falavarjan",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["falavarjan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.fsriau.ac.ir/"],
    name: "Islamic Azad University, Fars Science & Research Branch",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["fsriau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.fums.ac.ir/"],
    name: "Fasa Faculty of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["fums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.gau.ac.ir/"],
    name: "Gorgan University",
    alpha_two_code: "IR",
    "state-province": "Golestan",
    domains: ["gau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.gmu.ac.ir/"],
    name: "Gonabad University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["gmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.gorganiau.ir/"],
    name: "Islamic Azad University, Gorgan",
    alpha_two_code: "IR",
    "state-province": "Golestan",
    domains: ["gorganiau.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.goums.ac.ir/"],
    name: "Golestan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Golestan",
    domains: ["goums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.guilan.ac.ir/"],
    name: "University of Guilan",
    alpha_two_code: "IR",
    "state-province": "Gilan",
    domains: ["guilan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.gums.ac.ir/"],
    name: "Guilan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Gilan",
    domains: ["gums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.hormozgan.ac.ir/"],
    name: "University of Hormozgan",
    alpha_two_code: "IR",
    "state-province": "Hormozgan",
    domains: ["hormozgan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.hums.ac.ir/"],
    name: "Hormozgan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Hormozgan",
    domains: ["hums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.hyrcania.ac.ir/"],
    name: "Hyrcania Institute of Higher Education",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["hyrcania.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iasbs.ac.ir/"],
    name: "Zanjan Institute for Advanced Studies in Basic Sciences",
    alpha_two_code: "IR",
    "state-province": "Zanjan",
    domains: ["iasbs.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-ahar.ac.ir/"],
    name: "Islamic Azad University, Ahar",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["iau-ahar.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-arak.ac.ir/"],
    name: "Islamic Azad University, Arak",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["iau-arak.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauardabil.ac.ir/"],
    name: "Islamic Azad University, Ardabil",
    alpha_two_code: "IR",
    "state-province": "Ardabil",
    domains: ["iauardabil.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauba.ac.ir/"],
    name: "Islamic Azad University, Bandar Abbas",
    alpha_two_code: "IR",
    "state-province": "Hormozgan",
    domains: ["iauba.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaubos.ac.ir/"],
    name: "Islamic Azad University, Bostanabad",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["iaubos.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-boukan.ac.ir"],
    name: "Islamic Azad University, Boukan",
    alpha_two_code: "IR",
    "state-province": "West Azerbaijan",
    domains: ["iau-boukan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauctb.ac.ir/"],
    name: "Islamic Azad University, Central Tehran Branch",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iauctb.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-garmsar.ac.ir/"],
    name: "Islamic Azad University, Garmsar",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["iau-garmsar.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauh.ac.ir/"],
    name: "Islamic Azad University, Hamedan",
    alpha_two_code: "IR",
    "state-province": "Hamedan",
    domains: ["iauh.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauk.ac.ir/"],
    name: "Islamic Azad University, Kerman",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["iauk.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaukb.ir/"],
    name: "Islamic Azad University, Karaj",
    alpha_two_code: "IR",
    "state-province": "Alborz",
    domains: ["iaukb.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-lahijan.ac.ir/"],
    name: "Islamic Azad University, Lahijan",
    alpha_two_code: "IR",
    "state-province": "Gilan",
    domains: ["iau-lahijan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaumajlesi.ac.ir/"],
    name: "Islamic Azad University, Majlesi",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["iaumajlesi.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaumehriz.com/"],
    name: "Islamic Azad University, Mehriz",
    alpha_two_code: "IR",
    "state-province": "Yazd",
    domains: ["iaumehriz.com"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaun.ac.ir/"],
    name: "Islamic Azad University, Najafabad",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["iaun.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauq.ac.ir/"],
    name: "Islamic Azad University, Quchan",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["iauq.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauro.ac.ir/"],
    name: "Islamic Azad University, Region One",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["iauro.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-saveh.ac.ir/"],
    name: "Islamic Azad University, Saveh",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["iau-saveh.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iausdj.ac.ir/"],
    name: "Islamic Azad University, Sanandaj",
    alpha_two_code: "IR",
    "state-province": "Kurdistan",
    domains: ["iausdj.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaushab.ac.ir/"],
    name: "Islamic Azad University, Shabestar",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["iaushab.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-shahrood.ac.ir/"],
    name: "Islamic Azad University, Shahrood",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["iau-shahrood.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaushiraz.ac.ir/"],
    name: "Islamic Azad University, Shiraz",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["iaushiraz.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-shirvan.ac.ir/"],
    name: "Islamic Azad University, Shirvan",
    alpha_two_code: "IR",
    "state-province": "North Khorasan",
    domains: ["iau-shirvan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iausr.ac.ir/"],
    name: "Islamic Azad University, Shahr-e-rey",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iausr.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iaut.ac.ir/"],
    name: "Islamic Azad University, Tabriz",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["iaut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iautb.ac.ir/"],
    name: "Islamic Azad University, Tafresh",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["iautb.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iautmu.ac.ir/"],
    name: "Islamic Azad University, Theran Medical",
    alpha_two_code: "IR",
    "state-province": "Theran",
    domains: ["iautmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iau-tnb.ac.ir/"],
    name: "Islamic Azad University, North Tehran",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iau-tnb.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauvaramin.ac.ir/"],
    name: "Islamic Azad University, Varamin",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iauvaramin.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iauyazd.ac.ir/"],
    name: "Islamic Azad University, Yazd",
    alpha_two_code: "IR",
    "state-province": "Yazd",
    domains: ["iauyazd.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ikiu.ac.ir/"],
    name: "Imam Khomeini International University",
    alpha_two_code: "IR",
    "state-province": "Qazvin",
    domains: ["ikiu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ilam.ac.ir/"],
    name: "Ilam University",
    alpha_two_code: "IR",
    "state-province": "Ilam",
    domains: ["ilam.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.imamreza.ac.ir/"],
    name: "Imam Reza University",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["imamreza.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.isu.ac.ir/"],
    name: "Imam Sadegh University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["isu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iums.ac.ir/"],
    name: "Iran University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iust.ac.ir/"],
    name: "Iran University of Science and Technology Tehran",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["iust.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.iut.ac.ir/"],
    name: "Isfahan University of Technology",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["iut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.jami.ac.ir/"],
    name: "Jami Institute of Technology",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["jami.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.janahiau.ac.ir/"],
    name: "Islamic Azad University, Janah",
    alpha_two_code: "IR",
    "state-province": "Hormozgan",
    domains: ["janahiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.jums.ac.ir/"],
    name: "Jahrom University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["jums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kamalolmolk.ac.ir/"],
    name: "Kamal-Ol-Molk University",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["kamalolmolk.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.karuniversity.com/"],
    name: "Kar University",
    alpha_two_code: "IR",
    "state-province": "Qazvin",
    domains: ["karuniversity.com"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kashanu.ac.ir/"],
    name: "Kashan University",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["kashanu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kau.ac.ir/"],
    name: "Islamic Azad University, Kazerun",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["kau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kaums.ac.ir/"],
    name: "Kashan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["kaums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kgut.ac.ir/"],
    name: "Kerman Graduate University of Technology",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["kgut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.khuisf.ac.ir/"],
    name: "Islamic Azad University, Khorasgan",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["khuisf.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kish.ac.ir/"],
    name: "Sharif University of Technology, Kish Campus",
    alpha_two_code: "IR",
    "state-province": "Hormozgan",
    domains: ["kish.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://km.isfpnu.ac.ir/"],
    name: "Khomeinishahr Payame Noor University",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["km.isfpnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kmu.ac.ir/"],
    name: "Kerman University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["kmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kntu.ac.ir/"],
    name: "Khajeh Nasir Toosi University of Technology",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["kntu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.kums.ac.ir/"],
    name: "Kermanshah University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Kermanshah",
    domains: ["kums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://teh-lavasan.pnu.ac.ir/"],
    name: "Payam Noor University Lavasan",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["teh-lavasan.pnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.lu.ac.ir/"],
    name: "Lorestan University",
    alpha_two_code: "IR",
    "state-province": "Lorestan",
    domains: ["lu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.lums.ac.ir/"],
    name: "Lorestan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Lorestan",
    domains: ["lums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mahshahriau.ac.ir/"],
    name: "Islamic Azad University, Mahshar",
    alpha_two_code: "IR",
    "state-province": "Khuzestan",
    domains: ["mahshahriau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.malayeru.ac.ir/"],
    name: "Malayer University",
    alpha_two_code: "IR",
    "state-province": "Hamadan",
    domains: ["malayeru.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.malekanpnu.ac.ir/"],
    name: "Malekan Payame Noor University",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["malekanpnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mamasaniiau.ac.ir/"],
    name: "Mamasani University of Technology",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["mamasaniiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mau.ac.ir/"],
    name: "Islamic Azad University, Mobarakeh",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["mau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.maybod.ac.ir/"],
    name: "Islamic Azad University, Maybod",
    alpha_two_code: "IR",
    "state-province": "Yazd",
    domains: ["maybod.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mazums.ac.ir/"],
    name: "Mazandaran University of Medical Science",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["mazums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.medilam.hbi.ir/"],
    name: "Ilam University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Ilam",
    domains: ["medilam.hbi.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.medsab.ac.ir/"],
    name: "Sabzevar School of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["medsab.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.modares.ac.ir/"],
    name: "Tarbiat Modares University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["modares.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mofidu.ac.ir/"],
    name: "Mofid University",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["mofidu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mshdiau.ac.ir/"],
    name: "Islamic Azad University, Mashhad",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["mshdiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mubabol.ac.ir/"],
    name: "Babol University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["mubabol.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mui.ac.ir/"],
    name: "Isfahan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["mui.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.muk.ac.ir/"],
    name: "Kurdistan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Kurdistan",
    domains: ["muk.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.mums.ac.ir/"],
    name: "Mashhad University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["mums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.muq.ac.ir/"],
    name: "Qom University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["muq.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.najafabad-uast.ac.ir/"],
    name: "Najaf Abad University of Applied Science and Technology",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["najafabad-uast.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.nit.ac.ir/"],
    name: "Babol Noshirvani University of Technology",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["nit.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.pgu.ac.ir/"],
    name: "Persian Gulf University",
    alpha_two_code: "IR",
    "state-province": "Bushehr",
    domains: ["pgu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.piau.ac.ir/"],
    name: "Islamic Azad University, Parand",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["piau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.pnu.ac.ir/"],
    name: "Payame Noor University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["pnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.pnum.ac.ir/"],
    name: "University of Mashhad Payame Noor",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["pnum.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.pnut.ac.ir/"],
    name: "Payame Noor University, Tafresh",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["pnut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.put.ac.ir/"],
    name: "Petroleum University of Technology",
    alpha_two_code: "IR",
    "state-province": "Khuzestan",
    domains: ["put.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.pwit.ac.ir/"],
    name: "Power and Water Institute of Technology",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["pwit.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://qiau.ac.ir/"],
    name: "Islamic Azad University, Qazvin",
    alpha_two_code: "IR",
    "state-province": "Qazvin",
    domains: ["qiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.qom.ac.ir/"],
    name: "Qom University",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["qom.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.qom-iau.ac.ir/"],
    name: "Islamic Azad University, Qom",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["qom-iau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.qums.ac.ir/"],
    name: "Qazvin University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Qazvin",
    domains: ["qums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.qut.ac.ir/"],
    name: "Qom University of Technology",
    alpha_two_code: "IR",
    "state-province": "Qom",
    domains: ["qut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.raghebisf.ac.ir/"],
    name: "Ragheb Esfahani University",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["raghebisf.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.razi.ac.ir/"],
    name: "Razi University",
    alpha_two_code: "IR",
    "state-province": "Kermanshah",
    domains: ["razi.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.riau.ac.ir/"],
    name: "Islamic Azad University, Roodehen",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["riau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.rums.ac.ir/"],
    name: "Rafsanjan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["rums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sadjad.ac.ir/"],
    name: "Sadjad Institute of Technology",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["sadjad.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sadra.ac.ir/"],
    name: "Sadra University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["sadra.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sbmu.ac.ir/"],
    name: "Shahid Beheshti University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["sbmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sbu.ac.ir/"],
    name: "Shahid Beheshti University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["sbu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sdi.ac.ir/"],
    name: "Daneshestan Institute of Higher Education",
    alpha_two_code: "IR",
    "state-province": "Markazi",
    domains: ["sdi.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.semnan.ac.ir/"],
    name: "Semnan University",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["semnan.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.semnaniau.ac.ir/"],
    name: "Islamic Azad University, Semnan",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["semnaniau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sem-ums.ac.ir/"],
    name: "Semnan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["sem-ums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ses.ac.ir/"],
    name: "School of Economic Sciences",
    alpha_two_code: "IR",
    "state-province": null,
    domains: ["ses.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shahed.ac.ir/"],
    name: "Shahed University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["shahed.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shahroodut.ac.ir/"],
    name: "Shahrood University of Technology",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["shahroodut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shahryariau.ac.ir/"],
    name: "Islamic Azad University, Shahryar",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["shahryariau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sharif.ac.ir/"],
    name: "Sharif University of Technology",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["sharif.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shbu.ac.ir/"],
    name: "Sheikh Bahaei University",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["shbu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shirazu.ac.ir/"],
    name: "Shiraz University",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["shirazu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shmu.ac.ir/"],
    name: "Shahrood University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Semnan",
    domains: ["shmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.shomal.ac.ir/"],
    name: "Shomal University",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["shomal.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sku.ac.ir/"],
    name: "Shahrekord University",
    alpha_two_code: "IR",
    "state-province": "Chaharmahal and Bakhtiari",
    domains: ["sku.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.skums.ac.ir/"],
    name: "Shahrekord University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Chaharmahal and Bakhtiari",
    domains: ["skums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sowmesaraiau.ac.ir/"],
    name: "Islamic Azad University, Someh Sara",
    alpha_two_code: "IR",
    "state-province": "Gilan",
    domains: ["sowmesaraiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.spnu.ac.ir/"],
    name: "Shiraz Payamnoor University",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["spnu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.srbiau.ac.ir/"],
    name: "Islamic Azad University, Tehran Science & Research Branch",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["srbiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.srttu.edu/"],
    name: "Shahid Rajaee Teacher Training University",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["srttu.edu"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ssu.ac.ir/"],
    name: "Yazd Medical University",
    alpha_two_code: "IR",
    "state-province": "Yazd",
    domains: ["ssu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sttu.ac.ir/"],
    name: "Sabzevar Teacher Training University",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["sttu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sums.ac.ir/"],
    name: "Shiraz University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["sums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sut.ac.ir/"],
    name: "Sahand University of Technology",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["sut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.sutech.ac.ir/"],
    name: "Shiraz University of Technology",
    alpha_two_code: "IR",
    "state-province": "Fars",
    domains: ["sutech.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tabriziau.ac.ir/"],
    name: "Tabriz Islamic Art University",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["tabriziau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tabrizu.ac.ir/"],
    name: "Tabriz University",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["tabrizu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tbzmed.ac.ir/"],
    name: "Tabriz University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["tbzmed.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tct.ac.ir/"],
    name: "Tabriz College of Technology",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["tct.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.thums.ac.ir/"],
    name: "Torbat Heydarieh University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["thums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tiau.ac.ir/"],
    name: "Takestan Islamic Azad University",
    alpha_two_code: "IR",
    "state-province": "Qazvin",
    domains: ["tiau.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tmu.ac.ir/"],
    name: "Tehran University of Teacher Training",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["tmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.tums.ac.ir/"],
    name: "Tehran University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["tums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uast.ac.ir/"],
    name: "University of Applied Science and Technology",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["uast.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ucna.info/"],
    name: "University College of Nabi Akram",
    alpha_two_code: "IR",
    "state-province": "East Azerbaijan",
    domains: ["ucna.info"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ui.ac.ir/"],
    name: "Isfahan University",
    alpha_two_code: "IR",
    "state-province": "Isfahan",
    domains: ["ui.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uk.ac.ir/"],
    name: "Shahid Bahonar University of Kerman",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["uk.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uma.ac.ir/"],
    name: "University of Mohaghegh Ardabili",
    alpha_two_code: "IR",
    "state-province": "Ardabili",
    domains: ["uma.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.um.ac.ir/"],
    name: "Ferdowsi University of Mashhad",
    alpha_two_code: "IR",
    "state-province": "Razavi Khorasan",
    domains: ["um.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.umsha.ac.ir/"],
    name: "Hamadan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Hamadan",
    domains: ["umsha.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.umsu.ac.ir/"],
    name: "Urmia University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "West Azarbaijan",
    domains: ["umsu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.umz.ac.ir/"],
    name: "Mazandaran University of Iran",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["umz.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uok.ac.ir/"],
    name: "University of Kurdistan",
    alpha_two_code: "IR",
    "state-province": "Kurdistan",
    domains: ["uok.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uoz.ac.ir/"],
    name: "Zabol University",
    alpha_two_code: "IR",
    "state-province": "Sistan and Baluchestan",
    domains: ["uoz.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.urmia.ac.ir/"],
    name: "Urmia University",
    alpha_two_code: "IR",
    "state-province": "West Azerbaijan",
    domains: ["urmia.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.usb.ac.ir/"],
    name: "Sistan and Baluchestan University",
    alpha_two_code: "IR",
    "state-province": "Sistan and Baluchestan",
    domains: ["usb.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.usc.ac.ir/"],
    name: "University of Science and Culture",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["usc.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ustmb.ac.ir/"],
    name: "Mazandaran University of Science & Technology",
    alpha_two_code: "IR",
    "state-province": "Mazandaran",
    domains: ["ustmb.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uswr.ac.ir/"],
    name: "University of Social Welfare and Rehabilitation Sciences",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["uswr.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ut.ac.ir/"],
    name: "University of Tehran",
    alpha_two_code: "IR",
    "state-province": "Tehran",
    domains: ["ut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.uut.ac.ir/"],
    name: "Urmia University of Technology",
    alpha_two_code: "IR",
    "state-province": "West Azerbaijan",
    domains: ["uut.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.vru.ac.ir/"],
    name: "Vali-e-Asr University of Rafsanjan",
    alpha_two_code: "IR",
    "state-province": "Kerman",
    domains: ["vru.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.yazduni.ac.ir/"],
    name: "Yazd University",
    alpha_two_code: "IR",
    "state-province": "Yazd",
    domains: ["yazduni.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.yu.ac.ir/"],
    name: "Yasuj University",
    alpha_two_code: "IR",
    "state-province": "Kohgiluyeh and Boyer-Ahmad",
    domains: ["yu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.yums.ac.ir/"],
    name: "Yasuj University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Kohgiluyeh and Boyer-Ahmad",
    domains: ["yums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.zdmu.ac.ir/"],
    name: "Zahedan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Sistan and Baluchestan",
    domains: ["zdmu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.znu.ac.ir/"],
    name: "Zanjan University",
    alpha_two_code: "IR",
    "state-province": "Zanjan",
    domains: ["znu.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.zums.ac.ir/"],
    name: "Zanjan University of Medical Sciences",
    alpha_two_code: "IR",
    "state-province": "Zanjan",
    domains: ["zums.ac.ir"],
    country: "Iran",
  },
  {
    web_pages: ["http://www.ahlulbaitonline.com/"],
    name: "Ahlulbait International University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["ahlulbaitonline.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.almamonuc.org/"],
    name: "Al Mamon University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["almamonuc.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.alrasheed-uc.com/"],
    name: "Al Rasheed University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["alrasheed-uc.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.alsadrain.org/"],
    name: "Alsadrain University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["alsadrain.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.auc-edu.org/"],
    name: "Al Maarif University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["auc-edu.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.auis.edu.iq/"],
    name: "American University of Iraq, Sulaimani (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["auis.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.baghdadcollege.edu.iq/"],
    name: "Baghdad College of Economic Sciences University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["baghdadcollege.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.bpc.edu.iq/"],
    name: "Baghdad College of Pharmacy",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["bpc.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://broyalu.net/"],
    name: "British Royal University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["broyalu.net"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.cihanuniversity.edu.iq/"],
    name: "Cihan University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["cihanuniversity.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.coalrafidain.edu.iq/"],
    name: "Al Rafidain University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["coalrafidain.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.duc.edu.iq/"],
    name: "Dijla University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["duc.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.hawlermu.org/"],
    name: "Hawler Medical University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["hawlermu.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.iraquniversity.net/"],
    name: "Iraq University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["iraquniversity.net"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.iu.edu.iq/"],
    name: "Ishik University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["iu.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.komar.edu.iq/"],
    name: "Komar University of Science and Technology",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["komar.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.koyauniversity.org/"],
    name: "Koya University (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["koyauniversity.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.madenatalelem.com/"],
    name: "Madenat Alelem University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["madenatalelem.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.muc.edu.iq/"],
    name: "Al Mansour University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["muc.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.nahrainuniv.edu.iq/"],
    name: "Al Nahrain University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["nahrainuniv.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.nawrozuniversity.com/"],
    name: "Nawroz University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["nawrozuniversity.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.qadissuni.edu.iq/"],
    name: "University of Al-Qadisiyah",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["qadissuni.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.scbaghdad.edu.iq/"],
    name: "College of Science, Baghdad University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["scbaghdad.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.soran.edu.iq/"],
    name: "Soran University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["soran.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.suh-edu.com/"],
    name: "Salahddin University (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["suh-edu.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.thiqaruni.org/"],
    name: "Thi Qar University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["thiqaruni.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.tu.edu.iq/"],
    name: "Tikrit University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["tu.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.turathun.com/"],
    name: "Al Turath University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["turathun.com"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uhd.edu.iq/"],
    name: "University of Human Development (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uhd.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.ukh.ac/"],
    name: "University of Kurdistan - Hawler",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["ukh.ac"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.univsul.org/"],
    name: "University of Sulaimania (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["univsul.org"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uoalmuthana.edu.iq/"],
    name: "Al Muthanna University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uoalmuthana.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uoanbar.edu.iq/"],
    name: "University of Anbar",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uoanbar.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uobabylon.edu.iq/"],
    name: "Uinversity of Babylon",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uobabylon.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uobaghdad.edu.iq/"],
    name: "University of Baghdad",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uobaghdad.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uobasrah.edu.iq/"],
    name: "University of Basrah",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uobasrah.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uod.ac/"],
    name: "University of Dohuk (Kurdistan Region)",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uod.ac"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uodiyala.edu.iq/"],
    name: "Diyala University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uodiyala.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uokerbala.edu.iq/"],
    name: "Kerbala University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uokerbala.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uokirkuk.edu.iq/"],
    name: "University of Kirkuk",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uokirkuk.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uokufa.edu.iq/"],
    name: "University of Kufa",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uokufa.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uomisan.edu.iq/"],
    name: "Misan University",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uomisan.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uomosul.edu.iq/"],
    name: "University of Mosul",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uomosul.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uomustansiriyah.edu.iq/"],
    name: "University of Mustansiriyah",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uomustansiriyah.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uotechnology.edu.iq/"],
    name: "University of Technology - Iraq",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uotechnology.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.uowasit.edu.iq/"],
    name: "University of Wassit",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["uowasit.edu.iq"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.yu.edu.jo/"],
    name: "Al Yarmouk University College",
    alpha_two_code: "IQ",
    "state-province": null,
    domains: ["yu.edu.jo"],
    country: "Iraq",
  },
  {
    web_pages: ["http://www.ait.ie/"],
    name: "Athlone Institute of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ait.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.cit.ie/"],
    name: "Cork Institute of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["cit.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.dcu.ie/"],
    name: "Dublin City University",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["dcu.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.dias.ie/"],
    name: "Dublin Institute for Advanced Studies",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["dias.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.dit.ie/"],
    name: "Dublin Institute of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["dit.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.gcd.ie/"],
    name: "Griffith College",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["gcd.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.gmit.ie/"],
    name: "Galway Mayo Institute of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["gmit.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.iiuedu.ie/"],
    name: "Irish International University (Distance Education)",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["iiuedu.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.itcarlow.ie/"],
    name: "Carlow Institute of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["itcarlow.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.ittralee.ie/"],
    name: "Institue of Technology, Tralee",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ittralee.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.lsb.ie/"],
    name: "LSB College",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["lsb.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.may.ie/"],
    name: "National University of Ireland, Maynooth",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["may.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.ncirl.ie/"],
    name: "National College of Ireland",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ncirl.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.nui.ie/"],
    name: "National University of Ireland",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["nui.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.rcpi.ie/"],
    name: "Royal College of Physicians of Ireland",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["rcpi.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.rcsi.ie/"],
    name: "Royal College of Surgeons",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["rcsi.ie", "rcsi.com"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.shannoncollege.com/"],
    name: "Shannon College of Hotel Management",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["shannoncollege.com"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.tcd.ie/"],
    name: "University of Dublin, Trinity College",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["tcd.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.ucc.ie/"],
    name: "University College Cork",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ucc.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.ucd.ie/"],
    name: "University College Dublin",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ucd.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["https://www.nuigalway.ie/", "http://www.ucg.ie/"],
    name: "National University of Ireland, Galway",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["nuigalway.ie", "ucg.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.ul.ie/"],
    name: "University of Limerick",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["ul.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.warnborough.edu/"],
    name: "Warnborough University",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["warnborough.edu"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.wit.ie/"],
    name: "Waterford Institute Of Technology",
    alpha_two_code: "IE",
    "state-province": null,
    domains: ["wit.ie"],
    country: "Ireland",
  },
  {
    web_pages: ["http://www.afeka.ac.il/"],
    name: "Afeka Tel Aviv Academic College of Engineering",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["afeka.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.jct.ac.il/"],
    name: "JCT Lev Academic Center",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["jct.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.ariel.ac.il/"],
    name: "Ariel University Center of Samaria",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["ariel.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.ash-college.ac.il/"],
    name: "Ashkelon Academic College",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["ash-college.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.bezalel.ac.il/"],
    name: "Bezalel Academy of Art and Design",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["bezalel.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.bgu.ac.il/"],
    name: "Ben-Gurion University of the Negev",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["bgu.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.biu.ac.il/"],
    name: "Bar-Ilan University",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["biu.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.clb.ac.il/"],
    name: "Acdemic Center for Law and Business",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["clb.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.colman.ac.il/"],
    name: "College of Management",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["colman.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.galilcol.ac.il/"],
    name: "Galillee College",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["galilcol.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.haifa.ac.il/"],
    name: "University of Haifa",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["haifa.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.huji.ac.il/"],
    name: "Hebrew University of Jerusalem",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["huji.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.idc.ac.il/"],
    name: "The Interdisciplinary Center Herzliya",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["idc.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.juc.edu/"],
    name: "Jerusalem University College",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["juc.edu"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.openu.ac.il/"],
    name: "Open University of Israel",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["openu.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://rbni.technion.ac.il/"],
    name: "Russell Berrie Nanotechnology Institute",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["rbni.technion.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.sce.ac.il/"],
    name: "Sami Shamoon College of Engineering",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["sce.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.shenkar.ac.il/"],
    name: "Shenkar School of Engineering & Design",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["shenkar.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.tau.ac.il/"],
    name: "Tel Aviv University",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["tau.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.technion.ac.il/"],
    name: "Technion - Israel Institute of Technology",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["technion.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.weizmann.ac.il/"],
    name: "Weizmann Institute of Science",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["weizmann.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.wgalil.ac.il/"],
    name: "Western Galilee College",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["wgalil.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.yvc.ac.il/"],
    name: "Emeq Yizrael College",
    alpha_two_code: "IL",
    "state-province": null,
    domains: ["yvc.ac.il"],
    country: "Israel",
  },
  {
    web_pages: ["http://www.angelicum.org/"],
    name: "Pontificia Università S. Tommaso",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["angelicum.org"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.antonianum.ofm.org/"],
    name: "Pontificio Ateneo Antonianum",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["antonianum.ofm.org"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.casa.unimo.it/"],
    name: "University of Modena",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["casa.unimo.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.ictp.trieste.it/"],
    name: "Abdus Salam international centre for theoretical physics",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["ictp.trieste.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.imtlucca.it/"],
    name: "Institute for Advanced Studies Lucca",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["imtlucca.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iuav.unive.it/"],
    name: "University Institute of Architecture Venice",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iuav.unive.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iue.it/"],
    name: "European University Institute",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iue.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iulm.it/"],
    name: "University Institute of Modern Languages",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iulm.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iuoart.org/"],
    name: "Dutch University Institute for Art History (DUIA)",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iuoart.org"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iuo.it/"],
    name: "University Institute of Oriental Studies",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iuo.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.iusspavia.it/"],
    name: "Istituto Universitario di Studi Superiori",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["iusspavia.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.jhubc.it/"],
    name: "Johns Hopkins University, SAIS Bologna Center",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["jhubc.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.johncabot.edu/"],
    name: "John Cabot University",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["johncabot.edu"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.liuc.it/"],
    name: 'Free University Institute "Carlo Cattaneo"',
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["liuc.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.luiss.it/"],
    name: "Free International University of Social Studies",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["luiss.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.lumsa.it/"],
    name: 'Free University "Maria Santissima Assunta"',
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["lumsa.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.naba.it/"],
    name: "NABA - Nuova Accademia di Belle Arti, Milan",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["naba.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.nyuniversity.net/"],
    name: "Yorker International University, Milano",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["nyuniversity.net"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.pio.urbe.it/"],
    name: "Pontificio Istituto Orientale",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["pio.urbe.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.poliba.it/"],
    name: "Polytechnic Institute of Bari",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["poliba.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.polimi.it/"],
    name: "Polytechnic Institute of Milan",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["polimi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.polito.it/"],
    name: "Polytechnic Institute of Turin",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["polito.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.pul.it/"],
    name: "Pontificia Università Lateranense",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["pul.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.pusc.it/"],
    name: "Pontificia Università della Santa Croce",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["pusc.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.sacrocuore.org/"],
    name: "Fondazione Sacro Cuore",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["sacrocuore.org"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.sissa.it/"],
    name: "International Higher School for Advanced Studies Trieste",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["sissa.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.sns.it/"],
    name: "School of Education Pisa",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["sns.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.sssup.it/"],
    name: "Higher School of University and Advanced Studies Pisa",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["sssup.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unian.it/"],
    name: "University of Ancona",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unian.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniba.it/"],
    name: "University of Bari",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniba.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibas.it/"],
    name: "Basilicata University Potenza",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibas.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibg.it/"],
    name: "University of Bergamo",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibg.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibocconi.eu/"],
    name: "Bocconi University",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibocconi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibo.it/"],
    name: "University of Bologna",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibo.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibs.it/"],
    name: "University of Brescia",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibs.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unibz.it/"],
    name: "Free University of Bozen",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unibz.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unica.it/"],
    name: "University of Cagliari",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unica.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unical.it/"],
    name: "University of Calabria",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unical.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unicam.it/"],
    name: "University of Camerino",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unicam.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unicampus.it/"],
    name: "Campus Bio-Medico University of Rome",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unicampus.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unicas.it/"],
    name: "University of Cassino",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unicas.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unicatt.it/"],
    name: "Catholic University of the Sacred Heart",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unicatt.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unich.it/"],
    name: "University of Chieti",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unich.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unict.it/"],
    name: "University of Catania",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unict.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniese.it/"],
    name: "European School of Economics",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniese.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unife.it/"],
    name: "University of Ferrara",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unife.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unifg.it/"],
    name: "University of Foggia",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unifg.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unifi.it/"],
    name: "University of Florence",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unifi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unige.it/"],
    name: "University of Genoa",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unige.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unigre.it/"],
    name: "Pontifica Università Gregoriana",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unigre.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unile.it/"],
    name: "University of Lecce",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unile.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unilink.it/"],
    name: "Link Campus University of Malta",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unilink.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unimc.it/"],
    name: "University of Macerata",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unimc.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unime.it/"],
    name: "University of Messina",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unime.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unimib.it/"],
    name: "University of Milan - Bicocca",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unimib.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unimi.it/"],
    name: "University of Milan",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unimi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unimol.it/"],
    name: "University of Molise",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unimol.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unina2.it/"],
    name: "Second University of Naples",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unina2.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unina.it/"],
    name: "University of Naples Federico II",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unina.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uninav.it/"],
    name: "University Institute of Naval Studies",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uninav.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uninsubria.it/"],
    name: "University of Insubria",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uninsubria.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipa.it/"],
    name: "University of Palermo",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipa.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipd.it/"],
    name: "University of Padua",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipd.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipg.it/"],
    name: "University of Perugia",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipg.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipi.it/"],
    name: "University of Pisa",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipr.it/"],
    name: "University of Parma",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipr.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unipv.it/"],
    name: "University of Pavia",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unipv.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unirc.it/"],
    name: "University of Reggio Calabria",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unirc.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniroma1.it/"],
    name: 'University of Roma "La Sapienza"',
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniroma1.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniroma2.it/"],
    name: 'University of Roma "Tor Vergata"',
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniroma2.eu"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniroma3.it/"],
    name: "Third University of Rome",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniroma3.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisa.it/"],
    name: "University of Salerno",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisa.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisal.it/"],
    name: "Università Pontificia Salesiana",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisal.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisannio.it/"],
    name: "University of Sannio",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisannio.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisg.it/"],
    name: "University of Gastronomic Sciences",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisg.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisi.it/"],
    name: "University of Siena",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unisob.na.it/"],
    name: 'University Institute of Teacher Training "Suor Orsola Benincasa"',
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unisob.na.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniss.it/"],
    name: "University of Sassari",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniss.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unistrapg.it/"],
    name: "University of Italian Studies for Foreigners of Perugia",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unistrapg.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unistrasi.it/"],
    name: "University of Italian Studies for Foreigners of Siena",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unistrasi.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unite.it/"],
    name: "University of Teramo",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unite.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unitn.it/"],
    name: "University of Trento",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unitn.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unito.it/"],
    name: "University of Turin",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unito.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unitus.it/"],
    name: "Viterbo State University",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unitus.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniud.it/"],
    name: "University of Udine",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniud.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.uniurb.it/"],
    name: "University of Urbino",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["uniurb.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.univaq.it/"],
    name: "University of Aquila",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["univaq.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.unive.it/"],
    name: "University of Venice",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["unive.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.univr.it/"],
    name: "University of Verona",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["univr.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.units.it/"],
    name: "University of Trieste",
    alpha_two_code: "IT",
    "state-province": null,
    domains: ["units.it"],
    country: "Italy",
  },
  {
    web_pages: ["http://www.ncu.edu.jm/"],
    name: "Northern Caribbean University",
    alpha_two_code: "JM",
    "state-province": null,
    domains: ["ncu.edu.jm"],
    country: "Jamaica",
  },
  {
    web_pages: ["http://www.utech.edu.jm/"],
    name: "University of Technology Jamaica",
    alpha_two_code: "JM",
    "state-province": null,
    domains: ["utech.edu.jm"],
    country: "Jamaica",
  },
  {
    web_pages: ["http://www.uwimona.edu.jm/"],
    name: "University of the West Indies, Mona",
    alpha_two_code: "JM",
    "state-province": null,
    domains: ["uwimona.edu.jm"],
    country: "Jamaica",
  },
  {
    web_pages: ["http://www.aasa.ac.jp/"],
    name: "Aichi Shukutoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aasa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.abu.ac.jp/"],
    name: "Aichi Bunkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["abu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-edu.ac.jp/"],
    name: "Aichi University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-edu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-fam-u.ac.jp/"],
    name: "Aichi Prefectural University of Fine Arts & Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-fam-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-gakuin.ac.jp/"],
    name: "Aichi Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-gakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-med-u.ac.jp/"],
    name: "Aichi Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-med-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-pu.ac.jp/"],
    name: "Aichi Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aichi-u.ac.jp/"],
    name: "Aichi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aichi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aikoku-u.ac.jp/"],
    name: "Aikoku Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aikoku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aitech.ac.jp/"],
    name: "Aichi Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aitech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.akeihou-u.ac.jp/"],
    name: "Akita University of Economics and Law",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["akeihou-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.akita-u.ac.jp/"],
    name: "Akita University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["akita-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.andrew.ac.jp/"],
    name: "St. Andrew's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["andrew.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aomoricgu.ac.jp/"],
    name: "Aomori Chuoh Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aomoricgu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aomori-u.ac.jp/"],
    name: "Aomori University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aomori-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aoyama.ac.jp/"],
    name: "Aoyama Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aoyama.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.apu.ac.jp/"],
    name: "Ritsumeikan Asia Pacific University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["apu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.asahikawa-med.ac.jp/"],
    name: "Asahikawa Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["asahikawa-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.asahikawa-u.ac.jp/"],
    name: "Asahikawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["asahikawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.asahi-u.ac.jp/"],
    name: "Asahi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["asahi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ashitech.ac.jp/"],
    name: "Ashikaga Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ashitech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ashiya-u.ac.jp/"],
    name: "Ashiya University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ashiya-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.asia-u.ac.jp/"],
    name: "Asia University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["asia-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.asu.ac.jp/"],
    name: "Aichi Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["asu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.atomi.ac.jp/"],
    name: "Atomi College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["atomi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aue-okinawa.ac.jp/"],
    name: "American University Extension, Okinawa",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["aue-okinawa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.auhw.ac.jp/"],
    name: "Aomori University of Health and Welfare",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["auhw.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.azabu-u.ac.jp/"],
    name: "Azabu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["azabu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.baika.ac.jp/"],
    name: "Baika Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["baika.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.baiko.ac.jp/"],
    name: "Baiko Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["baiko.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.beppu-u.ac.jp/"],
    name: "Beppu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["beppu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.budo-u.ac.jp/"],
    name: "International Budo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["budo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.bukkyo-u.ac.jp/"],
    name: "Bukkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["bukkyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.bunka-wu.ac.jp/"],
    name: "Bunka Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["bunka-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.bunkyo.ac.jp/"],
    name: "Bunkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["bunkyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.bunri-u.ac.jp/"],
    name: "Tokushima Bunri University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["bunri-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.cgu.ac.jp/"],
    name: "Chuo Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["cgu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chiba-u.ac.jp/"],
    name: "Chiba University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chiba-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chikushi.ac.jp/"],
    name: "Chikushi Jogakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chikushi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chubu.ac.jp/"],
    name: "Chubu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chubu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chubu-gu.ac.jp/"],
    name: "Chubu Gakuin University & Chubu Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chubu-gu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chujo-u.ac.jp/"],
    name: "Chukyo Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chujo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chukyogakuin-u.ac.jp/"],
    name: "Chukyo Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chukyogakuin-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chukyo-u.ac.jp/"],
    name: "Chukyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chukyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.chuo-u.ac.jp/"],
    name: "Chuo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["chuo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.cku.ac.jp/"],
    name: "Chiba Keizai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["cku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.cuc.ac.jp/"],
    name: "Chiba University of Commerce",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["cuc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daido-it.ac.jp/"],
    name: "Daido Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daido-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daiichi-cps.ac.jp/"],
    name: "Daiichi College of Pharmaceutical Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daiichi-cps.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daiichi-koudai.ac.jp/"],
    name: "Dai Ichi University, College of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daiichi-koudai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daiichi-ue.ac.jp/"],
    name: "Daiichi University of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daiichi-ue.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daion.ac.jp/"],
    name: "Osaka College of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daion.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daishodai.ac.jp/"],
    name: "Osaka University of Commerce",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daishodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.daito.ac.jp/"],
    name: "Daito Bunka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["daito.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.dendai.ac.jp/"],
    name: "Tokyo Denki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["dendai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.doho.ac.jp/"],
    name: "Doho University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["doho.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.doho.ac.jp/~meion/"],
    name: "Nagoya College of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["doho.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.dohto.ac.jp/"],
    name: "Dohto University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["dohto.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.do-johodai.ac.jp/"],
    name: "Hokkaido Information University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["do-johodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.dokkyo.ac.jp/"],
    name: "Dokkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["dokkyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.dokkyomed.ac.jp/"],
    name: "Dokkyo University School of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["dokkyomed.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.doshisha.ac.jp/"],
    name: "Doshisha University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["doshisha.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.dwc.doshisha.ac.jp/"],
    name: "Doshisha Women's College of Liberal Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["dwc.doshisha.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.edogawa-u.ac.jp/"],
    name: "Edogawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["edogawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ehime-u.ac.jp/"],
    name: "Ehime University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ehime-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.eichi-u.ac.jp/"],
    name: "Eichi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["eichi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.eiyo.ac.jp/"],
    name: "Kagawa Institute of Nutrition",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["eiyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.eum.ac.jp/"],
    name: "Elisabeth University of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["eum.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fdcnet.ac.jp/"],
    name: "Fukuoka Dental College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fdcnet.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ferris.ac.jp/"],
    name: "Ferris University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ferris.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fish-u.ac.jp/"],
    name: "National Fisheries University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fish-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fit.ac.jp/"],
    name: "Fukuoka Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fmu.ac.jp/"],
    name: "Fukushima Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fmu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fpu.ac.jp/"],
    name: "Fukui Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fpu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fujijoshi.ac.jp/"],
    name: "Fuji Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fujijoshi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fujita-hu.ac.jp/"],
    name: "Fujita Health University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fujita-hu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukui-med.ac.jp/"],
    name: "Fukui Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukui-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukui-u.ac.jp/"],
    name: "Fukui University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukui-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukui-ut.ac.jp/"],
    name: "Fukui University of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukui-ut.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukuoka-edu.ac.jp/"],
    name: "Fukuoka University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukuoka-edu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukuoka-int-u.ac.jp/"],
    name: "Fukuoka International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukuoka-int-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukuoka-pu.ac.jp/"],
    name: "Fukuoka Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukuoka-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukuoka-u.ac.jp/"],
    name: "Fukuoka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukuoka-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukushima-u.ac.jp/"],
    name: "Fukushima University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukushima-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fukuyama-u.ac.jp/"],
    name: "Fukuyama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fukuyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.fwu.ac.jp/"],
    name: "Fukuoka Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["fwu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gakusen.ac.jp/"],
    name: "Aichi Gakusen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gakusen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gakushuin.ac.jp/"],
    name: "Gakushuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gakushuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.geidai.ac.jp/"],
    name: "Tokyo National University of Fine Arts and Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["geidai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gifu-keizai.ac.jp/"],
    name: "Gifu Keizai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gifu-keizai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gifu-kyoiku.ac.jp/"],
    name: "Gifu University for Education and Languages",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gifu-kyoiku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gifu-pu.ac.jp/"],
    name: "Gifu Pharmaceutical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gifu-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gifu-u.ac.jp/"],
    name: "Gifu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gifu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gijodai.ac.jp/"],
    name: "Gifu Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gijodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gpwu.ac.jp/"],
    name: "Gunma Prefectural Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gpwu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.gunma-u.ac.jp/"],
    name: "Gunma University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["gunma-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hachinohe-u.ac.jp/"],
    name: "Hachinohe University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hachinohe-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hakodate-u.ac.jp/"],
    name: "Hakodate University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hakodate-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hakuoh.ac.jp/"],
    name: "Hakuoh University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hakuoh.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hamamatsu-u.ac.jp/"],
    name: "Hamamatsu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hamamatsu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hama-med.ac.jp/"],
    name: "Hamamatsu University School of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hama-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hanazono.ac.jp/"],
    name: "Hanazono University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hanazono.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hannan-u.ac.jp/"],
    name: "Hannan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hannan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.h-bunkyo.ac.jp/"],
    name: "Hiroshima Bunkyo Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["h-bunkyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.heisei-u.ac.jp/"],
    name: "Fukuyama Heisei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["heisei-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hijiyama-u.ac.jp/"],
    name: "Hijiyama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hijiyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.himeji-du.ac.jp/"],
    name: "Himeji Dokkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["himeji-du.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.himeji-tech.ac.jp/"],
    name: "Himeji Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["himeji-tech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hirogaku-u.ac.jp/"],
    name: "Hirosaki Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hirogaku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hirojo-u.ac.jp/"],
    name: "Hiroshima Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hirojo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hirokoku-u.ac.jp/"],
    name: "Hiroshima International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hirokoku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hirosaki-u.ac.jp/"],
    name: "Hirosaki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hirosaki-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hiroshima-cu.ac.jp/"],
    name: "Hiroshima City University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hiroshima-cu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hiroshima-pu.ac.jp/"],
    name: "Hiroshima Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hiroshima-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hiroshima-u.ac.jp/"],
    name: "Hiroshima University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hiroshima-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hit.ac.jp/"],
    name: "Hokkaido Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hi-tech.ac.jp/"],
    name: "Hachinohe Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hi-tech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hit-u.ac.jp/"],
    name: "Hitotsubashi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hit-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hiu.ac.jp/"],
    name: "Heisei International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hju.ac.jp/"],
    name: "Hiroshima Jogakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hju.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hkg.ac.jp/"],
    name: "Hiroshima Kokusai Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hkg.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokkai-k-u.ac.jp/"],
    name: "Hokkaigakuen University of Kitami",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokkai-k-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokkai-s-u.ac.jp/"],
    name: "Hokkaigakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokkai-s-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokkyodai.ac.jp/"],
    name: "Hokkaido University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokkyodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokudai.ac.jp/"],
    name: "Hokkaido University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokudai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hoku-iryo-u.ac.jp/"],
    name: "Hokkaido University of Health Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hoku-iryo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokuriku-u.ac.jp/"],
    name: "Hokuriku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokuriku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokusei.ac.jp/"],
    name: "Hokusei Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokusei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hokuyakudai.ac.jp/"],
    name: "Hokkaido Institute of Pharmaceutical Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hokuyakudai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hosei.ac.jp/"],
    name: "Hosei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hosei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hoshi.ac.jp/"],
    name: "Hoshi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hoshi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hue.ac.jp/"],
    name: "Hiroshima University of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hue.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hyogo-dai.ac.jp/"],
    name: "Hyogo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hyogo-dai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hyogo-u.ac.jp/"],
    name: "Hyogo University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hyogo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.hyo-med.ac.jp/"],
    name: "Hyogo College of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["hyo-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ibaraki.ac.jp/"],
    name: "Ibaraki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ibaraki.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.icc.ac.jp/"],
    name: "Ibaraki Christian College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["icc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.icu.ac.jp/"],
    name: "International Christian University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["icu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ip.kyusan-u.ac.jp/"],
    name: "Kyushu Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ip.kyusan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ipu.ac.jp/"],
    name: "Ibaraki Prefectural University of Health Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ipu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.isenshu-u.ac.jp/"],
    name: "Ishinomaki Senshu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["isenshu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.it-chiba.ac.jp/"],
    name: "Chiba Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["it-chiba.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.it-hiroshima.ac.jp/"],
    name: "Hiroshima Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["it-hiroshima.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iuhw.ac.jp/"],
    name: "International University of Health and Welfare",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iuhw.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iuj.ac.jp/"],
    name: "International University of Japan",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iuj.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iuk.ac.jp/"],
    name: "International University of Kagoshima",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iuk.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iwakimu.ac.jp/"],
    name: "Iwaki Meisei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iwakimu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iwate-med.ac.jp/"],
    name: "Iwate Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iwate-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iwate-pu.ac.jp/"],
    name: "Iwate Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iwate-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.iwate-u.ac.jp/"],
    name: "Iwate University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["iwate-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jaist.ac.jp/"],
    name: "Japan Advanced Institute of Science and Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jaist.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jichi.ac.jp/"],
    name: "Jichi Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jichi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jikei.ac.jp/"],
    name: "Jikei University School of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jikei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jissen.ac.jp/"],
    name: "Jissen Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jissen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jiu.ac.jp/"],
    name: "Josai International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jobu.ac.jp/"],
    name: "Jobu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jobu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.josai.ac.jp/"],
    name: "Josai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["josai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.joshibi.ac.jp/"],
    name: "Women's College of Fine Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["joshibi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.juen.ac.jp/"],
    name: "Joetsu University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["juen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.juntan.k-junshin.ac.jp/jundai/"],
    name: "Kagoshima Immaculate Heart University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["juntan.k-junshin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.juntendo.ac.jp/"],
    name: "Juntendo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["juntendo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.jwu.ac.jp/"],
    name: "Japan Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["jwu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kagawa-u.ac.jp/"],
    name: "Kagawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kagawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kagoshima-u.ac.jp/"],
    name: "Kagoshima University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kagoshima-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kamakura-u.ac.jp/"],
    name: "Kamakura Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kamakura-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanagawa-it.ac.jp/"],
    name: "Kanagawa Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanagawa-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanagawa-u.ac.jp/"],
    name: "Kanagawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanagawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-bidai.ac.jp/"],
    name: "Kanazawa College of Art",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-bidai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-eco.ac.jp/"],
    name: "Kanazawa College of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-eco.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-gu.ac.jp/"],
    name: "Kanazawa Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-gu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-it.ac.jp/"],
    name: "Kanazawa Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-med.ac.jp/"],
    name: "Kanazawa Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanazawa-u.ac.jp/"],
    name: "Kanazawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanazawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kankyo-u.ac.jp/"],
    name: "Tottori University of Environmental Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kankyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kansai-gaidai-u.ac.jp/"],
    name: "Kansai Gaidai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kansai-gaidai-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kansai-u.ac.jp/"],
    name: "Kansai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kansai-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanto-gakuen.ac.jp/"],
    name: "Kanto Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanto-gakuen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kanto-gakuin.ac.jp/"],
    name: "Kanto Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kanto-gakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kawasaki-m.ac.jp/"],
    name: "Kawasaki Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kawasaki-m.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kawasaki-m.ac.jp/mw/"],
    name: "Kawasaki University of Medical Care",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kawasaki-m.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kbu.ac.jp/"],
    name: "Kyoto Bunkyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kbu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kcua.ac.jp/"],
    name: "Kyoto City University of Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kcua.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kdcnet.ac.jp/"],
    name: "Kanagawa Dental College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kdcnet.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.keiho-u.ac.jp/"],
    name: "Osaka University of Economics & Law",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["keiho-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.keio.ac.jp/"],
    name: "Keio University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["keio.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.keisen.ac.jp/"],
    name: "Keisen Jogaku-en College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["keisen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.keiwa-c.ac.jp/"],
    name: "Keiwa College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["keiwa-c.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kgwu.ac.jp/"],
    name: "Kawamura Gakuen Woman's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kgwu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kindai.ac.jp/"],
    name: "Kinki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kindai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kinjo-u.ac.jp/"],
    name: "Kinjo Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kinjo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kit.ac.jp/"],
    name: "Kyoto Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kitakyu-u.ac.jp/"],
    name: "Kitakyushu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kitakyu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kitami-it.ac.jp/"],
    name: "Kitami Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kitami-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kitasato-u.ac.jp/"],
    name: "Kitasato University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kitasato-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kiu.ac.jp/"],
    name: "Kyushu International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kiui.ac.jp/"],
    name: "Kibi International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kiui.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kms.ac.jp/"],
    name: "Kagawa Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kms.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kmu.ac.jp/"],
    name: "Kansai Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kmu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.knct.ac.jp/"],
    name: "Kumamoto Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["knct.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-c.ac.jp/"],
    name: "Kobe Jogakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-c.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-cufs.ac.jp/"],
    name: "Kobe City University of ForeignStudies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-cufs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-du.ac.jp/"],
    name: "Kobe Design University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-du.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobegakuin.ac.jp/"],
    name: "Kobe Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobegakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-kiu.ac.jp/"],
    name: "Kobe International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-kiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobepharma-u.ac.jp/"],
    name: "Kobe Pharmaceutical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobepharma-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-shinwa.ac.jp/"],
    name: "Kobe Shinwa Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-shinwa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kobe-u.ac.jp/"],
    name: "Kobe University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kobe-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kochi-ms.ac.jp/"],
    name: "Kochi Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kochi-ms.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kochi-tech.ac.jp/"],
    name: "Kochi University of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kochi-tech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kochi-u.ac.jp/"],
    name: "Kochi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kochi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kochi-wu.ac.jp/"],
    name: "Kochi Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kochi-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kogakkan-u.ac.jp/"],
    name: "Kogakkan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kogakkan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kogakuin.ac.jp/"],
    name: "Kogakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kogakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.koka.ac.jp/"],
    name: "Koka Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["koka.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kokugakuin.ac.jp/"],
    name: "Kokugakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kokugakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kokushikan.ac.jp/"],
    name: "Kokushikan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kokushikan.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.komazawa-u.ac.jp/"],
    name: "Komazawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["komazawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.konan-u.ac.jp/"],
    name: "Konan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["konan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.konan-wu.ac.jp/"],
    name: "Konan Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["konan-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.korea-u.ac.jp/"],
    name: "Korea University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["korea-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.koriyama-kgc.ac.jp/"],
    name: "Koriyama Women's University and College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["koriyama-kgc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.koshien.ac.jp/"],
    name: "Koshien University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["koshien.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.koyasan-u.ac.jp/"],
    name: "Koyasan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["koyasan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kpu.ac.jp/"],
    name: "Kyoto Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kpu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kpu-m.ac.jp/"],
    name: "Kyoto Prefectural University of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kpu-m.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kshosen.ac.jp/"],
    name: "Kobe University of Mercantile Marine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kshosen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ksu.ac.jp/"],
    name: "Kurashiki Sakuyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ksu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ktokai-u.ac.jp/"],
    name: "Kyushu Tokai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ktokai-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kufs.ac.jp/"],
    name: "Kyoto University of Foreign Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kufs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kuins.ac.jp/"],
    name: "Kansai University of International Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kuins.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kuis.ac.jp/"],
    name: "Kanda University of International Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kuis.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kumagaku.ac.jp/"],
    name: "Kumamoto Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kumagaku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kumamoto-u.ac.jp/"],
    name: "Kumamoto University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kumamoto-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kunitachi.ac.jp/"],
    name: "Kunitachi College of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kunitachi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kure-u.ac.jp/"],
    name: "Kure University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kure-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kurume-it.ac.jp/"],
    name: "Kurume Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kurume-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kurume-u.ac.jp/"],
    name: "Kurume University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kurume-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kusa.ac.jp/"],
    name: "Kurashiki University of Science and the Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kusa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kushiro-pu.ac.jp/"],
    name: "Kushiro Public University of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kushiro-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kusw.ac.jp/"],
    name: "Kansai University of Social Welfare",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kusw.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kwansei.ac.jp/"],
    name: "Kwansei Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kwansei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kwassui.ac.jp/"],
    name: "Kwassui Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kwassui.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kwc-u.ac.jp/"],
    name: "Kagoshima Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kwc-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kwuc.ac.jp/"],
    name: "Kyushu Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kwuc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyokyo-u.ac.jp/"],
    name: "Kyoto University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyokyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyorin-u.ac.jp/"],
    name: "Kyorin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyorin-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoritsu-ph.ac.jp/"],
    name: "Kyoritsu Pharmaceutical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoritsu-ph.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoritsu-wu.ac.jp/"],
    name: "Kyoritsu Woman's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoritsu-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-art.ac.jp/"],
    name: "Kyoto University of Art and Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-art.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyotogakuen-u.ac.jp/"],
    name: "Kyoto Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyotogakuen-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-phu.ac.jp/"],
    name: "Kyoto Pharmaceutical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-phu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-seika.ac.jp/"],
    name: "Kyoto Seika University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-seika.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-su.ac.jp/"],
    name: "Kyoto Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-su.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-u.ac.jp/"],
    name: "Kyoto University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyoto-wu.ac.jp/"],
    name: "Kyoto Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyoto-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyu-dent.ac.jp/"],
    name: "Kyushu Dental College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyu-dent.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyukyo-u.ac.jp/"],
    name: "Kyushu Kyoritsu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyukyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyushu-id.ac.jp/"],
    name: "Kyushu Institute of Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyushu-id.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyushu-ns.ac.jp/"],
    name: "Kyushu University of Nursing and SocialWelfare",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyushu-ns.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyushu-u.ac.jp/"],
    name: "Kyushu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyushu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.kyutech.ac.jp/"],
    name: "Kyushu Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["kyutech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.marianna-u.ac.jp/"],
    name: "St. Marianna University School of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["marianna-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.matsuyama-u.ac.jp/"],
    name: "Matsuyama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["matsuyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mdu.ac.jp/"],
    name: "Matsumoto Dental University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mdu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meiji.ac.jp/"],
    name: "Meiji University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meiji.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meijigakuin.ac.jp/"],
    name: "Meiji Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meijigakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meiji-u.ac.jp/"],
    name: "Meiji University of Oriental Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meiji-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meijo-u.ac.jp/"],
    name: "Meijo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meijo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meikai.ac.jp/"],
    name: "Meikai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meikai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meio-u.ac.jp/"],
    name: "Meio University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meio-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.meisei-u.ac.jp/"],
    name: "Meisei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["meisei-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mejiro.ac.jp/"],
    name: "Mejiro University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mejiro.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.metro-hs.ac.jp/"],
    name: "Tokyo Metropolitan University of Health Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["metro-hs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.metro-u.ac.jp/"],
    name: "Tokyo Metropolitan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["metro-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mgu.ac.jp/"],
    name: "Miyagi Gakuin Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mgu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mie-chukyo-u.ac.jp/"],
    name: "Matsusaka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mie-chukyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mie-u.ac.jp/"],
    name: "Mie University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mie-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mimasaka.ac.jp/"],
    name: "Mimasaka Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mimasaka.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.miyakyo-u.ac.jp/"],
    name: "Miyagi University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["miyakyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.miyasankei-u.ac.jp/"],
    name: "Sankei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["miyasankei-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.miyazaki-med.ac.jp/"],
    name: "Miyazaki Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["miyazaki-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.miyazaki-mu.ac.jp/"],
    name: "Miyazaki Municipal University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["miyazaki-mu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.miyazaki-u.ac.jp/"],
    name: "Miyazaki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["miyazaki-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.morioka-u.ac.jp/"],
    name: "Morioka College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["morioka-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mpu.ac.jp/"],
    name: "Miyazaki Prefectural Nursing University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mpu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.mukogawa-u.ac.jp/"],
    name: "Mukogawa Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["mukogawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.muroran-it.ac.jp/"],
    name: "Muroran Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["muroran-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.musabi.ac.jp/"],
    name: "Musashino Art University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["musabi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.musashi.ac.jp/"],
    name: "Musashi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["musashi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.musashino-music.ac.jp/"],
    name: "Musashino Academy of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["musashino-music.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.musashino-wu.ac.jp/"],
    name: "Musashino Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["musashino-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.musashi-tech.ac.jp/"],
    name: "Musashi Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["musashi-tech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.my-pharm.ac.jp/"],
    name: "Meiji College of Pharmacy",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["my-pharm.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.myu.ac.jp/"],
    name: "Miyagi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["myu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagano.ac.jp/"],
    name: "Nagano University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagano.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagaokaut.ac.jp/"],
    name: "Nagaoka University of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagaokaut.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagasakipu.ac.jp/"],
    name: "Nagasaki Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagasakipu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagasaki-u.ac.jp/"],
    name: "Nagasaki University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagasaki-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagoya-cu.ac.jp/"],
    name: "Nagoya City University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagoya-cu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagoya-ku.ac.jp/"],
    name: "Nagoya Economics University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagoya-ku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagoya-u.ac.jp/"],
    name: "Nagoya University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagoya-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nagoya-wu.ac.jp/"],
    name: "Nagoya Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nagoya-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nakamura-u.ac.jp/"],
    name: "Nakamura Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nakamura-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nankyudai.ac.jp/"],
    name: "Minamikyushu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nankyudai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nanzan-u.ac.jp/"],
    name: "Nanzan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nanzan-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nara-edu.ac.jp/"],
    name: "Nara University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nara-edu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.naramed-u.ac.jp/"],
    name: "Nara Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["naramed-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nara-su.ac.jp/"],
    name: "Nara Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nara-su.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nara-u.ac.jp/"],
    name: "Nara University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nara-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.narauc.ac.jp/"],
    name: "Nara University of Commerce",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["narauc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nara-wu.ac.jp/"],
    name: "Nara Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nara-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.naruto-u.ac.jp/"],
    name: "Naruto University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["naruto-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nbu.ac.jp/"],
    name: "Nippon Bunri University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nbu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ndmc.ac.jp/"],
    name: "National Defence Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ndmc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ndsu.ac.jp/"],
    name: "Nortre Dame Seishin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ndsu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ndu.ac.jp/"],
    name: "Nippon Dental University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ndu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nebuta.ac.jp/"],
    name: "Aomori Public College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nebuta.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.n-fukushi.ac.jp/"],
    name: "Nihon Fukushi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["n-fukushi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ngu.ac.jp/"],
    name: "Nagoya Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ngu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nias.ac.jp/"],
    name: "Nagasaki Institute of Applied Science",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nias.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nifs-k.ac.jp/"],
    name: "National Institute of Fitness and Sports Kanoya",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nifs-k.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nihon-u.ac.jp/"],
    name: "Nihon University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nihon-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.niigata-pharm.ac.jp/"],
    name: "Niigata College of Pharmacy",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["niigata-pharm.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.niigata-u.ac.jp/"],
    name: "Niigata University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["niigata-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.niigataum.ac.jp/"],
    name: "Niigata University of Management",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["niigataum.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nishitech.ac.jp/"],
    name: "Nishinippon Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nishitech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nishogakusha-u.ac.jp/"],
    name: "Nisho Gakusha University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nishogakusha-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nisikyu-u.ac.jp/"],
    name: "Nishikyushu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nisikyu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nit.ac.jp/"],
    name: "Nippon Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nitech.ac.jp/"],
    name: "Nagoya Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nitech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nittai.ac.jp/"],
    name: "Nippon Sport Science University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nittai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nms.ac.jp/"],
    name: "Nippon Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nms.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nodai.ac.jp/"],
    name: "Tokyo University of Agriculture",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.notredame.ac.jp/"],
    name: "Notre Dame Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["notredame.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nsu.ac.jp/"],
    name: "Niigata Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nsu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ntu.ac.jp/"],
    name: "Teikyo University of Science and Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ntu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nua.ac.jp/"],
    name: "Nagoya University of Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nua.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nucba.ac.jp/"],
    name: "Nagoya University of Commerce and Business Administration",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nucba.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nufs.nakanishi.ac.jp/"],
    name: "Nagoya University of Foreign Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nufs.nakanishi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nuis.ac.jp/"],
    name: "Niigata University of International and Information Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nuis.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.nvau.ac.jp/"],
    name: "Nippon Veterinary and Animalscience University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["nvau.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.obihiro.ac.jp/"],
    name: "Obihiro University of Agriculture and Veterinary Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["obihiro.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.obirin.ac.jp/"],
    name: "Obirin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["obirin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ocha.ac.jp/"],
    name: "Ochanomizu Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ocha.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ohkagakuen-u.ac.jp/"],
    name: "Ohka Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ohkagakuen-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ohtani-w.ac.jp/"],
    name: "Ohtani Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ohtani-w.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ohu-u.ac.jp/"],
    name: "Ohu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ohu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oit.ac.jp/"],
    name: "Osaka Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oita-med.ac.jp/"],
    name: "Oita Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oita-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oita-nhs.ac.jp/"],
    name: "Oita University of Nursing and Health Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oita-nhs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oita-u.ac.jp/"],
    name: "Oita University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oita-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oiu.oiu.ac.jp/"],
    name: "Osaka International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oiu.oiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oiuw.oiu.ac.jp/"],
    name: "Osaka International University for Women",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oiuw.oiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oka-pu.ac.jp/"],
    name: "Okayama Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oka-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.okayama-u.ac.jp/"],
    name: "Okayama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["okayama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.okigei.ac.jp/"],
    name: "Okinawa Prefectural University of Fine Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["okigei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.okinawa-u.ac.jp/"],
    name: "Okinawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["okinawa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.okiu.ac.jp/"],
    name: "Okinawa International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["okiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osakac.ac.jp/"],
    name: "Osaka Electro-Communication University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osakac.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-cu.ac.jp/"],
    name: "Osaka City University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-cu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-dent.ac.jp/"],
    name: "Osaka Dental University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-dent.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osakafu-u.ac.jp/"],
    name: "Osaka Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osakafu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-gaidai.ac.jp/"],
    name: "Osaka University of Foreign Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-gaidai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-geidai.ac.jp/"],
    name: "Osaka University of Arts",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-geidai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-gu.ac.jp/"],
    name: "Osaka Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-gu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-kyoiku.ac.jp/"],
    name: "Osaka University of Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-kyoiku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-med.ac.jp/"],
    name: "Osaka Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-sandai.ac.jp/"],
    name: "Osaka Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-sandai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-shoin.ac.jp/"],
    name: "Osaka Shoin Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-shoin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-u.ac.jp/"],
    name: "Osaka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-ue.ac.jp/"],
    name: "Osaka University of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-ue.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osaka-wu.ac.jp/"],
    name: "Osaka Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osaka-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.osu.ac.jp/"],
    name: "Okayama Shoka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["osu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.otani.ac.jp/"],
    name: "Otani University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["otani.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.otaru-uc.ac.jp/"],
    name: "Otaru University of Commerce",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["otaru-uc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.otemae.ac.jp/"],
    name: "Otemae University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["otemae.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.otemon.ac.jp/"],
    name: "Otemon Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["otemon.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.otsuma.ac.jp/"],
    name: "Otsuma Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["otsuma.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ouhs.ac.jp/"],
    name: "Osaka University of Health and Sport Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ouhs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.oups.ac.jp/"],
    name: "Osaka University of Pharmaceutical Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["oups.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ous.ac.jp/"],
    name: "Okayama University of Science",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ous.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.poole.ac.jp/"],
    name: "Poole Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["poole.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.pu-kumamoto.ac.jp/"],
    name: "Kumamoto Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["pu-kumamoto.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.pu-toyama.ac.jp/"],
    name: "Toyama Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["pu-toyama.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.rakuno.ac.jp/"],
    name: "Rakuno Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["rakuno.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.redcross.ac.jp/"],
    name: "Japanese Red Cross College of Nursing",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["redcross.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.reitaku-u.ac.jp/"],
    name: "Reitaku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["reitaku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.rikkyo.ac.jp/"],
    name: "Rikkyo University (St. Paul's University)",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["rikkyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ris.ac.jp/"],
    name: "Rissho University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ris.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ritsumei.ac.jp/"],
    name: "Ritsumeikan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ritsumei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.rku.ac.jp/"],
    name: "Ryutsu Keizai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["rku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ryukoku.ac.jp/"],
    name: "Ryukoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ryukoku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.saga-med.ac.jp/"],
    name: "Saga Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["saga-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sagami-wu.ac.jp/"],
    name: "Sagami Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sagami-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.saga-u.ac.jp/"],
    name: "Saga University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["saga-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.saitama-med.ac.jp/"],
    name: "Saitama Medical School",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["saitama-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.saitama-u.ac.jp/"],
    name: "Saitama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["saitama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sakushin-u.ac.jp/"],
    name: "Sakushin Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sakushin-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sanno.ac.jp/"],
    name: "Sanno University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sanno.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sapmed.ac.jp/"],
    name: "Sapporo Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sapmed.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sapporo-u.ac.jp/"],
    name: "Sapporo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sapporo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seian.ac.jp/"],
    name: "Seian University of Art & Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seian.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seigakuin-univ.ac.jp/"],
    name: "Seigakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seigakuin-univ.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seijo.ac.jp/"],
    name: "Seijo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seijo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seikei.ac.jp/"],
    name: "Seikei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seikei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seinan-gu.ac.jp/"],
    name: "Seinan Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seinan-gu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seisen-u.ac.jp/"],
    name: "Seisen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seisen-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.seiwa-u.ac.jp/"],
    name: "Seiwa College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["seiwa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sendaidaigaku.jp/"],
    name: "Sendai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sendaidaigaku.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.senshu-u.ac.jp/"],
    name: "Senshu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["senshu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.senzoku.ac.jp/"],
    name: "Senzoku Gakuen College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["senzoku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.setsunan.ac.jp/"],
    name: "Setsunan University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["setsunan.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sgu.ac.jp/"],
    name: "Sapporo Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sgu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sg-u.ac.jp/"],
    name: "Shikoku Christian College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sg-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sguc.ac.jp/"],
    name: "Sanyo Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sguc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shakaijigyo.ac.jp/"],
    name: "Japan College of Social Work",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shakaijigyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shibaura-it.ac.jp/"],
    name: "Shibaura Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shibaura-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shiga-med.ac.jp/"],
    name: "Shiga University of Medical Science",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shiga-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shiga-u.ac.jp/"],
    name: "Shiga University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shiga-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shikoku-u.ac.jp/"],
    name: "Shikoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shikoku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shimane-med.ac.jp/"],
    name: "Shimane University, Faculty of Medicine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shimane-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shimane-u.ac.jp/"],
    name: "Shimane University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shimane-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shimonoseki-cu.ac.jp/"],
    name: "Shimonoseki City University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shimonoseki-cu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shinshu-u.ac.jp/"],
    name: "Shinshu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shinshu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shirayuri.ac.jp/"],
    name: "Shirayuri Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shirayuri.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shitennoji.ac.jp/"],
    name: "International Buddhist University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shitennoji.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shizuoka.ac.jp/"],
    name: "Shizuoka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shizuoka.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shodai.ac.jp/"],
    name: "Yokohama College of Commerce",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shodai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shoin.ac.jp/"],
    name: "Kobe Shoin Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shoin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shokei-gakuen.ac.jp/shokeicol/"],
    name: "Shokei College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shokei-gakuen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shonan-it.ac.jp/"],
    name: "Shonan Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shonan-it.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shotoku.ac.jp/"],
    name: "Gifu Shotoku Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shotoku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.showa-u.ac.jp/"],
    name: "Showa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["showa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shoyaku.ac.jp/"],
    name: "Showa College of Pharmaceutical Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shoyaku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shuchiin.ac.jp/"],
    name: "Shuchiin College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shuchiin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shudo-u.ac.jp/"],
    name: "Hiroshima Shudo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shudo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shujitsu.ac.jp/"],
    name: "Shujitsu Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shujitsu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shukutoku.ac.jp/"],
    name: "Shukutoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shukutoku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.shumei-u.ac.jp/"],
    name: "Shumei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["shumei-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sit.ac.jp/"],
    name: "Saitama Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.siu.ac.jp/"],
    name: "Sapporo International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["siu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.slcn.ac.jp/"],
    name: "St. Luke' s College of Nursing",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["slcn.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.soai.ac.jp/"],
    name: "Soai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["soai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.soka.ac.jp/"],
    name: "Soka University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["soka.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.soken.ac.jp/"],
    name: "Graduate University for Advanced Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["soken.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sonoda-u.ac.jp/"],
    name: "Sonoda Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sonoda-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sophia.ac.jp/"],
    name: "Sophia University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sophia.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.spu.ac.jp/"],
    name: "Saitama Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["spu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ssu.ac.jp/"],
    name: "Shizuoka Sangyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ssu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sugino.ac.jp/daiindex.html"],
    name: "Sugino Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sugino.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sugiyama-u.ac.jp/"],
    name: "Sugiyama Jogakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sugiyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.suma.kobe-wu.ac.jp/"],
    name: "Kobe Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["suma.kobe-wu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sun.ac.jp/"],
    name: "Siebold University of Nagasaki",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sun.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.surugadai.ac.jp/"],
    name: "Surugadai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["surugadai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.sut.ac.jp/"],
    name: "Science University of Tokyo",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["sut.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.suzuka-iu.ac.jp/"],
    name: "Suzuka International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["suzuka-iu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.suzuka-u.ac.jp/"],
    name: "Suzuka University of Medical Science",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["suzuka-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.swu.ac.jp/"],
    name: "Showa Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["swu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tachibana-u.ac.jp/"],
    name: "Kyoto Tachibana Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tachibana-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tais.ac.jp/"],
    name: "Taisho University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tais.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.takachiho.ac.jp/"],
    name: "Takachiho University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["takachiho.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.takamatsu-u.ac.jp/"],
    name: "Takamatsu University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["takamatsu-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.takara-univ.ac.jp/"],
    name: "Takarazuka University of Art and Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["takara-univ.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.takushoku-u.ac.jp/"],
    name: "Takushoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["takushoku-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tamabi.ac.jp/"],
    name: "Tama Art University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tamabi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tamagawa.ac.jp/"],
    name: "Tamagawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tamagawa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tbgu.ac.jp/"],
    name: "Tohoku Bunka Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tbgu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tcue.ac.jp/"],
    name: "Takasaki City University of Economics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tcue.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tdc.ac.jp/"],
    name: "Tokyo Dental College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tdc.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.teikyo-u.ac.jp/"],
    name: "Teikyo Heisei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["teikyo-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tenri-u.ac.jp/"],
    name: "Tenri University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tenri-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.termnet.co.jp/fujidai/"],
    name: "Fuji University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["termnet.co.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.teu.ac.jp/"],
    name: "Tokyo Engineering University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["teu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tezuka-gu.ac.jp/"],
    name: "Tezukayama Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tezuka-gu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tezukayama-u.ac.jp/"],
    name: "Tezukayama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tezukayama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tfu.ac.jp/"],
    name: "Tohoku Fukushi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tfu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.timis.ac.jp/"],
    name: "Tama Institute of Management and Information Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["timis.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.titech.ac.jp/"],
    name: "Tokyo Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["titech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tiu.ac.jp/"],
    name: "Tokyo International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tiu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.t-komazawa.ac.jp/"],
    name: "Tomakomai Komazawa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["t-komazawa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.t-kougei.ac.jp/"],
    name: "Tokyo Institute of Polytechnics",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["t-kougei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tku.ac.jp/"],
    name: "Tokyo Keizai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tmd.ac.jp/"],
    name: "Tokyo Medical and Dental University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tmd.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tmit.ac.jp/"],
    name: "Tokyo Metropolitan Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tmit.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohoku.ac.jp/"],
    name: "Tohoku University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohoku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohoku-gakuin.ac.jp/"],
    name: "Tohoku Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohoku-gakuin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohoku-pharm.ac.jp/"],
    name: "Tohoku College of Pharmacy",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohoku-pharm.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toho-music.ac.jp/"],
    name: "Toho College of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toho-music.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohomusic.ac.jp/"],
    name: "Toho Gakuen School of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohomusic.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toho-u.ac.jp/"],
    name: "Toho University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toho-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohtech.ac.jp"],
    name: "Tohoku Institute of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohtech.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tohwa-u.ac.jp/"],
    name: "Tohwa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tohwa-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toin.ac.jp/"],
    name: "Toin University of Yokohama",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toin.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tojo.ac.jp/"],
    name: "Tohoku Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tojo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokai.ac.jp/"],
    name: "Tokai University Educational System",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokaigakuen-u.ac.jp/"],
    name: "Tokai Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokaigakuen-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokaijoshi-u.ac.jp/"],
    name: "Tokai Women's College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokaijoshi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokiwa.ac.jp/"],
    name: "Tokiwa University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokiwa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokoha-u.ac.jp/"],
    name: "Tokoha Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokoha-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokushima-u.ac.jp/"],
    name: "Tokushima University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokushima-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokuyama-u.ac.jp/"],
    name: "Tokuyama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokuyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokyo-kasei.ac.jp/"],
    name: "Tokyo Kasei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokyo-kasei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokyo-med.ac.jp/"],
    name: "Tokyo Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokyo-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokyo-ondai.ac.jp/"],
    name: "Tokyo College of Music",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokyo-ondai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tokyo-u-fish.ac.jp/"],
    name: "Tokyo University of Fisheries",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tokyo-u-fish.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tonichi-kokusai-u.ac.jp/"],
    name: "Higashi Nippon International University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tonichi-kokusai-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tosho-u.ac.jp/"],
    name: "Tokyo University of Mercantile Marine",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tosho-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tottori-u.ac.jp/"],
    name: "Tottori University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tottori-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toua-u.ac.jp/"],
    name: "University of East Asia",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toua-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyaku.ac.jp/"],
    name: "Tokyo University of Pharmacy and Life Science",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyaku.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyama-mpu.ac.jp/"],
    name: "Toyama Medical and Pharmaceutical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyama-mpu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyama-u.ac.jp/"],
    name: "Toyama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyo.ac.jp/"],
    name: "Toyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyoeiwa.ac.jp/"],
    name: "Toyo Eiwa Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyoeiwa.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyogakuen-u.ac.jp/"],
    name: "Toyo Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyogakuen-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.toyota-ti.ac.jp/"],
    name: "Toyota Technological Institute",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["toyota-ti.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tsuda.ac.jp/"],
    name: "Tsuda College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tsuda.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tsukuba.ac.jp/"],
    name: "Tsukuba University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tsukuba.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tsuru.ac.jp/"],
    name: "Tsuru University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tsuru.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tsurumi-u.ac.jp/"],
    name: "Tsurumi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tsurumi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tuad.ac.jp/"],
    name: "Tohoku University of Art and Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tuad.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tuat.ac.jp/"],
    name: "Tokyo University of Agriculture and Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tuat.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tufs.ac.jp/"],
    name: "Tokyo University of Foreign Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tufs.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tuins.ac.jp/"],
    name: "Toyama University of International Studies",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tuins.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tuis.ac.jp/"],
    name: "Tokyo University of Information Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tuis.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tuj.ac.jp/"],
    name: "Temple University Japan",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tuj.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.tut.ac.jp/"],
    name: "Toyohashi University of Technology",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["tut.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.twcpe.ac.jp/"],
    name: "Tokyo Women's College of Physical Education",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["twcpe.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.twcu.ac.jp/"],
    name: "Tokyo Woman's Christian University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["twcu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.twmu.ac.jp/"],
    name: "Tokyo Women's Medial College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["twmu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-air.ac.jp/"],
    name: "University of the Air",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-air.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-aizu.ac.jp/"],
    name: "University of Aizu",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-aizu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-bunkyo.ac.jp/"],
    name: "University of Bunkyo",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-bunkyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.uec.ac.jp/"],
    name: "University of Electro-Communications",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["uec.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.uenogakuen.ac.jp/"],
    name: "Ueno Gakuen College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["uenogakuen.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-gakugei.ac.jp/"],
    name: "Tokyo Gakugei University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-gakugei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.uitec.ac.jp/"],
    name: "Polytechnic University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["uitec.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-keiai.ac.jp/"],
    name: "Keiai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-keiai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.umds.ac.jp/"],
    name: "University of Marketing and Distribution Sciences",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["umds.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.unu.edu/"],
    name: "United Nations University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["unu.edu"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.uoeh-u.ac.jp/"],
    name: "University of Occupational and Environmental Health, Japan",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["uoeh-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-ryukyu.ac.jp/"],
    name: "University of the Ryukyus",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-ryukyu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-sacred-heart.ac.jp/"],
    name: "University of the Sacred Heart Tokyo",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-sacred-heart.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-shizuoka-ken.ac.jp/"],
    name: "Shizuoka Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-shizuoka-ken.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.usp.ac.jp/"],
    name: "University of Shiga Prefecture",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["usp.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-tokai.ac.jp/"],
    name: "Hokkaido Tokai University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-tokai.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.u-tokyo.ac.jp/"],
    name: "Tokyo University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["u-tokyo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.utsunomiya-u.ac.jp/"],
    name: "Utsunomiya University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["utsunomiya-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.wakayama-med.ac.jp/"],
    name: "Wakayama Medical College",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["wakayama-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.wakayama-u.ac.jp/"],
    name: "Wakayama University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["wakayama-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.wakhok.ac.jp/"],
    name: "Wakkanai Hokusei Gakuen University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["wakhok.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.wako.ac.jp/"],
    name: "Wako University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["wako.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.waseda.ac.jp/"],
    name: "Waseda University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["waseda.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.wayo.ac.jp/"],
    name: "Wayo Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["wayo.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yamagata-u.ac.jp/"],
    name: "Yamagata University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yamagata-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yamaguchi-pu.ac.jp/"],
    name: "Yamaguchi Prefectural University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yamaguchi-pu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yamaguchi-u.ac.jp/"],
    name: "Yamaguchi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yamaguchi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yamanashi.ac.jp/"],
    name: "Yamanashi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yamanashi.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yamanashi-med.ac.jp/"],
    name: "Yamanashi Medical University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yamanashi-med.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yama.sut.ac.jp/"],
    name: "Science University of Tokyo in Yamaguchi",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yama.sut.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yasuda-u.ac.jp/"],
    name: "Yasuda Women's University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yasuda-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ygu.ac.jp/"],
    name: "Yamanashi Gakuin University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ygu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.ynu.ac.jp/"],
    name: "Yokohama National University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["ynu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yokkaichi-u.ac.jp/"],
    name: "Yokkaichi University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yokkaichi-u.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.yokohama-cu.ac.jp/"],
    name: "Yokohama City University",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["yokohama-cu.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.zokei.ac.jp/"],
    name: "Tokyo University of Art and Design",
    alpha_two_code: "JP",
    "state-province": null,
    domains: ["zokei.ac.jp"],
    country: "Japan",
  },
  {
    web_pages: ["http://www.aabfs.org/"],
    name: "Arab Academy for Banking and Financial Sciences",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["aabfs.org"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.aabu.edu.jo/"],
    name: "Al al-Bayt University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["aabu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.aau.edu.jo/"],
    name: "Amman Arab University for Higher Studies",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["aau.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.ahu.edu.jo/"],
    name: "Al Hussein Bin Talal University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["ahu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.alzaytoonah.edu.jo/"],
    name: "Al-Zaytoonah University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["alzaytoonah.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.amman.edu/"],
    name: "Amman University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["amman.edu"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.ammanu.edu.jo/"],
    name: "Al-Ahliyya Amman University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["ammanu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.aou.edu.jo/"],
    name: "Arab Open University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["aou.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.asu.edu.jo/"],
    name: "Applied Science University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["asu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.bau.edu.jo/"],
    name: "Al-Balqa Applied University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["bau.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.gju.edu.jo/"],
    name: "German Jordanian University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["gju.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.hu.edu.jo/"],
    name: "Hashemite University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["hu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.inu.edu.jo/"],
    name: "Irbid National University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["inu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.isra.edu.jo/"],
    name: "Al-Isra University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["isra.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.jadara.edu.jo/"],
    name: "Jadara University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["jadara.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.jam.edu.jo/"],
    name: "Jordan Academy of Music / Higher Institute of Music",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["jam.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.jerashun.edu.jo/"],
    name: "Jerash Private University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["jerashun.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.ju.edu.jo/"],
    name: "University of Jordan",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["ju.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.just.edu.jo/"],
    name: "Jordan University of Science and Technology",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["just.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.meu.edu.jo/"],
    name: "Middle East University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["meu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.mutah.edu.jo/"],
    name: "Mu' tah University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["mutah.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.nyit.edu.jo/"],
    name: "New York Institute of Technology",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["nyit.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.philadelphia.edu.jo/"],
    name: "Philadelphia University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["philadelphia.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.psut.edu.jo/"],
    name: "Princess Sumaya University for Technology",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["psut.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.ttu.edu.jo/"],
    name: "Tafila Technical University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["ttu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.uop.edu.jo/"],
    name: "University of Petra",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["uop.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.wise.edu.jo/"],
    name: "The World Islamic Sciences & Education University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["wise.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.yu.edu.jo/"],
    name: "Yarmouk University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["yu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.zpu.edu.jo/"],
    name: "Zarka Private University",
    alpha_two_code: "JO",
    "state-province": null,
    domains: ["zpu.edu.jo"],
    country: "Jordan",
  },
  {
    web_pages: ["http://www.ablaikhan.kz/"],
    name: "Abylai Khan University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["ablaikhan.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.agriun.almaty.kz/"],
    name: "Kazak State University of Agriculture",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["agriun.almaty.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.aktsu.kz/"],
    name: "Aktau State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["aktsu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.atgu.kz/"],
    name: "Atyrau State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["atgu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.ektu.kz/"],
    name: "East Kazakstan State Technical University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["ektu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.enu.kz/"],
    name: "L.N. Gumilyov Eurasian National University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["enu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.eurazir.kz/"],
    name: "Eurasian Institute of market",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["eurazir.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kau.kz/"],
    name: "Kazak American University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kau.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kazeu.kz/"],
    name: "Turar Ryskulov Kazakh Economic University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kazeu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kaznpu.kz/"],
    name: "Abai State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kaznpu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kazntu.kz/"],
    name: "Kazak National Technical University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kazntu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kaznu.kz/"],
    name: "Al-Farabi Kazakh National University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kaznu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kbtu.kz/"],
    name: "Kazakh British Technical University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kbtu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kimep.kz/"],
    name: "Kazakhstan Institute of Management, Economics, and Strategic Research",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kimep.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.kstu.kz/"],
    name: "Karaganda State Technical University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["kstu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.ksu.kst.kz/"],
    name: "Kostanai State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["ksu.kst.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.ksu.kz/"],
    name: "Karaganda State Buketov University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["ksu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.nkzu.kz/"],
    name: "North Kazakhstan State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["nkzu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.psu.kz/"],
    name: "Pavlodar University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["psu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.sdu.edu.kz/"],
    name: "Suleyman Demirel University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["sdu.edu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.semgu.kz/"],
    name: "Semey State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["semgu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.sgma.kz/"],
    name: "Semey State Medical University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["sgma.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.turkistan.kz/"],
    name: "International Kazakh-Turkish University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["turkistan.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.uib.kz/"],
    name: "University of International Business",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["uib.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.vkgu.kz/"],
    name: "East Kazakhstan State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["vkgu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.wkau.kz/"],
    name: "Western Kazakhstan Agricultural University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["wkau.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.zhezu.kz/"],
    name: "Zhezkazgan Baikonurov University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["zhezu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.zhgu.kz/"],
    name: "Zhetysu State University",
    alpha_two_code: "KZ",
    "state-province": null,
    domains: ["zhgu.kz"],
    country: "Kazakhstan",
  },
  {
    web_pages: ["http://www.aiu.ac.ke/"],
    name: "Africa International University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["aiu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.aku.edu/"],
    name: "Aga Khan University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["aku.edu"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.anu.ac.ke/"],
    name: "Africa Nazarene University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["anu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.aua.ac.ke/"],
    name: "Adventist University of Africa",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["aua.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.chuka.ac.ke/"],
    name: "Chuka University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["chuka.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.cuea.edu/"],
    name: "Catholic University of Eastern Africa",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["cuea.edu"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.daystar.ac.ke/"],
    name: "Daystar University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["daystar.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.dkut.ac.ke/"],
    name: "Dedan Kimathi University of Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["dkut.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.egerton.ac.ke/"],
    name: "Egerton University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["egerton.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.gluk.ac.ke/"],
    name: "Great Lakes University of Kisumu",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["gluk.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.gretsauniversity.ac.ke/"],
    name: "Gretsa Universtiy",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["gretsauniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.iu.ac.ke/"],
    name: "Inoorero University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["iu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.jkuat.ac.ke/"],
    name: "Jomo Kenyatta University of Agriculture and Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["jkuat.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.jooust.ac.ke/"],
    name: "Jaramogi Oginga Odinga University of Science and Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["jooust.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kabarak.ac.ke/"],
    name: "Kabarak University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kabarak.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kabianga.ac.ke/"],
    name: "University of Kabianga",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kabianga.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.karatinauniversity.ac.ke/"],
    name: "Karatina University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["karatinauniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kca.ac.ke/"],
    name: "Kenya College of Accountancy",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kca.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kemu.ac.ke/"],
    name: "Kenya Methodist University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kemu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kisiiuniversity.ac.ke/"],
    name: "Kisii University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kisiiuniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kmtc.ac.ke/"],
    name: "Kenya Medical Training College",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kmtc.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.ku.ac.ke/"],
    name: "Kenyatta University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["ku.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.kwust.ac.ke/"],
    name: "Kiriri Womens University of Science and Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["kwust.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.laikipia.ac.ke/"],
    name: "Laikipia University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["laikipia.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.maseno.ac.ke/"],
    name: "Maseno University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["maseno.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.mku.ac.ke/"],
    name: "Mount Kenya University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["mku.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.mmarau.ac.ke/"],
    name: "Maasai Mara University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["mmarau.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.mmu.ac.ke/"],
    name: "Multimedia University of Kenya",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["mmu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.mmust.ac.ke/"],
    name: "Masinde Muliro University of Science and Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["mmust.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.mu.ac.ke/"],
    name: "Moi University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["mu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.must.ac.ke/"],
    name: "Meru University of Science and Technology",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["must.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.nibs.ac.ke/"],
    name: "Nairobi Institute of Business Studies",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["nibs.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.ntti.ac.ke/"],
    name: "Nairobi Technical Training Institute",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["ntti.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.pacuniversity.ac.ke/"],
    name: "Pan Africa Christian University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["pacuniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.piu.ac.ke/"],
    name: "Pioneer International University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["piu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.pu.ac.ke/"],
    name: "Pwani University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["pu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.puea.ac.ke/"],
    name: "Presbyterian University of East Africa",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["puea.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.riarauniversity.ac.ke/"],
    name: "Riara University School of Business and Law",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["riarauniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.scott.ac.ke/"],
    name: "Scott Christian University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["scott.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.seku.ac.ke/"],
    name: "South Eastern Kenya University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["seku.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.spu.ac.ke/"],
    name: "St. Pauls University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["spu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.strathmore.edu/"],
    name: "Strathmore University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["strathmore.edu"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.tukenya.ac.ke/"],
    name: "Technical University of Kenya",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["tukenya.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.tum.ac.ke/"],
    name: "Technical University of Mombasa",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["tum.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.ueab.ac.ke/"],
    name: "University of Eastern Africa, Baraton",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["ueab.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.uoeld.ac.ke/"],
    name: "University of Eldoret",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["uoeld.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.uonbi.ac.ke/"],
    name: "University of Nairobi",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["uonbi.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.usiu.ac.ke/"],
    name: "United States International University",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["usiu.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.uzimauniversity.ac.ke/"],
    name: "Uzima University College",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["uzimauniversity.ac.ke"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.zetechcollege.com/"],
    name: "Zetech College",
    alpha_two_code: "KE",
    "state-province": null,
    domains: ["zetechcollege.com"],
    country: "Kenya",
  },
  {
    web_pages: ["http://www.pust.net/"],
    name: "Pyongyang University of Science and Technology",
    alpha_two_code: "KP",
    "state-province": null,
    domains: ["pust.net"],
    country: "Korea, Democratic People's Republic of",
  },
  {
    web_pages: ["http://www.ajou.ac.kr/"],
    name: "Ajou University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ajou.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.andong.ac.kr/"],
    name: "Andong National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["andong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.acts.ac.kr/"],
    name: "Asian United Theological University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["acts.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.bu.ac.kr"],
    name: "Baekseok University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["bu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.bnue.ac.kr/"],
    name: "Busan National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["bnue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.bpu.ac.kr/"],
    name: "Busan Presbyterian University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["bpu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.bufs.ac.kr"],
    name: "Busan University of Foreign Studies",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["bufs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cataegu.ac.kr/"],
    name: "Catholic University of Taegu-Hyosung",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cataegu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cau.ac.kr/"],
    name: "Chung-Ang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cau.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.changwon.ac.kr/"],
    name: "Changwon National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["changwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["https://www.charusat.ac.in/"],
    name: "Charotar University of Science and Technology",
    alpha_two_code: "IN",
    "state-province": null,
    domains: ["charusat.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.cheju.ac.kr/"],
    name: "Cheju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cheju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cheju-e.ac.kr/"],
    name: "Cheju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cheju-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chinju.ac.kr/"],
    name: "Chinju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chinju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chinju-e.ac.kr/"],
    name: "Chinju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chinju-e.ac.kr", "cue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chodang.ac.kr/"],
    name: "Chodang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chodang.ac.kr", "cdu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chonbuk.ac.kr/"],
    name: "Chonbuk National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chonbuk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chongju.ac.kr/"],
    name: "Chongju University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chongju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chongju-e.ac.kr/"],
    name: "Chongju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chongju-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chonju-e.ac.kr/"],
    name: "Chonju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chonju-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chonnam.ac.kr/"],
    name: "Chonnam National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chonnam.ac.kr", "jnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chosun.ac.kr/"],
    name: "Chosun University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chosun.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chungbuk.ac.kr/"],
    name: "Chungbuk National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chungbuk.ac.kr", "cbnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chungju.ac.kr/"],
    name: "Chung-Ju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chungju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chungnam.ac.kr/"],
    name: "Chungnam National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chungnam.ac.kr", "cnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cnue-e.ac.kr/"],
    name: "Chunchon National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cnue-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cuk.ac.kr/"],
    name: "Catholic University of Korea",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cuk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cup.ac.kr/"],
    name: "Catholic University of Pusan",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cup.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cha.ac.kr"],
    name: "CHA University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cha.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cju.ac.kr"],
    name: "CHEONGJU UNIVERSITY",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cku.ac.kr"],
    name: "Catholic Kwandong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cku.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cs.ac.kr/"],
    name: "Changshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cje.ac.kr/"],
    name: "Cheongju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cje.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chongshin.ac.kr"],
    name: "Chongshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chongshin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chugye.ac.kr/"],
    name: "Chugye University for the Arts",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chugye.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.cnue.ac.kr/"],
    name: "Chuncheon National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["cnue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.chungwoon.ac.kr"],
    name: "Chungwoon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["chungwoon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.daebul.ac.kr/"],
    name: "Daebul University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["daebul.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dankook.ac.kr/"],
    name: "Dankook University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dankook.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.donga.ac.kr/"],
    name: "Dong-A University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["donga.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dongduk.ac.kr/"],
    name: "Dongduk Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dongduk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dongeui.ac.kr/"],
    name: "Dong Eui University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dongeui.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dongguk.ac.kr/"],
    name: "Dongguk University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dongguk.ac.kr", "dongguk.edu"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dongseo.ac.kr/"],
    name: "Dongseo University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dongseo.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dongshinu.ac.kr/"],
    name: "Dongshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dongshinu.ac.kr", "dsu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.duksung.ac.kr/"],
    name: "Duksung Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["duksung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dytc.ac.kr/"],
    name: "Dong Yang University of Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dytc.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.tau.ac.kr/"],
    name: "Daegu Arts University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["tau.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dgist.ac.kr/"],
    name: "Daegu Gyeongbuk Institute of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dgist.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dhu.ac.kr"],
    name: "Daegu Haany University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dhu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dnue.ac.kr/"],
    name: "Daegu National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dnue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.daegu.ac.kr/"],
    name: "Daegu University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["daegu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dufs.ac.kr/"],
    name: "Daegu University of Foreign Studies",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dufs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dcatholic.ac.kr/"],
    name: "Daejeon Catholic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dcatholic.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.daejeon.ac.kr/"],
    name: "Daejeon Theological University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["daejeon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dju.ac.kr/"],
    name: "Daejeon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.daejin.ac.kr"],
    name: "Daejin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["daejin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.daeshin.ac.kr/"],
    name: "Daeshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["daeshin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.deu.ac.kr"],
    name: "Dong-Eui University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["deu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.dyu.ac.kr/"],
    name: "Dongyang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["dyu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ewha.ac.kr/"],
    name: "Ewha Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ewha.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.eulji.ac.kr/"],
    name: "Eulji University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["eulji.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kdu.ac.kr/"],
    name: "Far East University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kdu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gachon.ac.kr/"],
    name: "Gachon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gachon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gwnu.ac.kr/"],
    name: "Gangneung-Wonju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gwnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ggu.ac.kr"],
    name: "Geumgang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ggu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gimcheon.ac.kr/"],
    name: "Gimcheon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gimcheon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gjue.ac.kr"],
    name: "Gongju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gjue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gjcatholic.ac.kr/"],
    name: "Gwangju Catholic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gjcatholic.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gist.ac.kr/"],
    name: "Gwangju Institute of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gist.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gnue.ac.kr/"],
    name: "Gwangju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gnue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gwangju.ac.kr/"],
    name: "Gwangju University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gwangju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ginue.ac.kr/"],
    name: "Gyeongin National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ginue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gntech.ac.kr"],
    name: "Gyeongnam National University of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gntech.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.gsnu.ac.kr/"],
    name: "Gyeongsang National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["gsnu.ac.kr", "gnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hallym.ac.kr/"],
    name: "Hallym University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hallym.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hangkong.ac.kr/"],
    name: "Hankuk Aviation University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hangkong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hannam.ac.kr/"],
    name: "Hannam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hannam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hansei.ac.kr/"],
    name: "Hansei University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hansei.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanseo.ac.kr/"],
    name: "Hanseo University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanseo.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanshin.ac.kr/"],
    name: "Hanshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanshin.ac.kr", "hs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hansung.ac.kr/"],
    name: "Hansung University Seoul",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hansung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanyang.ac.kr/"],
    name: "Hanyang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanyang.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hknu.ac.kr/"],
    name: "Hankyong National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hknu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.honam.ac.kr/"],
    name: "Honam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["honam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hongik.ac.kr/"],
    name: "Hongik University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hongik.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hoseo.ac.kr/"],
    name: "Hoseo University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hoseo.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.howon.ac.kr/"],
    name: "Chonbuk Sanup University of Technology (Howon University)",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["howon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hufs.ac.kr/"],
    name: "Hankuk University of Foreign Studies",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hufs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hyupsung.ac.kr/"],
    name: "Hyupsung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hyupsung.ac.kr", "uhs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.halla.ac.kr/"],
    name: "Halla University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["halla.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanbat.ac.kr/"],
    name: "Hanbat National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanbat.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.handong.edu"],
    name: "Handong Global University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["handong.edu"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanil.ac.kr/"],
    name: "Hanil University and Presbyterian Theological Seminary",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanil.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanlyo.ac.kr/"],
    name: "Hanlyo University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanlyo.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hanzhong.ac.kr/"],
    name: "Hanzhong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hanzhong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.htus.ac.kr/"],
    name: "Honam Theological University and Seminary",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["htus.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.iccu.ac.kr/"],
    name: "Incheon Catholic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["iccu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.iuk.ac.kr/"],
    name: "International University of Korea",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["iuk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.icu.ac.kr/"],
    name: "Information and Communications University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["icu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.inchon.ac.kr/"],
    name: "Inchon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["inchon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.inchon-e.ac.kr/"],
    name: "Inchon National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["inchon-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.inha.ac.kr/"],
    name: "Inha University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["inha.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.inje.ac.kr/"],
    name: "Inje University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["inje.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jeonju.ac.kr/"],
    name: "Jeonju University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jeonju.ac.kr", "jj.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jeju.ac.kr/"],
    name: "Jeju International University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jeju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jejunu.ac.kr"],
    name: "Jeju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jejunu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jnue.ac.kr/"],
    name: "Jeonju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jnue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jesus.ac.kr/"],
    name: "Jesus University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jesus.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sangha.ac.kr/"],
    name: "Joong-Ang Sangha University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sangha.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.joongbu.ac.kr"],
    name: "Joongbu University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["joongbu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.jwu.ac.kr"],
    name: "Jungwon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["jwu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kaist.ac.kr/"],
    name: "Korea Advanced Institute of Science & Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kaist.ac.kr", "kaist.edu"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kangnam.ac.kr/"],
    name: "Kangnam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kangnam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kangnung.ac.kr/"],
    name: "Kangnung National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kangnung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kangwon.ac.kr/"],
    name: "Kangwon National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kangwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kaya.ac.kr/"],
    name: "Kaya University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kaya.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kdischool.ac.kr/"],
    name: "KDI School of Public Policy and Management",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kdischool.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.keimyung.ac.kr/"],
    name: "Keimyung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["keimyung.ac.kr", "kmu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kmaritime.ac.kr/"],
    name: "Korea Maritime University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kmaritime.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.knou.ac.kr/"],
    name: "Korea National Open University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["knou.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.knua.ac.kr/"],
    name: "Korea National University of Arts",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["knua.ac.kr", "karts.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.knue.ac.kr/"],
    name: "Korea National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["knue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.knupe.ac.kr/"],
    name: "Korea National University of Physical Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["knupe.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kongju-e.ac.kr/"],
    name: "Kongju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kongju-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.konkuk.ac.kr/"],
    name: "Konkuk University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["konkuk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.konyang.ac.kr/"],
    name: "Konyang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["konyang.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kookmin.ac.kr/"],
    name: "Kookmin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kookmin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.korea.ac.kr/"],
    name: "Korea University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["korea.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kosin.ac.kr/"],
    name: "Kosin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kosin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kumoh.ac.kr/"],
    name: "Kumoh National University of Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kumoh.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kunsan.ac.kr/"],
    name: "Kunsan National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kunsan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwandong.ac.kr/"],
    name: "Kwan Dong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwandong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwangju.ac.kr/"],
    name: "Kwangju University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwangju.ac.kr", "gwangju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwangju-e.ac.kr/"],
    name: "Kwangju National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwangju-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwangwoon.ac.kr/"],
    name: "Kwangwoon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwangwoon.ac.kr", "kw.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyonggi.ac.kr/"],
    name: "Kyonggi University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyonggi.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyongju.ac.kr/"],
    name: "Kongju National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyongju.ac.kr", "kongju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyunghee.ac.kr/"],
    name: "Kyunghee University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyunghee.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyungil.ac.kr/"],
    name: "Kyungil University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyungil.ac.kr", "kiu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyungnam.ac.kr/"],
    name: "Kyungnam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyungnam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyungpook.ac.kr/"],
    name: "Kyungpook National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyungpook.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyungsung.ac.kr/"],
    name: "Kyungsung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyungsung.ac.kr", "ks.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kyungwon.ac.kr/"],
    name: "Kyungwon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kyungwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kcu.ac.kr/"],
    name: "KC University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kcu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kkot.ac.kr/"],
    name: "Kkottongnae University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kkot.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kau.ac.kr"],
    name: "Korea Aerospace University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kau.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kafna.ac.kr"],
    name: "Korea Armed Forces Nursing Academy",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kafna.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kbtus.ac.kr/"],
    name: "Korea Baptist Theological University and Seminary",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kbtus.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kmou.ac.kr"],
    name: "Korea Maritime and Ocean University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kmou.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kma.ac.kr/"],
    name: "Korea Military Academy",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kma.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.knsu.ac.kr"],
    name: "Korea National Sport University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["knsu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.nuch.ac.kr"],
    name: "Korea National University of Cultural Heritage",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["nuch.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kornu.ac.kr/"],
    name: "Korea Nazarene University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kornu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kpu.ac.kr/"],
    name: "Korea Polytechnic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kpu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.koreatech.ac.kr"],
    name: "Korea University of Technology and Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["koreatech.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.bible.ac.kr/"],
    name: "Korean Bible University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["bible.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.police.ac.kr/"],
    name: "Korean National Police University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["police.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwu.ac.kr/"],
    name: "Kwangju Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kwangshin.ac.kr/"],
    name: "Kwangshin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kwangshin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.khu.ac.kr"],
    name: "Kyung Hee University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["khu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.kduniv.ac.kr/"],
    name: "Kyungdong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["kduniv.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ikw.ac.kr/"],
    name: "Kyungwoon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ikw.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.miryang.ac.kr/"],
    name: "Miryang National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["miryang.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.mmu.ac.kr/"],
    name: "Mokpo National Maritime University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["mmu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.mokpo.ac.kr/"],
    name: "Mokpo National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["mokpo.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.mokwon.ac.kr/"],
    name: "Mokwon University Taejon",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["mokwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.myongji.ac.kr/"],
    name: "Myongji University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["myongji.ac.kr", "mju.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.mtu.ac.kr/"],
    name: "Methodist Theological University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["mtu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["https://www.mcu.ac.kr/"],
    name: "Mokpo Catholic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["mcu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.nambu.ac.kr/"],
    name: "Nambu University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["nambu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.nsu.ac.kr/"],
    name: "Namseoul University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["nsu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pcu.ac.kr"],
    name: "Pai Chai University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pcu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.puts.ac.kr/"],
    name: "Presbyterian University and Theological Seminary",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["puts.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ptu.ac.kr/"],
    name: "Pyeongtaek University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ptu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.paichai.ac.kr/"],
    name: "Paichai University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["paichai.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pknu.ac.kr/"],
    name: "Pukyong National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pknu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.postech.ac.kr/", "http://www.postech.edu/"],
    name: "Pohang University of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["postech.ac.kr", "postech.edu"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ptuniv.ac.kr/"],
    name: "Pyongtaek University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ptuniv.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pufs.ac.kr/"],
    name: "Pusan University of Foreign Studies",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pufs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pusan.ac.kr/"],
    name: "Pusan National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pusan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pusan-e.ac.kr/"],
    name: "Pusan National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pusan-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.pwc.ac.kr/"],
    name: "Pusan Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["pwc.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.afa.ac.kr/"],
    name: "Republic of Korea Air Force Academy",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["afa.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.navy.ac.kr/"],
    name: "Republic of Korea Naval Academy",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["navy.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.samchok.ac.kr/"],
    name: "Samchok National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["samchok.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sangji.ac.kr/"],
    name: "Sang Ji University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sangji.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sangmyung.ac.kr/"],
    name: "Sang Myung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sangmyung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sch.ac.kr/"],
    name: "Soonchunhyang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sch.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sejong.ac.kr/"],
    name: "Sejong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sejong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.semyung.ac.kr/"],
    name: "Semyung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["semyung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.seonam.ac.kr/"],
    name: "Seonam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["seonam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.seoul-e.ac.kr/"],
    name: "Seoul National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["seoul-e.ac.kr", "snue.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.seowon.ac.kr/"],
    name: "Seowon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["seowon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.silla.ac.kr/"],
    name: "Silla University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["silla.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.skku.ac.kr/"],
    name: "Sung Kyun Kwan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["skku.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.skuniv.ac.kr/", "http://www.seokyeong.ac.kr/"],
    name: "Seokyeong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["skuniv.ac.kr", "seokyeong.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.snu.ac.kr/"],
    name: "Seoul National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["snu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.snut.ac.kr/"],
    name: "Seoul National University of Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["snut.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sogang.ac.kr/"],
    name: "Sogang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sogang.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sookmyung.ac.kr/"],
    name: "Sookmyung Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sookmyung.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.soongsil.ac.kr/"],
    name: "Soongsil University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["soongsil.ac.kr", "ssu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.stu.ac.kr/"],
    name: "Seoul Teological University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["stu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sunchon.ac.kr/"],
    name: "Sunchon National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sunchon.ac.kr", "scnu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sungkyul.ac.kr/"],
    name: "Sungkyul University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sungkyul.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sungshin.ac.kr/"],
    name: "Sungshin Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sungshin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sunmoon.ac.kr/"],
    name: "Sunmoon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sunmoon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.suwon.ac.kr/"],
    name: "Suwon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["suwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.suwoncatholic.ac.kr/"],
    name: "Suwon Catholic University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["suwoncatholic.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.swu.ac.kr/"],
    name: "Seoul Women's University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["swu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.syu.ac.kr/"],
    name: "Sahmyook University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["syu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.smu.ac.kr"],
    name: "Sangmyung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["smu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sehan.ac.kr/"],
    name: "Sehan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sehan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.scu.ac.kr/"],
    name: "Seoul Christian University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["scu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.hytu.ac.kr/"],
    name: "Seoul Hanyoung University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["hytu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sjs.ac.kr"],
    name: "Seoul Jangsin University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sjs.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.seoultech.ac.kr"],
    name: "Seoul National University of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["seoultech.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.sgu.ac.kr/"],
    name: "Shingyeong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["sgu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.shinhan.ac.kr/"],
    name: "Shinhan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["shinhan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.songwon.ac.kr/"],
    name: "Songwon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["songwon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.skhu.ac.kr"],
    name: "Sungkonghoe University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["skhu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.skku.edu/"],
    name: "Sungkyunkwan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["skku.edu"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.taegu.ac.kr/"],
    name: "Taegu University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["taegu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.taegu-e.ac.kr/"],
    name: "Taegu National University of Education",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["taegu-e.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.taejon.ac.kr/"],
    name: "Taejon University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["taejon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.taeshin.ac.kr/"],
    name: "Taeshin Christian University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["taeshin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.tit.ac.kr/"],
    name: "Tongmyung University of Information Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["tit.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.tnut.ac.kr/"],
    name: "Taejon National University of Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["tnut.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ulsan.ac.kr/"],
    name: "Ulsan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ulsan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.uos.ac.kr/"],
    name: "Seoul City University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["uos.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ust.ac.kr/"],
    name: "University of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["ust.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.u1.ac.kr/"],
    name: "U1 University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["u1.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.uu.ac.kr/"],
    name: "Uiduk University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["uu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.unist.ac.kr"],
    name: "Ulsan National Institute of Science and Technology",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["unist.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.wsu.ac.kr/"],
    name: "Woosong University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["wsu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.wonkwang.ac.kr/"],
    name: "Wonkwang University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["wonkwang.ac.kr", "wku.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.woosuk.ac.kr/"],
    name: "Woosuk University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["woosuk.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.yeungnam.ac.kr/"],
    name: "Yeungnam University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["yeungnam.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.yonsei.ac.kr/"],
    name: "Yonsei University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["yonsei.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.yosu.ac.kr/"],
    name: "Yosu National University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["yosu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.yewon.ac.kr/"],
    name: "Yewon Arts University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["www.yewon.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.yongin.ac.kr/"],
    name: "Yong In University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["www.yongin.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.ysu.ac.kr/"],
    name: "Youngsan University",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["www.ysu.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.youngsan.ac.kr"],
    name: "Youngsan University of Son Studies",
    alpha_two_code: "KR",
    "state-province": null,
    domains: ["www.youngsan.ac.kr"],
    country: "Korea, Republic of",
  },
  {
    web_pages: ["http://www.aukonline.org/"],
    name: "American University In Kosovo",
    alpha_two_code: "XK",
    "state-province": null,
    domains: ["aukonline.org"],
    country: "Kosovo",
  },
  {
    web_pages: ["http://www.uiliria.org/"],
    name: "ILIRIA College",
    alpha_two_code: "XK",
    "state-province": null,
    domains: ["uiliria.org"],
    country: "Kosovo",
  },
  {
    web_pages: ["http://www.uni-pr.edu/"],
    name: "University of Prishtina",
    alpha_two_code: "XK",
    "state-province": null,
    domains: ["uni-pr.edu"],
    country: "Kosovo",
  },
  {
    web_pages: ["http://www.uni-prizren.com/"],
    name: 'University of Prizren "Ukshin Hoti"',
    alpha_two_code: "XK",
    "state-province": null,
    domains: ["uni-prizren.com"],
    country: "Kosovo",
  },
  {
    web_pages: ["http://www.universum-ks.org/"],
    name: "Universum College",
    alpha_two_code: "XK",
    "state-province": null,
    domains: ["universum-ks.org"],
    country: "Kosovo",
  },
  {
    web_pages: ["http://www.ackonline.com/"],
    name: "Australlian College of Kuwait",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["ackonline.com"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.aou.edu.kw/"],
    name: "Arab Open University, Kuwait Branch",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["aou.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.auk.edu.kw/"],
    name: "American University of Kuwait",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["auk.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.aum.edu.kw/"],
    name: "American University of Middle East",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["aum.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.gust.edu.kw/"],
    name: "Gulf University for Science and Technology",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["gust.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.kilaw.edu.kw/"],
    name: "Kuwait International Law School",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["kilaw.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.kmbs.edu.kw/"],
    name: "Kuwait Maastricht Business School",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["kmbs.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.kuniv.edu.kw/"],
    name: "Kuwait University",
    alpha_two_code: "KW",
    "state-province": null,
    domains: ["kuniv.edu.kw"],
    country: "Kuwait",
  },
  {
    web_pages: ["http://www.asmi.edu.kg/"],
    name: "Asian Medical Institute",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["asmi.edu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.auca.kg/"],
    name: "American University of Central Asia",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["auca.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.bhu.kg/"],
    name: "Bishkek Humanities University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["bhu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.iaau.edu.kg/"],
    name: "International Ataturk Alatoo University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["iaau.edu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.iuk.kg/"],
    name: "International University of Kyrgyzstan",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["iuk.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.jasu.edu.kg/"],
    name: "Jalalabad State University Kyrgyzstan",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["jasu.edu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.knau.kg/"],
    name: "Kyrgyz National Agrarian University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["knau.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.krsu.edu.kg/"],
    name: "Kyrgyz Russian Slavic University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["krsu.edu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.kstu.kg/"],
    name: "Kyrgyz State Technical University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["kstu.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.ksucta.kg/"],
    name: "Kyrgyz State University of Construction, Transportation and Architecture",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["ksucta.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.manas.kg/"],
    name: "Kyrgyz Turkish  Manas University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["manas.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.oshmed.com/"],
    name: "Medical Faculty, Osh State University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["oshmed.com"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["http://www.university.kg/"],
    name: "Kyrgyz National University",
    alpha_two_code: "KG",
    "state-province": null,
    domains: ["university.kg"],
    country: "Kyrgyzstan",
  },
  {
    web_pages: ["https://www.nuol.edu.la/"],
    name: "National University of Laos",
    alpha_two_code: "LA",
    "state-province": "Vientiane",
    domains: ["nuol.edu.la"],
    country: "Lao People's Democratic Republic",
  },
  {
    web_pages: ["https://www.scmt.edu.la/"],
    name: "Soutsaka Institute of Technology",
    alpha_two_code: "LA",
    "state-province": "Vientiane",
    domains: ["simt.edu.la"],
    country: "Lao People's Democratic Republic",
  },
  {
    web_pages: ["http://www.aml.lv/"],
    name: "Medical Academy of Latvia",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["aml.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.ba.lv/"],
    name: "School of Business and Finance",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["ba.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.bsa.edu.lv/"],
    name: "Baltic International Academy",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["bsa.edu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.cs.lpu.lv/"],
    name: "Liepaja Pedagogical Higher School",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["cs.lpu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.dau.lv/"],
    name: "Daugavpils University",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["dau.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.lama.lv/"],
    name: "Latvian Maritime Academy",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lama.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.lka.edu.lv/"],
    name: "Latvian Academy of Culture",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lka.edu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.llu.lv/"],
    name: "Latvian University of Agriculture",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["llu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.lma.lv/"],
    name: "Latvian Academy of Arts",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lma.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.lmuza.lv/academy/"],
    name: "Latvian Academy of Music",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lmuza.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://lspa.lanet.lv/"],
    name: "Latvian Academy of Sports Education",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lspa.lanet.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.lu.lv/"],
    name: "University of Latvia",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["lu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.mil.lv/"],
    name: "National Defence Academy of Latvia",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["mil.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.polak.edu.lv/"],
    name: "Police Academy of Latvia",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["polak.edu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.psy.lv/"],
    name: "Higher School of Psychology",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["psy.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.rau.lv/"],
    name: "Riga Aviation University",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["rau.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.rpiva.lv/"],
    name: "Riga Teacher Training and Educational Management Academy",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["rpiva.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.rtu.lv/"],
    name: "Riga Technical University",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["rtu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.ru.lv/"],
    name: "Rezekne Higher School",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["ru.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.sseriga.edu.lv/"],
    name: "Stockholm School of Economics in Riga",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["sseriga.edu.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.tsi.lv/"],
    name: "Transport and Telecommunication Institute",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["tsi.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.va.lv/"],
    name: "Vidzeme University College",
    alpha_two_code: "LV",
    "state-province": null,
    domains: ["va.lv"],
    country: "Latvia",
  },
  {
    web_pages: ["http://www.arabou-lb.edu.lb/"],
    name: "Arab Open University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["arabou-lb.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.aub.edu.lb/"],
    name: "American University of Beirut",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["aub.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.aul.edu.lb/"],
    name: "Arts, Sciences and Technology University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["aul.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.aust.edu.lb/"],
    name: "American University of Science and Technology",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["aust.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.aut.edu/"],
    name: "American University College of Technology",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["aut.edu"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.balamand.edu.lb/"],
    name: "Balamand University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["balamand.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.bau.edu.lb/"],
    name: "Beirut Arab University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["bau.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.cut.edu.lb/"],
    name: "Centre Universitaire de Technologie",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["cut.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.gu.edu.lb/"],
    name: "Global University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["gu.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.haigazian.edu.lb/"],
    name: "Haigazian University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["haigazian.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.hariricanadian.edu.lb/"],
    name: "Hariri Canadian University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["hariricanadian.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.hu.edu.lb/"],
    name: "Business & Computer University College",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["hu.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.islahonline.org/"],
    name: "Al-Islah University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["islahonline.org"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.jinan.edu.lb/"],
    name: "Jinan University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["jinan.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.lau.edu.lb/"],
    name: "Lebanese American University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["lau.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.liu.edu.lb/"],
    name: "Lebanese International University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["liu.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.matnu.edu.lb/"],
    name: "Matn University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["matnu.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.mut.edu.lb/"],
    name: "Al-Manar University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["mut.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.ndu.edu.lb/"],
    name: "Notre Dame University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["ndu.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.theonest.edu.lb/"],
    name: "Near East School of Theology",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["theonest.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.ul.edu.lb/"],
    name: "Lebanese University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["ul.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.usek.edu.lb/"],
    name: "Holy Spirit University of Kaslik",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["usek.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.usj.edu.lb/"],
    name: "St. Joseph University Beirut",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["usj.edu.lb"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.wakf.org/"],
    name: "Al Imam Al-Ouzai University",
    alpha_two_code: "LB",
    "state-province": null,
    domains: ["wakf.org"],
    country: "Lebanon",
  },
  {
    web_pages: ["http://www.nul.ls/"],
    name: "National University of Lesotho",
    alpha_two_code: "LS",
    "state-province": null,
    domains: ["nul.ls"],
    country: "Lesotho",
  },
  {
    web_pages: ["http://www.universityliberia.org/"],
    name: "University of Liberia",
    alpha_two_code: "LR",
    "state-province": null,
    domains: ["universityliberia.org"],
    country: "Liberia",
  },
  {
    web_pages: ["http://www.asmarya.edu.ly/"],
    name: "Al-Asmarya University for Islamic Studies",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["asmarya.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.elmergib.edu.ly/"],
    name: "Elmergib University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["elmergib.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.jgu.edu.ly/"],
    name: "Al-Jabal Al-Gharbi University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["jgu.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.libopenuniv-edu.org/"],
    name: "Libya Open University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["libopenuniv-edu.org"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.limu.edu.ly/"],
    name: "Libyan International Medical University (LIMU)",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["limu.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.omu.edu.ly/"],
    name: "Omar Al-Mukhtar University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["omu.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.sebhau.edu.ly/"],
    name: "Sebha University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["sebhau.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.su.edu.ly/"],
    name: "Sirte University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["su.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.uob.edu.ly/"],
    name: "University of Benghazi",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["uob.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.uot.edu.ly/"],
    name: "University of Tripoli",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["uot.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.zu.edu.ly/"],
    name: "Zawiya University",
    alpha_two_code: "LY",
    "state-province": null,
    domains: ["zu.edu.ly"],
    country: "Libya",
  },
  {
    web_pages: ["http://www.iap.li/"],
    name: "Internationle Akademie für Philosophie",
    alpha_two_code: "LI",
    "state-province": null,
    domains: ["iap.li"],
    country: "Liechtenstein",
  },
  {
    web_pages: ["http://www.uni.li/"],
    name: "Universität Liechtenstein",
    alpha_two_code: "LI",
    "state-province": null,
    domains: ["uni.li"],
    country: "Liechtenstein",
  },
  {
    web_pages: ["http://info.kma.lt/"],
    name: "Kaunas Medical Academy",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["info.kma.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.ism.lt/"],
    name: "International School of Management",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["ism.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.ktu.lt/"],
    name: "Kaunas University of Technology",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["ktu.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.ku.lt/"],
    name: "Klaipeda University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["ku.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lcc.lt/"],
    name: "Lithuania Christian College",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lcc.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lka.lt/"],
    name: "Military academy of Lithuania",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lka.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lkka.lt/"],
    name: "Lithunian Institute of Physical Education",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lkka.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lmta.lt/"],
    name: "Lithunian Academy of Music and Theatre",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lmta.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lva.lt/"],
    name: "Lithunian Veterinary Academy",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lva.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.lzua.lt/"],
    name: "Lithunian University of Agriculture",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["lzua.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.mch.mii.lt/more/vda/"],
    name: "Vilnius Academy of Arts",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["mch.mii.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.mruni.eu/"],
    name: "Mykolo Romerio university",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["mruni.eu"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.su.lt/"],
    name: "Siauliai University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["su.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.vdu.lt/"],
    name: "Vytautas Magnus University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["vdu.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.vgtu.lt/"],
    name: "Vilnius Gediminas Technical University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["vgtu.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.vpu.lt/"],
    name: "Vilnius Pedagogical University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["vpu.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.vu.lt/"],
    name: "Vilnius University",
    alpha_two_code: "LT",
    "state-province": null,
    domains: ["vu.lt"],
    country: "Lithuania",
  },
  {
    web_pages: ["http://www.iuil.lu/"],
    name: "International University Institute of Luxembourg",
    alpha_two_code: "LU",
    "state-province": null,
    domains: ["iuil.lu"],
    country: "Luxembourg",
  },
  {
    web_pages: ["http://www.uni.lu/"],
    name: "University of Luxemburg",
    alpha_two_code: "LU",
    "state-province": null,
    domains: ["uni.lu"],
    country: "Luxembourg",
  },
  {
    web_pages: ["http://www.ipm.edu.mo/"],
    name: "Macau Polytechnic Institute",
    alpha_two_code: "MO",
    "state-province": null,
    domains: ["ipm.edu.mo"],
    country: "Macao",
  },
  {
    web_pages: ["http://www.umac.mo/"],
    name: "University of Macau",
    alpha_two_code: "MO",
    "state-province": null,
    domains: ["umac.mo"],
    country: "Macao",
  },
  {
    web_pages: ["http://www.usj.edu.mo/"],
    name: "University of Saint Joseph",
    alpha_two_code: "MO",
    "state-province": null,
    domains: ["usj.edu.mo"],
    country: "Macao",
  },
  {
    web_pages: ["http://www.fon.edu.mk/"],
    name: "FON University",
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["fon.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.seeu.edu.mk/"],
    name: "South East European University",
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["seeu.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.ugd.edu.mk/"],
    name: "University Goce Delcev",
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["ugd.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.uist.edu.mk/"],
    name: 'University for Information Science and Technology  "St. Paul The Apostle"',
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["uist.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.ukim.edu.mk/"],
    name: "St.Cyril and Methodius University",
    alpha_two_code: "MK",
    "state-province": null,
    domains: [
      "ukim.edu.mk",
      "ukim.mk",
      "finki.ukim.mk",
      "students.finki.ukim.mk",
    ],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.uklo.edu.mk/"],
    name: "St.Kliment Ohridski University",
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["uklo.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.unite.edu.mk/"],
    name: "State University of Tetova",
    alpha_two_code: "MK",
    "state-province": null,
    domains: ["unite.edu.mk"],
    country: "North Macedonia",
  },
  {
    web_pages: ["http://www.univ-antananarivo.mg/"],
    name: "Université d'Antananarivo",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-antananarivo.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.univ-antsiranana.mg/"],
    name: "Université d'Antsiranana",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-antsiranana.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.univ-fianar.mg/"],
    name: "Université de Fianarantsoa",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-fianar.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.univ-mahajanga.mg/"],
    name: "Université de Mahajanga",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-mahajanga.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.univ-toamasina.mg/"],
    name: "Université de Toamasina",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-toamasina.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.univ-toliara.mg/"],
    name: "Université de Toliary",
    alpha_two_code: "MG",
    "state-province": null,
    domains: ["univ-toliara.mg"],
    country: "Madagascar",
  },
  {
    web_pages: ["http://www.cunima.net/"],
    name: "Catholic University of Malawi",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["cunima.net"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.mzuni.ac.mw/"],
    name: "Mzuzu University",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["mzuni.ac.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.ulivingstonia.com/"],
    name: "University of Livingstonia",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["ulivingstonia.com"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.unima.ac.mw/"],
    name: "University of Malawi",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["unima.ac.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.mubas.ac.mw/"],
    name: "Malawi University of Business and Applied Sciences",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["mubas.ac.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.must.ac.mw/"],
    name: "Malawi University of Science and Technology",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["must.ac.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.luanar.ac.mw/"],
    name: "Lilongwe University of Agriculture and Natural Resources",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["luanar.ac.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.unima.mw/"],
    name: "University of Malawi | Old",
    alpha_two_code: "MW",
    "state-province": null,
    domains: ["unima.mw"],
    country: "Malawi",
  },
  {
    web_pages: ["http://www.acms.edu.my/"],
    name: "Allianze College of Medical Sciences (ACMS)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["acms.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.aeu.edu.my/"],
    name: "Asia E University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["aeu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.aimst.edu.my/"],
    name: "Aimst University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["aimst.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.aiu.edu.my/"],
    name: "Al-Bukhari International University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["aiu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.apiit.edu.my/"],
    name: "Asia Pacific Institute of Information Technology (APIIT)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["apiit.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.atc2u.com/"],
    name: "Advance Tertiary College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["atc2u.com"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.bac.edu.my/"],
    name: "Brickfields Asia College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["bac.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.binary.edu.my/"],
    name: "Binary University College of Managemant & Entrepreneurship",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["binary.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.bmi.edu.my/"],
    name: "British Malaysian Institute",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["bmi.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.city.edu.my/"],
    name: "City University College of Science and Technology",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["city.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.curtin.edu.my/"],
    name: "Curtin University of Technology, Sarawak Campus",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["curtin.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.cybermed.edu.my/"],
    name: "Cyberjaya University College of Medical Science",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["cybermed.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ftmsglobal.com/"],
    name: "FTMS Global Academy",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ftmsglobal.com"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.help.edu.my/"],
    name: "Help University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["help.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.hikmah.edu.my/"],
    name: "Darul Hikmah Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["hikmah.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.i4p.edu.my/"],
    name: "Institute of Teachers Education, Penang",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["i4p.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iact.edu.my/"],
    name: "Iact College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iact.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iic.edu.my/"],
    name: "International Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iic.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iiu.edu.my/"],
    name: "International Islamic University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iiu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.imu.edu.my/"],
    name: "International Medical University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["imu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.instedt.edu.my/"],
    name: "Darul Takzim Institute of Technology",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["instedt.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipb.edu.my/"],
    name: "Baitulmal Management Institute (IPB)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipbl.edu.my/"],
    name: "Institute of Teachers Education, Batu Lintang",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipbl.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipbmm.edu.my/"],
    name: "Institute of Teachers Education, Malay Language",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipbmm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipda.edu.my/"],
    name: "Institute of Teachers Education, Darul Aman",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipda.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgkkb.edu.my/"],
    name: "Institute of Teachers Education, Kota Bharu",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgkkb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgkrajang.edu.my/"],
    name: "Institute of Teachers Education, Rajang",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgkrajang.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgkti.edu.my/"],
    name: "Institute of Teachers Education, Temenggong Ibrahim",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgkti.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgmkdri.edu.my/"],
    name: "Institute of Teachers Education, Dato' Razali Ismail",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgmkdri.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgmksm.edu.my/"],
    name: "Institute of Teachers Education, Sultan Mizan",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgmksm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgmtawau.edu.my/"],
    name: "Institute of Teachers Education, Tawau",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgmtawau.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipgperlis.edu.my/"],
    name: "Institute of Teachers Education, Perlis",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipgperlis.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipik.edu.my/"],
    name: "Institute of Teachers Education, Ilmu Khas",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipik.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipip.edu.my/"],
    name: "Institute of Teachers Education, Ipoh",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipip.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipislam.edu.my/"],
    name: "Institute of Teachers Education, Islamic Education",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipislam.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipkent.edu.my/"],
    name: "Institute of Teachers Education, Kent",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipkent.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipks.edu.my/"],
    name: "Institute of Teachers Education, Keningau",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipks.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ippm.edu.my/"],
    name: "Institute of Teachers Education, Melaka",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ippm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iprm.edu.my/"],
    name: "Institute of Teachers Education, Raja Melewar",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iprm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipsah.edu.my/"],
    name: "Institute of Teachers Education, Sultan Abdul Halim",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipsah.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipsmiri.edu.my/"],
    name: "Institute of Teachers Education, Sarawak",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipsmiri.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iptaa.edu.my/"],
    name: "Institute of Teachers Education, Tengku Ampuan Afzan",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iptaa.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iptb.edu.my/"],
    name: "Institute of Teachers Education, Tuanku Bainun",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iptb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ipteknik.edu.my/"],
    name: "Institute of Teachers Education, Technical Education",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ipteknik.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iptho.edu.my/"],
    name: "Institute of Teachers Education, Tun Hussein Onn",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iptho.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iptips.edu.my/"],
    name: "Perlis Islamic Higher Learning Institute",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iptips.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iucn.edu.my/"],
    name: "International University College of Nursing (IUCN)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iucn.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.iuctt.edu.my/"],
    name: "International University College of Technology Twintech (IUCTT)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["iuctt.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kbu.edu.my/"],
    name: "KBU International College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kbu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kdu.edu.my/"],
    name: "KDU College Sdn Bhd",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kdu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kias.edu.my/"],
    name: "Sultan Ismail Petra International Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kias.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://kidu-darululum.blogspot.com/"],
    name: "Darul Ulum Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kidu-darululum.blogspot.com"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kiperak.edu.my/"],
    name: "Perak Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kiperak.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kipsas.edu.my/"],
    name: "Sultan Ahmad Shah Islamic College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kipsas.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kist.edu.my/"],
    name: "Islamic College for Sciences and Technologies",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kist.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kitab.edu.my/"],
    name: "International Islamic College of Penang",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kitab.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kliuc.edu.my/"],
    name: "Kuala Lumpur Infrastructure University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kliuc.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.klmu.edu.my/"],
    name: "Kuala Lumpur Metropolitan University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["klmu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kolejshahputra.edu.my/"],
    name: "Shahputra College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kolejshahputra.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kolejypc.edu.my/"],
    name: "YPC-iTWEB College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kolejypc.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kptm.edu.my/"],
    name: "Mara Poly-Tech College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kptm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ktd.edu.my/"],
    name: "Darul Naim College of Technology",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ktd.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://kudqi.net.my/"],
    name: "Darul Quran Islamic College University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kudqi.net.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kuim.edu.my/"],
    name: "Melaka Islamic University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kuim.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kuin.edu.my/"],
    name: "Kolej Universiti Insaniah",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kuin.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.kuis.edu.my/"],
    name: "Selangor Islamic University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["kuis.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.limkokwing.edu.my/"],
    name: "Limkokwing University College of Creative Technology",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["limkokwing.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.linton.edu.my/"],
    name: "Linton University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["linton.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.mahsa.edu.my/"],
    name: "Mahsa University College for Health and Medical Science",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["mahsa.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.mediu.edu.my/"],
    name: "Al Madinah International University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["mediu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://miit.unikl.edu.my/"],
    name: "Universiti Kuala Lumpur Malaysian Institute of Information Technology (MIIT)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["miit.unikl.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.mmu.edu.my/"],
    name: "Multimedia University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["mmu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.monash.edu.my/"],
    name: "Monash University, Malaysia Campus",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["monash.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.msu.edu.my/"],
    name: "Management and Science University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["msu.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.murni.edu.my/"],
    name: "Murni Nursing College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["murni.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.must.edu.my/"],
    name: "Malaysia University of Science and Technology (MUST)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["must.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.nilai.edu.my/"],
    name: "Nilai University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["nilai.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.nottingham.edu.my/"],
    name: "University of Nottingham, Malaysia Campus",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["nottingham.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://numed.ncl.ac.uk/"],
    name: "Newcastle University, Medicine Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["numed.ncl.ac.uk"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.olympia.edu.my/"],
    name: "Olympia College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["olympia.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.oum.edu.my/"],
    name: "Open University Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["oum.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.perdanauniversity.edu.my/"],
    name: "Perdana University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["perdanauniversity.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pidc.edu.my/"],
    name: "Penang International Dental College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pidc.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pine.edu.my/"],
    name: "Institut Prima Bestari - Pine Academy",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pine.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.piup.edu.my/"],
    name: "Primier International University Perak",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["piup.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pkb.edu.my/"],
    name: "Kota Bharu Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pkb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pkksabah.edu.my/"],
    name: "Kota Kinabalu Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pkksabah.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pkkt.edu.my/"],
    name: "Kuala Terengganu City Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pkkt.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.pmm.edu.my/"],
    name: "Merlimau Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["pmm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polijb.edu.my/"],
    name: "Johore Bharu Primeir Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polijb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.poliku.edu.my/"],
    name: "Kuching Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["poliku.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polimas.edu.my/"],
    name: "Sultan Abdul Halim Muadzam Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polimas.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polimelaka.edu.my/"],
    name: "Melaka City Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polimelaka.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polimuadzam.edu.my/"],
    name: "Muadzam Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polimuadzam.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polipd.edu.my/"],
    name: "Port Dickson Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polipd.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.polisas.edu.my/"],
    name: "Sultan Haji Ahmad Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["polisas.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.psa.edu.my/"],
    name: "Sultan Salahuddin Abdul Aziz Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["psa.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.psas.edu.my/"],
    name: "Sultan Azlan Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["psas.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.psis.edu.my/"],
    name: "Sultan Idris Shah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["psis.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.psmza.edu.my/"],
    name: "Sultan Mizan Zainal Abidin Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["psmza.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.psp.edu.my/"],
    name: "Seberang Perai Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["psp.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ptpl.edu.my/"],
    name: "PTPL College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ptpl.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ptsb.edu.my/"],
    name: "Sultanah Bahiyah Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ptsb.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ptss.edu.my/"],
    name: "Tunku Syed Sirajuddin Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ptss.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.puo.edu.my/"],
    name: "Ungku Omar Premier Polytechnic",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["puo.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.raffles-university.edu.my/"],
    name: "Raffles University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["raffles-university.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.saito.edu.my/"],
    name: "Saito College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["saito.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.segi.edu.my/"],
    name: "Segi University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["segi.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.sunway.edu.my/"],
    name: "Sunway University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["sunway.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.swinburne.edu.my/"],
    name: "Swinburne University of Technology, Sarawak Campus",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["swinburne.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.taj.edu.my/"],
    name: "Taj International College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["taj.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.tarc.edu.my/"],
    name: "Tunku Abdul Rahman Chinese College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["tarc.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.taylors.edu.my/"],
    name: "Taylor's University College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["taylors.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.tpmcollege.edu.my/"],
    name: "TPM College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["tpmcollege.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ucsi.edu.my/"],
    name: "UCSI University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ucsi.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ucti.edu.my/"],
    name: "University College of Technology & Innovation (UCTI)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ucti.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.udm.edu.my/"],
    name: "Universiti Darul Iman",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["udm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.uitm.edu.my/"],
    name: "Universiti Teknologi Mara",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["uitm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ukm.my/"],
    name: "Universiti Kebangsaan Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ukm.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.um.edu.my/"],
    name: "Universiti Malaya",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["um.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.umk.edu.my/"],
    name: "Universiti Malaysia Kelantan",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["umk.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ump.edu.my/"],
    name: "University Malaysia Pahang",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ump.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.ums.edu.my/"],
    name: "Universiti Malaysia Sabah",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["ums.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.umtech.edu.my/"],
    name: "University of Management and Technology",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["umtech.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.umt.edu.my/"],
    name: "Universiti Malaysia Terengganu",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["umt.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unikl.edu.my/"],
    name: "Universiti Kuala Lumpur",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unikl.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unimap.edu.my/"],
    name: "Universiti Malaysia Perlis",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unimap.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unimas.my/"],
    name: "Universiti Malaysia Sarawak",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unimas.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unirazak.edu.my/"],
    name: "University Tun Abdul Razak",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unirazak.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unisel.edu.my/"],
    name: "Universiti Industri Selangor",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unisel.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unisza.edu.my/"],
    name: "Universiti Sultan Zainal Abidin",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unisza.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.unitar.edu.my/"],
    name: "Universiti Tun Abdul Razak",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["unitar.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.uniten.edu.my/"],
    name: "Universiti Tenaga Nasional",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["uniten.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.upm.edu.my/"],
    name: "Universiti Putra Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["upm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.upsi.edu.my/"],
    name: "Universiti Pendidikan Sultan Idris",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["upsi.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.usm.my/"],
    name: "Universiti Sains Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["usm.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utar.edu.my/"],
    name: "Tunku Abdul Rahman University (Chinese University)",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utar.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utar.edu.my/"],
    name: "Universiti Tunku Abdul Rahman",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utar.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utem.edu.my/"],
    name: "Universiti Teknikal Malaysia Melaka",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utem.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.uthm.edu.my/"],
    name: "Universiti Tun Hussein Onn Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["uthm.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utm.my/"],
    name: "Universiti Teknologi Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utm.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utp.edu.my/"],
    name: "Petronas Technology University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utp.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.utp.edu.my/"],
    name: "Universiti Teknologi Petronas",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["utp.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.uum.edu.my/"],
    name: "Universiti Utara Malaysia",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["uum.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.westminster.edu.my/"],
    name: "West Minster International College",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["westminster.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.wou.edu.my/"],
    name: "Wawasan Open University",
    alpha_two_code: "MY",
    "state-province": null,
    domains: ["wou.edu.my"],
    country: "Malaysia",
  },
  {
    web_pages: ["http://www.cyryxcollege.edu.mv/"],
    name: "Cyryx College",
    alpha_two_code: "MV",
    "state-province": null,
    domains: ["cyryxcollege.edu.mv"],
    country: "Maldives",
  },
  {
    web_pages: ["http://www.mandhu.com/edu/"],
    name: "Mandhu College",
    alpha_two_code: "MV",
    "state-province": null,
    domains: ["mandhu.com"],
    country: "Maldives",
  },
  {
    web_pages: ["http://www.mnu.edu.mv/"],
    name: "Maldives National University",
    alpha_two_code: "MV",
    "state-province": null,
    domains: ["mnu.edu.mv"],
    country: "Maldives",
  },
  {
    web_pages: ["http://www.ml.refer.org/u-bamako/"],
    name: "Université de Bamako",
    alpha_two_code: "ML",
    "state-province": null,
    domains: ["ml.refer.org"],
    country: "Mali",
  },
  {
    web_pages: ["http://www.eieonline.com/"],
    name: "European Institute of Education",
    alpha_two_code: "MT",
    "state-province": null,
    domains: ["eieonline.com"],
    country: "Malta",
  },
  {
    web_pages: ["http://www.itismalta.com/"],
    name: "International Tourism Institute",
    alpha_two_code: "MT",
    "state-province": null,
    domains: ["itismalta.com"],
    country: "Malta",
  },
  {
    web_pages: ["http://www.um.edu.mt/"],
    name: "University of Malta",
    alpha_two_code: "MT",
    "state-province": null,
    domains: ["um.edu.mt"],
    country: "Malta",
  },
  {
    web_pages: ["http://www.univ-ag.fr/"],
    name: "Université des Antilles et de la Guyane",
    alpha_two_code: "MQ",
    "state-province": null,
    domains: ["univ-ag.fr"],
    country: "Martinique",
  },
  {
    web_pages: ["http://www.univ-nkc.mr/"],
    name: "Université de Nouakchott",
    alpha_two_code: "MR",
    "state-province": null,
    domains: ["univ-nkc.mr"],
    country: "Mauritania",
  },
  {
    web_pages: ["http://www.uom.ac.mu/"],
    name: "University of Mauritius",
    alpha_two_code: "MU",
    "state-province": null,
    domains: ["uom.ac.mu"],
    country: "Mauritius",
  },
  {
    web_pages: ["http://www.utm.ac.mu/"],
    name: "University of Technology",
    alpha_two_code: "MU",
    "state-province": null,
    domains: ["utm.ac.mu"],
    country: "Mauritius",
  },
  {
    web_pages: ["http://www.anahuac.mx/"],
    name: "Universidad Anáhuac",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["anahuac.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://bajio.delasalle.edu.mx/"],
    name: "Universidad de La Salle, Bajío",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["bajio.delasalle.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.buap.mx/"],
    name: "Benemerita Universidad Autónoma de Puebla",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["buap.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.campusleon.ugto.mx/"],
    name: "Universidad de Guanajuato, Campus León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["campusleon.ugto.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ceti.mx/"],
    name: "Centro de Enseñanza Técnica Industrial",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ceti.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.cetys.mx/"],
    name: "CETYS Universidad",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["cetys.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ceu.edu.mx/"],
    name: "Centro de Estudios Universitarios Monterrey",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ceu.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ceunix.com.mx/"],
    name: "Centro Universitario Ixtlahuaca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ceunix.com.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ceux.mx/"],
    name: "Centro de Estudios Universitarios Xochicalco",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ceux.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.champagnat.edu.mx/"],
    name: "Universidad Champagnat",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["champagnat.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.chapingo.mx/"],
    name: "Universidad Autónoma de Chapingo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["chapingo.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.colmex.mx/"],
    name: "El Colegio de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["colmex.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.cuauhtemoc.edu.mx/"],
    name: "Universidad Cuauhtémoc",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["cuauhtemoc.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://cueyatl.uam.mx/"],
    name: "Universidad Autónoma Metropolitana - Xochimilco",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["cueyatl.uam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.dgit.gob.mx/"],
    name: "Dirección General de Institutos Tecnológicos",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["dgit.gob.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ebc.mx/"],
    name: "Escuela Bancaria y Comercial",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ebc.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.enes.unam.mx/"],
    name: "Escuela Nacional de Estudios Superiores Unidad León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["enes.unam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.frayluca.edu.mx/"],
    name: "Universidad Fray Luca Paccioli",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["frayluca.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://hispano.edu.mx/"],
    name: "Universidad Hispanoamericana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["hispano.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.i.edu.mx/"],
    name: "Universidad Itaca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["i.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ipn.edu.mx/"],
    name: "Instituto Politécnico Nacional",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ipn.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itam.mx/"],
    name: "Instituto Tecnológico Autonómo de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ita.mx/"],
    name: "Instituto Tecnológico de Aguascalientes",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ita.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itc.mx/"],
    name: "Instituto Tecnológico de Celaya",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itc.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itdurango.edu.mx/"],
    name: "Instituto Tecnologico de Durango",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itdurango.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itesm.mx/"],
    name: "Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM)",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itesm.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.iteso.mx/"],
    name: "Instituto Tecnológico y de Estudios Superiores de Occidente",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["iteso.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itleon.edu.mx/"],
    name: "Instituto Tecnológico de León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itleon.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itmina.edu.mx/"],
    name: "Instituto Tecnologico de Minatitlan",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itmina.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itmorelia.edu.mx/"],
    name: "Instituto Tecnológico de Morelia",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itmorelia.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itq.edu.mx/"],
    name: "Instituto Tecnológico de Querétaro",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itq.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itslp.edu.mx/"],
    name: "Instituto Tecnológico de San Luis Potosí",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itslp.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itson.mx/"],
    name: "Instituto Tecnológico de Sonora",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itson.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.iztapalapa.uam.mx/"],
    name: "Universidad Autónoma Metropolitana - Iztapalapa",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["iztapalapa.uam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.lef.upn.mx/"],
    name: "Universidad Pedagógica Nacional, Unidad León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["lef.upn.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.leon.uia.mx/"],
    name: "Universidad Iberoamericana, Campus León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["leon.uia.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://members.rotfl.com/uvp/"],
    name: "Universidad del Valle de Puebla",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["members.rotfl.com"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.motolinia.com.mx/"],
    name: "Universidad Motolinía del Pedregal",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["motolinia.com.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.olmeca.edu.mx/"],
    name: "Universidad Olmeca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["olmeca.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.poligto.edu.mx/"],
    name: "Politécnico de Guanajuato",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["poligto.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.reduaeh.mx/"],
    name: "Universidad Autónoma del Estado de Hidalgo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["reduaeh.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.reduaz.mx/"],
    name: "Universidad Autónoma de Zacatecas",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["reduaz.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.secupv.org/"],
    name: "Universidad Pedagógica Veracruzana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["secupv.org"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.tecbc.mx/"],
    name: "Tecnologico de Baja California, Universidad",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["tecbc.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.tepeyac.edu.mx/"],
    name: "Universidad del Tepeyac",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["tepeyac.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ties.com.mx/"],
    name: "Instituto de Estudios Superiores de la Sierra",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ties.com.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaaan.mx/"],
    name: 'Universidad Autónoma Agraria "Antonio Narro"',
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaaan.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaa.mx:8001/"],
    name: "Universidad Autónoma de Aguascalientes",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaa.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uabc.mx/"],
    name: "Universidad Autónoma de Baja California",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uabc.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uabcs.mx/"],
    name: "Universidad Autónoma de Baja California Sur",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uabcs.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uabjo.mx/"],
    name: 'Universidad Autónoma "Benito Juárez" de Oaxaca',
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uabjo.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uacam.mx/"],
    name: "Universidad Autónoma de Campeche",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uacam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uach.mx/"],
    name: "Universidad Autónoma de Chihuahua",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uach.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://itsncg.edu.mx/"],
    name: "Instituto Tecnológico Superior de Nuevo Casas Grandes",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itsncg.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uacj.mx/"],
    name: "Universidad Autónoma de Ciudad Juárez",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uacj.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uacm.edu.mx/"],
    name: "Universidad Autónoma de la Ciudad de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uacm.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uadec.mx/"],
    name: "Universidad Autónoma de Coahuila",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uadec.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uad.edu.mx/"],
    name: "Universidad Autonoma  de Durango",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uad.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uady.mx/"],
    name: "Universidad Autónoma de Yucatán",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uady.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaed.edu.mx/"],
    name: "Universidad Autonoma España de Durango",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaed.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaemex.mx/"],
    name: "Universidad Autónoma del Estado de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaemex.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaem.mx/"],
    name: "Universidad Autónoma del Estado de Morelos",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaem.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaf.mx/"],
    name: "Universidad Autónoma de Fresnillo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaf.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uag.mx/"],
    name: "Universidad Autónoma de Guadalajara",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uag.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uagro.mx/"],
    name: "Universidad Autónoma de Guerrero",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uagro.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ual.mx/"],
    name: "Universidad Autónoma de la Laguna",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ual.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uam.mx/"],
    name: "Universidad Autónoma Metropolitana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uane.edu.mx/"],
    name: "Universidad Autónoma del Noreste",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uane.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uanl.mx/"],
    name: "Universidad Autónoma de Nuevo León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uanl.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uan.mx/"],
    name: "Universidad Autónoma de Nayarit",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uan.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaq.mx/"],
    name: "Universidad Autónoma de Querétaro",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaq.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uaslp.mx/"],
    name: "Universidad Autónoma de San Luis Potosí",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uaslp.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uas.mx/"],
    name: "Universidad Anáhuac del Sur",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uas.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uasnet.mx/"],
    name: "Universidad Autónoma de Sinaloa",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uasnet.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uat.mx/"],
    name: "Universidad Autónoma de Tamaulipas",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uat.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uatx.mx/"],
    name: "Universidad Autónoma de Tlaxcala",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uatx.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ubac.edu.mx/"],
    name: "Universidad del Bajío",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ubac.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ucem.edu.mx/"],
    name: "Universidad del Centro de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ucem.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uclah.edu.mx/"],
    name: "Universidad Cientifica Latinoamericana de Hidalgo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uclah.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ucol.mx/"],
    name: "Universidad de Colima",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ucol.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udec.edu.mx/"],
    name: "Universidad de Celaya",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udec.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udeci.edu.mx/"],
    name: "Universidad de Cuautitlan Izcalli",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udeci.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udeh.edu.mx/"],
    name: "Universidad de Hermosillo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udeh.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udem.edu.mx/"],
    name: "Universidad de Monterrey",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udem.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udesanmiguel.edu.mx/"],
    name: "Universidad de San Miguel",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udesanmiguel.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udg.mx/"],
    name: "Universidad de Guadalajara",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udg.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udla.mx/"],
    name: "Universidad de las Américas",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udla.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udlap.mx/"],
    name: "Universidad de las Américas - Puebla",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udlap.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udo.mx/"],
    name: "Universidad de Occidente",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udo.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.udv.edu.mx/"],
    name: "Universidad Don Vasco",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["udv.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ufm.edu.mx/"],
    name: "Universidad Franciscana de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ufm.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ufram.edu.mx/"],
    name: "Universidad Franco-Mexicana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ufram.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ugto.mx/"],
    name: "Universidad de Guanajuato",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ugto.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uia.mx/"],
    name: "Universidad Iberoamericana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uia.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uic.edu.mx/"],
    name: "Universidad Intercontinental",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uic.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uileon.edu.mx/"],
    name: "Universidad Insurgentes Plantel León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uileon.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ujat.mx/"],
    name: "Universidad Juárez Autónoma de Tabasco",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ujat.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ujed.mx/"],
    name: "Universidad Juárez del Estado de Durango",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ujed.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ujsierra.mx/"],
    name: "Universidad Justo Sierra",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ujsierra.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ula.edu.mx/"],
    name: "Universidad Latinoamericana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ula.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ulsab.edu.mx/"],
    name: "Universidad Lasallista Benavente",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ulsab.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ulsac.edu.mx/"],
    name: "Universidad La Salle Cuernavaca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ulsac.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ulsa.edu.mx/"],
    name: "Universidad La Salle",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ulsa.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umad.edu.mx/"],
    name: "Universidad Madero",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umad.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uman.edu.mx/"],
    name: "Universidad México Americana del Norte",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uman.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umar.mx/"],
    name: "Universidad del Mar",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umar.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umich.mx/"],
    name: "Universidad Michoacana de San Nicolás de Hidalgo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umich.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umi.edu.mx/"],
    name: "Universidad México Internacional",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umi.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umla.edu.mx/"],
    name: "Universidad Metropolitana Latin Campus",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umla.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umm.edu.mx/"],
    name: "Universidad Metropolitana de Monterrey",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umm.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umne.edu.mx/"],
    name: "Universidad Mexicana del Noreste",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umne.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umontemorelos.edu.mx/"],
    name: "Universidad de Montemorelos",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umontemorelos.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.umsa.edu.mx/"],
    name: "Universidad Mesoamericana de San Agustín",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["umsa.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unacar.mx/"],
    name: "Universidad Autónoma del Carmen",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unacar.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unach.mx/"],
    name: "Universidad Autónoma de Chiapas",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unach.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unam.mx/"],
    name: "Universidad Nacional Autónoma de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.un.edu.mx/"],
    name: "Universidad del Norte",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["un.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.une.edu.mx/"],
    name: "Universidad del Noreste",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["une.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unes.edu.mx/"],
    name: "Universidad España de Durango",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unes.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unicach.edu.mx/"],
    name: "Universidad de Ciencias y Artes de Chiapas",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unicach.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unica.edu.mx/"],
    name: "Universidad de Comunicación Avanzada",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unica.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unikino.mx/"],
    name: "Universidad Kino",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unikino.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unimayab.edu.mx/"],
    name: "Universidad del Mayab",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unimayab.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unimex.edu.mx/"],
    name: "Universidad Mexicana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unimex.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unitec.mx/"],
    name: "Universidad Tecnológica de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unitec.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.univa.mx/"],
    name: "Universidad del Valle de Atemajac",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["univa.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.univas.edu.mx/"],
    name: "Universidad Jóse Vasconcelos",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["univas.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.univchapultepec.edu.mx/"],
    name: "Universidad Chapultepéc",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["univchapultepec.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.universidaddeleon.edu.mx/"],
    name: "Universidad de León",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["universidaddeleon.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.universidadlaconcordia.edu.mx/"],
    name: "Universidad la Concordia",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["universidadlaconcordia.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.universidadmotolinia.edu.mx/"],
    name: "Universidad Motolinía del Pedegral",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["universidadmotolinia.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.universidadsalesiana.edu.mx/"],
    name: "Universidad Salesiana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["universidadsalesiana.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.univillarica.mx/"],
    name: "Universidad Autónoma de Veracruz Villa Rica",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["univillarica.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unla.edu.mx/"],
    name: "Universidad Latina",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unla.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.un.mx/"],
    name: "Universidad de Norteamerica",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["un.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uno.mx/"],
    name: "Universidad del Noroeste",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uno.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.unum.edu.mx/"],
    name: "Universidad Nuevo Mundo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["unum.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uom.edu.mx/"],
    name: "Universidad Obrera de Mexico",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uom.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.upaep.mx/"],
    name: "Universidad Popular Autonóma del Estado de Puebla",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["upaep.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.upiig.ipn.mx/"],
    name: "Instituto Politécnico Nacional, Campus Guanajuato",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["upiig.ipn.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.up.mx/"],
    name: "Universidad Panamericana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["up.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.upn.mx/"],
    name: "Universidad Pedagógica Nacional",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["upn.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uqroo.mx/"],
    name: "Universidad de Quintana Roo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uqroo.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.urmh.edu.mx/"],
    name: "Universidad Regional Miguel Hidalgo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["urmh.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ur.mx/"],
    name: "Universidad Regiomontana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ur.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.urse.edu.mx/"],
    name: "Universidad Regional del Sureste",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["urse.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.usac.edu.mx/"],
    name: "Universidad de la Sierra A.C.",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["usac.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.usb.edu.mx/"],
    name: "Universidad Simón Bolivar",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["usb.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.usf.com.mx/"],
    name: "Universidad Santa Fe",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["usf.com.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uson.mx/"],
    name: "Universidad de Sonora",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uson.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.utm.mx/"],
    name: "Universidad Tecnologica de la Mixteca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["utm.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.utneza.edu.mx/"],
    name: "Universidad Tecnologica de Nezahualcoyotl",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["utneza.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uvb.edu.mx/"],
    name: "Universidad del Valle del Bravo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uvb.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uvg1.net/"],
    name: "Universidad Valle del Grijalva",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uvg1.net"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uvmnet.edu/"],
    name: "Universidad del Valle de México",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uvmnet.edu"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uv.mx/"],
    name: "Universidad Veracruzana",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uv.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uvt.edu.mx/"],
    name: "Universidad del Valle de Toluca",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uvt.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.uxac.edu.mx/"],
    name: "Universidad Xicotepetl",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["uxac.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ver.ucc.mx/"],
    name: "Universidad Cristóbal Colón",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["ver.ucc.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.westhill.edu.mx/"],
    name: "Westhill University",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["westhill.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["https://azc.uam.mx/"],
    name: "Universidad Autónoma Metropolitana - Azcapotzalco",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["azc.uam.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.itsoeh.edu.mx/"],
    name: "Instituto Tecnológico de Occidente del Estado de Hidalgo",
    alpha_two_code: "MX",
    "state-province": null,
    domains: ["itsoeh.edu.mx"],
    country: "Mexico",
  },
  {
    web_pages: ["http://www.ase.md/"],
    name: "Academy of Economic Studies of Moldova",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["ase.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.kdu.md/"],
    name: "Comrat State University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["kdu.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.uasm.md/"],
    name: "Moldova State Agricultural University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["uasm.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.uccm.md/"],
    name: "Moldova Cooperative Trade University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["uccm.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.ulim.md/"],
    name: "Free International University of Moldova",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["ulim.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://upm.moldnet.md/"],
    name: 'Pedagogical State University "Ion Creanga"',
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["upm.moldnet.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.usam.md/"],
    name: "University of Applied Sciences of Moldova",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["usam.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.usb.md/"],
    name: 'Balti State University "Alecu Russo"',
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["usb.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.usmf.md/"],
    name: 'Moldova State University of Medicine and Pharmacy "N. Testemitsanu"',
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["usmf.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.usm.md/"],
    name: "Moldova State University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["usm.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.ust.md/"],
    name: "Tiraspol State University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["ust.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.utm.md/"],
    name: "Moldova Technical University",
    alpha_two_code: "MD",
    "state-province": null,
    domains: ["utm.md"],
    country: "Moldova, Republic of",
  },
  {
    web_pages: ["http://www.riviera.fr/usehome.htm"],
    name: "University of Southern Europe (Monaco Business School)",
    alpha_two_code: "MC",
    "state-province": null,
    domains: ["riviera.fr"],
    country: "Monaco",
  },
  {
    web_pages: ["http://www.hsum-ac.mn/"],
    name: "Health sciences University of Mongolia",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["hsum-ac.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.humanities.mn/"],
    name: "University of the Humanities",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["humanities.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.icb.edu.mn/"],
    name: "Institute of Commerce and Business",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["icb.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.msuac.edu.mn/"],
    name: "Mongolian State University of Arts and Culture",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["msuac.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.msua.edu.mn/"],
    name: "Mongolian State University of Agriculture",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["msua.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.msue.edu.mn/"],
    name: "Mongolian State University of Education",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["msue.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.must.edu.mn/"],
    name: "Mongolian University of Science and Technology",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["must.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.num.edu.mn/"],
    name: "Mongolian National University",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["num.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.orkhon.edu.mn/"],
    name: "Orkhon University",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["orkhon.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.ulaanbaatar.edu.mn/"],
    name: "Ulaanbaatar University",
    alpha_two_code: "MN",
    "state-province": null,
    domains: ["ulaanbaatar.edu.mn"],
    country: "Mongolia",
  },
  {
    web_pages: ["http://www.ucg.cg.ac.yu/"],
    name: "University of Montenegro",
    alpha_two_code: "ME",
    "state-province": null,
    domains: ["ucg.cg.ac.yu"],
    country: "Montenegro",
  },
  {
    web_pages: ["http://www.usat.ms/"],
    name: "University of Science, Arts and Technology",
    alpha_two_code: "MS",
    "state-province": null,
    domains: ["usat.ms"],
    country: "Montserrat",
  },
  {
    web_pages: ["http://www.archi.ac.ma/"],
    name: "Ecole Nationale d'Architecture",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["archi.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.aui.ma/"],
    name: "Al Akhawayn University",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["aui.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.edhec.ac.ma/"],
    name: "Ecole des Hautes Etudes en Gestion Informatique et Communication",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["edhec.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.emi.ac.ma/"],
    name: "Ecole Mohammadia d'Ingénieurs",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["emi.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.enameknes.ac.ma/"],
    name: "Ecole National d'Agriculture de Meknes",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["enameknes.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.esca.ac.ma/"],
    name: "Ecole Supérieure de Commerce et des Affaires",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["esca.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.esta.ac.ma/"],
    name: "Université Ibn Zohr Agadir",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["esta.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.groupeiscae.ma/"],
    name: "Institut Supérieur de Commerce et d'Administration des Entreprises",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["groupeiscae.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.hec.ac.ma/"],
    name: "Ecole des Hautes Etudes Commerciales MAROC",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["hec.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.hem.ac.ma/"],
    name: "Institut des Hautes Etudes de Management",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["hem.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.hightech.edu/"],
    name: "Ecole Supérieure d'Informatique et de Management",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["hightech.edu"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.iihem.ac.ma/"],
    name: "International Institute for Higher Education",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["iihem.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.imbt.ma/"],
    name: "Institute of Management and Business Technology",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["imbt.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.inpt.ac.ma/"],
    name: "Institut National des Postes et Télécommunications",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["inpt.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.isfort.ac.ma/"],
    name: "ISFORT - Institut de Formation en Technologie Alimentaire",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["isfort.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.matci.ac.ma/"],
    name: "Institut Supérieur de Management et de Technologie (MATCI)",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["matci.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.rectorat-uh2c.ac.ma/"],
    name: "Université Hassan II - Aïn Chock",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["rectorat-uh2c.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.rumi.ac.ma/"],
    name: "Université Moulay Ismail Meknès",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["rumi.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.suptelecom.net.ma/"],
    name: "Ecole Superieure des Télécommunications",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["suptelecom.net.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.uae.ac.ma/"],
    name: "Université Abdelmalek Essadi",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["uae.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.ucam.ac.ma/"],
    name: "Université Cadi Ayyad",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["ucam.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.ucd.ac.ma/"],
    name: "Université Chouaib Doukkali",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["ucd.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.uh1.ac.ma/"],
    name: "Université Hassan Ier - Settat",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["uh1.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.uh2m.ac.ma/"],
    name: "Université Hassan II - Mohammadia",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["uh2m.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.um5a.ac.ma/"],
    name: "Université Mohammed V - Agdal",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["um5a.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.um5s.ac.ma/"],
    name: "Université Mohammed V - Souissi",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["um5s.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.univ-ibntofail.ac.ma/"],
    name: "Université Ibn Toufail",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["univ-ibntofail.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.univ-oujda.ac.ma/"],
    name: "Université Mohammed Ier",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["univ-oujda.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.usmba.ac.ma/"],
    name: "Université Sidi Mohammed Ben Abdellah",
    alpha_two_code: "MA",
    "state-province": null,
    domains: ["usmba.ac.ma"],
    country: "Morocco",
  },
  {
    web_pages: ["http://www.isctem.ac.mz/"],
    name: "Instituto Superior de Ciênicas e Tecnologia de Moçambique",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["isctem.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.ispu.ac.mz/"],
    name: "Instituto Superior Politécnico e Universitário",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["ispu.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.isri.ac.mz/"],
    name: "Instituto Superior de Relações Internacionais (ISRI)",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["isri.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.ucm.ac.mz/"],
    name: "Universidade Católica de Moçambique",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["ucm.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.uem.mz/"],
    name: "Universidade Eduardo Mondlane",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["uem.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["https://www.up.ac.mz/"],
    name: "Universidade Pedagógica",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["up.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.unizambeze.ac.mz/"],
    name: "Universidade Zambeze",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["unizambeze.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.unilurio.ac.mz/"],
    name: "Universidade Lúrio",
    alpha_two_code: "MZ",
    "state-province": null,
    domains: ["unilurio.ac.mz"],
    country: "Mozambique",
  },
  {
    web_pages: ["http://www.iit.com.na/"],
    name: "Institute of Information Technology",
    alpha_two_code: "NA",
    "state-province": null,
    domains: ["iit.com.na"],
    country: "Namibia",
  },
  {
    web_pages: ["http://www.ilsacollege.edu.na/"],
    name: "Ilsa Independent College",
    alpha_two_code: "NA",
    "state-province": null,
    domains: ["ilsacollege.edu.na"],
    country: "Namibia",
  },
  {
    web_pages: ["http://www.ium.edu.na/"],
    name: "International University of Management",
    alpha_two_code: "NA",
    "state-province": null,
    domains: ["ium.edu.na"],
    country: "Namibia",
  },
  {
    web_pages: ["http://www.polytechnic.edu.na/"],
    name: "Polytechnic of Namibia",
    alpha_two_code: "NA",
    "state-province": null,
    domains: ["polytechnic.edu.na"],
    country: "Namibia",
  },
  {
    web_pages: ["http://www.unam.na/"],
    name: "University of Namibia",
    alpha_two_code: "NA",
    "state-province": null,
    domains: ["unam.na"],
    country: "Namibia",
  },
  {
    web_pages: ["http://www.afu.edu.np/"],
    name: "Agriculture and Forestry University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["afu.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.bpkihs.edu/"],
    name: "B.P.Koirala Institute of Health Sciences",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["bpkihs.edu"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.ku.edu.np/"],
    name: "Kathmandu University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["ku.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.lbu.edu.np/"],
    name: "Lumbini Buddhist University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["lbu.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.nsu.edu.np/"],
    name: "Nepal Sanskrit University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["nsu.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.pu.edu.np/"],
    name: "Pokhara University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["pu.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.purbuniv.edu.np/"],
    name: "Purbanchal University",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["purbuniv.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.tribhuvan-university.edu.np/"],
    name: "Tribhuvan University Kathmandu",
    alpha_two_code: "NP",
    "state-province": null,
    domains: ["tribhuvan-university.edu.np"],
    country: "Nepal",
  },
  {
    web_pages: ["http://www.aucmed.edu/"],
    name: "American University of the Caribbean, Sint Maarten",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["aucmed.edu"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.eustatiusmed.edu/"],
    name: "University of Sint Eustatius School of Medicine",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["eustatiusmed.edu"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.internationaluniversity-schoolofmedicine.org/"],
    name: "International University School of Medicine (IUSOM)",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["internationaluniversity-schoolofmedicine.org"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.sjsm.org/"],
    name: "St.James's School of Medicine, Bonaire",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["sjsm.org"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.una.an/"],
    name: "University of the Netherlands Antilles, Curacao",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["una.an"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.ddu.nl/"],
    name: "Dutch Delta University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["ddu.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.dehaagsehogeschool.nl/"],
    name: "De Haagse Hogeschool",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["dehaagsehogeschool.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.eur.nl/"],
    name: "Erasmus University Rotterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["eur.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["https://www.rsm.nl/"],
    name: "Rotterdam School of Management",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["rsm.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.europeanopenuniversity.com/"],
    name: "European Open University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["europeanopenuniversity.com"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.fontys.edu/"],
    name: "Fontys University of Applied Sciences",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["fontys.edu"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.foundationuniversity.com/"],
    name: "Foundation University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["foundationuniversity.com"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hanze.nl/"],
    name: "Hanze University Groningen",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hanze.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hku.nl/"],
    name: "Hogeschool voor de Kunsten Utrecht (HKU)",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hku.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hotelschool.nl/"],
    name: "Hotelschool The Hague",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hotelschool.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hro.nl/"],
    name: "Hogeschool Rotterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hro.nl", "hr.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hsleiden.nl/"],
    name: "Hogeschool Leiden",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hsleiden.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hu.nl/"],
    name: "Hogeschool Utrecht",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hu.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.hva.nl/"],
    name: "Hogeschool van Amsterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["hva.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.inholland.nl/"],
    name: "Hogeschool Inholland",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["inholland.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.islamicuniversity.nl/"],
    name: "Islamic University of Rotterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["islamicuniversity.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.iss.nl/"],
    name: "Institute of Social Studies",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["iss.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.itc.nl/"],
    name: "International Institute for Geo - Information Science and Earth Observation",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["itc.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.leidenuniv.nl/"],
    name: "Leiden University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["leidenuniv.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.nhtv.nl"],
    name: "NHTV Breda University of Professional Education",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["nhtv.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.nyenrode.nl/"],
    name: "Nyenrode Business University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["nyenrode.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.ou.nl/"],
    name: "Open University of the Netherlands",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["ou.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.roac.nl/"],
    name: "Roosevelt Academy University College",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["roac.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.rug.nl/"],
    name: "University of Groningen",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["rug.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.ru.nl/"],
    name: "Radboud University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["ru.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://saxion.edu/"],
    name: "Saxion Universities",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["saxion.edu"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.stenden.com/"],
    name: "Stenden University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["stenden.com"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.tilburguniversity.nl/"],
    name: "Tilburg University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["tilburguniversity.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.tudelft.nl/"],
    name: "Delft University of Technology",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["tudelft.nl", "student.tudelft.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.tue.nl/"],
    name: "Eindhoven University of Technology",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["tue.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.unesco-ihe.org/"],
    name: "UNESCO-IHE Institute for Water Education",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["unesco-ihe.org"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.unimaas.nl/"],
    name: "Maastricht University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["unimaas.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.utwente.nl/"],
    name: "University of Twente",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["utwente.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.uu.nl/"],
    name: "Utrecht University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["uu.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.uva.nl/"],
    name: "University of Amsterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["uva.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.uvh.nl/"],
    name: "University for Humanistics (UH)",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["uvh.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.vu.nl/"],
    name: "Vrije Universiteit Amsterdam",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["vu.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.wageningenuniversity.nl/"],
    name: "Wageningen University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["wageningenuniversity.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.windesheim.nl/"],
    name: "Christelijke Hogeschool Windesheim",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["windesheim.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.wittenborg.eu/"],
    name: "Wittenborg University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["wittenborg.eu"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.zuyd.nl/"],
    name: "Zuyd University",
    alpha_two_code: "NL",
    "state-province": null,
    domains: ["zuyd.nl"],
    country: "Netherlands",
  },
  {
    web_pages: ["http://www.ufp.nc/"],
    name: "University of New Caledonia",
    alpha_two_code: "NC",
    "state-province": null,
    domains: ["ufp.nc"],
    country: "New Caledonia",
  },
  {
    web_pages: ["http://www.auckland.ac.nz/"],
    name: "University of Auckland",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["auckland.ac.nz", "aucklanduni.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.aut.ac.nz/"],
    name: "Auckland University of Technology",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["aut.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.canterbury.ac.nz/"],
    name: "University of Canterbury",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["canterbury.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.cpit.ac.nz/"],
    name: "Christchurch Polytechnic Institute of Technology",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["cpit.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.lincoln.ac.nz/"],
    name: "Lincoln University",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["lincoln.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.massey.ac.nz/"],
    name: "Massey University",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["massey.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.openpolytechnic.ac.nz/"],
    name: "Open Polytechnic",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["openpolytechnic.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.otago.ac.nz/"],
    name: "University of Otago",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["otago.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.vuw.ac.nz/"],
    name: "Victoria University of Wellington",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["vuw.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.waikato.ac.nz/"],
    name: "University of Waikato",
    alpha_two_code: "NZ",
    "state-province": null,
    domains: ["waikato.ac.nz"],
    country: "New Zealand",
  },
  {
    web_pages: ["http://www.uam.edu.ni/"],
    name: "Universidad Americana",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uam.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.uca.edu.ni/"],
    name: "Universidad Centroamericana",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uca.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.ucc.edu.ni/"],
    name: "Universidad Ciencias Comerciales",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["ucc.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.ucem.edu.ni/"],
    name: "Universidad Centroamericana de Ciencias Empresariales (UCEM)",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["ucem.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.ucyt.edu.ni/"],
    name: "Universidad Nicaragüense de Ciencia y Tecnológica",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["ucyt.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.udem.edu.ni/"],
    name: "Universidad de Managua (U de M)",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["udem.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.uhispam.edu.ni/"],
    name: "Universidad Hispanoamericana",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uhispam.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.ulam.edu.ni/"],
    name: "Universidad de las Américas (ULAM)",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["ulam.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.una.edu.ni/"],
    name: "Universidad Nacional Agraria",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["una.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.unan.edu.ni/"],
    name: "Universidad Nacional Autonoma de Nicaragua",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["unan.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.unica.edu.ni/"],
    name: 'Universidad Catolica "Redemptoris Mater"',
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["unica.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.unicit.edu.ni/"],
    name: "Universidad Iberoamericana de Ciencia y Tecnologia",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["unicit.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.uni.edu.ni/"],
    name: "Universidad Nacional de Ingenieria",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uni.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.unival.edu.ni/"],
    name: "Universidad Internacional de Integración de América Latina",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["unival.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.upoli.edu.ni/"],
    name: "Universidad Politecnica de Nicaragua",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["upoli.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.uponic.edu.ni/"],
    name: "Universidad Popular de Nicaragua (UPONIC)",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uponic.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://www.uraccan.edu.ni/"],
    name: "Universidad de las Regiones Autónomas de la Costa Caribe Nicaragüense",
    alpha_two_code: "NI",
    "state-province": null,
    domains: ["uraccan.edu.ni"],
    country: "Nicaragua",
  },
  {
    web_pages: ["http://uam.refer.ne/"],
    name: "Université Abdou Moumouni de Niamey",
    alpha_two_code: "NE",
    "state-province": null,
    domains: ["uam.refer.ne"],
    country: "Niger",
  },
  {
    web_pages: ["http://www.aaua.edu.ng/"],
    name: "Adekunle Ajasin University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["aaua.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.aauekpoma.edu.ng/"],
    name: "Ambrose Alli University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["aauekpoma.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.abiapoly.edu.ng/"],
    name: "Abia State Polytechnic",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["abiapoly.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.absu.edu.ng/"],
    name: "Abia State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["absu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.abuad.edu.ng/"],
    name: "Afe Babalola University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["abuad.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.abu.edu.ng/"],
    name: "Ahmadu Bello University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["abu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.aceondo-ng.com/"],
    name: "Adeyemi College of Education",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["aceondo-ng.com"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.achievers.edu.ng/"],
    name: "The Achievers University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["achievers.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.acu.edu.ng/"],
    name: "Ajayi Crowther University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["acu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.adelekeuniversity.edu.ng/"],
    name: "Adeleke University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["adelekeuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.adsu.edu.ng/"],
    name: "Adamawa State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["adsu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.akutech.edu.ng/"],
    name: "Akwa Ibom State University of Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["akutech.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.alhikmah.edu.ng/"],
    name: "Al-hikmah University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["alhikmah.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ansu.edu.ng/"],
    name: "Anambra State University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ansu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.atbu.edu.ng/"],
    name: "Abubakar Tafawa Balewa University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["atbu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.auchipoly.edu.ng/"],
    name: "Auchi Polytechnic",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["auchipoly.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.aun.edu.ng/"],
    name: "ABTI American University of Nigeria",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["aun.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.aust-abuja.org/"],
    name: "African University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["aust-abuja.org"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.babcockuni.edu.ng/"],
    name: "Babcock University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["babcockuni.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.basug.edu.ng/"],
    name: "Bauchi State University, Gadau",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["basug.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.bazeuniversity.edu.ng"],
    name: "Baze University Abuja",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["bazeuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.bellsuniversity.org/"],
    name: "Bells University of Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["bellsuniversity.org"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.binghamuni.edu.ng/"],
    name: "Bingham University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["binghamuni.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.biu.edu.ng/"],
    name: "Benson Idahosa University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["biu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://bowenuniversity-edu.org/"],
    name: "Bowen University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["bowenuniversity-edu.org"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.bsum.edu.ng/"],
    name: "Benue State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["bsum.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.buk.edu.ng/"],
    name: "Bayero University Kano",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["buk.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.calebuniversity.edu.ng/"],
    name: "Caleb University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["calebuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.caritasuni.edu.ng/"],
    name: "Caritas University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["caritasuni.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.coeikere.edu.ng/"],
    name: "College of Education Ikere",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["coeikere.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.coeoju.com/"],
    name: "College of Education Oju",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["coeoju.com"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.covenantuniversity.edu.ng/"],
    name: "Covenant University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["covenantuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.crawforduniversity.edu.ng/"],
    name: "Crawford University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["crawforduniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.crescent-university.edu.ng/"],
    name: "Crescent University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["crescent-university.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.crutech.edu.ng/"],
    name: "Cross River University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["crutech.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ebsu-edu.net/"],
    name: "Ebonyi State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ebsu-edu.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.eksu.edu.ng/"],
    name: "Ekiti State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["eksu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.esut.edu.ng/"],
    name: "Enugu State University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["esut.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.fcetakoka-edu.net/"],
    name: "Federal College Of Education (Technical), Akoka",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["fcetakoka-edu.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.fedpoffa.edu.ng/"],
    name: "The Federal Polytechnic Offa",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["fedpoffa.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.fountainuniversity.edu.ng/"],
    name: "Fountain University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["fountainuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.fupre.edu.ng/"],
    name: "Federal University of Petroleum Resources",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["fupre.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.futa.edu.ng/"],
    name: "Federal University of Technology, Akure",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["futa.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.futminna.edu.ng/"],
    name: "Federal University of Technology, Minna",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["futminna.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.futo.edu.ng/"],
    name: "Federal University of Technology, Owerri",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["futo.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.futy.edu.ng/"],
    name: "Federal University of Technology, Yola",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["futy.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.gouni.edu.ng/"],
    name: "Godfrey Okoye University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["gouni.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.gsu.edu.ng/"],
    name: "Gombe State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["gsu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ibbu.edu.ng/"],
    name: "Ibrahim Babangida University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ibbu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.imsu.edu.ng/"],
    name: "Imo State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["imsu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.iuokada.edu.ng/"],
    name: "Igbinedion University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["iuokada.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.jabu.edu.ng/"],
    name: "Joseph Ayo Babalola University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["jabu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kasuportal.net/"],
    name: "Kaduna State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kasuportal.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ksuportal.edu.ng/"],
    name: "Kogi State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ksuportal.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ksusta.edu.ng/"],
    name: "Kebbi State University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ksusta.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kuk.edu.ng/"],
    name: "Katsina University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kuk.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kustwudil.edu.ng/"],
    name: "Kano State University of Technology Wudil",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kustwudil.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kwarapoly.edu.ng/"],
    name: "Kwara State Polytecnic",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kwarapoly.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kwararafauniversity.edu.ng/"],
    name: "Kwararafa University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kwararafauniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.kwasu.edu.ng/"],
    name: "Kwara State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["kwasu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.laspotech.net/"],
    name: "Lagos State Polytechnic",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["laspotech.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.lasunigeria.org/"],
    name: "Lagos State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["lasunigeria.org"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.lautech.edu.ng/"],
    name: "Ladoke Akintola University of Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["lautech.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.lcu.edu.ng/"],
    name: "Lead City University of Ibadan",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["lcu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.lmu.edu.ng/"],
    name: "Landmark University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["lmu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.madonnauniversity.edu.ng/"],
    name: "Madonna University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["madonnauniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.mouau.edu.ng/"],
    name: "Michael Okpara University of Agriculture",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["mouau.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.mylcp.net/"],
    name: "Lagos City Polytechnic",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["mylcp.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.nda.edu.ng/"],
    name: "Nigerian Defence Academy",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["nda.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ndu.edu.ng/"],
    name: "Niger Delta University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ndu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.nou.edu.ng/"],
    name: "National Open University of Nigeria",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["nou.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.novenauniversity.edu.ng/"],
    name: "Novena University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["novenauniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.nsuk.edu.ng/"],
    name: "Nasarawa State University Keffi",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["nsuk.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ntnu.edu.ng/"],
    name: "Nigerian Turkish Nile University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ntnu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.oauife.edu.ng/"],
    name: "Obafemi Awolowo University Ile-Ife",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["oauife.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.obonguniversity.net/"],
    name: "Obong University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["obonguniversity.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.oduduwauniversity.edu.ng/"],
    name: "Oduduwa University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["oduduwauniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.oouagoiwoye.edu.ng/"],
    name: "Olabisi Onabanjo University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["oouagoiwoye.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.osustech.edu.ng/"],
    name: "Ondo State University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["osustech.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.pau.edu.ng/"],
    name: "Pan-African University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["pau.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.pauluniversity.edu.ng/"],
    name: "Paul University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["pauluniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.polyibadan.edu.ng/"],
    name: "Polytechnic Ibadan",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["polyibadan.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.polyunwana.net/"],
    name: "Akanu Ibiam Federal Polytechnic, Unwana",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["polyunwana.net"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.rnu.edu.ng/"],
    name: "Renaissance University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["rnu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.run.edu.ng/"],
    name: "Redeemers University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["run.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.salemuniversity.edu.ng/"],
    name: "Salem University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["salemuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ssu.edu.ng/"],
    name: "Sokoto State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ssu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.tansianuniversity.edu.ng/"],
    name: "Tansian University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["tansianuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.tasued.edu.ng/"],
    name: "Tai Solarin University of Education",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["tasued.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.tsuniversity.edu.ng/"],
    name: "Taraba State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["tsuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.uam.edu.ng/"],
    name: "University of Agriculture Makurdi",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["uam.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.udusok.edu.ng/"],
    name: "Usmanu Danfodiyo University Sokoto",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["udusok.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ui.edu.ng/"],
    name: "University of Ibadan",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ui.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.umyu.edu.ng/"],
    name: "Umaru Musa Yar'Adua University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["umyu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unaab.edu.ng/"],
    name: "University of Agriculture Abeokuta",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unaab.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.uniben.edu/"],
    name: "University of Benin",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["uniben.edu"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unibuja.edu.ng/"],
    name: "University of Abuja",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unibuja.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unical.edu.ng/"],
    name: "University of Calabar",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unical.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unijos.edu.ng/"],
    name: "University of Jos",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unijos.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unilag.edu.ng/"],
    name: "University of Lagos",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unilag.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unilorin.edu.ng/"],
    name: "University of Ilorin",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unilorin.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unimaid.edu.ng/"],
    name: "University of Maiduguri",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unimaid.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unimkar.edu.ng/"],
    name: "University of Mkar",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unimkar.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.uniosun.edu.ng/"],
    name: "Osun State University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["uniosun.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.uniport.edu.ng/"],
    name: "University of Portharcourt",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["uniport.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.uniuyo.edu.ng/"],
    name: "University of Uyo",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["uniuyo.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unizik.edu.ng/"],
    name: "Nnamdi Azikiwe University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unizik.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.unn.edu.ng/"],
    name: "University of Nigeria",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["unn.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.ust.edu.ng/"],
    name: "Rivers State University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["ust.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.veritas.edu.ng/"],
    name: "Veritas University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["veritas.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.wdu.edu.ng/"],
    name: "Western Delta University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["wdu.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.wellspringuniversity.edu.ng/"],
    name: "Wellspring University",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["wellspringuniversity.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.wustoportal.edu.ng/"],
    name: "Wesley University of Science and Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["wustoportal.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.yabatech.edu.ng/"],
    name: "Yaba College of Technology",
    alpha_two_code: "NG",
    "state-province": null,
    domains: ["yabatech.edu.ng"],
    country: "Nigeria",
  },
  {
    web_pages: ["http://www.stclements.edu.nu/"],
    name: "St Clements University - Higher Education School",
    alpha_two_code: "NU",
    "state-province": null,
    domains: ["stclements.edu.nu"],
    country: "Niue",
  },
  {
    web_pages: ["http://www.aho.no/"],
    name: "Oslo School of Architecture",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["aho.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.bi.no/"],
    name: "Norwegian School of Management BI",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["bi.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.hia.no/"],
    name: "Agder University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["hia.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.hib.no/"],
    name: "Bergen University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["hib.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.hibo.no/"],
    name: "Bodo Regional University",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["hibo.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.hifm.no/"],
    name: "Finnmark University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["hifm.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.hil.no/"],
    name: "Lillehammer University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["hil.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.himolde.no/"],
    name: "Molde University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["himolde.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.khio.no/shks/"],
    name: "National College of Art and Design",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["khio.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nhh.no/"],
    name: "Norwegian School of Economics and Business Administration",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nhh.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nih.no/"],
    name: "Norwegian University of Sport and Physical Education",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nih.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nith.no/"],
    name: "Norway's Information Technology University College",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nith.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nla.no/"],
    name: "Norwegian Teacher Academy for Studies in Religion and Education",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nla.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nlh.no/"],
    name: "Agricultural University of Norway",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nlh.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.nmh.no/"],
    name: "Norwegian State Academy of Music",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["nmh.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.ntnu.no/"],
    name: "Norwegian University of Science and Technology",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["ntnu.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://ska.khio.no/main"],
    name: "National Academy of Fine Arts",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["ska.khio.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.uib.no/"],
    name: "University of Bergen",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["uib.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.uio.no/"],
    name: "University of Oslo",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["uio.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.uis.no/"],
    name: "University of Stavanger",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["uis.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.uit.no/"],
    name: "University of Tromsø",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["uit.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.umb.no/"],
    name: "Norwegian University of Life Sciences",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["umb.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.veths.no/"],
    name: "Norwegian College of Veterinary Medicine",
    alpha_two_code: "NO",
    "state-province": null,
    domains: ["veths.no"],
    country: "Norway",
  },
  {
    web_pages: ["http://www.aou.edu.om/"],
    name: "Arab Open University",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["aou.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.buc.edu.om/"],
    name: "Al-Buraimi University College",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["buc.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.du.edu.om/"],
    name: "Dhofar University",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["du.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.ict.edu.om/"],
    name: "Ibra College of Technology",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["ict.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.majancollege.edu.om/"],
    name: "Majan University College",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["majancollege.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.muscatcollege.edu.om/"],
    name: "Muscat College",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["muscatcollege.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.omancollege.edu.om/"],
    name: "Oman College Of Management & Technology",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["omancollege.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.soharuni.edu.om/"],
    name: "Sohar University",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["soharuni.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.squ.edu.om/"],
    name: "Sultan Qaboos University",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["squ.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.suc.edu.om/"],
    name: "Sur University College",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["suc.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.unizwa.edu.om/"],
    name: "University of Nizwa",
    alpha_two_code: "OM",
    "state-province": null,
    domains: ["unizwa.edu.om"],
    country: "Oman",
  },
  {
    web_pages: ["http://www.abasyn.edu.pk/"],
    name: "Abasyn University Peshawar",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["abasyn.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.aiou.edu.pk/"],
    name: "Allama Iqbal Open University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["aiou.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ajku.edu.pk/"],
    name: "Azad Jammu and Kashmir University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ajku.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.aku.edu/"],
    name: "Aga Khan University",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["aku.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.aldirasat.edu.pk/"],
    name: "Jamia Al Dirasat Ul Islami Karachi",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["aldirasat.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.alkhair.edu.pk/"],
    name: "Al-Khair University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["alkhair.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ami.edu.pk/"],
    name: "Ahmed Medical Institute",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["ami.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.au.edu.pk/"],
    name: "Air University",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["au.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.aup.edu.pk/"],
    name: "The University of Agriculture, Peshawar",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["aup.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.bahria.edu.pk/"],
    name: "Bahria University",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["bahria.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.biit.edu.pk/"],
    name: "Barani Institute of Information Technology",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["biit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.bims.edu.pk/"],
    name: "Barani Institute of Management Sciences",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["bims.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://baqai.edu.pk/"],
    name: "Baqai Medical University",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["baqai.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.buetk.edu.pk/"],
    name: "Balochistan University of Engineering and Technology Khuzdar",
    alpha_two_code: "PK",
    "state-province": "Balochistan",
    domains: ["buetk.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.buitms.edu.pk/"],
    name: "Balochistan University of Information Technology & Management Sciences",
    alpha_two_code: "PK",
    "state-province": "Balochistan",
    domains: ["buitms.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.bzu.edu.pk/"],
    name: "Bahauddin Zakariya University, Multan",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["bzu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://cbm.iobm.edu.pk/"],
    name: "College of Business Management (CBM)",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["cbm.iobm.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.cecos.edu.pk/"],
    name: "Cecos Univeristy of Information Technology",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["cecos.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ciit-atd.edu.pk/"],
    name: "COMSATS Institute of Information Technology, Abbottabad",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["ciit-atd.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ciit-attock.edu.pk/"],
    name: "COMSATS Institute of Information Technology, Attock",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["ciit-attock.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ciit.edu.pk/"],
    name: "COMSATS Institute of Information Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ciit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ciitlahore.edu.pk/"],
    name: "COMSATS Institute of Information Technology, Lahore",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["ciitlahore.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ciit-wah.edu.pk/"],
    name: "COMSATS Institute of Information Technology, Wah",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ciit-wah.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.cosmiq.edu.pk/"],
    name: "COSMIQ Institute of Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["cosmiq.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.dadabhoy.edu.pk/"],
    name: "Dadabhoy Institute of Higher Education",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["dadabhoy.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.dcet.edu.pk/"],
    name: "Dawood College of Engineering and Technology",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["dcet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.duhs.edu.pk/"],
    name: "Dow University of Health Sciences",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["duhs.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.fitfd.edu.pk/"],
    name: "Faisalabad Institute of Textile and Fashion Design",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["fitfd.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.fuuast.edu.pk/"],
    name: "Federal Urdu University of Arts,Science and Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["fuuast.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.fwu.edu.pk/"],
    name: "Shaheed Benazir Bhutto Women University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["fwu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gandhara.edu.pk/"],
    name: "Gandhara Institute of Medical Sciences",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gandhara.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gcu.edu.pk/"],
    name: "Government College University Lahore",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gcu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gcuf.edu.pk/"],
    name: "Government College University Faisalabad",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gcuf.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uob.edu.pk"],
    name: "University of Balochistan",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uob.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://zu.edu.pk/"],
    name: "Zia-ud-Din University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["zu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gift.edu.pk/"],
    name: "Gift University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gift.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.giki.edu.pk/"],
    name: "Ghulam Ishaq Khan Institute of Science & Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["giki.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gist.edu.pk/"],
    name: "Gangdara Institute Of Science & Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gist.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.global.edu.pk/"],
    name: "The Global College Lahore",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["global.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.gu.edu.pk/"],
    name: "Gomal University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["gu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.guic.edu.pk/"],
    name: "Greenwich University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["guic.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.hajvery.edu.pk/"],
    name: "Hajvery University Lahore for Women",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["hajvery.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.hamdard.edu.pk/"],
    name: "Hamdard University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["hamdard.edu.pk", "hamdard.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.hitecuni.edu.pk/"],
    name: "Hitec University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["hitecuni.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.hu.edu.pk/"],
    name: "Hazara University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["hu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iba.edu.pk/"],
    name: "Institute of Business Administration (IBA)",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iba.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iba-suk.edu.pk/"],
    name: "Institute of Business Administration Sukkur",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iba-suk.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iiee.edu.pk/"],
    name: "Institute of Industrial Electronics Engineering",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iiee.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iiu.edu.pk/"],
    name: "International Islamic University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iiu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.imsciences.edu.pk/"],
    name: "Institute of Management Sciences, Peshawar",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["imsciences.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.indus.edu.pk/"],
    name: "Indus Institute of Higher Education",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["indus.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iqra.edu.pk/"],
    name: "Iqra University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iqra.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.isra.edu.pk/"],
    name: "Isra University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["isra.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ist.edu.pk/"],
    name: "Institute of Space Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ist.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.iub.edu.pk/"],
    name: "Islamia University of Bahawalpur",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["iub.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.jinnah.edu/"],
    name: "Mohammad Ali Jinnah University, Karachi",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["jinnah.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.jinnah.edu.pk/"],
    name: "Mohammad Ali Jinnah University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["jinnah.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.juw.edu.pk/"],
    name: "Jinnah University for Women",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["juw.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.kasbit.edu.pk/"],
    name: "KASB Institute of Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["kasbit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.kiit.edu.pk/"],
    name: "Karachi Institute of Information Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["kiit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.kiu.edu.pk/"],
    name: "Karakoram International University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["kiu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.kmdc.edu.pk/"],
    name: "Karachi Medical and Dental College",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["kmdc.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ksa.edu.pk/"],
    name: "Karachi School of Art",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["ksa.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.kust.edu.pk/"],
    name: "Kohat University of Science and Technology  (KUST)",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["kust.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.lcwu.edu.pk/"],
    name: "Lahore College for Women University",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["lcwu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.lumhs.edu.pk/"],
    name: "Liaquat University of Medical & Health Sciences Jamshoro",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["lumhs.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.lums.edu.pk/"],
    name: "Lahore University of Management Sciences",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["lums.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.miu.edu.pk/"],
    name: "Mohi-ud-Din Islamic University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["miu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.moorelanduniversity.com/"],
    name: "Mooreland University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["moorelanduniversity.com"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.muet.edu.pk/"],
    name: "Mehran University of Engineering & Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["muet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.mul.edu.pk/"],
    name: "Minhaj University Lahore",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["mul.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.nca.edu.pk/"],
    name: "National College of Arts",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["nca.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.neduet.edu.pk/"],
    name: "NED University of Engineering and Technology Karachi",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["neduet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://www.dsu.edu.pk/"],
    name: "DHA Suffa Uinversity",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["dsu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://www.smiu.edu.pk/"],
    name: "Sindh Madressatul Islam University",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["smiu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["https://www.indus.edu.pk/"],
    name: "Indus University",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["indus.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.newports.edu.pk/"],
    name: "Newports Institute of Communication & Economics",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["newports.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.niab.org.pk/"],
    name: "Nuclear Institute for Agriculture and Biology (NIAB)",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["niab.org.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.nu.edu.pk/"],
    name: "FAST - National University of Computer and Emerging Sciences (NUCES)",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["nu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.numl.edu.pk/"],
    name: "National University of Modern Languages",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["numl.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.nust.edu.pk/"],
    name: "National University of Science and Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["nust.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.nwfpuet.edu.pk/"],
    name: "University of Engineering and Technology Peshawar",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["nwfpuet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pafkiet.edu.pk/"],
    name: "Karachi Institute Of Economics And Technology",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["pafkiet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pakaims.edu/"],
    name: "Pak-AIMS (American Institute of Management Sciences)",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["pakaims.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pakaims.edu.pk/"],
    name: "Institute of Management Sciences, Lahore (IMS)",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["pakaims.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pakistanhomoeopathy.com/"],
    name: "Hahnamann Honoeopathic Medical College",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["pakistanhomoeopathy.com"],
    country: "Pakistan",
  },
  {
    web_pages: [
      "http://www.panasia.org.sg/tcdc/pakistan/qauid_sindh/index.html",
    ],
    name: "Qauid-e-Awam University of Engineering Sciences & Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["panasia.org.sg"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pedu.edu.pk/"],
    name: "Pyramid Education Center",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["pedu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pics.edu.pk/"],
    name: "Punjab Institute of Computer science",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["pics.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pieas.edu.pk/"],
    name: "Pakistan Institute of Engineering and Applied Sciences (PIEAS)",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["pieas.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pimsat-khi.edu.pk/"],
    name: "Preston Institute of Management Sciences and Technology (PIMSAT)",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["pimsat-khi.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.planwel.edu/"],
    name: "Planwel University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["planwel.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.prestonpak.edu.pk/"],
    name: "Preston University, Pakistan Campus",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["prestonpak.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pucit.edu.pk/"],
    name: "Punjab University College of Information Tecnology",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["pucit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pu.edu.pk/"],
    name: "University of the Punjab",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["pu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.pugc.edu.pk/"],
    name: "University of the Punjab, Gujranwala Campus",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["pugc.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.qau.edu.pk/"],
    name: "Quaid-i-Azam University",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["qau.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.qurtuba.edu.pk/"],
    name: "Qurtuba University of Science and Infromation Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["qurtuba.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.riphah.edu.pk/"],
    name: "Riphah International Univeristy",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["riphah.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.salu.edu.pk/"],
    name: "Shah Abdul Latif University Khairpur",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["salu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.sau.edu.pk/"],
    name: "Sindh Agricultural University",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["sau.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ssms.edu.pk/"],
    name: "Sir Syed Institute Of Technology Islamabad",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["ssms.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ssuet.edu.pk/"],
    name: "Sir Syed University of Engineering and Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ssuet.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.suit.edu.pk/"],
    name: "Sarhad University of Science & Information Technology, Peshawar",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["suit.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.superior.edu.pk/"],
    name: "The Superior College",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["superior.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.szabist.edu.pk/"],
    name: "Shaheed Zulifkar Ali Bhutto Institute of Science and Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["szabist.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.tip.edu.pk/"],
    name: "Textile Institute of Pakistan",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["tip.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.tuf.edu.pk/"],
    name: "University of Faisalabad",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["tuf.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uaar.edu.pk/"],
    name: "Arid Agriculture University",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["uaar.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uaf.edu.pk/"],
    name: "University of Agriculture Faisalabad",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uaf.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ucp.edu.pk/"],
    name: "University of Central Punjab",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ucp.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ue.edu.pk/"],
    name: "University of Education",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ue.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uet.edu/"],
    name: "University of Engineering and Technology Lahore",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uet.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uettaxila.edu.pk/"],
    name: "University of Engineering and Technology Taxila",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uettaxila.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.umi.edu.pk/"],
    name: "University of Munawwar-ul-Islam",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["umi.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.umt.edu.pk/"],
    name: "University of Management and Technology",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["umt.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.unw.edu.pk/"],
    name: "University of NorthWest",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["unw.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uoe.edu.pk/"],
    name: "University of East",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uoe.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uog.edu.pk/"],
    name: "University of Gujrat",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["uog.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uok.edu.pk/"],
    name: "University of Karachi",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["uok.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uol.edu.pk/"],
    name: "University of Lahore",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["uol.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uom.edu.pk/"],
    name: "University of Malakand",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["uom.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uos.edu.pk/"],
    name: "University of Sargodha",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["uos.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.upesh.edu/"],
    name: "University of Peshawar",
    alpha_two_code: "PK",
    "state-province": "Khyber Pakhtunkhwa",
    domains: ["upesh.edu"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.usa.edu.pk/"],
    name: "University of South Asia",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["usa.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.usindh.edu.pk/"],
    name: "University of Sindh",
    alpha_two_code: "PK",
    "state-province": "Sindh",
    domains: ["usindh.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.ustb.edu.pk/"],
    name: "University of Science & Technology Bannu",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["ustb.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uvas.edu.pk/"],
    name: "University of Veterinary & Animal Science",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["uvas.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.uw.edu.pk/"],
    name: "University of Wah",
    alpha_two_code: "PK",
    "state-province": null,
    domains: ["uw.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.vu.edu.pk/"],
    name: "Virtual University of Pakistan",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["vu.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.wahmedicalcollege.edu.pk/"],
    name: "Wah Medical College",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["wahmedicalcollege.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.zawiya.edu.pk/"],
    name: "Zawiya Academy",
    alpha_two_code: "PK",
    "state-province": "Panjab",
    domains: ["zawiya.edu.pk"],
    country: "Pakistan",
  },
  {
    web_pages: ["http://www.aauj.edu/"],
    name: "Arab American University - Jenin",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["aauj.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.alaqsa.edu.ps/"],
    name: "Al-Aqsa University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["alaqsa.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.alazhar.edu.ps/"],
    name: "Al-Azhar University of Gaza",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["alazhar.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.alquds.edu/"],
    name: "Al-Quds University - The Arab University in Jerusalem",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["alquds.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.bethlehem.edu/"],
    name: "Bethlehem University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["bethlehem.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.birzeit.edu/"],
    name: "Birzeit University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["birzeit.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.hebron.edu/"],
    name: "Hebron University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["hebron.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.iugaza.edu.ps/"],
    name: "Islamic University of Gaza",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["iugaza.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.najah.edu/"],
    name: "An-Najah National University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["najah.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.ppu.edu/"],
    name: "Palestine Polytechnic University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["ppu.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.ptcdb.edu.ps/"],
    name: "Palestine Technical College-Dier Elbalah",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["ptcdb.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.ptuk.edu.ps/"],
    name: "Palestine Technical University - Kadoorie",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["ptuk.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.qou.edu/"],
    name: "Al-Quds Open University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["qou.edu"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.ucas.edu.ps/"],
    name: "University College of Applied Sciences",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["ucas.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.uou.edu.ps/"],
    name: "Ummah University",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["uou.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.up.edu.ps/"],
    name: "University of Palestine",
    alpha_two_code: "PS",
    "state-province": null,
    domains: ["up.edu.ps"],
    country: "Palestine, State of",
  },
  {
    web_pages: ["http://www.columbus.edu/"],
    name: "Columbus University",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["columbus.edu"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.floret.edu.pa/"],
    name: "Floret Global University",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["floret.edu.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.institutoteima.ac.pa/"],
    name: "Instituto de Enseñanza Superior Oteima",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["institutoteima.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.oteima.ac.pa/"],
    name: "Universidad Tecnológica Oteima",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["oteima.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.ucapanama.org/"],
    name: "Universidad de Cartago",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["ucapanama.org"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.udelas.ac.pa/"],
    name: "Universidad Especializada de Las Americas",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["udelas.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.udi.edu/"],
    name: "Universidad del Istmo",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["udi.edu"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.ulacit.ac.pa/"],
    name: "Universidad Latinoamericana de Ciencia y Tecnologia, Panamá",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["ulacit.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.ulat.ac.pa/"],
    name: "Universidad Latina de Panamá",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["ulat.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.unachi.ac.pa/"],
    name: "Universidad Autonoma de Chiriqui",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["unachi.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.unadp.ac.pa/"],
    name: "Universidad Abierta y a Distancia de Panama",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["unadp.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.uniedpa.com/"],
    name: "Universidad Interamericana de Educacion a Distancia de Panama",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["uniedpa.com"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.up.ac.pa/"],
    name: "Universidad de Panamá",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["up.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.usma.ac.pa/"],
    name: "Universidad Católica Santa María La Antigua",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["usma.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.utp.ac.pa/"],
    name: "Universidad Tecnológica de Panamá",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["utp.ac.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.viu.edu.pa/"],
    name: "Victoria International University",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["viu.edu.pa"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.westcoastuniversity-edu.com/"],
    name: "West Coast University (WCU)",
    alpha_two_code: "PA",
    "state-province": null,
    domains: ["westcoastuniversity-edu.com"],
    country: "Panama",
  },
  {
    web_pages: ["http://www.dwu.ac.pg/"],
    name: "Divine Word University",
    alpha_two_code: "PG",
    "state-province": null,
    domains: ["dwu.ac.pg"],
    country: "Papua New Guinea",
  },
  {
    web_pages: ["http://www.pau.ac.pg/"],
    name: "Pacific Adventist University",
    alpha_two_code: "PG",
    "state-province": null,
    domains: ["pau.ac.pg"],
    country: "Papua New Guinea",
  },
  {
    web_pages: ["http://www.unitech.ac.pg/"],
    name: "Papua New Guinea University of Technology",
    alpha_two_code: "PG",
    "state-province": null,
    domains: ["unitech.ac.pg"],
    country: "Papua New Guinea",
  },
  {
    web_pages: ["http://www.uog.ac.pg/"],
    name: "University of Goroka",
    alpha_two_code: "PG",
    "state-province": null,
    domains: ["uog.ac.pg"],
    country: "Papua New Guinea",
  },
  {
    web_pages: ["http://www.upng.ac.pg/"],
    name: "University of Papua New Guinea",
    alpha_two_code: "PG",
    "state-province": null,
    domains: ["upng.ac.pg"],
    country: "Papua New Guinea",
  },
  {
    web_pages: ["http://www.columbia.edu.py/"],
    name: "Universidad Columbia del Paraguay",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["columbia.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uaa.edu.py/"],
    name: "Universidad Autónoma de Asunción",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uaa.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uamericana.edu.py/"],
    name: "Universidad Americana",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uamericana.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uap.edu.py/"],
    name: "Universidad Autónoma del Paraguay",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uap.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uc.edu.py/"],
    name: "Universidad Católica Nuestra Senora de la Asunción",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uc.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.ucom.edu.py/"],
    name: "Universidad Comunera",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["ucom.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.ucsa.edu.py/"],
    name: "Universidad del Cono Sur de las Américas",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["ucsa.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uma.edu.py/"],
    name: "Universidad Metropolitana de Asunción",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uma.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.una.py/"],
    name: "Universidad Nacional de Asunción",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["una.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.une.edu.py/"],
    name: "Universidad Nacional del Este",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["une.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.unida.edu.py/"],
    name: "Universidad de la Integración de las Americas (UNIDAD)",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["unida.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.uninorte.edu.py/"],
    name: "Universidad del Norte",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["uninorte.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.upe.edu.py/"],
    name: "Universidad Privada del Este",
    alpha_two_code: "PY",
    "state-province": null,
    domains: ["upe.edu.py"],
    country: "Paraguay",
  },
  {
    web_pages: ["http://www.champagnat.edu.pe/"],
    name: "Universidad Marcelino Champagnat",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["champagnat.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.lamolina.edu.pe/"],
    name: "Universidad Nacional Agraria La Molina",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["lamolina.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.pucp.edu.pe/"],
    name: "Pontificia Universidad Católica del Perú",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["pucp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.sil.edu.pe/"],
    name: "Universidad San Ignacio de Loyola",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["sil.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uancv.edu.pe/"],
    name: "Universidad Andina Nestor Caceares Velasquez",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uancv.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uandina.edu.pe/"],
    name: "Universidad Andina del Cusco",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uandina.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uap.edu.pe/"],
    name: "Universidad Alas Peruanas",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uap.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uch.edu.pe/"],
    name: "Universidad de Ciencias y Humanidades",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uch.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.ucsm.edu.pe/"],
    name: "Universidad Católica de Santa María",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["ucsm.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.ucsur.edu.pe/"],
    name: "Universidad Cientifica del Sur",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["ucsur.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.ucv.edu.pe/"],
    name: "Universidad César Vallejo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["ucv.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.udch.edu.pe/"],
    name: "Universidad Particular de Chiclayo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["udch.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.udep.edu.pe/"],
    name: "Universidad de Piura",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["udep.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.udh.edu.pe/"],
    name: "Universidad de Huánuco",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["udh.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.udl.edu.pe/"],
    name: "Universidad de Lambayeque",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["udl.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uigv.edu.pe/"],
    name: "Universidad Particular Inca Garcilaso de la Vega",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uigv.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uladech.edu.pe/"],
    name: "Universidad Los Angeles de Chimbote",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uladech.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.ulima.edu.pe/"],
    name: "Universidad de Lima",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["ulima.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.umb.edu.pe/"],
    name: "Universidad Privada Juan Mejía Baca",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["umb.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unac.edu.pe/"],
    name: "Universidad Nacional del Callao",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unac.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unap.edu.pe/"],
    name: "Universidad Nacional del Altiplano",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unap.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unapiquitos.edu.pe/"],
    name: "Universidad Nacional de la Amazonía Peruana",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unapiquitos.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unasam.edu.pe/"],
    name: "Universidad Nacional Santiago Antúnez de Mayolo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unasam.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unas.edu.pe/"],
    name: "Universidad Nacional Agraria de la Selva",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unas.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unc.edu.pe/"],
    name: "Universidad Nacional de Cajamarca",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unc.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uncp.edu.pe/"],
    name: "Universidad Nacional del Centro del Perú",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uncp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.undac.edu.pe/"],
    name: "Universidad Nacional Daniel Alcides Carrion",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["undac.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.une.edu.pe/"],
    name: "Universidad Nacional de Educación Enrique Guzmán y Valle",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["une.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unfv.edu.pe/"],
    name: "Universidad Nacional Federico Villarreal",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unfv.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unheval.edu.pe/"],
    name: "Universidad Nacional Hermilio Valdizan",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unheval.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unica.edu.pe/"],
    name: "Universidad Nacional San Luis Gonzaga",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unica.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uni.edu.pe/"],
    name: "Universidad Nacional de Ingeniería",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uni.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unife.edu.pe/"],
    name: "Universidad Femenina del Sagrado Corazón",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unife.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unitru.edu.pe/"],
    name: "Universidad Nacional de La Libertad, Trujillo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unitru.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unjbg.edu.pe/"],
    name: "Universidad Nacional Jorge Basadre Grohmann",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unjbg.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unjfsc.edu.pe/"],
    name: "Universidad Nacional José Faustino Sánchez Carrión",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unjfsc.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unmsm.edu.pe/"],
    name: "Universidad Nacional Mayor de San Marcos",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unmsm.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unp.edu.pe/"],
    name: "Universidad Nacional de Piura",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unprg.edu.pe/"],
    name: "Universidad Nacional Pedro Ruíz Gallo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unprg.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unsaac.edu.pe/"],
    name: "Universidad Nacional de San Antonio Abad",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unsaac.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unsa.edu.pe/"],
    name: "Universidad Nacional de San Agustin",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unsa.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unsch.edu.pe/"],
    name: "Universidad Nacional de San Cristóbal de Huamanga",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unsch.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uns.edu.pe/"],
    name: "Universidad Nacional de Santa - Chimbote",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uns.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unsm.edu.pe/"],
    name: "Universidad Nacional de San Martín",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unsm.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.untumbes.edu.pe/"],
    name: "Universidad Nacional de Tumbes",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["untumbes.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.unu.edu.pe/"],
    name: "Universidad Nacional de Ucayali",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["unu.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upao.edu.pe/"],
    name: "Universidad Privada Antenor Orrego",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upao.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upc.edu.pe/"],
    name: "Universidad Peruana de Ciencias Aplicadas",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upc.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upch.edu.pe/"],
    name: "Universidad Peruana Cayetano Heredia",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upch.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upci.edu.pe/"],
    name: "Universidad Peruana de Ciencias e Informática",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upci.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.up.edu.pe/"],
    name: "Universidad del Pacifico",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["up.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upeu.edu.pe/"],
    name: "Universidad Peruana Union",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upeu.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upla.edu.pe/"],
    name: "Universidad Privada Los Andes",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upla.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upnorte.edu.pe/"],
    name: "Universidad Privada del Norte",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upnorte.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upsb.edu.pe/"],
    name: "Universidad Privada Sergio Bernales",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upsb.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upsjb.edu.pe/"],
    name: "Universidad Privada San Juan Bautista",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upsjb.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.upt.edu.pe/"],
    name: "Universidad Privada de Tacna",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["upt.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.urp.edu.pe/"],
    name: "Universidad Ricardo Palma",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["urp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.usanpedro.edu.pe/"],
    name: "Universidad Privada San Pedro",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["usanpedro.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.usat.edu.pe/"],
    name: "Universidad Católica Santo Toribio de Mogrovejo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["usat.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.usmp.edu.pe/"],
    name: "Universidad San Martin de Porres",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["usmp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.usp.edu.pe/"],
    name: "Universidad San Pablo",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["usp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uss.edu.pe/"],
    name: "Universidad Señor de Sipán",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uss.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.utea.edu.pe/"],
    name: "Universidad Tecnológica de los Andes de Apurímac",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["utea.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.utp.edu.pe/"],
    name: "Universidad Tecnológica del Peru",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["utp.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.uwiener.edu.pe/"],
    name: "Universidad Norbert Wiener",
    alpha_two_code: "PE",
    "state-province": null,
    domains: ["uwiener.edu.pe"],
    country: "Peru",
  },
  {
    web_pages: ["http://www.adamson.edu.ph/"],
    name: "Adamson University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["adamson.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.addu.edu.ph/"],
    name: "Ateneo de Davao University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["addu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.admu.edu.ph/"],
    name: "Ateneo de Manila University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["admu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.adnu.edu.ph/"],
    name: "Ateneo de Naga University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["adnu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.adzu.edu.ph/"],
    name: "Ateneo de Zamboanga University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["adzu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.aquinas-university.edu/"],
    name: "Aquinas University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["aquinas-university.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.araneta.dlsu.edu.ph/"],
    name: "De La Salle University, Araneta",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["araneta.dlsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.arellano.edu.ph/"],
    name: "Arellano University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["arellano.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.auf.edu.ph/"],
    name: "Angeles University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["auf.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.aup.edu.ph/"],
    name: "Adventist University of the Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["aup.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.aupen.edu.ph/"],
    name: "Araullo University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["aupen.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.bicol-u.edu.ph/"],
    name: "Bicol University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["bicol-u.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.bsu.edu.ph/"],
    name: "Benguet State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["bsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.bulsu.edu.ph/"],
    name: "Bulacan State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["bulsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ceu.edu.ph/"],
    name: "Centro Escolar University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ceu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.cmu.edu.ph/"],
    name: "Central Mindanao University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["cmu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.cpuic.edu/"],
    name: "Central Philippine University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["cpuic.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.csu.edu.ph/"],
    name: "Cagayan State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["csu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.cu-cdo.edu.ph/"],
    name: "Capitol University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["cu-cdo.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.davaodoctors.edu.ph/"],
    name: "Davao Doctors College",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["davaodoctors.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.dlsu.edu.ph/"],
    name: "De La Salle University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["dlsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.dmmmsu.edu.ph/"],
    name: "Don Mariano Marcos Memorial State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["dmmmsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.dwc-legazpi.edu/"],
    name: "Divine Word College of Legazpi",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["dwc-legazpi.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.fatima.edu.ph/"],
    name: "Our Lady of Fatima University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["fatima.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.featiu.edu.ph/"],
    name: "Feati University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["featiu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.feu.edu.ph/"],
    name: "Far Eastern University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["feu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.foundationu.com/"],
    name: "Foundation University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["foundationu.com"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.hau.edu.ph/"],
    name: "Holy Angel University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["hau.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.holyspirit.edu.ph/"],
    name: "College of the Holy Spirit",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["holyspirit.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.iacademy.ph/"],
    name: "Information and Communications Technology Academy",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["iacademy.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.isu.edu.ph/"],
    name: "Isabela State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["isu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.iubs.co.uk/"],
    name: "Irish University Business School, Cebu",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["iubs.co.uk"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ldcu.edu.ph/"],
    name: "Liceo de Cagayan University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ldcu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.letran.edu/"],
    name: "Colegio de San Juan de Letran",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["letran.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://lnu.evis.net.ph/"],
    name: "Leyte Normal University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["lnu.evis.net.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.lpu.edu.ph/"],
    name: "Lyceum of the Philippines University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["lpu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.lsu-visca.edu.ph/"],
    name: "Leyte State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["lsu-visca.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mcu.edu.ph/"],
    name: "Manila Central University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mcu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mlqu.edu.ph/"],
    name: "Manuel L. Quezon University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mlqu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mmsu.edu.ph/"],
    name: "Mariano Marcos State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mmsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mseuf.edu.ph/"],
    name: "Manuel S. Enverga University Foundation",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mseuf.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.msuiit.edu.ph/"],
    name: "Mindanao State University - Iligan Institute of Technology",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["msuiit.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.msumain.edu.ph/"],
    name: "Mindanao State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["msumain.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mu.fapenet.org/"],
    name: "Misamis University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mu.fapenet.org"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.mvc.edu.ph/"],
    name: "Mountain View College",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["mvc.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ndmu.edu.ph/"],
    name: "Notre Dame of Marbel University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ndmu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ndu.fapenet.org/"],
    name: "Notre Dame University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ndu.fapenet.org"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.neu.edu.ph/"],
    name: "New Era University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["neu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.nu.edu.ph/"],
    name: "National University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["nu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.nulaoag.com/"],
    name: "Northwestern University of the Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["nulaoag.com"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.pcu.edu.ph/"],
    name: "Philippine Christian University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["pcu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.perpetualdalta.edu.ph/"],
    name: "University of Perpetual Help, System Dalta",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["perpetualdalta.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.plm.edu.ph/"],
    name: "University of the City of Manila",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["plm.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.pma.ph/"],
    name: "Philippine Military Academy",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["pma.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.pnumanila.com.ph/"],
    name: "Philippine Normal University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["pnumanila.com.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.psu.edu.ph/"],
    name: "Pangasinan State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["psu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.psu-online.edu.ph/"],
    name: "Palawan State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["psu-online.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.pup.edu.ph/"],
    name: "Polytechnic University of the Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["pup.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.pwu.edu/"],
    name: "Philippine Women's University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["pwu.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.rtu.edu.ph/"],
    name: "Rizal Technological University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["rtu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.sanbeda.edu.ph/"],
    name: "San Beda College",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["sanbeda.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.slc-sflu.edu.ph/"],
    name: "Saint Louis College",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["slc-sflu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.slu.edu.ph/"],
    name: "Saint Louis University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["slu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.smu.edu.ph/"],
    name: "Saint Mary's University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["smu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.spu.edu.ph/"],
    name: "Saint Paul University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["spu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ssu.edu.ph/"],
    name: "Samar State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ssu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.su.edu.ph/"],
    name: "Silliman University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["su.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.swu.edu.ph/"],
    name: "Southwestern University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["swu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.tup.edu.ph/"],
    name: "Technological University of the Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["tup.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ua.edu.ph/"],
    name: "University of the Assumption",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ua.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uap.edu.ph/"],
    name: "University of Asia and the Pacific",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uap.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ubaguio.edu/"],
    name: "University of Baguio",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ubaguio.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ub.edu.ph/"],
    name: "University of Batangas",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ub.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uc-bcf.edu.ph/"],
    name: "University of the Cordilleras",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uc-bcf.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ucv.edu.ph/"],
    name: "University of Cagayan Valley",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ucv.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ue.edu.ph/caloocan/"],
    name: "University of the East, Coloocan",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ue.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ue.edu.ph/manila/"],
    name: "University of the East, Manila",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ue.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uep.educ.ph/"],
    name: "University of Eastern Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uep.educ.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uerm.edu.ph/"],
    name: "University of the East, Ramon Magsaysay Memorial Medical Center",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uerm.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://uic.globe.com.ph/"],
    name: "University of the Immaculate Conception",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uic.globe.com.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ui.phinma.edu.ph/"],
    name: "University of lloilo",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ui.phinma.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.umindanao.edu.ph/"],
    name: "University of Mindanao",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["umindanao.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.unc.edu.ph/"],
    name: "University of Nueva Caceres",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["unc.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.unep.edu.ph/"],
    name: "University of Northeastern Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["unep.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.universityofbohol.com/"],
    name: "University of Bohol",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["universityofbohol.com"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.universityofcebu.edu.ph/"],
    name: "University of Cebu",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["universityofcebu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.univman.edu.ph/"],
    name: "University of Manila",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["univman.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uno-r.edu.ph/"],
    name: "University of Negros Occidental-Recoletos",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uno-r.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.unp.edu.ph/"],
    name: "University of Northern Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["unp.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upang.edu.ph/"],
    name: "University of Pangasinan",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upang.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upb.edu.ph/"],
    name: "University of the Philippines Baguio",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upb.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upd.edu.ph/"],
    name: "University of the Philippines Diliman",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upd.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uphighschoolcebu.edu.ph/"],
    name: "University of the Philippines Visayas - Cebu High School",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uphighschoolcebu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uphr.edu.ph/"],
    name: "University of Perpetual Help",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uphr.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uplb.edu.ph/"],
    name: "University of the Philippines Los Banos",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uplb.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upm.edu.ph/"],
    name: "University of the Philippines Manila",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upm.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upmin.edu.ph/"],
    name: "University of the Philippines Mindanao",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upmin.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upou.org/"],
    name: "University of the Philippines Open University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upou.org"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.upv.edu.ph/"],
    name: "University of the Philippines Visayas",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["upv.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.urc.edu.ph/"],
    name: "University of Regina Carmeli",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["urc.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usa.edu.ph/"],
    name: "University of San Agustin",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usa.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usc.edu.ph/"],
    name: "University of San Carlos",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usc.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usep.edu.ph/"],
    name: "University of Southeastern Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usep.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usjr.edu.ph/"],
    name: "University of San Jose Recoletos",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usjr.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usls.edu/"],
    name: "University of Saint La Salle",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usls.edu"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usm.edu.ph/"],
    name: "University of Southern Mindanao",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usm.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.usp.ph/"],
    name: "University of Southern Philippines Foundation",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["usp.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.ust.edu.ph/"],
    name: "University of Santo Tomas",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["ust.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.uv.edu.ph/"],
    name: "University of the Visayas",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["uv.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.vmuf.edu.ph/"],
    name: "Virgen Milagrosa University Foundation",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["vmuf.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.wesleyan.edu.ph/"],
    name: "Wesleyan University Philippines",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["wesleyan.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.wmsu.edu.ph/"],
    name: "Western Mindanao State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["wmsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.wvsu.edu.ph/"],
    name: "West Visayas State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["wvsu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www2.mozcom.com/~clsu/"],
    name: "Central Luzon State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["www2.mozcom.com"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www2.mozcom.com/~tsu-ics/"],
    name: "Tarlac State University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["www2.mozcom.com"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.xu.edu.ph/"],
    name: "Xavier University",
    alpha_two_code: "PH",
    "state-province": null,
    domains: ["xu.edu.ph"],
    country: "Philippines",
  },
  {
    web_pages: ["http://www.asp.krakow.pl/"],
    name: 'Fine Arts Academy "Jan Matejko" in Cracow',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ae.katowice.pl/"],
    name: "Academy of Economics in Katowice",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ae.katowice.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ae.krakow.pl/"],
    name: "Academy of Economics in Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ae.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ae.poznan.pl/"],
    name: "Academy of Economics in Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ae.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ae.wroc.pl/"],
    name: "Academy of Economics in Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ae.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.agh.edu.pl/"],
    name: "AGH University of Science and Technology",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["agh.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ahe.edu.pl/"],
    name: "Academy of Humanities and Economics in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ahe.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amb.bydgoszcz.pl/"],
    name: "Medical Academy Ludwik Rydygier in Bydgoszcz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amb.bydgoszcz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amb.edu.pl/"],
    name: "Medical Academy in Bialystok",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amb.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amg.gda.pl/"],
    name: "Medical Academy in Gdansk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amg.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.am.katowice.pl/"],
    name: 'Music Academy "Karol Szymanowski" in Katowice',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["am.katowice.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.am.lodz.pl/"],
    name: "Medical Academy in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["am.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.am.lublin.pl/"],
    name: "Medical Academy in Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["am.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amu.edu.pl/"],
    name: "Adam Mickiewicz University of Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amu.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.bydgoszcz.pl/"],
    name: 'Music Academy "Felix Nowowiejski" in Bydgoszcz',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.bydgoszcz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.gda.pl/"],
    name: 'Music Academy "Stanislaw Moniuszko" in Gdansk',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.krakow.pl/"],
    name: "Music Academy in Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.lodz.pl/"],
    name: "Music Academy in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.poznan.pl/"],
    name: 'Music Academy "Ignacy Jana Paderewski" in Poznan',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amuz.wroc.pl/"],
    name: 'Music Academy "Karol Lipinski" in Wroclaw',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amuz.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.amwaw.edu.pl/"],
    name: "Medical Academy in Warszawa",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["amwaw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.am.wroc.pl/"],
    name: "Medical Academy in Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["am.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ap.edu.pl/"],
    name: "Polonia University in Czêstochowa",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ap.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ap.siedlce.pl/"],
    name: "Akademia Podlaska",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ap.siedlce.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ar.krakow.pl/"],
    name: "Agricultural University of Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ar.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ar.lublin.pl/"],
    name: "Agricultural University of Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ar.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ar.szczecin.pl/"],
    name: "Agricultural University of Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ar.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.art.olsztyn.pl/"],
    name: "Agricultural-Technical Academy in Olsztyn",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["art.olsztyn.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ar.wroc.pl/"],
    name: "Agricultural University of Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ar.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.asp.gda.pl/"],
    name: "Fine Arts Academy in Gdansk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.aspkat.edu.pl/"],
    name: "Fine Arts Academy in Katowice",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["aspkat.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.asp.lodz.pl/"],
    name: "Fine Arts Academy Wladyslaw Strzeminski in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.asp.poznan.pl/"],
    name: "Fine Arts Academy in Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.asp.waw.pl/"],
    name: "Fine Arts Academy in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.waw.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.asp.wroc.pl/"],
    name: "Fine Arts Academy in Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["asp.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.at.edu.pl/"],
    name: "Aleksander Zelwerowicz State Theatre Academy",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["at.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.au.poznan.pl/"],
    name: "Agricultural University of Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["au.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.edu.pl/"],
    name: 'Physical Education Academy "Jozef Pilsudski" in Warsaw',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.gda.pl/"],
    name: 'Physical Education Academy "Jedrzej Sniadecki" in Gdansk',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.katowice.pl/"],
    name: "Physical Education Academy in Katowice",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.katowice.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.krakow.pl/"],
    name: "University School of Physical Education",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.poznan.pl/"],
    name: 'Physical Education Academy "Eugeniusz Piasecki" in Poznan',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.awf.wroc.pl/"],
    name: "Physical Education Academy in Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["awf.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.chopin.edu.pl/"],
    name: 'Music Academy "Fryderyk Chopin" in Warszaw',
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["chopin.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.collegium.edu.pl/"],
    name: "Collegium Civitas",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["collegium.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.dswe.wroc.pl/"],
    name: "University of Lower Silesia of the Association for the Advancement of Education in Wroclaw.",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["dswe.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.eas.edu.pl/"],
    name: "European Academy of Arts in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["eas.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.filmowka.lodz.pl/"],
    name: "State Film, Television and Theatre Higher School Leon Schiller in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["filmowka.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.gallus.pl/"],
    name: "Silesian School of Economics and Languages",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["gallus.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.gwsh.pl/"],
    name: "Katowice School of Economics",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["gwsh.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ifg.com.pl/"],
    name: "French Institute of Management",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ifg.com.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ksw.edu.pl/"],
    name: "Andrzej Frycz Modrzewski Cracow College",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ksw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.kul.lublin.pl/"],
    name: "Catholic University of Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["kul.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.lazarski.pl/"],
    name: "Lazarski School of Commerce and Law",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["lazarski.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.man.radom.pl/"],
    name: "Technical University of Radom",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["man.radom.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.nkrriwf.pl/"],
    name: "Teacher Training College of Revalidation, Rehabilitation and Physical Education",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["nkrriwf.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pam.szczecin.pl/"],
    name: "Pomeranian Academy of Medicine in Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pam.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pb.bialystok.pl/"],
    name: "Technical University of Bialystok",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pb.bialystok.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pcz.czest.pl/"],
    name: "Technical University of Czestochowa",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pcz.czest.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pg.gda.pl/"],
    name: "Technical University of Gdansk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pg.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pjwstk.edu.pl/"],
    name: "Polish-Japanese Institute of Information Technology in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pjwstk.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pk.edu.pl/"],
    name: "Technical University of Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pk.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.p.lodz.pl/"],
    name: "Technical University of Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["p.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pol.lublin.pl/"],
    name: "Technical University of Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pol.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.polsl.gliwice.pl/", "http://www.polsl.pl/"],
    name: "Silesian Technical University of Gliwice",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["polsl.gliwice.pl", "polsl.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.po.opole.pl/"],
    name: "Technical University of Opole",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["po.opole.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.prz.rzeszow.pl/"],
    name: "Technical University of Rzeszow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["prz.rzeszow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pu.kielce.pl/"],
    name: "Pedagogical University of Kielce",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pu.kielce.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.puls.edu.pl/"],
    name: "Poznan University of Life Sciences",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["puls.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.put.poznan.pl/"],
    name: "Technical University of Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["put.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pw.edu.pl/"],
    name: "Warsaw University of Technology",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pwr.wroc.pl/"],
    name: "Technical University of Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pwr.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pwst.krakow.pl/"],
    name: "Ludwik Solski State Academy of Theatre in Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pwst.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pwsz.eu/"],
    name: "Walcz College",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pwsz.eu"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pwsz.pila.pl/"],
    name: "Staszic Pila College",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pwsz.pila.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.pz.zgora.pl/"],
    name: "Technical University of Zielona Gora",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["pz.zgora.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.qdnet.pl/ChAT/"],
    name: "Christian Theological Academy in Warszaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["qdnet.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.sggw.waw.pl/"],
    name: "Agricultural University of Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["sggw.waw.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.sgh.waw.pl/"],
    name: "Warsaw School of Economics",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["sgh.waw.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.slam.katowice.pl/"],
    name: "Silesian Academy of Medicine in Katowice",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["slam.katowice.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.swps.edu.pl/"],
    name: "Warsaw School of Social Psychology",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["swps.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.tu.kielce.pl/"],
    name: "Technical University of Kielce",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["tu.kielce.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.tu.koszalin.pl/"],
    name: "Technical University of Koszalin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["tu.koszalin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.tuniv.szczecin.pl/"],
    name: "Technical University of Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["tuniv.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.tyszkiewicz.edu.pl/"],
    name: "Józef Tyszkiewicz College of Business and Computer Science in Bielsko-Biala",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["tyszkiewicz.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.ub.edu.pl/"],
    name: "University of Bialystok",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["ub.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uj.edu.pl/"],
    name: "Jagiellonian University Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uj.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uksw.edu.pl/"],
    name: "Cardinal Stefan Wyszynski University in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uksw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.umcs.lublin.pl/"],
    name: "Maria Curie-Sklodowska University Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["umcs.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["https://www.wsei.lublin.pl/"],
    name: "University of Economics and Innovation Lublin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsei.lublin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uni.lodz.pl/"],
    name: "University of Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uni.lodz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uni.opole.pl/"],
    name: "University of Opole",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uni.opole.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uni.torun.pl/"],
    name: "Nicolaus Copernicus University of Torun",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uni.torun.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.univ.gda.pl/"],
    name: "University of Gdansk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["univ.gda.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.univ.rzeszow.pl/"],
    name: "Pedagogical University of Rzeszow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["univ.rzeszow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.univ.szczecin.pl/"],
    name: "University of Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["univ.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uni.wroc.pl/"],
    name: "University of Wroclaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uni.wroc.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.us.edu.pl/"],
    name: "University of Silesia",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["us.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.usoms.poznan.pl/"],
    name: "Medical Academy Karol Marcinkowski in Poznan",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["usoms.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.utp.edu.pl/"],
    name: "University of Technology and Life Sciences",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["utp.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uw.edu.pl/"],
    name: "University of Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.uwm.edu.pl/"],
    name: "University of Wamia and Masuria in Olsztyn",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["uwm.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wlodkowic.pl/"],
    name: "Pawel Wlodkowic University College in Plock",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wlodkowic.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsb-nlu.edu.pl/"],
    name: "Higher School o Business/National Louis University(WSB/NLU) in Nowy Sacz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsb-nlu.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsb.poznan.pl/"],
    name: "Poznan School of Banking",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsb.poznan.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://wsb.toi.tarnow.pl/"],
    name: "Higher School o Business in Tarnow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsb.toi.tarnow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsfiz.edu.pl/"],
    name: "University of Finance and Management in Bialystok",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsfiz.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsh.edu.pl/"],
    name: "Aleksander Gieysztor School of Humanities in Pultusk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsh.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wship.edu.pl/"],
    name: "Ryszard Lazarski University of Commerce and Law in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wship.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsinf.edu.pl/"],
    name: "College of Computer Science in Lodz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsinf.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsisiz.edu.pl/"],
    name: "Warsaw School of Information Technology",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsisiz.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsiz.rzeszow.pl/"],
    name: "University of Information Technology and Management in Rzeszow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsiz.rzeszow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsm.gdynia.pl/"],
    name: "Gdynia Maritime Academy",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsm.gdynia.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsms.edu.pl/"],
    name: "Academy of International Economic and Political Relations, Gdynia",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsms.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsm.szczecin.pl/"],
    name: "Maritime University in Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsm.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsp.bydgoszcz.pl/"],
    name: "Pedagogical University of Bydgoszcz",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsp.bydgoszcz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsp.czest.pl/"],
    name: "Pedagogical University of Czestochowa",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsp.czest.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wspiz.edu.pl/"],
    name: "Leon Kozminski Academy of Entrepreneurship and Mangement in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wspiz.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsp.krakow.pl/"],
    name: "Pedagogical University of Krakow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsp.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsp.slupsk.pl/"],
    name: "Pedagogical University of Slupsk",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsp.slupsk.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsps.waw.pl/"],
    name: "Maria Grzegorzewska College for Special Education",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsps.waw.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsptwpwaw.edu.pl/"],
    name: "Pedagogical University of the Polish Association for Adult Education in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsptwpwaw.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsp.zgora.pl/"],
    name: "Pedagogical University of Zielona Gora",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsp.zgora.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsub.waw.pl/"],
    name: "University of Insurance and Banking in Warsaw",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsub.waw.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wszib.krakow.pl/"],
    name: "School of Banking and Management in Cracow",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wszib.krakow.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wszim.edu.pl/"],
    name: "University of Management and Marketing",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wszim.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsz.pl/"],
    name: "Gdansk Management College",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsz.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.wsz-pou.edu.pl/"],
    name: "Polish Open University in Warsaw (WSZ/POU)",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["wsz-pou.edu.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.zpsb.szczecin.pl/"],
    name: "West Pomeranian Business School in Szczecin",
    alpha_two_code: "PL",
    "state-province": null,
    domains: ["zpsb.szczecin.pl"],
    country: "Poland",
  },
  {
    web_pages: ["http://www.cocite.pt/"],
    name: "Instituto Superior de Informática e Gestão",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["cocite.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.enautica.pt/"],
    name: "Escola Nautica Infante D. Henrique",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["enautica.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.esad.pt/"],
    name: "Escola Superior de Artes e Design",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["esad.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.eshte.pt/"],
    name: "Escola Superior de Hotelaria e Turismo do Estoril",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["eshte.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.europeanuniversity.pt/"],
    name: "European University Portugal",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["europeanuniversity.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.iade.pt/"],
    name: "Instituto de Artes Visuais, Design e Marketing - IADE",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["iade.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.inp.pt/"],
    name: "Instituto Superior Novas Profissões - INP",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["inp.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.inuaf-studia.pt/"],
    name: "Instituto Superior D. Afonso III - INUAF",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["inuaf-studia.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipbeja.pt/"],
    name: "Instituto Politécnico de Beja",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipbeja.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipb.pt/"],
    name: "Instituto Politécnico de Bragança",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipb.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipca.pt/"],
    name: "Instituto Politécnico do Cávado e do Ave",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipca.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipcb.pt/"],
    name: "Instituto Politécnico de Castelo Branco",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipcb.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipc.pt/"],
    name: "Instituto Politécnico de Coimbra",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipc.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipg.pt/"],
    name: "Instituto Politécnico da Guarda",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipg.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipiaget.org/"],
    name: "Instituto Piaget",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipiaget.org"],
    country: "Portugal",
  },
  {
    web_pages: ["https://www.ipleiria.pt/"],
    name: "Instituto Politécnico de Leiria",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipleiria.pt", "my.ipleiria.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipl.pt/"],
    name: "Instituto Politécnico de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipl.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipportalegre.pt/"],
    name: "Instituto Politécnico de Portalegre",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipportalegre.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipp.pt/"],
    name: "Instituto Politecnico do Porto",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipp.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipsantarem.pt/"],
    name: "Instituto Politécnico de Santarém",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipsantarem.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ips.pt/"],
    name: "Instituto Politécnico de Setúbal",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ips.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipt.pt/"],
    name: "Instituto Politécnico de Tomar",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipt.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ipvc.pt/"],
    name: "Instituto Politécnico de Viana do Castelo",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ipvc.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isai.pt/"],
    name: "Instituto Superior de Assistentes e Intérpretes",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isai.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isave.edu.pt/"],
    name: "Instituto Superior de Saúde do Alto Ave",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isave.edu.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isbb.pt/"],
    name: "Instituto Superior Bissaya Barreto",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isbb.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.iscet.pt/"],
    name: "Instituto Superior de Ciências Empresariais e de Turismo",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["iscet.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.iscte-iul.pt/"],
    name: "ISCTE - Instituto Universitário de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["iscte.pt", "iscte-iul.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isg.pt/"],
    name: "Instituto Superior de Gestão - ISG",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isg.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isla.pt/"],
    name: "Instituto Superior de Línguas e Administração",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isla.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ispab.pt/"],
    name: "Instituto Superior de Paços de Brandão",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ispab.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ispa.pt/"],
    name: "Instituto Superior de Psicologia Aplicada",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ispa.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ispgaya.pt/"],
    name: "Instituto Superior Politécnico Gaya",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ispgaya.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.istec.pt/"],
    name: "Instituto Superior de Tecnologias Avançadas - ISTEC",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["istec.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.istp.pt/"],
    name: "Instituto Superior de Transportes e Comunicações",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["istp.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.isvouga.com/"],
    name: "Instituto Superior de Entre Douro e Vouga",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["isvouga.com"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.oml.pt/anso/"],
    name: "Academia Nacional Superior de Orquesta",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["oml.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.pedago.pt/isce.htm"],
    name: "Instituto Superior de Ciências Educativas",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["pedago.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uac.pt/"],
    name: "Universidade dos Acores",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uac.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ualg.pt/"],
    name: "Universidade do Algarve",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ualg.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ua.pt/"],
    name: "Universidade de Aveiro",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ua.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uatla.pt/"],
    name: "Universidade Atlântica",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uatla.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ubi.pt/"],
    name: "Universidade da Beira Interior",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ubi.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ucp.pt/"],
    name: "Universidade Catolica Portuguesa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ucp.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uc.pt/"],
    name: "Universidade de Coimbra",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uc.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uevora.pt/"],
    name: "Universidade de Evora",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uevora.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ufp.pt/"],
    name: "Universidade Fernando Pessoa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ufp.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uinternacional.pt/"],
    name: "Universidade Internacional Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uinternacional.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ul.pt/"],
    name: "Universidade de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ul.pt", "campus.ul.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ulusiada.pt/"],
    name: "Universidade Lusiada",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ulusiada.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.ulusofona.pt/"],
    name: "Universidade Lusófona de Humanidades e Technologias",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["ulusofona.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uma.pt/"],
    name: "Universidade da Madeira",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uma.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uminho.pt/"],
    name: "Universidade do Minho",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uminho.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.umoderna.pt/"],
    name: "Universidade Moderna de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["umoderna.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uni.pt/"],
    name: "Universidade Independente",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uni.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.univ-ab.pt/"],
    name: "Universidade Aberta Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["univ-ab.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.universidade-autonoma.pt/"],
    name: "Universidade Autónoma de Lisboa Luís de Camoes",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["universidade-autonoma.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.unl.pt/"],
    name: "Universidade Nova de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["unl.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.uportu.pt/"],
    name: "Universidade Portucalense Infante D. Henrique",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["uportu.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.up.pt/"],
    name: "Universidade do Porto",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["up.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.utad.pt/"],
    name: "Universidade de Tras-os-Montes e Alto Douro",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["utad.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.utl.pt/"],
    name: "Universidade Tecnica de Lisboa",
    alpha_two_code: "PT",
    "state-province": null,
    domains: ["utl.pt"],
    country: "Portugal",
  },
  {
    web_pages: ["http://www.bayamon.inter.edu/"],
    name: "Universidad Interamericana de Puerto Rico, Bayamón",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["bayamon.inter.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.caribbean.edu/"],
    name: "Caribbean University",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["caribbean.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.cayey.upr.edu/"],
    name: "Universidad de Puerto Rico, Cayey",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["cayey.upr.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.ceaprc.org/"],
    name: "Centro de Estudios Avanzados de Puerto Rico y el Caribe",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["ceaprc.org"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://cuhwww.upr.clu.edu/"],
    name: "Universidad de Puerto Rico, Humacao",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["cuhupr.clu.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.inter.edu/"],
    name: "Universidad Interamericana de Puerto Rico",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["inter.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.pucpr.edu/"],
    name: "Pontificia Universidad Catolica de Puerto Rico",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["pucpr.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.rcm.upr.edu/"],
    name: "Universidad de Puerto Rico, Ciencias Medicas",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["rcm.upr.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.sagrado.edu/"],
    name: "Universidad del Sagrado Corazon",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["sagrado.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.sanjuanbautista.edu/"],
    name: "San Juan Bautista School of Medicine",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["sanjuanbautista.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.sg.inter.edu/"],
    name: "Universidad Interamericana de Puerto Rico, San Germán",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["sg.inter.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.suagm.edu/"],
    name: "Sistema Universitario Ana G. Méndez",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["suagm.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.suagm.edu/suagm/umet/"],
    name: "Universidad Metropolitana",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["suagm.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.ucb.edu.pr/"],
    name: "Universidad Central de Bayamón",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["ucb.edu.pr"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uccaribe.edu/"],
    name: "Universidad Central del Caribe",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uccaribe.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.upra.edu/"],
    name: "Universidad de Puerto Rico, Arecibo",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["upra.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprag.edu/"],
    name: "Universidad de Puerto Rico, Aguadilla",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprag.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprb.edu/"],
    name: "Universidad de Puerto Rico, Bayamon",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprb.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprc.edu/"],
    name: "Universidad de Puerto Rico, Carolina",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprc.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.upr.clu.edu/"],
    name: "Universidad de Puerto Rico",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["upr.clu.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprm.edu/"],
    name: "Universidad de Puerto Rico, Mayaguez",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprm.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://upr-ponce.upr.edu/"],
    name: "Universidad de Puerto Rico, Ponce",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["upr-ponce.upr.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprrp.edu/"],
    name: "Universidad de Puerto Rico, Rio Pedras",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprrp.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.uprutuado.edu/"],
    name: "Universidad de Puerto Rico, Utuado",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["uprutuado.edu"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.ut.pr/"],
    name: "Universidad del Turabo",
    alpha_two_code: "PR",
    "state-province": null,
    domains: ["ut.pr"],
    country: "Puerto Rico",
  },
  {
    web_pages: ["http://www.qatar.northwestern.edu/"],
    name: "Northwestern University In Qatar",
    alpha_two_code: "QA",
    "state-province": null,
    domains: ["qatar.northwestern.edu"],
    country: "Qatar",
  },
  {
    web_pages: ["http://www.qu.edu.qa/"],
    name: "University of Qatar",
    alpha_two_code: "QA",
    "state-province": null,
    domains: ["qu.edu.qa"],
    country: "Qatar",
  },
  {
    web_pages: ["http://www.univ-reunion.fr/"],
    name: "Université de la Reunion",
    alpha_two_code: "RE",
    "state-province": null,
    domains: ["univ-reunion.fr"],
    country: "Réunion",
  },
  {
    web_pages: ["http://www.aistedaab.ro/"],
    name: "AISTEDA",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["aistedaab.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.amgd.eu/"],
    name: 'Academy of Music "Georghe Dima" Cluj-Napoca',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["amgd.eu"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.anefs-edu.ro/"],
    name: "National Academy for Physical Education and Sports Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["anefs-edu.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.arteiasi.ro/"],
    name: 'Academy of Arts "George Enescu" Iasi',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["arteiasi.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ase.ro/"],
    name: "Academia de Studii Economice din Bucuresti",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ase.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.central.ucv.ro/"],
    name: "University of Craiova",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["central.ucv.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.emanuel.ro/"],
    name: "Emanuel University",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["emanuel.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.iaim.ro/"],
    name: 'Institute of Architecture "Ion Mincu" Bucharest',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["iaim.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.mta.ro/"],
    name: "Academia Tehnica Militara",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["mta.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.oradeauniversity.com/"],
    name: "University of Medicine and Pharmacology of Oradea",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["oradeauniversity.com"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.oradeauniversity.com"],
    name: "Oradea University",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["oradeauniversity.co"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ovidunivconstanta-edu.org/"],
    name: "University of Constanta Medical School",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ovidunivconstanta-edu.org"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.pub.ro/"],
    name: "University Politehnica of Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["pub.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.rau.ro/"],
    name: "Romanian-American University",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["rau.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.sibiu.ro/"],
    name: "University of Sibiu",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["sibiu.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.snspa.ro/"],
    name: "National School of Political and Administrative Studies Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["snspa.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.spiruharet.ro/"],
    name: "Spiru Haret University",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["spiruharet.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.tuiasi.ro/"],
    name: "Technical University of Iasi",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["tuiasi.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uab.ro/"],
    name: "1 December University of Alba Iulia",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uab.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uaic.ro/"],
    name: "University of Iasi",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uaic.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uartdcluj.ro/"],
    name: "University of Art and Design Cluj-Napoca",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uartdcluj.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uat.ro/"],
    name: "Targu-Mures University of Theatre",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uat.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uav.ro/"],
    name: 'University "Aurel Vlaicu" Arad',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uav.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ubbcluj.ro/"],
    name: "Babes-Bolyai University of Cluj-Napoca",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ubbcluj.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ubm.ro/"],
    name: "North University of Baia Mare",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ubm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ub.ro/"],
    name: "University of Bacau",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ub.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uem.ro/"],
    name: "University of Resita",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uem.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ugal.ro/"],
    name: "University of Galatzi",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ugal.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.ulbsibiu.ro/"],
    name: "University Lucian Blaga of Sibiu",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["ulbsibiu.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.umfcluj.ro/"],
    name: "University of Medicine and Pharmacy of Cluj-Napoca",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["umfcluj.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.umfiasi.ro/"],
    name: "University of Medicine and Pharmacy of Iasi",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["umfiasi.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.umftgm.ro/"],
    name: "University of Medicine and Pharmacy of Targu Mures",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["umftgm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.umft.ro/"],
    name: "University of Medicine and Pharmacy of Timisoara",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["umft.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.unarte.ro/"],
    name: "National University of Arts",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["unarte.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.unatc.ro/"],
    name: "National University of Theater and Film Arts",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["unatc.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.unibuc.ro/"],
    name: "University of Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["unibuc.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.unitbv.ro/"],
    name: 'University "Transilvany" of Brasov',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["unitbv.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.univagro-iasi.ro/"],
    name: "University of Agriculture and Veterinary Medicine Iasi",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["univagro-iasi.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.univcb.ro/"],
    name: "Constantin Brancoveanu University Pitesti",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["univcb.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.univermed-cdgm.ro/"],
    name: "University of Medicine and Pharmacy of Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["univermed-cdgm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.universitateamaritima.ro/"],
    name: "Maritime University Constanta",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["universitateamaritima.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.univ-ovidius.ro/"],
    name: "University of Constanta",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["univ-ovidius.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.unmb.ro/"],
    name: "National University of Music",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["unmb.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uoradea.ro/"],
    name: "University of Oradea",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uoradea.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.upa.ro/"],
    name: 'University "Petre Andrei" Iasi',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["upa.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.upet.ro/"],
    name: "University of Petrosani",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["upet.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.upg-ploiesti.ro/"],
    name: "University Oil- Gas Ploiesti",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["upg-ploiesti.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.upit.ro/"],
    name: "University of Pitesti",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["upit.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.upm.ro/"],
    name: "Petru Maior University of Targu Mures",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["upm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.usab.ro/"],
    name: "University of Agriculture and Veterinary Medicine Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["usab.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.usab-tm.ro/"],
    name: "Banat's University of Agricultural Sciences",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["usab-tm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.usab-tm.ro/"],
    name: "University of Agriculture and Veterinary Medicine Timisoara",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["usab-tm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.usamvcluj.ro/"],
    name: "University of Agriculture and Veterinary Medicine Cluj-Napoca",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["usamvcluj.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.usv.ro/"],
    name: "University of Suceava",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["usv.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.utcb.ro/"],
    name: "Technical University of Civil Engineering Bucharest",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["utcb.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.utcluj.ro/"],
    name: "Technical University of Cluj-Napoca",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["utcluj.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.utgjiu.ro/"],
    name: "University of Targu Jiu",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["utgjiu.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.utm.ro/"],
    name: 'University "Titu Maiorescu"',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["utm.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.utt.ro/"],
    name: "Technical University of Timisoara",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["utt.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uvt.ro/"],
    name: "West University of Timisoara",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uvt.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.uvvg.ro/"],
    name: 'Universitatea de Vest "Vasile Goldi&#351;"',
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["uvvg.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.valahia.ro/"],
    name: "Valahia University of Targoviste",
    alpha_two_code: "RO",
    "state-province": null,
    domains: ["valahia.ro"],
    country: "Romania",
  },
  {
    web_pages: ["http://www.academiaga.ru/"],
    name: "St. Petersburg State University of Civil Aviation",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["academiaga.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.adygnet.ru/"],
    name: "Adygeja State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["adygnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ael.ru/"],
    name: "Khabarovsk State Academy of Economics and Law",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ael.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://agma.astranet.ru/"],
    name: "Astrahan State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["agma.astranet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.agtu.ru/"],
    name: "Arhangelsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["agtu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ame.ru/"],
    name: "Academy of Management and Entrepreneurship",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ame.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.amursu.ru/"],
    name: "Amur State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["amursu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.aqua.sci-nnov.ru/"],
    name: "Volga State Academy of Water Transport",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["aqua.sci-nnov.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://artacademy.spb.ru/"],
    name: "St. Petersburg Repin State Academic Institute of Painting Sculpture and Achitecture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["artacademy.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.asmu.ru/"],
    name: "Altai State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["asmu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.aspu.ru/"],
    name: "Astrakhan State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["aspu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.astu.org/"],
    name: "Astrahan State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["astu.org"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.astu.secna.ru/"],
    name: "Altai State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["astu.secna.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.asu.ru/"],
    name: "Altai State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["asu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.avtlg.ru/~vlgmed/"],
    name: "Volgograd Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["avtlg.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/vuz/bgau_e.htm"],
    name: "Bashkir State Agrarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/vuz/bgmu_e.htm"],
    name: "Bashkir State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/"],
    name: "Bashkir State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/vuz/birskgpi_e.htm"],
    name: "Birsk State Pedagogical Institute",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/vuz/sgpi_e.htm"],
    name: "Sterlitamak State Pedagogical Institute",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bashedu.ru/vuz/ugii_e.htm"],
    name: "Ufa State Institute of Arts",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bashedu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bigpi.biysk.ru/wwwsite/"],
    name: "Biysk State Padagogical University after V.M. Shukshin",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bigpi.biysk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bmstu.ru/"],
    name: "Bauman Moscow State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bmstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.brstu.ru/"],
    name: "Bratsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["brstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bsaa.ru/"],
    name: "Belgorod State Agricultural Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bsaa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bspu.ru/"],
    name: "Bashkir State Pedagogical University named After M. Akmullah",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bspu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bstu.ru/"],
    name: "Belgorod State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bsu.burnet.ru/"],
    name: "Burjat State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bsu.burnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.bsu.edu.ru/"],
    name: "Belgorod State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["bsu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["https://mosgu.ru/en/"],
    name: "Moscow External University of the Humanities",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mosgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.chuvsu.ru/"],
    name: "Chuvash State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["chuvsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://cit.drbit.com.ru/"],
    name: "Novosibirsk State Academy of Economics and Mangement",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["cit.drbit.com.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.conservatoire.ru/"],
    name: "Novosibirsk State Music Academy M. Glinka",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["conservatoire.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.conservatory.ru/"],
    name: "St. Petersburg State Conservatory",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["conservatory.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://cspi.urc.ac.ru/"],
    name: "Cheljabinsk State Institute of Teacher Training",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["cspi.urc.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.csu.ac.ru/"],
    name: "Cheljabinsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["csu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.dgu.ru/"],
    name: "Dagestan State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["dgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.dongau.ru/"],
    name: "Don State Agrarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["dongau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.dstu.edu.ru/"],
    name: "Don State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["dstu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.dvgups.ru/"],
    name: "Far East State Transport University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["dvgups.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.dvgu.ru/"],
    name: "Far Eastern State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["dvgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://education.ivanovo.ru:8101/IGTA/"],
    name: "Ivanovo State Textile Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["education.ivanovo.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.elsu.ru/"],
    name: "Yelets State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["elsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.eltech.ru/"],
    name: "St. Petersburg State Electrotechnical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["eltech.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.engec.ru/"],
    name: "St. Petersburg State Academy for Engineering Economics (ENGECON)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["engec.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.engec.ru/"],
    name: "St. Petersburg State University of Engineering and Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["engec.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.esstu.ru/"],
    name: "East-Siberian State University of Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["esstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.eu.spb.ru/"],
    name: "European University at St.Petersburg",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["eu.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.fa.ru/"],
    name: "Finance Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["fa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.festu.ru/"],
    name: "Far Eastern State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["festu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://filine.centro.ru/Gorky/"],
    name: "Maxim Gorky Institute of Literature",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["filine.centro.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ftacademy.ru/"],
    name: "St. Petersburg State Forest-Technical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ftacademy.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gasu.ru/"],
    name: "Gorno-Altaisk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gasu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gitis.net/"],
    name: "Russian Academy of Theatre Arts",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gitis.net"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gma.ru/"],
    name: "State Maritine Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gnesin-academy.ru/"],
    name: "Gnesins Russian Academy of Music",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gnesin-academy.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gorny-ins.ru/"],
    name: "St. Petersburg State Mountain Institut",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gorny-ins.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gpma.ru/"],
    name: "St. Petersburg State Pediatric Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gpma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gti.spb.ru/"],
    name: "St. Petersburg State Institute of Technology (Technological University)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gti.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gturp.spb.ru/"],
    name: "St. Petersburg State Technological University of Plant Polymers",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gturp.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gubkin.ru/"],
    name: "Gubkin Russian State University of Oil and Gas",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gubkin.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.gukit.ru/"],
    name: "St. Petersburg State Cinema and TV University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["gukit.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.guu.ru/"],
    name: "State University of Management",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["guu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.herzen.spb.ru/"],
    name: "Herzen State Pedagogical University of Russia",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["herzen.edu.ru", "herzen.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.hse.ru/"],
    name: "Higher School of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["hse.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.iate.obninsk.ru/"],
    name: "Obninsk State Technical University for Nuclear Power Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["iate.obninsk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ibch.ru/"],
    name: "Shemyakin–Ovchinnikov Institute of bioorganic chemistry RAS",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ibch.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ibi.spb.ru/"],
    name: "International Banking Institute, St. Petersburg",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ibi.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ibp-moscow.ru/"],
    name: "Institute of Business and Politics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ibp-moscow.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ieeu.udm.ru/"],
    name: "International East-European University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ieeu.udm.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.iet.ru/"],
    name: "Institute for the Economy in Transition",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["iet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ifmo.ru/", "https://itmo.ru/"],
    name: "ITMO University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ifmo.ru", "itmo.ru", "niuitmo.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ime.ru/"],
    name: "Institute of Management and Economy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ime.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.intstudy.mai.ru/"],
    name: "State University of Aerospace Technologies",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["intstudy.mai.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.isea.irk.ru/"],
    name: "Irkutsk State Academy of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["isea.irk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.isea.ru/"],
    name: "Baikal National University of Economics and Law",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["isea.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://isma.indi.ru/"],
    name: "Ivanovo State Academy of Medicine",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["isma.indi.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ispu.ru/"],
    name: "Ivanovo State Power University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ispu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.istu.irk.ru/"],
    name: "Irkutsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["istu.irk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.istu.ru/"],
    name: "Izhevsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["istu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.isuct.ru/"],
    name: "Ivanovo State University of Chemistry and Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["isuct.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.isu.ru/"],
    name: "Irkutsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["isu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.iubnt.yar.ru/"],
    name: "Yaroslavl International University of Business and New Technologies",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["iubnt.yar.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.iufs.edu/"],
    name: "International University of Fundamental Studies, St. Petersburg",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["iufs.edu"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ivanovo.ac.ru/"],
    name: "Ivanovo State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ivanovo.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.jum.ru/"],
    name: "Jewish University in Moscow",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["jum.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kai.ru/"],
    name: "Kazan State University of Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kai.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kalmsu.ru/"],
    name: "Kalmyk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kalmsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kamgu.ru/"],
    name: "Kamchatka State University Vitus Bering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kamgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kantiana.ru/"],
    name: "Immanuel Kant State University of Russia",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kantiana.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.karelia.ru/psu/"],
    name: "Petrozavodsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["karelia.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kazanconservatory.ru/"],
    name: "Kazan State Music Conservatory",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kazanconservatory.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kbsu.ru/"],
    name: "Kabardino-Balkarian State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kbsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kemsu.ru/"],
    name: "Kemerovo State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kemsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kgmu.kcn.ru/"],
    name: "Kazan State University of Medicine",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kgmu.kcn.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kgpu.ru/"],
    name: "Kazan State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kgpu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kgtu.runnet.ru/"],
    name: "Krasnoyarsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kgtu.runnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.khspu.ru/"],
    name: "Far Easten State University of Humanities",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["khspu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.khstu.ru/"],
    name: "Khabarovsk State University of Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["khstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kirovballet.com/vaganova.html"],
    name: "Vaganova Academy of Russian Ballet",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kirovballet.com"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kiu.ru/"],
    name: "Kurgan International University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kiu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.klgtu.ru/"],
    name: "Kaliningrad State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["klgtu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.knastu.ru/"],
    name: "Komsomolsk-on-Amur State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["knastu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ksaba.ru/"],
    name: "Kazan State Academy of Architecture and Civil Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ksaba.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ksfei.ru/"],
    name: "Kazan State Finance and Economics Institute",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ksfei.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ksmu.kursknet.ru/"],
    name: "Kursk State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ksmu.kursknet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://kspu.kaluga.ru/"],
    name: "Kaluga State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kspu.kaluga.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://kspu.ptz.ru/"],
    name: "Karelian State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kspu.ptz.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kstu.edu.ru/"],
    name: "Kostroma State Technological University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kstu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kstu.kursk.ru/"],
    name: "Kursk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kstu.kursk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ksu.ru/"],
    name: "Kazan State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ksu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kubagro.ru/"],
    name: "Kuban State University of Agriculture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kubagro.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kubstu.ru/"],
    name: "Kuban State University of Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kubstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kubsu.ru/"],
    name: "Kuban State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kubsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kursk-uni.ru/"],
    name: "Kursk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kursk-uni.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.kuzstu.ac.ru/"],
    name: "Kuzbass State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["kuzstu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.lunn.sci-nnov.ru/"],
    name: "Linguistic University of Nizhny Novgorod",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["lunn.sci-nnov.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.madi.ru/"],
    name: "Moscow State Automobile and Road Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["madi.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://margu.mari.ru/"],
    name: "Marij State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["margu.mari.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.marstu.mari.ru/"],
    name: "Marij State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["marstu.mari.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.masu.ru/"],
    name: "Magnitogorsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["masu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mechnik.spb.ru/"],
    name: "St. Petersburg State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mechnik.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.medin.nsc.ru/"],
    name: "Novosibirsk State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["medin.nsc.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.med.sgu.ru/"],
    name: "Saratov State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["med.sgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mesi.ru/"],
    name: "Moscow State University of Economics, Statistics and Informatics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mesi.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mgavm.ru/"],
    name: "Skrjabin Moscow State Academy of Veterinary Medicine and Biotechnology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mgavm.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mgimo.ru/"],
    name: "Moscow State Institute of International Relations MFA Russia (MGIMO-University)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mgimo.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mgri-rggru.ru/"],
    name: "Russian State Geological Prospecting University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mgri-rggru.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://mgsu.norna.ru/"],
    name: "Moscow State University of Civil Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mgsu.norna.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mgul.ac.ru/"],
    name: "Moscow State University of Forestry Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mgul.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.miet.ru/"],
    name: "National Research University of Electronic Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["miet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.miigaik.ru/"],
    name: "Moscow State University of Geodesy and Cartography",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["miigaik.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.miit.ru/"],
    name: "Moscow State University of Railway Transport",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["miit.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://miom.org/"],
    name: "Modern Institute of Managament",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["miom.org"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mipt.ru/", "http://www.phystech.edu/"],
    name: "Moscow Institute of Physics and Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mipt.ru", "phystech.edu"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mirbis.ru/"],
    name: "Moscow International Higher Business School (MIRBIS)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mirbis.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mirea.ru/"],
    name: "Moscow State Institute of Radiotechnics, Electronics and Automation (Technical University)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mirea.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.misis.ru/"],
    name: "Moscow State Institute of Steel and Alloys",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["misis.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.miu.ru/"],
    name: "International University of Engineering, Moscow",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["miu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mma.ru/"],
    name: "I.M. Sechenov Moscow Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mosconsv.ru/"],
    name: "Moscow P. I. Tchaikovsky Conservatory",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mosconsv.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mpei.ac.ru/"],
    name: "Moscow Power Engineering Institute (Technical University)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mpei.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mrsu.ru/"],
    name: "Mordovian State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mrsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msaab.ru/"],
    name: "Moscow State Academy of Applied Biotechnology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msaab.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msiu.ru/"],
    name: "Moscow State Industrial University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msiu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msta.ac.ru/"],
    name: "Moscow State Textile University A.N. Kosygin",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msta.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mstuca.ru/"],
    name: "Moscow State Technical University of Civil Aviation",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mstuca.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mstu.edu.ru/"],
    name: "Murmansk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mstu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msuc.edu.ru/"],
    name: "Moscow State University of Culture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msuc.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msuee.ru/"],
    name: "Moscow State University of Environmental Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msuee.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.msuie.ru/"],
    name: "Moscow State University of Ecological Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msuie.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["https://www.msu.ru/"],
    name: "Lomonosov Moscow State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["msu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.mtuci.ru/"],
    name: "Moscow Technical University of Informatics and Communication",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["mtuci.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.muctr.edu.ru/"],
    name: "Mendeleev Russian University of Chemical Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["muctr.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.muh.ru/"],
    name: "Modern University for the Humanities",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["muh.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nayanova.edu/"],
    name: "Nayanova University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nayanova.edu"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ncstu.ru/"],
    name: "Stavropol State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ncstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.neic.nsk.su/"],
    name: "Siberian State University of Telecommunications and Informatics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["neic.nsk.su"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nes.ru/"],
    name: "New Economic School",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nes.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ngasu.sci-nnov.ru/"],
    name: "Nizhny Novgorod State Architectural - Building University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ngasu.sci-nnov.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nilc.spb.ru/"],
    name: "Nevsky Institute of Language and Culture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nilc.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.n-nov.mednet.com/"],
    name: "Nizhny Novgorod State Academy of Medicine",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["n-nov.mednet.com"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nntu.sci-nnov.ru/"],
    name: "Nizhny Novgorod State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nntu.sci-nnov.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nosu.ru/"],
    name: "North Ossetian State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nosu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.novsu.ac.ru/"],
    name: "Novgorod State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["novsu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nsau.edu.ru/"],
    name: "Novosibirsk State Agricultural University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nsau.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nsmu.ru/"],
    name: "Northern State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nsmu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nstu.ru/"],
    name: "Novosibirsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nsu.ru/"],
    name: "Novosibirsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nsu.ru", "g.nsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.nwpi.ru/"],
    name: "North-West State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["nwpi.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.omgau.ru/"],
    name: "Omsk State Agrarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["omgau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.omgtu.ru/"],
    name: "Omsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["omgtu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.omgups.ru/"],
    name: "Omsk State Transport University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["omgups.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.omsk.edu/"],
    name: "Omsk State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["omsk.edu"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.omsk-osma.ru/"],
    name: "Omsk State Medicical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["omsk-osma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.orun.ru/"],
    name: "Oriental University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["orun.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.osu.ru/"],
    name: "Orenburg State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["osu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pfu.edu.ru/"],
    name: "People' s Friendship University of Russia",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pfu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pglu.ru/"],
    name: "Pjatigorsk State Linguistic University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pglu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pnzgu.ru/"],
    name: "Penza State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pnzgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pomorsu.ru/"],
    name: "Pomorsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pomorsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pomorsu.ru/"],
    name: "Pomor State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pomorsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.psfa.ru/"],
    name: "Perm State Pharmaceutical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["psfa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.psma.ru/"],
    name: "Perm State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["psma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pspu.ac.ru/"],
    name: "Perm State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pspu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pstu.ac.ru/"],
    name: "Perm State Academy of Agriculture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pstu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.pstu.ac.ru/"],
    name: "Perm State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["pstu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.psu.ru/"],
    name: "Perm State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["psu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rah.ru/"],
    name: "Russian Academy of Arts",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rah.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rea.ru/"],
    name: "Plekhanov Russian Academy of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rea.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rgata.yaroslavl.ru/"],
    name: "Rybinsk State Academy of Aviational Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rgata.yaroslavl.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rshu.ru/"],
    name: "Russian State Hydrometeorological University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rshu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rsmu.da.ru/"],
    name: "Rostov State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rsmu.da.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rsmu.ru/"],
    name: "Russian State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rsmu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rsuh.ru/"],
    name: "Russian State University for the Humanities",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rsuh.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rsu.ru/"],
    name: "Rostov State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rsute.ru/"],
    name: "Moscow State University of Commerce",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rsute.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.rusoil.net/"],
    name: "Ufa State Petroleum Technological University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["rusoil.net"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sakhgu.sakhalin.ru/"],
    name: "Sakhalin State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sakhgu.sakhalin.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.samiit.ru/"],
    name: "Samara State Academy for Railway Transportation",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["samiit.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.samsmu.ru/"],
    name: "Samara State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["samsmu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sapanet.ru/"],
    name: "Siberian Academy of Public Services",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sapanet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sgap.ru/"],
    name: "Saratov State Academy of Law",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sgap.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sgau.ru/"],
    name: "Saratov State Agrarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sgau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sgma.info/"],
    name: "Smolensk State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sgma.info"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sgu.ru/"],
    name: "Saratov State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sgu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://shu.smolensk.su/"],
    name: "Smolensk Humanitarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["shu.smolensk.su"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://sibsiu.kemerovo.su/"],
    name: "Siberian State Industrial University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sibsiu.kemerovo.su"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.smolny-un.spb.ru/"],
    name: "Smolny University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["smolny-un.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.smtu.ru/"],
    name: "St. Petersburg State Marine Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["smtu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbau.ru/"],
    name: "Academic University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbgasu.ru/"],
    name: "St. Petersburg State University of Architecture and Civil Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbgasu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbgau.spb.ru/"],
    name: "St. Petersburg State Agrarian University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbgau.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbguki.ru/"],
    name: "St. Petersburg State University of Culture and Arts",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbguki.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbiir.ru/"],
    name: "St. Petersburg Institute of Arts and Restoration",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbiir.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbstu.ru/"],
    name: "St. Petersburg State Polytechnical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbtei.ru/"],
    name: "St. Petersburg Institute of Sales Management and Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbtei.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbu.ru/"],
    name: "St. Petersburg State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spbuwc.ru/"],
    name: "St. Petersburg State University of Waterway Communications",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spbuwc.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spcpa.ru/"],
    name: "St. Petersburg State Chemical Pharmaceutical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spcpa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spmi.edu.ru/"],
    name: "St. Petersburg State Mining Institute (Technical University)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spmi.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.spsmma.com/"],
    name: "St. Petersburg StateMechnikov  Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["spsmma.com"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssaa.ru/"],
    name: "Samara State Agricultural Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssaa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssaba.smr.ru/"],
    name: "Samara State Academy of Architecture and Civil Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssaba.smr.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssau.ru/"],
    name: "Samara State Aerospace University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssea.runnet.ru/"],
    name: "Saratov State Socio-Economic University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssea.runnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sseu.ru/"],
    name: "Samara State University of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sseu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssmu.ru/"],
    name: "Siberian State Medical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssmu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssttu.samara.ru/"],
    name: "Samara State University of Teacher Training",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssttu.samara.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sstu-edu.ru/"],
    name: "Saratov State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sstu-edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sstu.samara.ru/"],
    name: "Samara State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sstu.samara.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://ssu.komi.com:8101/"],
    name: "Syktyvkar State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssu.komi.com"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ssu.samara.ru/"],
    name: "Samara State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ssu.samara.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.stankin.ru/"],
    name: "Moscow State University of Technology (Stankin)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["stankin.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.stavsu.ru/"],
    name: "Stavropol State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["stavsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.stu.lipetsk.ru/"],
    name: "Lipeck State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["stu.lipetsk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.stu.ru/"],
    name: "Siberian State Transport University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["stu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.suai.ru/"],
    name: "St. Petersburg State University of Aerospace Instrumentation",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["suai.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.surgu.wsnet.ru/"],
    name: "Surgut State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["surgu.wsnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sutd.ru/"],
    name: "St. Petersburg State University of Technology and Design",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sutd.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.sut.ru/"],
    name: "St. Petersburg State University of Telecommunication",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["sut.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tart.spb.ru/"],
    name: "St. Petersburg State Theatre Arts Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tart.spb.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tgpi.ttn.ru/"],
    name: "Taganrog State Pedagogical Institute",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tgpi.ttn.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tgsha.ru/"],
    name: "Tyumen State Agricultural Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tgsha.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.theatrins-yar.ru/"],
    name: "Yaroslavl State Theatre Institute",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["theatrins-yar.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.timacad.ru/"],
    name: "Timirjazev Moscow Academy of Agricultutre",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["timacad.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tltsu.ru/"],
    name: "Togliatti State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tltsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.touro.ru/"],
    name: "Moscow University Touro",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["touro.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tpu.ru/"],
    name: "Tomsk Polytechnic University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tpu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsma.ru/"],
    name: "Tver State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsma.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsogu.ru/"],
    name: "Tyumen State University of Gas and Oil",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsogu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tspu.edu.ru/"],
    name: "Tomsk State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tspu.edu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tstu.ru/"],
    name: "Tambov State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tstu.tver.ru/"],
    name: "Tver State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tstu.tver.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsuab.ru/"],
    name: "Tomsk State University of Architecture and Building",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsuab.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsure.ru/"],
    name: "Taganrog State University of Radioengineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsure.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsu.ru/"],
    name: "Tomsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["https://www.utmn.ru/"],
    name: "Tyumen State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["utmn.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tsu.tula.ru/"],
    name: "Tula State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tsu.tula.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ttc.ryazan.ru/"],
    name: "Ryazan State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ttc.ryazan.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tu-bryansk.ru/"],
    name: "Brjansk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tu-bryansk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tu-chel.ac.ru/"],
    name: "Southern Ural State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tu-chel.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.tusur.ru/"],
    name: "Tomsk State University of Control Systems and Radioelectronics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tusur.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://tuvsu.ru/"],
    name: "Tuva State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["tuvsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uapa.ru/"],
    name: "Ural Academy of Public Administration",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uapa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uef.ru/"],
    name: "St. Petersburg State University of Economics and Finance",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uef.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ugatu.ac.ru/"],
    name: "Ufa State Aviation Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ugatu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ugrasu.ru/"],
    name: "Yugra State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ugrasu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ugsha.ru/"],
    name: "Ulyanovsk State Agricultural Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ugsha.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://uii.sever.ru/"],
    name: "Ukhta State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uii.sever.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ulspu.ru/"],
    name: "Ulyanovsk State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ulspu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ulstu.ru/"],
    name: "Ulyanovsk State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ulstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ulsu.ru/"],
    name: "Ulyanovsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ulsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uni-dubna.ru/"],
    name: "Dubna International University for Nature, Society and Man",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uni-dubna.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.unilib.neva.ru/"],
    name: "St. Petersburg State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["unilib.neva.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uni.udm.ru/"],
    name: "Udmurt State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uni.udm.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.univer.omsk.su/"],
    name: "Omsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["univer.omsk.su"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://university.tversu.ru/"],
    name: "Tver State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["university.tversu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uni-vologda.ac.ru/"],
    name: "Vologda State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uni-vologda.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uniyar.ac.ru/"],
    name: "Yaroslavl State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uniyar.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.unn.ac.ru/"],
    name: "Nizhny Novgorod State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["unn.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.urc.ac.ru/Universities/AGRO/"],
    name: "Cheljabinsk University of Agricultural Engineering",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["urc.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usaaa.ru/"],
    name: "Ural State Academy of Architecture and Arts",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usaaa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usart.ru/"],
    name: "Ural State Academy of Railway Transport",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usart.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uscon.ru/"],
    name: "Ural State Conservatory",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uscon.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usfea.ru/"],
    name: "Ural State Forestry Technical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usfea.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usla.ru/"],
    name: "Ural State Academy of Law",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usla.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usmga.ru/"],
    name: "Ural State Academy of Mining and Geology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usmga.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["https://urfu.ru"],
    name: "Ural Federal University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["urfu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usue.ru/"],
    name: "Ural State University of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usue.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.usu.ru/"],
    name: "Ural Gorkij State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["usu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.uvauga.ru/"],
    name: "Ulyanovsk Higher School of Civil Aviation",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["uvauga.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vfrta.ru/"],
    name: "Russian Customs Academy, Vladivostok Branch",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vfrta.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vgafk.ru/"],
    name: "Volgograd State Academy of Physical Education",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vgafk.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vgasa.ru/"],
    name: "Volgograd State University of Architecture and Civil Engineering (VolgGASU)",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vgasa.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vgta.vrn.ru/"],
    name: "Voronezh State Academy of Technology",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vgta.vrn.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vieup.ru/"],
    name: "NGO Vladikavkaz Institute of Economics, Management, and Law",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vieup.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vlsu.ru/"],
    name: "Vladimir State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vlsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.voenmeh.ru/"],
    name: "Baltic State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["voenmeh.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.volsu.ru/"],
    name: "Volgograd State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["volsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vorstu.ac.ru/"],
    name: "Voronezh State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vorstu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vsau.ru/"],
    name: "Voronezh State Agricultural University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vsau.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vsgaki.burnet.ru/"],
    name: "East-Siberian State Institute of Culture",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vsgaki.burnet.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vsgtu.eastsib.ru/"],
    name: "East-Siberian State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vsgtu.eastsib.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vsma.info/"],
    name: "Voronezh State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vsma.info"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vspu.ac.ru/"],
    name: "Voronezh State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vspu.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vspu.kirov.ru/"],
    name: "Vyatka State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vspu.kirov.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vspu.ru/"],
    name: "Volgograd State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vspu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vstu.ru/"],
    name: "Volgograd State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vstu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vsu.ru/"],
    name: "Voronezh State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.vvsu.ru/"],
    name: "Vladivostock State University of Economics",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["vvsu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.yma.ac.ru/"],
    name: "Yaroslavl State Medical Academy",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["yma.ac.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.yspu.yar.ru/"],
    name: "Yaroslavl State Pedagogical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["yspu.yar.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ystu.yar.ru/"],
    name: "Yaroslavl State Technical University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ystu.yar.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.ysu.ru/"],
    name: "Yakutsk State University",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["ysu.ru"],
    country: "Russian Federation",
  },
  {
    web_pages: ["https://synergy.ru/", "http://synergy.university/"],
    name: "Moscow University for Industry and Finance “Synergy”",
    alpha_two_code: "RU",
    "state-province": null,
    domains: ["synergy.ru", "synergy.university"],
    country: "Russian Federation",
  },
  {
    web_pages: ["http://www.auca.ac.rw/"],
    name: "Adventist University of Central Africa",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["auca.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.inatek.ac.rw/"],
    name: "Institut d'Agriculture, de Technologie et d'Education de Kibungo",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["inatek.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.isae.ac.rw/"],
    name: "Higher Institute of Agriculture and Animal Husbandry",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["isae.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.khi.ac.rw/"],
    name: "Kigali Health Institute",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["khi.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.kie.ac.rw/"],
    name: "Kigali Institute of Education",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["kie.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.kist.ac.rw/"],
    name: "Kigali Institute of Science & Technology",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["kist.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.nur.ac.rw/"],
    name: "National University of Rwanda",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["nur.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.sfb.ac.rw/"],
    name: "School of Finance and Banking",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["sfb.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.uck.ac.rw/"],
    name: "Université Catholique de Kabgayi",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["uck.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.ulk.ac.rw/"],
    name: "Kigali Independent University",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["ulk.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.umutarapolytech.ac.rw/"],
    name: "Umutara Polytechnic",
    alpha_two_code: "RW",
    "state-province": null,
    domains: ["umutarapolytech.ac.rw"],
    country: "Rwanda",
  },
  {
    web_pages: ["http://www.iugrad.edu.kn/"],
    name: "International University for Graduate Studies",
    alpha_two_code: "KN",
    "state-province": null,
    domains: ["iugrad.edu.kn"],
    country: "Saint Kitts and Nevis",
  },
  {
    web_pages: ["http://www.rossu.edu/veterinary-school/"],
    name: "Ross University Caribbean School of Veterinary Medicine",
    alpha_two_code: "KN",
    "state-province": null,
    domains: ["rossu.edu"],
    country: "Saint Kitts and Nevis",
  },
  {
    web_pages: ["http://www.stmu.org/"],
    name: "St Theresa's Medical University",
    alpha_two_code: "KN",
    "state-province": null,
    domains: ["stmu.org"],
    country: "Saint Kitts and Nevis",
  },
  {
    web_pages: ["http://www.unisilvaner.info/"],
    name: "University of Silvaner",
    alpha_two_code: "KN",
    "state-province": null,
    domains: ["unisilvaner.info"],
    country: "Saint Kitts and Nevis",
  },
  {
    web_pages: ["http://www.windsor.edu/"],
    name: "Windsor University School of Medicine",
    alpha_two_code: "KN",
    "state-province": null,
    domains: ["windsor.edu"],
    country: "Saint Kitts and Nevis",
  },
  {
    web_pages: ["http://www.spartanmed.org/"],
    name: "Spartan University of Health Sciences",
    alpha_two_code: "LC",
    "state-province": null,
    domains: ["spartanmed.org"],
    country: "Saint Lucia",
  },
  {
    web_pages: ["http://www.tusom.org/"],
    name: "Trinity University School of Medicine",
    alpha_two_code: "VC",
    "state-province": null,
    domains: ["tusom.org"],
    country: "Saint Vincent and the Grenadines",
  },
  {
    web_pages: ["http://www.nus.edu.ws/"],
    name: "National University of Samoa",
    alpha_two_code: "WS",
    "state-province": null,
    domains: ["nus.edu.ws"],
    country: "Samoa",
  },
  {
    web_pages: ["http://www.usp.ac.fj/wwwsoa/"],
    name: "University of the South Pacific School of Agriculture",
    alpha_two_code: "WS",
    "state-province": null,
    domains: ["usp.ac.fj"],
    country: "Samoa",
  },
  {
    web_pages: ["http://www.unirsm.sm/"],
    name: "University of San Marino",
    alpha_two_code: "SM",
    "state-province": null,
    domains: ["unirsm.sm"],
    country: "San Marino",
  },
  {
    web_pages: ["http://www.act.gotevot.edu.sa/"],
    name: "College of Technology at Abha",
    alpha_two_code: "SA",
    "state-province": "Abha",
    domains: ["act.gotevot.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.alfaisal.edu/"],
    name: "Alfaisal University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["alfaisal.edu"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.almaarifah.com/"],
    name: "Knowledge International University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["almaarifah.com"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.alyamamah.edu.sa/"],
    name: "Al-Yamamah College",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["alyamamah.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.arabou.edu.sa/"],
    name: "Arab Open University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["arabou.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.bmc.edu.sa/"],
    name: "Batterjee Medical College",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["bmc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.bpc.edu.sa/"],
    name: "Buraydah College for Applied Medical Sciences",
    alpha_two_code: "SA",
    "state-province": "Buraidah",
    domains: ["bpc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.bu.edu.sa/"],
    name: "Al-baha University",
    alpha_two_code: "SA",
    "state-province": "Abha",
    domains: ["bu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.cba.edu.sa/"],
    name: "College of Busniess Admnistration",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["cba.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.cti.edu.sa/"],
    name: "College of Telecommunication & Information",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["cti.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.dah.edu.sa"],
    name: "Dar al Hekma College",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["dah.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.dau.edu.sa/"],
    name: "Dar Al-Uloom Colleges",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["dau.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.dcc.edu.sa/"],
    name: "Dammam Community College",
    alpha_two_code: "SA",
    "state-province": "Dammam",
    domains: ["dcc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.dct.gotevot.edu.sa/"],
    name: "College of Technology at Dammam",
    alpha_two_code: "SA",
    "state-province": "Dammam",
    domains: ["dct.gotevot.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.effatcollege.edu.sa/"],
    name: "Effat College",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["effatcollege.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.fbsc.edu.sa/"],
    name: "Fahad Bin Sultan University",
    alpha_two_code: "SA",
    "state-province": "Tabuk",
    domains: ["fbsc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ibnsina.edu.sa/"],
    name: "Ibn Sina National College for Medical Studies",
    alpha_two_code: "SA",
    "state-province": "Jeddah ",
    domains: ["ibnsina.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.imamu.edu.sa/"],
    name: "Al-Imam Mohamed Ibn Saud Islamic University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["imamu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ipa.edu.sa/"],
    name: "Institute of Public Administration",
    alpha_two_code: "SA",
    "state-province": "Dammam",
    domains: ["ipa.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.iu.edu.sa/"],
    name: "Islamic University of Medinah",
    alpha_two_code: "SA",
    "state-province": "Medinah",
    domains: ["iu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.jazanu.edu.sa/"],
    name: "Jazan University",
    alpha_two_code: "SA",
    "state-province": "Jazan",
    domains: ["jazanu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.jct.edu.sa/"],
    name: "College of Technology at Jeddah",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["jct.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.jic.edu.sa/"],
    name: "Jubail Industrial College",
    alpha_two_code: "SA",
    "state-province": "Jubail",
    domains: ["jic.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ju.edu.sa/"],
    name: "Aljouf University",
    alpha_two_code: "SA",
    "state-province": "Aljouf",
    domains: ["ju.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kau.edu.sa/"],
    name: "King Abdul Aziz University",
    alpha_two_code: "SA",
    "state-province": "Jeddah",
    domains: ["kau.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kaust.edu.sa/"],
    name: "King Abdullah University of Science and Technology",
    alpha_two_code: "SA",
    "state-province": "Aljouf",
    domains: ["kaust.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["https://www.kfshrc.edu.sa/en/home"],
    name: "King Faisal Specialist Hospital & Research Centre",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["kfshrc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://kct.gotevot.edu.sa/"],
    name: "College of Technology at Kharj",
    alpha_two_code: "SA",
    "state-province": "Al-Kharj",
    domains: ["kct.gotevot.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kfsc.edu.sa/"],
    name: "King Fahd Security College",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["kfsc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kfu.edu.sa/"],
    name: "King Faisal University",
    alpha_two_code: "SA",
    "state-province": "Al-Ahsa",
    domains: ["kfu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kfupm.edu.sa/"],
    name: "King Fahad University of Petroleum and Minerals",
    alpha_two_code: "SA",
    "state-province": "Dhahran",
    domains: ["kfupm.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.kku.edu.sa/"],
    name: "King Khaled University",
    alpha_two_code: "SA",
    "state-province": "Abha",
    domains: ["kku.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ksau-hs.edu.sa/"],
    name: "King Saud bin Abdulaziz University for Health Sciences",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["ksau-hs.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ksu.edu.sa/"],
    name: "King Saud University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["ksu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ku.edu.sa/"],
    name: "Alkharj University",
    alpha_two_code: "SA",
    "state-province": "Al-kharj",
    domains: ["ku.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.mcst.edu.sa/"],
    name: "Knowledge College for Science and Technology",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["mcst.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.mu.edu.sa/"],
    name: "Majmaah University",
    alpha_two_code: "SA",
    "state-province": "Al Majma'ah",
    domains: ["mu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.nauss.edu.sa/"],
    name: "Naif Arab University for Security Sciences",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["nauss.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.nbu.edu.sa/"],
    name: "Northern Border University",
    alpha_two_code: "SA",
    "state-province": "Arar",
    domains: ["nbu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ngha.med.sa/"],
    name: "College of Nursing and Allied Health Scinces",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["ngha.med.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.nu.edu.sa/"],
    name: "Najran University",
    alpha_two_code: "SA",
    "state-province": "Najran",
    domains: ["nu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.pcdp.edu.sa/"],
    name: "Private College of Dentistry and Pharmacy",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["pcdp.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.pmu.edu.sa/"],
    name: "Prince Mohammad Bin Fahd University",
    alpha_two_code: "SA",
    "state-province": "Khobar",
    domains: ["pmu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.pscabha.edu.sa/"],
    name: "Prince Sultan College for Tourism and Hotel Scinces",
    alpha_two_code: "SA",
    "state-province": null,
    domains: ["pscabha.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.psu.edu.sa/"],
    name: "Prince Sultan University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["psu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.qc.edu.sa/"],
    name: "Qassim Private College",
    alpha_two_code: "SA",
    "state-province": "Qassim",
    domains: ["qc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.qu.edu.sa/"],
    name: "Qassim University",
    alpha_two_code: "SA",
    "state-province": "Qassim",
    domains: ["qu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.rct.edu.sa/"],
    name: "College of Technology at Riyadh",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["rct.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.riyadh.edu.sa/"],
    name: "Riyadh College of Dentistry and Pharmacy",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["riyadh.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.rug.edu.sa/"],
    name: "Princess Nora Bint Abdulrahman University",
    alpha_two_code: "SA",
    "state-province": "Riyadh",
    domains: ["rug.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.saadcollege.com/"],
    name: "Saad College of Nursing and Allied Health Sciences",
    alpha_two_code: "SA",
    "state-province": " Al-Khobar",
    domains: ["saadcollege.com"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.su.edu.sa/"],
    name: "Shaqra University",
    alpha_two_code: "SA",
    "state-province": "Shaqra",
    domains: ["su.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.taibahu.edu.sa/"],
    name: "Taibah University",
    alpha_two_code: "SA",
    "state-province": "Medina",
    domains: ["taibahu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.tnmeyah.net/jct/"],
    name: "College of Technology at Jazan",
    alpha_two_code: "SA",
    "state-province": "Jazan",
    domains: ["tnmeyah.net"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.tu.edu.sa/"],
    name: "Taif University",
    alpha_two_code: "SA",
    "state-province": "Taif",
    domains: ["tu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ucj.edu.sa/"],
    name: "Jubail University College",
    alpha_two_code: "SA",
    "state-province": "Jubail",
    domains: ["ucj.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ud.edu.sa/"],
    name: "University of Dammam",
    alpha_two_code: "SA",
    "state-province": "Dammam",
    domains: ["ud.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.uoh.edu.sa/"],
    name: "University of Hail",
    alpha_two_code: "SA",
    "state-province": "Hail",
    domains: ["uoh.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.uqu.edu.sa/"],
    name: "Umm Al-Qura University",
    alpha_two_code: "SA",
    "state-province": "Mecca",
    domains: ["uqu.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.ut.edu.sa/"],
    name: "University of Tabuk",
    alpha_two_code: "SA",
    "state-province": "Tabuk",
    domains: ["ut.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.yic.edu.sa/"],
    name: "Yanbu Industrial College",
    alpha_two_code: "SA",
    "state-province": "Yanbu",
    domains: ["yic.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.yti.edu.sa/"],
    name: "Yanbu Technical Institute",
    alpha_two_code: "SA",
    "state-province": "Yanbu",
    domains: ["yti.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.yuc.edu.sa/"],
    name: "Yanbu University College",
    alpha_two_code: "SA",
    "state-province": "Yanbu",
    domains: ["yuc.edu.sa"],
    country: "Saudi Arabia",
  },
  {
    web_pages: ["http://www.afi-ue.sn/"],
    name: "L'Université de l'Entreprise",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["afi-ue.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.bambey.univ.sn/"],
    name: "Université Alioune Diop de Bambey",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["bambey.univ.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.uahb.sn/"],
    name: "Universite Amadou Hampaté Ba",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["uahb.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.ucad.sn/"],
    name: "Université Cheikh Anta Diop",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["ucad.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.udb.sn/"],
    name: "Université Dakar Bourguiba",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["udb.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.uea.edu.sn/"],
    name: "Université Euro-Afrique",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["uea.edu.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.ugb.sn/"],
    name: "Université Gaston Berger Saint-Louis",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["ugb.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.unis.sn/"],
    name: "Université du Sahel",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["unis.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.univ-thies.sn/"],
    name: "Université de Thiès",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["univ-thies.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.univ-zig.sn/"],
    name: "Université de Ziguinchor",
    alpha_two_code: "SN",
    "state-province": null,
    domains: ["univ-zig.sn"],
    country: "Senegal",
  },
  {
    web_pages: ["http://www.arts.bg.ac.rs/"],
    name: "University of Fine Arts Belgrade",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["arts.bg.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.bg.ac.rs/"],
    name: "University of Belgrade",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["bg.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.eu.ac.rs/"],
    name: "European University",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["eu.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.kg.ac.rs/"],
    name: "University of Kragujevac",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["kg.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: [
      "http://www.megatrend-edu.net/",
      "http://megatrend.edu.rs/",
      "http://xz.edu.rs/",
    ],
    name: "Megatrend University of Applied Sciences",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["megatrend-edu.net", "megatrend.edu.rs", "xz.edu.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.metropolitan.edu.rs/"],
    name: "Metropolitan University",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["metropolitan.edu.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.ni.ac.rs/"],
    name: "University of Nis",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["ni.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.np.ac.rs/"],
    name: "Drzavni Univerzitet u Novom Pazaru",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["np.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.pr.ac.rs/"],
    name: "University of Priština",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["pr.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.privrednaakademija.edu.rs/"],
    name: "Privredna Akademija (Business Academy)",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["privrednaakademija.edu.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.singidunum.edu.rs/"],
    name: "Singidunum University",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["singidunum.edu.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.uninp.edu.rs/"],
    name: "International University of Novi Pazar",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["uninp.edu.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.uns.ac.rs/"],
    name: "University of Novi Sad",
    alpha_two_code: "RS",
    "state-province": null,
    domains: ["uns.ac.rs"],
    country: "Serbia",
  },
  {
    web_pages: ["http://www.unisey.ac.sc/"],
    name: "University of Seychelles",
    alpha_two_code: "SC",
    "state-province": null,
    domains: ["unisey.ac.sc"],
    country: "Seychelles",
  },
  {
    web_pages: ["http://www.usaim.edu/"],
    name: "University of Seychelles - American Institute of Medicine",
    alpha_two_code: "SC",
    "state-province": null,
    domains: ["usaim.edu"],
    country: "Seychelles",
  },
  {
    web_pages: ["http://fbcusl.8k.com/"],
    name: "Fourah Bay College, University of Sierra Leone",
    alpha_two_code: "SL",
    "state-province": null,
    domains: ["fbcusl.8k.com"],
    country: "Sierra Leone",
  },
  {
    web_pages: ["http://www.liccsalsl.org/"],
    name: "LICCSAL Business College",
    alpha_two_code: "SL",
    "state-province": null,
    domains: ["liccsalsl.org"],
    country: "Sierra Leone",
  },
  {
    web_pages: ["http://www.nu-online.com/"],
    name: "Njala University",
    alpha_two_code: "SL",
    "state-province": null,
    domains: ["nu-online.com"],
    country: "Sierra Leone",
  },
  {
    web_pages: ["http://www.tusol.org/"],
    name: "University of Sierra Leone",
    alpha_two_code: "SL",
    "state-province": null,
    domains: ["tusol.org"],
    country: "Sierra Leone",
  },
  {
    web_pages: ["http://www.aventis.edu.sg/"],
    name: "Aventis School of Management",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["aventis.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.ntu.edu.sg/"],
    name: "Nanyang Technological University",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["ntu.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.nus.edu/", "http://www.nus.edu.sg/"],
    name: "National University of Singapore",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["nus.edu", "nus.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.yale-nus.edu.sg/"],
    name: "yale-NUS",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["yale-nus.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.sim.edu.sg/"],
    name: "Singapore Institute of Management (SIM)",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["sim.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.smu.edu.sg/"],
    name: "Singapore Management University",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["smu.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.taoistcollege.org.sg/"],
    name: "Taoist College Singapore",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["taoistcollege.org.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.tp.edu.sg/"],
    name: "Temasek Polytechnic",
    alpha_two_code: "SG",
    "state-province": null,
    domains: ["tp.edu.sg"],
    country: "Singapore",
  },
  {
    web_pages: ["http://www.akademiapz.sk/"],
    name: "Police Academy in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["akademiapz.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.aku.sk/"],
    name: "Academy of Arts in Banská Bystrica",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["aku.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.aos.sk/"],
    name: "Armed Forces Academy of General Milan Rastislav Štefánik",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["aos.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.bisla.sk/"],
    name: "Bratislava International School of Liberal Arts",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["bisla.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.dti.sk/"],
    name: "Technical Institute of Dubnica in Dubnica nad Váhom",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["dti.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.euba.sk/"],
    name: "University of Economics in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["euba.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.ismpo.sk/"],
    name: "International School of Management in Prešov",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["ismpo.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.ku.sk/"],
    name: "Catholic University in Ruzomberok",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["ku.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.szu.sk/"],
    name: "Slovak Medical University",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["szu.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.selyeuni.sk/"],
    name: "Janos Selye University",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["selyeuni.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.sevs.sk/"],
    name: "University of Central Europe in Skalica",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["sevs.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.stuba.sk/"],
    name: "Slovak University of Technology in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["stuba.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.tnuni.sk/"],
    name: "University of Alexandra Dubček in Trenčín",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["tnuni.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.truni.sk/"],
    name: "University of Trnava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["truni.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.tuke.sk/"],
    name: "Technical University in Kosice",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["tuke.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.tuzvo.sk/"],
    name: "Technical University in Zvolen",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["tuzvo.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.ucm.sk/"],
    name: "University of SS. Cyril and Methodius in Trnava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["ucm.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.ukf.sk/"],
    name: "University Konstantina Filozov in Nitra",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["ukf.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.umb.sk/"],
    name: "Matej Bel University in Banská Bystrica",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["umb.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.uniag.sk/"],
    name: "Slovak University of Agriculture in Nitra",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["uniag.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.uniba.sk/"],
    name: "Comenius University in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["uniba.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.uninova.sk/"],
    name: "Law University of Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["uninova.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.unipo.sk/"],
    name: "University of Presov",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["unipo.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.uniza.sk/"],
    name: "University of Zilinska",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["uniza.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.upjs.sk/"],
    name: "Pavol Jozef Safarik University in Kosice",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["upjs.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.uvm.sk/"],
    name: "University of Veterinary Medicine in Kosice",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["uvm.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.vsm.sk/"],
    name: "School of Management",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["vsm.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.vsmu.sk/"],
    name: "University of Performing Arts in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["vsmu.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.vssladkovicovo.sk/"],
    name: "College in Sládkovičovo",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["vssladkovicovo.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.vssvalzbety.sk/"],
    name: "St. Elizabeth’s College of Health and Social Sciences in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["vssvalzbety.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.vsvu.sk/"],
    name: "Academy of Fine Arts and Design in Bratislava",
    alpha_two_code: "SK",
    "state-province": null,
    domains: ["vsvu.sk"],
    country: "Slovakia",
  },
  {
    web_pages: ["http://www.ung.si/"],
    name: "University of Nova Gorica",
    alpha_two_code: "SI",
    "state-province": null,
    domains: ["ung.si"],
    country: "Slovenia",
  },
  {
    web_pages: ["http://www.uni-lj.si/"],
    name: "University of Ljubljana",
    alpha_two_code: "SI",
    "state-province": null,
    domains: ["uni-lj.si"],
    country: "Slovenia",
  },
  {
    web_pages: ["http://www.um.si/"],
    name: "University of Maribor",
    alpha_two_code: "SI",
    "state-province": null,
    domains: ["um.si"],
    country: "Slovenia",
  },
  {
    web_pages: ["http://www.upr.si/"],
    name: "University of Primorska",
    alpha_two_code: "SI",
    "state-province": null,
    domains: ["upr.si"],
    country: "Slovenia",
  },
  {
    web_pages: ["http://www.usp.ac.fj/"],
    name: "University of the South Pacific",
    alpha_two_code: "SB",
    "state-province": null,
    domains: ["usp.ac.fj"],
    country: "Solomon Islands",
  },
  {
    web_pages: ["http://www.amouduniversity.org/"],
    name: "Amoud University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["amouduniversity.org"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.benadiruniversity.net/"],
    name: "Benadir University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["benadiruniversity.net"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.bosasocollege.com/"],
    name: "Bosaso College",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["bosasocollege.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.buraouniversity.com/"],
    name: "University of Burao",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["buraouniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.eastafricauniversity.net/"],
    name: "East Africa University Bosaso",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["eastafricauniversity.net"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.eastsomaliauniversity.com/"],
    name: "East Somalia University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["eastsomaliauniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.eelouniversity.org/"],
    name: "Eelo American University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["eelouniversity.org"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.gollisuniversity.com/"],
    name: "Gollis University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["gollisuniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.hargeisauniversity.net/"],
    name: "University of Hargeisa",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["hargeisauniversity.net"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.hiiraanuniversity.info/"],
    name: "Hiiraan University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["hiiraanuniversity.info"],
    country: "Somalia",
  },
  {
    web_pages: ["http://maakhiruniversity.net/"],
    name: "Maakhir University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["maakhiruniversity.net"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.mogadishuuniversity.com/"],
    name: "Mogadishu University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["mogadishuuniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.nugaaluniversity.com/"],
    name: "Nugaal University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["nugaaluniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.puntlandstateuniversity.com/"],
    name: "Puntland State University",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["puntlandstateuniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.sanaaguniversity.com/"],
    name: "Sanaag University of Science and Technology",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["sanaaguniversity.com"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.somtech.org/"],
    name: "Somaliland University of Technology",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["somtech.org"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.universityofsomalia.net/"],
    name: "University of Somalia",
    alpha_two_code: "SO",
    "state-province": null,
    domains: ["universityofsomalia.net"],
    country: "Somalia",
  },
  {
    web_pages: ["http://www.cput.ac.za/"],
    name: "Cape Peninsula University of Technology",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["cput.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.cut.ac.za/"],
    name: "Central University of Technology, Free State",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["cut.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.dut.ac.za/"],
    name: "Durban University of Technology",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["dut.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.mandela.ac.za/", "http://www.nmmu.ac.za/"],
    name: "Nelson Mandela University",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["mandela.ac.za", "nmmu.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.ru.ac.za/"],
    name: "Rhodes University",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["ru.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.sun.ac.za/"],
    name: "University of Stellenbosch",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["sun.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.tut.ac.za/"],
    name: "Tshwane University of Technology",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["tut.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.uct.ac.za/"],
    name: "University of Cape Town",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["uct.ac.za", "myuct.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.ufh.ac.za/"],
    name: "University of Fort Hare",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["ufh.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.uj.ac.za/"],
    name: "University of Johannesburg",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["uj.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.ukzn.ac.za/"],
    name: "University of KwaZulu-Natal",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["ukzn.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.ul.ac.za/"],
    name: "University of Limpopo",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["ul.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.unisa.ac.za/"],
    name: "University of South Africa",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["unisa.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.univen.ac.za/"],
    name: "University of Venda",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["univen.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.nwu.ac.za/", "http://www.uniwest.ac.za/"],
    name: "North-West University",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["nwu.ac.za", "uniwest.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.uovs.ac.za/", "http://www.ufs.ac.za/"],
    name: "University of the Free State",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["uovs.ac.za", "ufs.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.up.ac.za/"],
    name: "University of Pretoria",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["up.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.uwc.ac.za/"],
    name: "University of the Western Cape",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["uwc.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.unizulu.ac.za/"],
    name: "University of Zululand",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["unizulu.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.vut.ac.za/"],
    name: "Vaal University of Technology",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["vut.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.wits.ac.za/"],
    name: "University of Witwatersrand",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["wits.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.wsu.ac.za/"],
    name: "Walter Sisulu University for Technology and Science",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["wsu.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.msa.ac.za/"],
    name: "Monash Univerisity South Africa",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["msa.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.ump.ac.za/"],
    name: "Univerisity of Mpumalanga",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["ump.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.mut.ac.za/"],
    name: "Mangosuthu Univerisity of Technology",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["mut.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.smu.ac.za/"],
    name: "Sefako Makgatho Health Sciences University",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["smu.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.spu.ac.za/"],
    name: "Sol Plaatje University",
    alpha_two_code: "ZA",
    "state-province": null,
    domains: ["spu.ac.za"],
    country: "South Africa",
  },
  {
    web_pages: ["http://www.juba.edu.sd/"],
    name: "University of Juba",
    alpha_two_code: "SS",
    "state-province": null,
    domains: ["juba.edu.sd"],
    country: "South Sudan",
  },
  {
    web_pages: ["http://www.unbeg.edu.sd/"],
    name: "University of Northern Bahr El-Ghazal",
    alpha_two_code: "SS",
    "state-province": null,
    domains: ["unbeg.edu.sd"],
    country: "South Sudan",
  },
  {
    web_pages: ["http://www.barcelonagse.eu/"],
    name: "Barcelona Graduate School of Economics",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["barcelonagse.eu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.bircham.edu/"],
    name: "Bircham International University",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["bircham.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ceu.es/"],
    name: "Universidad de San Pablo CEU",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ceu.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.deusto.es/"],
    name: "Universidad de Deusto",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["deusto.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ehu.es/"],
    name: "Universidad del País Vasco",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ehu.es", "ehu.eus"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.esic.es/"],
    name: "Escuela Superior de Gestion Comercial y Marketing (ESIC)",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["esic.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.global-business-school.org/"],
    name: "Global Business School Barcelona",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["global-business-school.org"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ie.edu/"],
    name: "IE University",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ie.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.iuse.edu.es/"],
    name: "International University of Southern Europe",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["iuse.edu.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.lasalleuniversities.net/"],
    name: "La Salle Universities - International Programmes",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["lasalleuniversities.net"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.muni.es/"],
    name: "Mondragon Univertsitatea",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["muni.es", "mundragon.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.salleurl.edu/"],
    name: "La Salle - Universitat Rámon Llull",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["salleurl.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.schillermadrid.edu/"],
    name: "Schiller International University, Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["schillermadrid.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uab.es/"],
    name: "Universitat Autónoma de Barcelona",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uab.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ua.es/"],
    name: "Universidad de Alicante",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ua.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uah.es/"],
    name: "Universidad de Alcalá de Henares",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uah.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ualm.es/"],
    name: "Universidad de Almería",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ualm.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uam.es/"],
    name: "Universidad Autónoma de Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uam.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uax.es/"],
    name: "Universidad Alfonso X El Sabio",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uax.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ub.es/"],
    name: "Universitat de Barcelona",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ub.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ubu.es/"],
    name: "Universidad de Burgos",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ubu.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uc3m.es/"],
    name: "Universidad Carlos III de Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uc3m.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uca.es/"],
    name: "Universidad de Cádiz",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uca.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ucam.edu/"],
    name: "Universidad Católica San Antonio",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ucam.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ucavila.es/"],
    name: "Universidad Católica de Ávila",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ucavila.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uchceu.es/"],
    name: "Universidad Cardenal Herrera-CEU",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uchceu.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uclm.es/"],
    name: "Universidad de Castilla La Mancha",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uclm.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ucm.es/"],
    name: "Universidad Complutense de Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ucm.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uco.es/"],
    name: "Universidad de Córdoba",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uco.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ucv.es/"],
    name: "Universidad Católica de Valencia",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ucv.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.udc.es/"],
    name: "Universidad de La Coruña",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["udc.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.udg.es/"],
    name: "Universidad de Gerona",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["udg.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.udl.es/"],
    name: "Universitat de Lleida",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["udl.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uem.es/"],
    name: "Universidad Europea de Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uem.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ufv.es/"],
    name: "Universidad Francisco de Vitoria",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ufv.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ugr.es/"],
    name: "Universidad de Granada",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ugr.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uhu.es/"],
    name: "Universidad de Huelva",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uhu.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uia.es/"],
    name: "Universidad Internacional de Andalucía",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uia.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uib.es/"],
    name: "Universitat de les Illes Balears",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uib.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uic.es/"],
    name: "Universitat Internacional de Catalunya",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uic.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uimp.es/"],
    name: "Universidad Internacional Menéndez Pelayo",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uimp.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ujaen.es/"],
    name: "Universidad de Jaén",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ujaen.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uji.es/"],
    name: "Universitat Jaume I de Castellón",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uji.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ull.es/"],
    name: "Universidad de La Laguna",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ull.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.ulpgc.es/"],
    name: "Universidad de Las Palmas de Gran Canaria",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["ulpgc.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uma.es/"],
    name: "Universidad de Málaga",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uma.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.um.es/"],
    name: "Universidad de Murcia",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["um.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.umh.es/"],
    name: "Universidad Miguel Hernández de Elche",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["umh.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unavarra.es/"],
    name: "Universidad Pública de Navarra",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unavarra.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unav.es/"],
    name: "Universidad de Navarra",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unav.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uned.es/"],
    name: "Universidad Nacional de Educación a Distancia",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uned.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unex.es/"],
    name: "Universidad de Extremadura",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unex.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uniaam.uia.es/"],
    name: "Universidad Internacional de Andalucía, Sede Antonio Machado de Baeza",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uniaam.uia.es"],
    country: "Spain",
  },
  {
    web_pages: ["https://www.uloyola.es/"],
    name: "Universidad Loyola Andalucía",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uloyola.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uniactiva.com/"],
    name: "Universidad Abierta Interactiva",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uniactiva.com"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uniara.uia.es/"],
    name: "Universidad Internacional de Andalucía, Sede La Rábida",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uniara.uia.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unican.es/"],
    name: "Universidad de Cantabria",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unican.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unileon.es/"],
    name: "Universidad de León",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unileon.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uniovi.es/"],
    name: "Universidad de Oviedo",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uniovi.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unirioja.es/"],
    name: "Universidad de La Rioja",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unirioja.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.universidadatlantico.org/"],
    name: "Iniciativa Universidad del Atlantico",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["universidadatlantico.org"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unizar.es/"],
    name: "Universidad de Zaragoza",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unizar.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.unnet.es/"],
    name: "Universidad Antonio de Nebrija",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["unnet.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uoc.edu/"],
    name: "Universitat Oberta de Catalunya",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uoc.es", "uoc.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upc.edu/"],
    name: "Universidad Politécnica de Cataluna",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upc.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upco.es/"],
    name: "Universidad Pontificia Comillas",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upco.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upct.es/"],
    name: "Universidad Politécnica de Cartagena",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upct.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upf.es/", "https://www.upf.edu/"],
    name: "Universitat Pompeu Fabra",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upf.es", "upf.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upm.es/"],
    name: "Universidad Politécnica de Madrid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upm.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upo.es/"],
    name: "Universidad Pablo de Olavide",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upo.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upsa.es/"],
    name: "Universidad Pontificia de Salamanca",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upsa.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.upv.es/"],
    name: "Universidad Politécnica de Valencia",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["upv.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.urjc.es/"],
    name: "Universidad Rey Juan Carlos",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["urjc.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.url.es/"],
    name: "Universitat Rámon Llull",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["url.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.urv.es/"],
    name: "Universitat Rovira I Virgili Tarragona",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["urv.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.usal.es/"],
    name: "Universidad de Salamanca",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["usal.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.usc.es/"],
    name: "Universidad de Santiago de Compostela",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["usc.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.us.es/"],
    name: "Universidad de Sevilla",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["us.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uva.es/"],
    name: "Universidad de Valladolid",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uva.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uv.es/"],
    name: "Universidad de Valencia",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uv.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uvic.es/"],
    name: "Universitat de Vic",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uvic.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.uvigo.es/"],
    name: "Universidad de Vigo",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["uvigo.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.villanueva.edu/"],
    name: "Centro Universitario Villanueva",
    alpha_two_code: "ES",
    "state-province": null,
    domains: ["villanueva.edu"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.accimt.ac.lk/"],
    name: "Arthur C Clarke Institute of Modern Technologies",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["accimt.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.bbu.ac.lk/"],
    name: "Buddhasravaka Bhikshu University",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["bbu.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.bpu.ac.lk/"],
    name: "Buddhist and Pali University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["bpu.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.cmb.ac.lk/"],
    name: "University of Colombo",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["cmb.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.esn.ac.lk/"],
    name: "Eastern University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["esn.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.jfn.ac.lk/"],
    name: "University of Jaffna",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["jfn.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.kdu.ac.lk/"],
    name: "Kotelawala Defence University",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["kdu.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.kln.ac.lk/institutes/pgipbs/"],
    name: "Postgraduate Institute of Pali & Buddhist Studies (University of Kelaniya)",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["kln.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.kln.ac.lk/"],
    name: "University of Kelaniya",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["kln.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.mrt.ac.lk/"],
    name: "University of Moratuwa",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["mrt.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.ou.ac.lk/"],
    name: "Open University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["ou.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.pdn.ac.lk/"],
    name: "University of Peradeniya",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["pdn.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.pgia.ac.lk/"],
    name: "Postgraduate Institute of Agriculture (PGIA)",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["pgia.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.rjt.ac.lk/"],
    name: "Rajarata University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["rjt.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.ruh.ac.lk/"],
    name: "University of Ruhuna",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["ruh.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.sab.ac.lk/"],
    name: "Sabaragamuwa University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["sab.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.saitm.edu.lk/"],
    name: "South Asian Institute of Technology And Medicine (SAITM)",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["saitm.edu.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.seu.ac.lk/"],
    name: "South Eastern University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["seu.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.sjp.ac.lk/"],
    name: "University of Sri Jayawardenapura",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["sjp.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.sliate.net/"],
    name: "Sri Lanka Institute of Advanced Technical Education",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["sliate.net"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.sliit.lk/"],
    name: "Sri Lanka Institute of Information Technology (SLIT)",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["sliit.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.uwu.ac.lk/"],
    name: "Uva Wellassa University",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["uwu.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.vpa.ac.lk/"],
    name: "University of the Visual & Performing Arts",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["vpa.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.wyb.ac.lk/"],
    name: "Wayamba University of Sri Lanka",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["wyb.ac.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.nsbm.lk/"],
    name: "National School of Business Management",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["nsbm.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["https://www.nibm.lk/"],
    name: "National Institute of Business Management",
    alpha_two_code: "LK",
    "state-province": null,
    domains: ["nibm.lk"],
    country: "Sri Lanka",
  },
  {
    web_pages: ["http://www.aau.edu.sd/"],
    name: "Al-Zaiem Al-Azhari University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["aau.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ahfad.edu.sd/"],
    name: "Ahfad University for Women",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ahfad.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.bakhtalruda.edu.sd/"],
    name: "Bakht Er-Ruda University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["bakhtalruda.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.bayantech.edu/"],
    name: "Bayan College for Science & Technology",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["bayantech.edu"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.bnu.edu.sd/"],
    name: "Blue Nile University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["bnu.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ccs.edu.sd/"],
    name: "Canadian Sudanese College",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ccs.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.dalanjuniversity.edu.sd/"],
    name: "Dalanj University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["dalanjuniversity.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.elmahdi.edu.sd/"],
    name: "University of El Imam El Mahdi University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["elmahdi.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.elrazicollege.net/"],
    name: "Elrazi College Of Medical & Technological Sciences",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["elrazicollege.net"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.fashir.edu.sd/"],
    name: "Al Fashir University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["fashir.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.gaduniv.edu.sd/"],
    name: "University of Gadarif",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["gaduniv.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.geziracollege.edu.sd/"],
    name: "Gezira College of Technology",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["geziracollege.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.hibfs.edu.sd/"],
    name: "High Institute for Banking & Financial Studies",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["hibfs.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.iua.edu.sd/"],
    name: "International University of Africa (IUA)",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["iua.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.kassalauni.edu.sd/"],
    name: "Kassala University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["kassalauni.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.kordofan.edu.sd/"],
    name: "University of Kordofan",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["kordofan.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.nc.edu.sd/"],
    name: "National College for Medical and Technical Studies",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["nc.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.neelain.edu.sd/"],
    name: "Neelain University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["neelain.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.nilevalley.edu.sd/"],
    name: "Nile Valley University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["nilevalley.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.oau.edu.sd/"],
    name: "Omdurman Ahlia University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["oau.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.oiu.edu.sd/"],
    name: "Omdurman Islamic University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["oiu.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ous.edu.sd/"],
    name: "Open University of Sudan (OUS)",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ous.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.quran-unv.edu.sd/"],
    name: "University of Holy Quran and Islamic Siences",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["quran-unv.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ribat.edu.sd/"],
    name: "National Ribat University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ribat.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.rsu.edu.sd/"],
    name: "Red Sea University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["rsu.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.sas-sd.net/"],
    name: "Sudan Academy of Sciences",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["sas-sd.net"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.sinnaruniv.edu.sd/"],
    name: "Sinnar University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["sinnaruniv.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.sustech.edu/"],
    name: "Sudan University for Science and Technology",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["sustech.edu"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.umst-edu.com/"],
    name: "University Of Medical Sciences & Technology (UMST)",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["umst-edu.com"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.unu.edu.sd/"],
    name: "Upper Nile University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["unu.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.uofd.edu.sd/"],
    name: "University of Dongola",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["uofd.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.uofg.edu.sd/"],
    name: "University of Gezira",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["uofg.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.uofk.edu/"],
    name: "University of Khartoum",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["uofk.edu"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ush.sd/"],
    name: "Shendi University",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ush.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.ust.edu.sd/"],
    name: "University of Science and Technology",
    alpha_two_code: "SD",
    "state-province": null,
    domains: ["ust.edu.sd"],
    country: "Sudan",
  },
  {
    web_pages: ["http://www.uvs.edu/"],
    name: "Anton de Kom University",
    alpha_two_code: "SR",
    "state-province": null,
    domains: ["uvs.edu"],
    country: "Suriname",
  },
  {
    web_pages: ["http://www.uniswa.sz/"],
    name: "University of Swaziland",
    alpha_two_code: "SZ",
    "state-province": null,
    domains: ["uniswa.sz"],
    country: "Swaziland",
  },
  {
    web_pages: ["http://www.bth.se/"],
    name: "Blekinge Institute of Technology",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["bth.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.chalmers.se/"],
    name: "Chalmers University of Technology",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["chalmers.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.du.se/"],
    name: "Dalarna University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["du.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.gu.se/"],
    name: "Göteborg University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["gu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hb.se/"],
    name: "University College of Borås",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hb.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hdk.gu.se/"],
    name: "School of Design and Crafts",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hdk.gu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hgo.se/"],
    name: "Gotland University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hgo.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hh.se/"],
    name: "Halmstad University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hh.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hhs.se/"],
    name: "Stockholm School of Economics",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hhs.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hig.se/"],
    name: "University College of Gävle",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hig.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hik.se/"],
    name: "Kalmar University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hik.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.his.se/"],
    name: "University College of Skövde",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["his.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hj.se/"],
    name: "Jönköping University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hj.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hj.se/hhj/"],
    name: "Jönköping University College of Health Sciences",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hj.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.hkr.se/"],
    name: "University College of Kristianstad",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["hkr.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.htu.se/"],
    name: "University College of Trollhättan/Uddevalla",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["htu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.kau.se/"],
    name: "Karlstad University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["kau.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.ki.se/"],
    name: "Karolinska Institute Stockholm",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["ki.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.konstfack.se/"],
    name: "University College of Arts, Crafts and Design",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["konstfack.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.kth.se/"],
    name: "KTH Royal Institute of Technology",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["kth.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.lhs.se/"],
    name: "Stockholm Institute of Education",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["lhs.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.liu.se/"],
    name: "Linköping University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["liu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.lu.se/"],
    name: "Lund University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["lu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.luth.se/"],
    name: "Lulea University of Technology",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["luth.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.mah.se/"],
    name: "Malmö University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["mah.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.mdh.se/"],
    name: "Mälardalen University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["mdh.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.miun.se/"],
    name: "Mid-Sweden University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["miun.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.nhv.se/"],
    name: "Nordic School of Public Health",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["nhv.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.oru.se/"],
    name: "Örebro University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["oru.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.sh.se/"],
    name: "Södertörn University College",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["sh.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.slu.se/"],
    name: "Swedish University of Agricultural Sciences",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["slu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.stockholm-fu.com/"],
    name: "Free University Stockholm",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["stockholm-fu.com"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.su.se/"],
    name: "Stockholm University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["su.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.umu.se/"],
    name: "Umea University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["umu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.uu.se/"],
    name: "Uppsala University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["uu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.vxu.se/"],
    name: "Växjö University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["vxu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.wmu.se/"],
    name: "World Maritime University",
    alpha_two_code: "SE",
    "state-province": null,
    domains: ["wmu.se"],
    country: "Sweden",
  },
  {
    web_pages: ["http://www.american-college.com/"],
    name: "Schiller International University, American College of Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["american-college.com"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.bhms.ch/"],
    name: "Business and Hotel Management School",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["bhms.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.bsl-lausanne.ch/"],
    name: "Business School Lausanne (BSL)",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["bsl-lausanne.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.cubidor.com/"],
    name: "Cubidor University Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["cubidor.com"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.dct.ch/"],
    name: "DCT International Hotel & Business Management School",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["dct.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.egs.edu/"],
    name: "European Graduate School, Media & Communications",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["egs.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ehl.ch/"],
    name: "Lausanne Hotel School (EHL)",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ehl.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.euruni.edu/"],
    name: "European University",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["euruni.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fc.edu/"],
    name: "Franklin College Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fc.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fh-aargau.ch/"],
    name: "University of Applied Sciences Aargau",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fh-aargau.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fhbb.ch/"],
    name: "University of Applied Sciences Basel (FHBB )",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fhbb.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fh-htachur.ch/"],
    name: "University of Applied Sciences Chur",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fh-htachur.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fhso.ch/"],
    name: "University of Applied Sciences Solothurn Northwestern Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fhso.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.gbs-ge.ch/"],
    name: "Geneva Business School",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["gbs-ge.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.glion.edu/"],
    name: "Glion Institute of Higher Education",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["glion.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.gsba.ch/"],
    name: "Graduate School of Business Administration Zurich (GSBA Zurich)",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["gsba.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hgkz.ch/"],
    name: "Hochschule für Gestaltung und Kunst Zürich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hgkz.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ici-luzern.com/"],
    name: "International Culinary Institute (ICI)",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ici-luzern.com"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.imi-luzern.com/"],
    name: "International Hotel Management Institute",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["imi-luzern.com"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.isbm-school.com/"],
    name: "International School of Business Management",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["isbm-school.com"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.iun.ch/"],
    name: "International University in Geneva",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["iun.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.lesroches.edu/"],
    name: "Les Roches International School of Hotel Management",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["lesroches.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.lrguas.ch/"],
    name: "Les Roches Gruyère University of Applied Sciences",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["lrguas.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phw.info/"],
    name: "Fachhochschule Pur",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phw.info"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.sbs.edu/"],
    name: "Swiss Business School Zurich (SBS)",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["sbs.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.swissmc.ch/"],
    name: "Swiss Management Center",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["swissmc.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.swissu.org/"],
    name: "University of Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["swissu.org"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.uccr.edu/"],
    name: 'University Center "César Ritz"',
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["uccr.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.uniludes.ch/"],
    name: "Libera Università degli Studi di Scienze Umane e Tecnologiche",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["uniludes.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unizh.ch/"],
    name: "University of Zürich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unizh.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.victoria-uni.ch/"],
    name: "Victoria University",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["victoria-uni.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.webster.ch/"],
    name: "Webster University Geneva",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["webster.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.zhwin.ch/"],
    name: "Zurich University of Applied Sciences Winterthur",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["zhwin.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.epfl.ch/", "http://www.epfl.edu/"],
    name: "EPFL - EPF Lausanne",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["epfl.ch", "epfl.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ethz.ch/", "http://www.eth.edu/"],
    name: "ETHZ - ETH Zurich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ethz.ch", "eth.edu"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.usi.ch/"],
    name: "Universita della Svizzera Italiana",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["usi.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unibas.ch/"],
    name: "University of Basel",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unibas.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unifr.ch/"],
    name: "University of Fribourg",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unifr.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unige.ch/"],
    name: "University of Geneva",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unige.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.uzh.ch/"],
    name: "University of Zurich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["uzh.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unibe.ch/"],
    name: "Universität Bern",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unibe.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unilu.ch/"],
    name: "Universität Luzern",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unilu.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unisg.ch/"],
    name: "Universität St. Gallen",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unisg.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unil.ch/"],
    name: "Université de Lausanne",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unil.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unine.ch/"],
    name: "Université de Neuchâtel",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unine.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.bfh.ch/"],
    name: "BFH - Bern University of Applied Sciences",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["bfh.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ffhs.ch/"],
    name: "FFHS - Fernfachhochschule Schweiz",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ffhs.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fhnw.ch/"],
    name: "FHNW - Fachhochschule Nordwestschweiz",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fhnw.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fhsg.ch/"],
    name: "FHS St.Gallen",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fhsg.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hepl.ch/"],
    name: "HEP Vaud - Haute école pédagogique du canton de Vaud",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hepl.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hep-bejune.ch/"],
    name: "HEP-BEJUNE - Haute Ecole Pédagogique BEJUNE",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hep-bejune.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.edufr.ch/"],
    name: "HEP-PH FR - University of Teacher Education Fribourg",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["edufr.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hepvs.ch/"],
    name: "HEPVS - Haute école pédagogique du Valais",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hepvs.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hes-so.ch/"],
    name: "HES-SO : UAS Western Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hes-so.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hfh.ch/"],
    name: "HfH – University of Applied Sciences of Special Needs Education",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hfh.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hslu.ch/"],
    name: "HSLU - Lucerne University of Applied Sciences and Arts",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hslu.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hsr.ch/"],
    name: "HSR - Hochschule für Technik Rapperswil",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hsr.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fh-htwchur.ch/"],
    name: "HTW Chur - University of Applied Sciences HTW Chur",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fh-htwchur.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.fh-hwz.ch/"],
    name: "HWZ - University of Applied Sciences in Business Administration Zurich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["fh-hwz.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ntb.ch/"],
    name: "NTB - Hochschule für Technik Buchs",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ntb.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phzg.ch/"],
    name: "PH Zug - Pädagogische Hochschule Zug",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phzg.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phzh.ch/"],
    name: "PH Zürich - Pädagogische Hochschule Zürich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phzh.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phbern.ch/"],
    name: "PHBern - University of Teacher Education Bern",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phbern.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.ph-gr.ch/"],
    name: "PHGR - University of Teacher Education Graubünden",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["ph-gr.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phlu.ch/"],
    name: "PHLU - University of Teacher Education Lucerne",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phlu.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phsg.ch/"],
    name: "PHSG - Pädagogische Hochschule St.Gallen",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phsg.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phsz.ch/"],
    name: "PHSZ - University of Teacher Education Schwyz",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phsz.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.phtg.ch/"],
    name: "PHTG - Pädagogische Hochschule Thurgau",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["phtg.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.supsi.ch/"],
    name: "SUPSI - University of Applied Sciences Southern Switzerland",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["supsi.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.zhaw.ch/"],
    name: "ZHAW - Zürcher Hochschule für Angewandte Wissenschaften",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["zhaw.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.zhdk.ch/"],
    name: "ZHdK - Zurich University of the Arts",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["zhdk.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.chuv.ch/"],
    name: "CHUV - University Hospital Lausanne",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["chuv.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.hcuge.ch/"],
    name: "HUG - Univ. Hospitals of Geneva",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["hcuge.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.insel.ch/"],
    name: "Insel Gruppe",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["insel.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.unispital.ch/"],
    name: "University Hospital Zurich",
    alpha_two_code: "CH",
    "state-province": null,
    domains: ["unispital.ch"],
    country: "Switzerland",
  },
  {
    web_pages: ["http://www.aiu.edu.sy/"],
    name: "Arab European University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["aiu.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.albaath-univ.edu.sy/"],
    name: "Al-Baath University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["albaath-univ.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.alepuniv.edu.sy/"],
    name: "University of Aleppo",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["alepuniv.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.damascusuniversity.edu.sy/"],
    name: "Damascus University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["damascusuniversity.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.hiba.edu.sy/"],
    name: "Higher Institute of Business Administration",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["hiba.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.ipu.edu.sy/"],
    name: "Ittihad Private University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["ipu.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.iust.edu.sy/"],
    name: "International University for Science & Technology",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["iust.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.must.edu.sy/"],
    name: "Mamoun Private University for Science and Technology",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["must.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.siust.edu.sy/"],
    name: "Syrian International Private University for Science & Technology",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["siust.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.svuonline.org/"],
    name: "Syrian Virtual University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["svuonline.org"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.tishreen.edu.sy/"],
    name: "Tishreen University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["tishreen.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.uok.edu.sy/"],
    name: "University of Kalamoon",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["uok.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.wiu.edu.sy/"],
    name: "Wadi International University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["wiu.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.wpu.edu.sy/"],
    name: "Al-Wataniya Private University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["wpu.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.ypu.edu.sy/"],
    name: "Yarmouk Private University",
    alpha_two_code: "SY",
    "state-province": null,
    domains: ["ypu.edu.sy"],
    country: "Syrian Arab Republic",
  },
  {
    web_pages: ["http://www.au.edu.tw/"],
    name: "Aletheia University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["au.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ccu.edu.tw/"],
    name: "National Chung Cheng University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ccu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cgu.edu.tw/"],
    name: "Chang Gung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cgu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.chna.edu.tw/"],
    name: "Chia Nana College of Pharmacy and Science",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["chna.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.chu.edu.tw/"],
    name: "Chung Hua University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["chu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cju.edu.tw/"],
    name: "Chang Jung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cju.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cku.edu.tw/"],
    name: "Ching Kuo Institue of Management & Health",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cku.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cmc.edu.tw/"],
    name: "China Medical College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cmc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cpu.edu.tw/"],
    name: "Central Police University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cpu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.csmc.edu.tw/"],
    name: "Chung Shan Medical and Dental College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["csmc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cycu.edu.tw/"],
    name: "Chung Yuan Christian University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cycu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.cyut.edu.tw/"],
    name: "Chao Yang University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["cyut.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.dyu.edu.tw/"],
    name: "Da-Yeh University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["dyu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://english.web.ncku.edu.tw/"],
    name: "National Cheng Kung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["english.web.ncku.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.fcu.edu.tw/"],
    name: "Feng Chia University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["fcu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.fju.edu.tw/"],
    name: "Fu Jen Catholic University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["fju.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.hcu.edu.tw/"],
    name: "Hsuan Chuang University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["hcu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.hfu.edu.tw/"],
    name: "Huafan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["hfu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.isu.edu.tw/"],
    name: "I-Shou University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["isu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.kmc.edu.tw/"],
    name: "Kaohsiung Medical College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["kmc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ksit.edu.tw/"],
    name: "Kung Shan Institute of Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ksit.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ksu.edu.tw/"],
    name: "Kun Shan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ksu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.kuas.edu.tw/"],
    name: "National Kaohsiung University of Applied Sciences",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["kuas.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.lhu.edu.tw/"],
    name: "LungHwa University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["lhu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ltc.edu.tw/"],
    name: "Ling Tung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ltc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.mcu.edu.tw/"],
    name: "Ming Chuan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["mcu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nccu.edu.tw/"],
    name: "National Chengchi University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nccu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nchu.edu.tw/"],
    name: "National Chung Hsing University, Taichung",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nchu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nchulc.edu.tw/"],
    name: "National Chung Hsing University, Taipei",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nchulc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ncnu.edu.tw/"],
    name: "National Chi Nan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ncnu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ncpes.edu.tw/"],
    name: "National College of Physical Education and Sports",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ncpes.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nctu.edu.tw/"],
    name: "National Chiao Tung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nctu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ncu.edu.tw/"],
    name: "National Central University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ncu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ncue.edu.tw/"],
    name: "National Changhua University of Education",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ncue.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ncyu.edu.tw/"],
    name: "National Chiayi University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ncyu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ndhu.edu.tw/"],
    name: "National Dong Hwa University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ndhu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nfu.edu.tw/"],
    name: "National Formosa University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nfu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nhctc.edu.tw/"],
    name: "National Hsin-Chu Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nhctc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nhltc.edu.tw/"],
    name: "National Hualien Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nhltc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nhu.edu.tw/"],
    name: "Nanhua University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nhu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nia.edu.tw/"],
    name: "National Institute of the Arts",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nia.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.niu.edu.tw/"],
    name: "National Ilan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["niu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nkfu.edu.tw/"],
    name: "National Kaohsiung First University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nkfu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nknu.edu.tw/"],
    name: "National Kaohsiung Normal University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nknu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nou.edu.tw/"],
    name: "National Open University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nou.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.npttc.edu.tw/"],
    name: "National Pingtung Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["npttc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.npust.edu.tw/"],
    name: "National Pingtung University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["npust.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nsysu.edu.tw/"],
    name: "National Sun Yat-Sen University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nsysu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntca.edu.tw/"],
    name: "National Taiwan College of the Arts",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntca.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntcn.edu.tw/"],
    name: "National Taipei College of Nursing",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntcn.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntcpe.edu.tw/"],
    name: "National Taiwan College of Physical Education and Sports",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntcpe.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntctc.edu.tw/"],
    name: "National Taichung Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntctc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nthu.edu.tw/"],
    name: "National Tsinghua University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nthu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntntc.edu.tw/"],
    name: "National Tainan Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntntc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntnu.edu.tw/"],
    name: "National Taiwan Normal University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntnu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntou.edu.tw/"],
    name: "National Taiwan Ocean University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntou.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntptc.edu.tw/"],
    name: "National Taipei Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntptc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntpu.edu.tw/"],
    name: "National Taipei University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntpu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntttc.edu.tw/"],
    name: "National Taitung Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntttc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntu.edu.tw/"],
    name: "National Taiwan University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntust.edu.tw/"],
    name: "National Taiwan University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntust.edu.tw", "gapps.ntust.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ntut.edu.tw/"],
    name: "National Taipei University of Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ntut.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nuk.edu.tw/"],
    name: "National University of Kaohsiung",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nuk.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.nuu.edu.tw/"],
    name: "National United University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["nuu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ouk.edu.tw/"],
    name: "Kaohsuing Open University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ouk.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.pccu.edu.tw/"],
    name: "Chinese Culture University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["pccu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.pu.edu.tw/"],
    name: "Providence University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["pu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.scc.edu.tw/"],
    name: "Shih Chien University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["scc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.scu.edu.tw/"],
    name: "Soochow University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["scu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.shu.edu.tw/"],
    name: "Shih Hsin University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["shu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.sjsmit.edu.tw/"],
    name: "St. John's & St. Mary's Institute of Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["sjsmit.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.stut.edu.tw/"],
    name: "Southern Taiwan University of Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["stut.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tcu.edu.tw/"],
    name: "Tzu Chi College of Medicine and Humanities",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tcu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.thmu.edu.tw/"],
    name: "TaiChung Healthcare and Management University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["thmu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.thu.edu.tw/"],
    name: "Tunghai University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["thu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tku.edu.tw/"],
    name: "Tamkang University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tku.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tmc.edu.tw/"],
    name: "Taipei Medical College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tmc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tmtc.edu.tw/"],
    name: "Taipei Municipal Teachers College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tmtc.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tnca.edu.tw/"],
    name: "Tainan National College of the Arts",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tnca.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tpec.edu.tw/"],
    name: "Taipei Physical Education College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["tpec.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ttit.edu.tw/"],
    name: "Tatung Institute of Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ttit.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ttu.edu.tw/"],
    name: "TaTung University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ttu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.ym.edu.tw/"],
    name: "National Yang Ming Medical College",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["ym.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.yuntech.edu.tw/"],
    name: "National Yunlin University of Science and Technology",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["yuntech.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.yzu.edu.tw/"],
    name: "Yuan Ze University",
    alpha_two_code: "TW",
    "state-province": null,
    domains: ["yzu.edu.tw"],
    country: "Taiwan",
  },
  {
    web_pages: ["http://www.tajagroun.tj/"],
    name: "Tajik Agrarian University",
    alpha_two_code: "TJ",
    "state-province": null,
    domains: ["tajagroun.tj"],
    country: "Tajikistan",
  },
  {
    web_pages: ["http://tgnu.tarena.tj/"],
    name: "Tajik National University",
    alpha_two_code: "TJ",
    "state-province": null,
    domains: ["tgnu.tarena.tj"],
    country: "Tajikistan",
  },
  {
    web_pages: ["http://www.tiu.tj/"],
    name: "Tajikistan International University",
    alpha_two_code: "TJ",
    "state-province": null,
    domains: ["tiu.tj"],
    country: "Tajikistan",
  },
  {
    web_pages: ["http://www.aku.edu/"],
    name: "Aga Khan University",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["aku.edu"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.avu.org/"],
    name: "African Virtual University",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["avu.org"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.dit.ac.tz/"],
    name: "Dares Salaam Institute of Technology",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["dit.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.hkmu.ac.tz/"],
    name: "Hubert Kairuki Memorial University",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["hkmu.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.iaa.ac.tz/"],
    name: "Institute of Accountancy Arusha",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["iaa.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.ifm.ac.tz/"],
    name: "Institute of Finance Management",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["ifm.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.imtu.edu/index.htm"],
    name: "International Medical & Technological University",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["imtu.edu"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.kcmc.ac.tz/"],
    name: "Kilimanjaro Christian Medical College",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["kcmc.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.mmu.ac.tz/"],
    name: "Mount Meru University",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["mmu.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.mnma.ac.tz/"],
    name: "Mwalimu Nyerere Memorial Academy",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["mnma.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.muccobs.ac.tz/"],
    name: "Moshi University College of Cooperative and Business Studies",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["muccobs.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.muchs.ac.tz/"],
    name: "Muhimbili University of Health and Allied Sciences (MUHAS)",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["muchs.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.mzumbe.ac.tz/"],
    name: "Mzumbe University (Chuo Kikuu Mzumbe)",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["mzumbe.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.out.ac.tz/"],
    name: "Open University of Tanzania",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["out.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.saut.ac.tz/"],
    name: "St. Augustine University of Tanzania",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["saut.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.sekuco.org/"],
    name: "Sebatian Kolowa University College",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["sekuco.org"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.stjosephtanzania.com/sjcet/index.html"],
    name: "St. Joseph Group of Institutes",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["stjosephtanzania.com"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.suanet.ac.tz/"],
    name: "Sokoine University of Agriculture",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["suanet.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.tumaini.ac.tz/"],
    name: "Tumaini University - Iringa University College",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["tumaini.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.udom.ac.tz/"],
    name: "University of Dodoma",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["udom.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["http://www.udsm.ac.tz/"],
    name: "University of Dar Es Salaam",
    alpha_two_code: "TZ",
    "state-province": null,
    domains: ["udsm.ac.tz"],
    country: "Tanzania, United Republic of",
  },
  {
    web_pages: ["https://www.ait.ac.th/"],
    name: "Asian Institute of Technology",
    alpha_two_code: "TH",
    "state-province": "Pathum Thani",
    domains: ["ait.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.aru.ac.th/"],
    name: "Phranakhon Si Ayutthaya Rajabhat University",
    alpha_two_code: "TH",
    "state-province": "Phra Nakhon Si Ayutthaya",
    domains: ["aru.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.asianust.ac.th/"],
    name: "Asian University of Science and Technology",
    alpha_two_code: "TH",
    "state-province": "Chon Buri",
    domains: ["asianust.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.au.edu/"],
    name: "Assumption University of Thailand",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["au.edu"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.bu.ac.th/"],
    name: "Bangkok University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["bu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.buu.ac.th/"],
    name: "Burapha University",
    alpha_two_code: "TH",
    "state-province": "Chon Buri",
    domains: ["buu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.chiangmai.ac.th/"],
    name: "Chiang Mai University",
    alpha_two_code: "TH",
    "state-province": "Chiang Mai",
    domains: ["chiangmai.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://chiangraicampus.rmutl.ac.th/"],
    name: "Rajamangala University of Technology, Lanna Chiang Rai",
    alpha_two_code: "TH",
    "state-province": "Chiang Rai",
    domains: ["chiangraicampus.rmutl.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.chula.ac.th/"],
    name: "Chulalongkorn University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["chula.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.cmru.ac.th/"],
    name: "Chiang Mai Rajabhat University",
    alpha_two_code: "TH",
    "state-province": "Chiang Mai",
    domains: ["cmru.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.cmvc.ac.th/"],
    name: "Chiang Mai Vocational College",
    alpha_two_code: "TH",
    "state-province": "Chiang Mai",
    domains: ["cmvc.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.cpu.ac.th/"],
    name: "Chaopraya University",
    alpha_two_code: "TH",
    "state-province": "Nakhon Sawan",
    domains: ["cpu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.dpu.ac.th/"],
    name: "Dhurakijpundit University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["dpu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.dusit.ac.th/"],
    name: "Suan Dusit Rajabhat University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["dusit.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.eau.ac.th/"],
    name: "Eastern Asia University",
    alpha_two_code: "TH",
    "state-province": "Pathum Thani",
    domains: ["eau.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.asianu.ac.th/"],
    name: "Asian University",
    alpha_two_code: "TH",
    "state-province": "Chon Buri",
    domains: ["efau.org"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.hcu.ac.th/"],
    name: "Huachiew Chalermprakiet University",
    alpha_two_code: "TH",
    "state-province": "Samut Prakarn",
    domains: ["hcu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.hu.ac.th/"],
    name: "Hatyai University",
    alpha_two_code: "TH",
    "state-province": "Songkhla",
    domains: ["hu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.ibc.ac.th/"],
    name: "International Buddhist College",
    alpha_two_code: "TH",
    "state-province": "SongKhla",
    domains: ["ibc.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.kbu.ac.th/"],
    name: "Kasem Bundit University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["kbu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.kku.ac.th/"],
    name: "Khon Kaen University",
    alpha_two_code: "TH",
    "state-province": "Khon Kaen",
    domains: ["kku.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.kmitl.ac.th/"],
    name: "King Mongkut's Institute of Technology Ladkrabang",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["kmitl.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.kmutnb.ac.th/"],
    name: "King Mongkut's University of Technology North Bangkok",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["kmutnb.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.kmutt.ac.th/"],
    name: "King Mongkut's University of Technology Thonburi",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["kmutt.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.krirk.ac.th/"],
    name: "Krirk University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["krirk.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.ku.ac.th/"],
    name: "Kasetsart University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["ku.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.lampangvc.ac.th/"],
    name: "Lampang Vocational College",
    alpha_two_code: "TH",
    "state-province": "Lampang",
    domains: ["lampangvc.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.lcat.ac.th/"],
    name: "Lamphun College of Agriculture and Technology",
    alpha_two_code: "TH",
    "state-province": "Lamphun",
    domains: ["lcat.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.lcct.ac.th/"],
    name: "Lampang College of Commerce and Technology",
    alpha_two_code: "TH",
    "state-province": "Lampang",
    domains: ["lcct.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.lpru.ac.th/"],
    name: "Lampang Rajabhat University",
    alpha_two_code: "TH",
    "state-province": "Lampang",
    domains: ["lpru.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.mahidol.ac.th/"],
    name: "Mahidol University",
    alpha_two_code: "TH",
    "state-province": "Nakhon Pathom",
    domains: ["mahidol.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.mbu.ac.th/"],
    name: "Mahamakut Buddhist University",
    alpha_two_code: "TH",
    "state-province": "Nakhon Pathom",
    domains: ["mbu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.mcu.ac.th/"],
    name: "Mahachulalongkorn Buddhist University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["mcu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.mfu.ac.th/"],
    name: "Mae Fah Luang University",
    alpha_two_code: "TH",
    "state-province": "Chiang Rai",
    domains: ["mfu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.mju.ac.th/"],
    name: "Maejo University",
    alpha_two_code: "TH",
    "state-province": "Chiang Mai",
    domains: ["mju.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.msu.ac.th/"],
    name: "Mahasarakham University",
    alpha_two_code: "TH",
    "state-province": "Mahasarakham",
    domains: ["msu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.muic.mahidol.ac.th/"],
    name: "Mahidol University International College",
    alpha_two_code: "TH",
    "state-province": "Nakhon Pathom",
    domains: ["muic.mahidol.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.mut.ac.th/"],
    name: "Mahanakorn University of Technology",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["mut.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.nan.rmutl.ac.th/"],
    name: "Rajamangala University of Technology, Lanna Nan",
    alpha_two_code: "TH",
    "state-province": "Nan",
    domains: ["nan.rmutl.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.nida.ac.th/"],
    name: "National Institute of Development Administration",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["nida.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.nuv.ac.in/"],
    name: "Navrachana University",
    alpha_two_code: "IN",
    "state-province": "Gujarat",
    domains: ["nuv.ac.in"],
    country: "India",
  },
  {
    web_pages: ["http://www.nivadhana.ac.th/"],
    name: "Nivadhana University",
    alpha_two_code: "TH",
    "state-province": "Lamphun",
    domains: ["nivadhana.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.nu.ac.th/"],
    name: "Naresuan University",
    alpha_two_code: "TH",
    "state-province": "Phitsanulok",
    domains: ["nu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.payap.ac.th/"],
    name: "Payap University Chaiang Mai",
    alpha_two_code: "TH",
    "state-province": "Chiang Mai",
    domains: ["payap.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.psu.ac.th/"],
    name: "Prince of Songkla University",
    alpha_two_code: "TH",
    "state-province": "Songkhla",
    domains: ["psu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.ptu.ac.th/"],
    name: "Pathumthani University",
    alpha_two_code: "TH",
    "state-province": "Pathum Thani",
    domains: ["ptu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.rmutp.ac.th/"],
    name: "Rajamangala University of Technology, Phra Nakhon",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["rmutp.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www2.rsu.ac.th/"],
    name: "Rangsit University",
    alpha_two_code: "TH",
    "state-province": "Pathum Thani",
    domains: ["rsu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.ru.ac.th/"],
    name: "Ramkhamhaeng University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["ru.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.sau.ac.th/"],
    name: "South-East Asia University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["sau.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.shinawatra.ac.th/"],
    name: "Shinawatra University",
    alpha_two_code: "TH",
    "state-province": "Pathum Thani",
    domains: ["shinawatra.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.siam.edu/"],
    name: "Siam University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["siam.edu"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.spu.ac.th/"],
    name: "Sripatum University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["spu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.stamford.edu/"],
    name: "Stamford International University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["stamford.edu"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.stjohn.ac.th/"],
    name: "St. John's University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["stjohn.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.stou.ac.th/"],
    name: "Sukhothai Thammathirat Open University",
    alpha_two_code: "TH",
    "state-province": "Nonthaburi",
    domains: ["stou.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.su.ac.th/"],
    name: "Silpakorn University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["su.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.sut.ac.th/"],
    name: "Suranaree University of Technology",
    alpha_two_code: "TH",
    "state-province": "Nakhon Ratchasima",
    domains: ["sut.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.swu.ac.th/"],
    name: "Srinakharinwirot University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["swu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.tsu.ac.th/"],
    name: "Thaksin University",
    alpha_two_code: "TH",
    "state-province": "Songkhla",
    domains: ["tsu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.tu.ac.th/"],
    name: "Thammasat University",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["tu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.ubu.ac.th/"],
    name: "Ubonratchathani University",
    alpha_two_code: "TH",
    "state-province": "Ubonratchathani",
    domains: ["ubu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.utcc.ac.th/"],
    name: "University of the Thai Chamber of Commerce",
    alpha_two_code: "TH",
    "state-province": "Bangkok",
    domains: ["utcc.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.vu.ac.th/"],
    name: "Vongchavalitkul University",
    alpha_two_code: "TH",
    "state-province": "Nakhon Ratchasima",
    domains: ["vu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.webster.ac.th/"],
    name: "Webster University, Thailand",
    alpha_two_code: "TH",
    "state-province": "Petchaburi",
    domains: ["webster.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["https://www.wu.ac.th/"],
    name: "Walailak University",
    alpha_two_code: "TH",
    "state-province": "Nakhon Si Thammarat",
    domains: ["wu.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.nation.ac.th/"],
    name: "Nation University",
    alpha_two_code: "TH",
    "state-province": "Lampang",
    domains: ["nation.ac.th"],
    country: "Thailand",
  },
  {
    web_pages: ["http://www.univ-lome.tg/"],
    name: "Université de Lomé",
    alpha_two_code: "TG",
    "state-province": null,
    domains: ["univ-lome.tg"],
    country: "Togo",
  },
  {
    web_pages: ["http://www.usp.ac.fj/"],
    name: "University of the South Pacific Centre",
    alpha_two_code: "TO",
    "state-province": null,
    domains: ["usp.ac.fj"],
    country: "Tonga",
  },
  {
    web_pages: ["http://www.usc.edu.tt/"],
    name: "University of the Southern Caribbean",
    alpha_two_code: "TT",
    "state-province": null,
    domains: ["usc.edu.tt"],
    country: "Trinidad and Tobago",
  },
  {
    web_pages: ["http://www.utt.edu.tt/"],
    name: "University of Trinidad and Tobago",
    alpha_two_code: "TT",
    "state-province": null,
    domains: ["utt.edu.tt"],
    country: "Trinidad and Tobago",
  },
  {
    web_pages: ["http://www.uwi.tt/"],
    name: "University of the West Indies St. Augustine",
    alpha_two_code: "TT",
    "state-province": null,
    domains: ["uwi.tt"],
    country: "Trinidad and Tobago",
  },
  {
    web_pages: ["http://www.disfm.rnu.tn/"],
    name: "Instituts Supérieurs de Formation des Maîtres",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["disfm.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.isetr.rnu.tn/"],
    name: "Instituts Supérieurs des Etudes Technologiques",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["isetr.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.isg.rnu.tn/"],
    name: "Institut Supérieur de Gestion de Tunis",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["isg.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://u7nc.uvt.rnu.tn/"],
    name: "Université de 7 Novembre à Carthage",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["u7nc.uvt.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.ucaat.com/"],
    name: "Université Centrale",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["ucaat.com"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uc.rnu.tn/"],
    name: "Université du Centre, Sousse",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uc.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.ugaf.rnu.tn/"],
    name: "Université de Gafsa",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["ugaf.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uj.rnu.tn/"],
    name: "Université de Jendouba",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uj.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.ult.ens.tn/"],
    name: "Université Libre de Tunis",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["ult.ens.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uma.rnu.tn/"],
    name: "Université de la Manouba",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uma.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.um.rnu.tn/"],
    name: "Université de Monastir",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["um.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.unat.ens.tn/"],
    name: "University of Aviation and Technology",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["unat.ens.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.univgb.rnu.tn/"],
    name: "Université de Gabès",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["univgb.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.univ-k.rnu.tn/"],
    name: "Université de Kairouan",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["univ-k.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uss.rnu.tn/"],
    name: "Université de Sfax",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uss.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.utm.rnu.tn/"],
    name: "Université de Tunis El Manar",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["utm.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.utunis.rnu.tn/"],
    name: "Université de Tunis",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["utunis.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uvt.rnu.tn/"],
    name: "Université Virtuelle de Tunis",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uvt.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.uz.rnu.tn/"],
    name: "Université Ez-Zitouna",
    alpha_two_code: "TN",
    "state-province": null,
    domains: ["uz.rnu.tn"],
    country: "Tunisia",
  },
  {
    web_pages: ["http://www.adu.edu.tr/"],
    name: "Adnan Menderes University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["adu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ahievran.edu.tr/"],
    name: "Ahi Evran University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ahievran.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.akdeniz.edu.tr/"],
    name: "Akdeniz University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["akdeniz.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.aku.edu.tr/"],
    name: "Afyon Kocatepe University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["aku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.anadolu.edu.tr/"],
    name: "Anadolu University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["anadolu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ankara.edu.tr/"],
    name: "Ankara University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ankara.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.arel.edu.tr/"],
    name: "Istanbul Arel University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["arel.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.atauni.edu.tr/"],
    name: "Atatürk University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["atauni.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.atilim.edu.tr/"],
    name: "Atilim University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["atilim.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bahcesehir.edu.tr/"],
    name: "Bahcesehir University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bahcesehir.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.balikesir.edu.tr/"],
    name: "Balikesir University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["balikesir.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.baskent.edu.tr/"],
    name: "Baskent University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["baskent.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bayar.edu.tr/"],
    name: "Celal Bayar University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bayar.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.beykent.edu.tr/"],
    name: "Beykent University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["beykent.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bilecik.edu.tr/"],
    name: "Bilecik University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bilecik.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bilgi.edu.tr/"],
    name: "Istanbul Bilgi University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bilgi.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bilkent.edu.tr/"],
    name: "Bilkent University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bilkent.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.boun.edu.tr/"],
    name: "Boğaziçi University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["boun.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.cag.edu.tr/"],
    name: "Cag University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["cag.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.cankaya.edu.tr/"],
    name: "Cankaya University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["cankaya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.comu.edu.tr/"],
    name: "Canakkale (18th March) University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["comu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.cu.edu.tr/"],
    name: "Cukurova University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["cu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.cumhuriyet.edu.tr/"],
    name: "Cumhuriyet (Republik) University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["cumhuriyet.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.deu.edu.tr/"],
    name: "Dokuz Eylül University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["deu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.dho.edu.tr/"],
    name: "Turkish Naval Academy",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["dho.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.dicle.edu.tr/"],
    name: "Dicle (Tirgris) University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["dicle.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.dogus.edu.tr/"],
    name: "Dogus University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["dogus.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.dumlupinar.edu.tr/", "http://www.dpu.edu.tr/"],
    name: "Dumlupinar University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["dumlupinar.edu.tr", "dpu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ege.edu.tr/"],
    name: "Ege University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ege.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.erciyes.edu.tr/"],
    name: "Erciyes University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["erciyes.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.etu.edu.tr/"],
    name: "Tobb Economics and Technology University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["etu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.firat.edu.tr/"],
    name: "Firat (Euphrates) University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["firat.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["https://fbu.edu.tr/"],
    name: "Fenerbahce University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["fbu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gantep.edu.tr/"],
    name: "Gaziantep University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gantep.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gazi.edu.tr/"],
    name: "Gazi University Ankara",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gazi.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gop.edu.tr/"],
    name: "Gaziosmanpasa University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gop.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gsu.edu.tr/"],
    name: "Galatasaray University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gsu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gyte.edu.tr/"],
    name: "Gebze Institute of Technology",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gyte.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.halic.edu.tr/"],
    name: "Halic University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["halic.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.harran.edu.tr/"],
    name: "Harran University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["harran.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.hun.edu.tr/", "http://www.hacettepe.edu.tr/"],
    name: "Hacettepe University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["hun.edu.tr", "hacettepe.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ibu.edu.tr/"],
    name: "Abant Izzet Baysal University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ibu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.iku.edu.tr/"],
    name: "Istanbul Kultur University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["iku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.inonu.edu.tr/"],
    name: "Inönü University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["inonu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.isikun.edu.tr/"],
    name: "Isik University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["isikun.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.iticu.edu.tr/"],
    name: "Istanbul Ticaret University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["iticu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.itu.edu.tr/"],
    name: "Istanbul Technical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["itu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.iyte.edu.tr/"],
    name: "Izmir Institute of Technology",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["iyte.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.izmirekonomi.edu.tr/"],
    name: "Izmir Economic University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["izmirekonomi.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kafkas.edu.tr/"],
    name: "Kafkas University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kafkas.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.karaelmas.edu.tr/"],
    name: "Zonguldak Karaelmas University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["karaelmas.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.khas.edu.tr/"],
    name: "Kadir Has University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["khas.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kilis.edu.tr/"],
    name: "Kilis 7 Aralık University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kilis.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kku.edu.tr/"],
    name: "Kirikkale University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.konya.edu.tr/"],
    name: "Necmettin Erbakan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["konya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kou.edu.tr/"],
    name: "Kocaeli University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kou.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ksu.edu.tr/"],
    name: "Kahramanmaras Sütcü Imam University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ksu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ktu.edu.tr/"],
    name: "Karadeniz Technical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ktu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ku.edu.tr/"],
    name: "Koç University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.maltepe.edu.tr/"],
    name: "Maltepe University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["maltepe.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.marmara.edu.tr/"],
    name: "Marmara University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["marmara.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.mersin.edu.tr/"],
    name: "Mersin University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["mersin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.mku.edu.tr/"],
    name: "Mustafa Kemal University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["mku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.msu.edu.tr/"],
    name: "Mimar Sinan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["msu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.mu.edu.tr/"],
    name: "Mugla Sitki Kocman University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["mu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ohu.edu.tr/"],
    name: "Omer Halisdemir University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ohu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.nku.edu.tr/"],
    name: "Namik Kemal University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["nku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.metu.edu.tr/"],
    name: "Middle East Technical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["metu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ogu.edu.tr/"],
    name: "Osmangazi University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ogu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.omu.edu.tr/"],
    name: "Ondokuz Mayis University Samsun",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["omu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.odu.edu.tr"],
    name: "Ordu University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["odu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ozyegin.edu.tr/"],
    name: "Ozyegin University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ozyegin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.pamukkale.edu.tr/"],
    name: "Pamukkale University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["pamukkale.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: [
      "http://www.sabanciuniv.edu.tr/",
      "http://www.sabanciuniv.edu/",
    ],
    name: "Sabanci University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sabanciuniv.edu.tr", "sabanciuniv.edu"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sau.edu.tr/"],
    name: "Sakarya University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sau.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sdu.edu.tr/"],
    name: "Suleyman Demirel University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sdu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sehir.edu.tr/"],
    name: "Istanbul Şehir University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sehir.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.selcuk.edu.tr/"],
    name: "Selcuk University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["selcuk.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.tau.edu.tr/"],
    name: "Türkisch-Deutsche Universität",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["tau.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.trakya.edu.tr/"],
    name: "Trakya University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["trakya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ufuk.edu.tr/"],
    name: "Ufuk University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ufuk.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.uludag.edu.tr/"],
    name: "Uludag University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["uludag.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yalova.edu.tr/"],
    name: "Yalova University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yalova.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yasar.edu.tr/"],
    name: "Yasar University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yasar.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ybu.edu.tr/"],
    name: "Yildirim Beyazit University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ybu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yeditepe.edu.tr/"],
    name: "Yeditepe University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yeditepe.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yildiz.edu.tr/"],
    name: "Yildiz Technical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yildiz.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yyu.edu.tr/"],
    name: "Yüzüncü Yil (Centennial) University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yyu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ittu.edu.tm/"],
    name: "International Turkmen Turkish University",
    alpha_two_code: "TM",
    "state-province": null,
    domains: ["ittu.edu.tm"],
    country: "Turkmenistan",
  },
  {
    web_pages: ["http://www.charismauniversity.org/"],
    name: "Charisma University",
    alpha_two_code: "TC",
    "state-province": null,
    domains: ["charismauniversity.org"],
    country: "Turks and Caicos Islands",
  },
  {
    web_pages: ["http://www.aku.edu/"],
    name: "Aga Khan University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["aku.edu"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.bugemauniv.ac.ug/"],
    name: "Bugema University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["bugemauniv.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.busitema.ac.ug/"],
    name: "Busitema University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["busitema.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.busogauniversity.ac.ug/"],
    name: "Busoga University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["busogauniversity.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.cbu2000.com/"],
    name: "Central Buganda University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["cbu2000.com"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.gu.ac.ug/"],
    name: "Gulu University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["gu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.iuiu.ac.ug/"],
    name: "Islamic University in Uganda",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["iuiu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.kiu.ac.ug/"],
    name: "Kampala International University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["kiu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.ku.ac.ug/"],
    name: "Kampala University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["ku.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.kyu.ac.ug/"],
    name: "Kyambogo University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["kyu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.mak.ac.ug/"],
    name: "Makerere University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["mak.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.mmu.ac.ug/"],
    name: "Mountains of the Moon University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["mmu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.mru.ac.ug/"],
    name: "Mutesa 1 Royal University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["mru.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.must.ac.ug/"],
    name: "Mbarara University of Science and Technology",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["must.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.ndejjeuniversity.ac.ug/"],
    name: "Ndejje University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["ndejjeuniversity.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.nkumbauniversity.ac.ug/"],
    name: "Nkumba University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["nkumbauniversity.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.saiu.ac.ug/"],
    name: "St. Augustine International University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["saiu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.ucu.ac.ug/"],
    name: "Uganda Christian University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["ucu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.umu.ac.ug/"],
    name: "Uganda Martyr's University",
    alpha_two_code: "UG",
    "state-province": null,
    domains: ["umu.ac.ug"],
    country: "Uganda",
  },
  {
    web_pages: ["http://www.academy.sumy.ua/"],
    name: "Ukrainian Academy of Banking",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["academy.sumy.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.arosmu.org/"],
    name: "Odessa State Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["arosmu.org"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.btsau.kiev.ua/"],
    name: "Bila Cerkva State Agrarian University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["btsau.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.chnu.cv.ua/"],
    name: "Chernivci National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["chnu.cv.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.crsmu.com/"],
    name: "Crimea State Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["crsmu.com"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.diit.edu.ua/"],
    name: "Dnepropetrovsk National University of Railway Transport",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["diit.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.dnu.dp.ua/"],
    name: "Dnepropetrovsk National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["dnu.dp.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.donmeduni.com/"],
    name: "Donetsk State Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["donmeduni.com"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.donntu.edu.ua/"],
    name: "Donetsk National Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["donntu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.donnu.edu.ua/"],
    name: "Donetsk National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["donnu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.dstu.dp.ua/"],
    name: "Dneprodzerzhinsk State Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["dstu.dp.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.duep.edu/"],
    name: "Alfred Nobel University of Economics and Law",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["duep.edu"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.forest.lviv.ua/"],
    name: "Ukrainian National Forestry University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["forest.lviv.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.franko.lviv.ua/"],
    name: "Lviv National University Ivan Franko",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["franko.lviv.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.hneu.edu.ua/"],
    name: "Kharkiv National University of Economics",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["hneu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ifdtung.if.ua/"],
    name: "Ivano-Frankivsk National University of Oli and Gas",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ifdtung.if.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kdpu.edu.ua/"],
    name: "State Pedagogical University in Kryvyi Rih",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kdpu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.khadi.kharkov.ua/"],
    name: "Kharkiv State Transport Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["khadi.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.khai.edu/"],
    name: "National Aerospace University Kharkov Aviation Institute",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["khai.edu"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kma.mk.ua/"],
    name: "Petro Mohyla Black Sea State University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kma.mk.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kneu.kiev.ua/"],
    name: "Kiev National Economic University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kneu.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.knuba.edu.ua/"],
    name: "Kiev National University of Construction and Architecture",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["knuba.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kpi.kharkov.ua/"],
    name: "National Technical University (Kharkiv Polytechnical Institute)",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kpi.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kpi.ua/"],
    name: "National Technical University (Kiev Politechnical Institute)",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kpi.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.krok.edu.ua/"],
    name: "KROK Economics and Law University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["krok.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kse.org.ua/"],
    name: "Kiev School Of Economics",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kse.org.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ksmu.kharkov.ua/"],
    name: "Kharkiv State Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ksmu.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.kstuca.kharkov.ua/"],
    name: "Kharkiv State Technical University of Construction and Architecture",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["kstuca.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ksu.edu.ua/"],
    name: "Kiev Slavonic University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ksu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["https://nure.ua"],
    name: "Kharkiv National University of Radio Electronics",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nure.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.lgpu.lg.ua/"],
    name: "Luhansk Taras Shevchenko National Pedagogical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["lgpu.lg.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.lp.edu.ua/"],
    name: "Lviv Polytechnic National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["lp.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["https://www.lsmu.edu.ua/en/"],
    name: "Luhansk State Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["lsmu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ma.odessa.ua/"],
    name: "Odessa National Maritime Academy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ma.odessa.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.meduniv.lviv.ua/"],
    name: "Lviv National Medical Univeristy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["meduniv.lviv.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.nau.edu.ua/"],
    name: "National Aviation Univesity",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nau.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.nauu.kiev.ua/"],
    name: "National Agricultural University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nauu.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.nmetau.edu.ua/"],
    name: "National Metallurgical Academy of Ukraine",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nmetau.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.nmu.edu.ua/"],
    name: "National Medical University O.O. Bogomolets",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nmu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.nmu.org.ua/"],
    name: "National Mining University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["nmu.org.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.npu.edu.ua/"],
    name: "National Pedagogical University M. Dragomanov",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["npu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ntu.kar.net/"],
    name: "National Transport University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ntu.kar.net"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ogasa.odessa.ua/"],
    name: "Odessa State Academy of Construction and Architecture",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ogasa.odessa.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.onu.edu.ua/"],
    name: "Odessa National I.I. Mecnikov University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["onu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.opu.odessa.ua/"],
    name: "Odessa National Polytechnic University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["opu.odessa.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.osaft.odessa.ua/"],
    name: "Odessa National Academy of Food Technologies",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["osaft.odessa.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.osmu.odessa.ua/"],
    name: "Odessa National Marine University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["osmu.odessa.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.pntu.edu.ua/"],
    name: "Poltava National Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["pntu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.pu.if.ua/"],
    name: "Precarpathian University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["pu.if.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.pusku.edu.ua/"],
    name: "Poltava University of Consumer Cooperatives in Ukraine",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["pusku.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.sau.sumy.ua/"],
    name: "Sumy National Agrarian University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["sau.sumy.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://sevntu.com.ua/"],
    name: "Sevastopol National Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["sevntu.com.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.snu.edu.ua/"],
    name: "East Ukrainian National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["snu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.sumdu.edu.ua/"],
    name: "Sumy State University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["sumdu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.tane.edu.ua/"],
    name: "Ternopil Academy of National Economy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["tane.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.tnu.crimea.ua/"],
    name: "Taurida National V.I.Vernadsky University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["tnu.crimea.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.tu.edu.te.ua/"],
    name: "Ternopil State Ivan Pul'uj Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["tu.edu.te.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.tup.km.ua/"],
    name: "Khmelnitsky National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["tup.km.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.tup.km.ua/"],
    name: "Technological University of Podillya",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["tup.km.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.uamsa.net/"],
    name: "Ukrainian Medical Stomatological Academy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["uamsa.net"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ukma.kiev.ua/"],
    name: "National University of Kiev-Mohyla Academy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ukma.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.ukrfa.kharkov.ua/"],
    name: "Ukrainian Academy of Pharmacy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["ukrfa.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.univd.edu.ua/"],
    name: "National University of Internal Affairs",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["univd.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.univer.kharkov.ua/"],
    name: "Kharkiv National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["univer.kharkov.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.university.kherson.ua/"],
    name: "Kherson State University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["university.kherson.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.univ.kiev.ua/"],
    name: "National Taras Shevchenko University of Kiev",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["univ.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.univ.uzhgorod.ua/"],
    name: "Uzhgorod National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["univ.uzhgorod.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.uosa.uar.net/"],
    name: "National University of Ostroh Academy",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["uosa.uar.net"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.usmtu.edu.ua/"],
    name: "National University of Shipbuilding",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["usmtu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.usuft.kiev.ua/"],
    name: "National University of Food Technologies",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["usuft.kiev.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.vdu.edu.ua/"],
    name: "Volyn National University Lesja Ukrainka",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["vdu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.vnmu.vn.ua/"],
    name: "National Pirogov Memorial Medical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["vnmu.vn.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.vstu.vinnica.ua/"],
    name: "Vinnica National Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["vstu.vinnica.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.zntu.edu.ua/"],
    name: "Zaporizhzhe National Technical University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["zntu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.znu.edu.ua/"],
    name: "Zaporizhzhe National University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["znu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["https://www.lnu.edu.ua/"],
    name: "Lviv University",
    alpha_two_code: "UA",
    "state-province": null,
    domains: ["lnu.edu.ua"],
    country: "Ukraine",
  },
  {
    web_pages: ["http://www.acd.ac.ae/"],
    name: "American College Of Dubai",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["acd.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.adu.ac.ae/"],
    name: "Abu Dhabi University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["adu.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.agu.ae/"],
    name: "Al Ghurair University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["agu.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ajman.ac.ae/"],
    name: "Ajman University of Science & Technology",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ajman.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.alainuniversity.ac.ae/"],
    name: "Alain University of Science and Technology",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["alainuniversity.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.alhosnu.ae/"],
    name: "Alhosn University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["alhosnu.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.aud.edu/"],
    name: "American University in Dubai",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["aud.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.aue.ae/"],
    name: "American University in the Emirates",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["aue.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.aus.edu/"],
    name: "American University of Sharjah",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["aus.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.buid.ac.ae/"],
    name: "British University in Dubai",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["buid.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.dmcg.edu/"],
    name: "Dubai Medical College for Girls",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["dmcg.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.dpc.edu/"],
    name: "Dubai Pharmacy College",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["dpc.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://dubai.rit.edu/"],
    name: "Rochester Institute of Technology, Dubai",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["dubai.rit.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ece.ac.ae/"],
    name: "Etisalat University College",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ece.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.emiratesacademy.edu/"],
    name: "The Emirates Academy of Hotel Managment",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["emiratesacademy.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.gmu.ac.ae/"],
    name: "Gulf Medical University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["gmu.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.hbmeu.ac.ae/"],
    name: "Hamdan Bin Mohammed e-University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["hbmeu.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.hct.ac.ae/"],
    name: "Higher Colleges of Technology",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["hct.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ittihad.ac.ae/"],
    name: "Ittihad University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ittihad.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ju.ac.ae/"],
    name: "Jumeira University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ju.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.khawarizmi.com/"],
    name: "Al Khawarizmi International College",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["khawarizmi.com"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ku.ac.ae/"],
    name: "Khalifa University of Science, Technology and Research",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ku.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.kustar.ac.ae/"],
    name: "Khalifa University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["kustar.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.masdar.ac.ae/"],
    name: "Masdar University Of Science And Technology",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["masdar.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://nyuad.nyu.edu/"],
    name: "New York University, Abu Dhabi",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["nyuad.nyu.edu"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.pi.ac.ae/"],
    name: "The Petroleum Institute",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["pi.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.rakmhsu.com/"],
    name: "Rak Medical & Health Sciences University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["rakmhsu.com"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.sharjah.ac.ae/"],
    name: "University of Sharjah",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["sharjah.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.skylineuniversity.com/"],
    name: "Skyline University College, Sharjah",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["skylineuniversity.com"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.sorbonne.ae/"],
    name: "Paris-Sorbonne University Abu Dhabi",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["sorbonne.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.uaeu.ac.ae/"],
    name: "United Arab Emirates University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["uaeu.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.ud.ac.ae/"],
    name: "University Of Dubai",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["ud.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.uojazeera.com/"],
    name: "University of Jazeera",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["uojazeera.com"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.uowdubai.ac.ae/"],
    name: "University of Wollongong - Dubai Campus",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["uowdubai.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.zu.ac.ae/"],
    name: "Zayed University",
    alpha_two_code: "AE",
    "state-province": null,
    domains: ["zu.ac.ae"],
    country: "United Arab Emirates",
  },
  {
    web_pages: ["http://www.abdn.ac.uk/"],
    name: "University of Aberdeen",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["abdn.ac.uk", "aberdeen.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.aber.ac.uk/"],
    name: "University of Wales, Aberystwyth",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["aber.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.abertay.ac.uk/"],
    name: "University of Abertay Dundee",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["abertay.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.aiuniv.edu/"],
    name: "American InterContinental University - London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["aiuniv.edu"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.aku.edu/"],
    name: "Aga Khan University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["aku.edu"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.anglia.ac.uk/"],
    name: "Anglia Ruskin University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["anglia.ac.uk", "student.aru.ac.uk", "student.anglia.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.aston.ac.uk/"],
    name: "Aston University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["aston.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.aul.edu/"],
    name: "The American University in London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["aul.edu"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bangor.ac.uk/"],
    name: "University of Wales, Bangor",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bangor.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bath.ac.uk/"],
    name: "University of Bath",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bath.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bbk.ac.uk/"],
    name: "Birkbeck College, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bbk.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bcom.ac.uk/"],
    name: "British College of Osteopathic Medicine",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bcom.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bcu.ac.uk/"],
    name: "Birmingham City University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bcu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.beds.ac.uk/"],
    name: "University of Bedfordshire",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["beds.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bham.ac.uk/"],
    name: "University of Birmingham",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bham.ac.uk", "student.bham.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bolton.ac.uk/"],
    name: "University of Bolton",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bolton.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bournemouth.ac.uk/"],
    name: "Bournemouth University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bournemouth.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.brad.ac.uk/"],
    name: "University of Bradford",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["brad.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.brijnet.org/lsjs/"],
    name: "London School of Jewish Studies",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["brijnet.org"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bris.ac.uk/"],
    name: "University of Bristol",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bris.ac.uk", "my.bristol.ac.uk", "bristol.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.brookes.ac.uk/"],
    name: "Oxford Brookes University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["brookes.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.brunel.ac.uk/"],
    name: "Brunel University Uxbridge",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["brunel.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bton.ac.uk/"],
    name: "University of Brighton",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bton.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bton.ac.uk/"],
    name: "Brighton and Sussex medical school",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uni.bsms.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.buck.ac.uk/"],
    name: "University of Buckingham",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["buck.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.bucks.ac.uk/"],
    name: "Buckinghamshire New University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["bucks.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.cam.ac.uk/"],
    name: "University of Cambridge",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["cam.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.camb.linst.ac.uk/"],
    name: "Camberwell College of Arts",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["camb.linst.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.canterbury.ac.uk/"],
    name: "Canterbury Christ Church University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["canterbury.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.cardiff.ac.uk/"],
    name: "Cardiff University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["cardiff.ac.uk", "cf.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.chelsea.linst.ac.uk/"],
    name: "Chelsea College of Art and Design",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["chelsea.linst.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.chester.ac.uk/"],
    name: "University of Chester",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["chester.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.city.ac.uk/"],
    name: "City University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["city.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.courtauld.ac.uk/"],
    name: "Courtauld Institute of Art, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["courtauld.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.coventry.ac.uk/"],
    name: "Coventry University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["coventry.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.cranfield.ac.uk/"],
    name: "Cranfield University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["cranfield.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.csm.linst.ac.uk/"],
    name: "Central Saint Martins College of Art & Design",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["csm.linst.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.derby.ac.uk/"],
    name: "University of Derby",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["derby.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.dmu.ac.uk/"],
    name: "De Montfort University Leicester",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["dmu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.dundee.ac.uk/"],
    name: "University of Dundee",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["dundee.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.dur.ac.uk/"],
    name: "University of Durham",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["dur.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.edgehill.ac.uk/"],
    name: "Edge Hill University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["edgehill.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ed.ac.uk/"],
    name: "University of Edinburgh",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ed.ac.uk", "sms.ed.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.eselondon.ac.uk/"],
    name: "European School of Economics",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["eselondon.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.essex.ac.uk/"],
    name: "University of Essex",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["essex.ac.uk", "sx.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ex.ac.uk/"],
    name: "University of Exeter",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ex.ac.uk", "exeter.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.falmouth.ac.uk/"],
    name: "Falmouth University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["falmouth.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gcal.ac.uk/"],
    name: "Glasgow Caledonian University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["gcal.ac.uk", "gcu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gla.ac.uk/"],
    name: "University of Glasgow",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["gla.ac.uk", "student.gla.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.glam.ac.uk/"],
    name: "University of Glamorgan",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["glam.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.glos.ac.uk/"],
    name: "University of Gloucestershire",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["glos.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gold.ac.uk/"],
    name: "Goldsmiths College, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["gold.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gre.ac.uk/"],
    name: "University of Greenwich",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["gre.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.gsa.ac.uk/"],
    name: "Glasgow School of Art",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["gsa.ac.uk", "student.gsa.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.halifaxuni.ac/"],
    name: "University of Halifax, Birmingham Campus",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["halifaxuni.ac"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.herts.ac.uk/"],
    name: "University of Hertfordshire",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["herts.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.heythrop.ac.uk/"],
    name: "Heythrop College, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["heythrop.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.hope.ac.uk/"],
    name: "Liverpool Hope University College",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["hope.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.hud.ac.uk/"],
    name: "University of Huddersfield",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["hud.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.hull.ac.uk/"],
    name: "University of Hull",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["hull.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.huron.ac.uk/"],
    name: "Huron University USA in London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["huron.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.hw.ac.uk/"],
    name: "Heriot-Watt University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["hw.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.imperial.ac.uk/"],
    name: "Imperial College London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["imperial.ac.uk", "ic.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ifslearning.ac.uk/"],
    name: "ifs University College",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ifslearning.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://ihr.sas.ac.uk/"],
    name: "Institue of Historical Research, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ihr.sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ihr.sas.ac.uk/ics/"],
    name: "Institute of Commonwealth Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ihr.sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ioe.ac.uk/"],
    name: "Institute of Education, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ioe.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.islamiccolleges.com/"],
    name: "International Colleges of Islamic Science",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["islamiccolleges.com"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.kcl.ac.uk/"],
    name: "King's College London, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["kcl.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.keele.ac.uk/"],
    name: "Keele University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["keele.ac.uk", "students.keele.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.kingston.ac.uk/"],
    name: "Kingston University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["kingston.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.kolieh.com/"],
    name: "International Centre for Isclamic Science",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["kolieh.com"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lamp.ac.uk/"],
    name: "University of Wales, Lampeter",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lamp.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lancs.ac.uk/"],
    name: "University of Lancaster",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lancs.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lboro.ac.uk/"],
    name: "Loughborough University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lboro.ac.uk", "student.lboro.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lbs.lon.ac.uk/"],
    name: "London Business School",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lbs.lon.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lcst.ac/"],
    name: "London College of Science & Technology",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lcst.ac"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.le.ac.uk/"],
    name: "University of Leicester",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["le.ac.uk", "student.le.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.leeds.ac.uk/"],
    name: "University of Leeds",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["leeds.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lgu.ac.uk/"],
    name: "London Guildhall University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lgu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.limt.co.uk/"],
    name: "London Institute of Management and Technology",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["limt.co.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lincoln.ac.uk/"],
    name: "University of Lincoln",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lincoln.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.liv.ac.uk/"],
    name: "University of Liverpool",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["liv.ac.uk", "liverpool.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["https://www.ljmu.ac.uk/"],
    name: "Liverpool John Moores University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ljmu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lmu.ac.uk/"],
    name: "Leeds Metropolitan University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lmu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lon.ac.uk/"],
    name: "University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lon.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.londonmet.ac.uk/"],
    name: "London Metropolitan University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["londonmet.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lsbf.org.uk/"],
    name: "London School of Business & Finance",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lsbf.org.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lse.ac.uk/"],
    name: "London School of Economics and Political Science, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lse.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.lshtm.ac.uk/"],
    name: "London School of Hygiene & Tropical Medicine, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["lshtm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.manchester.ac.uk/"],
    name: "University of Manchester",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["manchester.ac.uk", "mbs.ac.uk", "man.ac.uk", "student.manchester.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.mdx.ac.uk/"],
    name: "Middlesex University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["mdx.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.med.ic.ac.uk/"],
    name: "Imperial College School of Medicine",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["med.ic.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.mmu.ac.uk/"],
    name: "The Manchester Metropolitan University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["mmu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.napier.ac.uk/"],
    name: "Napier University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["napier.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ncl.ac.uk/"],
    name: "University of Newcastle-upon-Tyne",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ncl.ac.uk", "newcastle.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.newport.ac.uk/"],
    name: "University of Wales, Newport",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["newport.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.niu.org.uk/"],
    name: "Newport International University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["niu.org.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.northampton.ac.uk/"],
    name: "University of Northampton",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["northampton.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.nottingham.ac.uk/"],
    name: "University of Nottingham",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["nottingham.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ntu.ac.uk/"],
    name: "Nottingham Trent University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ntu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.open.ac.uk/"],
    name: "Open University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["open.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ox.ac.uk/"],
    name: "University of Oxford",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["oxford.ac.uk", "ox.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.paisley.ac.uk/"],
    name: "University of Paisley",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["paisley.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.plymouth.ac.uk/"],
    name: "University of Plymouth",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["plymouth.ac.uk", "students.plymouth.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.port.ac.uk/"],
    name: "University of Portsmouth",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["port.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.qmul.ac.uk/"],
    name: "Queen Mary, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["qmw.ac.uk", "qmul.ac.uk", "smd18.qmul.ac.uk","smd17.qmul.ac.uk","smd16.qmul.ac.uk","smd15.qmul.ac.uk","smd19.qmul.ac.uk","smd20.qmul.ac.uk","smd21.qmul.ac.uk","smd22.qmul.ac.uk","smd23.qmul.ac.uk","smd24.qmul.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.qub.ac.uk/"],
    name: "The Queen's University Belfast",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["qub.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ram.ac.uk/"],
    name: "Royal Academy of Music, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ram.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.rca.ac.uk/"],
    name: "Royal College of Art",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["rca.ac.uk", "network.rca.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.rcm.ac.uk/"],
    name: "Royal College of Music, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["rcm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.rdg.ac.uk/"],
    name: "University of Reading",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["rdg.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.rfhsm.ac.uk/"],
    name: "Royal Free Hospital School of Medicine, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["rfhsm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.rgu.ac.uk/"],
    name: "The Robert Gordon University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["rgu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.royalholloway.ac.uk/"],
    name: "Royal Holloway and Bedford New College",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["royalholloway.ac.uk", "rhbnc.ac.uk", "rh.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.richmond.ac.uk/"],
    name: "Richmond University - The American International University in London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["richmond.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.roehampton.ac.uk/"],
    name: "Roehampton University of Surrey",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["roehampton.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.salford.ac.uk/"],
    name: "University of Salford",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["salford.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sas.ac.uk/ials/"],
    name: "Institute of Advanced Legal Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sas.ac.uk/icls/"],
    name: "Institute of Classical Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sas.ac.uk/igs/"],
    name: "Institute of Germanic Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sas.ac.uk/ilas/"],
    name: "Institute of Latin American Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sas.ac.uk/warburg/"],
    name: "Warburg Institute, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sbu.ac.uk/"],
    name: "South Bank University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sbu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.schillerlondon.ac.uk/"],
    name: "Schiller International University, London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["schillerlondon.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sclondon.ac/"],
    name: "Stratford College London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sclondon.ac"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sghms.ac.uk/"],
    name: "Saint George's Hospital Medical School, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sghms.ac.uk", "sgul.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.shef.ac.uk/"],
    name: "University of Sheffield",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["shef.ac.uk", "sheffield.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.shu.ac.uk/"],
    name: "Sheffield Hallam University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["shu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.smu.ac.uk/"],
    name: "Swansea Metropolitan University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["smu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.soas.ac.uk/"],
    name: "School of Oriental and African Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["soas.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.solent.ac.uk/"],
    name: "Southampton Solent University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["solent.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sothebysinstitutelondon.com/"],
    name: "Sotheby´s Institute of Art - London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sothebysinstitutelondon.com"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.southampton.ac.uk/"],
    name: "University of Southampton",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["soton.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ssees.ac.uk/"],
    name: "School of Slavonic and East European Studies, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ssees.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.staffs.ac.uk/"],
    name: "Staffordshire University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["staffs.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["https://www.st-andrews.ac.uk/"],
    name: "University of St. Andrews",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["st-andrews.ac.uk", "st-and.ac.uk", "scotgem.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.stir.ac.uk/"],
    name: "University of Stirling",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["stir.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.st-patricks.ac.uk/"],
    name: "St.Patrick's International College, London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["st-patricks.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.strath.ac.uk/"],
    name: "University of Strathclyde",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["strath.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sunderland.ac.uk/"],
    name: "University of Sunderland",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sunderland.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.surrey.ac.uk/"],
    name: "University of Surrey",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["surrey.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.sussex.ac.uk/"],
    name: "University of Sussex",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["sussex.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.swan.ac.uk/"],
    name: "University of Wales, Swansea",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["swan.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.tcm.ac.uk/"],
    name: "Trinity College of Music",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["tcm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.tees.ac.uk/"],
    name: "University of Teesside",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["tees.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.trinity-cm.ac.uk/"],
    name: "Trinity College Carmarthen",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["trinity-cm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.tvu.ac.uk/"],
    name: "Thames Valley University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["tvu.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ucl.ac.uk/"],
    name: "University College London, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ucl.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uclan.ac.uk/"],
    name: "University of Central Lancashire",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uclan.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ucs.ac.uk/"],
    name: "University Campus Suffolk",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ucs.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uea.ac.uk/"],
    name: "University of East Anglia",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uea.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uel.ac.uk/"],
    name: "University of East London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uel.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ukc.ac.uk/"],
    name: "University of Kent at Canterbury",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ukc.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ulsop.ac.uk/"],
    name: "School of Pharmacy, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ulsop.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.ulst.ac.uk/"],
    name: "University of Ulster",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["ulst.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.umds.ac.uk/"],
    name: "United Medical and Dental Schools, University of London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["umds.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.unl.ac.uk/"],
    name: "University of North London",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["unl.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.unn.ac.uk/"],
    name: "University of Northumbria at Newcastle",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["unn.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uwcm.ac.uk/"],
    name: "University of Wales College of Medicine",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uwcm.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uwe.ac.uk/"],
    name: "University of the West of England, Bristol",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uwe.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.uwic.ac.uk/"],
    name: "University of Wales Institute, Cardiff",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["uwic.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.wales.ac.uk/"],
    name: "University of Wales",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["wales.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.warnborough.edu/"],
    name: "Warnborough University",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["warnborough.edu"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.warwick.ac.uk/"],
    name: "University of Warwick",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["warwick.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.westminster.ac.uk/"],
    name: "University of Westminster",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["westminster.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.williamgilbert.co.uk/"],
    name: "William Gilbert College",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["williamgilbert.co.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.wimbledon.ac.uk/"],
    name: "Wimbledon School of Art",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["wimbledon.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.wlv.ac.uk/"],
    name: "University of Wolverhampton",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["wlv.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.worc.ac.uk/"],
    name: "University of Worcester",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["worc.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.york.ac.uk/"],
    name: "University of York",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["york.ac.uk", "york.nhs.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.york.ac.uk/"],
    name: "Hull-York medical school",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["hyms.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["https://www.mbro.ac.uk/"],
    name: "Middlesbrough College",
    alpha_two_code: "GB",
    "state-province": null,
    domains: ["middlesbro.ac.uk", "mbro.ac.uk"],
    country: "United Kingdom",
  },
  {
    web_pages: ["http://www.claeh.edu.uy/"],
    name: "Insituto Universitario - Centro Latinoamericano de Economia Humana - IU Claeh",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["claeh.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.ort.edu.uy/"],
    name: "Universidad ORT Uruguay",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["ort.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.ucu.edu.uy/"],
    name: "Universidad Católica del Uruguay",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["ucu.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.ude.edu.uy/"],
    name: "Universidad de la Empresa (UDE)",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["ude.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.um.edu.uy/"],
    name: "Universidad de Montevideo",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["um.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.universidad.edu.uy/"],
    name: "Universidad de la República",
    alpha_two_code: "UY",
    "state-province": null,
    domains: ["universidad.edu.uy"],
    country: "Uruguay",
  },
  {
    web_pages: ["http://www.agrar.uz/"],
    name: "Tashkent State Agrarian University",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["agrar.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://ferpi.dem.ru/"],
    name: "Ferghana Politechnical Institute",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["ferpi.dem.ru"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.ibs.uz/"],
    name: "International Business School Kelajak ILMI",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["ibs.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.mdis.uz/"],
    name: "Management Development Institute of Singapore, Tashkent",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["mdis.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.ndpi.uz/"],
    name: "Nukus State Teachers Training Institute",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["ndpi.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.nuu.uz/"],
    name: "National University of Uzbekistan",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["nuu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.pharmi.uz/"],
    name: "Tashkent Pharmaceutical Institute",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["pharmi.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.polito.uz/"],
    name: "Turin Polytechnic University In Tashkent",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["polito.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.qdpi.uz/"],
    name: "Kokand State Pedagogical Institute",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["qdpi.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.samdu.uz/"],
    name: "Samarkand State University",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["samdu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tashgiv.uz/"],
    name: "Tashkent State University of Oriental Studies",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tashgiv.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tayi.uz/"],
    name: "Tashkent Automobile and Roads Institute",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tayi.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tdiu.uz/"],
    name: "Tashkent State University of Economics",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tdiu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tdtu.uz/"],
    name: "Tashkent State Technical University",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tdtu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tfi.uz/"],
    name: "Tashkent School of Finance",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tfi.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tiim.uz/"],
    name: "Tashkent Institute of Irrigation and Melioration",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tiim.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tiu.uz/"],
    name: "Tashkent Islam University",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tiu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tma.uz/"],
    name: "Tashkent Medical Academy",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tma.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.tuit.uz/"],
    name: "Tashkent University of Information Technologies",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["tuit.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.uwed.uz/"],
    name: "University of World Economy and Diplomacy",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["uwed.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.uzswlu.uz/"],
    name: "Uzbek State World Languages University",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["uzswlu.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.wiut.uz/"],
    name: "Westminster International University in Tashkent",
    alpha_two_code: "UZ",
    "state-province": null,
    domains: ["wiut.uz"],
    country: "Uzbekistan",
  },
  {
    web_pages: ["http://www.luz.ve/index2.html"],
    name: "Universidad del Zulia",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["luz.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uba.edu.ve/"],
    name: "Universidad Bicentenaria de Aragua",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uba.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ubv.edu.ve/"],
    name: "Universidad Bolivariana de Venezuela",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ubv.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ucab.edu.ve/"],
    name: "Universidad Católica Andres Bello",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ucab.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ucat.edu.ve/"],
    name: "Universidad Católica del Táchira",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ucat.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uc.edu.ve/"],
    name: "Universidad de Carabobo",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uc.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ucla.edu.ve/"],
    name: "Universidad Centro Occidental Lisandro Alvarado",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ucla.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ucv.ve/"],
    name: "Universidad Central de Venezuela",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ucv.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.udo.edu.ve/"],
    name: "Universidad de Oriente",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["udo.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uft.edu.ve/"],
    name: "Universidad Fermin Toro",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uft.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ugma.edu.ve/"],
    name: "Universidad Gran Mariscal de Ayacucho",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ugma.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ujap.edu.ve/"],
    name: "Universidad José Antonio Páez",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ujap.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ujmv.edu/"],
    name: "Universidad José Maria Vargas",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ujmv.edu"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.ula.ve/"],
    name: "Universidad de Los Andes",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["ula.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.una.edu.ve/"],
    name: "Universidad Nacional Abierta",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["una.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.une.edu.ve/"],
    name: "Universidad Nueva Esparta",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["une.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unefa.edu.ve/"],
    name: "Universidad Nacional Experimental de la Fuerza Armada",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unefa.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unefm.edu.ve/"],
    name: 'Universidad Nacional Experimental "Francisco de Miranda"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unefm.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uneg.edu.ve/"],
    name: "Universidad Nacional Experimental de Guayana",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uneg.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unellez.edu.ve/"],
    name: 'Universidad Nacional Experimental de los Llanos Occidentales "Ezequiel Zamora"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unellez.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unerg.edu.ve/"],
    name: "Universidad Nacional Experimental Romulo Gallegos",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unerg.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unermb.edu.ve/"],
    name: 'Universidad Nacional Experimental "Rafael Maria Baralt"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unermb.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unesr.edu.ve/"],
    name: 'Universidad Nacional Experimental "Simón Rodriguez"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unesr.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unesur.edu.ve/"],
    name: 'Universidad Nacional Experimental Sur del Lago "Jesús Maria Semprum"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unesur.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unet.edu.ve/"],
    name: "Universidad Nacional Experimental del Táchira",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unet.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unexpo.edu.ve/"],
    name: 'Universidad Nacional Experimental Politécnica "Antonio José de Sucre"',
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unexpo.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unica.edu.ve/"],
    name: "Universidad Católica Cecilio Acosta",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unica.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unimet.edu.ve/"],
    name: "Universidad Metropolitana",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unimet.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.unitec.edu.ve/"],
    name: "Universidad Tecnológica del Centro",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["unitec.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.universidad-monteavila.edu.ve/"],
    name: "Universidad Monteávila",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["universidad-monteavila.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.upel.edu.ve/"],
    name: "Universidad Pedagógica Experimental Libertador",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["upel.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.urbe.edu/"],
    name: "Universidad Dr. Rafael Belloso Chacín",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["urbe.edu"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uru.edu/"],
    name: "Universidad Rafael Urdaneta",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uru.edu"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.usb.ve/"],
    name: "Universidad Simón Bolivar",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["usb.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://usm.trompo.com/"],
    name: "Universidad Santa Maria Caracas",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["usm.trompo.com"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.uvm.edu.ve/"],
    name: "Universidad Valle del Momboy",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["uvm.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.yacambu.edu.ve/"],
    name: "Universidad Yacambu",
    alpha_two_code: "VE",
    "state-province": null,
    domains: ["yacambu.edu.ve"],
    country: "Venezuela, Bolivarian Republic of",
  },
  {
    web_pages: ["http://www.bdu.edu.vn/"],
    name: "Binh Duong University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["bdu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.buh.edu.vn/"],
    name: "Banking University of Ho Chi Minh City",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["buh.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ctu.edu.vn/"],
    name: "Can-Tho University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ctu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.dct.udn.vn/"],
    name: "Danang College Of Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["dct.udn.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.dhxd.edu.vn/"],
    name: "Hanoi University of Civil Engineering",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["dhxd.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.dlu.edu.vn/"],
    name: "University of Da Lat",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["dlu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.fpt.edu.vn/"],
    name: "FPT University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["fpt.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ftu.edu.vn/"],
    name: "Foreign Trade University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ftu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hau.edu.vn/"],
    name: "Hanoi University of Architecture",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hau.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmuaf.edu.vn/"],
    name: "Ho Chi Minh City University of Agriculture and Forestry",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmuaf.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmuarc.edu.vn/"],
    name: "Ho Chi Minh City University of Architecture",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmuarc.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmulaw.edu.vn/"],
    name: "Ho Chi Minh City University of Law",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmulaw.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmuns.edu.vn/"],
    name: "Ho Chi Minh City University of Natural Sciences",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmuns.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmupeda.edu.vn/"],
    name: "Ho Chi Minh City University of Pedagogics",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmupeda.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmussh.edu.vn/"],
    name: "Ho Chi Minh City University of Social Sciences and Humanities",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmussh.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmut.edu.vn/"],
    name: "Ho Chi Minh City University of Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmut.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmute.edu.vn/"],
    name: "University of Technical Education Ho Chi Minh City",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmute.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hcmutrans.edu.vn/"],
    name: "Ho Chi Minh City University of Transport",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hcmutrans.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hmu.edu.vn/"],
    name: "Hanoi Medical University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hmu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hou.edu.vn/"],
    name: "Hanoi Open University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hou.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hua.edu.vn/"],
    name: "Hanoi University of Agriculture",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hua.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.huaf.edu.vn/"],
    name: "Hue University of Agriculture and Forestry",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["huaf.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hueuni.edu.vn/"],
    name: "Hue University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hueuni.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.huflit.vnn.vn/"],
    name: "Ho Chi Minh City University of Foreign Languages and Information Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["huflit.vnn.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.humg.edu.vn/"],
    name: "Hanoi University of Mining and Geology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["humg.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hus.edu.vn/"],
    name: "Hanoi University of Science",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hus.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hut.edu.vn/"],
    name: "Hanoi University of Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hut.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hvtc.edu.vn/"],
    name: "Institute of Finance",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hvtc.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.hwru.edu.vn/"],
    name: "Water Resources University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hwru.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ktkt-haiduong.edu.vn/"],
    name: "Hai Duong University of  Economics and Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ktkt-haiduong.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.neu.edu.vn/"],
    name: "Hanoi National Economics University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["neu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ou.edu.vn/"],
    name: "Ho Chi Minh City Open University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ou.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ptit.edu.vn/"],
    name: "Posts & Telecommunications Institute of Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ptit.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.rmit.edu.vn/"],
    name: "RMIT International University Vietnam",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["rmit.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.sgu.edu.vn/"],
    name: "Saigon University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["sgu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.taynguyenuni.edu.vn/"],
    name: "Tay Nguyen University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["taynguyenuni.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.tuaf.edu.vn/"],
    name: "Thai Nguyen University of Agriculture and Forestry",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["tuaf.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.uct.edu.vn/"],
    name: "Hanoi Univerisity of Transportation",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["uct.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ud.edu.vn/"],
    name: "University of Da Nang",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ud.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.ueh.edu.vn/"],
    name: "Ho Chi Minh City University of Economics",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["ueh.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.vimaru.edu.vn/"],
    name: "Vietnam Maritime University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["vimaru.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.vnu.edu.vn/"],
    name: "Vietnam National University Hanoi",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["vnu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.vnuhcm.edu.vn/"],
    name: "Vietnam National University Ho Chi Minh City",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["vnuhcm.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.yds.edu.vn/"],
    name: "Ho Chi Minh City University of Medicine and Pharmacy",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["yds.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.pnt.edu.vn"],
    name: "Pham Ngoc Thach University of Medicine",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["pnt.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.vgu.edu.vn/"],
    name: "Vietnamese - German University",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["vgu.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.uvi.edu/"],
    name: "University of the Virgin Islands",
    alpha_two_code: "VG",
    "state-province": null,
    domains: ["uvi.edu"],
    country: "Virgin Islands, British",
  },
  {
    web_pages: ["http://www.adenuniversity.edu.ye/"],
    name: "University of Aden",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["adenuniversity.edu.ye"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.ahgaff.edu/"],
    name: "Alahgaff University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["ahgaff.edu"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.al-edu.com/"],
    name: "Al-Nasser University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["al-edu.com"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.arwauniversity.org/"],
    name: "Queen Arwa University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["arwauniversity.org"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.eman-univ.edu.ye/"],
    name: "Al-Eman University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["eman-univ.edu.ye"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.hoduniv.net.ye/"],
    name: "Hodeidah University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["hoduniv.net.ye"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.hust.edu.ye/"],
    name: "Hadhramout University of Science and Technology",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["hust.edu.ye"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.sabauni.net/"],
    name: "Saba University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["sabauni.net"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.su.edu.ye/"],
    name: "Sana'a University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["su.edu.ye"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.taizun.net/"],
    name: "Taiz University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["taizun.net"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.thuniv.net/"],
    name: "Thamar University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["thuniv.net"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.ust.edu/"],
    name: "University of Science and Technology Sana'a",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["ust.edu"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.yuniv.net/"],
    name: "Yemenia University",
    alpha_two_code: "YE",
    "state-province": null,
    domains: ["yuniv.net"],
    country: "Yemen",
  },
  {
    web_pages: ["http://www.cavendishza.org/"],
    name: "Cavendish University",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["cavendishza.org"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.cbu.edu.zm/"],
    name: "Copperbelt University",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["cbu.edu.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.mu.ac.zm/"],
    name: "Mulungushi University",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["mu.ac.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.rusangu-university.edu.zm/"],
    name: "Rusangu University",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["rusangu-university.edu.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.unilus.ac.zm/"],
    name: "University of Lusaka",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["unilus.ac.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.unza.zm/"],
    name: "University of Zambia",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["unza.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.zaou.ac.zm/"],
    name: "Zambian Open University",
    alpha_two_code: "ZM",
    "state-province": null,
    domains: ["zaou.ac.zm"],
    country: "Zambia",
  },
  {
    web_pages: ["http://www.africau.edu/"],
    name: "Africa University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["africau.edu"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.buse.ac.zw/"],
    name: "Bindura University of Science Education",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["buse.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.cut.ac.zw/"],
    name: "Chinhoyi University of Technology",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["cut.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.cuz.ac.zw/"],
    name: "Catholic University in Zimbabwe",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["cuz.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.gzu.ac.zw/"],
    name: "Great Zimbabwe University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["gzu.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.hit.ac.zw/"],
    name: "Harare Institute of Technology",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["hit.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.lsu.ac.zw/"],
    name: "Lupane State University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["lsu.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.msu.ac.zw/"],
    name: "Midlands State University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["msu.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.nust.ac.zw/"],
    name: "National University of Science and Technology Bulawayo",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["nust.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.rcu.ac.zw/"],
    name: "Reformed Church University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["rcu.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.solusi.ac.zw/"],
    name: "Solusi University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["solusi.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.uz.ac.zw/"],
    name: "University of Zimbabwe",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["uz.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.wua.ac.zw/"],
    name: "Women's University in Africa",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["wua.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.zegu.ac.zw/"],
    name: "Zimbabwe Ezekiel Guti University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["zegu.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.zou.ac.zw/"],
    name: "Zimbabwe Open University",
    alpha_two_code: "ZW",
    "state-province": null,
    domains: ["zou.ac.zw"],
    country: "Zimbabwe",
  },
  {
    web_pages: ["http://www.agu.edu.tr/"],
    name: "Abdullah Gul University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["agu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.agu.edu.tr/"],
    name: "Adana Science and Technology University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["adanabtu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.adiyaman.edu.tr/"],
    name: "Adiyaman University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["adiyaman.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.agri.edu.tr/"],
    name: "Agri Ibrahim Cecen University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["agri.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.aksaray.edu.tr/"],
    name: "Aksaray University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["aksaray.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.alanyaaku.edu.tr/"],
    name: "Alanya Alaaddin Keykubat University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["alanyaaku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.amasya.edu.tr/"],
    name: "Amasya University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["amasya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.asbu.edu.tr/"],
    name: "Ankara Social Science University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["asbu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ardahan.edu.tr/"],
    name: "Ardahan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ardahan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.artvin.edu.tr/"],
    name: "Artvin Coruh University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["artvin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bamdirma.edu.tr/"],
    name: "Bandirma ONYEDI Eylul University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bandirma.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bartin.edu.tr/"],
    name: "Bartin University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bartin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.batman.edu.tr/"],
    name: "Batman University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["batman.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bayburt.edu.tr/"],
    name: "Bayburt University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bayburt.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bilecik.edu.tr/"],
    name: "Bilecik Seyh Edebali University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bilecik.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bingol.edu.tr/"],
    name: "Bingol University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bingol.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.beu.edu.tr/"],
    name: "Bitlis Eren University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["beu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bozok.edu.tr/"],
    name: "Bozok University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bozok.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.btu.edu.tr/"],
    name: "Bursa Tecnical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["btu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.karatekin.edu.tr/"],
    name: "Cankiri karatekin University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["karatekin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.duzce.edu.tr/"],
    name: "Duzce University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["duzce.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.erzincan.edu.tr/"],
    name: "Erzincan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["erzincan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.erzurum.edu.tr/"],
    name: "Erzurum Tecnical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["erzurum.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gtu.edu.tr/"],
    name: "Gebze Tecnical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gtu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gata.edu.tr/"],
    name: "Gulhane military medical Academy",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gata.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gumushane.edu.tr/"],
    name: "Gumushane University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gumushane.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.hakkari.edu.tr/"],
    name: "Hakkari University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["hakkari.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.hho.edu.tr/"],
    name: "Air Force Academy",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["hho.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.hitit.edu.tr/"],
    name: "Hitit University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["hitit.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.igdir.edu.tr/"],
    name: "Igdir University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["igdir.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.iste.edu.tr/"],
    name: "Iskenderun Tecnical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["iste.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.medeniyet.edu.tr/"],
    name: "Istanbul Medeniyet University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["medeniyet.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.istanbul.edu.tr/"],
    name: "Istanbul University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["istanbul.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ikc.edu.tr/"],
    name: "Izmir Katip celebi University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ikc.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.karabuk.edu.tr/"],
    name: "Karabuk University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["karabuk.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kmu.edu.tr/"],
    name: "karamanoglu mehmet bey University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kmu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kastamonu.edu.tr/"],
    name: "Kastamonu University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kastamonu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kirklareli.edu.tr/"],
    name: "Kirklareli University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kirklareli.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.artuklu.edu.tr/"],
    name: "Mardin Artuklu University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["artuklu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.mehmetakif.edu.tr/"],
    name: "Mehmet Akif Ersoy University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["mehmetakif.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.msgsu.edu.tr/"],
    name: "Mimar Sinan Fine Arts University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["msgsu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.alparslan.edu.tr/"],
    name: "Mus Alparslan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["alparslan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.nevsehir.edu.tr/"],
    name: "Nevsehir Haci Bektas Veli University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["nevsehir.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.osmaniye.edu.tr/"],
    name: "Osmaniye Korkut Ata University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["osmaniye.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.erdogan.edu.tr/"],
    name: "Recep Tayip Erdogan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["erdogan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.siirt.edu.tr/"],
    name: "Siirt University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["siirt.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sinop.edu.tr/"],
    name: "Sinop University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sinop.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sirnak.edu.tr/"],
    name: "Sirnak University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sirnak.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.tunceli.edu.tr/"],
    name: "Tunceli University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["tunceli.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sbu.edu.tr/"],
    name: "Health Sciences University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sbu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.usak.edu.tr/"],
    name: "Usak University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["usak.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.beun.edu.tr/"],
    name: "Bulent Ecevit University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["beun.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.acibadem.edu.tr/"],
    name: "Acibadem University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["acibadem.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ahap.edu.tr/"],
    name: "Alanya Hamdullah Emin Pasa University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ahap.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.avrasya.edu.tr/"],
    name: "Avrasya University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["avrasya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.bezmialem.edu.tr/"],
    name: "Bezmialem Vakif University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["bezmialem.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.biruni.edu.tr/"],
    name: "Biruni University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["biruni.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.fatihsultan.edu.tr/"],
    name: "Fatih Sultan Mehmet University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["fatihsultan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gedik.edu.tr/"],
    name: "Gedik University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gedik.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.hku.edu.tr/"],
    name: "Hasan Kalyoncu University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["hku.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.29mayis.edu.tr/"],
    name: "Istanbul 29Mayis  University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["29mayis.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.aydin.edu.tr/"],
    name: "Istanbul Aydin University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["aydin.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.esenyurt.edu.tr/"],
    name: "Istanbul Esenyurt University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["esenyurt.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gelisim.edu.tr/"],
    name: "Istanbul Gelisim University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gelisim.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.kemerburgaz.edu.tr/"],
    name: "Istanbul Kemerburgaz  University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["kemerburgaz.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.medipol.edu.tr/"],
    name: "Istanbul Medipol University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["medipol.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.rumeli.edu.tr/"],
    name: "Istanbul Rumeli University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["rumeli.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.iszu.edu.tr/"],
    name: "Istanbul Sabahattin Zaim University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["iszu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ieu.edu.tr/"],
    name: "Izmir Economy University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ieu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.karatay.edu.tr/"],
    name: "Karatay University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["karatay.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.gidatarim.edu.tr/"],
    name: "Konya Gida Tarim University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["gidatarim.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.mef.edu.tr/"],
    name: "MEF University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["mef.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.nisantasi.edu.tr/"],
    name: "Nisantasi University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["nisantasi.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.nny.edu.tr/"],
    name: "Nuh Naci Yazgan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["nny.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.okan.edu.tr/"],
    name: "Okan University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["okan.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.pirireis.edu.tr/"],
    name: "Piri Reis University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["pirireis.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.sanko.edu.tr/"],
    name: "Sanko University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["sanko.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.tedu.edu.tr/"],
    name: "TED University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["tedu.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.toros.edu.tr/"],
    name: "Toros University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["toros.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.thk.edu.tr/"],
    name: "Turkish Aeronautical Association University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["thk.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.antalya.edu.tr/"],
    name: "Antalya international University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["antalya.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.uskudar.edu.tr/"],
    name: "Uskudar University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["uskudar.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yeniyuzyil.edu.tr/"],
    name: "Yeni Yuzyil University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yeniyuzyil.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.yuksekihtisasuniversitesi.edu.tr/"],
    name: "Yuksek ihtisas University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["yuksekihtisasuniversitesi.edu.tr"],
    country: "Turkey",
  },
  {
    web_pages: ["http://www.ascc.edu"],
    name: "Alabama Southern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ascc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bscc.edu"],
    name: "Bevill State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bishop.edu"],
    name: "Bishop State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bishop.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cacc.edu"],
    name: "Central Alabama Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cv.edu"],
    name: "Chattahoochee Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.escc.edu"],
    name: "Enterprise State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["escc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gadsdenstate.edu"],
    name: "Gadsden State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gadsdenstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wallace.edu"],
    name: "George C Wallace State Community College-​Dothan",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wallace.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wallacestate.edu"],
    name: "George C Wallace State Community College-​Hanceville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wallacestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wccs.edu"],
    name: "George C Wallace State Community College-​Selma",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trenholmstate.edu"],
    name: "H Councill Trenholm State Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trenholmstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.faulknerstate.edu"],
    name: "James H Faulkner State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["faulknerstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jdcc.edu"],
    name: "Jefferson Davis Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jdcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jeffstateonline.com"],
    name: "Jefferson State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jeffstateonline.com"],
    country: "United States",
  },
  {
    web_pages: ["http://www.drakestate.edu"],
    name: "J F Drake State Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["drakestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.calhoun.edu"],
    name: "Calhoun Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["calhoun.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lbwcc.edu"],
    name: "Lurleen B Wallace Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lbwcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marionmilitary.edu"],
    name: "Marion Military Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marionmilitary.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nacc.edu"],
    name: "Northeast Alabama Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwscc.edu"],
    name: "Northwest-​Shoals Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sheltonstate.edu"],
    name: "Shelton State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sheltonstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.snead.edu"],
    name: "Snead State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["snead.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.suscc.edu"],
    name: "Southern Union State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["suscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ilisagvik.edu"],
    name: "Ilisagvik College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ilisagvik.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://pwsc.alaska.edu"],
    name: "Prince William Sound College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pwsc.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.centralaz.edu"],
    name: "Central Arizona College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["centralaz.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cgc.maricopa.edu"],
    name: "Chandler-​Gilbert Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cgc.maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cochise.edu"],
    name: "Cochise College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cochise.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.coconino.edu/"],
    name: "Coconino Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coconino.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eac.edu"],
    name: "Eastern Arizona College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emc.maricopa.edu"],
    name: "Estrella Mountain Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emc.maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gatewaycc.edu"],
    name: "GateWay Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gatewaycc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gccaz.edu"],
    name: "Glendale Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gccaz.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mesacc.edu"],
    name: "Mesa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mesacc.edu", "maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mohave.edu"],
    name: "Mohave Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mohave.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.npc.edu"],
    name: "Northland Pioneer College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["npc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pvc.maricopa.edu"],
    name: "Paradise Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pvc.maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.phoenixcollege.edu"],
    name: "Phoenix College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["phoenixcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pima.edu"],
    name: "Pima Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pima.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rio.maricopa.edu"],
    name: "Rio Salado College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rio.maricopa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scottsdalecc.edu"],
    name: "Scottsdale Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scottsdalecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southmountaincc.edu"],
    name: "South Mountain Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southmountaincc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tocc.edu"],
    name: "Tohono O'Odham Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tocc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.YC.EDU"],
    name: "Yavapai College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.anc.edu"],
    name: "Arkansas Northeastern College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["anc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asub.edu"],
    name: "Arkansas State University-​Beebe",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asub.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asumh.edu"],
    name: "Arkansas State University-​Mountain Home",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asumh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asun.edu"],
    name: "Arkansas State University-​Newport",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asun.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.blackrivertech.edu"],
    name: "Black River Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["blackrivertech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coto.edu"],
    name: "College of the Ouachitas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coto.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccua.edu/"],
    name: "Cossatot Community College of the University of Arkansas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.EACC.EDU"],
    name: "East Arkansas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.eacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.midsouthcc.edu"],
    name: "Mid-​South Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["midsouthcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.npcc.edu"],
    name: "National Park Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["npcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northark.edu"],
    name: "North Arkansas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwacc.edu"],
    name: "NorthWest Arkansas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ozarka.edu"],
    name: "Ozarka College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ozarka.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pccua.edu"],
    name: "Phillips Community College of the University of Arkansas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pccua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pulaskitech.edu"],
    name: "Pulaski Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pulaskitech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rmcc.edu"],
    name: "Rich Mountain Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southark.edu"],
    name: "South Arkansas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.seark.edu"],
    name: "Southeast Arkansas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["seark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sautech.edu"],
    name: "Southern Arkansas University Tech",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sautech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uaccb.edu"],
    name: "University of Arkansas Community College-​Batesville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uaccb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uacch.edu"],
    name: "University of Arkansas Community College-​Hope",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uacch.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uaccm.edu"],
    name: "University of Arkansas Community College-​Morrilton",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uaccm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hancockcollege.edu/"],
    name: "Allan Hancock College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hancockcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.arc.losrios.edu/"],
    name: "American River College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["arc.losrios.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.avc.edu"],
    name: "Antelope Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["avc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bakersfieldcollege.edu/"],
    name: "Bakersfield College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bakersfieldcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.barstow.edu"],
    name: "Barstow Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["barstow.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.berkeleycitycollege.edu/wp/"],
    name: "Berkeley City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["berkeleycitycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.butte.edu"],
    name: "Butte College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["butte.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cabrillo.edu"],
    name: "Cabrillo College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cabrillo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://canadacollege.edu"],
    name: "Canada College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["canadacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carrington.edu"],
    name: "Carrington College California-​Sacramento",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carrington.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cerritos.edu"],
    name: "Cerritos College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cerritos.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://cerrocoso.edu"],
    name: "Cerro Coso Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cerrocoso.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chabotcollege.edu"],
    name: "Chabot College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chabotcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chaffey.edu"],
    name: "Chaffey College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chaffey.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.citruscollege.edu"],
    name: "Citrus College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["citruscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccsf.edu"],
    name: "City College of San Francisco",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccsf.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastline.edu"],
    name: "Coastline Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastline.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.peralta.edu"],
    name: "College of Alameda",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["peralta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marin.edu"],
    name: "College of Marin",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.collegeofsanmateo.edu"],
    name: "College of San Mateo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["collegeofsanmateo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.canyons.edu"],
    name: "College of the Canyons",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["canyons.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://collegeofthedesert.edu"],
    name: "College of the Desert",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["collegeofthedesert.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.redwoods.edu"],
    name: "College of the Redwoods",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["redwoods.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cos.edu"],
    name: "College of the Sequoias",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cos.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.siskiyous.edu"],
    name: "College of the Siskiyous",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["siskiyous.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccis.edu/"],
    name: "Columbia College (MO)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gocolumbia.edu/"],
    name: "Columbia College (CA)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gocolumbia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.contracosta.edu"],
    name: "Contra Costa College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["contracosta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmccd.edu"],
    name: "Copper Mountain Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.crc.losrios.edu/"],
    name: "Cosumnes River College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["crc.losrios.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.craftonhills.edu"],
    name: "Crafton Hills College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["craftonhills.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.CUESTA.EDU"],
    name: "Cuesta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.cuesta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cuyamaca.edu"],
    name: "Cuyamaca College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cuyamaca.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cypresscollege.edu"],
    name: "Cypress College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cypresscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.deanza.edu/"],
    name: "De Anza College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["deanza.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dvc.edu"],
    name: "Diablo Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elac.edu/index.htm"],
    name: "East Los Angeles College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.compton.edu"],
    name: "El Camino College-​Compton Center",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["compton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elcamino.edu"],
    name: "El Camino Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elcamino.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.evc.edu"],
    name: "Evergreen Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["evc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.frc.edu"],
    name: "Feather River Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["frc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.flc.losrios.edu/"],
    name: "Folsom Lake College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["flc.losrios.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.foothill.edu"],
    name: "Foothill College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["foothill.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fresnocitycollege.edu"],
    name: "Fresno City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fresnocitycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fullcoll.edu"],
    name: "Fullerton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fullcoll.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gavilan.edu"],
    name: "Gavilan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gavilan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.glendale.edu"],
    name: "Glendale Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["glendale.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.goldenwestcollege.edu"],
    name: "Golden West College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["goldenwestcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.grossmont.edu/"],
    name: "Grossmont College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["grossmont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hartnell.edu"],
    name: "Hartnell College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hartnell.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.imperial.edu"],
    name: "Imperial Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["imperial.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ltcc.edu"],
    name: "Lake Tahoe Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ltcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laney.edu/wp/"],
    name: "Laney College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laney.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laspositascollege.edu"],
    name: "Las Positas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laspositascollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lassencollege.edu/"],
    name: "Lassen Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lassencollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lbcc.edu"],
    name: "Long Beach City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lbcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lacitycollege.edu/"],
    name: "Los Angeles City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lacitycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ladhs.org/wps/portal/CollegeofNursing"],
    name: "Los Angeles County College of Nursing and Allied Health",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ladhs.org"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lahc.edu"],
    name: "Los Angeles Harbor College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lahc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lamission.edu"],
    name: "Los Angeles Mission College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lamission.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.piercecollege.edu"],
    name: "Los Angeles Pierce College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["piercecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lasc.edu"],
    name: "Los Angeles Southwest College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lasc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lattc.edu"],
    name: "Los Angeles Trade Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lattc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lavc.edu"],
    name: "Los Angeles Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lavc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.losmedanos.edu"],
    name: "Los Medanos College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["losmedanos.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mendocino.edu"],
    name: "Mendocino College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mendocino.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mccd.edu"],
    name: "Merced College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.merritt.edu"],
    name: "Merritt College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["merritt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.miracosta.edu"],
    name: "MiraCosta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["miracosta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.missioncollege.edu/"],
    name: "Mission College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["missioncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://mjc.edu"],
    name: "Modesto Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mpc.edu"],
    name: "Monterey Peninsula College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mpc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.moorparkcollege.edu/index.shtml"],
    name: "Moorpark College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["moorparkcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mvc.edu/"],
    name: "Moreno Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://sacramento.mticollege.edu"],
    name: "MTI College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sacramento.mticollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtsac.edu"],
    name: "Mt. San Antonio College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtsac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msjc.edu"],
    name: "Mt. San Jacinto Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.napavalley.edu"],
    name: "Napa Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["napavalley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rcc.edu/norco/index.cfm"],
    name: "Norco College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ohlone.edu"],
    name: "Ohlone College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ohlone.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.orangecoastcollege.edu/"],
    name: "Orange Coast College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["orangecoastcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oxnardcollege.edu"],
    name: "Oxnard College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oxnardcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.palomar.edu"],
    name: "Palomar College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["palomar.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.paloverde.edu"],
    name: "Palo Verde College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["paloverde.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pasadena.edu"],
    name: "Pasadena City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pasadena.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.portervillecollege.edu"],
    name: "Porterville College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["portervillecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.reedleycollege.edu"],
    name: "Reedley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["reedleycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.riohondo.edu"],
    name: "Rio Hondo College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["riohondo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rcc.edu/riverside/"],
    name: "Riverside City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scc.losrios.edu/"],
    name: "Sacramento City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scc.losrios.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saddleback.edu"],
    name: "Saddleback College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saddleback.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.valleycollege.edu"],
    name: "San Bernardino Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["valleycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdcity.edu/"],
    name: "San Diego City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdcity.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdmesa.edu/"],
    name: "San Diego Mesa College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdmesa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sdmiramar.edu/"],
    name: "San Diego Miramar College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sdmiramar.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.deltacollege.edu"],
    name: "San Joaquin Delta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["deltacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjvc.edu"],
    name: "San Joaquin Valley College-​Visalia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sjcc.edu"],
    name: "San Jose City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sjcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sac.edu"],
    name: "Santa Ana College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sbcc.edu"],
    name: "Santa Barbara City College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sbcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smc.edu"],
    name: "Santa Monica College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.santarosa.edu"],
    name: "Santa Rosa Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["santarosa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sccollege.edu/Pages/default.aspx"],
    name: "Santiago Canyon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sccollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shastacollege.edu"],
    name: "Shasta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shastacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sierracollege.edu"],
    name: "Sierra College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sierracollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://skylinecollege.edu"],
    name: "Skyline College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["skylinecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.solano.edu"],
    name: "Solano Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["solano.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swccd.edu/"],
    name: "Southwestern College (CA)",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.taftcollege.edu"],
    name: "Taft College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["taftcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.venturacollege.edu/"],
    name: "Ventura College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["venturacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vvc.edu"],
    name: "Victor Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westhillscollege.com"],
    name: "West Hills College-​Coalinga",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westhillscollege.com"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wlac.edu"],
    name: "West Los Angeles College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wlac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westvalley.edu"],
    name: "West Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westvalley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://wcc.yccd.edu"],
    name: "Woodland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcc.yccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://yc.yccd.edu"],
    name: "Yuba College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yc.yccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aims.edu"],
    name: "Aims Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aims.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.arapahoe.edu"],
    name: "Arapahoe Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["arapahoe.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cncc.edu"],
    name: "Colorado Northwestern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccaurora.edu"],
    name: "Community College of Aurora",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccaurora.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccd.edu"],
    name: "Community College of Denver",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.frontrange.edu"],
    name: "Front Range Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["frontrange.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lamarcc.edu"],
    name: "Lamar Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lamarcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.morgancc.edu"],
    name: "Morgan Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["morgancc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.njc.edu"],
    name: "Northeastern Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["njc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.OJC.EDU"],
    name: "Otero Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.ojc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ppcc.edu"],
    name: "Pikes Peak Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ppcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pueblocc.edu"],
    name: "Pueblo Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pueblocc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rrcc.edu"],
    name: "Red Rocks Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rrcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trinidadstate.edu/"],
    name: "Trinidad State Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trinidadstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.Asnuntuck.edu"],
    name: "Asnuntuck Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asnuntuck.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccc.commnet.edu"],
    name: "Capital Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gwcc.commnet.edu/"],
    name: "Gateway Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gwcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hcc.commnet.edu"],
    name: "Housatonic Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcc.commnet.edu/"],
    name: "Manchester Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mxcc.commnet.edu"],
    name: "Middlesex Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mxcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nv.edu"],
    name: "Naugatuck Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwcc.commnet.edu"],
    name: "Northwestern Connecticut Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncc.commnet.edu"],
    name: "Norwalk Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.qvcc.edu"],
    name: "Quinebaug Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["qvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trcc.commnet.edu"],
    name: "Three Rivers Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trcc.commnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tunxis.edu"],
    name: "Tunxis Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tunxis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dcad.edu"],
    name: "Delaware College of Art and Design",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dcad.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.dtcc.edu/our-campuses/georgetown"],
    name: "Delaware Technical Community College-​Owens",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dtcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.dtcc.edu/our-campuses/wilmington"],
    name: "Delaware Technical Community College-​Stanton/​Wilmington",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dtcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.dtcc.edu/our-campuses/dover"],
    name: "Delaware Technical Community College-​Terry",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dtcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fkcc.edu"],
    name: "Florida Keys Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fkcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hccfl.edu"],
    name: "Hillsborough Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hccfl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nfcc.edu"],
    name: "North Florida Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.phcc.edu"],
    name: "Pasco-​Hernando Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["phcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.tcc.fl.edu"],
    name: "Tallahassee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcc.fl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.albanytech.edu"],
    name: "Albany Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["albanytech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastalpines.edu/"],
    name: "Altamaha Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastalpines.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.andrewcollege.edu"],
    name: "Andrew College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["andrewcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.athenstech.edu/"],
    name: "Athens Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["athenstech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.atlantatech.edu/"],
    name: "Atlanta Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["atlantatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.augustatech.edu"],
    name: "Augusta Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["augustatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bainbridge.edu"],
    name: "Bainbridge State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bainbridge.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.centralgatech.edu"],
    name: "Central Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["centralgatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chattahoocheetech.edu"],
    name: "Chattahoochee Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chattahoocheetech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.columbustech.edu/"],
    name: "Columbus Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbustech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.darton.edu"],
    name: "Darton State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["darton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.highlands.edu"],
    name: "Georgia Highlands College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["highlands.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gmc.cc.ga.us/"],
    name: "Georgia Military College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gmc.cc.ga.us"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gntc.edu"],
    name: "Georgia Northwestern Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gntc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gpc.edu"],
    name: "Georgia Perimeter College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gpc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gptc.edu"],
    name: "Georgia Piedmont Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gptc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.GwinnettTech.edu"],
    name: "Gwinnett Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gwinnetttech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laniertech.edu"],
    name: "Lanier Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laniertech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.moultrietech.edu"],
    name: "Moultrie Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["moultrietech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northgatech.edu"],
    name: "North Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northgatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ogeecheetech.edu"],
    name: "Ogeechee Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ogeecheetech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastalpines.edu/"],
    name: "Okefenokee Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastalpines.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.savannahtech.edu"],
    name: "Savannah Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["savannahtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeasterntech.edu"],
    name: "Southeastern Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeasterntech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sctech.edu"],
    name: "Southern Crescent Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sctech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southgatech.edu"],
    name: "South Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southgatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southwestgatech.edu/"],
    name: "Southwest Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southwestgatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westgatech.edu"],
    name: "West Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westgatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wiregrass.edu"],
    name: "Wiregrass Georgia Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wiregrass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://hawaii.hawaii.edu"],
    name: "Hawaii Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hawaii.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.honolulu.hawaii.edu/"],
    name: "Honolulu Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["honolulu.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://kapiolani.hawaii.edu/page/home"],
    name: "Kapiolani Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kapiolani.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://kauai.hawaii.edu"],
    name: "Kauai Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kauai.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.leeward.hawaii.edu"],
    name: "Leeward Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["leeward.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://windward.hawaii.edu"],
    name: "Windward Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["windward.hawaii.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csi.edu"],
    name: "College of Southern Idaho",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://cwidaho.cc/"],
    name: "College of Western Idaho",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cwidaho.cc"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eitc.edu"],
    name: "Eastern Idaho Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eitc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nic.edu/"],
    name: "North Idaho College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bhc.edu"],
    name: "Black Hawk College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bhc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sandburg.edu"],
    name: "Carl Sandburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sandburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccc.edu/colleges/washington/Pages/default.aspx"],
    name: "City Colleges of Chicago-​Harold Washington College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ccc.edu/colleges/truman/pages/default.aspx"],
    name: "City Colleges of Chicago-​Harry S Truman College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccc.edu/colleges/kennedy/pages/default.aspx"],
    name: "City Colleges of Chicago-​Kennedy-​King College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccc.edu/colleges/malcolm-x/pages/default.aspx"],
    name: "City Colleges of Chicago-​Malcolm X College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ccc.edu/colleges/olive-harvey/pages/default.aspx"],
    name: "City Colleges of Chicago-​Olive-​Harvey College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ccc.edu/colleges/daley/pages/default.aspx"],
    name: "City Colleges of Chicago-​Richard J Daley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ccc.edu/colleges/wright/pages/default.aspx"],
    name: "City Colleges of Chicago-​Wilbur Wright College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dupage.edu"],
    name: "College of DuPage",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dupage.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cod.edu"],
    name: "College of DuPage",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cod.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.CLCILLINOIS.EDU"],
    name: "College of Lake County",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.clcillinois.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dacc.edu"],
    name: "Danville Area Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elgin.edu"],
    name: "Elgin Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elgin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.foxcollege.edu"],
    name: "Fox College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["foxcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harpercollege.edu"],
    name: "Harper College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harpercollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.heartland.edu"],
    name: "Heartland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["heartland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.highland.edu"],
    name: "Highland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["highland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.icc.edu"],
    name: "Illinois Central College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["icc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ivcc.edu"],
    name: "Illinois Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ivcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jalc.edu"],
    name: "John A Logan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jalc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jwcc.edu"],
    name: "John Wood Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jwcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jjc.edu"],
    name: "Joliet Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kcc.edu"],
    name: "Kankakee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kaskaskia.edu"],
    name: "Kaskaskia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kaskaskia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kishwaukeecollege.edu"],
    name: "Kishwaukee College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kishwaukeecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lakeland.cc.il.us"],
    name: "Lake Land College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lakeland.cc.il.us"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chefs.edu/chicago"],
    name: "Le Cordon Bleu College of Culinary Arts-​Chicago",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chefs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lc.edu"],
    name: "Lewis and Clark Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.llcc.edu"],
    name: "Lincoln Land Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["llcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.maccormac.edu"],
    name: "MacCormac College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["maccormac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mchenry.edu"],
    name: "McHenry County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mchenry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.morainevalley.edu"],
    name: "Moraine Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["morainevalley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.morton.edu"],
    name: "Morton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["morton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.NorthwesternCollege.edu"],
    name: "Northwestern College-​Chicago Campus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northwesterncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oakton.edu"],
    name: "Oakton Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oakton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.parkland.edu"],
    name: "Parkland College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["parkland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.prairiestate.edu"],
    name: "Prairie State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["prairiestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rlc.edu"],
    name: "Rend Lake College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rlc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.richland.edu"],
    name: "Richland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["richland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rockvalleycollege.edu"],
    name: "Rock Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rockvalleycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.svcc.edu"],
    name: "Sauk Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["svcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shawneecc.edu"],
    name: "Shawnee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shawneecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sic.edu"],
    name: "Southeastern Illinois College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ssc.edu/"],
    name: "South Suburban College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ssc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swic.edu"],
    name: "Southwestern Illinois College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.src.edu"],
    name: "Spoon River College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["src.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.triton.edu"],
    name: "Triton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["triton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ancilla.edu"],
    name: "Ancilla College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ancilla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ivytech.edu"],
    name: "Ivy Tech Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ivytech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dmacc.edu"],
    name: "Des Moines Area Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dmacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eicc.edu"],
    name: "Eastern Iowa Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eicc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hawkeyecollege.edu"],
    name: "Hawkeye Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hawkeyecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indianhills.edu"],
    name: "Indian Hills Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indianhills.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iowacentral.edu"],
    name: "Iowa Central Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iowacentral.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iowalakes.edu"],
    name: "Iowa Lakes Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iowalakes.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iwcc.edu/"],
    name: "Iowa Western Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iwcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kirkwood.edu"],
    name: "Kirkwood Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kirkwood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iavalley.edu/mcc/index.html"],
    name: "Marshalltown Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iavalley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nicc.edu"],
    name: "Northeast Iowa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nicc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.niacc.edu"],
    name: "North Iowa Area Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["niacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwicc.edu"],
    name: "Northwest Iowa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwicc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scciowa.edu"],
    name: "Southeastern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scciowa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swcciowa.edu"],
    name: "Southwestern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swcciowa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.witcc.edu"],
    name: "Western Iowa Tech Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["witcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.allencc.edu"],
    name: "Allen County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["allencc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bartonccc.edu"],
    name: "Barton County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bartonccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.butlercc.edu/"],
    name: "Butler Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["butlercc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cloud.edu"],
    name: "Cloud County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cloud.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coffeyville.edu"],
    name: "Coffeyville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coffeyville.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colbycc.edu"],
    name: "Colby Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colbycc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cowley.edu"],
    name: "Cowley County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cowley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dc3.edu"],
    name: "Dodge City Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dc3.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fhtc.edu"],
    name: "Flint Hills Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fhtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fortscott.edu"],
    name: "Fort Scott Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fortscott.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gcccks.edu"],
    name: "Garden City Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gcccks.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.highlandcc.edu"],
    name: "Highland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["highlandcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hutchcc.edu"],
    name: "Hutchinson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hutchcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.indycc.edu"],
    name: "Independence Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["indycc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jccc.edu"],
    name: "Johnson County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kckcc.edu"],
    name: "Kansas City Kansas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kckcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.labette.edu"],
    name: "Labette Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["labette.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.manhattantech.edu"],
    name: "Manhattan Area Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["manhattantech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.neosho.edu"],
    name: "Neosho County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["neosho.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncktc.edu"],
    name: "North Central Kansas Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncktc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwktc.edu"],
    name: "Northwest Kansas Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwktc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.prattcc.edu"],
    name: "Pratt Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["prattcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sccc.edu"],
    name: "Seward County Community College and Area Technical School",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.watc.edu"],
    name: "Wichita Area Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["watc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ashland.kctcs.edu/"],
    name: "Ashland Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ashland.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bigsandy.kctcs.edu"],
    name: "Big Sandy Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bigsandy.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bluegrass.kctcs.edu/"],
    name: "Bluegrass Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bluegrass.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elizabethtown.kctcs.edu"],
    name: "Elizabethtown Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elizabethtown.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.galencollege.edu/louisville"],
    name: "Galen College of Nursing-​Louisville",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["galencollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gateway.kctcs.edu"],
    name: "Gateway Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gateway.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hazard.kctcs.edu"],
    name: "Hazard Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hazard.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hencc.kctcs.edu"],
    name: "Henderson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hencc.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://hopkinsville.kctcs.edu/"],
    name: "Hopkinsville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hopkinsville.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jefferson.kctcs.edu"],
    name: "Jefferson Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jefferson.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.madisonville.kctcs.edu/"],
    name: "Madisonville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["madisonville.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://maysville.kctcs.edu"],
    name: "Maysville Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["maysville.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.owensboro.kctcs.edu"],
    name: "Owensboro Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["owensboro.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.somerset.kctcs.edu/"],
    name: "Somerset Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["somerset.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bowlinggreen.kctcs.edu"],
    name: "Southcentral Kentucky Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bowlinggreen.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeast.kctcs.edu"],
    name: "Southeast Kentucky Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeast.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westkentucky.kctcs.edu"],
    name: "West Kentucky Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westkentucky.kctcs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mybrcc.edu"],
    name: "Baton Rouge Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mybrcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bpcc.edu"],
    name: "Bossier Parish Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.DCC.EDU"],
    name: "Delgado Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fletcher.edu/"],
    name: "L E Fletcher Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fletcher.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ladelta.edu"],
    name: "Louisiana Delta Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ladelta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lsue.edu"],
    name: "Louisiana State University-​Eunice",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lsue.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nunez.edu"],
    name: "Nunez Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nunez.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rpcc.edu"],
    name: "River Parishes Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.susla.edu"],
    name: "Southern University at Shreveport",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["susla.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.solacc.edu/"],
    name: "South Louisiana Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["solacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sowela.edu"],
    name: "SOWELA Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sowela.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmcc.edu"],
    name: "Central Maine Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cmmccollege.edu"],
    name: "Central Maine Medical Center College of Nursing and Health Professions",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cmmccollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.emcc.edu"],
    name: "Eastern Maine Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["emcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kvcc.me.edu"],
    name: "Kennebec Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kvcc.me.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmcc.edu"],
    name: "Northern Maine Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smccME.edu"],
    name: "Southern Maine Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smccme.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wccc.me.edu"],
    name: "Washington County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wccc.me.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yccc.edu"],
    name: "York County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.allegany.edu"],
    name: "Allegany College of Maryland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["allegany.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bccc.edu"],
    name: "Baltimore City Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carrollcc.edu"],
    name: "Carroll Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carrollcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cecil.edu"],
    name: "Cecil College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cecil.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.csmd.edu/"],
    name: "College of Southern Maryland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["csmd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.garrettcollege.edu"],
    name: "Garrett College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["garrettcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pgcc.edu"],
    name: "Prince George's Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pgcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.worwic.edu"],
    name: "Wor-​Wic Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["worwic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.berkshirecc.edu"],
    name: "Berkshire Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["berkshirecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://bristolcc.edu/"],
    name: "Bristol Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bristolcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bhcc.mass.edu"],
    name: "Bunker Hill Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bhcc.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.capecod.edu"],
    name: "Cape Cod Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["capecod.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gcc.mass.edu"],
    name: "Greenfield Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gcc.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hcc.edu"],
    name: "Holyoke Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.massbay.edu"],
    name: "Massachusetts Bay Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["massbay.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.massasoit.mass.edu"],
    name: "Massasoit Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["massasoit.mass.edu", "massasoit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.middlesex.mass.edu"],
    name: "Middlesex Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["middlesex.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://MWCC.EDU"],
    name: "Mount Wachusett Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mwcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.necc.mass.edu/"],
    name: "Northern Essex Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["necc.edu", "necc.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northshore.edu"],
    name: "North Shore Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northshore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.quincycollege.edu"],
    name: "Quincy College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["quincycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.qcc.edu"],
    name: "Quinsigamond Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["qcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rcc.mass.edu"],
    name: "Roxbury Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rcc.mass.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stcc.edu"],
    name: "Springfield Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.urbancollege.edu"],
    name: "Urban College of Boston",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["urbancollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alpenacc.edu"],
    name: "Alpena Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alpenacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.baycollege.edu/"],
    name: "Bay de Noc Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["baycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bmcc.edu"],
    name: "Bay Mills Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.delta.edu"],
    name: "Delta College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["delta.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.glenoaks.cc.mi.us/Pages/default.aspx"],
    name: "Glen Oaks Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["glenoaks.cc.mi.us"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gogebic.edu"],
    name: "Gogebic Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gogebic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.grcc.edu"],
    name: "Grand Rapids Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["grcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hfcc.edu"],
    name: "Henry Ford College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jccmi.edu"],
    name: "Jackson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jccmi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kvcc.edu"],
    name: "Kalamazoo Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kellogg.edu"],
    name: "Kellogg Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kellogg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kbocc.org"],
    name: "Keweenaw Bay Ojibwa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kbocc.org"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kirtland.edu"],
    name: "Kirtland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kirtland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lakemichigancollege.edu"],
    name: "Lake Michigan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lakemichigancollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lcc.edu"],
    name: "Lansing Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.macomb.edu"],
    name: "Macomb Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["macomb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.midmich.edu"],
    name: "Mid Michigan Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["midmich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.monroeccc.edu"],
    name: "Monroe County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monroeccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montcalm.edu"],
    name: "Montcalm Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montcalm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.muskegoncc.edu"],
    name: "Muskegon Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["muskegoncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncmich.edu"],
    name: "North Central Michigan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncmich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.oaklandcc.edu"],
    name: "Oakland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["oaklandcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sagchip.edu"],
    name: "Saginaw Chippewa Tribal College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sagchip.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.schoolcraft.edu"],
    name: "Schoolcraft College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["schoolcraft.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swmich.edu"],
    name: "Southwestern Michigan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swmich.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sc4.edu"],
    name: "St. Clair County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sc4.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wccnet.edu"],
    name: "Washtenaw Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wccnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcccd.edu"],
    name: "Wayne County Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcccd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westshore.edu"],
    name: "West Shore Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westshore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alextech.edu"],
    name: "Alexandria Technical & Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alextech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.anokaramsey.edu"],
    name: "Anoka-​Ramsey Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["anokaramsey.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.anokatech.edu"],
    name: "Anoka Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["anokatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.CLCMN.EDU"],
    name: "Central Lakes College-​Brainerd",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.clcmn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.century.edu"],
    name: "Century College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["century.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dctc.edu/"],
    name: "Dakota County Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fdltcc.edu"],
    name: "Fond du Lac Tribal and Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fdltcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hennepintech.edu"],
    name: "Hennepin Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hennepintech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hibbing.edu"],
    name: "Hibbing Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hibbing.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.inverhills.edu"],
    name: "Inver Hills Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["inverhills.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.itascacc.edu/"],
    name: "Itasca Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["itascacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lltc.edu"],
    name: "Leech Lake Tribal College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lltc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mesabirange.edu"],
    name: "Mesabi Range Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mesabirange.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.minneapolis.edu"],
    name: "Minneapolis Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["minneapolis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeastmn.edu"],
    name: "Minnesota State College-​Southeast Technical",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeastmn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.minnesota.edu"],
    name: "Minnesota State Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["minnesota.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mnwest.edu"],
    name: "Minnesota West Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mnwest.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.normandale.edu"],
    name: "Normandale Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["normandale.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nhcc.edu"],
    name: "North Hennepin Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nhcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northlandcollege.edu"],
    name: "Northland Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northlandcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ntcmn.edu"],
    name: "Northwest Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ntcmn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pinetech.edu"],
    name: "Pine Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pinetech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rrcc.mnscu.edu"],
    name: "Rainy River Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rrcc.mnscu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ridgewater.edu/Pages/default.aspx"],
    name: "Ridgewater College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ridgewater.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.riverland.edu"],
    name: "Riverland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["riverland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rctc.edu/"],
    name: "Rochester Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.saintpaul.edu"],
    name: "Saint Paul College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["saintpaul.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southcentral.edu"],
    name: "South Central College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southcentral.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sctcc.edu"],
    name: "St Cloud Technical and Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sctcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vcc.edu"],
    name: "Vermilion Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wetcc.edu"],
    name: "White Earth Tribal and Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wetcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coahomacc.edu/"],
    name: "Coahoma Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coahomacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.colin.edu"],
    name: "Copiah-​Lincoln Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["colin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eccc.edu"],
    name: "East Central Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eastms.edu/"],
    name: "East Mississippi Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eastms.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hindscc.edu"],
    name: "Hinds Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hindscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.holmescc.edu"],
    name: "Holmes Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["holmescc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.iccms.edu/Default.aspx?tabid=55"],
    name: "Itawamba Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["iccms.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jcjc.edu"],
    name: "Jones County Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jcjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.meridiancc.edu"],
    name: "Meridian Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["meridiancc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.msdelta.edu"],
    name: "Mississippi Delta Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["msdelta.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.mgccc.edu"],
    name: "Mississippi Gulf Coast Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mgccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nemcc.edu"],
    name: "Northeast Mississippi Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nemcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northwestms.edu"],
    name: "Northwest Mississippi Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northwestms.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.prcc.edu"],
    name: "Pearl River Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["prcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smcc.edu"],
    name: "Southwest Mississippi Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.crowder.edu"],
    name: "Crowder College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["crowder.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eastcentral.edu"],
    name: "East Central College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eastcentral.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jeffco.edu"],
    name: "Jefferson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jeffco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.linnstate.edu"],
    name: "Linn State Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["linnstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mineralarea.edu"],
    name: "Mineral Area College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mineralarea.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.missouristate.edu"],
    name: "Missouri State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["missouristate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wp.missouristate.edu"],
    name: "Missouri State University-​West Plains",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wp.missouristate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.macc.edu"],
    name: "Moberly Area Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["macc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncmissouri.edu"],
    name: "North Central Missouri College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncmissouri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.otc.edu"],
    name: "Ozarks Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["otc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeastmissourihospitalcollege.edu"],
    name: "Southeast Missouri Hospital College of Nursing and Health Sciences",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeastmissourihospitalcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sfccmo.edu"],
    name: "State Fair Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sfccmo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stchas.edu"],
    name: "St Charles Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stchas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.trcc.edu"],
    name: "Three Rivers Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["trcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wma.edu"],
    name: "Wentworth Military Academy & Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wma.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ancollege.edu"],
    name: "Aaniiih Nakoda College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ancollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://bfcc.edu"],
    name: "Blackfeet Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://cdkc.edu"],
    name: "Chief Dull Knife College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cdkc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dawson.edu"],
    name: "Dawson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dawson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fvcc.edu"],
    name: "Flathead Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fpcc.edu"],
    name: "Fort Peck Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gfcmsu.edu"],
    name: "Great Falls College Montana State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gfcmsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umhelena.edu"],
    name: "Helena College University of Montana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umhelena.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lbhc.edu/"],
    name: "Little Big Horn College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lbhc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://milescc.edu/"],
    name: "Miles Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["milescc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stonechild.edu"],
    name: "Stone Child College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stonechild.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccneb.edu"],
    name: "Central Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccneb.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.littlepriest.edu"],
    name: "Little Priest Tribal College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["littlepriest.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mpcc.edu"],
    name: "Mid-​Plains Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://NCTA.UNL.EDU"],
    name: "Nebraska College of Technical Agriculture",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncta.unl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.thenicc.edu"],
    name: "Nebraska Indian Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["thenicc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northeast.edu"],
    name: "Northeast Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northeast.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeast.edu"],
    name: "Southeast Community College Area",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeast.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wncc.edu"],
    name: "Western Nebraska Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tmcc.edu"],
    name: "Truckee Meadows Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.greatbay.edu"],
    name: "Great Bay Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["greatbay.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lrcc.edu"],
    name: "Lakes Region Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lrcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mccnh.edu"],
    name: "Manchester Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mccnh.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nashuacc.edu"],
    name: "Nashua Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nashuacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nhti.edu"],
    name: "NHTI-​Concord's Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nhti.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rivervalley.edu"],
    name: "River Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rivervalley.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wmcc.edu"],
    name: "White Mountains Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.acs350.org"],
    name: "Assumption College for Sisters",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["acs350.org"],
    country: "United States",
  },
  {
    web_pages: ["http://www.atlantic.edu"],
    name: "Atlantic Cape Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["atlantic.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bergen.edu"],
    name: "Bergen Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bergen.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brookdalecc.edu"],
    name: "Brookdale Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brookdalecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bcc.edu"],
    name: "Burlington County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.camdencc.edu"],
    name: "Camden County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["camdencc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.CCM.EDU"],
    name: "County College of Morris",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.ccm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccnj.edu"],
    name: "Cumberland County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccnj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.essex.edu"],
    name: "Essex County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["essex.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gccnj.edu"],
    name: "Gloucester County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gccnj.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hccc.edu"],
    name: "Hudson County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.middlesexcc.edu"],
    name: "Middlesex County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["middlesexcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ocean.edu/"],
    name: "Ocean County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ocean.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pccc.edu"],
    name: "Passaic County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.raritanval.edu"],
    name: "Raritan Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["raritanval.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.salemcc.edu"],
    name: "Salem Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["salemcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sussex.edu"],
    name: "Sussex County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sussex.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ucc.edu"],
    name: "Union County College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ucc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.warren.edu"],
    name: "Warren County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["warren.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cnm.edu"],
    name: "Central New Mexico Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cnm.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clovis.edu"],
    name: "Clovis Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clovis.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.roswell.enmu.edu"],
    name: "Eastern New Mexico University-​Roswell Campus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roswell.enmu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.luna.edu"],
    name: "Luna Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["luna.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mesalands.edu"],
    name: "Mesalands Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mesalands.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmjc.edu"],
    name: "New Mexico Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nmmi.edu"],
    name: "New Mexico Military Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmmi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://nmsua.edu"],
    name: "New Mexico State University-​Alamogordo",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nmsua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cavern.nmsu.edu/"],
    name: "New Mexico State University-​Carlsbad",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cavern.nmsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://dabcc.nmsu.edu/"],
    name: "New Mexico State University-​Dona Ana",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dabcc.nmsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sanjuancollege.edu"],
    name: "San Juan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sanjuancollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sfcc.edu"],
    name: "Santa Fe Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sipi.edu"],
    name: "Southwestern Indian Polytechnic Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sipi.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.SUNYACC.EDU"],
    name: "Adirondack Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.sunyacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.aada.edu"],
    name: "American Academy of Dramatic Arts-​New York",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["aada.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.asa.edu"],
    name: "ASA College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["asa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cayuga-cc.edu/"],
    name: "Cayuga County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cayuga-cc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clinton.edu"],
    name: "Clinton Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clinton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunycgcc.edu"],
    name: "Columbia-​Greene Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunycgcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bmcc.cuny.edu/"],
    name: "CUNY Borough of Manhattan Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bmcc.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bcc.cuny.edu"],
    name: "CUNY Bronx Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bcc.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hostos.cuny.edu"],
    name: "CUNY Hostos Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hostos.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kbcc.cuny.edu"],
    name: "CUNY Kingsborough Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kbcc.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lagcc.cuny.edu"],
    name: "CUNY LaGuardia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lagcc.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.qcc.cuny.edu"],
    name: "CUNY Queensborough Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["qcc.cuny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunydutchess.edu"],
    name: "Dutchess Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunydutchess.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.flcc.edu"],
    name: "Finger Lakes Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["flcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://fmcc.edu"],
    name: "Fulton-​Montgomery Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fmcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.genesee.edu"],
    name: "Genesee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["genesee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.herkimer.edu/"],
    name: "Herkimer County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["herkimer.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hvcc.edu"],
    name: "Hudson Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunyjcc.edu"],
    name: "Jamestown Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyjcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunyjefferson.edu"],
    name: "Jefferson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyjefferson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mvcc.edu"],
    name: "Mohawk Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.monroecc.edu/"],
    name: "Monroe Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["monroecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncc.edu/"],
    name: "Nassau Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.niagaracc.suny.edu"],
    name: "Niagara County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["niagaracc.suny.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nccc.edu"],
    name: "North Country Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunyocc.edu"],
    name: "Onondaga Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyocc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunyorange.edu/"],
    name: "Orange County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyorange.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunyrockland.edu/"],
    name: "Rockland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunyrockland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.secon.edu"],
    name: "Saint Elizabeth College of Nursing",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["secon.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunysccc.edu"],
    name: "Schenectady County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunysccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www3.sunysuffolk.edu"],
    name: "Suffolk County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www3.sunysuffolk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunysullivan.edu/"],
    name: "Sullivan County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunysullivan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.SUNYBROOME.EDU"],
    name: "SUNY Broome Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.sunybroome.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sunywcc.edu"],
    name: "SUNY Westchester Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sunywcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tcicollege.edu"],
    name: "Technical Career Institutes",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcicollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.TC3.edu"],
    name: "Tompkins Cortland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tc3.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.SUNYULSTER.EDU"],
    name: "Ulster County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.sunyulster.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamancecc.edu"],
    name: "Alamance Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alamancecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.abtech.edu"],
    name: "Asheville-​Buncombe Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["abtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.beaufortccc.edu"],
    name: "Beaufort County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["beaufortccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bladencc.edu"],
    name: "Bladen Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bladencc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.blueridge.edu"],
    name: "Blue Ridge Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["blueridge.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brunswickcc.edu"],
    name: "Brunswick Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brunswickcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccti.edu"],
    name: "Caldwell Community College and Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccti.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cfcc.edu"],
    name: "Cape Fear Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carolinascollege.edu"],
    name: "Carolinas College of Health Sciences",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carolinascollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carteret.edu"],
    name: "Carteret Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carteret.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cvcc.edu"],
    name: "Catawba Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cccc.edu"],
    name: "Central Carolina Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cpcc.edu"],
    name: "Central Piedmont Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clevelandcc.edu"],
    name: "Cleveland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clevelandcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastalcarolina.edu/"],
    name: "Coastal Carolina Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastalcarolina.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.albemarle.edu"],
    name: "College of the Albemarle",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["albemarle.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cravencc.edu"],
    name: "Craven Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cravencc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.davidsonccc.edu"],
    name: "Davidson County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["davidsonccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.durhamtech.edu"],
    name: "Durham Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["durhamtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.edgecombe.edu"],
    name: "Edgecombe Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["edgecombe.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.faytechcc.edu"],
    name: "Fayetteville Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["faytechcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.forsythtech.edu/"],
    name: "Forsyth Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["forsythtech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gaston.edu"],
    name: "Gaston College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gaston.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gtcc.edu"],
    name: "Guilford Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gtcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.halifaxcc.edu"],
    name: "Halifax Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["halifaxcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.haywood.edu"],
    name: "Haywood Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["haywood.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.isothermal.edu"],
    name: "Isothermal Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["isothermal.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jamessprunt.edu"],
    name: "James Sprunt Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jamessprunt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.johnstoncc.edu"],
    name: "Johnston Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["johnstoncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.louisburg.edu"],
    name: "Louisburg College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["louisburg.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.martincc.edu"],
    name: "Martin Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["martincc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mayland.edu"],
    name: "Mayland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mayland.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mcdowelltech.edu"],
    name: "McDowell Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcdowelltech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mitchellcc.edu"],
    name: "Mitchell Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mitchellcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.montgomery.edu"],
    name: "Montgomery Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["montgomery.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nashcc.edu"],
    name: "Nash Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nashcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pamlicocc.edu"],
    name: "Pamlico Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pamlicocc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.piedmontcc.edu"],
    name: "Piedmont Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["piedmontcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pittcc.edu"],
    name: "Pitt Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pittcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.randolph.edu"],
    name: "Randolph Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["randolph.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.richmondcc.edu"],
    name: "Richmond Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["richmondcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.roanokechowan.edu"],
    name: "Roanoke-​Chowan Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roanokechowan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.robeson.edu"],
    name: "Robeson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["robeson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rockinghamcc.edu"],
    name: "Rockingham Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rockinghamcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rccc.edu/"],
    name: "Rowan-​Cabarrus Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sampsoncc.edu"],
    name: "Sampson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sampsoncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sandhills.edu"],
    name: "Sandhills Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sandhills.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sccnc.edu"],
    name: "Southeastern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sccnc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.spcc.edu"],
    name: "South Piedmont Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["spcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southwesterncc.edu"],
    name: "Southwestern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southwesterncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stanly.edu"],
    name: "Stanly Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stanly.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.surry.edu"],
    name: "Surry Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["surry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tricountycc.edu"],
    name: "Tri-​County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tricountycc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.waketech.edu/"],
    name: "Wake Technical Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waketech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.waynecc.edu"],
    name: "Wayne Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waynecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wpcc.edu"],
    name: "Western Piedmont Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wpcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wilkescc.edu"],
    name: "Wilkes Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilkescc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wilsoncc.edu"],
    name: "Wilson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wilsoncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.littlehoop.edu"],
    name: "Cankdeska Cikana Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["littlehoop.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dakotacollege.edu"],
    name: "Dakota College at Bottineau",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dakotacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lrsc.edu"],
    name: "Lake Region State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lrsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ndscs.edu"],
    name: "North Dakota State College of Science",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ndscs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.willistonstate.edu"],
    name: "Williston State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["willistonstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.belmontcollege.edu"],
    name: "Belmont College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["belmontcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cotc.edu"],
    name: "Central Ohio Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cotc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chatfield.edu"],
    name: "Chatfield College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chatfield.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cincinnatistate.edu"],
    name: "Cincinnati State Technical and Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cincinnatistate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarkstate.edu"],
    name: "Clark State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clarkstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cscc.edu/"],
    name: "Columbus State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tri-c.edu"],
    name: "Cuyahoga Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tri-c.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.daviscollege.edu"],
    name: "Davis College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["daviscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.egcc.edu"],
    name: "Eastern Gateway Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["egcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.edisonOHIO.edu"],
    name: "Edison State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["edisonohio.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hocking.edu"],
    name: "Hocking College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hocking.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rhodesstate.edu"],
    name: "James A Rhodes State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rhodesstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lakelandcc.edu"],
    name: "Lakeland Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lakelandcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lorainccc.edu"],
    name: "Lorain County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lorainccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mtc.edu"],
    name: "Marion Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ncstatecollege.edu"],
    name: "North Central State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ncstatecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northweststate.edu"],
    name: "Northwest State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northweststate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ati.osu.edu/"],
    name: "Ohio State University Agricultural Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ati.osu.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.owens.edu"],
    name: "Owens Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["owens.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sscc.edu"],
    name: "Southern State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.starkstate.edu"],
    name: "Stark State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["starkstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.terra.edu"],
    name: "Terra State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["terra.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wayne.uakron.edu"],
    name: "University of Akron Wayne College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wayne.uakron.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wscc.edu"],
    name: "Washington State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.zanestate.edu"],
    name: "Zane State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["zanestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.carlalbert.edu"],
    name: "Carl Albert State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["carlalbert.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.connorsstate.edu"],
    name: "Connors State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["connorsstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eosc.edu"],
    name: "Eastern Oklahoma State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eosc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mscok.edu"],
    name: "Murray State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mscok.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.neo.edu"],
    name: "Northeastern Oklahoma A&M College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["neo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.noc.edu"],
    name: "Northern Oklahoma College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["noc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.occc.edu"],
    name: "Oklahoma City Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["occc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.redlandscc.edu"],
    name: "Redlands Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["redlandscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rose.edu"],
    name: "Rose State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rose.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sscok.edu"],
    name: "Seminole State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sscok.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tulsacc.edu"],
    name: "Tulsa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tulsacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wosc.edu"],
    name: "Western Oklahoma State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wosc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bluecc.edu"],
    name: "Blue Mountain Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bluecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cocc.edu"],
    name: "Central Oregon Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cocc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chemeketa.edu"],
    name: "Chemeketa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chemeketa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clackamas.edu"],
    name: "Clackamas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clackamas.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clatsopcc.edu"],
    name: "Clatsop Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clatsopcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cgcc.cc.or.us"],
    name: "Columbia Gorge Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cgcc.cc.or.us"],
    country: "United States",
  },
  {
    web_pages: ["https://www.klamathcc.edu"],
    name: "Klamath Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["klamathcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.Lanecc.edu"],
    name: "Lane Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lanecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.linnbenton.edu"],
    name: "Linn-​Benton Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["linnbenton.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mhcc.edu"],
    name: "Mt. Hood Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mhcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.roguecc.edu"],
    name: "Rogue Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roguecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.socc.edu"],
    name: "Southwestern Oregon Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["socc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tbcc.cc.or.us/"],
    name: "Tillamook Bay Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tbcc.cc.or.us"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tvcc.cc"],
    name: "Treasure Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tvcc.cc"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umpqua.edu/"],
    name: "Umpqua Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["umpqua.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bucks.edu/"],
    name: "Bucks County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bucks.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bc3.edu"],
    name: "Butler County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bc3.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccac.edu"],
    name: "Community College of Allegheny County",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccbc.edu"],
    name: "Community College of Beaver County",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccp.edu"],
    name: "Community College of Philadelphia",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccp.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dccc.edu"],
    name: "Delaware County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harcum.edu"],
    name: "Harcum College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harcum.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hacc.edu"],
    name: "Harrisburg Area Community College-​Harrisburg",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lackawanna.edu"],
    name: "Lackawanna College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lackawanna.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lccc.edu"],
    name: "Lehigh Carbon Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.luzerne.edu"],
    name: "Luzerne County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["luzerne.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.manor.edu"],
    name: "Manor College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["manor.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mc3.edu"],
    name: "Montgomery County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mc3.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pennhighlands.edu"],
    name: "Pennsylvania Highlands Community College",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pennhighlands.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pit.edu"],
    name: "Pennsylvania Institute of Technology",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pti.edu"],
    name: "Pittsburgh Technical Institute",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pti.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.racc.edu"],
    name: "Reading Area Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["racc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.stevenscollege.edu"],
    name: "Thaddeus Stevens College of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["stevenscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.upt.pitt.edu"],
    name: "University of Pittsburgh-​Titusville",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["upt.pitt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vfmac.edu"],
    name: "Valley Forge Military Academy and College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vfmac.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://wccc.edu"],
    name: "Westmoreland County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wccc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccri.edu"],
    name: "Community College of Rhode Island",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccri.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cctech.edu"],
    name: "Central Carolina Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cctech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.denmarktech.edu"],
    name: "Denmark Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["denmarktech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.FDTC.EDU"],
    name: "Florence-​Darlington Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.fdtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gvltec.edu"],
    name: "Greenville Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gvltec.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hgtc.edu"],
    name: "Horry-​Georgetown Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hgtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.midlandstech.edu"],
    name: "Midlands Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["midlandstech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.netc.edu"],
    name: "Northeastern Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["netc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.octech.edu"],
    name: "Orangeburg Calhoun Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["octech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ptc.edu"],
    name: "Piedmont Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ptc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sccsc.edu"],
    name: "Spartanburg Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sccsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.smcsc.edu/"],
    name: "Spartanburg Methodist College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["smcsc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tcl.edu"],
    name: "Technical College of the Lowcountry",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcl.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tctc.edu"],
    name: "Tri-​County Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tridenttech.edu"],
    name: "Trident Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tridenttech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wiltech.edu"],
    name: "Williamsburg Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wiltech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yorktech.edu"],
    name: "York Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yorktech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kilian.edu"],
    name: "Kilian Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kilian.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lakeareatech.edu"],
    name: "Lake Area Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lakeareatech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mitchelltech.edu"],
    name: "Mitchell Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mitchelltech.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swc.tc"],
    name: "Sisseton Wahpeton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swc.tc"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southeasttech.edu"],
    name: "Southeast Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southeasttech.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.wdt.edu"],
    name: "Western Dakota Technical Institute",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wdt.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.chattanoogastate.edu"],
    name: "Chattanooga State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["chattanoogastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clevelandstatecc.edu"],
    name: "Cleveland State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clevelandstatecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.columbiastate.edu"],
    name: "Columbia State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["columbiastate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dscc.edu"],
    name: "Dyersburg State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jscc.edu"],
    name: "Jackson State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.guptoncollege.edu"],
    name: "John A Gupton College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["guptoncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mscc.edu"],
    name: "Motlow State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mscc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.NortheastState.edu"],
    name: "Northeast State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northeaststate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pstcc.edu/"],
    name: "Pellissippi State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pstcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.roanestate.edu"],
    name: "Roane State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["roanestate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southwest.tn.edu"],
    name: "Southwest Tennessee Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southwest.tn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.volstate.edu"],
    name: "Volunteer State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["volstate.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ws.edu"],
    name: "Walters State Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ws.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alvincollege.edu"],
    name: "Alvin Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alvincollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.actx.edu"],
    name: "Amarillo College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["actx.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.angelina.edu"],
    name: "Angelina College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["angelina.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.blinn.edu"],
    name: "Blinn College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["blinn.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brookhavencollege.edu/"],
    name: "Brookhaven College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brookhavencollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cedarvalleycollege.edu"],
    name: "Cedar Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cedarvalleycollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ctcd.edu"],
    name: "Central Texas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ctcd.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cisco.edu"],
    name: "Cisco College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cisco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clarendoncollege.edu"],
    name: "Clarendon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clarendoncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.coastalbend.edu"],
    name: "Coastal Bend College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["coastalbend.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.com.edu"],
    name: "College of the Mainland",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["com.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.collin.edu"],
    name: "Collin County Community College District",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["collin.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.delmar.edu"],
    name: "Del Mar College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["delmar.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.eastfieldcollege.edu/"],
    name: "Eastfield College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eastfieldcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.elcentrocollege.edu/"],
    name: "El Centro College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["elcentrocollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.epcc.edu"],
    name: "El Paso Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["epcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fpctx.edu"],
    name: "Frank Phillips College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fpctx.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gc.edu"],
    name: "Galveston College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.grayson.edu"],
    name: "Grayson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["grayson.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hillcollege.edu"],
    name: "Hill College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hillcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.hccs.edu"],
    name: "Houston Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["hccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.howardcollege.edu"],
    name: "Howard College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["howardcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jacksonville-college.edu"],
    name: "Jacksonville College-​Main Campus",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jacksonville-college.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kilgore.edu"],
    name: "Kilgore College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kilgore.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lit.edu"],
    name: "Lamar Institute of Technology",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lsco.edu"],
    name: "Lamar State College-​Orange",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lsco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lamarpa.edu"],
    name: "Lamar State College-​Port Arthur",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lamarpa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.laredo.edu"],
    name: "Laredo Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["laredo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lee.edu"],
    name: "Lee College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lee.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lonestar.edu"],
    name: "Lone Star College System",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lonestar.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mclennan.edu"],
    name: "McLennan Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mclennan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.navarrocollege.edu"],
    name: "Navarro College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["navarrocollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nctc.edu"],
    name: "North Central Texas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ntcc.edu"],
    name: "Northeast Texas Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ntcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northlakecollege.edu/Pages/default.aspx"],
    name: "North Lake College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northlakecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamo.edu/nvc/"],
    name: "Northwest Vista College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alamo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.odessa.edu"],
    name: "Odessa College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["odessa.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamo.edu/pac/"],
    name: "Palo Alto College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alamo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.panola.edu"],
    name: "Panola College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["panola.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.parisjc.edu/"],
    name: "Paris Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["parisjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rangercollege.edu"],
    name: "Ranger College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rangercollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.richlandcollege.edu/"],
    name: "Richland College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["richlandcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamo.edu/sac"],
    name: "San Antonio College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alamo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southplainscollege.edu/"],
    name: "South Plains College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southplainscollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swtjc.net"],
    name: "Southwest Texas Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swtjc.net"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alamo.edu/spc/"],
    name: "St Philip's College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alamo.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.templejc.edu"],
    name: "Temple College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["templejc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.texarkanacollege.edu"],
    name: "Texarkana College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["texarkanacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.harlingen.tstc.edu"],
    name: "Texas State Technical College-​Harlingen",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["harlingen.tstc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.marshall.tstc.edu"],
    name: "Texas State Technical College-​Marshall",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["marshall.tstc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.waco.tstc.edu"],
    name: "Texas State Technical College-​Waco",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["waco.tstc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westtexas.tstc.edu"],
    name: "Texas State Technical College-​West Texas",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westtexas.tstc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tvcc.edu"],
    name: "Trinity Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://WWW.TJC.EDU"],
    name: "Tyler Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["www.tjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vernoncollege.edu"],
    name: "Vernon College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vernoncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.victoriacollege.edu"],
    name: "Victoria College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["victoriacollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wc.edu"],
    name: "Weatherford College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wtc.edu"],
    name: "Western Texas College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcjc.edu"],
    name: "Wharton County Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcjc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ldsbc.edu"],
    name: "Latter-day Saints Business College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ldsbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.slcc.edu"],
    name: "Salt Lake Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["slcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ccv.edu"],
    name: "Community College of Vermont",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.brcc.edu"],
    name: "Blue Ridge Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cvcc.vccs.edu"],
    name: "Central Virginia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cvcc.vccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dslcc.edu"],
    name: "Dabney S Lancaster Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dslcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.dcc.vccs.edu"],
    name: "Danville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["dcc.vccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.es.vccs.edu"],
    name: "Eastern Shore Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["es.vccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.germanna.edu"],
    name: "Germanna Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["germanna.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.jtcc.edu"],
    name: "John Tyler Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["jtcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.reynolds.edu"],
    name: "J Sargeant Reynolds Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["reynolds.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lfcc.edu"],
    name: "Lord Fairfax Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lfcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mecc.edu"],
    name: "Mountain Empire Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mecc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nr.edu"],
    name: "New River Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nr.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nvcc.edu"],
    name: "Northern Virginia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.patrickhenry.edu"],
    name: "Patrick Henry Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["patrickhenry.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pdc.edu/"],
    name: "Paul D Camp Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pdc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pvcc.edu"],
    name: "Piedmont Virginia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rappahannock.edu/"],
    name: "Rappahannock Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rappahannock.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rbc.edu"],
    name: "Richard Bland College of the College of William and Mary",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rbc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southside.edu"],
    name: "Southside Virginia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southside.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sw.edu"],
    name: "Southwest Virginia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sw.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tncc.edu"],
    name: "Thomas Nelson Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tcc.edu"],
    name: "Tidewater Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.vhcc.edu"],
    name: "Virginia Highlands Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["vhcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://virginiawestern.edu/"],
    name: "Virginia Western Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["virginiawestern.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wcc.vccs.edu"],
    name: "Wytheville Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wcc.vccs.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bates.ctc.edu/"],
    name: "Bates Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bates.ctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.btc.ctc.edu"],
    name: "Bellingham Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["btc.ctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bigbend.edu"],
    name: "Big Bend Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bigbend.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cascadia.edu"],
    name: "Cascadia Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cascadia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.clark.edu"],
    name: "Clark College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["clark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cptc.edu"],
    name: "Clover Park Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cptc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.edcc.edu"],
    name: "Edmonds Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["edcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.everettcc.edu"],
    name: "Everett Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["everettcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ghc.edu"],
    name: "Grays Harbor College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ghc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.greenriver.edu/"],
    name: "Green River Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["greenriver.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.highline.edu"],
    name: "Highline Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["highline.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://lowercolumbia.edu"],
    name: "Lower Columbia College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lowercolumbia.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pierce.ctc.edu/"],
    name: "Pierce College at Puyallup",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pierce.ctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.rtc.edu"],
    name: "Renton Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.shoreline.edu"],
    name: "Shoreline Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["shoreline.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.skagit.edu"],
    name: "Skagit Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["skagit.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.spscc.ctc.edu"],
    name: "South Puget Sound Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["spscc.ctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scc.spokane.edu"],
    name: "Spokane Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scc.spokane.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.spokanefalls.edu"],
    name: "Spokane Falls Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["spokanefalls.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.tacomacc.edu"],
    name: "Tacoma Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["tacomacc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wwcc.edu/"],
    name: "Walla Walla Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wwcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wvc.edu"],
    name: "Wenatchee Valley College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wvc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.whatcom.ctc.edu"],
    name: "Whatcom Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["whatcom.ctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.yvcc.edu"],
    name: "Yakima Valley Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["yvcc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.blueridgectc.edu/"],
    name: "Blue Ridge Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["blueridgectc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.bridgemont.edu"],
    name: "Bridgemont Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["bridgemont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.Eastern.wvnet.edu"],
    name: "Eastern West Virginia Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["eastern.wvnet.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.huntingtonjuniorcollege.edu"],
    name: "Huntington Junior College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["huntingtonjuniorcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.kvctc.edu"],
    name: "Kanawha Valley Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kvctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mctc.edu"],
    name: "Mountwest Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.newriver.edu"],
    name: "New River Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["newriver.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.pierpont.edu/"],
    name: "Pierpont Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["pierpont.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.southernwv.edu"],
    name: "Southern West Virginia Community and Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["southernwv.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wvncc.edu/"],
    name: "West Virginia Northern Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wvncc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.blackhawk.edu"],
    name: "Blackhawk Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["blackhawk.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cvtc.edu"],
    name: "Chippewa Valley Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cvtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.fvtc.edu"],
    name: "Fox Valley Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["fvtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gtc.edu"],
    name: "Gateway Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lco.edu"],
    name: "Lac Courte Oreilles Ojibwa Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lco.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.gotoltc.edu"],
    name: "Lakeshore Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["gotoltc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://madisoncollege.edu"],
    name: "Madison Area Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["madisoncollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.mstc.edu"],
    name: "Mid-​State Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mstc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://matc.edu"],
    name: "Milwaukee Area Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["matc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.morainepark.edu"],
    name: "Moraine Park Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["morainepark.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nicoletcollege.edu"],
    name: "Nicolet Area Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nicoletcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.ntc.edu"],
    name: "Northcentral Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ntc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.nwtc.edu"],
    name: "Northeast Wisconsin Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["nwtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.swtc.edu"],
    name: "Southwest Wisconsin Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["swtc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.uwc.edu"],
    name: "University of Wisconsin Colleges",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["uwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wctc.edu"],
    name: "Waukesha County Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wctc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.westerntc.edu"],
    name: "Western Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["westerntc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.witc.edu"],
    name: "Wisconsin Indianhead Technical College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["witc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.caspercollege.edu"],
    name: "Casper College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["caspercollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.cwc.edu/"],
    name: "Central Wyoming College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["cwc.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://ewc.wy.edu"],
    name: "Eastern Wyoming College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ewc.wy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.lccc.wy.edu"],
    name: "Laramie County Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["lccc.wy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.northwestcollege.edu"],
    name: "Northwest College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["northwestcollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.sheridan.edu"],
    name: "Sheridan College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["sheridan.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wwcc.wy.edu"],
    name: "Western Wyoming Community College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wwcc.wy.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://freeuni.edu.ge/"],
    name: "Free University of Tbilisi",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["freeuni.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["https://newvision.ge/"],
    name: "New Vision University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["newvision.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["https://www.ui1.es/"],
    name: "Universidad Internacional Isabel I",
    alpha_two_code: "ES",
    "state-province": "Castilla la mancha",
    domains: ["ui1.es", "alumnos.ui1.es"],
    country: "Spain",
  },
  {
    web_pages: ["http://www.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.heidenheim.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Heidenheim",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["heidenheim.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.cas.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Center for Advanced Studies (CAS)",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["cas.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-loerrach.de/"],
    name: "Duale Hochschule Baden-Württemberg Lörrach",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-loerrach.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-mosbach.de/", "https://www.mosbach.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Mosbach",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-mosbach.de", "mosbach.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ravensburg.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Ravensburg",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["ravensburg.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-stuttgart.de/"],
    name: "Duale Hochschule Baden-Württemberg Stuttgart",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-stuttgart.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-vs.de/"],
    name: "Duale Hochschule Baden-Württemberg Villingen-Schwenningen",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-vs.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.heilbronn.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Heilbronn",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["heilbronn.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: [
      "http://www.dhbw-karlsruhe.de/",
      "http://www.karlsruhe.dhbw.de/",
    ],
    name: "Duale Hochschule Baden-Württemberg Karlsruhe",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-karlsruhe.de", "karlsruhe.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-mannheim.de/", "http://www.mannheim.dhbw.de/"],
    name: "Duale Hochschule Baden-Wuerttemberg Mannheim",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-mannheim.de", "mannheim.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.dhbw-mosbach.de/", "http://www.mosbach.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Mosbach / Bad Mergentheim",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["dhbw-mosbach.de", "mosbach.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["http://www.ravensburg.dhbw.de/"],
    name: "Duale Hochschule Baden-Württemberg Ravensburg / Friedrichshafen",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["ravensburg.dhbw.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.hs-hannover.de/"],
    name: "Hochschule Hannover",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["hs-hannover.de", "stud.hs-hannover.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.ba-bautzen.de/"],
    name: "Staatliche Studienakademie Bautzen",
    alpha_two_code: "DE",
    "state-province": "null",
    domains: ["ba-bautzen.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://trinitybiblecollege.edu"],
    name: "Trinity Bible College & Graduate School",
    alpha_two_code: "US",
    "state-province": "ND",
    domains: ["trinitybiblecollege.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.umflint.edu"],
    name: "University of Michigan-Flint",
    alpha_two_code: "US",
    "state-province": "MI",
    domains: ["umflint.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.torrens.edu.au"],
    name: "Torrens University Australia",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["torrens.edu.au", "tua.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["https://www.mmibordeaux.com/"],
    name: "DUT MMI - Université Bordeaux Montaigne",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["mmibordeaux.com"],
    country: "France",
  },
  {
    web_pages: ["https://campus-saint-marc.com/"],
    name: "Campus Saint Marc",
    alpha_two_code: "FR",
    "state-province": null,
    domains: ["campus-saint-marc.com", "csmrouen.com", "csmrouen.net"],
    country: "France",
  },
  {
    web_pages: ["http://btu.ge"],
    name: "Business and Technology University",
    alpha_two_code: "GE",
    "state-province": null,
    domains: ["btu.ge", "btu.edu.ge"],
    country: "Georgia",
  },
  {
    web_pages: ["http://cic-cairo.com/"],
    name: "CIC - Canadian International College",
    alpha_two_code: "EG",
    "state-province": null,
    domains: ["cic-cairo.com"],
    country: "Egypt",
  },
  {
    web_pages: ["http://www.kpc.alaska.edu"],
    name: "Kenai Peninsula College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["kpc.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://matsu.alaska.edu"],
    name: "Mat-Su College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["matsu.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://koc.alaska.edu"],
    name: "Kodiak College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["koc.alaska.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.alaskapacific.edu"],
    name: "Alaska Pacific University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["alaskapacific.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.wbu.edu"],
    name: "Wayland Baptist University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["wbu.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://hust.edu.vn"],
    name: "Hanoi University of Science and Technology",
    alpha_two_code: "VN",
    "state-province": null,
    domains: ["hust.edu.vn"],
    country: "Viet Nam",
  },
  {
    web_pages: ["http://www.bhtafe.edu.au", "http://www.boxhill.edu.au"],
    name: "Box Hill Institute",
    alpha_two_code: "AU",
    "state-province": null,
    domains: ["bhtafe.edu.au", "boxhill.edu.au"],
    country: "Australia",
  },
  {
    web_pages: ["http://www.cust.edu.cn", "http://ieec.cust.edu.cn/"],
    name: "Changchun University of Science and Technology",
    alpha_two_code: "CN",
    "state-province": "JiLin",
    domains: ["cust.edu.cn", "ieec.cust.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["https://www.polk.edu/"],
    name: "Polk State College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["polk.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.mohawkcollege.ca/"],
    name: "Mohawk College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["mohawkcollege.ca"],
    country: "Canada",
  },
  {
    web_pages: ["https://www.bdeb.qc.ca/"],
    name: "College of Bois-de-Boulogne",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["bdeb.qc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["https://www.brescia.edu/"],
    name: "Brescia University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["brescia.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.rsu.edu/"],
    name: "Rogers State University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["rsu.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.neumann.edu/"],
    name: "Neumann University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["neumann.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.scad.edu/"],
    name: "Savannah College of Art and Design",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["scad.edu", "student.scad.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.fanshawec.ca/"],
    name: "Fanshawe College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["fanshawec.ca", "fanshaweonline.ca"],
    country: "Canada",
  },
  {
    web_pages: ["https://www.ashford.edu/"],
    name: "Ashford University",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ashford.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.mcpherson.edu/"],
    name: "McPherson College",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["mcpherson.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.ccsnh.edu/"],
    name: "Community College System of New Hampshire",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["ccsnh.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.vaniercollege.qc.ca/"],
    name: "Vanier College",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["vaniercollege.qc.ca"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.defiance.edu/"],
    name: "Defiance College",
    alpha_two_code: "US",
    "state-province": "Ohio",
    domains: ["defiance.edu"],
    country: "United States",
  },
  {
    web_pages: ["http://www.musc.edu/"],
    name: "Medical University of South Carolina",
    alpha_two_code: "US",
    "state-province": null,
    domains: ["musc.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.gulfcoast.edu/"],
    name: "Gulf Coast State College",
    alpha_two_code: "US",
    "state-province": "Florida",
    domains: ["gulfcoast.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.gcu.edu.cn/"],
    name: "Guangzhou College of South China University of Technology",
    alpha_two_code: "CN",
    "state-province": "Guangzhou",
    domains: ["stu.gcu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["http://www.xhu.edu.cn/"],
    name: "Xihua University",
    alpha_two_code: "CN",
    "state-province": "Si Chuan",
    domains: ["xhu.edu.cn", "stu.xhu.edu.cn", "mail.xhu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["https://www.academyart.edu/"],
    name: "Academy of Art University",
    alpha_two_code: "US",
    "state-province": "California",
    domains: ["academyart.edu", "art.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.lr.edu/"],
    name: "Lenoir-Rhyne University",
    alpha_two_code: "US",
    "state-province": "North Carolina",
    domains: ["lr.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://www.utfpr.edu.br/"],
    name: "Universidade Tecnológica Federal do Paraná",
    alpha_two_code: "BR",
    country: "Brazil",
    "state-province": null,
    domains: ["utfpr.edu.br"],
  },
  {
    web_pages: ["https://www.nuist.edu.cn/"],
    name: "Nanjing University of Information Science and Technology",
    alpha_two_code: "CN",
    "state-province": "Jiangsu",
    domains: ["nuist.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["https://www.lynu.edu.cn/"],
    name: "Luoyang Normal University",
    alpha_two_code: "CN",
    "state-province": "Henan",
    domains: ["lynu.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["https://pointpark.edu/"],
    name: "Point Park University",
    alpha_two_code: "US",
    "state-province": "Pennsylvania",
    domains: ["pointpark.edu"],
    country: "United States",
  },
  {
    web_pages: ["https://ontariotechu.ca/"],
    name: "Ontario Tech University",
    alpha_two_code: "CA",
    "state-province": null,
    domains: ["ontariotechu.ca", "ontariotechu.net"],
    country: "Canada",
  },
  {
    web_pages: ["http://www.hsu.edu.hk/"],
    name: "The Hang Seng University of Hong Kong",
    alpha_two_code: "HK",
    "state-province": null,
    domains: ["hsu.edu.hk"],
    country: "Hong Kong",
  },
  {
    web_pages: ["https://www.htl-villach.at/"],
    name: "HTL Villach",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["htl-villach.at", "edu.htl-villach.at"],
    country: "Austria",
  },
  {
    web_pages: ["https://www.htl-wels.at/"],
    name: "HTL WELS",
    alpha_two_code: "AT",
    "state-province": null,
    domains: ["htl-wels.at"],
    country: "Austria",
  },
  {
    web_pages: ["https://udb.ac.id/"],
    name: "Duta Bangsa University",
    alpha_two_code: "ID",
    "state-province": null,
    domains: ["udb.ac.id"],
    country: "Indonesia",
  },
  {
    web_pages: ["https://jedlik.eu/"],
    name: "Győr Jedlik Ányos Mechanical Engineering and Informatics Technical School",
    alpha_two_code: "HU",
    "state-province": null,
    domains: ["jedlik.eu", "students.jedlik.eu"],
    country: "Hungary",
  },
  {
    web_pages: ["https://northwood.edu/"],
    name: "Northwood University",
    alpha_two_code: "US",
    "state-province": "Michigan",
    domains: ["northwood.edu"],
    country: "United States",
  },
  {
    web_pages: [
      "https://www.infnet.edu.br/infnet/",
      "https://ecdd.infnet.edu.br/",
      "https://www.infnet.edu.br/esti/",
      "https://negocios.infnet.edu.br/",
      "https://bootcamp.infnet.edu.br/",
      "https://training.infnet.edu.br/",
    ],
    name: "Instituto Infnet",
    alpha_two_code: "BR",
    "state-province": "Rio de Janeiro",
    domains: ["infnet.edu.br", "al.infnet.edu.br", "prof.infnet.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["https://ssst.edu.ba/"],
    name: "Sarajevo School of Science and Technology",
    alpha_two_code: "BA",
    "state-province": null,
    domains: ["ssst.edu.ba"],
    country: "Bosnia and Herzegovina",
  },
  {
    web_pages: ["www.hbc.edu.cn"],
    name: "Hubei Business College",
    alpha_two_code: "CN",
    "state-province": "Hubei",
    domains: ["hbc.edu.cn"],
    country: "China",
  },
  {
    web_pages: ["www.fom.de"],
    name: "FOM Hochschule für Oekonomie & Management",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["fom-net.de"],
    country: "Germany",
  },
  {
    web_pages: ["www.thm.de"],
    name: "Technische Hochschule Mittelhessen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["thm.de"],
    country: "Germany",
  },
  {
    web_pages: ["www.hwg-lu.de"],
    name: "Hochschule für Wirtschaft und Gesellschaft Ludwigshafen",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["hwg-lu.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.iiitm.ac.in/"],
    name: "Atal Bihari Vajpayee Indian Institute of Information Technology and Management, Gwalior",
    alpha_two_code: "IN",
    "state-province": "Madhya Pradesh",
    domains: ["iiitm.ac.in"],
    country: "India",
  },
  {
    web_pages: ["www.leuphana.de"],
    name: "Leuphana Universität Lüneburg",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["leuphana.de"],
    country: "Germany",
  },
  {
    web_pages: ["https://www.oth-aw.de/"],
    name: "Ostbayerische Technische Hochschule Amberg-Weiden",
    alpha_two_code: "DE",
    "state-province": null,
    domains: ["oth-aw.de"],
    country: "Germany",
  },
  {
    web_pages: [
      "https://unifatecie.edu.br/",
      "https://ead.unifatecie.edu.br/",
      "https://fatecie.edu.br/",
    ],
    name: "Centro Universitário UniFatecie",
    alpha_two_code: "BR",
    "state-province": null,
    domains: ["fatecie.edu.br"],
    country: "Brazil",
  },
  {
    web_pages: ["https://www.hamk.fi/"],
    name: "Häme University of Applied Sciences",
    alpha_two_code: "FI",
    "state-province": null,
    domains: ["hamk.fi"],
    country: "Finland",
  },
  {
    web_pages: ["http://www.ktun.edu.tr/"],
    name: "Konya Technical University",
    alpha_two_code: "TR",
    "state-province": null,
    domains: ["ktun.edu.tr"],
    country: "Turkey",
  },
];

export default UniversitiesList;
